// This client was automatically generated by Segment Typewriter. ** Do Not Edit **
// To update this file, run:
//   npx typewriter

/**
 * [ACCOUNT DELETION] User pressed the button for the confirm cancellation for deleting
 * their account
 */
export interface AccountDeletionUserPressedConfirmCancellation {
    id?: string;
    [property: string]: any;
}

/**
 * [ACCOUNT DELETION] User pressed the contact support link
 */
export interface AccountDeletionUserPressedContactSupport {
    id?: string;
    [property: string]: any;
}

/**
 * [ACCOUNT DELETION] User pressed the privacy policy link
 */
export interface AccountDeletionUserViewedPrivacyPolicy {
    id?: string;
    [property: string]: any;
}

/**
 * [HOST POPUP] "become a host" popup on become a host page submitted
 */
export interface BecomeAHostPopupSubmission {
    /**
     * emailed entered from individual (may or may not be signed in user)
     */
    Email?: string;
    /**
     * first name entered from individual (may or may not be signed in user)
     */
    FirstName?: string;
    /**
     * last name entered from individual (may or may not be signed in user)
     */
    LastName?: string;
    /**
     * phone number entered from individual (may or may not be signed in user)
     */
    Phone?: string;
    /**
     * zip entered from individual (may or may not be signed in user)
     */
    Zipcode?: string;
    [property: string]: any;
}

/**
 * [HOST POPUP] "become a host" popup on become a host page shown
 */
export interface BecomeAHostPopupView {
    id?: string;
    [property: string]: any;
}

/**
 * [CHECKOUT] reason selected for booking
 */
export interface BookingReasonSelected {
    /**
     * id for the current checkout flow
     */
    checkoutId: string;
    /**
     * did they enter this item from the "contact host" PLP flow
     */
    enteredFromContactHostFlow: boolean;
    /**
     * the id for the pool listing
     */
    listingId: string;
    /**
     * name of booking reason
     */
    reasonName: string;
    /**
     * which rank was this on the reason list (1st option, 2nd option, etc)
     */
    reasonPositionInList: number;
    /**
     * id for the search that led to this listing
     */
    searchId: string;
    [property: string]: any;
}

/**
 * [CLAIM REFERRAL] Claim referral page from the invite
 */
export interface DisplayedReferral {
    /**
     * previous page before user enter the screen
     */
    enteredFrom: string;
    /**
     * Pre-filled text in the middle of screen
     */
    inviteText: string;
    /**
     * User name who sent the invite shown on the blurp
     */
    nameOfReferrer: string;
    /**
     * the referral id of the invite
     */
    referralId: string;
    /**
     * Type of the referral, host or guest
     */
    referralType: string;
    [property: string]: any;
}

/**
 * [CLAIM REFERRAL] Referral page as a host
 */
export interface DisplayedReferralDetailsHost {
    /**
     * previous page before user entered the screen
     */
    enteredFrom: string;
    /**
     * prefilled text in the middle of the screen
     */
    inviteText: string;
    /**
     * User name who sent the invite
     */
    nameOfReferrer: string;
    /**
     * The referral id of the invite
     */
    referralId: string;
    /**
     * host or guest
     */
    referralType: string;
    [property: string]: any;
}

/**
 * [REFERRAL] the screen or pop up with all the options for sending or sharing invites
 */
export interface DisplayedSharingInvitesOptions {
    /**
     * The options available for sharing
     */
    inviteOptions: InviteOption[];
    [property: string]: any;
}

export interface InviteOption {
    /**
     * the type of the sharing option (sms, email or Facebook, etc.)
     */
    optionType: string;
    /**
     * the type of referral for host or friends/ guests
     */
    referType: string;
    [property: string]: any;
}

/**
 * [FANS] user completed the message, added a promotion code and pressed continue
 */
export interface FansComposeMessageCTAPressed {
    /**
     * the discount in percentage that the user is offering
     */
    discountPercentage: number;
    /**
     * the displayed number of fans in the message fans button
     */
    displayedNumberOfFans: number;
    /**
     * the fan groups that the user is messaging to
     */
    groupTypes: any[];
    /**
     * message that the user has composed
     */
    messageBlurb: string;
    /**
     * the promo code that the user is offering
     */
    promoCode: string;
    /**
     * the displayed expiry date of the promo code
     */
    promoCodeExpireDate: string;
    [property: string]: any;
}

/**
 * [FANS] users viewed the compose message screen
 */
export interface FansComposeMessageScreenViewed {
    id?: string;
    [property: string]: any;
}

/**
 * [FANS] user viewed the intro of the pool fans sheet - *key additional context* host taps
 * the fans banner to enter the fans creation flow
 */
export interface FansInfoBottomSheetViewed {
    id?: string;
    [property: string]: any;
}

/**
 * [FANS] user pressed the fans info on the sheet
 */
export interface FansInfoCTAPressed {
    id?: string;
    [property: string]: any;
}

/**
 * [FANS] user pressed the button on the fan intro sheet
 */
export interface FansIntroCTAPressed {
    id?: string;
    [property: string]: any;
}

/**
 * [FANS] user entered the message sent screen
 */
export interface FansMessageSentScreenViewed {
    id?: string;
    [property: string]: any;
}

/**
 * [FANS] user viewed the rule sheet for messaging fans
 */
export interface FansRulesBottomSheetViewed {
    id?: string;
    [property: string]: any;
}

/**
 * [FANS] user pressed the button on the rule sheet for messaging fans
 */
export interface FansRulesCTAPressed {
    id?: string;
    [property: string]: any;
}

/**
 * [FANS] user viewed the sheet for the fans groups selection
 */
export interface FansSelectBottomSheetViewed {
    /**
     * the number of fans in the guest leads group
     */
    displayedNumberGuestLeads: number;
    /**
     * the number of fans in the one-time guest group
     */
    displayedNumberOneTimeGuests: number;
    /**
     * the number of fans in the repeat guest group
     */
    displayedNumberRepeatGuests: number;
    [property: string]: any;
}

/**
 * [FANS] user selected the fans group and pressed continue
 */
export interface FansSelectCTAPressed {
    /**
     * the fans groups that the user selected
     */
    selectedFansGroup: any[];
    [property: string]: any;
}

/**
 * [GUEST RESERVATION] guest accepted change request from host
 */
export interface GuestAcceptReviewChangesFromHost {
    /**
     * a unique ID to identify the booking_edit_history entry
     */
    bookingEditHistoryId: string;
    /**
     * id of the bookings
     */
    bookingId: string;
    /**
     * was the booking made using a pass
     */
    bookingWithPass?: BookingWithPass;
    /**
     * true if amenities is edited, false otherwise
     */
    hasAmenitiesEdit: boolean;
    /**
     * true if booking date is edited, false otherwise
     */
    hasBookingDateEdit: boolean;
    /**
     * true if booking time is edited, false otherwise
     */
    hasBookingTimeEdit: boolean;
    /**
     * true if guest count is edited, false otherwise
     */
    hasGuestCountEdit: boolean;
    /**
     * true if there is any change in total price
     */
    hasTotalPriceChange: boolean;
    /**
     * true if guests has refund amount
     */
    isRefund: boolean;
    /**
     * new number of adult guests
     */
    newAdultGuests: number;
    /**
     * new amenities
     */
    newAmenities: GuestAcceptReviewChangesFromHostNewAmenity[];
    /**
     * new charges after edit
     */
    newCharges: number;
    /**
     * new number of children guests
     */
    newChildrenGuests: number;
    /**
     * new date of booking
     */
    newDate: string;
    /**
     * new end time of booking
     */
    newEndTime: string;
    /**
     * new number of infants guests
     */
    newInfantGuests: number;
    /**
     * new number of amenities
     */
    newNumberAmenities: number;
    /**
     * new number of pet guests
     */
    newPetGuests: number;
    /**
     * new start time of booking
     */
    newStartTime: string;
    /**
     * original number of adult guests before changes
     */
    originalAdultGuests: number;
    /**
     * the original amenities
     */
    originalAmenities: GuestAcceptReviewChangesFromHostOriginalAmenity[];
    /**
     * original number of children guests before changes
     */
    originalChildrenGuests: number;
    /**
     * original date of the booking
     */
    originalDate: string;
    /**
     * original end time before changes
     */
    originalEndTime: string;
    /**
     * string formatted display of all guests ex "13 guests (6 adults, 6 children, 1 infant, 1
     * pet)"
     */
    originalGuestsFullList: string;
    /**
     * original number of infants guests before changes
     */
    originalInfantGuests: number;
    /**
     * original number of amenities before changes
     */
    originalNumberAmenities: number;
    /**
     * original number of pet guests before changes
     */
    originalPetGuests: number;
    /**
     * original start time before changes
     */
    originalStartTime: string;
    /**
     * paid price of the booking
     */
    paidPrice: number;
    /**
     * if the booking was made or partially made with a pass, the pass id used
     */
    passId?: number | null;
    /**
     * the type of the pass formatted to be LCM friendly
     */
    passName?: null | string;
    /**
     * if the booking was made or partially made with a pass, what type of pass
     */
    passType?: GuestAcceptReviewChangesFromHostPassType | null;
    /**
     * if the booking was made or partially made with a pass, what was the user pass Id used
     */
    userPassId?: number | null;
    [property: string]: any;
}

/**
 * was the booking made using a pass
 */
export enum BookingWithPass {
    False = "FALSE",
    Partial = "PARTIAL",
    True = "TRUE",
}

export interface GuestAcceptReviewChangesFromHostNewAmenity {
    /**
     * description of the amenity
     */
    amenityDescription: string;
    amenityFeeDetails:  PurpleAmenityFeeDetails;
    /**
     * name of amenity
     */
    amenityName: string;
    /**
     * is this a custom amenity from the host?
     */
    isCustomAmenity: boolean;
    /**
     * does this amenity have a fee?
     */
    isFee: boolean;
    /**
     * is this amenity pre selected
     */
    isPreSelected: boolean;
    [property: string]: any;
}

export interface PurpleAmenityFeeDetails {
    /**
     * fee of amenity
     */
    feeAmount: number;
    /**
     * does this amenity have a flat fee?
     */
    isFlatFee: boolean;
    [property: string]: any;
}

export interface GuestAcceptReviewChangesFromHostOriginalAmenity {
    /**
     * description of amenity
     */
    amenityDescription: string;
    amenityFeeDetails:  FluffyAmenityFeeDetails;
    /**
     * name of amenity
     */
    amenityName: string;
    /**
     * is this a custom amenity from the host
     */
    isCustomAmenity: boolean;
    /**
     * does this amenity have a fee
     */
    isFee: boolean;
    /**
     * is this amenity pre selected
     */
    isPreSelected: boolean;
    [property: string]: any;
}

export interface FluffyAmenityFeeDetails {
    /**
     * fee of amenity
     */
    feeAmount: number;
    /**
     * does this amenity have a fee
     */
    isFlatFee: boolean;
    [property: string]: any;
}

/**
 * the type of pass
 *
 * the pass type selected when a user selects to see all listings with that pass
 */
export enum GuestAcceptReviewChangesFromHostPassType {
    AllAccess = "ALL_ACCESS",
    EarlyBird = "EARLY_BIRD",
    Weekday = "WEEKDAY",
}

/**
 * [GUEST PASS MANAGEMENT]
 */
export interface GuestConfirmedCancelPass {
    canceled?:       boolean;
    canceledReason?: string;
    createdAt?:      string;
    end:             string;
    hasAutorenewOn:  boolean;
    id?:             string;
    /**
     * true if the pass is a legacy pass
     */
    isLegacy:   boolean;
    listingId?: string;
    /**
     * the status of the pass
     */
    passholderStatus: PassholderStatus;
    /**
     * the user id of the pass holder
     */
    passholderUserId: number;
    passId:           number;
    passType:         GuestAcceptReviewChangesFromHostPassType;
    start:            string;
    userPassId:       number;
    [property: string]: any;
}

/**
 * the status of the pass
 */
export enum PassholderStatus {
    Active = "ACTIVE",
    Expired = "EXPIRED",
}

/**
 * [GUEST RESERVATION] guest declined change request from host
 */
export interface GuestDeclineReviewChangesFromHost {
    /**
     * a unique ID to identify the booking_edit_history entry
     */
    bookingEditHistoryId: string;
    /**
     * id of the bookings
     */
    bookingId: string;
    /**
     * was the booking made using a pass
     */
    bookingWithPass?: BookingWithPass;
    /**
     * true if amenities is edited, false otherwise
     */
    hasAmenitiesEdit: boolean;
    /**
     * true if booking date is edited, false otherwise
     */
    hasBookingDateEdit: boolean;
    /**
     * true if booking time is edited, false otherwise
     */
    hasBookingTimeEdit: boolean;
    /**
     * true if guest count is edited, false otherwise
     */
    hasGuestCountEdit: boolean;
    /**
     * true if there is any change in total price
     */
    hasTotalPriceChange: boolean;
    /**
     * true if guests has refund amount
     */
    isRefund: boolean;
    /**
     * new number of adult guests
     */
    newAdultGuests: number;
    /**
     * new amenities
     */
    newAmenities: GuestDeclineReviewChangesFromHostNewAmenity[];
    /**
     * new charges after edit
     */
    newCharges: number;
    /**
     * new number of children guests
     */
    newChildrenGuests: number;
    /**
     * new date of booking
     */
    newDate: string;
    /**
     * new end time of booking
     */
    newEndTime: string;
    /**
     * new number of infants guests
     */
    newInfantGuests: number;
    /**
     * new number of amenities
     */
    newNumberAmenities: number;
    /**
     * new number of pet guests
     */
    newPetGuests: number;
    /**
     * new start time of booking
     */
    newStartTime: string;
    /**
     * original number of adult guests before changes
     */
    originalAdultGuests: number;
    /**
     * the original amenities
     */
    originalAmenities: GuestDeclineReviewChangesFromHostOriginalAmenity[];
    /**
     * original number of children guests before changes
     */
    originalChildrenGuests: number;
    /**
     * original date of the booking
     */
    originalDate: string;
    /**
     * original end time before changes
     */
    originalEndTime: string;
    /**
     * string formatted display of all guests ex "13 guests (6 adults, 6 children, 1 infant, 1
     * pet)"
     */
    originalGuestsFullList: string;
    /**
     * original number of infants guests before changes
     */
    originalInfantGuests: number;
    /**
     * original number of amenities before changes
     */
    originalNumberAmenities: number;
    /**
     * original number of pet guests before changes
     */
    originalPetGuests: number;
    /**
     * original start time before changes
     */
    originalStartTime: string;
    /**
     * paid price of the booking
     */
    paidPrice: number;
    /**
     * if the booking was made or partially made with a pass, the pass id used
     */
    passId?: number | null;
    /**
     * the type of the pass formatted to be LCM friendly
     */
    passName?: null | string;
    /**
     * if the booking was made or partially made with a pass, what type of pass
     */
    passType?: GuestAcceptReviewChangesFromHostPassType | null;
    /**
     * if the booking was made or partially made with a pass, what was the user pass Id used
     */
    userPassId?: number | null;
    [property: string]: any;
}

export interface GuestDeclineReviewChangesFromHostNewAmenity {
    /**
     * description of the amenity
     */
    amenityDescription: string;
    amenityFeeDetails:  TentacledAmenityFeeDetails;
    /**
     * name of amenity
     */
    amenityName: string;
    /**
     * is this a custom amenity from the host?
     */
    isCustomAmenity: boolean;
    /**
     * does this amenity have a fee?
     */
    isFee: boolean;
    /**
     * is this amenity pre selected
     */
    isPreSelected: boolean;
    [property: string]: any;
}

export interface TentacledAmenityFeeDetails {
    /**
     * fee of amenity
     */
    feeAmount: number;
    /**
     * does this amenity have a flat fee?
     */
    isFlatFee: boolean;
    [property: string]: any;
}

export interface GuestDeclineReviewChangesFromHostOriginalAmenity {
    /**
     * description of amenity
     */
    amenityDescription: string;
    amenityFeeDetails:  StickyAmenityFeeDetails;
    /**
     * name of amenity
     */
    amenityName: string;
    /**
     * is this a custom amenity from the host
     */
    isCustomAmenity: boolean;
    /**
     * does this amenity have a fee
     */
    isFee: boolean;
    /**
     * is this amenity pre selected
     */
    isPreSelected: boolean;
    [property: string]: any;
}

export interface StickyAmenityFeeDetails {
    /**
     * fee of amenity
     */
    feeAmount: number;
    /**
     * does this amenity have a fee
     */
    isFlatFee: boolean;
    [property: string]: any;
}

/**
 * [GUEST RESERVATION] guest entered the additional note for 'other' cancel reason
 */
export interface GuestEnteredOtherCancelReason {
    /**
     * note of the cancel reason
     */
    additionalReason: string;
    /**
     * id of the booking
     */
    bookingId: string;
    /**
     * was the booking made using a pass
     */
    bookingWithPass?: BookingWithPass;
    /**
     * if the booking was made or partially made with a pass, the pass id used
     */
    passId?: number | null;
    /**
     * the type of the pass formatted to be LCM friendly
     */
    passName?: null | string;
    /**
     * if the booking was made or partially made with a pass, what type of pass
     */
    passType?: GuestAcceptReviewChangesFromHostPassType | null;
    /**
     * if the booking was made or partially made with a pass, what was the user pass Id used
     */
    userPassId?: number | null;
    [property: string]: any;
}

/**
 * [GUEST RESERVATION] guest pressed 'never mind' in the leave a note screen in change
 * request and cancel changes
 */
export interface GuestExitChangeRequest {
    /**
     * id of the booking
     */
    bookingId: string;
    /**
     * was the booking made using a pass
     */
    bookingWithPass?: BookingWithPass;
    /**
     * if the booking was made or partially made with a pass, the pass id used
     */
    passId?: number | null;
    /**
     * the type of the pass formatted to be LCM friendly
     */
    passName?: null | string;
    /**
     * if the booking was made or partially made with a pass, what type of pass
     */
    passType?: GuestAcceptReviewChangesFromHostPassType | null;
    /**
     * if the booking was made or partially made with a pass, what was the user pass Id used
     */
    userPassId?: number | null;
    [property: string]: any;
}

/**
 * [GUEST PASS MANAGEMENT]
 */
export interface GuestPassHoursUsed {
    /**
     * guestPass id
     */
    id: number;
    [property: string]: any;
}

/**
 * [GUEST PASS ACQUISITION - PLP]
 */
export interface GuestPassPurchaseFailure {
    /**
     * the url for the cover image of the listing the pass is for
     */
    coverImageURL: string;
    /**
     * first name of the host
     */
    hostFirstName: string;
    id?:           string;
    /**
     * id of the listing the pass is for
     */
    listingId: string;
    /**
     * the title of the listing the pass is for
     */
    listingTitle: string;
    /**
     * the url of the listing the pass is for
     */
    listingURL: string;
    /**
     * [{from:”07:00:00”, “11:00:00”}...] Time slots when this pass is eligible
     */
    passAvailableTimes?: any[];
    /**
     * LCM formatted version of available times property
     */
    passAvailableTimesText?: string;
    /**
     * list of blackout dates (e.g. July 4, 2024).
     */
    passBlackoutDays?: any[] | null;
    /**
     * when the pass was created
     */
    passCreatedAt: string;
    /**
     * currency for all monetary fields
     */
    passCurrencyCode: string;
    /**
     * flag indicating that this is the current version for a pass. For a type/name/listing_id,
     * there can only be one record with this attribute true.
     */
    passCurrent: boolean;
    /**
     * free text description set by host
     */
    passDescription?: null | string;
    /**
     * discount amount. Fixed discounts will be in minors units.
     */
    passDiscount: number | null;
    /**
     * type of pass discount num[‘percentage’, ‘fixed’]
     */
    passDiscountType: PassDiscountType | null;
    /**
     * days the pass is eligible
     */
    passEligibleDays?: any[] | null;
    /**
     * id of the pass
     */
    passId: number;
    /**
     * max active passes allowed. This constraint will apply to the (listing_id, type, name)
     * rather than id so that we can be accurate across edits.
     */
    passMaxActivePasses?: number | null;
    /**
     * max bookings allowed under this pass
     */
    passMaxDailyBookings?: number | null;
    /**
     * max duration that may be booked using this pass
     */
    passMaxDuration?: number | null;
    /**
     * max guests that may be booked using this pass
     */
    passMaxGuests?: number | null;
    /**
     * the type of the pass formatted to be LCM friendly
     */
    passName: string;
    /**
     * the ids of all premium amenities included with the pass
     */
    passPremiumAmenities?: any[] | null;
    /**
     * pass price in minor units
     */
    passPrice: string;
    /**
     * ‘draft’ -> pass is being actively edited by the host via the creation flow. The step
     * attribute below tracks the progress of the host through the creation flow.
     * ‘inactive’ -> pass has been created by the host, but not ready for sale yet
     * ‘active’ -> pass has passed the final availability requirements and has been marked by
     * the host as ready for sale.
     */
    passState: PassState;
    /**
     * the pass of the price plus the service fee
     */
    passTotalPrice: string;
    /**
     * the type of pass
     */
    passType: GuestPassPurchaseFailurePassType;
    /**
     * if the submission is unsuccessful, a list of the errors
     */
    unSuccessfullySubmittedReasons?: any[] | null;
    [property: string]: any;
}

export enum PassDiscountType {
    Fixed = "FIXED",
    Percentage = "PERCENTAGE",
}

/**
 * ‘draft’ -> pass is being actively edited by the host via the creation flow. The step
 * attribute below tracks the progress of the host through the creation flow.
 * ‘inactive’ -> pass has been created by the host, but not ready for sale yet
 * ‘active’ -> pass has passed the final availability requirements and has been marked by
 * the host as ready for sale.
 */
export enum PassState {
    Active = "ACTIVE",
    Draft = "DRAFT",
    Inactive = "INACTIVE",
}

/**
 * the type of pass
 */
export enum GuestPassPurchaseFailurePassType {
    AllAccess = "ALL_ACCESS",
    EarlyBird = "EARLY_BIRD",
    FixedHours = "FIXED_HOURS",
    Weekday = "WEEKDAY",
}

/**
 * [GUEST PASS ACQUISITION - PLP]
 */
export interface GuestPassPurchaseSuccess {
    /**
     * the url for the cover image of the listing the pass is for
     */
    coverImageURL: string;
    enteredFrom:   GuestPassPurchaseSuccessEnteredFrom;
    /**
     * first name of the host
     */
    hostFirstName: string;
    id?:           string;
    /**
     * id of the listing the pass is for
     */
    listingId: string;
    /**
     * the title of the listing the pass is for
     */
    listingTitle: string;
    /**
     * the url of the listing the pass is for
     */
    listingURL: string;
    /**
     * [{from:”07:00:00”, “11:00:00”}...] Time slots when this pass is eligible
     */
    passAvailableTimes?: any[];
    /**
     * LCM formatted version of available times property
     */
    passAvailableTimesText?: string;
    /**
     * list of blackout dates (e.g. July 4, 2024).
     */
    passBlackoutDays?: any[] | null;
    /**
     * when the pass was created
     */
    passCreatedAt: string;
    /**
     * currency for all monetary fields
     */
    passCurrencyCode: string;
    /**
     * flag indicating that this is the current version for a pass. For a type/name/listing_id,
     * there can only be one record with this attribute true.
     */
    passCurrent: boolean;
    /**
     * free text description set by host
     */
    passDescription?: null | string;
    /**
     * discount amount. Fixed discounts will be in minors units.
     */
    passDiscount: number | null;
    /**
     * type of pass discount num[‘percentage’, ‘fixed’]
     */
    passDiscountType: PassDiscountType | null;
    /**
     * days the pass is eligible
     */
    passEligibleDays?: any[] | null;
    /**
     * id of the pass
     */
    passId: number;
    /**
     * max active passes allowed. This constraint will apply to the (listing_id, type, name)
     * rather than id so that we can be accurate across edits.
     */
    passMaxActivePasses?: number | null;
    /**
     * max bookings allowed under this pass
     */
    passMaxDailyBookings?: number | null;
    /**
     * max duration that may be booked using this pass
     */
    passMaxDuration?: number | null;
    /**
     * max guests that may be booked using this pass
     */
    passMaxGuests?: number | null;
    /**
     * the type of the pass formatted to be LCM friendly
     */
    passName: string;
    /**
     * the ids of all premium amenities included with the pass
     */
    passPremiumAmenities?: any[] | null;
    /**
     * pass price in minor units
     */
    passPrice: string;
    /**
     * ‘draft’ -> pass is being actively edited by the host via the creation flow. The step
     * attribute below tracks the progress of the host through the creation flow.
     * ‘inactive’ -> pass has been created by the host, but not ready for sale yet
     * ‘active’ -> pass has passed the final availability requirements and has been marked by
     * the host as ready for sale.
     */
    passState: PassState;
    /**
     * the pass of the price plus the service fee
     */
    passTotalPrice: string;
    /**
     * the type of pass
     */
    passType: GuestPassPurchaseFailurePassType;
    /**
     * If the guest is shown an expiring discount towards the pass purchase, how much is it for
     * (null if it's expired or not sh...
     */
    passUpsellCreditAmountOffer?: number | null;
    [property: string]: any;
}

export enum GuestPassPurchaseSuccessEnteredFrom {
    Checkout = "checkout",
    PDP = "pdp",
    Rebook = "rebook",
}

/**
 * [GUEST PASS MANAGEMENT]
 */
export interface GuestPassRenewed {
    id?: string;
    [property: string]: any;
}

/**
 * [GUEST SPECIAL OFFER RESPONSE]
 */
export interface GuestPressedAcceptAndPay {
    bookingChangeRequestId: number;
    bookingId:              number;
    bookingSpecialOfferId:  number;
    messageSentId:          number;
    originalPrice:          number;
    specialOfferPrice:      number;
    [property: string]: any;
}

/**
 * [GUEST T&S SWIPE] guest pressed the finish check in button
 */
export interface GuestPressedAwesomeThanksButton {
    /**
     * the id of the booking
     */
    bookingId: number;
    [property: string]: any;
}

/**
 * [GUEST RESERVATION] guest pressed the booking type on the top (today, confirmed, pending,
 * past)
 */
export interface GuestPressedBookingType {
    /**
     * Today, all, pending, confirmed, past
     */
    bookingType: BookingType;
    [property: string]: any;
}

/**
 * Today, all, pending, confirmed, past
 */
export enum BookingType {
    Past = "past",
    PendingAndUpcoming = "pending_and_upcoming",
}

/**
 * [GUEST PASS MANAGEMENT]
 */
export interface GuestPressedCancelPassNevermind {
    canceled?:       boolean;
    canceledReason?: string;
    createdAt?:      string;
    end:             string;
    hasAutorenewOn:  boolean;
    id?:             string;
    /**
     * true if the pass is a legacy pass
     */
    isLegacy:   boolean;
    listingId?: string;
    /**
     * the status of the pass
     */
    passholderStatus: PassholderStatus;
    /**
     * the user id of the pass holder
     */
    passholderUserId: number;
    passId:           number;
    passType:         GuestAcceptReviewChangesFromHostPassType;
    start:            string;
    userPassId:       number;
    [property: string]: any;
}

/**
 * [GUEST PASS MANAGEMENT]
 */
export interface GuestPressedCancelPassNext {
    canceled?:       boolean;
    canceledReason?: string;
    createdAt?:      string;
    end:             string;
    hasAutorenewOn:  boolean;
    id?:             string;
    /**
     * true if the pass is a legacy pass
     */
    isLegacy:   boolean;
    listingId?: string;
    /**
     * the status of the pass
     */
    passholderStatus: PassholderStatus;
    /**
     * the user id of the pass holder
     */
    passholderUserId: number;
    passId:           number;
    passType:         GuestAcceptReviewChangesFromHostPassType;
    start:            string;
    userPassId:       number;
    [property: string]: any;
}

/**
 * [GUEST CHAT] guest pressed to enter chat from reservation details
 */
export interface GuestPressedChatFromReservationDetails {
    /**
     * id of the booking
     */
    bookingId: number;
    /**
     * id of the listing
     */
    listingId: number;
    [property: string]: any;
}

/**
 * [GUEST T&S SWIPE] guest pressed the close flow button on the top left
 */
export interface GuestPressedCloseFlowTrustAndSafety {
    /**
     * the id of the booking
     */
    bookingId: number;
    /**
     * page number of the T&S flow (1, 2, or 3)
     */
    currentPageNumber: number;
    [property: string]: any;
}

/**
 * [GUEST T&S SWIPE] guest pressed 'X' button to close Thanks for Reading card
 */
export interface GuestPressedCloseThanksForReading {
    /**
     * the id of the booking
     */
    bookingId: number;
    [property: string]: any;
}

/**
 * [GUEST SPECIAL OFFER RESPONSE]
 */
export interface GuestPressedDeclineSpecialOffer {
    bookingId?:             number;
    bookingSpecialOfferId?: number;
    messageSentId:          number;
    originalPrice:          number;
    specialOfferPrice:      number;
    [property: string]: any;
}

/**
 * [GUEST RESERVATION] guest pressed to view or change amenities
 */
export interface GuestPressedEditAmenities {
    /**
     * id of the booking
     */
    bookingId: string;
    /**
     * was the booking made using a pass
     */
    bookingWithPass?: BookingWithPass;
    /**
     * if the booking was made or partially made with a pass, the pass id used
     */
    passId?: number | null;
    /**
     * the type of the pass formatted to be LCM friendly
     */
    passName?: null | string;
    /**
     * if the booking was made or partially made with a pass, what type of pass
     */
    passType?: GuestAcceptReviewChangesFromHostPassType | null;
    /**
     * if the booking was made or partially made with a pass, what was the user pass Id used
     */
    userPassId?: number | null;
    [property: string]: any;
}

/**
 * [GUEST RESERVATION] guest pressed extend reservation in the live reservation
 */
export interface GuestPressedExtendReservationLiveBooking {
    /**
     * id of the booking
     */
    bookingId: string;
    /**
     * was the booking made using a pass
     */
    bookingWithPass?: BookingWithPass;
    /**
     * displayed end time in the live booking
     */
    displayedEndTime: number;
    /**
     * displayed start time in the live booking
     */
    displayedStartTime: number;
    /**
     * the cost of the extension
     */
    extendedCost: string;
    /**
     * extend 30 minutes or 60 minutes
     */
    extendedTime: number;
    /**
     * if the booking was made or partially made with a pass, the pass id used
     */
    passId?: number | null;
    /**
     * the type of the pass formatted to be LCM friendly
     */
    passName?: null | string;
    /**
     * if the booking was made or partially made with a pass, what type of pass
     */
    passType?: GuestAcceptReviewChangesFromHostPassType | null;
    /**
     * if the booking was made or partially made with a pass, what was the user pass Id used
     */
    userPassId?: number | null;
    [property: string]: any;
}

/**
 * guest entered the refund request flow
 */
export interface GuestPressedInitiateRefundRequest {
    /**
     * id of the booking
     */
    bookingId: number;
    /**
     * status of the booking
     */
    bookingStatus: string;
    /**
     * which screen/tab the user entered from
     */
    enteredFrom: string;
    /**
     * id of the host for the booking
     */
    hostId: number;
    [property: string]: any;
}

/**
 * [GUEST PASS ONBOARDING]
 */
export interface GuestPressedLearnMorePassOnboarding {
    /**
     * how the guest accessed pass onboarding
     */
    enteredFrom?: GuestPressedLearnMorePassOnboardingEnteredFrom;
    id?:          string;
    [property: string]: any;
}

/**
 * how the guest accessed pass onboarding
 */
export enum GuestPressedLearnMorePassOnboardingEnteredFrom {
    HomepageLearnMore = "homepage_learn_more",
    PopUp = "pop_up",
    SearchBanner = "search_banner",
}

/**
 * [GUEST PASS MANAGEMENT] the guest clicked into a specific pass
 */
export interface GuestPressedManagePass {
    canceled?:       boolean;
    canceledReason?: string;
    createdAt?:      string;
    end:             string;
    hasAutorenewOn:  boolean;
    id?:             string;
    /**
     * true if the pass is a legacy pass
     */
    isLegacy:   boolean;
    listingId?: string;
    /**
     * the status of the pass
     */
    passholderStatus: PassholderStatus;
    /**
     * the user id of the pass holder
     */
    passholderUserId: number;
    passId:           number;
    passType:         GuestAcceptReviewChangesFromHostPassType;
    start:            string;
    userPassId:       number;
    [property: string]: any;
}

/**
 * [GUEST PASS MANAGEMENT]
 */
export interface GuestPressedManagePassCancelPass {
    canceled?:       boolean;
    canceledReason?: string;
    createdAt?:      string;
    end:             string;
    hasAutorenewOn:  boolean;
    id?:             string;
    /**
     * true if the pass is a legacy pass
     */
    isLegacy:   boolean;
    listingId?: string;
    /**
     * the status of the pass
     */
    passholderStatus: PassholderStatus;
    /**
     * the user id of the pass holder
     */
    passholderUserId: number;
    passId:           number;
    passType:         GuestAcceptReviewChangesFromHostPassType;
    start:            string;
    userPassId:       number;
    [property: string]: any;
}

/**
 * [GUEST PASS MANAGEMENT]
 */
export interface GuestPressedManagePassContactSupport {
    canceled?:       boolean;
    canceledReason?: string;
    createdAt?:      string;
    end:             string;
    hasAutorenewOn:  boolean;
    id?:             string;
    /**
     * true if the pass is a legacy pass
     */
    isLegacy:   boolean;
    listingId?: string;
    /**
     * the status of the pass
     */
    passholderStatus: PassholderStatus;
    /**
     * the user id of the pass holder
     */
    passholderUserId: number;
    passId:           number;
    passType:         GuestAcceptReviewChangesFromHostPassType;
    start:            string;
    userPassId:       number;
    [property: string]: any;
}

/**
 * [GUEST PASS MANAGEMENT]
 */
export interface GuestPressedManagePassMessageHost {
    canceled?:       boolean;
    canceledReason?: string;
    createdAt?:      string;
    end:             string;
    hasAutorenewOn:  boolean;
    id?:             string;
    /**
     * true if the pass is a legacy pass
     */
    isLegacy:   boolean;
    listingId?: string;
    /**
     * the status of the pass
     */
    passholderStatus: PassholderStatus;
    /**
     * the user id of the pass holder
     */
    passholderUserId: number;
    passId:           number;
    passType:         GuestAcceptReviewChangesFromHostPassType;
    start:            string;
    userPassId:       number;
    [property: string]: any;
}

/**
 * [GUEST PASS MANAGEMENT]
 */
export interface GuestPressedManagePassPurchaseHistory {
    canceled?:       boolean;
    canceledReason?: string;
    createdAt?:      string;
    end:             string;
    hasAutorenewOn:  boolean;
    id?:             string;
    /**
     * true if the pass is a legacy pass
     */
    isLegacy:   boolean;
    listingId?: string;
    /**
     * the status of the pass
     */
    passholderStatus: PassholderStatus;
    /**
     * the user id of the pass holder
     */
    passholderUserId: number;
    passId:           number;
    passType:         GuestAcceptReviewChangesFromHostPassType;
    start:            string;
    userPassId:       number;
    [property: string]: any;
}

/**
 * [GUEST PASS MANAGEMENT] the guest turned OFF autorenew on the pass
 */
export interface GuestPressedManagePassTurnOffAutoRenew {
    canceled?:       boolean;
    canceledReason?: string;
    createdAt?:      string;
    end:             string;
    hasAutorenewOn:  boolean;
    id?:             string;
    /**
     * true if the pass is a legacy pass
     */
    isLegacy:   boolean;
    listingId?: string;
    /**
     * the status of the pass
     */
    passholderStatus: PassholderStatus;
    /**
     * the user id of the pass holder
     */
    passholderUserId: number;
    passId:           number;
    passType:         GuestAcceptReviewChangesFromHostPassType;
    start:            string;
    userPassId:       number;
    [property: string]: any;
}

/**
 * [GUEST PASS MANAGEMENT] the guest turned ON autorenew on the pass
 */
export interface GuestPressedManagePassTurnOnAutoRenew {
    canceled?:       boolean;
    canceledReason?: string;
    createdAt?:      string;
    end:             string;
    hasAutorenewOn:  boolean;
    id?:             string;
    /**
     * true if the pass is a legacy pass
     */
    isLegacy:   boolean;
    listingId?: string;
    /**
     * the status of the pass
     */
    passholderStatus: PassholderStatus;
    /**
     * the user id of the pass holder
     */
    passholderUserId: number;
    passId:           number;
    passType:         GuestAcceptReviewChangesFromHostPassType;
    start:            string;
    userPassId:       number;
    [property: string]: any;
}

/**
 * [GUEST PASS MANAGEMENT]
 */
export interface GuestPressedManagePassViewBookings {
    canceled?:       boolean;
    canceledReason?: string;
    createdAt?:      string;
    end:             string;
    hasAutorenewOn:  boolean;
    id?:             string;
    /**
     * true if the pass is a legacy pass
     */
    isLegacy:   boolean;
    listingId?: string;
    /**
     * the status of the pass
     */
    passholderStatus: PassholderStatus;
    /**
     * the user id of the pass holder
     */
    passholderUserId: number;
    passId:           number;
    passType:         GuestAcceptReviewChangesFromHostPassType;
    start:            string;
    userPassId:       number;
    [property: string]: any;
}

/**
 * [GUEST PASS MANAGEMENT] the guest clicked all passes (possibly more than 1)
 */
export interface GuestPressedManagePasses {
    id?: string;
    [property: string]: any;
}

/**
 * [GUEST T&S SWIPE] guest pressed the next page button
 */
export interface GuestPressedNextPageTrustAndSafety {
    /**
     * the id of the booking
     */
    bookingId: number;
    /**
     * page number of the T&S flow (1 or 2)
     */
    currentPageNumber: number;
    [property: string]: any;
}

/**
 * [GUEST PASS ONBOARDING]
 */
export interface GuestPressedNextPassOnboarding {
    hostPassOnboardingPageName: GuestPressedNextPassOnboardingHostPassOnboardingPageName;
    id?:                        string;
    [property: string]: any;
}

export enum GuestPressedNextPassOnboardingHostPassOnboardingPageName {
    Billing = "billing",
    Discovery = "discovery",
    PassType = "pass_type",
}

/**
 * [GUEST PASS ACQUISITION - PLP]
 */
export interface GuestPressedPurchasePass {
    /**
     * the url for the cover image of the listing the pass is for
     */
    coverImageURL: string;
    enteredFrom:   GuestPassPurchaseSuccessEnteredFrom | null;
    /**
     * first name of the host
     */
    hostFirstName: string;
    id?:           string;
    /**
     * id of the listing the pass is for
     */
    listingId: string;
    /**
     * the title of the listing the pass is for
     */
    listingTitle: string;
    /**
     * the url of the listing the pass is for
     */
    listingURL: string;
    /**
     * [{from:”07:00:00”, “11:00:00”}...] Time slots when this pass is eligible
     */
    passAvailableTimes?: any[];
    /**
     * LCM formatted version of available times property
     */
    passAvailableTimesText?: string;
    /**
     * list of blackout dates (e.g. July 4, 2024).
     */
    passBlackoutDays?: any[] | null;
    /**
     * when the pass was created
     */
    passCreatedAt: string;
    /**
     * currency for all monetary fields
     */
    passCurrencyCode: string;
    /**
     * flag indicating that this is the current version for a pass. For a type/name/listing_id,
     * there can only be one record with this attribute true.
     */
    passCurrent: boolean;
    /**
     * free text description set by host
     */
    passDescription?: null | string;
    /**
     * discount amount. Fixed discounts will be in minors units.
     */
    passDiscount: number | null;
    /**
     * type of pass discount num[‘percentage’, ‘fixed’]
     */
    passDiscountType: PassDiscountType | null;
    /**
     * days the pass is eligible
     */
    passEligibleDays?: any[] | null;
    /**
     * id of the pass
     */
    passId: number;
    /**
     * max active passes allowed. This constraint will apply to the (listing_id, type, name)
     * rather than id so that we can be accurate across edits.
     */
    passMaxActivePasses?: number | null;
    /**
     * max bookings allowed under this pass
     */
    passMaxDailyBookings?: number | null;
    /**
     * max duration that may be booked using this pass
     */
    passMaxDuration?: number | null;
    /**
     * max guests that may be booked using this pass
     */
    passMaxGuests?: number | null;
    /**
     * the type of the pass formatted to be LCM friendly
     */
    passName: string;
    /**
     * the ids of all premium amenities included with the pass
     */
    passPremiumAmenities?: any[] | null;
    /**
     * pass price in minor units
     */
    passPrice: string;
    /**
     * ‘draft’ -> pass is being actively edited by the host via the creation flow. The step
     * attribute below tracks the progress of the host through the creation flow.
     * ‘inactive’ -> pass has been created by the host, but not ready for sale yet
     * ‘active’ -> pass has passed the final availability requirements and has been marked by
     * the host as ready for sale.
     */
    passState: PassState;
    /**
     * the pass of the price plus the service fee
     */
    passTotalPrice: string;
    /**
     * the type of pass
     */
    passType: GuestPassPurchaseFailurePassType;
    [property: string]: any;
}

/**
 * [GUEST T&S SWIPE] guest pressed the check in button on the reservation page
 */
export interface GuestPressedReadGuideButton {
    /**
     * the id of the booking
     */
    bookingId: number;
    [property: string]: any;
}

/**
 * [GUEST T&S SWIPE] Guest view the screen "Arriving at your pool"
 */
export interface GuestPressedRequestChanges {
    /**
     * the id of the booking
     */
    bookingId: number;
    [property: string]: any;
}

/**
 * [GUEST RESERVATION] guest pressed reservation option (or 'booking' in app )to enter
 * management flow
 */
export interface GuestPressedReservation {
    /**
     * was the booking made using a pass
     */
    bookingWithPass?: BookingWithPass;
    id?:              string;
    /**
     * if the booking was made or partially made with a pass, the pass id used
     */
    passId?: number | null;
    /**
     * the type of the pass formatted to be LCM friendly
     */
    passName?: null | string;
    /**
     * if the booking was made or partially made with a pass, what type of pass
     */
    passType?: GuestAcceptReviewChangesFromHostPassType | null;
    /**
     * if the booking was made or partially made with a pass, what was the user pass Id used
     */
    userPassId?: number | null;
    [property: string]: any;
}

/**
 * [GUEST RESERVATION] guest pressed review change request from host
 */
export interface GuestPressedReviewChangesFromHost {
    /**
     * id of the bookings
     */
    bookingId: string;
    /**
     * was the booking made using a pass
     */
    bookingWithPass?: BookingWithPass;
    /**
     * if the booking was made or partially made with a pass, the pass id used
     */
    passId?: number | null;
    /**
     * the type of the pass formatted to be LCM friendly
     */
    passName?: null | string;
    /**
     * if the booking was made or partially made with a pass, what type of pass
     */
    passType?: GuestAcceptReviewChangesFromHostPassType | null;
    /**
     * if the booking was made or partially made with a pass, what was the user pass Id used
     */
    userPassId?: number | null;
    [property: string]: any;
}

/**
 * [PLP] when the user presses to learn more about security deposits
 */
export interface GuestPressedSecurityDepositLearnMore {
    /**
     * where did the user press this from - PDP, Checkout, Booking Edit
     */
    enteredFrom: GuestPressedSecurityDepositLearnMoreEnteredFrom;
    listingId:   string;
    [property: string]: any;
}

/**
 * where did the user press this from - PDP, Checkout, Booking Edit
 */
export enum GuestPressedSecurityDepositLearnMoreEnteredFrom {
    BookingEdit = "booking_edit",
    Checkout = "checkout",
    PDP = "pdp",
}

/**
 * [PLP] when the user presses to exit the learn more about security deposits pop up
 */
export interface GuestPressedSecurityDepositLearnMoreExit {
    /**
     * where did the user press this from - PDP, Checkout, Booking Edit
     */
    enteredFrom: GuestPressedSecurityDepositLearnMoreEnteredFrom;
    listingId:   string;
    [property: string]: any;
}

/**
 * [GUEST T&S SWIPE] guest pressed the see host rules button
 */
export interface GuestPressedSeeHostRules {
    /**
     * the id of the booking
     */
    bookingId: number;
    [property: string]: any;
}

/**
 * [PLP] user clicks to see more parking details on the listing
 */
export interface GuestPressedSeeParkingDetails {
    /**
     * id of the listing
     */
    listingId: string;
    [property: string]: any;
}

/**
 * [GUEST PASS ONBOARDING]
 */
export interface GuestPressedStartExploringPasses {
    hostPassOnboardingPageName: GuestPressedNextPassOnboardingHostPassOnboardingPageName;
    id?:                        string;
    [property: string]: any;
}

/**
 * Fired when a user presses the Swimply Promise/Guarantee/Booking with Confidence banner
 */
export interface GuestPressedSwimplyPromiseBanner {
    listingId?: string;
    [property: string]: any;
}

/**
 * [GUEST RESERVATION] guest pressed 'make changes' (instant change) or 'continue'(change
 * request)  button after saving the booking edit and pay
 */
export interface GuestPressedToConfirmBookingEdit {
    /**
     * id of the bookings
     */
    bookingId: string;
    /**
     * was the booking made using a pass
     */
    bookingWithPass?: BookingWithPass;
    /**
     * true if amenities is edited, false otherwise
     */
    hasAmenitiesEdit: boolean;
    /**
     * true if booking date is edited, false otherwise
     */
    hasBookingDateEdit: boolean;
    /**
     * true if booking time is edited, false otherwise
     */
    hasBookingTimeEdit: boolean;
    /**
     * true if guest count is edited, false otherwise
     */
    hasGuestCountEdit: boolean;
    /**
     * true if there is any change in total price
     */
    hasTotalPriceChange: boolean;
    /**
     * true if guests has refund amount
     */
    isRefund: boolean;
    /**
     * new number of adult guests
     */
    newAdultGuests: number;
    /**
     * new amenities
     */
    newAmenities: GuestPressedToConfirmBookingEditNewAmenity[];
    /**
     * new charges after edit
     */
    newCharges: number;
    /**
     * new number of children guests
     */
    newChildrenGuests: number;
    /**
     * new date of booking
     */
    newDate: string;
    /**
     * new end time of booking
     */
    newEndTime: string;
    /**
     * new number of infants guests
     */
    newInfantGuests: number;
    /**
     * new number of amenities
     */
    newNumberAmenities: number;
    /**
     * new number of pet guests
     */
    newPetGuests: number;
    /**
     * new start time of booking
     */
    newStartTime: string;
    /**
     * original number of adult guests before changes
     */
    originalAdultGuests: number;
    /**
     * the original amenities
     */
    originalAmenities: GuestPressedToConfirmBookingEditOriginalAmenity[];
    /**
     * original number of children guests before changes
     */
    originalChildrenGuests: number;
    /**
     * original date of the booking
     */
    originalDate: string;
    /**
     * original end time before changes
     */
    originalEndTime: string;
    /**
     * string formatted display of all guests ex "13 guests (6 adults, 6 children, 1 infant, 1
     * pet)"
     */
    originalGuestsFullList: string;
    /**
     * original number of infants guests before changes
     */
    originalInfantGuests: number;
    /**
     * original number of amenities before changes
     */
    originalNumberAmenities: number;
    /**
     * original number of pet guests before changes
     */
    originalPetGuests: number;
    /**
     * original start time before changes
     */
    originalStartTime: string;
    /**
     * paid price of the booking
     */
    paidPrice: number;
    /**
     * if the booking was made or partially made with a pass, the pass id used
     */
    passId?: number | null;
    /**
     * the type of the pass formatted to be LCM friendly
     */
    passName?: null | string;
    /**
     * if the booking was made or partially made with a pass, what type of pass
     */
    passType?: GuestAcceptReviewChangesFromHostPassType | null;
    /**
     * if the booking was made or partially made with a pass, what was the user pass Id used
     */
    userPassId?: number | null;
    [property: string]: any;
}

export interface GuestPressedToConfirmBookingEditNewAmenity {
    /**
     * description of the amenity
     */
    amenityDescription: string;
    amenityFeeDetails:  IndigoAmenityFeeDetails;
    /**
     * name of amenity
     */
    amenityName: string;
    /**
     * is this a custom amenity from the host?
     */
    isCustomAmenity: boolean;
    /**
     * does this amenity have a fee?
     */
    isFee: boolean;
    /**
     * is this amenity pre selected
     */
    isPreSelected: boolean;
    [property: string]: any;
}

export interface IndigoAmenityFeeDetails {
    /**
     * fee of amenity
     */
    feeAmount: number;
    /**
     * does this amenity have a flat fee?
     */
    isFlatFee: boolean;
    [property: string]: any;
}

export interface GuestPressedToConfirmBookingEditOriginalAmenity {
    /**
     * description of amenity
     */
    amenityDescription: string;
    amenityFeeDetails:  IndecentAmenityFeeDetails;
    /**
     * name of amenity
     */
    amenityName: string;
    /**
     * is this a custom amenity from the host
     */
    isCustomAmenity: boolean;
    /**
     * does this amenity have a fee
     */
    isFee: boolean;
    /**
     * is this amenity pre selected
     */
    isPreSelected: boolean;
    [property: string]: any;
}

export interface IndecentAmenityFeeDetails {
    /**
     * fee of amenity
     */
    feeAmount: number;
    /**
     * does this amenity have a fee
     */
    isFlatFee: boolean;
    [property: string]: any;
}

/**
 * [GUEST RESERVATION] guest pressed to confirm cancellation
 */
export interface GuestPressedToConfirmCancellation {
    /**
     * id of the booking
     */
    bookingId: string;
    /**
     * was the booking made using a pass
     */
    bookingWithPass?: BookingWithPass;
    /**
     * selected cancellation reason
     */
    cancellationReason: string;
    /**
     * True if the refund is in credit
     */
    isCredit: boolean;
    /**
     * True if the cancellation is within host's cancellation policy
     */
    isWithinPolicy: boolean;
    /**
     * if the booking was made or partially made with a pass, the pass id used
     */
    passId?: number | null;
    /**
     * the type of the pass formatted to be LCM friendly
     */
    passName?: null | string;
    /**
     * if the booking was made or partially made with a pass, what type of pass
     */
    passType?: GuestAcceptReviewChangesFromHostPassType | null;
    /**
     * displayed refund amount
     */
    refundAmount: number;
    /**
     * if the booking was made or partially made with a pass, what was the user pass Id used
     */
    userPassId?: number | null;
    [property: string]: any;
}

/**
 * [GUEST FAVORITE] guest pressed to enter the favorite list (fav tab on app or favorite on
 * user profile on web)
 */
export interface GuestPressedToEnterFavoriteList {
    id?: string;
    [property: string]: any;
}

/**
 * [TIERED PRICING] guest pressed show prices details groups in PLP
 */
export interface GuestPressedToShowPriceDetails {
    /**
     * the id of the listing
     */
    listingId: string;
    [property: string]: any;
}

/**
 * [GUEST SPECIAL OFFER RESPONSE]
 */
export interface GuestPressedViewAndAcceptOfferThread {
    bookingId:             number;
    bookingSpecialOfferId: number;
    messageSentId:         number;
    originalPrice:         number;
    specialOfferPrice:     number;
    [property: string]: any;
}

/**
 * [GUEST RESERVATION] guest pressed view reservation in the booking card
 */
export interface GuestPressedViewReservation {
    /**
     * id of the booking
     */
    bookingId: string;
    /**
     * was the booking made using a pass
     */
    bookingWithPass?: BookingWithPass;
    /**
     * live, confirmed, cancelled, pending or past
     */
    displayedStatus: DisplayedStatus;
    /**
     * if the booking was made or partially made with a pass, the pass id used
     */
    passId?: number | null;
    /**
     * the type of the pass formatted to be LCM friendly
     */
    passName?: null | string;
    /**
     * if the booking was made or partially made with a pass, what type of pass
     */
    passType?: GuestAcceptReviewChangesFromHostPassType | null;
    /**
     * if the booking was made or partially made with a pass, what was the user pass Id used
     */
    userPassId?: number | null;
    [property: string]: any;
}

/**
 * live, confirmed, cancelled, pending or past
 */
export enum DisplayedStatus {
    Approved = "approved",
    Cancelled = "cancelled",
    Completed = "completed",
    Confirmed = "confirmed",
    Declined = "declined",
    Expired = "expired",
    PaymentFailed = "payment failed",
    Pending = "pending",
    PreApproved = "pre-approved",
    RecentlyCompleted = "recently completed",
}

/**
 * [GUEST SPECIAL OFFER RESPONSE]
 */
export interface GuestPressedViewSpecialOfferMessages {
    bookingId:             number;
    bookingSpecialOfferId: number;
    messageSentId:         number;
    originalPrice:         number;
    specialOfferPrice:     number;
    [property: string]: any;
}

/**
 * [GUEST RESERVATION] guest pressed reschedule in cancellation flow
 */
export interface GuestReservationCancellationPressedReschedule {
    /**
     * id of the booking
     */
    bookingId: string;
    /**
     * was the booking made using a pass
     */
    bookingWithPass?: BookingWithPass;
    /**
     * selected cancellation reason
     */
    cancellationReason: string;
    /**
     * if the booking was made or partially made with a pass, the pass id used
     */
    passId?: number | null;
    /**
     * the type of the pass formatted to be LCM friendly
     */
    passName?: null | string;
    /**
     * if the booking was made or partially made with a pass, what type of pass
     */
    passType?: GuestAcceptReviewChangesFromHostPassType | null;
    /**
     * if the booking was made or partially made with a pass, what was the user pass Id used
     */
    userPassId?: number | null;
    [property: string]: any;
}

/**
 * [GUEST RESERVATION] guest pressed to change date time in confirmed booking
 */
export interface GuestReservationEditBookingDateTime {
    /**
     * id of the booking
     */
    bookingId: string;
    /**
     * was the booking made using a pass
     */
    bookingWithPass?: BookingWithPass;
    /**
     * if the booking was made or partially made with a pass, the pass id used
     */
    passId?: number | null;
    /**
     * the type of the pass formatted to be LCM friendly
     */
    passName?: null | string;
    /**
     * if the booking was made or partially made with a pass, what type of pass
     */
    passType?: GuestAcceptReviewChangesFromHostPassType | null;
    /**
     * if the booking was made or partially made with a pass, what was the user pass Id used
     */
    userPassId?: number | null;
    [property: string]: any;
}

/**
 * [GUEST RESERVATION] guest pressed contact host or message host
 */
export interface GuestReservationPressedContactHost {
    /**
     * id of the booking
     */
    bookingId: string;
    /**
     * was the booking made using a pass
     */
    bookingWithPass?: BookingWithPass;
    /**
     * True if guests pressed the contact host button from the cancellation flow
     */
    enteredFromCancellation: boolean;
    /**
     * True if guests pressed the send message button from the reservation page
     */
    enteredFromReservation: boolean;
    /**
     * if the booking was made or partially made with a pass, the pass id used
     */
    passId?: number | null;
    /**
     * the type of the pass formatted to be LCM friendly
     */
    passName?: null | string;
    /**
     * if the booking was made or partially made with a pass, what type of pass
     */
    passType?: GuestAcceptReviewChangesFromHostPassType | null;
    /**
     * if the booking was made or partially made with a pass, what was the user pass Id used
     */
    userPassId?: number | null;
    [property: string]: any;
}

/**
 * [GUEST RESERVATION] guest pressed contact support in reservation
 */
export interface GuestReservationPressedContactSupport {
    /**
     * id of the booking
     */
    bookingId: string;
    /**
     * was the booking made using a pass
     */
    bookingWithPass?: BookingWithPass;
    /**
     * True if guest pressed contact support after selecting the cancel reason 'I'm
     * uncomfortable with my host '
     */
    enteredFromCancellation: boolean;
    /**
     * True if guest pressed contact support from the reservation page
     */
    enteredFromReservation: boolean;
    /**
     * if the booking was made or partially made with a pass, the pass id used
     */
    passId?: number | null;
    /**
     * the type of the pass formatted to be LCM friendly
     */
    passName?: null | string;
    /**
     * if the booking was made or partially made with a pass, what type of pass
     */
    passType?: GuestAcceptReviewChangesFromHostPassType | null;
    /**
     * if the booking was made or partially made with a pass, what was the user pass Id used
     */
    userPassId?: number | null;
    [property: string]: any;
}

/**
 * [GUEST RESERVATION] guest pressed to edit guest in confirmed booking
 */
export interface GuestReservationPressedEditGuest {
    /**
     * id of the booking
     */
    bookingId: string;
    /**
     * was the booking made using a pass
     */
    bookingWithPass?: BookingWithPass;
    /**
     * if the booking was made or partially made with a pass, the pass id used
     */
    passId?: number | null;
    /**
     * the type of the pass formatted to be LCM friendly
     */
    passName?: null | string;
    /**
     * if the booking was made or partially made with a pass, what type of pass
     */
    passType?: GuestAcceptReviewChangesFromHostPassType | null;
    /**
     * if the booking was made or partially made with a pass, what was the user pass Id used
     */
    userPassId?: number | null;
    [property: string]: any;
}

/**
 * [GUEST RESERVATION] guest pressed to make changes in confirmed reservation
 */
export interface GuestReservationPressedMakeChange {
    /**
     * id of the booking
     */
    bookingId: string;
    /**
     * was the booking made using a pass
     */
    bookingWithPass?: BookingWithPass;
    /**
     * if the booking was made or partially made with a pass, the pass id used
     */
    passId?: number | null;
    /**
     * the type of the pass formatted to be LCM friendly
     */
    passName?: null | string;
    /**
     * if the booking was made or partially made with a pass, what type of pass
     */
    passType?: GuestAcceptReviewChangesFromHostPassType | null;
    /**
     * if the booking was made or partially made with a pass, what was the user pass Id used
     */
    userPassId?: number | null;
    [property: string]: any;
}

/**
 * [GUEST RESERVATION] guest pressed to pay the extend reservation
 */
export interface GuestReservationPressedPayExtendedHour {
    /**
     * id of the booking
     */
    bookingId: string;
    /**
     * was the booking made using a pass
     */
    bookingWithPass?: BookingWithPass;
    /**
     * if the booking was made or partially made with a pass, the pass id used
     */
    passId?: number | null;
    /**
     * the type of the pass formatted to be LCM friendly
     */
    passName?: null | string;
    /**
     * if the booking was made or partially made with a pass, what type of pass
     */
    passType?: GuestAcceptReviewChangesFromHostPassType | null;
    /**
     * payment method
     */
    paymentMethod: string;
    /**
     * price of the extended hour
     */
    totalExtendPrice: number;
    /**
     * if the booking was made or partially made with a pass, what was the user pass Id used
     */
    userPassId?: number | null;
    [property: string]: any;
}

/**
 * [GUEST RESERVATION] guest pressed 'No I'd like to cancel' in cancellation flow
 */
export interface GuestReservationPressedToContinueCancel {
    /**
     * id of the booking
     */
    bookingId: string;
    /**
     * was the booking made using a pass
     */
    bookingWithPass?: BookingWithPass;
    /**
     * selected cancellation reason
     */
    cancellationReason: string;
    /**
     * if the booking was made or partially made with a pass, the pass id used
     */
    passId?: number | null;
    /**
     * the type of the pass formatted to be LCM friendly
     */
    passName?: null | string;
    /**
     * if the booking was made or partially made with a pass, what type of pass
     */
    passType?: GuestAcceptReviewChangesFromHostPassType | null;
    /**
     * if the booking was made or partially made with a pass, what was the user pass Id used
     */
    userPassId?: number | null;
    [property: string]: any;
}

/**
 * [GUEST RESERVATION] guest pressed to enter cancellation flow
 */
export interface GuestReservationPressedToEnterCancellation {
    /**
     * id of the booking
     */
    bookingId: string;
    /**
     * was the booking made using a pass
     */
    bookingWithPass?: BookingWithPass;
    /**
     * if the booking was made or partially made with a pass, the pass id used
     */
    passId?: number | null;
    /**
     * the type of the pass formatted to be LCM friendly
     */
    passName?: null | string;
    /**
     * if the booking was made or partially made with a pass, what type of pass
     */
    passType?: GuestAcceptReviewChangesFromHostPassType | null;
    /**
     * if the booking was made or partially made with a pass, what was the user pass Id used
     */
    userPassId?: number | null;
    [property: string]: any;
}

/**
 * [GUEST RESERVATION] guest pressed to view cancellation policy
 */
export interface GuestReservationPressedViewHostCancelPolicy {
    /**
     * id of the booking
     */
    bookingId: string;
    /**
     * was the booking made using a pass
     */
    bookingWithPass?: BookingWithPass;
    /**
     * selected cancellation reason if guest view policy from the cancellation flow. Null
     * otherwise
     */
    canellationReason: null | string;
    /**
     * if the booking was made or partially made with a pass, the pass id used
     */
    passId?: number | null;
    /**
     * the type of the pass formatted to be LCM friendly
     */
    passName?: null | string;
    /**
     * if the booking was made or partially made with a pass, what type of pass
     */
    passType?: GuestAcceptReviewChangesFromHostPassType | null;
    /**
     * if the booking was made or partially made with a pass, what was the user pass Id used
     */
    userPassId?: number | null;
    [property: string]: any;
}

/**
 * [GUEST RESERVATION] guest pressed to change amenities
 */
export interface GuestReservationSaveChangeAmenities {
    /**
     * id of the booking
     */
    bookingId: string;
    /**
     * was the booking made using a pass
     */
    bookingWithPass?: BookingWithPass;
    /**
     * if the booking was made or partially made with a pass, the pass id used
     */
    passId?: number | null;
    /**
     * the type of the pass formatted to be LCM friendly
     */
    passName?: null | string;
    /**
     * if the booking was made or partially made with a pass, what type of pass
     */
    passType?: GuestAcceptReviewChangesFromHostPassType | null;
    /**
     * selected amenities the guest wants to add
     */
    selectedAmenitites: GuestReservationSaveChangeAmenitiesSelectedAmenitite[];
    /**
     * if the booking was made or partially made with a pass, what was the user pass Id used
     */
    userPassId?: number | null;
    [property: string]: any;
}

export interface GuestReservationSaveChangeAmenitiesSelectedAmenitite {
    /**
     * description of the amenity
     */
    amenityDescription: null | string;
    amenityFeeDetails:  HilariousAmenityFeeDetails;
    /**
     * name of amenity
     */
    amenityName: string;
    /**
     * is this a custom amenity from the host
     */
    isCustomAmenity: boolean;
    /**
     * does this amenity have a fee
     */
    isFee: boolean;
    /**
     * is this amenity pre selected
     */
    isPreSelected: boolean;
    [property: string]: any;
}

export interface HilariousAmenityFeeDetails {
    /**
     * fee of amenity
     */
    feeAmount: number;
    /**
     * does this amenity have a flat fee, 1 is flat fee, 0 is hourly fee
     */
    isFlatFee: boolean;
    [property: string]: any;
}

/**
 * [GUEST RESERVATION] guest pressed save for the changes in booking date time
 */
export interface GuestReservationSaveChangeDateTime {
    /**
     * id of the booking
     */
    bookingId: string;
    /**
     * was the booking made using a pass
     */
    bookingWithPass?: BookingWithPass;
    /**
     * the new date of the booking changed by guest
     */
    newDate: string;
    /**
     * the new end time of the booking changed by guest
     */
    newEndTime: number;
    /**
     * the new start time of the booking changed by guest
     */
    newStartTime: number;
    /**
     * the original date of the booking
     */
    orginalDate: string;
    /**
     * the original end time of the booking
     */
    originalEndTime: number;
    /**
     * the original start time of the booking
     */
    originalStartTime: number;
    /**
     * if the booking was made or partially made with a pass, the pass id used
     */
    passId?: number | null;
    /**
     * the type of the pass formatted to be LCM friendly
     */
    passName?: null | string;
    /**
     * if the booking was made or partially made with a pass, what type of pass
     */
    passType?: GuestAcceptReviewChangesFromHostPassType | null;
    /**
     * if the booking was made or partially made with a pass, what was the user pass Id used
     */
    userPassId?: number | null;
    [property: string]: any;
}

/**
 * [GUEST RESERVATION] guest pressed to save changes of guest in reservation
 */
export interface GuestReservationSaveChangeGuest {
    /**
     * id of the booking
     */
    bookingId: string;
    /**
     * was the booking made using a pass
     */
    bookingWithPass?: BookingWithPass;
    /**
     * new number of adult guest
     */
    newAdultGuest: number;
    /**
     * new number of children guest
     */
    newChildrenGuest: number;
    /**
     * new number of infant guest
     */
    newInfantGuest: number;
    /**
     * new number of pet guest
     */
    newPetGuest: number;
    /**
     * original number of adult guest
     */
    originalAdultGuest: number;
    /**
     * original number of children guest
     */
    originalChildrenGuest: number;
    /**
     * original number of infant guest
     */
    originalInfantGuest: number;
    /**
     * original number of pet guest
     */
    originalPetGuest: number;
    /**
     * if the booking was made or partially made with a pass, the pass id used
     */
    passId?: number | null;
    /**
     * the type of the pass formatted to be LCM friendly
     */
    passName?: null | string;
    /**
     * if the booking was made or partially made with a pass, what type of pass
     */
    passType?: GuestAcceptReviewChangesFromHostPassType | null;
    /**
     * if the booking was made or partially made with a pass, what was the user pass Id used
     */
    userPassId?: number | null;
    [property: string]: any;
}

/**
 * [GUEST RESERVATION] guest selected cancellation reason
 */
export interface GuestReservationSelectedCancelReason {
    /**
     * was the booking made using a pass
     */
    bookingWithPass?: BookingWithPass;
    /**
     * cancellation reason selected by guest
     */
    cancellationReason: string;
    /**
     * if the booking was made or partially made with a pass, the pass id used
     */
    passId?: number | null;
    /**
     * the type of the pass formatted to be LCM friendly
     */
    passName?: null | string;
    /**
     * if the booking was made or partially made with a pass, what type of pass
     */
    passType?: GuestAcceptReviewChangesFromHostPassType | null;
    /**
     * if the booking was made or partially made with a pass, what was the user pass Id used
     */
    userPassId?: number | null;
    [property: string]: any;
}

/**
 * [GUEST FAVORITE] guest pressed to enter one of the favorite lists
 */
export interface GuestSelectFavoriteList {
    /**
     * the user id of the account who created the favorite collection
     */
    alphaUserId?: number;
    /**
     * an array of any favorite collection collaborator's user ids
     */
    betaUserIds?: any[];
    /**
     * the favorite collection id
     */
    favoriteCollectionId: number;
    /**
     * the name of the favorite collection
     */
    favoriteCollectionName: string;
    id?:                    string;
    /**
     * a boolean to identify whether the actions being taken to a favorite collection are being
     * done by the alpha user (1) or a beta user (0)
     */
    isAlphaUserId: boolean;
    [property: string]: any;
}

/**
 * [GUEST RESERVATION] guest select and pressed accept refund type after host cancelled
 * booking
 */
export interface GuestSelectedRefundType {
    /**
     * id of the booking
     */
    bookingId: string;
    /**
     * was the booking made using a pass
     */
    bookingWithPass?: BookingWithPass;
    /**
     * amount of the cash refund option
     */
    cashRefundAmount: number;
    /**
     * amount of the credit refund option
     */
    creditRefundAmount: number;
    /**
     * True if guest pressed credit option, false if pressed cash option
     */
    isCredit: boolean;
    /**
     * if the booking was made or partially made with a pass, the pass id used
     */
    passId?: number | null;
    /**
     * the type of the pass formatted to be LCM friendly
     */
    passName?: null | string;
    /**
     * if the booking was made or partially made with a pass, what type of pass
     */
    passType?: GuestAcceptReviewChangesFromHostPassType | null;
    /**
     * if the booking was made or partially made with a pass, what was the user pass Id used
     */
    userPassId?: number | null;
    [property: string]: any;
}

/**
 * guest submitted a refund request to host
 */
export interface GuestSubmittedRefundRequest {
    /**
     * id of the booking
     */
    bookingId: number;
    /**
     * status of the booking
     */
    bookingStatus: string;
    /**
     * id of the host for the booking
     */
    hostId: number;
    /**
     * message the guest sends to the host regarding the refund
     */
    refundMessage: string;
    /**
     * guest-selected refund reason
     */
    refundReason: string;
    [property: string]: any;
}

/**
 * [GUEST RESERVATION] guest submitted change request with note to host
 */
export interface GuestSubmittedSendRequestWithNote {
    /**
     * id of the booking
     */
    bookingId: string;
    /**
     * was the booking made using a pass
     */
    bookingWithPass?: BookingWithPass;
    /**
     * note entered by the guests in the change request for host
     */
    enteredNote: string;
    /**
     * if the booking was made or partially made with a pass, the pass id used
     */
    passId?: number | null;
    /**
     * the type of the pass formatted to be LCM friendly
     */
    passName?: null | string;
    /**
     * if the booking was made or partially made with a pass, what type of pass
     */
    passType?: GuestAcceptReviewChangesFromHostPassType | null;
    /**
     * if the booking was made or partially made with a pass, what was the user pass Id used
     */
    userPassId?: number | null;
    [property: string]: any;
}

/**
 * [HOST PROMO CODE] Host Pressed "Done" or "Skip" on adding a message to their promocode
 * and this event should fire when the promo is added to the listing
 */
export interface HostAddedPromotionToListing {
    amountOff:  number;
    expireDate: string;
    /**
     * [LISTING TYPE] The type of the listing associated with this event
     */
    globalListingType: GlobalListingType;
    /**
     * was the promotion created during the flow of adding a promotion to the pdp
     */
    isNew:         boolean;
    listingId:     string;
    maxRedemption: number;
    promocodeId:   number;
    promoCodeName: string;
    /**
     * if the user selected to add a message to go with the promo on the listing
     */
    promoMessage?: string;
    [property: string]: any;
}

/**
 * [LISTING TYPE] The type of the listing associated with this event
 */
export enum GlobalListingType {
    ArtStudio = "artStudio",
    BasketballCourt = "basketballCourt",
    DockedBoat = "dockedBoat",
    Home = "home",
    HomeGym = "homeGym",
    Joyspace = "joyspace",
    Kitchen = "kitchen",
    LargeBackyard = "largeBackyard",
    MusicStudio = "musicStudio",
    Other = "other",
    Pending = "pending",
    Pickleball = "pickleball",
    Pool = "pool",
    PrivateLake = "privateLake",
    RoofDeck = "roofDeck",
    TennisCourt = "tennisCourt",
}

/**
 * [HOST ONBOARDING] host entered additional pool details
 */
export interface HostAdditionalPoolDetailsEntered {
    /**
     * if the host indicated the listing is ada compliant, they can add a note for context
     */
    accessibilityDetails?: string;
    /**
     * host indicated pool ada compliant
     */
    adaCompliantSelected: boolean;
    /**
     * host indicated pool has diving board
     */
    divingBoardSelected: boolean;
    /**
     * All possible values for enteredFrom in host onboarding
     */
    enteredFrom: HostAdditionalPoolDetailsEnteredEnteredFrom;
    /**
     * any generic features that a listing has
     */
    features: any[];
    /**
     * any great for stickers selected in the great for section
     */
    greatForUseCase: any[];
    /**
     * host indicated pool has great sunlight
     */
    greatSunlightSelected: boolean;
    /**
     * host indicated pool has grotto
     */
    grottoSelected: boolean;
    /**
     * host indicated pool has kiddie pool
     */
    kiddiePoolSelected: boolean;
    /**
     * host indicated pool has large shallow area
     */
    largeShallowAreaSelected: boolean;
    /**
     * any listing type specific features that a listing has
     */
    listingFeatures: any[];
    /**
     * id for the related listing
     */
    listingId: string;
    /**
     * host indicated pool has night lighting
     */
    nightLightingSelected: boolean;
    /**
     * host indicated pool has pool basketball hoop
     */
    poolBasketballHoopSelected: boolean;
    /**
     * legacy name for listing id
     */
    poolId?: string;
    /**
     * pressed "save and exit" to remove from flow
     */
    pressedSaveExit: boolean;
    /**
     * host indicated pool has saltwater
     */
    saltWaterSelected: boolean;
    /**
     * host indicated pool area has shade
     */
    shadedAreaSelected: boolean;
    /**
     * host indicated pool has swimming lanes
     */
    swimmingLanesSelected: boolean;
    /**
     * host indicated pool has tanning edge
     */
    tanningEdgeSelected: boolean;
    /**
     * host indicated pool has water fall
     */
    waterfallSelected: boolean;
    /**
     * host indicated pool has water slide
     */
    waterSlideSelected: boolean;
    [property: string]: any;
}

/**
 * All possible values for enteredFrom in host onboarding
 */
export enum HostAdditionalPoolDetailsEnteredEnteredFrom {
    Austin = "austin",
    AustinFB = "austinFB",
    ClarkRubber = "clarkRubber",
    DIPApp = "dipApp",
    DirectPoolSupplies = "directPoolSupplies",
    ExistingHostNewListingFlow = "existingHostNewListingFlow",
    HostExistingListingManagement = "hostExistingListingManagement",
    HostOnboardingFlow = "hostOnboardingFlow",
    Houston = "houston",
    HoustonFB = "houstonFB",
    Losangeles = "losangeles",
    LosangelesFB = "losangelesFB",
    NewYork = "newYork",
    NewYorkFB = "newYorkFB",
    NoListingsScreen = "noListingsScreen",
    PerformanceTips = "performanceTips",
    Ph = "ph",
    PoolProfits = "poolProfits",
    PoolSafetySolutions = "poolSafetySolutions",
    Portland = "portland",
    PortlandFB = "portlandFB",
    PrecisionPoolsAndLandscape = "precisionPoolsAndLandscape",
    ProfileManageListings = "profileManageListings",
    ProfilePhotosScreen = "ProfilePhotosScreen",
    ProfileScreen = "ProfileScreen",
    SANAntonio = "sanAntonio",
    SANAntonioFB = "sanAntonioFB",
    Seattle = "seattle",
    SeattleFB = "seattleFB",
    SwimUniversity = "swimUniversity",
    Toronto = "toronto",
    TorontoFB = "torontoFB",
    Vip = "vip",
}

/**
 * [HOST ONBOARDING] host read all and agree neighbor guidelines
 */
export interface HostAgreeNeighborGuidelines {
    /**
     * All possible values for enteredFrom in host onboarding
     */
    enteredFrom: HostAdditionalPoolDetailsEnteredEnteredFrom;
    id?:         string;
    /**
     * id for the related listing
     */
    listingId: string;
    /**
     * legacy name for listing id
     */
    poolId?: string;
    [property: string]: any;
}

/**
 * [HOST ONBOARDING] host added amenities. Event should fire per amenity selected
 */
export interface HostAmenitiesAdded {
    /**
     * a host added an amenity
     */
    amenityAdded?: AmenityAdded;
    /**
     * All possible values for enteredFrom in host onboarding
     */
    enteredFrom: HostAdditionalPoolDetailsEnteredEnteredFrom;
    /**
     * id for the related listing
     */
    listingId: string;
    /**
     * legacy name for listing id
     */
    poolId?: string;
    /**
     * pressed "save and exit" to remove from flow
     */
    pressedSaveExit: boolean;
    [property: string]: any;
}

/**
 * a host added an amenity
 */
export interface AmenityAdded {
    /**
     * blurb for the amenity
     */
    amenityDetails?: null | string;
    /**
     * details of the amenity price (even if free)
     */
    amenityPricingDetails?: null | AmenityPricingDetails;
    /**
     * name of the amenity added
     */
    amenityType: string;
    /**
     * is this a custom entered amenity (not a Swimply pre-defined amenity)
     */
    isCustomAmenity: boolean;
    [property: string]: any;
}

export interface AmenityPricingDetails {
    /**
     * details for flat fee amenities
     */
    amenityPremiumFlatFee?: AmenityPremiumFlatFee;
    /**
     * details for hourly fee amenities
     */
    amenityPremiumHourlyFee?: AmenityPremiumHourlyFee;
    /**
     * is there an additional fee for this amenity
     */
    isAmenityPremium: boolean;
    [property: string]: any;
}

/**
 * details for flat fee amenities
 */
export interface AmenityPremiumFlatFee {
    /**
     * flat fee amount
     */
    flatFeeAmount: string;
    /**
     * currency for the flat fee
     */
    flatFeeCurrencyType: string;
    /**
     * is a flat fee charged
     */
    isAmenityFlatFee: boolean;
    [property: string]: any;
}

/**
 * details for hourly fee amenities
 */
export interface AmenityPremiumHourlyFee {
    /**
     * fee per hour
     */
    hourlyFee: number | null;
    /**
     * currency for the hourly fee
     */
    hourlyFeeCurrencyType: string;
    /**
     * is there an hourly fee
     */
    isAmenityPremiumHourlyFee: boolean;
    [property: string]: any;
}

/**
 * [HOST ONBOARDING] host saved amenities - event should fire only when the amenity
 * management selection are saved
 */
export interface HostAmenitiesEntered {
    additionalAmenitiesAndServices?: string;
    additionalSpaces?:               string;
    /**
     * any generic space type amenities that are added
     */
    amenities: any[];
    id?:       string;
    /**
     * any listing type specific amenities that are added
     */
    listingAmenities: any[];
    [property: string]: any;
}

/**
 * [HOST CALENDAR] Host pressed the advanced setting in general availability setting (Cog
 * wheel)
 */
export interface HostAvailabilitySettingPressedAdvancedSetting {
    /**
     * listing id
     */
    listingId: string;
    [property: string]: any;
}

/**
 * [HOST CALENDAR] Host pressed done in the advanced setting
 */
export interface HostAvailabilitySettingPressedDoneAdvancedSetting {
    /**
     * selected advance notice
     */
    advancedNotice: number;
    /**
     * selected future booking notice
     */
    futureBookingNotice: number;
    /**
     * selected maximum number of guest for instant book
     */
    instantMaxGuest: number;
    /**
     * true if enabled instant book, false otherwise
     */
    isInstantBook: boolean;
    /**
     * true if checked the box for still show me request under advance notice, false if unchecked
     */
    isStillShowMeRequestAdvanceNotice: boolean;
    /**
     * true if checked the box for still show me request under future notice, false if unchecked
     */
    isStillShowMeRequestFutureBooking: boolean;
    /**
     * listing id
     */
    listingId: string;
    [property: string]: any;
}

/**
 * [HOST CALENDAR] Host pressed done in the general setting
 */
export interface HostAvailabilitySettingPressedDoneGeneralSetting {
    /**
     * array of selected available week day [Mon, Tue, Wed, Thur, Fri, Sat, Sun]
     */
    availableWeekDay: any[];
    /**
     * selected buffer time
     */
    bufferTime: number;
    /**
     * selected end available hour
     */
    endHour: string;
    /**
     * listing id
     */
    listingId: string;
    /**
     * selected start available hour
     */
    startHour: string;
    [property: string]: any;
}

/**
 * [HOST CALENDAR] Host pressed done in the listing setting
 */
export interface HostAvailabilitySettingPressedDoneListingStatus {
    /**
     * current status
     */
    currentStatus: string;
    /**
     * listing id
     */
    listingId: string;
    /**
     * new status
     */
    newStatus: string;
    [property: string]: any;
}

/**
 * [HOST CALENDAR] Host pressed the general setting in general availability setting (Cog
 * wheel)
 */
export interface HostAvailabilitySettingPressedGeneralSetting {
    id?: string;
    [property: string]: any;
}

/**
 * [HOST CALENDAR] Host pressed the listing setting in general availability setting (Cog
 * wheel)
 */
export interface HostAvailabilitySettingPressedListingStatus {
    id?: string;
    [property: string]: any;
}

/**
 * [HOST CALENDAR SYNCING] host presses "sync external calendars"  after pressing the cog
 * wheel
 */
export interface HostAvailabilitySettingPressedSyncCals {
    listingId: number;
    [property: string]: any;
}

/**
 * [HOST CALENDAR] Host pressed the unavailability rule in general availability setting (Cog
 * wheel)
 */
export interface HostAvailabilitySettingPressedUnavailabilityRules {
    id?: string;
    [property: string]: any;
}

/**
 * [HOST ONBOARDING] host entered cancellation policy info
 */
export interface HostBookingCancellationPolicy {
    /**
     * which cancellation policy was selected
     */
    cancellationPolicy: string;
    /**
     * All possible values for enteredFrom in host onboarding
     */
    enteredFrom: HostAdditionalPoolDetailsEnteredEnteredFrom;
    /**
     * id for the related listing
     */
    listingId: string;
    /**
     * legacy name for listing id
     */
    poolId?: string;
    /**
     * pressed "save and exit" to remove from flow
     */
    pressedSaveExit: boolean;
    [property: string]: any;
}

/**
 * [HOST ONBOARDING] host entered information about cameras and whether they are home
 */
export interface HostBookingHostPrivacy {
    /**
     * All possible values for enteredFrom in host onboarding
     */
    enteredFrom: HostAdditionalPoolDetailsEnteredEnteredFrom;
    /**
     * does the pool have security cameras
     */
    hostHasSecurityCameras: boolean;
    /**
     * host staying at home option
     */
    hostHomeOptionSelected: string;
    /**
     * id for the related listing
     */
    listingId: string;
    /**
     * legacy name for listing id
     */
    poolId?: string;
    /**
     * pressed "save and exit" to remove from flow
     */
    pressedSaveExit: boolean;
    [property: string]: any;
}

/**
 * [HOST ONBOARDING] on booking overview page details about whether host requests to review
 * each booking request
 */
export interface HostBookingRequestReview {
    /**
     * did the host confirm that they would like to review bookings
     */
    confirmedReviewEveryRequest: boolean;
    /**
     * All possible values for enteredFrom in host onboarding
     */
    enteredFrom: HostAdditionalPoolDetailsEnteredEnteredFrom;
    /**
     * id for the related listing
     */
    listingId: string;
    /**
     * legacy name for listing id
     */
    poolId?: string;
    /**
     * pressed "save and exit" to remove from flow
     */
    pressedSaveExit: boolean;
    /**
     * did the host press to see information about reviewing bookings
     */
    pressReviewEveryRequest: boolean;
    [property: string]: any;
}

/**
 * [HOST ONBOARDING] host entered in rules for pool
 */
export interface HostBookingRules {
    /**
     * any additional rules that the host entered
     */
    additionalRules: string;
    /**
     * is alcohol allowed
     */
    alcoholAllowed: boolean;
    /**
     * All possible values for enteredFrom in host onboarding
     */
    enteredFrom: HostAdditionalPoolDetailsEnteredEnteredFrom;
    /**
     * id for the related listing
     */
    listingId: string;
    /**
     * is loud music allowed
     */
    loudMusicAllowed: boolean;
    /**
     * is nudity allowed - pools only
     */
    nudityAllowed?: boolean | null;
    /**
     * are parties allowed
     */
    partiesAllowed: boolean;
    /**
     * legacy name for listing id
     */
    poolId?: string;
    /**
     * pressed "save and exit" to remove from flow
     */
    pressedSaveExit: boolean;
    /**
     * is smoking allowed
     */
    smokingAllowed: boolean;
    /**
     * are 3rd party vendors allowed
     */
    thirdPartyVendorsAllowed: boolean;
    [property: string]: any;
}

/**
 * [HOST CALENDAR SYNCING] after pressing the cog wheel and then "sync external calendars"
 * host pressed "Export Swimply iCalendar"
 */
export interface HostCalSyncPressedExportCalendar {
    listingId: number;
    [property: string]: any;
}

/**
 * [HOST CALENDAR SYNCING] after pressing the cog wheel and then "sync external calendars"
 * host pressed "Import external iCalendars"
 */
export interface HostCalSyncPressedImportCalendar {
    listingId: number;
    [property: string]: any;
}

/**
 * [HOST CALENDAR SYNCING] after pressing the cog wheel and then "sync external calendars"
 * host pressed "Manage Cronofy"
 */
export interface HostCalSyncPressedManageCronofy {
    listingId: number;
    [property: string]: any;
}

/**
 * [HOST CALENDAR SYNCING] after pressing the cog wheel and then "sync external calendars"
 * host pressed "Manage external iCalendars"
 */
export interface HostCalSyncPressedManageImportedCal {
    listingId: number;
    [property: string]: any;
}

/**
 * [HOST CALENDAR SYNCING] after pressing the cog wheel and then "sync external calendars"
 * host pressed "Sync with Cronofy"
 */
export interface HostCalSyncPressedSyncWCronofy {
    listingId: number;
    [property: string]: any;
}

/**
 * [HOST CALENDAR] Host pressed apply discount/boost button in price
 */
export interface HostCalendarApplyDiscountOrBoost {
    /**
     * Listing id
     */
    listingId: string;
    /**
     * Percent change for discount or boost
     */
    percentChange: number;
    /**
     * Array of selected date for this adjustment
     */
    selectedDates: any[];
    [property: string]: any;
}

/**
 * [HOST CALENDAR] Host pressed to adjust status in the bottom card
 */
export interface HostCalendarBottomCardAdjustedStatus {
    /**
     * Object consists of new status per dates
     */
    changedStatus: ChangedStatus;
    /**
     * listing id
     */
    listingId: string;
    [property: string]: any;
}

/**
 * Object consists of new status per dates
 */
export interface ChangedStatus {
    /**
     * selected dates
     */
    dates?: any[];
    /**
     * status after changed, instant book or request only
     */
    newStatus?: string;
    /**
     * status before changed, instant book or request only
     */
    originalStatus?: string;
    [property: string]: any;
}

/**
 * [HOST CALENDAR] Host pressed clear in discount/boost in price
 */
export interface HostCalendarClearDiscountOrBoost {
    id?: string;
    [property: string]: any;
}

/**
 * [HOST CALENDAR] Host pressed close in apply discount/boost card
 */
export interface HostCalendarCloseApplyDiscountOrBoost {
    id?: string;
    [property: string]: any;
}

/**
 * [HOST CALENDAR] Host pressed close in clear card for discount/boost in price
 */
export interface HostCalendarCloseClearDiscountOrBoost {
    id?: string;
    [property: string]: any;
}

/**
 * [HOST CALENDAR] Host pressed close schedule conflicting card
 */
export interface HostCalendarCloseScheduleConflict {
    id?: string;
    [property: string]: any;
}

/**
 * [HOST CALENDAR] Host pressed confirmed clear discount or boost
 */
export interface HostCalendarConfirmClearDiscountOrBoost {
    id?: string;
    [property: string]: any;
}

/**
 * [HOST CALENDAR] Host pressed set discount or boost in no tier pricing
 */
export interface HostCalendarNoTierPricePressedSetDiscountOrBoost {
    id?: string;
    [property: string]: any;
}

/**
 * [HOST CALENDAR] Host pressed update prices in no tier pricing card
 */
export interface HostCalendarNoTierPricePressedUpdatePrices {
    id?: string;
    [property: string]: any;
}

/**
 * [HOST CALENDAR] Host pressed apply block in the schedule conflicting card
 */
export interface HostCalendarPressedApplyBlockScheduleConflict {
    /**
     * Array of booking id got conflicted
     */
    conflictedBookingId: any[];
    /**
     * Displayed conflicted date
     */
    conflictedDate: any[];
    /**
     * Displayed conflicted hour
     */
    conflictedHour: any[];
    /**
     * listing Id
     */
    listingId: string;
    [property: string]: any;
}

/**
 * [HOST CALENDAR] Host pressed availability box
 */
export interface HostCalendarPressedAvailability {
    id?: string;
    [property: string]: any;
}

/**
 * [HOST CALENDAR] Host pressed block hour button to confirm block hour
 */
export interface HostCalendarPressedConfirmBlockedHour {
    /**
     * Array of selected dates
     */
    dates: any[];
    /**
     * hour the block end
     */
    endHour: string;
    /**
     * listing id
     */
    listingId: string;
    /**
     * hour the block start
     */
    startHour: string;
    [property: string]: any;
}

/**
 * [HOST CALENDAR] Host pressed edit for discount/boost
 */
export interface HostCalendarPressedEditDiscountorBoost {
    id?: string;
    [property: string]: any;
}

/**
 * [HOST CALENDAR] Host pressed cross on top left to exit managing dates
 */
export interface HostCalendarPressedExitManageDate {
    id?: string;
    [property: string]: any;
}

/**
 * [HOST CALENDAR] Host pressed cog wheel for general availability setting
 */
export interface HostCalendarPressedManageGeneralAvailability {
    id?: string;
    [property: string]: any;
}

/**
 * Host pressed manage in calendar view
 */
export interface HostCalendarPressedManageSelectDates {
    /**
     * array object of the selected dates
     */
    dates: any[];
    /**
     * listingId
     */
    listingId: string;
    [property: string]: any;
}

/**
 * [HOST CALENDAR] Host pressed price in the manage date view
 */
export interface HostCalendarPressedPrice {
    id?: string;
    [property: string]: any;
}

/**
 * [HOST CALENDAR] Host pressed remove block in the manage date view
 */
export interface HostCalendarPressedRemoveBlock {
    /**
     * array of selected dates
     */
    dates: any[];
    /**
     * end of blocked hour
     */
    endHour: string;
    /**
     * listing id
     */
    listingId: string;
    /**
     * start of blocked hour
     */
    startHour: string;
    [property: string]: any;
}

/**
 * [HOST CALENDAR] Host pressed set discount or boost in price view
 */
export interface HostCalendarPressedSetDiscountOrBoost {
    id?: string;
    [property: string]: any;
}

/**
 * [HOST CALENDAR] Host pressed remove selected dates on top of the manage view (only for
 * multiple selected dates)
 */
export interface HostCalendarRemoveSelectedDates {
    /**
     * listing id
     */
    listingId: string;
    /**
     * removed dates
     */
    removedDates: any[];
    [property: string]: any;
}

/**
 * [HOST CALENDAR] Host pressed on date in the calendar view
 */
export interface HostCalendarSelectedDate {
    id?: string;
    [property: string]: any;
}

/**
 * [HOST CALENDAR] Host pressed view reservation on schedule conflict card
 */
export interface HostCalendarViewReservationScheduleConflict {
    /**
     * Array of booking id got conflicted
     */
    conflictedBookingId: any[];
    /**
     * Displayed conflicted date
     */
    conflictedDate: any[];
    /**
     * Displayed conflicted hour
     */
    conflictedHour: any[];
    [property: string]: any;
}

/**
 * [HOST BOOKING INQUIRY POST-SPECIAL OFFER SENT]
 */
export interface HostCancelledSpecialOffer {
    bookingId:             number;
    bookingSpecialOfferId: number;
    courtesyNote?:         null | string;
    /**
     * [LISTING TYPE] The type of the listing associated with this event
     */
    globalListingType: GlobalListingType;
    guestId:           number;
    hostId:            number;
    listingId:         number;
    originalPrice:     number;
    roomId?:           string;
    specialOfferPrice: number;
    [property: string]: any;
}

/**
 * [HOST PASS MANAGEMENT - DEACTIVATING]
 */
export interface HostConfirmedDeactivatePass {
    /**
     * the url for the cover image of the listing the pass is for
     */
    coverImageURL: string;
    /**
     * first name of the host
     */
    hostFirstName: string;
    id?:           string;
    /**
     * id of the listing the pass is for
     */
    listingId: string;
    /**
     * the title of the listing the pass is for
     */
    listingTitle: string;
    /**
     * the url of the listing the pass is for
     */
    listingURL: string;
    /**
     * [{from:”07:00:00”, “11:00:00”}...] Time slots when this pass is eligible
     */
    passAvailableTimes?: any[];
    /**
     * LCM formatted version of available times property
     */
    passAvailableTimesText?: string;
    /**
     * list of blackout dates (e.g. July 4, 2024).
     */
    passBlackoutDays?: any[] | null;
    /**
     * when the pass was created
     */
    passCreatedAt: string;
    /**
     * currency for all monetary fields
     */
    passCurrencyCode: string;
    /**
     * flag indicating that this is the current version for a pass. For a type/name/listing_id,
     * there can only be one record with this attribute true.
     */
    passCurrent: boolean;
    /**
     * free text description set by host
     */
    passDescription?: null | string;
    /**
     * discount amount. Fixed discounts will be in minors units.
     */
    passDiscount: number | null;
    /**
     * type of pass discount num[‘percentage’, ‘fixed’]
     */
    passDiscountType: PassDiscountType | null;
    /**
     * days the pass is eligible
     */
    passEligibleDays?: any[] | null;
    /**
     * id of the pass
     */
    passId: number;
    /**
     * max active passes allowed. This constraint will apply to the (listing_id, type, name)
     * rather than id so that we can be accurate across edits.
     */
    passMaxActivePasses?: number | null;
    /**
     * max bookings allowed under this pass
     */
    passMaxDailyBookings?: number | null;
    /**
     * max duration that may be booked using this pass
     */
    passMaxDuration?: number | null;
    /**
     * max guests that may be booked using this pass
     */
    passMaxGuests?: number | null;
    /**
     * the type of the pass formatted to be LCM friendly
     */
    passName: string;
    /**
     * the ids of all premium amenities included with the pass
     */
    passPremiumAmenities?: any[] | null;
    /**
     * pass price in minor units
     */
    passPrice: string;
    /**
     * ‘draft’ -> pass is being actively edited by the host via the creation flow. The step
     * attribute below tracks the progress of the host through the creation flow.
     * ‘inactive’ -> pass has been created by the host, but not ready for sale yet
     * ‘active’ -> pass has passed the final availability requirements and has been marked by
     * the host as ready for sale.
     */
    passState: PassState;
    /**
     * the pass of the price plus the service fee
     */
    passTotalPrice: string;
    /**
     * the type of pass
     */
    passType: GuestPassPurchaseFailurePassType;
    [property: string]: any;
}

/**
 * [HOST PASS MANAGEMENT - REFUND]
 */
export interface HostConfirmedRefundPassholder {
    canceled?:       boolean;
    canceledReason?: string;
    /**
     * the url for the cover image of the listing the pass is for
     */
    coverImageURL:  string;
    createdAt?:     string;
    end:            string;
    hasAutorenewOn: boolean;
    /**
     * first name of the host
     */
    hostFirstName: string;
    id?:           string;
    /**
     * true if the pass is a legacy pass
     */
    isLegacy: boolean;
    /**
     * id of the listing the pass is for
     */
    listingId: string;
    /**
     * the title of the listing the pass is for
     */
    listingTitle: string;
    /**
     * the url of the listing the pass is for
     */
    listingURL: string;
    /**
     * [{from:”07:00:00”, “11:00:00”}...] Time slots when this pass is eligible
     */
    passAvailableTimes?: any[];
    /**
     * LCM formatted version of available times property
     */
    passAvailableTimesText?: string;
    /**
     * list of blackout dates (e.g. July 4, 2024).
     */
    passBlackoutDays?: any[] | null;
    /**
     * when the pass was created
     */
    passCreatedAt: string;
    /**
     * currency for all monetary fields
     */
    passCurrencyCode: string;
    /**
     * flag indicating that this is the current version for a pass. For a type/name/listing_id,
     * there can only be one record with this attribute true.
     */
    passCurrent: boolean;
    /**
     * free text description set by host
     */
    passDescription?: null | string;
    /**
     * discount amount. Fixed discounts will be in minors units.
     */
    passDiscount: number | null;
    /**
     * type of pass discount num[‘percentage’, ‘fixed’]
     */
    passDiscountType: PassDiscountType | null;
    /**
     * days the pass is eligible
     */
    passEligibleDays?: any[] | null;
    /**
     * the status of the pass
     */
    passholderStatus: PassholderStatus;
    /**
     * the user id of the pass holder
     */
    passholderUserId: number;
    /**
     * id of the pass
     */
    passId: number;
    /**
     * max active passes allowed. This constraint will apply to the (listing_id, type, name)
     * rather than id so that we can be accurate across edits.
     */
    passMaxActivePasses?: number | null;
    /**
     * max bookings allowed under this pass
     */
    passMaxDailyBookings?: number | null;
    /**
     * max duration that may be booked using this pass
     */
    passMaxDuration?: number | null;
    /**
     * max guests that may be booked using this pass
     */
    passMaxGuests?: number | null;
    /**
     * the type of the pass formatted to be LCM friendly
     */
    passName: string;
    /**
     * the ids of all premium amenities included with the pass
     */
    passPremiumAmenities?: any[] | null;
    /**
     * pass price in minor units
     */
    passPrice: string;
    /**
     * ‘draft’ -> pass is being actively edited by the host via the creation flow. The step
     * attribute below tracks the progress of the host through the creation flow.
     * ‘inactive’ -> pass has been created by the host, but not ready for sale yet
     * ‘active’ -> pass has passed the final availability requirements and has been marked by
     * the host as ready for sale.
     */
    passState: PassState;
    /**
     * the pass of the price plus the service fee
     */
    passTotalPrice: string;
    /**
     * the type of pass
     */
    passType:   GuestPassPurchaseFailurePassType;
    start:      string;
    userPassId: number;
    [property: string]: any;
}

/**
 * [HOST PERFORMANCE] Host deleted their reply to a review
 */
export interface HostDeletedReviewReply {
    bookingId: number;
    /**
     * message sent by the guest when booking
     */
    bookingMessage?: null | string;
    /**
     * if the guest left a rating between 1-5, what was it
     */
    bookingRating?: number | null;
    /**
     * guest selection (listing type specific) for why they're booking
     */
    bookingReason?: BookingReason | null;
    /**
     * if the guest left a review, what was it
     */
    bookingReview?:         null | string;
    bookingSpecialOfferId?: number | null;
    guestId:                number;
    hostId:                 number;
    id?:                    string;
    isInstantBooking?:      boolean;
    listingId:              number;
    listingTitle:           string;
    /**
     * the host's reply
     */
    reply:        string;
    totalGuests?: number;
    totalPrice?:  number;
    [property: string]: any;
}

export enum BookingReason {
    CasualPlay = "casual_play",
    CompetitivePlay = "competitive_play",
    CorporateOrMeeting = "corporate_or_meeting",
    Courts = "courts",
    Date = "date",
    Exercise = "exercise",
    FamilyHangout = "family_hangout",
    FriendHangout = "friend_hangout",
    Lessons = "lessons",
    Other = "other",
    PartyCelebration = "party_celebration",
    PartyOrCelebration = "party_or_celebration",
    PetSwim = "pet_swim",
    Photoshoot = "photoshoot",
    Training = "training",
}

/**
 * [HOST PERFORMANCE] Host pressed to change the start date in the transaction in earning
 */
export interface HostEarningHistChangedStartDate {
    /**
     * id of the listing
     */
    listingId: string;
    /**
     * the new start date
     */
    newStartDate: string;
    [property: string]: any;
}

/**
 * [HOST PERFORMANCE] Host pressed the displayed end date in transaction in earning
 */
export interface HostEarningHistPressedEndDate {
    /**
     * end date of the shown transaction
     */
    endDate: string;
    /**
     * id of the listing
     */
    listingId: string;
    [property: string]: any;
}

/**
 * [HOST PERFORMANCE] Host pressed the displayed start date in transaction in earning
 */
export interface HostEarningHistPressedStartDate {
    /**
     * id of the listing
     */
    listingId: string;
    /**
     * start date of the shown transaction
     */
    startDate: string;
    [property: string]: any;
}

/**
 * [HOST PERFORMANCE] Host pressed the completed or upcoming tab in transaction in earning DB
 */
export interface HostEarningHistSwitchTab {
    /**
     * id of the listing
     */
    listingId: string;
    /**
     * the tab that pressed by the host (completed or upcoming)
     */
    switchTo: HostEarningHistSwitchTabSwitchTo;
    [property: string]: any;
}

/**
 * the tab that pressed by the host (completed or upcoming)
 */
export enum HostEarningHistSwitchTabSwitchTo {
    Completed = "completed",
    Upcoming = "upcoming",
}

/**
 * [HOST PERFORMANCE] Host pressed to change the end date in the transaction in earning
 */
export interface HostEarningsHistChangedEndDate {
    /**
     * id of the listing
     */
    listingId: string;
    /**
     * the new end date
     */
    newEndDate: string;
    [property: string]: any;
}

/**
 * [HOST PERFORMANCE] Host pressed insight or transactions tab in earning DB
 */
export interface HostEarningsSwitchTab {
    /**
     * id of the listing
     */
    listingId: string;
    /**
     * the tab that pressed by the host (insight or transactions)
     */
    switchTo: HostEarningsSwitchTabSwitchTo;
    [property: string]: any;
}

/**
 * the tab that pressed by the host (insight or transactions)
 */
export enum HostEarningsSwitchTabSwitchTo {
    Insights = "insights",
    Transactions = "transactions",
}

/**
 * when host edit a listing property
 */
export interface HostEditListingProperty {
    /**
     * [LISTING TYPE] The type of the listing associated with this event
     */
    globalListingType: GlobalListingType;
    /**
     * id of the listing
     */
    listingId: number;
    /**
     * category of the space property
     */
    spacePropertyCategory: SpacePropertyCategory;
    /**
     * the values of each edited property
     */
    value: Value[];
    [property: string]: any;
}

/**
 * category of the space property
 */
export enum SpacePropertyCategory {
    Amenities = "amenities",
    Availability = "availability",
    Cancallations = "cancallations",
    Features = "features",
    Guests = "guests",
    HostPreference = "hostPreference",
    Parking = "parking",
    Pricing = "pricing",
    Privacy = "privacy",
    Profile = "profile",
    Restroom = "restroom",
    SpaceDetails = "spaceDetails",
    SpaceFeatures = "spaceFeatures",
}

/**
 * each item contains the field name and the value edited for the property
 */
export interface Value {
    /**
     * the field name of the listing property
     */
    fieldName: string;
    /**
     * the value after edited or selected
     */
    value: string;
    [property: string]: any;
}

/**
 * [TIERED PRICING] host entered the price for legacy flat rate pricing
 */
export interface HostEnteredFlatRatePrice {
    /**
     * boolean true if the price change is for the hourly price, false if the price change is
     * for the fee per guest
     */
    isEditHourlyPrice: boolean;
    /**
     * new price after change
     */
    newPrice: number;
    /**
     * original price before change
     */
    originalPrice: number;
    [property: string]: any;
}

/**
 * [TIERED PRICING] host entered the price for the full day price
 */
export interface HostEnteredFullDayPrice {
    /**
     * new price after change
     */
    newPrice: number;
    /**
     * original price before change
     */
    originalPrice: number;
    [property: string]: any;
}

/**
 * [HOST RESERVATION] host pressed 'nevermind' button to cancel sending change request
 */
export interface HostExitChangeRequestNeverMind {
    /**
     * id of the booking the reservation pertains to
     */
    bookingId: string;
    /**
     * was the booking made using a pass
     */
    bookingWithPass?: BookingWithPass;
    /**
     * entered from with booking edit flow
     */
    enteredFrom: HostExitChangeRequestNeverMindEnteredFrom;
    /**
     * if the booking was made or partially made with a pass, the pass id used
     */
    passId?: number | null;
    /**
     * the type of the pass formatted to be LCM friendly
     */
    passName?: null | string;
    /**
     * if the booking was made or partially made with a pass, what type of pass
     */
    passType?: GuestAcceptReviewChangesFromHostPassType | null;
    /**
     * if the booking was made or partially made with a pass, what was the user pass Id used
     */
    userPassId?: number | null;
    [property: string]: any;
}

/**
 * entered from with booking edit flow
 */
export enum HostExitChangeRequestNeverMindEnteredFrom {
    Cancellation = "cancellation",
    ChangeRequest = "change request",
}

/**
 * [HOST PROFILE EVENTS] pressed to upload proof of address/ownership
 */
export interface HostGetVerifiedPressAddressUpload {
    /**
     * "take photo" or "choose image"
     */
    photoOption?: string;
    [property: string]: any;
}

/**
 * [HOST PROFILE EVENTS] host pressed to "upload proof of ownership" on get verified page
 */
export interface HostGetVerifiedPressAddressVerif {
    id?: string;
    [property: string]: any;
}

/**
 * [HOST PROFILE EVENTS] pressed to upload id
 */
export interface HostGetVerifiedPressIDUpload {
    /**
     * "take photo" or "choose image"
     */
    photoOption?: string;
    [property: string]: any;
}

/**
 * [HOST PROFILE EVENTS] host pressed to "upload your id" on get verified page
 */
export interface HostGetVerifiedPressIDVerif {
    id?: string;
    [property: string]: any;
}

/**
 * [HOST PROFILE EVENTS] host submitted proof of ownership/address
 */
export interface HostGetVerifiedSubmitAddressUpload {
    /**
     * file size of photo in kb
     */
    fileSize: number;
    /**
     * png, jif, etc
     */
    imageExtention: string;
    /**
     * url of the photo
     */
    photoURL: string;
    [property: string]: any;
}

/**
 * [HOST PROFILE EVENTS] host submitted id photo
 */
export interface HostGetVerifiedSubmitIDUpload {
    /**
     * file size of photo in kb
     */
    fileSize: number;
    /**
     * png, jif, etc
     */
    imageExtension: string;
    /**
     * url of the photo
     */
    photoURL: string;
    [property: string]: any;
}

/**
 * [HOST ONBOARDING] - Host selection of either request or instant booking
 */
export interface HostHowSwimplyWorks {
    /**
     * All possible values for enteredFrom in host onboarding
     */
    enteredFrom: HostAdditionalPoolDetailsEnteredEnteredFrom;
    /**
     * If isInstantBook is true, what was the selected size?
     */
    instantGroupSize?: number;
    isInstantBook:     boolean;
    /**
     * id for the related listing
     */
    listingId: string;
    /**
     * legacy name for listing id
     */
    poolId?: string;
    /**
     * Was this event triggered by pressing save and exit?
     */
    pressedSaveExit: boolean;
    [property: string]: any;
}

/**
 * [HOST ONBOARDING] host set basic details about court type
 */
export interface HostInitialCourtDetailsEntered {
    /**
     * the number of courts available (5+ = 5 in the data please)
     */
    courtCount: number;
    /**
     * the surface material of the court - tennis and basketball only
     */
    courtSurface?: null | string;
    /**
     * All possible values for enteredFrom in host onboarding
     */
    enteredFrom: HostAdditionalPoolDetailsEnteredEnteredFrom;
    /**
     * [LISTING TYPE] The type of the listing associated with this event
     */
    globalListingType: GlobalListingType;
    /**
     * is the court a full court - basketball only
     */
    isFullCourt?: boolean | null;
    /**
     * is the court regulation - pickleball only
     */
    isRegulation?: boolean | null;
    /**
     * id for the related listing
     */
    listingId: string;
    /**
     * legacy name for listing id
     */
    poolId?: string;
    /**
     * pressed "save and exit" to remove from flow
     */
    pressedSaveExit: boolean;
    [property: string]: any;
}

/**
 * [HOST ONBOARDING] host set basic details about home- actually only fires during post
 * onboard
 */
export interface HostInitialHomeDetailsEntered {
    /**
     * in sq feet
     */
    approximateHomeSize: number;
    id?:                 string;
    [property: string]: any;
}

/**
 * [HOST ONBOARDING] host set basic details about pool (type, water type)
 */
export interface HostInitialPoolDetailsEntered {
    deepEnd?: number;
    /**
     * All possible values for enteredFrom in host onboarding
     */
    enteredFrom: HostAdditionalPoolDetailsEnteredEnteredFrom;
    /**
     * [LISTING TYPE] The type of the listing associated with this event
     */
    globalListingType: GlobalListingType;
    length?:           number;
    /**
     * id for the related listing
     */
    listingId: string;
    /**
     * legacy name for listing id
     */
    poolId?: string;
    /**
     * type of pool listed
     */
    poolTypeListing: string;
    /**
     * pressed "save and exit" to remove from flow
     */
    pressedSaveExit?: boolean;
    shallowEnd?:      number;
    /**
     * type of water system selected
     */
    waterSystemSelected: string;
    width?:              number;
    [property: string]: any;
}

/**
 * [HOST ONBOARDING] confirmation screen for host entering address
 */
export interface HostLeadAddressConfirmation {
    /**
     * final confirmed address
     */
    hostLeadConfirmedAddress: string;
    /**
     * pressed "edit" button to return to previous screen
     */
    hostLeadEditedAddress?: boolean;
    /**
     * moved pin on map which determines location
     */
    hostLeadMovedMapPin?: boolean;
    /**
     * Lowercase only with no punctuation, no special characters, and no spaces. If using
     * special characters, the text must be encoded in UTF-8 format.
     */
    listingCityMetaFormat: string;
    /**
     * listing country code: Use the lowercase, 2-letter country codes in ISO 3166-1 alpha-2
     */
    listingCountryCode: string;
    /**
     * listing id of the address
     */
    listingId?: string;
    /**
     * Listing state: Use the 2-character ANSI abbreviation code in lowercase. Normalize states
     * outside the U.S. in lowercase w...
     */
    listingStateMetaFormat: string;
    /**
     * Use lowercase with no spaces and no dash. Use only the first 5 digits for U.S. zip codes.
     * Use the area, district, and se...
     */
    listingZipcodeMetaFormat: string;
    /**
     * pressed "save and exit" to remove from flow
     */
    pressedSaveExit?: boolean;
    [property: string]: any;
}

/**
 * [HOST ONBOARDING] initial screen for host entering address
 */
export interface HostLeadLocationEntered {
    /**
     * All possible values for enteredFrom in host onboarding
     */
    enteredFrom: HostAdditionalPoolDetailsEnteredEnteredFrom;
    /**
     * address which the user originally submitted before confirmation
     */
    initialAddressSubmitted: string;
    /**
     * Lowercase only with no punctuation, no special characters, and no spaces. If using
     * special characters, the text must be encoded in UTF-8 format.
     */
    listingCityMetaFormat: string;
    /**
     * listing country code: Use the lowercase, 2-letter country codes in ISO 3166-1 alpha-2
     */
    listingCountryCode: string;
    /**
     * id for the related listing
     */
    listingId: string;
    /**
     * Listing state: Use the 2-character ANSI abbreviation code in lowercase. Normalize states
     * outside the U.S. in lowercase with no punctuation, no special characters, and no spaces.
     */
    listingStateMetaFormat: string;
    /**
     * Use lowercase with no spaces and no dash. Use only the first 5 digits for U.S. zip codes.
     * Use the area, district, and sector format for the UK.
     */
    listingZipcodeMetaFormat: string;
    /**
     * did user manually entered or edited address in submission field
     */
    manuallyEnteredAddress: boolean;
    /**
     * legacy name for listing id
     */
    poolId?: string;
    /**
     * pressed "save and exit" to remove from flow
     */
    pressedSaveExit?: boolean;
    /**
     * user used the "use current location" prompt to fill address
     */
    utilizedCurrentLocationPrompt: boolean;
    [property: string]: any;
}

/**
 * [HOST PERFORMANCE] Host pressed cross to close the fan message screen
 */
export interface HostMarketingCloseFansMessages {
    /**
     * id of the listing
     */
    listingId: string;
    [property: string]: any;
}

/**
 * [HOST PERFORMANCE] Host pressed cross to close the invite friends screen
 */
export interface HostMarketingCloseInviteFriends {
    /**
     * id of the listing
     */
    listingId: string;
    [property: string]: any;
}

/**
 * [HOST PERFORMANCE] Host pressed cross to close the marketing tips screen
 */
export interface HostMarketingPressedCloseTips {
    /**
     * id of the listing
     */
    listingId: string;
    [property: string]: any;
}

/**
 * [HOST PERFORMANCE] Host pressed the fan message card in marketing dashboard
 */
export interface HostMarketingPressedFansCard {
    /**
     * id of the listing
     */
    listingId: string;
    /**
     * the displayed fan numbers
     */
    numberOfFans: number;
    [property: string]: any;
}

/**
 * [HOST PERFORMANCE] Host pressed button invite my friends in the invite friends screen in
 * marketing dashboard
 */
export interface HostMarketingPressedInviteFriends {
    /**
     * id of the listing
     */
    listingId?: string;
    [property: string]: any;
}

/**
 * [HOST PERFORMANCE] Host pressed the invite friend card in the marketing dashboard
 */
export interface HostMarketingPressedInviteFriendsCard {
    /**
     * currency of the credit
     */
    creditCurrency: string;
    /**
     * the displayed referral credit
     */
    displayedCredit: number;
    /**
     * id of the listing
     */
    listingId: string;
    [property: string]: any;
}

/**
 * [HOST PERFORMANCE] Host pressed button message my fans in the fan message screen in
 * marketing dashboard
 */
export interface HostMarketingPressedMessageFans {
    /**
     * id of the listing
     */
    listingId: string;
    [property: string]: any;
}

/**
 * [HOST PERFORMANCE] (placeholder) Host pressed the CTA button in marketing tips card
 */
export interface HostMarketingPressedTips {
    /**
     * id of the listing
     */
    listingId: string;
    /**
     * the name of the marketing tip
     */
    tipName: string;
    [property: string]: any;
}

/**
 * [HOST PERFORMANCE] Host switched to other marketing tips
 */
export interface HostMarketingSwitchTipsCarousel {
    /**
     * id of the listing
     */
    listingId: string;
    [property: string]: any;
}

/**
 * [HOST PERFORMANCE] Host pressed cancel to change time range in performance DB
 */
export interface HostPerfCancelChangeTimeRange {
    /**
     * id of the listing
     */
    listingId: string;
    [property: string]: any;
}

/**
 * [HOST PERFORMANCE] Host pressed the time range in the performance dahboard
 */
export interface HostPerfOverviewSwitchTimeRange {
    /**
     * id of the listing
     */
    listingId: string;
    /**
     * the selected new time range
     */
    newTimeRange: TimeRange;
    /**
     * the original time range (last 7 days/ last 14 days etc.)
     */
    originalTimeRange: TimeRange;
    [property: string]: any;
}

/**
 * the selected new time range
 *
 * the original time range (last 7 days/ last 14 days etc.)
 */
export enum TimeRange {
    AllTime = "all time",
    Last30Days = "last 30 days",
    Last365Days = "last 365 days",
    Last7Days = "last 7 days",
    YearToDate = "year to date",
}

/**
 * [HOST PERFORMANCE] Host pressed cross to close the performance tips screen
 */
export interface HostPerfPressedClosePerfTips {
    /**
     * id of the listing
     */
    listingId: string;
    [property: string]: any;
}

/**
 * [HOST PERFORMANCE] Host pressed the earning card in the performance DB
 */
export interface HostPerfPressedEarnings {
    /**
     * id of the listing
     */
    listingId: string;
    [property: string]: any;
}

/**
 * [HOST PERFORMANCE] Host pressed on the Fan Favorite FAQ in the bookings section of
 * Performance Overview
 */
export interface HostPerfPressedFanFavoriteFAQ {
    /**
     * DO NOT SEND: This is added as a workaround for this issue:
     * https://github.com/segmentio/typewriter/issues/284
     */
    fakeProperty?: string;
    [property: string]: any;
}

/**
 * [HOST PERFORMANCE] Host pressed to view the performance scores info (question mark)
 */
export interface HostPerfPressedInfoIconScores {
    /**
     * id of the listing
     */
    listingId: string;
    [property: string]: any;
}

/**
 * [HOST PERFORMANCE] Host pressed to view the performance tips info (question mark)
 */
export interface HostPerfPressedInfoIconTips {
    /**
     * id of the listing
     */
    listingId: string;
    [property: string]: any;
}

/**
 * [HOST PERFORMANCE] Host pressed to leave a reply to a guest's review
 */
export interface HostPerfPressedLeaveReply {
    bookingId: number;
    /**
     * message sent by the guest when booking
     */
    bookingMessage?: null | string;
    /**
     * if the guest left a rating between 1-5, what was it
     */
    bookingRating?: number | null;
    /**
     * guest selection (listing type specific) for why they're booking
     */
    bookingReason?: BookingReason | null;
    /**
     * if the guest left a review, what was it
     */
    bookingReview?:         null | string;
    bookingSpecialOfferId?: number | null;
    /**
     * Did the host click on the reply from the performance screen or after pressing show all
     */
    enteredFrom:       HostPerfPressedLeaveReplyEnteredFrom | null;
    guestId:           number;
    hostId:            number;
    id?:               string;
    isInstantBooking?: boolean;
    listingId:         number;
    listingTitle:      string;
    totalGuests?:      number;
    totalPrice?:       number;
    [property: string]: any;
}

export enum HostPerfPressedLeaveReplyEnteredFrom {
    Performance = "performance",
    ViewAll = "view_all",
}

/**
 * [HOST PERFORMANCE] Host pressed manage my listing button in the performance dashboard
 */
export interface HostPerfPressedManageListings {
    /**
     * id of the listing
     */
    listingId: string;
    [property: string]: any;
}

/**
 * [HOST PERFORMANCE] (placeholder) Host pressed the CTA button in performance tips
 */
export interface HostPerfPressedPerfTips {
    /**
     * id of the listing
     */
    listingId: string;
    /**
     * the name of the performance tip
     */
    tipName: string;
    [property: string]: any;
}

/**
 * [HOST PERFORMANCE] Host pressed to see all reviews in the performance dashboard
 */
export interface HostPerfPressedSeeAllReviews {
    /**
     * id of the listing
     */
    listingId: string;
    [property: string]: any;
}

/**
 * [HOST PERFORMANCE] Host switched to marketing or performance dashboard
 */
export interface HostPerfSwitchDashboard {
    /**
     * id of the listing
     */
    listingId: string;
    /**
     * the tab that pressed by the host (performance or marketing)
     */
    switchTo: HostPerfSwitchDashboardSwitchTo;
    [property: string]: any;
}

/**
 * the tab that pressed by the host (performance or marketing)
 */
export enum HostPerfSwitchDashboardSwitchTo {
    Marketing = "marketing",
    Performance = "performance",
}

/**
 * [HOST PERFORMANCE] Host switched to other performance tips
 */
export interface HostPerfSwitchPerfTipsCarousel {
    /**
     * id of the listing
     */
    listingId: string;
    [property: string]: any;
}

/**
 * [HOST PERFORMANCE] Host switched the review card in the performance DB
 */
export interface HostPerfSwitchReviewCarousel {
    /**
     * id of the listing
     */
    listingId: string;
    [property: string]: any;
}

/**
 * [HOST ONBOARDING] host set availability blocks for pool
 */
export interface HostPoolAvailability {
    /**
     * if there is a buffer time - what is it in minutes
     */
    bufferTime?: number;
    /**
     * daily end time for pool availability (military time)
     */
    dailyEndTime: number;
    /**
     * daily start time for pool availability (military time)
     */
    dailyStartTime: number;
    /**
     * All possible values for enteredFrom in host onboarding
     */
    enteredFrom: HostAdditionalPoolDetailsEnteredEnteredFrom;
    /**
     * the first day the listing will be live (will be the current day if the user selects go
     * live immediately)
     */
    firstDayLive?: string;
    /**
     * [LISTING TYPE] The type of the listing associated with this event
     */
    globalListingType: GlobalListingType;
    /**
     * id for the related listing
     */
    listingId: string;
    /**
     * legacy name for listing id
     */
    poolId?: string;
    /**
     * pressed "save and exit" to remove from flow
     */
    pressedSaveExit: boolean;
    /**
     * month for when pool goes offline
     */
    seasonEndMonth?: string;
    /**
     * month for when pool goes online
     */
    seasonStartMonth?: string;
    [property: string]: any;
}

/**
 * [HOST ONBOARDING] host added advanced availability settings
 */
export interface HostPoolAvailabilityAdvancedSettings {
    /**
     * the advance notice option selected
     */
    advanceNotice?: string;
    /**
     * whether the listing has instant book enabled
     */
    instantBook?:         boolean;
    instantBookGuestMax?: number;
    [property: string]: any;
}

/**
 * [HOST ONBOARDING] host set selected dates unavailable
 */
export interface HostPoolAvailabilityDatesExcluded {
    /**
     * array of every date selected for calendar exclusion
     */
    datesExcludedBooking: any[];
    /**
     * All possible values for enteredFrom in host onboarding
     */
    enteredFrom: HostAdditionalPoolDetailsEnteredEnteredFrom;
    /**
     * id for the related listing
     */
    listingId: string;
    /**
     * legacy name for listing id
     */
    poolId?: string;
    /**
     * pressed "save and exit" to remove from flow
     */
    pressedSaveExit: boolean;
    [property: string]: any;
}

/**
 * [HOST ONBOARDING] host entered pool dimensions
 */
export interface HostPoolDimensions {
    /**
     * deep point in feet entered by host
     */
    deepPointEntered: number;
    /**
     * All possible values for enteredFrom in host onboarding
     */
    enteredFrom: HostAdditionalPoolDetailsEnteredEnteredFrom;
    /**
     * length in feet entered by host
     */
    lengthEntered: number;
    /**
     * id for the related listing
     */
    listingId: string;
    /**
     * legacy name for listing id
     */
    poolId?: string;
    /**
     * pressed "save and exit" to remove from flow
     */
    pressedSaveExit: boolean;
    /**
     * shallow point in feet entered by host
     */
    shallowPointEntered: number;
    /**
     * width in feet entered by host
     */
    widthEntered: number;
    [property: string]: any;
}

/**
 * [HOST ONBOARDING] host requirements for types of guests
 */
export interface HostPoolGuestInformation {
    /**
     * are children allowed in pool
     */
    childrenAllowed: boolean;
    /**
     * All possible values for enteredFrom in host onboarding
     */
    enteredFrom: HostAdditionalPoolDetailsEnteredEnteredFrom;
    /**
     * [LISTING TYPE] The type of the listing associated with this event
     */
    globalListingType: GlobalListingType;
    /**
     * are infants allowed in pool
     */
    infantsAllowed: boolean;
    /**
     * id for the related listing
     */
    listingId: string;
    /**
     * max number of guests allowed
     */
    maxGuestsAmount: number;
    /**
     * are parties allowed
     */
    partiesAllowed: boolean;
    /**
     * rule about pet guests
     */
    petsRuleDetails: PetsRuleDetails;
    /**
     * legacy name for listing id
     */
    poolId?: string;
    /**
     * pressed "save and exit" to remove from flow
     */
    pressedSaveExit: boolean;
    [property: string]: any;
}

/**
 * rule about pet guests
 */
export enum PetsRuleDetails {
    InSpace = "InSpace",
    NotAllowed = "NotAllowed",
    NotInSpace = "NotInSpace",
}

/**
 * [HOST ONBOARDING] host entered pricing information
 */
export interface HostPoolPricingEntered {
    /**
     * currency of daily price
     */
    dailyPriceCurrency?: null | string;
    /**
     * the entered daily price
     */
    dailyPriceEntered?: number | null;
    /**
     * All possible values for enteredFrom in host onboarding
     */
    enteredFrom: HostAdditionalPoolDetailsEnteredEnteredFrom;
    /**
     * [LISTING TYPE] The type of the listing associated with this event
     */
    globalListingType: GlobalListingType;
    /**
     * currency of hourly price
     */
    hourlyPriceCurrency?: null | string;
    /**
     * the entered hourly price
     */
    hourlyPriceEntered?: number | null;
    /**
     * id for the related listing
     */
    listingId: string;
    /**
     * currency of additional guest fee
     */
    perGuestFeeCurrency?: null | string;
    /**
     * entered fee amount per guest
     */
    perGuestFeeEntered?: number | null;
    /**
     * legacy name for listing id
     */
    poolId?: string;
    /**
     * pressed "save and exit" to remove from flow
     */
    pressedSaveExit: boolean;
    /**
     * the price structure of the listing
     */
    pricingStructure: PricingStructure | null;
    /**
     * the listing pricing tiers
     */
    tiers?: Tier[];
    [property: string]: any;
}

/**
 * the pricing type after switching
 *
 * the pricing type before switching
 */
export enum PricingStructure {
    FlatRate = "flat_rate",
    FullDaySingle = "full_day_single",
    FullDayTiered = "full_day_tiered",
    TieredPricing = "tiered_pricing",
}

export interface Tier {
    maxGuests?: string;
    price?:     string;
    [property: string]: any;
}

/**
 * [HOST ONBOARDING] host title and description information
 */
export interface HostPoolProfileAdded {
    /**
     * All possible values for enteredFrom in host onboarding
     */
    enteredFrom: HostAdditionalPoolDetailsEnteredEnteredFrom;
    /**
     * [LISTING TYPE] The type of the listing associated with this event
     */
    globalListingType: GlobalListingType;
    /**
     * id for the related listing
     */
    listingId:       string;
    poolDescription: string;
    /**
     * legacy name for listing id
     */
    poolId?:   string;
    poolTitle: string;
    /**
     * pressed "save and exit" to remove from flow
     */
    pressedSaveExit: boolean;
    [property: string]: any;
}

/**
 * [HOST ONBOARDING] final review screen for host onboarding
 */
export interface HostPoolReview {
    /**
     * was the host blocked from submitting due to needing photos
     */
    blockedByPhotos: boolean;
    /**
     * All possible values for enteredFrom in host onboarding
     */
    enteredFrom: HostAdditionalPoolDetailsEnteredEnteredFrom;
    /**
     * id for the related listing
     */
    listingId: string;
    /**
     * legacy name for listing id
     */
    poolId?: string;
    /**
     * did the host press to add phoots
     */
    pressedAddPhotos: boolean;
    /**
     * pressed "save and exit" to remove from flow
     */
    pressedSaveExit?: boolean;
    [property: string]: any;
}

/**
 * [HOST PROMO CODE] Host Pressed started on after viewing the abandon cart discount context
 * page
 */
export interface HostPressedAbandonCartDiscountGetStarted {
    id?: string;
    [property: string]: any;
}

/**
 * [HOST RESERVATION] host pressed the "view details" option of a given reservation
 * adjustment request
 */
export interface HostPressedAcceptReservationRequest {
    /**
     * id for booking_edit_history entry that the adjustment pertains to
     */
    bookingEditHistoryId?: { [key: string]: any };
    /**
     * id of the booking the reservation pertains to
     */
    bookingId: number;
    /**
     * guest selection (listing type specific) for why they're booking
     */
    bookingReason?: BookingReason | null;
    /**
     * was the booking made using a pass
     */
    bookingWithPass?: BookingWithPass;
    /**
     * if the booking was made or partially made with a pass, the pass id used
     */
    passId?: number | null;
    /**
     * the type of the pass formatted to be LCM friendly
     */
    passName?: null | string;
    /**
     * if the booking was made or partially made with a pass, what type of pass
     */
    passType?: GuestAcceptReviewChangesFromHostPassType | null;
    /**
     * if the booking was made or partially made with a pass, what was the user pass Id used
     */
    userPassId?: number | null;
    [property: string]: any;
}

/**
 * [HOST PROMO CODE] Host Pressed activate abandon cart promo
 */
export interface HostPressedActivateAbandonCartDiscount {
    /**
     * percent amount off of this promo code (1-100)
     */
    amountOff:  number;
    expireDays: string;
    listingId:  string;
    note?:      null | string;
    [property: string]: any;
}

/**
 * [HOST PASS CREATION]
 */
export interface HostPressedActivatePass {
    /**
     * the url for the cover image of the listing the pass is for
     */
    coverImageURL: string;
    /**
     * first name of the host
     */
    hostFirstName: string;
    id?:           string;
    /**
     * id of the listing the pass is for
     */
    listingId: string;
    /**
     * the title of the listing the pass is for
     */
    listingTitle: string;
    /**
     * the url of the listing the pass is for
     */
    listingURL: string;
    /**
     * [{from:”07:00:00”, “11:00:00”}...] Time slots when this pass is eligible
     */
    passAvailableTimes?: any[];
    /**
     * LCM formatted version of available times property
     */
    passAvailableTimesText?: string;
    /**
     * list of blackout dates (e.g. July 4, 2024).
     */
    passBlackoutDays?: any[] | null;
    /**
     * when the pass was created
     */
    passCreatedAt: string;
    /**
     * currency for all monetary fields
     */
    passCurrencyCode: string;
    /**
     * flag indicating that this is the current version for a pass. For a type/name/listing_id,
     * there can only be one record with this attribute true.
     */
    passCurrent: boolean;
    /**
     * free text description set by host
     */
    passDescription?: null | string;
    /**
     * discount amount. Fixed discounts will be in minors units.
     */
    passDiscount: number | null;
    /**
     * type of pass discount num[‘percentage’, ‘fixed’]
     */
    passDiscountType: PassDiscountType | null;
    /**
     * days the pass is eligible
     */
    passEligibleDays?: any[] | null;
    /**
     * id of the pass
     */
    passId: number;
    /**
     * max active passes allowed. This constraint will apply to the (listing_id, type, name)
     * rather than id so that we can be accurate across edits.
     */
    passMaxActivePasses?: number | null;
    /**
     * max bookings allowed under this pass
     */
    passMaxDailyBookings?: number | null;
    /**
     * max duration that may be booked using this pass
     */
    passMaxDuration?: number | null;
    /**
     * max guests that may be booked using this pass
     */
    passMaxGuests?: number | null;
    /**
     * the type of the pass formatted to be LCM friendly
     */
    passName: string;
    /**
     * the ids of all premium amenities included with the pass
     */
    passPremiumAmenities?: any[] | null;
    /**
     * pass price in minor units
     */
    passPrice: string;
    /**
     * ‘draft’ -> pass is being actively edited by the host via the creation flow. The step
     * attribute below tracks the progress of the host through the creation flow.
     * ‘inactive’ -> pass has been created by the host, but not ready for sale yet
     * ‘active’ -> pass has passed the final availability requirements and has been marked by
     * the host as ready for sale.
     */
    passState: PassState;
    /**
     * the pass of the price plus the service fee
     */
    passTotalPrice: string;
    /**
     * the type of pass
     */
    passType: GuestPassPurchaseFailurePassType;
    [property: string]: any;
}

/**
 * [HOST PROMO CODE] Host started the creating abandon cart discount flow
 */
export interface HostPressedAddAbandonCartDiscount {
    /**
     * how they accessed the flow - either via the section in the marketing tab or after
     * clicking the pop up in the fans flow
     */
    enteredFrom?: HostPressedAddAbandonCartDiscountEnteredFrom;
    [property: string]: any;
}

/**
 * how they accessed the flow - either via the section in the marketing tab or after
 * clicking the pop up in the fans flow
 */
export enum HostPressedAddAbandonCartDiscountEnteredFrom {
    Fans = "fans",
    Marketing = "marketing",
}

/**
 * [HOST PROMO CODE] Host pressed the add a promotion to your listing button
 */
export interface HostPressedAddPromotionToListing {
    id?: string;
    [property: string]: any;
}

/**
 * [HOST PROMO CODE] Host pressed the add weekday discounts button in the marketing tab of
 * Host Analytics
 */
export interface HostPressedAddWeekdayDiscount {
    id?: string;
    [property: string]: any;
}

/**
 * [HOST RESERVATION] host chose approve instead from the decline flow
 */
export interface HostPressedApproveFromDeclineFlow {
    /**
     * id of the booking the reservation pertains to
     */
    bookingId: number;
    /**
     * was the booking made using a pass
     */
    bookingWithPass?: BookingWithPass;
    /**
     * if the booking was made or partially made with a pass, the pass id used
     */
    passId?: number | null;
    /**
     * the type of the pass formatted to be LCM friendly
     */
    passName?: null | string;
    /**
     * if the booking was made or partially made with a pass, what type of pass
     */
    passType?: GuestAcceptReviewChangesFromHostPassType | null;
    /**
     * if the booking was made or partially made with a pass, what was the user pass Id used
     */
    userPassId?: number | null;
    [property: string]: any;
}

/**
 * [HOST T&S SWIPE] host pressed the Awesome, Thanks! button to finish the T&S flow
 */
export interface HostPressedAwesomeThanksButton {
    /**
     * the id of the booking
     */
    bookingId: number;
    [property: string]: any;
}

/**
 * [HOST BOOKING INQUIRY POST-SPECIAL OFFER SENT]
 */
export interface HostPressedBackFromWithdrawSpecialOffer {
    bookingId:             number;
    bookingSpecialOfferId: number;
    /**
     * [LISTING TYPE] The type of the listing associated with this event
     */
    globalListingType: GlobalListingType;
    guestId:           number;
    hostId:            number;
    listingId:         number;
    originalPrice:     number;
    roomId?:           string;
    specialOfferPrice: number;
    [property: string]: any;
}

/**
 * [HOST BOOKING INQUIRY SENDING SPECIAL OFFER]
 */
export interface HostPressedBackOnCreatingSendSo {
    bookingId?:        number | null;
    originalPrice:     number;
    specialOfferPrice: number;
    [property: string]: any;
}

/**
 * [HOST BOOKING INQUIRY RESPONSE]
 */
export interface HostPressedBlockFromMessages {
    bookingId?: number | null;
    /**
     * [LISTING TYPE] The type of the listing associated with this event
     */
    globalListingType: GlobalListingType;
    guestId:           number;
    hostId:            number;
    listingId:         number;
    roomId?:           string;
    [property: string]: any;
}

/**
 * [HOST CALENDAR] Host Pressed into their calendar (either via the calendar section on web
 * or via the calendar tab on app)
 */
export interface HostPressedCalendar {
    listingId?: string;
    [property: string]: any;
}

/**
 * [HOST RESERVATION] host pressed to cancel change request
 */
export interface HostPressedCancelChangeRequest {
    /**
     * id of the booking
     */
    bookingId: string;
    /**
     * was the booking made using a pass
     */
    bookingWithPass?: BookingWithPass;
    /**
     * True if the request contains amenitieschange
     */
    isEditAmenities: boolean;
    /**
     * True if the request contains date time change
     */
    isEditDateTime: boolean;
    /**
     * True if the request contains guests change
     */
    isEditGuest: boolean;
    /**
     * if the booking was made or partially made with a pass, the pass id used
     */
    passId?: number | null;
    /**
     * the type of the pass formatted to be LCM friendly
     */
    passName?: null | string;
    /**
     * if the booking was made or partially made with a pass, what type of pass
     */
    passType?: GuestAcceptReviewChangesFromHostPassType | null;
    /**
     * if the booking was made or partially made with a pass, what was the user pass Id used
     */
    userPassId?: number | null;
    [property: string]: any;
}

/**
 * [HOST PERFORMANCE] Host pressed to cancel deleting their reply to a review
 */
export interface HostPressedCancelDeleteReviewReply {
    bookingId: number;
    /**
     * message sent by the guest when booking
     */
    bookingMessage?: null | string;
    /**
     * if the guest left a rating between 1-5, what was it
     */
    bookingRating?: number | null;
    /**
     * guest selection (listing type specific) for why they're booking
     */
    bookingReason?: BookingReason | null;
    /**
     * if the guest left a review, what was it
     */
    bookingReview?:         null | string;
    bookingSpecialOfferId?: number | null;
    guestId:                number;
    hostId:                 number;
    id?:                    string;
    isInstantBooking?:      boolean;
    listingId:              number;
    listingTitle:           string;
    /**
     * the host's reply
     */
    reply:        string;
    totalGuests?: number;
    totalPrice?:  number;
    [property: string]: any;
}

/**
 * [HOST RESERVATION] host pressed to initiate cancel from reservation page
 */
export interface HostPressedCancelFromReservationPage {
    /**
     * id of the booking the reservation pertains to
     */
    bookingId: number;
    /**
     * was the booking made using a pass
     */
    bookingWithPass?: BookingWithPass;
    /**
     * if the booking was made or partially made with a pass, the pass id used
     */
    passId?: number | null;
    /**
     * the type of the pass formatted to be LCM friendly
     */
    passName?: null | string;
    /**
     * if the booking was made or partially made with a pass, what type of pass
     */
    passType?: GuestAcceptReviewChangesFromHostPassType | null;
    /**
     * if the booking was made or partially made with a pass, what was the user pass Id used
     */
    userPassId?: number | null;
    [property: string]: any;
}

/**
 * [HOST RESERVATION] host pressed to "not make changes" on reschedule confirmation screen
 */
export interface HostPressedCancelReschedule {
    /**
     * id of the booking the reservation pertains to
     */
    bookingId: number;
    /**
     * was the booking made using a pass
     */
    bookingWithPass?: BookingWithPass;
    /**
     * if the booking was made or partially made with a pass, the pass id used
     */
    passId?: number | null;
    /**
     * the type of the pass formatted to be LCM friendly
     */
    passName?: null | string;
    /**
     * if the booking was made or partially made with a pass, what type of pass
     */
    passType?: GuestAcceptReviewChangesFromHostPassType | null;
    /**
     * if the booking was made or partially made with a pass, what was the user pass Id used
     */
    userPassId?: number | null;
    [property: string]: any;
}

/**
 * [HOST PERFORMANCE] Host pressed to cancel replying to a guest's review
 */
export interface HostPressedCancelReviewReply {
    bookingId: number;
    /**
     * message sent by the guest when booking
     */
    bookingMessage?: null | string;
    /**
     * if the guest left a rating between 1-5, what was it
     */
    bookingRating?: number | null;
    /**
     * guest selection (listing type specific) for why they're booking
     */
    bookingReason?: BookingReason | null;
    /**
     * if the guest left a review, what was it
     */
    bookingReview?:         null | string;
    bookingSpecialOfferId?: number | null;
    guestId:                number;
    hostId:                 number;
    id?:                    string;
    isInstantBooking?:      boolean;
    listingId:              number;
    listingTitle:           string;
    totalGuests?:           number;
    totalPrice?:            number;
    [property: string]: any;
}

/**
 * [HOST RESERVATION] host pressed to edit booking guest count
 */
export interface HostPressedChatFromReservationDetails {
    /**
     * the id of the booking
     */
    bookingId: number;
    /**
     * the id of the guest
     */
    guestId: number;
    [property: string]: any;
}

/**
 * [HOST T&S SWIPE] Host pressed the close flow button on the top left
 */
export interface HostPressedCloseFlowTrustAndSafety {
    /**
     * the id of the booking
     */
    bookingId: number;
    /**
     * page number of the T&S flow (1, 2, or 3)
     */
    currentPageNumber: number;
    [property: string]: any;
}

/**
 * [HOST T&S SWIPE] host pressed the 'X' button to close the Thanks for Reading card
 */
export interface HostPressedCloseThanksForReading {
    /**
     * id of the booking
     */
    bookingId: number;
    [property: string]: any;
}

/**
 * [HOST BOOKING INQUIRY RESPONSE]
 */
export interface HostPressedConfirmPreApproval {
    bookingChangeRequestId: number;
    bookingId:              number;
    [property: string]: any;
}

/**
 * [HOST SETTINGS - INSTAGRAM] when host presses "Connect Instagram"in the connect Instagram
 * flow
 */
export interface HostPressedConnectToInstagram {
    listingId: number;
    [property: string]: any;
}

/**
 * [HOST RESERVATION] host pressed to contact support from reservation page
 */
export interface HostPressedContactSupportFromReservationPage {
    /**
     * id of the booking the reservation pertains to
     */
    bookingId: number;
    /**
     * was the booking made using a pass
     */
    bookingWithPass?: BookingWithPass;
    /**
     * if the booking was made or partially made with a pass, the pass id used
     */
    passId?: number | null;
    /**
     * the type of the pass formatted to be LCM friendly
     */
    passName?: null | string;
    /**
     * if the booking was made or partially made with a pass, what type of pass
     */
    passType?: GuestAcceptReviewChangesFromHostPassType | null;
    /**
     * if the booking was made or partially made with a pass, what was the user pass Id used
     */
    userPassId?: number | null;
    [property: string]: any;
}

/**
 * [HOST RESERVATION] host pressed to continue to change request
 */
export interface HostPressedContinueChangeRequest {
    /**
     * id of the booking
     */
    bookingId: string;
    /**
     * was the booking made using a pass
     */
    bookingWithPass?: BookingWithPass;
    /**
     * if the booking was made or partially made with a pass, the pass id used
     */
    passId?: number | null;
    /**
     * the type of the pass formatted to be LCM friendly
     */
    passName?: null | string;
    /**
     * if the booking was made or partially made with a pass, what type of pass
     */
    passType?: GuestAcceptReviewChangesFromHostPassType | null;
    /**
     * if the booking was made or partially made with a pass, what was the user pass Id used
     */
    userPassId?: number | null;
    [property: string]: any;
}

/**
 * [HOST BOOKING INQUIRY CREATING SPECIAL OFFER]
 */
export interface HostPressedContinueToCreateSo {
    bookingId?:        number | null;
    originalPrice:     number;
    specialOfferPrice: number;
    [property: string]: any;
}

/**
 * [TIERED PRICING] Host pressed to continue to set up tiered price
 */
export interface HostPressedContinueToSetUpTieredPrice {
    /**
     * id of the listing
     */
    listingId: number;
    [property: string]: any;
}

/**
 * [HOST PROMO CODE] Host pressed the create a promo code button
 */
export interface HostPressedCreatePromoCode {
    /**
     * the page of the button
     */
    enteredFrom: HostPressedCreatePromoCodeEnteredFrom;
    /**
     * id of the listing of that marketing page
     */
    listingId: string;
    [property: string]: any;
}

/**
 * the page of the button
 */
export enum HostPressedCreatePromoCodeEnteredFrom {
    AddToListing = "add_to_listing",
    Fans = "fans",
    Manage = "manage",
    PopUp = "pop_up",
}

/**
 * [HOST PROMO CODE]
 */
export interface HostPressedDeactivateAbandonCartDiscount {
    /**
     * percent amount off of this promo code (1-100)
     */
    amountOff:   number;
    expireDays:  string;
    listingId:   string;
    note?:       null | string;
    promocodeId: number;
    [property: string]: any;
}

/**
 * [HOST PASS MANAGEMENT - DEACTIVATING]
 */
export interface HostPressedDeactivatePass {
    /**
     * the url for the cover image of the listing the pass is for
     */
    coverImageURL: string;
    /**
     * first name of the host
     */
    hostFirstName: string;
    id?:           string;
    /**
     * id of the listing the pass is for
     */
    listingId: string;
    /**
     * the title of the listing the pass is for
     */
    listingTitle: string;
    /**
     * the url of the listing the pass is for
     */
    listingURL: string;
    /**
     * [{from:”07:00:00”, “11:00:00”}...] Time slots when this pass is eligible
     */
    passAvailableTimes?: any[];
    /**
     * LCM formatted version of available times property
     */
    passAvailableTimesText?: string;
    /**
     * list of blackout dates (e.g. July 4, 2024).
     */
    passBlackoutDays?: any[] | null;
    /**
     * when the pass was created
     */
    passCreatedAt: string;
    /**
     * currency for all monetary fields
     */
    passCurrencyCode: string;
    /**
     * flag indicating that this is the current version for a pass. For a type/name/listing_id,
     * there can only be one record with this attribute true.
     */
    passCurrent: boolean;
    /**
     * free text description set by host
     */
    passDescription?: null | string;
    /**
     * discount amount. Fixed discounts will be in minors units.
     */
    passDiscount: number | null;
    /**
     * type of pass discount num[‘percentage’, ‘fixed’]
     */
    passDiscountType: PassDiscountType | null;
    /**
     * days the pass is eligible
     */
    passEligibleDays?: any[] | null;
    /**
     * id of the pass
     */
    passId: number;
    /**
     * max active passes allowed. This constraint will apply to the (listing_id, type, name)
     * rather than id so that we can be accurate across edits.
     */
    passMaxActivePasses?: number | null;
    /**
     * max bookings allowed under this pass
     */
    passMaxDailyBookings?: number | null;
    /**
     * max duration that may be booked using this pass
     */
    passMaxDuration?: number | null;
    /**
     * max guests that may be booked using this pass
     */
    passMaxGuests?: number | null;
    /**
     * the type of the pass formatted to be LCM friendly
     */
    passName: string;
    /**
     * the ids of all premium amenities included with the pass
     */
    passPremiumAmenities?: any[] | null;
    /**
     * pass price in minor units
     */
    passPrice: string;
    /**
     * ‘draft’ -> pass is being actively edited by the host via the creation flow. The step
     * attribute below tracks the progress of the host through the creation flow.
     * ‘inactive’ -> pass has been created by the host, but not ready for sale yet
     * ‘active’ -> pass has passed the final availability requirements and has been marked by
     * the host as ready for sale.
     */
    passState: PassState;
    /**
     * the pass of the price plus the service fee
     */
    passTotalPrice: string;
    /**
     * the type of pass
     */
    passType: GuestPassPurchaseFailurePassType;
    [property: string]: any;
}

/**
 * [HOST RESERVATION] host initiated decline reservation flow
 */
export interface HostPressedDeclineReservationRequest {
    /**
     * id of the booking the reservation pertains to
     */
    bookingId: number;
    /**
     * was the booking made using a pass
     */
    bookingWithPass?: BookingWithPass;
    /**
     * if the booking was made or partially made with a pass, the pass id used
     */
    passId?: number | null;
    /**
     * the type of the pass formatted to be LCM friendly
     */
    passName?: null | string;
    /**
     * if the booking was made or partially made with a pass, what type of pass
     */
    passType?: GuestAcceptReviewChangesFromHostPassType | null;
    /**
     * if the booking was made or partially made with a pass, what was the user pass Id used
     */
    userPassId?: number | null;
    [property: string]: any;
}

/**
 * [HOST CALENDAR SYNCING] Host pressed "Done" after having pressed the trash can next to an
 * external calendar after having pressed "Manage external iCalendars"
 */
export interface HostPressedDeleteImportCalendar {
    calendarName?: string;
    calendarURL?:  string;
    listingId:     number;
    [property: string]: any;
}

/**
 * [HOST PERFORMANCE] Host pressed to delete their reply to a guest's review
 */
export interface HostPressedDeleteReviewReply {
    bookingId: number;
    /**
     * message sent by the guest when booking
     */
    bookingMessage?: null | string;
    /**
     * if the guest left a rating between 1-5, what was it
     */
    bookingRating?: number | null;
    /**
     * guest selection (listing type specific) for why they're booking
     */
    bookingReason?: BookingReason | null;
    /**
     * if the guest left a review, what was it
     */
    bookingReview?:         null | string;
    bookingSpecialOfferId?: number | null;
    guestId:                number;
    hostId:                 number;
    id?:                    string;
    isInstantBooking?:      boolean;
    listingId:              number;
    listingTitle:           string;
    /**
     * the host's reply
     */
    reply:        string;
    totalGuests?: number;
    totalPrice?:  number;
    [property: string]: any;
}

/**
 * [HOST SETTINGS - VIDEO TOUR] when host presses "the trash can" after having uploaded a
 * video tour
 */
export interface HostPressedDeleteVideoTour {
    listingId: number;
    [property: string]: any;
}

/**
 * [HOST CALENDAR SYNCING] Host pressed "Disconnect Cronofy"
 */
export interface HostPressedDisconnectCronofy {
    listingId: string;
    [property: string]: any;
}

/**
 * [HOST SETTINGS - INSTAGRAM] when host presses "Disconnect Instagram" in the connect
 * Instagram flow
 */
export interface HostPressedDisconnectInstagram {
    listingId: number;
    [property: string]: any;
}

/**
 * [HOST RESERVATION] host pressed to edit amenities
 */
export interface HostPressedEditAmenities {
    /**
     * id of the booking the reservation pertains to
     */
    bookingId: string;
    /**
     * was the booking made using a pass
     */
    bookingWithPass?: BookingWithPass;
    /**
     * if the booking was made or partially made with a pass, the pass id used
     */
    passId?: number | null;
    /**
     * the type of the pass formatted to be LCM friendly
     */
    passName?: null | string;
    /**
     * if the booking was made or partially made with a pass, what type of pass
     */
    passType?: GuestAcceptReviewChangesFromHostPassType | null;
    /**
     * if the booking was made or partially made with a pass, what was the user pass Id used
     */
    userPassId?: number | null;
    [property: string]: any;
}

/**
 * [HOST SETTINGS - INSTAGRAM] when host presses "Edit" to enter the connect their Instagram
 * flow
 */
export interface HostPressedEditConnectToInstagram {
    listingId: number;
    [property: string]: any;
}

/**
 * [HOST RESERVATION] host pressed to edit booking date or time
 */
export interface HostPressedEditDateTime {
    /**
     * id of the booking the reservation pertains to
     */
    bookingId: string;
    /**
     * was the booking made using a pass
     */
    bookingWithPass?: BookingWithPass;
    /**
     * if the booking was made or partially made with a pass, the pass id used
     */
    passId?: number | null;
    /**
     * the type of the pass formatted to be LCM friendly
     */
    passName?: null | string;
    /**
     * if the booking was made or partially made with a pass, what type of pass
     */
    passType?: GuestAcceptReviewChangesFromHostPassType | null;
    /**
     * if the booking was made or partially made with a pass, what was the user pass Id used
     */
    userPassId?: number | null;
    [property: string]: any;
}

/**
 * [HOST RESERVATION] host pressed to edit booking guest count
 */
export interface HostPressedEditGuest {
    bookingId: string;
    /**
     * was the booking made using a pass
     */
    bookingWithPass?: BookingWithPass;
    /**
     * if the booking was made or partially made with a pass, the pass id used
     */
    passId?: number | null;
    /**
     * the type of the pass formatted to be LCM friendly
     */
    passName?: null | string;
    /**
     * if the booking was made or partially made with a pass, what type of pass
     */
    passType?: GuestAcceptReviewChangesFromHostPassType | null;
    /**
     * if the booking was made or partially made with a pass, what was the user pass Id used
     */
    userPassId?: number | null;
    [property: string]: any;
}

/**
 * [HOST PASS MANAGEMENT - UPDATING]
 */
export interface HostPressedEditPass {
    /**
     * the url for the cover image of the listing the pass is for
     */
    coverImageURL: string;
    /**
     * first name of the host
     */
    hostFirstName: string;
    id?:           string;
    /**
     * id of the listing the pass is for
     */
    listingId: string;
    /**
     * the title of the listing the pass is for
     */
    listingTitle: string;
    /**
     * the url of the listing the pass is for
     */
    listingURL: string;
    /**
     * [{from:”07:00:00”, “11:00:00”}...] Time slots when this pass is eligible
     */
    passAvailableTimes?: any[];
    /**
     * LCM formatted version of available times property
     */
    passAvailableTimesText?: string;
    /**
     * list of blackout dates (e.g. July 4, 2024).
     */
    passBlackoutDays?: any[] | null;
    /**
     * when the pass was created
     */
    passCreatedAt: string;
    /**
     * currency for all monetary fields
     */
    passCurrencyCode: string;
    /**
     * flag indicating that this is the current version for a pass. For a type/name/listing_id,
     * there can only be one record with this attribute true.
     */
    passCurrent: boolean;
    /**
     * free text description set by host
     */
    passDescription?:   null | string;
    passDetailSelected: PassDetailSelected;
    /**
     * discount amount. Fixed discounts will be in minors units.
     */
    passDiscount: number | null;
    /**
     * type of pass discount num[‘percentage’, ‘fixed’]
     */
    passDiscountType: PassDiscountType | null;
    /**
     * days the pass is eligible
     */
    passEligibleDays?: any[] | null;
    /**
     * id of the pass
     */
    passId: number;
    /**
     * max active passes allowed. This constraint will apply to the (listing_id, type, name)
     * rather than id so that we can be accurate across edits.
     */
    passMaxActivePasses?: number | null;
    /**
     * max bookings allowed under this pass
     */
    passMaxDailyBookings?: number | null;
    /**
     * max duration that may be booked using this pass
     */
    passMaxDuration?: number | null;
    /**
     * max guests that may be booked using this pass
     */
    passMaxGuests?: number | null;
    /**
     * the type of the pass formatted to be LCM friendly
     */
    passName: string;
    /**
     * the ids of all premium amenities included with the pass
     */
    passPremiumAmenities?: any[] | null;
    /**
     * pass price in minor units
     */
    passPrice: string;
    /**
     * ‘draft’ -> pass is being actively edited by the host via the creation flow. The step
     * attribute below tracks the progress of the host through the creation flow.
     * ‘inactive’ -> pass has been created by the host, but not ready for sale yet
     * ‘active’ -> pass has passed the final availability requirements and has been marked by
     * the host as ready for sale.
     */
    passState: PassState;
    /**
     * the pass of the price plus the service fee
     */
    passTotalPrice: string;
    /**
     * the type of pass
     */
    passType: GuestPassPurchaseFailurePassType;
    [property: string]: any;
}

export enum PassDetailSelected {
    PassAvailableTimes = "passAvailableTimes",
    PassDescription = "passDescription",
    PassEligibleDays = "passEligibleDays",
    PassMaxDuration = "passMaxDuration",
    PassMaxGuests = "passMaxGuests",
    PassPremiumAmenities = "passPremiumAmenities",
    PassPrice = "passPrice",
}

/**
 * [HOST CALENDAR SYNCING] fires when the host pressed "Copy link" on the pop up after
 * pressing "Export Swimply iCalendar"
 */
export interface HostPressedExportCalendarCopyLink {
    calendarURL: string;
    listingId:   number;
    [property: string]: any;
}

/**
 * [HOST SD CLAIM]
 */
export interface HostPressedFileSDClaim {
    bookingId: string;
    listingId: number;
    [property: string]: any;
}

/**
 * [HOST SD CLAIM]
 */
export interface HostPressedFileSDClaimExit {
    bookingId: string;
    listingId: number;
    [property: string]: any;
}

/**
 * [HOST ONBOARDING] first screen a user sees to begin onboarding and they press get started
 */
export interface HostPressedGetStartedOnboardingListing {
    /**
     * All possible values for enteredFrom in host onboarding
     */
    enteredFrom: HostAdditionalPoolDetailsEnteredEnteredFrom;
    id?:         string;
    /**
     * id for the related listing
     */
    listingId: string;
    /**
     * legacy name for listing id
     */
    poolId?: string;
    [property: string]: any;
}

/**
 * [HOST PROMO CODE] Host pressed get started after seeing the promocodes on PDP Educational
 * card
 */
export interface HostPressedGetStartedPromoOnPDPEdu {
    id?: string;
    [property: string]: any;
}

/**
 * [HOST BOOKING INQUIRY RESPONSE]
 */
export interface HostPressedHelpCenterFromMessages {
    bookingId?: number | null;
    /**
     * [LISTING TYPE] The type of the listing associated with this event
     */
    globalListingType: GlobalListingType;
    guestId:           number;
    hostId:            number;
    listingId:         number;
    roomId?:           string;
    [property: string]: any;
}

/**
 * [HOST RESERVATION] host pressed to see help center from reservation page
 */
export interface HostPressedHelpCenterFromReservationPage {
    /**
     * id of the booking the reservation pertains to
     */
    bookingId: number;
    /**
     * was the booking made using a pass
     */
    bookingWithPass?: BookingWithPass;
    /**
     * if the booking was made or partially made with a pass, the pass id used
     */
    passId?: number | null;
    /**
     * the type of the pass formatted to be LCM friendly
     */
    passName?: null | string;
    /**
     * if the booking was made or partially made with a pass, what type of pass
     */
    passType?: GuestAcceptReviewChangesFromHostPassType | null;
    /**
     * if the booking was made or partially made with a pass, what was the user pass Id used
     */
    userPassId?: number | null;
    [property: string]: any;
}

/**
 * [HOST PERFORMANCE] Host clicked on the host wake up banner learn more link
 */
export interface HostPressedHostWakeUpBannerLearnMore {
    id?: string;
    [property: string]: any;
}

/**
 * within refund flow, host entered full refund option
 */
export interface HostPressedInitiateFullRefund {
    /**
     * id of the booking
     */
    bookingId: number;
    /**
     * status of the booking
     */
    bookingStatus: string;
    /**
     * id of the guest
     */
    guestId: number;
    [property: string]: any;
}

/**
 * within refund flow, host entered partial refund option
 */
export interface HostPressedInitiatePartialRefund {
    /**
     * id of the booking
     */
    bookingId: number;
    /**
     * status of the booking
     */
    bookingStatus: string;
    /**
     * id of the guest
     */
    guestId: number;
    [property: string]: any;
}

/**
 * host entered the refund request flow
 */
export interface HostPressedInitiateRefund {
    /**
     * id of the booking
     */
    bookingId: number;
    /**
     * status of the booking
     */
    bookingStatus: string;
    /**
     * which screen/tab the user entered from
     */
    enteredFrom: string;
    /**
     * id of the guest
     */
    guestId: number;
    [property: string]: any;
}

/**
 * [HOST PASS ONBOARDING]
 */
export interface HostPressedLearnMorePassOnboarding {
    /**
     * how the host accessed onboarding
     */
    enteredFrom: HostPressedLearnMorePassOnboardingEnteredFrom;
    id?:         string;
    [property: string]: any;
}

/**
 * how the host accessed onboarding
 */
export enum HostPressedLearnMorePassOnboardingEnteredFrom {
    AutoPopup = "auto_popup",
    HostBanner = "host_banner",
    ListingManagement = "listing_management",
    MarketingTab = "marketing_tab",
}

/**
 * [HOST ONBOARDING] first screen a user sees to begin onboarding and they select to import
 * their listing from another site
 */
export interface HostPressedListFromExternalSite {
    /**
     * All possible values for enteredFrom in host onboarding
     */
    enteredFrom: HostAdditionalPoolDetailsEnteredEnteredFrom;
    id?:         string;
    /**
     * id for the related listing
     */
    listingId: string;
    /**
     * legacy name for listing id
     */
    poolId?: string;
    [property: string]: any;
}

/**
 * [HOST RESERVATION] host pressed to make changes in the booking
 */
export interface HostPressedMakeChanges {
    /**
     * id of the booking
     */
    bookingId: string;
    /**
     * was the booking made using a pass
     */
    bookingWithPass?: BookingWithPass;
    /**
     * if the booking was made or partially made with a pass, the pass id used
     */
    passId?: number | null;
    /**
     * the type of the pass formatted to be LCM friendly
     */
    passName?: null | string;
    /**
     * if the booking was made or partially made with a pass, what type of pass
     */
    passType?: GuestAcceptReviewChangesFromHostPassType | null;
    /**
     * if the booking was made or partially made with a pass, what was the user pass Id used
     */
    userPassId?: number | null;
    [property: string]: any;
}

/**
 * [HOST PASS MANAGEMENT] fires when a user presses manage pass from a SPECIFIC pass' page
 */
export interface HostPressedManagePassFromPassOverview {
    /**
     * the url for the cover image of the listing the pass is for
     */
    coverImageURL: string;
    /**
     * first name of the host
     */
    hostFirstName: string;
    id?:           string;
    /**
     * id of the listing the pass is for
     */
    listingId: string;
    /**
     * the title of the listing the pass is for
     */
    listingTitle: string;
    /**
     * the url of the listing the pass is for
     */
    listingURL: string;
    /**
     * [{from:”07:00:00”, “11:00:00”}...] Time slots when this pass is eligible
     */
    passAvailableTimes?: any[];
    /**
     * LCM formatted version of available times property
     */
    passAvailableTimesText?: string;
    /**
     * list of blackout dates (e.g. July 4, 2024).
     */
    passBlackoutDays?: any[] | null;
    /**
     * when the pass was created
     */
    passCreatedAt: string;
    /**
     * currency for all monetary fields
     */
    passCurrencyCode: string;
    /**
     * flag indicating that this is the current version for a pass. For a type/name/listing_id,
     * there can only be one record with this attribute true.
     */
    passCurrent: boolean;
    /**
     * free text description set by host
     */
    passDescription?: null | string;
    /**
     * discount amount. Fixed discounts will be in minors units.
     */
    passDiscount: number | null;
    /**
     * type of pass discount num[‘percentage’, ‘fixed’]
     */
    passDiscountType: PassDiscountType | null;
    /**
     * days the pass is eligible
     */
    passEligibleDays?: any[] | null;
    /**
     * id of the pass
     */
    passId: number;
    /**
     * max active passes allowed. This constraint will apply to the (listing_id, type, name)
     * rather than id so that we can be accurate across edits.
     */
    passMaxActivePasses?: number | null;
    /**
     * max bookings allowed under this pass
     */
    passMaxDailyBookings?: number | null;
    /**
     * max duration that may be booked using this pass
     */
    passMaxDuration?: number | null;
    /**
     * max guests that may be booked using this pass
     */
    passMaxGuests?: number | null;
    /**
     * the type of the pass formatted to be LCM friendly
     */
    passName: string;
    /**
     * the ids of all premium amenities included with the pass
     */
    passPremiumAmenities?: any[] | null;
    /**
     * pass price in minor units
     */
    passPrice: string;
    /**
     * ‘draft’ -> pass is being actively edited by the host via the creation flow. The step
     * attribute below tracks the progress of the host through the creation flow.
     * ‘inactive’ -> pass has been created by the host, but not ready for sale yet
     * ‘active’ -> pass has passed the final availability requirements and has been marked by
     * the host as ready for sale.
     */
    passState: PassState;
    /**
     * the pass of the price plus the service fee
     */
    passTotalPrice: string;
    /**
     * the type of pass
     */
    passType: GuestPassPurchaseFailurePassType;
    [property: string]: any;
}

/**
 * [HOST PASS MANAGEMENT] fires when a user is on the generic passes page with the 3
 * different pass types shown
 */
export interface HostPressedManagePassFromPasses {
    /**
     * the url for the cover image of the listing the pass is for
     */
    coverImageURL: string;
    /**
     * first name of the host
     */
    hostFirstName: string;
    id?:           string;
    /**
     * id of the listing the pass is for
     */
    listingId: string;
    /**
     * the title of the listing the pass is for
     */
    listingTitle: string;
    /**
     * the url of the listing the pass is for
     */
    listingURL: string;
    pageName:   PageName;
    /**
     * [{from:”07:00:00”, “11:00:00”}...] Time slots when this pass is eligible
     */
    passAvailableTimes?: any[];
    /**
     * LCM formatted version of available times property
     */
    passAvailableTimesText?: string;
    /**
     * list of blackout dates (e.g. July 4, 2024).
     */
    passBlackoutDays?: any[] | null;
    /**
     * when the pass was created
     */
    passCreatedAt: string;
    /**
     * currency for all monetary fields
     */
    passCurrencyCode: string;
    /**
     * flag indicating that this is the current version for a pass. For a type/name/listing_id,
     * there can only be one record with this attribute true.
     */
    passCurrent: boolean;
    /**
     * free text description set by host
     */
    passDescription?: null | string;
    /**
     * discount amount. Fixed discounts will be in minors units.
     */
    passDiscount: number | null;
    /**
     * type of pass discount num[‘percentage’, ‘fixed’]
     */
    passDiscountType: PassDiscountType | null;
    /**
     * days the pass is eligible
     */
    passEligibleDays?: any[] | null;
    /**
     * id of the pass
     */
    passId:  number;
    passIds: any[];
    /**
     * max active passes allowed. This constraint will apply to the (listing_id, type, name)
     * rather than id so that we can be accurate across edits.
     */
    passMaxActivePasses?: number | null;
    /**
     * max bookings allowed under this pass
     */
    passMaxDailyBookings?: number | null;
    /**
     * max duration that may be booked using this pass
     */
    passMaxDuration?: number | null;
    /**
     * max guests that may be booked using this pass
     */
    passMaxGuests?: number | null;
    /**
     * the type of the pass formatted to be LCM friendly
     */
    passName: string;
    /**
     * the ids of all premium amenities included with the pass
     */
    passPremiumAmenities?: any[] | null;
    /**
     * pass price in minor units
     */
    passPrice: string;
    /**
     * ‘draft’ -> pass is being actively edited by the host via the creation flow. The step
     * attribute below tracks the progress of the host through the creation flow.
     * ‘inactive’ -> pass has been created by the host, but not ready for sale yet
     * ‘active’ -> pass has passed the final availability requirements and has been marked by
     * the host as ready for sale.
     */
    passState: PassState;
    /**
     * the pass of the price plus the service fee
     */
    passTotalPrice: string;
    /**
     * the type of pass
     */
    passType: GuestPassPurchaseFailurePassType;
    [property: string]: any;
}

export enum PageName {
    Creation = "creation",
    Management = "management",
}

/**
 * [HOST PROMO CODE] Host pressed to manage promo code in the host setting tabe
 */
export interface HostPressedManagePromoCode {
    /**
     * Where was the user before opening host promo codes?
     */
    enteredFrom: HostPressedManagePromoCodeEnteredFrom;
    /**
     * id of the listing for this promocode
     */
    listingId: number;
    [property: string]: any;
}

/**
 * Where was the user before opening host promo codes?
 */
export enum HostPressedManagePromoCodeEnteredFrom {
    HostSettings = "host_settings",
    Marketing = "marketing",
}

/**
 * [HOST BOOKING INQUIRY POST-SPECIAL OFFER SENT]
 */
export interface HostPressedMangeSpecialOffer {
    bookingId:             number;
    bookingSpecialOfferId: number;
    /**
     * [LISTING TYPE] The type of the listing associated with this event
     */
    globalListingType: GlobalListingType;
    guestId:           number;
    hostId:            number;
    listingId:         number;
    originalPrice:     number;
    roomId?:           string;
    specialOfferPrice: number;
    [property: string]: any;
}

/**
 * [HOST RESERVATION] host pressed to send guest a message from the reservation management
 * page
 */
export interface HostPressedMessageFromReservationPage {
    /**
     * id of the booking the reservation pertains to
     */
    bookingId: number;
    /**
     * was the booking made using a pass
     */
    bookingWithPass?: BookingWithPass;
    /**
     * if the booking was made or partially made with a pass, the pass id used
     */
    passId?: number | null;
    /**
     * the type of the pass formatted to be LCM friendly
     */
    passName?: null | string;
    /**
     * if the booking was made or partially made with a pass, what type of pass
     */
    passType?: GuestAcceptReviewChangesFromHostPassType | null;
    /**
     * if the booking was made or partially made with a pass, what was the user pass Id used
     */
    userPassId?: number | null;
    [property: string]: any;
}

/**
 * [HOST PASS MANAGEMENT - REFUND]
 */
export interface HostPressedMessagePassholder {
    canceled?:       boolean;
    canceledReason?: string;
    /**
     * the url for the cover image of the listing the pass is for
     */
    coverImageURL:  string;
    createdAt?:     string;
    end:            string;
    hasAutorenewOn: boolean;
    /**
     * first name of the host
     */
    hostFirstName: string;
    id?:           string;
    /**
     * true if the pass is a legacy pass
     */
    isLegacy: boolean;
    /**
     * id of the listing the pass is for
     */
    listingId: string;
    /**
     * the title of the listing the pass is for
     */
    listingTitle: string;
    /**
     * the url of the listing the pass is for
     */
    listingURL: string;
    /**
     * [{from:”07:00:00”, “11:00:00”}...] Time slots when this pass is eligible
     */
    passAvailableTimes?: any[];
    /**
     * LCM formatted version of available times property
     */
    passAvailableTimesText?: string;
    /**
     * list of blackout dates (e.g. July 4, 2024).
     */
    passBlackoutDays?: any[] | null;
    /**
     * when the pass was created
     */
    passCreatedAt: string;
    /**
     * currency for all monetary fields
     */
    passCurrencyCode: string;
    /**
     * flag indicating that this is the current version for a pass. For a type/name/listing_id,
     * there can only be one record with this attribute true.
     */
    passCurrent: boolean;
    /**
     * free text description set by host
     */
    passDescription?: null | string;
    /**
     * discount amount. Fixed discounts will be in minors units.
     */
    passDiscount: number | null;
    /**
     * type of pass discount num[‘percentage’, ‘fixed’]
     */
    passDiscountType: PassDiscountType | null;
    /**
     * days the pass is eligible
     */
    passEligibleDays?: any[] | null;
    /**
     * the status of the pass
     */
    passholderStatus: PassholderStatus;
    /**
     * the user id of the pass holder
     */
    passholderUserId: number;
    /**
     * id of the pass
     */
    passId: number;
    /**
     * max active passes allowed. This constraint will apply to the (listing_id, type, name)
     * rather than id so that we can be accurate across edits.
     */
    passMaxActivePasses?: number | null;
    /**
     * max bookings allowed under this pass
     */
    passMaxDailyBookings?: number | null;
    /**
     * max duration that may be booked using this pass
     */
    passMaxDuration?: number | null;
    /**
     * max guests that may be booked using this pass
     */
    passMaxGuests?: number | null;
    /**
     * the type of the pass formatted to be LCM friendly
     */
    passName: string;
    /**
     * the ids of all premium amenities included with the pass
     */
    passPremiumAmenities?: any[] | null;
    /**
     * pass price in minor units
     */
    passPrice: string;
    /**
     * ‘draft’ -> pass is being actively edited by the host via the creation flow. The step
     * attribute below tracks the progress of the host through the creation flow.
     * ‘inactive’ -> pass has been created by the host, but not ready for sale yet
     * ‘active’ -> pass has passed the final availability requirements and has been marked by
     * the host as ready for sale.
     */
    passState: PassState;
    /**
     * the pass of the price plus the service fee
     */
    passTotalPrice: string;
    /**
     * the type of pass
     */
    passType:   GuestPassPurchaseFailurePassType;
    start:      string;
    userPassId: number;
    [property: string]: any;
}

/**
 * [HOST BOOKING INQUIRY SENDING SPECIAL OFFER]
 */
export interface HostPressedNeverMindOnCreatingSendSo {
    bookingId?:        number | null;
    originalPrice:     number;
    specialOfferPrice: number;
    [property: string]: any;
}

/**
 * [HOST BOOKING INQUIRY POST-SPECIAL OFFER SENT]
 */
export interface HostPressedNeverMindOnWithdrawingSo {
    bookingId:             number;
    bookingSpecialOfferId: number;
    originalPrice:         number;
    specialOfferPrice:     number;
    [property: string]: any;
}

/**
 * [HOST RESERVATION] host pressed "nevermind" button to exit cancel
 */
export interface HostPressedNevermindCancel {
    /**
     * id of the booking the reservation pertains to
     */
    bookingId: number;
    /**
     * was the booking made using a pass
     */
    bookingWithPass?: BookingWithPass;
    /**
     * if the booking was made or partially made with a pass, the pass id used
     */
    passId?: number | null;
    /**
     * the type of the pass formatted to be LCM friendly
     */
    passName?: null | string;
    /**
     * if the booking was made or partially made with a pass, what type of pass
     */
    passType?: GuestAcceptReviewChangesFromHostPassType | null;
    /**
     * if the booking was made or partially made with a pass, what was the user pass Id used
     */
    userPassId?: number | null;
    [property: string]: any;
}

/**
 * [HOST PASS MANAGEMENT - DEACTIVATING]
 */
export interface HostPressedNevermindDeactivatePass {
    /**
     * the url for the cover image of the listing the pass is for
     */
    coverImageURL: string;
    /**
     * first name of the host
     */
    hostFirstName: string;
    id?:           string;
    /**
     * id of the listing the pass is for
     */
    listingId: string;
    /**
     * the title of the listing the pass is for
     */
    listingTitle: string;
    /**
     * the url of the listing the pass is for
     */
    listingURL: string;
    /**
     * [{from:”07:00:00”, “11:00:00”}...] Time slots when this pass is eligible
     */
    passAvailableTimes?: any[];
    /**
     * LCM formatted version of available times property
     */
    passAvailableTimesText?: string;
    /**
     * list of blackout dates (e.g. July 4, 2024).
     */
    passBlackoutDays?: any[] | null;
    /**
     * when the pass was created
     */
    passCreatedAt: string;
    /**
     * currency for all monetary fields
     */
    passCurrencyCode: string;
    /**
     * flag indicating that this is the current version for a pass. For a type/name/listing_id,
     * there can only be one record with this attribute true.
     */
    passCurrent: boolean;
    /**
     * free text description set by host
     */
    passDescription?: null | string;
    /**
     * discount amount. Fixed discounts will be in minors units.
     */
    passDiscount: number | null;
    /**
     * type of pass discount num[‘percentage’, ‘fixed’]
     */
    passDiscountType: PassDiscountType | null;
    /**
     * days the pass is eligible
     */
    passEligibleDays?: any[] | null;
    /**
     * id of the pass
     */
    passId: number;
    /**
     * max active passes allowed. This constraint will apply to the (listing_id, type, name)
     * rather than id so that we can be accurate across edits.
     */
    passMaxActivePasses?: number | null;
    /**
     * max bookings allowed under this pass
     */
    passMaxDailyBookings?: number | null;
    /**
     * max duration that may be booked using this pass
     */
    passMaxDuration?: number | null;
    /**
     * max guests that may be booked using this pass
     */
    passMaxGuests?: number | null;
    /**
     * the type of the pass formatted to be LCM friendly
     */
    passName: string;
    /**
     * the ids of all premium amenities included with the pass
     */
    passPremiumAmenities?: any[] | null;
    /**
     * pass price in minor units
     */
    passPrice: string;
    /**
     * ‘draft’ -> pass is being actively edited by the host via the creation flow. The step
     * attribute below tracks the progress of the host through the creation flow.
     * ‘inactive’ -> pass has been created by the host, but not ready for sale yet
     * ‘active’ -> pass has passed the final availability requirements and has been marked by
     * the host as ready for sale.
     */
    passState: PassState;
    /**
     * the pass of the price plus the service fee
     */
    passTotalPrice: string;
    /**
     * the type of pass
     */
    passType: GuestPassPurchaseFailurePassType;
    [property: string]: any;
}

/**
 * [HOST RESERVATION] host pressed "nevermind" button to exit decline
 */
export interface HostPressedNevermindDecline {
    /**
     * id of the booking the reservation pertains to
     */
    bookingId: number;
    /**
     * was the booking made using a pass
     */
    bookingWithPass?: BookingWithPass;
    /**
     * if the booking was made or partially made with a pass, the pass id used
     */
    passId?: number | null;
    /**
     * the type of the pass formatted to be LCM friendly
     */
    passName?: null | string;
    /**
     * if the booking was made or partially made with a pass, what type of pass
     */
    passType?: GuestAcceptReviewChangesFromHostPassType | null;
    /**
     * if the booking was made or partially made with a pass, what was the user pass Id used
     */
    userPassId?: number | null;
    [property: string]: any;
}

/**
 * [HOST PASS MANAGEMENT - REFUND]
 */
export interface HostPressedNevermindPassholderRefund {
    canceled?:       boolean;
    canceledReason?: string;
    /**
     * the url for the cover image of the listing the pass is for
     */
    coverImageURL:  string;
    createdAt?:     string;
    end:            string;
    hasAutorenewOn: boolean;
    /**
     * first name of the host
     */
    hostFirstName: string;
    id?:           string;
    /**
     * true if the pass is a legacy pass
     */
    isLegacy: boolean;
    /**
     * id of the listing the pass is for
     */
    listingId: string;
    /**
     * the title of the listing the pass is for
     */
    listingTitle: string;
    /**
     * the url of the listing the pass is for
     */
    listingURL: string;
    /**
     * [{from:”07:00:00”, “11:00:00”}...] Time slots when this pass is eligible
     */
    passAvailableTimes?: any[];
    /**
     * LCM formatted version of available times property
     */
    passAvailableTimesText?: string;
    /**
     * list of blackout dates (e.g. July 4, 2024).
     */
    passBlackoutDays?: any[] | null;
    /**
     * when the pass was created
     */
    passCreatedAt: string;
    /**
     * currency for all monetary fields
     */
    passCurrencyCode: string;
    /**
     * flag indicating that this is the current version for a pass. For a type/name/listing_id,
     * there can only be one record with this attribute true.
     */
    passCurrent: boolean;
    /**
     * free text description set by host
     */
    passDescription?: null | string;
    /**
     * discount amount. Fixed discounts will be in minors units.
     */
    passDiscount: number | null;
    /**
     * type of pass discount num[‘percentage’, ‘fixed’]
     */
    passDiscountType: PassDiscountType | null;
    /**
     * days the pass is eligible
     */
    passEligibleDays?: any[] | null;
    /**
     * the status of the pass
     */
    passholderStatus: PassholderStatus;
    /**
     * the user id of the pass holder
     */
    passholderUserId: number;
    /**
     * id of the pass
     */
    passId: number;
    /**
     * max active passes allowed. This constraint will apply to the (listing_id, type, name)
     * rather than id so that we can be accurate across edits.
     */
    passMaxActivePasses?: number | null;
    /**
     * max bookings allowed under this pass
     */
    passMaxDailyBookings?: number | null;
    /**
     * max duration that may be booked using this pass
     */
    passMaxDuration?: number | null;
    /**
     * max guests that may be booked using this pass
     */
    passMaxGuests?: number | null;
    /**
     * the type of the pass formatted to be LCM friendly
     */
    passName: string;
    /**
     * the ids of all premium amenities included with the pass
     */
    passPremiumAmenities?: any[] | null;
    /**
     * pass price in minor units
     */
    passPrice: string;
    /**
     * ‘draft’ -> pass is being actively edited by the host via the creation flow. The step
     * attribute below tracks the progress of the host through the creation flow.
     * ‘inactive’ -> pass has been created by the host, but not ready for sale yet
     * ‘active’ -> pass has passed the final availability requirements and has been marked by
     * the host as ready for sale.
     */
    passState: PassState;
    /**
     * the pass of the price plus the service fee
     */
    passTotalPrice: string;
    /**
     * the type of pass
     */
    passType:   GuestPassPurchaseFailurePassType;
    start:      string;
    userPassId: number;
    [property: string]: any;
}

/**
 * [HOST T&S SWIPE] host pressed the next page button
 */
export interface HostPressedNextPageTrustAndSafety {
    /**
     * the id of the booking
     */
    bookingId: number;
    /**
     * page number of the T&S flow (1, 2, or 3)
     */
    currentPageNumber: number;
    [property: string]: any;
}

/**
 * [HOST PASS ONBOARDING]
 */
export interface HostPressedNextPassOnboarding {
    /**
     * the name of the pass onboarding page the host is on
     */
    hostPassOnboardingPageName: HostPressedNextPassOnboardingHostPassOnboardingPageName;
    id?:                        string;
    [property: string]: any;
}

/**
 * the name of the pass onboarding page the host is on
 */
export enum HostPressedNextPassOnboardingHostPassOnboardingPageName {
    Details = "details",
    PassType = "pass_type",
}

/**
 * [HOST PASS ONBOARDING]
 */
export interface HostPressedPassFAQ {
    id?: string;
    /**
     * name of the link clicked on
     */
    linkName: string;
    /**
     * url to the link clicked on
     */
    linkURL?: string;
    [property: string]: any;
}

/**
 * [HOST PASS CREATION]
 */
export interface HostPressedPassFailedManageAvailability {
    /**
     * the url for the cover image of the listing the pass is for
     */
    coverImageURL: string;
    failureReason: any[];
    /**
     * first name of the host
     */
    hostFirstName: string;
    id?:           string;
    /**
     * id of the listing the pass is for
     */
    listingId: string;
    /**
     * the title of the listing the pass is for
     */
    listingTitle: string;
    /**
     * the url of the listing the pass is for
     */
    listingURL: string;
    /**
     * [{from:”07:00:00”, “11:00:00”}...] Time slots when this pass is eligible
     */
    passAvailableTimes?: any[];
    /**
     * LCM formatted version of available times property
     */
    passAvailableTimesText?: string;
    /**
     * list of blackout dates (e.g. July 4, 2024).
     */
    passBlackoutDays?: any[] | null;
    /**
     * when the pass was created
     */
    passCreatedAt: string;
    /**
     * currency for all monetary fields
     */
    passCurrencyCode: string;
    /**
     * flag indicating that this is the current version for a pass. For a type/name/listing_id,
     * there can only be one record with this attribute true.
     */
    passCurrent: boolean;
    /**
     * free text description set by host
     */
    passDescription?: null | string;
    /**
     * discount amount. Fixed discounts will be in minors units.
     */
    passDiscount: number | null;
    /**
     * type of pass discount num[‘percentage’, ‘fixed’]
     */
    passDiscountType: PassDiscountType | null;
    /**
     * days the pass is eligible
     */
    passEligibleDays?: any[] | null;
    /**
     * id of the pass
     */
    passId: number;
    /**
     * max active passes allowed. This constraint will apply to the (listing_id, type, name)
     * rather than id so that we can be accurate across edits.
     */
    passMaxActivePasses?: number | null;
    /**
     * max bookings allowed under this pass
     */
    passMaxDailyBookings?: number | null;
    /**
     * max duration that may be booked using this pass
     */
    passMaxDuration?: number | null;
    /**
     * max guests that may be booked using this pass
     */
    passMaxGuests?: number | null;
    /**
     * the type of the pass formatted to be LCM friendly
     */
    passName: string;
    /**
     * the ids of all premium amenities included with the pass
     */
    passPremiumAmenities?: any[] | null;
    /**
     * pass price in minor units
     */
    passPrice: string;
    /**
     * ‘draft’ -> pass is being actively edited by the host via the creation flow. The step
     * attribute below tracks the progress of the host through the creation flow.
     * ‘inactive’ -> pass has been created by the host, but not ready for sale yet
     * ‘active’ -> pass has passed the final availability requirements and has been marked by
     * the host as ready for sale.
     */
    passState: PassState;
    /**
     * the pass of the price plus the service fee
     */
    passTotalPrice: string;
    /**
     * the type of pass
     */
    passType: GuestPassPurchaseFailurePassType;
    [property: string]: any;
}

/**
 * [HOST PASS ONBOARDING]
 */
export interface HostPressedPassGetHelp {
    id?: string;
    [property: string]: any;
}

/**
 * [HOST PASS MANAGEMENT - REFUND]
 */
export interface HostPressedPassholder {
    canceled?:       boolean;
    canceledReason?: string;
    /**
     * the url for the cover image of the listing the pass is for
     */
    coverImageURL:  string;
    createdAt?:     string;
    end:            string;
    hasAutorenewOn: boolean;
    /**
     * first name of the host
     */
    hostFirstName: string;
    id?:           string;
    /**
     * true if the pass is a legacy pass
     */
    isLegacy: boolean;
    /**
     * id of the listing the pass is for
     */
    listingId: string;
    /**
     * the title of the listing the pass is for
     */
    listingTitle: string;
    /**
     * the url of the listing the pass is for
     */
    listingURL: string;
    /**
     * [{from:”07:00:00”, “11:00:00”}...] Time slots when this pass is eligible
     */
    passAvailableTimes?: any[];
    /**
     * LCM formatted version of available times property
     */
    passAvailableTimesText?: string;
    /**
     * list of blackout dates (e.g. July 4, 2024).
     */
    passBlackoutDays?: any[] | null;
    /**
     * when the pass was created
     */
    passCreatedAt: string;
    /**
     * currency for all monetary fields
     */
    passCurrencyCode: string;
    /**
     * flag indicating that this is the current version for a pass. For a type/name/listing_id,
     * there can only be one record with this attribute true.
     */
    passCurrent: boolean;
    /**
     * free text description set by host
     */
    passDescription?: null | string;
    /**
     * discount amount. Fixed discounts will be in minors units.
     */
    passDiscount: number | null;
    /**
     * type of pass discount num[‘percentage’, ‘fixed’]
     */
    passDiscountType: PassDiscountType | null;
    /**
     * days the pass is eligible
     */
    passEligibleDays?: any[] | null;
    /**
     * the status of the pass
     */
    passholderStatus: PassholderStatus;
    /**
     * the user id of the pass holder
     */
    passholderUserId: number;
    /**
     * id of the pass
     */
    passId: number;
    /**
     * max active passes allowed. This constraint will apply to the (listing_id, type, name)
     * rather than id so that we can be accurate across edits.
     */
    passMaxActivePasses?: number | null;
    /**
     * max bookings allowed under this pass
     */
    passMaxDailyBookings?: number | null;
    /**
     * max duration that may be booked using this pass
     */
    passMaxDuration?: number | null;
    /**
     * max guests that may be booked using this pass
     */
    passMaxGuests?: number | null;
    /**
     * the type of the pass formatted to be LCM friendly
     */
    passName: string;
    /**
     * the ids of all premium amenities included with the pass
     */
    passPremiumAmenities?: any[] | null;
    /**
     * pass price in minor units
     */
    passPrice: string;
    /**
     * ‘draft’ -> pass is being actively edited by the host via the creation flow. The step
     * attribute below tracks the progress of the host through the creation flow.
     * ‘inactive’ -> pass has been created by the host, but not ready for sale yet
     * ‘active’ -> pass has passed the final availability requirements and has been marked by
     * the host as ready for sale.
     */
    passState: PassState;
    /**
     * the pass of the price plus the service fee
     */
    passTotalPrice: string;
    /**
     * the type of pass
     */
    passType:   GuestPassPurchaseFailurePassType;
    start:      string;
    userPassId: number;
    [property: string]: any;
}

/**
 * [HOST T&S SWIPE] host pressed the read guide button on the reservation page
 */
export interface HostPressedReadGuideButton {
    /**
     * the id of the booking
     */
    bookingId: number;
    [property: string]: any;
}

/**
 * [HOST CALENDAR SYNCING] after having imported external iCalendars, fires when the host
 * presses refresh one of them
 */
export interface HostPressedRefreshCalendar {
    calendarName?: string;
    listingId:     number;
    [property: string]: any;
}

/**
 * [HOST PASS MANAGEMENT - REFUND]
 */
export interface HostPressedRefundPassholder {
    canceled?:       boolean;
    canceledReason?: string;
    /**
     * the url for the cover image of the listing the pass is for
     */
    coverImageURL:  string;
    createdAt?:     string;
    end:            string;
    hasAutorenewOn: boolean;
    /**
     * first name of the host
     */
    hostFirstName: string;
    id?:           string;
    /**
     * true if the pass is a legacy pass
     */
    isLegacy: boolean;
    /**
     * id of the listing the pass is for
     */
    listingId: string;
    /**
     * the title of the listing the pass is for
     */
    listingTitle: string;
    /**
     * the url of the listing the pass is for
     */
    listingURL: string;
    /**
     * [{from:”07:00:00”, “11:00:00”}...] Time slots when this pass is eligible
     */
    passAvailableTimes?: any[];
    /**
     * LCM formatted version of available times property
     */
    passAvailableTimesText?: string;
    /**
     * list of blackout dates (e.g. July 4, 2024).
     */
    passBlackoutDays?: any[] | null;
    /**
     * when the pass was created
     */
    passCreatedAt: string;
    /**
     * currency for all monetary fields
     */
    passCurrencyCode: string;
    /**
     * flag indicating that this is the current version for a pass. For a type/name/listing_id,
     * there can only be one record with this attribute true.
     */
    passCurrent: boolean;
    /**
     * free text description set by host
     */
    passDescription?: null | string;
    /**
     * discount amount. Fixed discounts will be in minors units.
     */
    passDiscount: number | null;
    /**
     * type of pass discount num[‘percentage’, ‘fixed’]
     */
    passDiscountType: PassDiscountType | null;
    /**
     * days the pass is eligible
     */
    passEligibleDays?: any[] | null;
    /**
     * the status of the pass
     */
    passholderStatus: PassholderStatus;
    /**
     * the user id of the pass holder
     */
    passholderUserId: number;
    /**
     * id of the pass
     */
    passId: number;
    /**
     * max active passes allowed. This constraint will apply to the (listing_id, type, name)
     * rather than id so that we can be accurate across edits.
     */
    passMaxActivePasses?: number | null;
    /**
     * max bookings allowed under this pass
     */
    passMaxDailyBookings?: number | null;
    /**
     * max duration that may be booked using this pass
     */
    passMaxDuration?: number | null;
    /**
     * max guests that may be booked using this pass
     */
    passMaxGuests?: number | null;
    /**
     * the type of the pass formatted to be LCM friendly
     */
    passName: string;
    /**
     * the ids of all premium amenities included with the pass
     */
    passPremiumAmenities?: any[] | null;
    /**
     * pass price in minor units
     */
    passPrice: string;
    /**
     * ‘draft’ -> pass is being actively edited by the host via the creation flow. The step
     * attribute below tracks the progress of the host through the creation flow.
     * ‘inactive’ -> pass has been created by the host, but not ready for sale yet
     * ‘active’ -> pass has passed the final availability requirements and has been marked by
     * the host as ready for sale.
     */
    passState: PassState;
    /**
     * the pass of the price plus the service fee
     */
    passTotalPrice: string;
    /**
     * the type of pass
     */
    passType:   GuestPassPurchaseFailurePassType;
    start:      string;
    userPassId: number;
    [property: string]: any;
}

/**
 * [HOST SETTINGS - SECURITY DEPOSIT]
 */
export interface HostPressedRemoveSecurityDeposit {
    /**
     * the size of the deposit required
     */
    depositAmount?: DepositAmount | null;
    /**
     * min guest count to charge a security deposit
     */
    guestMin?: number | null;
    listingId: number;
    [property: string]: any;
}

/**
 * the size of the deposit required
 */
export enum DepositAmount {
    The100 = "100",
    The1000 = "1000",
    The250 = "250",
    The500 = "500",
}

/**
 * [HOST RESERVATION] host pressed "reschedule instead" from the cancellation flow
 */
export interface HostPressedRescheduleFromCancelFlow {
    /**
     * id of the booking the reservation pertains to
     */
    bookingId: number;
    /**
     * was the booking made using a pass
     */
    bookingWithPass?: BookingWithPass;
    /**
     * if the booking was made or partially made with a pass, the pass id used
     */
    passId?: number | null;
    /**
     * the type of the pass formatted to be LCM friendly
     */
    passName?: null | string;
    /**
     * if the booking was made or partially made with a pass, what type of pass
     */
    passType?: GuestAcceptReviewChangesFromHostPassType | null;
    /**
     * if the booking was made or partially made with a pass, what was the user pass Id used
     */
    userPassId?: number | null;
    [property: string]: any;
}

/**
 * [HOST RESERVATION] host pressed to initiate reschedule from reservation page
 */
export interface HostPressedRescheduleFromReservationPage {
    /**
     * id of the booking the reservation pertains to
     */
    bookingId: number;
    /**
     * was the booking made using a pass
     */
    bookingWithPass?: BookingWithPass;
    /**
     * if the booking was made or partially made with a pass, the pass id used
     */
    passId?: number | null;
    /**
     * the type of the pass formatted to be LCM friendly
     */
    passName?: null | string;
    /**
     * if the booking was made or partially made with a pass, what type of pass
     */
    passType?: GuestAcceptReviewChangesFromHostPassType | null;
    /**
     * if the booking was made or partially made with a pass, what was the user pass Id used
     */
    userPassId?: number | null;
    [property: string]: any;
}

/**
 * [HOST BOOKING INQUIRY POST-SPECIAL OFFER SENT]
 */
export interface HostPressedReturnToChatFomManageSo {
    bookingId:             number;
    bookingSpecialOfferId: number;
    originalPrice:         number;
    specialOfferPrice:     number;
    [property: string]: any;
}

/**
 * [HOST BOOKING INQUIRY RESPONSE]
 */
export interface HostPressedReviewBookingInquiry {
    bookingId: number;
    /**
     * id of the booking inquiry message sent
     */
    messageSentId: number;
    [property: string]: any;
}

/**
 * [HOST RESERVATION] host pressed to change amenities
 */
export interface HostPressedSaveChangeAmenities {
    /**
     * id of the booking
     */
    bookingId: string;
    /**
     * was the booking made using a pass
     */
    bookingWithPass?: BookingWithPass;
    /**
     * if the booking was made or partially made with a pass, the pass id used
     */
    passId?: number | null;
    /**
     * the type of the pass formatted to be LCM friendly
     */
    passName?: null | string;
    /**
     * if the booking was made or partially made with a pass, what type of pass
     */
    passType?: GuestAcceptReviewChangesFromHostPassType | null;
    /**
     * selected amenities the guest wants to add
     */
    selectedAmenitites: HostPressedSaveChangeAmenitiesSelectedAmenitite[];
    /**
     * if the booking was made or partially made with a pass, what was the user pass Id used
     */
    userPassId?: number | null;
    [property: string]: any;
}

export interface HostPressedSaveChangeAmenitiesSelectedAmenitite {
    /**
     * description of the amenity
     */
    amenityDescription: string;
    amenityFeeDetails:  AmbitiousAmenityFeeDetails;
    /**
     * name of amenity
     */
    amenityName: string;
    /**
     * is this a custom amenity from the host
     */
    isCustomAmenity: boolean;
    /**
     * does this amenity have a fee
     */
    isFee: boolean;
    /**
     * is this amenity pre selected
     */
    isPreSelected: boolean;
    [property: string]: any;
}

export interface AmbitiousAmenityFeeDetails {
    /**
     * fee of amenity
     */
    feeAmount: number;
    /**
     * does this amenity have a flat fee, 1 is flat fee, 0 is hourly fee
     */
    isFlatFee: boolean;
    [property: string]: any;
}

/**
 * [HOST RESERVATION] host pressed save for the changes in booking date time
 */
export interface HostPressedSaveChangeDateTime {
    /**
     * id of the booking
     */
    bookingId: string;
    /**
     * was the booking made using a pass
     */
    bookingWithPass?: BookingWithPass;
    /**
     * the new date of the booking changed by guest
     */
    newDate: string;
    /**
     * the new end time of the booking changed by guest
     */
    newEndTime: number;
    /**
     * the new start time of the booking changed by guest
     */
    newStartTime: number;
    /**
     * the original date of the booking
     */
    orginalDate: string;
    /**
     * the original end time of the booking
     */
    originalEndTime: number;
    /**
     * the original start time of the booking
     */
    originalStartTime: number;
    /**
     * if the booking was made or partially made with a pass, the pass id used
     */
    passId?: number | null;
    /**
     * the type of the pass formatted to be LCM friendly
     */
    passName?: null | string;
    /**
     * if the booking was made or partially made with a pass, what type of pass
     */
    passType?: GuestAcceptReviewChangesFromHostPassType | null;
    /**
     * if the booking was made or partially made with a pass, what was the user pass Id used
     */
    userPassId?: number | null;
    [property: string]: any;
}

/**
 * [HOST RESERVATION] host pressed to save changes of guest in reservation
 */
export interface HostPressedSaveChangeGuest {
    /**
     * id of the booking
     */
    bookingId: string;
    /**
     * was the booking made using a pass
     */
    bookingWithPass?: BookingWithPass;
    /**
     * new number of adult guest
     */
    newAdultGuest: number;
    /**
     * new number of children guest
     */
    newChildrenGuest: number;
    /**
     * new number of infant guest
     */
    newInfantGuest: number;
    /**
     * new number of pet guest
     */
    newPetGuest: number;
    /**
     * original number of adult guest
     */
    originalAdultGuest: number;
    /**
     * original number of children guest
     */
    originalChildrenGuest: number;
    /**
     * original number of infant guest
     */
    originalInfantGuest: number;
    /**
     * original number of pet guest
     */
    originalPetGuest: number;
    /**
     * if the booking was made or partially made with a pass, the pass id used
     */
    passId?: number | null;
    /**
     * the type of the pass formatted to be LCM friendly
     */
    passName?: null | string;
    /**
     * if the booking was made or partially made with a pass, what type of pass
     */
    passType?: GuestAcceptReviewChangesFromHostPassType | null;
    /**
     * if the booking was made or partially made with a pass, what was the user pass Id used
     */
    userPassId?: number | null;
    [property: string]: any;
}

/**
 * [HOST PASS CREATION]
 */
export interface HostPressedSavePassAndActivateLater {
    /**
     * the url for the cover image of the listing the pass is for
     */
    coverImageURL: string;
    /**
     * first name of the host
     */
    hostFirstName: string;
    id?:           string;
    /**
     * id of the listing the pass is for
     */
    listingId: string;
    /**
     * the title of the listing the pass is for
     */
    listingTitle: string;
    /**
     * the url of the listing the pass is for
     */
    listingURL: string;
    /**
     * [{from:”07:00:00”, “11:00:00”}...] Time slots when this pass is eligible
     */
    passAvailableTimes?: any[];
    /**
     * LCM formatted version of available times property
     */
    passAvailableTimesText?: string;
    /**
     * list of blackout dates (e.g. July 4, 2024).
     */
    passBlackoutDays?: any[] | null;
    /**
     * when the pass was created
     */
    passCreatedAt: string;
    /**
     * currency for all monetary fields
     */
    passCurrencyCode: string;
    /**
     * flag indicating that this is the current version for a pass. For a type/name/listing_id,
     * there can only be one record with this attribute true.
     */
    passCurrent: boolean;
    /**
     * free text description set by host
     */
    passDescription?: null | string;
    /**
     * discount amount. Fixed discounts will be in minors units.
     */
    passDiscount: number | null;
    /**
     * type of pass discount num[‘percentage’, ‘fixed’]
     */
    passDiscountType: PassDiscountType | null;
    /**
     * days the pass is eligible
     */
    passEligibleDays?: any[] | null;
    /**
     * id of the pass
     */
    passId: number;
    /**
     * max active passes allowed. This constraint will apply to the (listing_id, type, name)
     * rather than id so that we can be accurate across edits.
     */
    passMaxActivePasses?: number | null;
    /**
     * max bookings allowed under this pass
     */
    passMaxDailyBookings?: number | null;
    /**
     * max duration that may be booked using this pass
     */
    passMaxDuration?: number | null;
    /**
     * max guests that may be booked using this pass
     */
    passMaxGuests?: number | null;
    /**
     * the type of the pass formatted to be LCM friendly
     */
    passName: string;
    /**
     * the ids of all premium amenities included with the pass
     */
    passPremiumAmenities?: any[] | null;
    /**
     * pass price in minor units
     */
    passPrice: string;
    /**
     * ‘draft’ -> pass is being actively edited by the host via the creation flow. The step
     * attribute below tracks the progress of the host through the creation flow.
     * ‘inactive’ -> pass has been created by the host, but not ready for sale yet
     * ‘active’ -> pass has passed the final availability requirements and has been marked by
     * the host as ready for sale.
     */
    passState: PassState;
    /**
     * the pass of the price plus the service fee
     */
    passTotalPrice: string;
    /**
     * the type of pass
     */
    passType: GuestPassPurchaseFailurePassType;
    [property: string]: any;
}

/**
 * [HOST PASS MANAGEMENT - UPDATING]
 */
export interface HostPressedSavePassChanges {
    /**
     * the url for the cover image of the listing the pass is for
     */
    coverImageURL: string;
    /**
     * first name of the host
     */
    hostFirstName: string;
    id?:           string;
    /**
     * id of the listing the pass is for
     */
    listingId: string;
    /**
     * the title of the listing the pass is for
     */
    listingTitle: string;
    /**
     * the url of the listing the pass is for
     */
    listingURL: string;
    /**
     * [{from:”07:00:00”, “11:00:00”}...] Time slots when this pass is eligible
     */
    passAvailableTimes?: any[];
    /**
     * LCM formatted version of available times property
     */
    passAvailableTimesText?: string;
    /**
     * list of blackout dates (e.g. July 4, 2024).
     */
    passBlackoutDays?: any[] | null;
    /**
     * when the pass was created
     */
    passCreatedAt: string;
    /**
     * currency for all monetary fields
     */
    passCurrencyCode: string;
    /**
     * flag indicating that this is the current version for a pass. For a type/name/listing_id,
     * there can only be one record with this attribute true.
     */
    passCurrent: boolean;
    /**
     * free text description set by host
     */
    passDescription?: null | string;
    /**
     * discount amount. Fixed discounts will be in minors units.
     */
    passDiscount: number | null;
    /**
     * type of pass discount num[‘percentage’, ‘fixed’]
     */
    passDiscountType: PassDiscountType | null;
    /**
     * days the pass is eligible
     */
    passEligibleDays?: any[] | null;
    /**
     * id of the pass
     */
    passId: number;
    /**
     * max active passes allowed. This constraint will apply to the (listing_id, type, name)
     * rather than id so that we can be accurate across edits.
     */
    passMaxActivePasses?: number | null;
    /**
     * max bookings allowed under this pass
     */
    passMaxDailyBookings?: number | null;
    /**
     * max duration that may be booked using this pass
     */
    passMaxDuration?: number | null;
    /**
     * max guests that may be booked using this pass
     */
    passMaxGuests?: number | null;
    /**
     * the type of the pass formatted to be LCM friendly
     */
    passName: string;
    /**
     * the ids of all premium amenities included with the pass
     */
    passPremiumAmenities?: any[] | null;
    /**
     * pass price in minor units
     */
    passPrice: string;
    /**
     * ‘draft’ -> pass is being actively edited by the host via the creation flow. The step
     * attribute below tracks the progress of the host through the creation flow.
     * ‘inactive’ -> pass has been created by the host, but not ready for sale yet
     * ‘active’ -> pass has passed the final availability requirements and has been marked by
     * the host as ready for sale.
     */
    passState: PassState;
    /**
     * the pass of the price plus the service fee
     */
    passTotalPrice: string;
    /**
     * the type of pass
     */
    passType: GuestPassPurchaseFailurePassType;
    [property: string]: any;
}

/**
 * [HOST PROMO CODE] When host pressed the save code button to create promo code
 */
export interface HostPressedSavePromoCode {
    /**
     * percent amount off of this promo code (1-100)
     */
    amountOff: number;
    /**
     * expiration date of this promo code
     */
    expireDate: string;
    /**
     * id of the listing for this promocode
     */
    listingId: string;
    /**
     * the maximum time of redemption of this promo code
     */
    maxRedemption: number;
    /**
     * the name of this promo code
     */
    promoCodeName: string;
    [property: string]: any;
}

/**
 * [HOST SETTINGS - SECURITY DEPOSIT]
 */
export interface HostPressedSecurityDepositMoreInformation {
    id?:       string;
    listingId: number;
    [property: string]: any;
}

/**
 * [HOST ONBOARDING] host pressed I got this for self serve sign up
 */
export interface HostPressedSelfServeSignUp {
    id?: string;
    [property: string]: any;
}

/**
 * [HOST RESERVATION] host pressed send change request
 */
export interface HostPressedSendChangeRequest {
    /**
     * id of the bookings
     */
    bookingId: string;
    /**
     * was the booking made using a pass
     */
    bookingWithPass?: BookingWithPass;
    /**
     * true if guests has refund amount (host's update earning is less than original earnings)
     */
    isRefund: boolean;
    /**
     * new number of adult guests
     */
    newAdultGuests: number;
    /**
     * new amenities
     */
    newAmenities: HostPressedSendChangeRequestNewAmenity[];
    /**
     * new charges after edit
     */
    newCharges: number;
    /**
     * new number of children guests
     */
    newChildrenGuests: number;
    /**
     * new date of booking
     */
    newDate: string;
    /**
     * new end time of booking
     */
    newEndTime: string;
    /**
     * new number of infants guests
     */
    newInfantGuests: number;
    /**
     * new number of amenities
     */
    newNumberAmenities: number;
    /**
     * new number of pet guests
     */
    newPetGuests: number;
    /**
     * new start time of booking
     */
    newStartTime: string;
    /**
     * original number of adult guests before changes
     */
    originalAdultGuests: number;
    originalAmenities:   HostPressedSendChangeRequestOriginalAmenity[];
    /**
     * original number of children guests before changes
     */
    originalChildrenGuests: number;
    /**
     * original date of the booking
     */
    originalDate: string;
    /**
     * original end time before changes
     */
    originalEndTime: string;
    /**
     * original number of infants guests before changes
     */
    originalInfantGuests: number;
    /**
     * original number of amenities before changes
     */
    originalNumberAmenities: number;
    /**
     * original number of pet guests before changes
     */
    originalPetGuests: number;
    /**
     * original start time before changes
     */
    originalStartTime: string;
    /**
     * paid price of the booking
     */
    paidPrice: number;
    /**
     * if the booking was made or partially made with a pass, the pass id used
     */
    passId?: number | null;
    /**
     * the type of the pass formatted to be LCM friendly
     */
    passName?: null | string;
    /**
     * if the booking was made or partially made with a pass, what type of pass
     */
    passType?: GuestAcceptReviewChangesFromHostPassType | null;
    /**
     * the additional message entered by host
     */
    requestMessage: string;
    /**
     * if the booking was made or partially made with a pass, what was the user pass Id used
     */
    userPassId?: number | null;
    [property: string]: any;
}

export interface HostPressedSendChangeRequestNewAmenity {
    /**
     * description of the amenity
     */
    amenityDescription?: null | string;
    amenityFeeDetails:   CunningAmenityFeeDetails;
    /**
     * name of amenity
     */
    amenityName: string;
    /**
     * is this a custom amenity from the host
     */
    isCustomAmenity: boolean;
    /**
     * does this amenity have a fee
     */
    isFee: boolean;
    /**
     * is this amenity pre selected
     */
    isPreSelected: boolean;
    [property: string]: any;
}

export interface CunningAmenityFeeDetails {
    /**
     * fee of amenity
     */
    feeAmount: number;
    /**
     * does this amenity have a flat fee, 1 is flat fee, 0 is hourly fee
     */
    isFlatFee: boolean;
    [property: string]: any;
}

export interface HostPressedSendChangeRequestOriginalAmenity {
    /**
     * description of the amenity
     */
    amenityDescription?: null | string;
    amenityFeeDetails:   MagentaAmenityFeeDetails;
    /**
     * name of amenity
     */
    amenityName: string;
    /**
     * is this a custom amenity from the host
     */
    isCustomAmenity: boolean;
    /**
     * does this amenity have a fee
     */
    isFee: boolean;
    /**
     * is this amenity pre selected
     */
    isPreSelected: boolean;
    [property: string]: any;
}

export interface MagentaAmenityFeeDetails {
    /**
     * fee of amenity
     */
    feeAmount: number;
    /**
     * does this amenity have a flat fee, 1 is flat fee, 0 is hourly fee
     */
    isFlatFee: boolean;
    [property: string]: any;
}

/**
 * [HOST BOOKING INQUIRY RESPONSE]
 */
export interface HostPressedSendSpecialOfferFromMessages {
    bookingId?: number | null;
    /**
     * how the host accessed the send special offer option
     */
    enteredFrom: HostPressedSendSpecialOfferFromMessagesEnteredFrom;
    /**
     * [LISTING TYPE] The type of the listing associated with this event
     */
    globalListingType: GlobalListingType;
    guestId:           number;
    hostId:            number;
    listingId:         number;
    roomId?:           string;
    [property: string]: any;
}

/**
 * how the host accessed the send special offer option
 */
export enum HostPressedSendSpecialOfferFromMessagesEnteredFrom {
    Messages = "messages",
    ViewInquiry = "view-inquiry",
}

/**
 * [HOST BOOKING INQUIRY CREATING SPECIAL OFFER]
 */
export interface HostPressedSetSpecialPrice {
    bookingId?: number | null;
    /**
     * [LISTING TYPE] The type of the listing associated with this event
     */
    globalListingType: GlobalListingType;
    guestId:           number;
    hostId:            number;
    listingId:         number;
    roomId?:           string;
    [property: string]: any;
}

/**
 * [HOST PASS ONBOARDING]
 */
export interface HostPressedSetUpPass {
    id?:       string;
    listingId: number;
    passType:  GuestAcceptReviewChangesFromHostPassType;
    [property: string]: any;
}

/**
 * [HOST SETTINGS - SECURITY DEPOSIT]
 */
export interface HostPressedSetUpSecurityDeposit {
    id?:       string;
    listingId: number;
    [property: string]: any;
}

/**
 * [HOST SETTINGS - SECURITY DEPOSIT]
 */
export interface HostPressedSetUpSecurityDepositExit {
    hasActiveSecurityDesposit: boolean;
    id?:                       string;
    listingId:                 number;
    [property: string]: any;
}

/**
 * [HOST ONBOARDING] host pressed to sign up with concierge onboarding
 */
export interface HostPressedSignUpTogether {
    id?: string;
    [property: string]: any;
}

/**
 * [HOST PASS ONBOARDING]
 */
export interface HostPressedStartSellingPassOnboarding {
    id?: string;
    [property: string]: any;
}

/**
 * [HOST PERFORMANCE] Host pressed to switch listing if they have multiple ones
 */
export interface HostPressedSwitchListing {
    /**
     * ! DO NOT ADD ID (HACK TO MAKE EVENT DISPLAY IN TYPES)
     */
    id?: string;
    [property: string]: any;
}

/**
 * [TIERED PRICING] host pressed to switch to tiered pricing or legacy price
 */
export interface HostPressedSwitchPricingType {
    /**
     * id of the listing
     */
    listingId: number;
    /**
     * the pricing type after switching
     */
    newPricingType: PricingStructure;
    /**
     * the pricing type before switching
     */
    originalPricingType: PricingStructure;
    [property: string]: any;
}

/**
 * [TIERED PRICING] host pressed to confirm to change to flat rate price
 */
export interface HostPressedToConfirmChangeToFlatRatePricing {
    /**
     * id of the listing
     */
    listingId: number;
    [property: string]: any;
}

/**
 * [TIERED PRICING] host pressed to confirm to change to full day pricing
 */
export interface HostPressedToConfirmChangeToFullDayPricing {
    /**
     * id of the listing
     */
    listingId: number;
    [property: string]: any;
}

/**
 * [TIERED PRICING] host pressed to confirm to change to full day pricing
 */
export interface HostPressedToConfirmChangeToTieredDayPricing {
    /**
     * id of the listing
     */
    listingId: number;
    [property: string]: any;
}

/**
 * [HOST RESERVATION] on initial cancellation text, host opted to continue with the
 * cancellation
 */
export interface HostPressedToContinueCancellation {
    /**
     * id of the booking the reservation pertains to
     */
    bookingId: number;
    /**
     * was the booking made using a pass
     */
    bookingWithPass?: BookingWithPass;
    /**
     * if the booking was made or partially made with a pass, the pass id used
     */
    passId?: number | null;
    /**
     * the type of the pass formatted to be LCM friendly
     */
    passName?: null | string;
    /**
     * if the booking was made or partially made with a pass, what type of pass
     */
    passType?: GuestAcceptReviewChangesFromHostPassType | null;
    /**
     * if the booking was made or partially made with a pass, what was the user pass Id used
     */
    userPassId?: number | null;
    [property: string]: any;
}

/**
 * [HOST RESERVATION] on approve-instead step, host opted to continue with the decline
 */
export interface HostPressedToContinueDecline {
    /**
     * id of the booking the reservation pertains to
     */
    bookingId: number;
    /**
     * was the booking made using a pass
     */
    bookingWithPass?: BookingWithPass;
    /**
     * if the booking was made or partially made with a pass, the pass id used
     */
    passId?: number | null;
    /**
     * the type of the pass formatted to be LCM friendly
     */
    passName?: null | string;
    /**
     * if the booking was made or partially made with a pass, what type of pass
     */
    passType?: GuestAcceptReviewChangesFromHostPassType | null;
    /**
     * if the booking was made or partially made with a pass, what was the user pass Id used
     */
    userPassId?: number | null;
    [property: string]: any;
}

/**
 * [HOST SETTINGS - SECURITY DEPOSIT]
 */
export interface HostPressedToEditSecurityDeposit {
    /**
     * the size of the deposit required
     */
    depositAmount?: DepositAmount | null;
    /**
     * min guest count to charge a security deposit
     */
    guestMin?: number | null;
    /**
     * true (1) if the listings has an active security deposit, false (0) if not
     */
    hasActiveSecurityDesposit: boolean;
    listingId:                 number;
    [property: string]: any;
}

/**
 * [HOST PROMO CODE] hose pressed copy promo code (on web) or share promo code (on mobile)
 */
export interface HostPressedToSharePromoCode {
    /**
     * the redemption made by guests for this promo code
     */
    currentRedemption: number;
    /**
     * id of the listing for this promocode
     */
    listingId: string;
    /**
     * the name of this promo code
     */
    promoCodeName: string;
    [property: string]: any;
}

/**
 * [HOST PROMO CODE] Host pressed the promo code in the Your promo code card
 */
export interface HostPressedToViewPromoCode {
    /**
     * the redemption made by guests for this promo code
     */
    currentRedemption: number;
    /**
     * True if the promo code is in the active table, false if it is in the expired tab
     */
    isActive: boolean;
    /**
     * id of the listing for this promocode
     */
    listingId: string;
    /**
     * the name of this promo code
     */
    promoCodeName: string;
    [property: string]: any;
}

/**
 * [HOST CALENDAR SYNCING] Host pressed the toggle for a synced Cronofy calendar
 */
export interface HostPressedUnsyncCronofy {
    calendarName: string;
    listingId:    number;
    [property: string]: any;
}

/**
 * [HOST CALENDAR SYNCING] Host pressed the toggle for a synced iCal calendar
 */
export interface HostPressedUnsyncICal {
    calendarName: string;
    listingId:    number;
    [property: string]: any;
}

/**
 * [HOST SETTINGS - VIDEO TOUR] when host presses "Upload a video" after having entered the
 * add video tour
 */
export interface HostPressedUploadVideoTour {
    listingId: number;
    [property: string]: any;
}

/**
 * [HOST RESERVATION] host pressed the "view details" option of a given reservation
 * adjustment request
 */
export interface HostPressedViewDetailsReservationAdjustment {
    /**
     * id for booking_edit_history entry that the adjustment pertains to
     */
    bookingEditHistoryId?: { [key: string]: any };
    /**
     * id of the booking the reservation pertains to
     */
    bookingId: number;
    /**
     * was the booking made using a pass
     */
    bookingWithPass?: BookingWithPass;
    /**
     * if the booking was made or partially made with a pass, the pass id used
     */
    passId?: number | null;
    /**
     * the type of the pass formatted to be LCM friendly
     */
    passName?: null | string;
    /**
     * if the booking was made or partially made with a pass, what type of pass
     */
    passType?: GuestAcceptReviewChangesFromHostPassType | null;
    /**
     * if the booking was made or partially made with a pass, what was the user pass Id used
     */
    userPassId?: number | null;
    [property: string]: any;
}

/**
 * [HOST RESERVATION] host pressed the "see details" option of a the latest booking
 * modification
 */
export interface HostPressedViewLatestBookingAmenityModifications {
    /**
     * id of the booking the reservation pertains to
     */
    bookingId: number;
    [property: string]: any;
}

/**
 * [HOST RESERVATION] host pressed "view" amenity modifications after clicking the "see
 * details" option of a the latest booking modification
 */
export interface HostPressedViewLatestBookingModifications {
    /**
     * id of the booking the reservation pertains to
     */
    bookingId: number;
    [property: string]: any;
}

/**
 * [HOST RESERVATION] host pressed "view reservation" on the reservation list page
 */
export interface HostPressedViewReservation {
    /**
     * id of the associated booking
     */
    bookingId: number;
    /**
     * guest selection (listing type specific) for why they're booking
     */
    bookingReason?: BookingReason | null;
    /**
     * was the booking made using a pass
     */
    bookingWithPass?: BookingWithPass;
    /**
     * if the booking was made or partially made with a pass, the pass id used
     */
    passId?: number | null;
    /**
     * the type of the pass formatted to be LCM friendly
     */
    passName?: null | string;
    /**
     * if the booking was made or partially made with a pass, what type of pass
     */
    passType?: GuestAcceptReviewChangesFromHostPassType | null;
    /**
     * if the booking was made or partially made with a pass, what was the user pass Id used
     */
    userPassId?: number | null;
    [property: string]: any;
}

/**
 * [HOST BOOKING INQUIRY POST-SPECIAL OFFER SENT]
 */
export interface HostPressedWithdrawSpecialOffer {
    bookingId:             number;
    bookingSpecialOfferId: number;
    /**
     * [LISTING TYPE] The type of the listing associated with this event
     */
    globalListingType: GlobalListingType;
    guestId:           number;
    hostId:            number;
    listingId:         number;
    originalPrice:     number;
    roomId?:           string;
    specialOfferPrice: number;
    [property: string]: any;
}

/**
 * [HOST PROFILE EVENTS] host pressed "account" tab on host profile
 */
export interface HostProfileAccount {
    id?: string;
    [property: string]: any;
}

/**
 * [HOST PROFILE EVENTS] host confirmed switching region on host profile
 */
export interface HostProfileConfirmedRegionSwitch {
    /**
     * the region they were in post button press
     */
    newRegion: string;
    /**
     * the region they were in prior to button press
     */
    previousRegion: string;
    [property: string]: any;
}

/**
 * [HOST PROFILE EVENTS] host pressed to enter payment methods
 */
export interface HostProfilePaymentMethods {
    id?: string;
    [property: string]: any;
}

/**
 * [HOST ONBOARDING] host profiles uploaded
 */
export interface HostProfilePhotosAdded {
    /**
     * All possible values for enteredFrom in host onboarding
     */
    enteredFrom: HostAdditionalPoolDetailsEnteredEnteredFrom;
    /**
     * [LISTING TYPE] The type of the listing associated with this event
     */
    globalListingType: GlobalListingType;
    /**
     * id for the related listing
     */
    listingId: string;
    /**
     * legacy name for listing id
     */
    poolId?: string;
    /**
     * pressed "save and exit" to remove from flow
     */
    pressedSaveExit: boolean;
    /**
     * did host select option to add photos
     */
    uploadPhotosPressed: boolean;
    [property: string]: any;
}

/**
 * [HOST PROFILE EVENTS] host pressed the referral banner
 */
export interface HostProfilePressReferralBanner {
    /**
     * text value of the banner
     */
    bannerText: string;
    [property: string]: any;
}

/**
 * [HOST PROFILE EVENTS] host pressed to enter terms of use
 */
export interface HostProfilePressTermsofUse {
    /**
     * destination of the terms of use link
     */
    urlDestination: string;
    [property: string]: any;
}

/**
 * [HOST PROFILE EVENTS] host pressed "contact us" on profile
 */
export interface HostProfilePressedContactUs {
    /**
     * destination of the "contact us" link
     */
    urlDestination: string;
    [property: string]: any;
}

/**
 * [HOST PROFILE EVENTS] host pressed "get verified" on profile
 */
export interface HostProfilePressedGetVerified {
    /**
     * is the host currently address verified
     */
    currentAddressVerified: boolean;
    /**
     * is the host currently bookings verified
     */
    currentIsBookingsVerified: boolean;
    /**
     * is the host currently id verified
     */
    currentIsIdVerified: boolean;
    [property: string]: any;
}

/**
 * [HOST PROFILE EVENTS] host pressed "gift cards" on profile
 */
export interface HostProfilePressedGiftCards {
    /**
     * destination of the "gift cards" link
     */
    urlDestination: string;
    [property: string]: any;
}

/**
 * [HOST PROFILE EVENTS] host pressed "help center" on profile
 */
export interface HostProfilePressedHelpCenter {
    /**
     * destination of the "help center" link
     */
    urlDestination: string;
    [property: string]: any;
}

/**
 * [HOST PROFILE EVENTS] host pressed to logout from profile
 */
export interface HostProfilePressedLogout {
    id?: string;
    [property: string]: any;
}

/**
 * [HOST PROFILE EVENTS] host pressed "privacy policy" on profile
 */
export interface HostProfilePressedPrivacyPolicy {
    /**
     * destination of the privacy policy link
     */
    urlDestination: string;
    [property: string]: any;
}

/**
 * [HOST PROFILE EVENTS] host pressed "rate app" on profile
 */
export interface HostProfilePressedRateApp {
    id?: string;
    [property: string]: any;
}

/**
 * [HOST PROFILE EVENTS] host pressed to switch region on host profile
 */
export interface HostProfilePressedRegionSwitch {
    /**
     * the region they are already in
     */
    existingRegion: string;
    [property: string]: any;
}

/**
 * [HOST PROFILE EVENTS] host pressed to connect stripe
 */
export interface HostProfilePressedStripeConnect {
    id?: string;
    [property: string]: any;
}

/**
 * [HOST PROFILE EVENTS] host pressed "Swimply Stuff" on profile
 */
export interface HostProfilePressedSwimplyStuff {
    id?: string;
    [property: string]: any;
}

/**
 * [HOST PROFILE EVENTS] host pressed "profile" on profile
 */
export interface HostProfileSelectProfile {
    id?: string;
    [property: string]: any;
}

/**
 * [HOST PROFILE EVENTS] host submitted country on stripe connect menu
 */
export interface HostProfileStripeSelectCountry {
    /**
     * country selectec
     */
    countrySelected: string;
    [property: string]: any;
}

/**
 * [HOST PROFILE EVENTS] host pressed "switch to guest view"  or "switch to swimmer view" on
 * profile
 */
export interface HostProfileSwitchGuestView {
    id?: string;
    [property: string]: any;
}

/**
 * [HOST RESERVATION] host received a reservation change request from guest
 */
export interface HostReceivedReservationAdjustmentRequest {
    /**
     * array of amenity ids added in the request, if any
     */
    amenitiesAdded: any[];
    /**
     * a unique ID to identify the booking_edit_history entry
     */
    bookingEditHistoryId: number;
    /**
     * id of the booking the reservation pertains to
     */
    bookingId: number;
    /**
     * was the booking made using a pass
     */
    bookingWithPass?: BookingWithPass;
    /**
     * if the booking was made or partially made with a pass, the pass id used
     */
    passId?: number | null;
    /**
     * the type of the pass formatted to be LCM friendly
     */
    passName?: null | string;
    /**
     * if the booking was made or partially made with a pass, what type of pass
     */
    passType?: GuestAcceptReviewChangesFromHostPassType | null;
    /**
     * if the booking was made or partially made with a pass, what was the user pass Id used
     */
    userPassId?: number | null;
    [property: string]: any;
}

/**
 * [HOST PROMO CODE] host pressed to remove a promotion from their PDP
 */
export interface HostRemovedPromotionFromListing {
    /**
     * [LISTING TYPE] The type of the listing associated with this event
     */
    globalListingType: GlobalListingType;
    listingId:         string;
    promocodeId:       number;
    [property: string]: any;
}

/**
 * [HOST RESERVATION] discount amount host selected, or "none"
 */
export interface HostRescheduleDiscountSelected {
    /**
     * id of the booking the reservation pertains to
     */
    bookingId: number;
    /**
     * was the booking made using a pass
     */
    bookingWithPass?: BookingWithPass;
    /**
     * discount offer in percentage
     */
    discountAmountOffered: number;
    /**
     * if the booking was made or partially made with a pass, the pass id used
     */
    passId?: number | null;
    /**
     * the type of the pass formatted to be LCM friendly
     */
    passName?: null | string;
    /**
     * if the booking was made or partially made with a pass, what type of pass
     */
    passType?: GuestAcceptReviewChangesFromHostPassType | null;
    /**
     * if the booking was made or partially made with a pass, what was the user pass Id used
     */
    userPassId?: number | null;
    [property: string]: any;
}

/**
 * [HOST RESERVATION] host responded to a reservation change request from guest
 */
export interface HostRespondedReservationAdjustmentRequest {
    /**
     * array of amenity ids added in the request, if any
     */
    amenitiesAdded: any[];
    /**
     * a unique ID to identify the booking_edit_history entry
     */
    bookingEditHistoryId: number;
    /**
     * id of the booking the reservation pertains to
     */
    bookingId: number;
    /**
     * was the booking made using a pass
     */
    bookingWithPass?: BookingWithPass;
    /**
     * is this adjustment accepted or declined?
     */
    isAccepted: boolean;
    /**
     * if the booking was made or partially made with a pass, the pass id used
     */
    passId?: number | null;
    /**
     * the type of the pass formatted to be LCM friendly
     */
    passName?: null | string;
    /**
     * if the booking was made or partially made with a pass, what type of pass
     */
    passType?: GuestAcceptReviewChangesFromHostPassType | null;
    /**
     * if the booking was made or partially made with a pass, what was the user pass Id used
     */
    userPassId?: number | null;
    [property: string]: any;
}

/**
 * [HOST BOOKING INQUIRY CREATING SPECIAL OFFER]
 */
export interface HostSavedSpecialPrice {
    bookingId?:        number;
    originalPrice:     number;
    specialOfferPrice: number;
    [property: string]: any;
}

/**
 * [HOST PROMO CODE] host pressed save to select a expiration date for the promo code
 */
export interface HostSelectExpirationDate {
    /**
     * expiration date of this promo code
     */
    expireDate: string;
    /**
     * id of the listing for this promocode
     */
    listingId?: string;
    [property: string]: any;
}

/**
 * [HOST RESERVATION] host chose a cancellation reason
 */
export interface HostSelectedCancellationReason {
    /**
     * id of the booking the reservation pertains to
     */
    bookingId: number;
    /**
     * was the booking made using a pass
     */
    bookingWithPass?: BookingWithPass;
    /**
     * if the booking was made or partially made with a pass, the pass id used
     */
    passId?: number | null;
    /**
     * the type of the pass formatted to be LCM friendly
     */
    passName?: null | string;
    /**
     * if the booking was made or partially made with a pass, what type of pass
     */
    passType?: GuestAcceptReviewChangesFromHostPassType | null;
    /**
     * reason for cancel selected by host
     */
    reasonSelected: string;
    /**
     * if the booking was made or partially made with a pass, what was the user pass Id used
     */
    userPassId?: number | null;
    [property: string]: any;
}

/**
 * [HOST RESERVATION] host chose a decline reason
 */
export interface HostSelectedDeclineReason {
    /**
     * id of the booking the reservation pertains to
     */
    bookingId: number;
    /**
     * was the booking made using a pass
     */
    bookingWithPass?: BookingWithPass;
    /**
     * if the booking was made or partially made with a pass, the pass id used
     */
    passId?: number | null;
    /**
     * the type of the pass formatted to be LCM friendly
     */
    passName?: null | string;
    /**
     * if the booking was made or partially made with a pass, what type of pass
     */
    passType?: GuestAcceptReviewChangesFromHostPassType | null;
    /**
     * reason for cancel selected by host
     */
    reasonSelected: string;
    /**
     * if the booking was made or partially made with a pass, what was the user pass Id used
     */
    userPassId?: number | null;
    [property: string]: any;
}

/**
 * [HOST ONBOARDING] host selected the listing type
 */
export interface HostSelectedListingType {
    /**
     * [LISTING TYPE] The type of the listing associated with this event
     */
    globalListingType: GlobalListingType;
    /**
     * ld of the listing
     */
    listingId: number;
    /**
     * pressed "save and exit" to remove from flow
     */
    pressedSaveExit?: boolean;
    [property: string]: any;
}

/**
 * [HOST ONBOARDING] host selected new pool discount option
 */
export interface HostSelectedNewPoolDiscountOption {
    /**
     * All possible values for enteredFrom in host onboarding
     */
    enteredFrom: HostAdditionalPoolDetailsEnteredEnteredFrom;
    /**
     * true if host added the new pool 20% discount, false if host chose not to add special offer
     */
    isAddedDiscount: boolean;
    /**
     * id for the related listing
     */
    listingId: string;
    /**
     * legacy name for listing id
     */
    poolId?: string;
    [property: string]: any;
}

/**
 * [HOST RESERVATION] host selected the new date and time for the booking, prior to the
 * "send reschedule request"
 */
export interface HostSelectedNewRescheduleTime {
    /**
     * id of the booking the reservation pertains to
     */
    bookingId: number;
    /**
     * was the booking made using a pass
     */
    bookingWithPass?: BookingWithPass;
    /**
     * new start date of booking
     */
    newRescheduleDate: string;
    /**
     * new end time of booking
     */
    newRescheduleEndTime: number;
    /**
     * new start time of booking
     */
    newRescheduleStartTime: number;
    /**
     * original date of booking
     */
    originalDate: string;
    /**
     * original end hour of booking
     */
    originalEndTime: number;
    /**
     * original start time of booking
     */
    originalStartTime: number;
    /**
     * if the booking was made or partially made with a pass, the pass id used
     */
    passId?: number | null;
    /**
     * the type of the pass formatted to be LCM friendly
     */
    passName?: null | string;
    /**
     * if the booking was made or partially made with a pass, what type of pass
     */
    passType?: GuestAcceptReviewChangesFromHostPassType | null;
    /**
     * if the booking was made or partially made with a pass, what was the user pass Id used
     */
    userPassId?: number | null;
    [property: string]: any;
}

/**
 * [HOST PASS CREATION]
 */
export interface HostSelectedPassAmenitiesIncluded {
    /**
     * the url for the cover image of the listing the pass is for
     */
    coverImageURL: string;
    /**
     * first name of the host
     */
    hostFirstName: string;
    id?:           string;
    /**
     * id of the listing the pass is for
     */
    listingId: string;
    /**
     * the title of the listing the pass is for
     */
    listingTitle: string;
    /**
     * the url of the listing the pass is for
     */
    listingURL: string;
    /**
     * [{from:”07:00:00”, “11:00:00”}...] Time slots when this pass is eligible
     */
    passAvailableTimes?: any[];
    /**
     * LCM formatted version of available times property
     */
    passAvailableTimesText?: string;
    /**
     * list of blackout dates (e.g. July 4, 2024).
     */
    passBlackoutDays?: any[] | null;
    /**
     * when the pass was created
     */
    passCreatedAt: string;
    /**
     * currency for all monetary fields
     */
    passCurrencyCode: string;
    /**
     * flag indicating that this is the current version for a pass. For a type/name/listing_id,
     * there can only be one record with this attribute true.
     */
    passCurrent: boolean;
    /**
     * free text description set by host
     */
    passDescription?: null | string;
    /**
     * discount amount. Fixed discounts will be in minors units.
     */
    passDiscount: number | null;
    /**
     * type of pass discount num[‘percentage’, ‘fixed’]
     */
    passDiscountType: PassDiscountType | null;
    /**
     * days the pass is eligible
     */
    passEligibleDays?: any[] | null;
    /**
     * id of the pass
     */
    passId: number;
    /**
     * max active passes allowed. This constraint will apply to the (listing_id, type, name)
     * rather than id so that we can be accurate across edits.
     */
    passMaxActivePasses?: number | null;
    /**
     * max bookings allowed under this pass
     */
    passMaxDailyBookings?: number | null;
    /**
     * max duration that may be booked using this pass
     */
    passMaxDuration?: number | null;
    /**
     * max guests that may be booked using this pass
     */
    passMaxGuests?: number | null;
    /**
     * the type of the pass formatted to be LCM friendly
     */
    passName: string;
    /**
     * the ids of all premium amenities included with the pass
     */
    passPremiumAmenities?: any[] | null;
    /**
     * pass price in minor units
     */
    passPrice: string;
    /**
     * ‘draft’ -> pass is being actively edited by the host via the creation flow. The step
     * attribute below tracks the progress of the host through the creation flow.
     * ‘inactive’ -> pass has been created by the host, but not ready for sale yet
     * ‘active’ -> pass has passed the final availability requirements and has been marked by
     * the host as ready for sale.
     */
    passState: PassState;
    /**
     * the pass of the price plus the service fee
     */
    passTotalPrice: string;
    /**
     * the type of pass
     */
    passType: GuestPassPurchaseFailurePassType;
    [property: string]: any;
}

/**
 * [HOST PASS CREATION]
 */
export interface HostSelectedPassDayAndTimes {
    /**
     * the url for the cover image of the listing the pass is for
     */
    coverImageURL: string;
    /**
     * first name of the host
     */
    hostFirstName: string;
    id?:           string;
    /**
     * id of the listing the pass is for
     */
    listingId: string;
    /**
     * the title of the listing the pass is for
     */
    listingTitle: string;
    /**
     * the url of the listing the pass is for
     */
    listingURL: string;
    /**
     * [{from:”07:00:00”, “11:00:00”}...] Time slots when this pass is eligible
     */
    passAvailableTimes?: any[];
    /**
     * LCM formatted version of available times property
     */
    passAvailableTimesText?: string;
    /**
     * list of blackout dates (e.g. July 4, 2024).
     */
    passBlackoutDays?: any[] | null;
    /**
     * when the pass was created
     */
    passCreatedAt: string;
    /**
     * currency for all monetary fields
     */
    passCurrencyCode: string;
    /**
     * flag indicating that this is the current version for a pass. For a type/name/listing_id,
     * there can only be one record with this attribute true.
     */
    passCurrent: boolean;
    /**
     * free text description set by host
     */
    passDescription?: null | string;
    /**
     * discount amount. Fixed discounts will be in minors units.
     */
    passDiscount: number | null;
    /**
     * type of pass discount num[‘percentage’, ‘fixed’]
     */
    passDiscountType: PassDiscountType | null;
    /**
     * days the pass is eligible
     */
    passEligibleDays?: any[] | null;
    /**
     * id of the pass
     */
    passId: number;
    /**
     * max active passes allowed. This constraint will apply to the (listing_id, type, name)
     * rather than id so that we can be accurate across edits.
     */
    passMaxActivePasses?: number | null;
    /**
     * max bookings allowed under this pass
     */
    passMaxDailyBookings?: number | null;
    /**
     * max duration that may be booked using this pass
     */
    passMaxDuration?: number | null;
    /**
     * max guests that may be booked using this pass
     */
    passMaxGuests?: number | null;
    /**
     * the type of the pass formatted to be LCM friendly
     */
    passName: string;
    /**
     * the ids of all premium amenities included with the pass
     */
    passPremiumAmenities?: any[] | null;
    /**
     * pass price in minor units
     */
    passPrice: string;
    /**
     * ‘draft’ -> pass is being actively edited by the host via the creation flow. The step
     * attribute below tracks the progress of the host through the creation flow.
     * ‘inactive’ -> pass has been created by the host, but not ready for sale yet
     * ‘active’ -> pass has passed the final availability requirements and has been marked by
     * the host as ready for sale.
     */
    passState: PassState;
    /**
     * the pass of the price plus the service fee
     */
    passTotalPrice: string;
    /**
     * the type of pass
     */
    passType: GuestPassPurchaseFailurePassType;
    [property: string]: any;
}

/**
 * [HOST PASS CREATION]
 */
export interface HostSelectedPassDescription {
    /**
     * the url for the cover image of the listing the pass is for
     */
    coverImageURL: string;
    /**
     * first name of the host
     */
    hostFirstName: string;
    id?:           string;
    /**
     * id of the listing the pass is for
     */
    listingId: string;
    /**
     * the title of the listing the pass is for
     */
    listingTitle: string;
    /**
     * the url of the listing the pass is for
     */
    listingURL: string;
    /**
     * [{from:”07:00:00”, “11:00:00”}...] Time slots when this pass is eligible
     */
    passAvailableTimes?: any[];
    /**
     * LCM formatted version of available times property
     */
    passAvailableTimesText?: string;
    /**
     * list of blackout dates (e.g. July 4, 2024).
     */
    passBlackoutDays?: any[] | null;
    /**
     * when the pass was created
     */
    passCreatedAt: string;
    /**
     * currency for all monetary fields
     */
    passCurrencyCode: string;
    /**
     * flag indicating that this is the current version for a pass. For a type/name/listing_id,
     * there can only be one record with this attribute true.
     */
    passCurrent: boolean;
    /**
     * free text description set by host
     */
    passDescription?: null | string;
    /**
     * discount amount. Fixed discounts will be in minors units.
     */
    passDiscount: number | null;
    /**
     * type of pass discount num[‘percentage’, ‘fixed’]
     */
    passDiscountType: PassDiscountType | null;
    /**
     * days the pass is eligible
     */
    passEligibleDays?: any[] | null;
    /**
     * id of the pass
     */
    passId: number;
    /**
     * max active passes allowed. This constraint will apply to the (listing_id, type, name)
     * rather than id so that we can be accurate across edits.
     */
    passMaxActivePasses?: number | null;
    /**
     * max bookings allowed under this pass
     */
    passMaxDailyBookings?: number | null;
    /**
     * max duration that may be booked using this pass
     */
    passMaxDuration?: number | null;
    /**
     * max guests that may be booked using this pass
     */
    passMaxGuests?: number | null;
    /**
     * the type of the pass formatted to be LCM friendly
     */
    passName: string;
    /**
     * the ids of all premium amenities included with the pass
     */
    passPremiumAmenities?: any[] | null;
    /**
     * pass price in minor units
     */
    passPrice: string;
    /**
     * ‘draft’ -> pass is being actively edited by the host via the creation flow. The step
     * attribute below tracks the progress of the host through the creation flow.
     * ‘inactive’ -> pass has been created by the host, but not ready for sale yet
     * ‘active’ -> pass has passed the final availability requirements and has been marked by
     * the host as ready for sale.
     */
    passState: PassState;
    /**
     * the pass of the price plus the service fee
     */
    passTotalPrice: string;
    /**
     * the type of pass
     */
    passType: GuestPassPurchaseFailurePassType;
    [property: string]: any;
}

/**
 * [HOST PASS CREATION]
 */
export interface HostSelectedPassMaxGuests {
    /**
     * the url for the cover image of the listing the pass is for
     */
    coverImageURL: string;
    /**
     * first name of the host
     */
    hostFirstName: string;
    id?:           string;
    /**
     * id of the listing the pass is for
     */
    listingId: string;
    /**
     * the title of the listing the pass is for
     */
    listingTitle: string;
    /**
     * the url of the listing the pass is for
     */
    listingURL: string;
    /**
     * [{from:”07:00:00”, “11:00:00”}...] Time slots when this pass is eligible
     */
    passAvailableTimes?: any[];
    /**
     * LCM formatted version of available times property
     */
    passAvailableTimesText?: string;
    /**
     * list of blackout dates (e.g. July 4, 2024).
     */
    passBlackoutDays?: any[] | null;
    /**
     * when the pass was created
     */
    passCreatedAt: string;
    /**
     * currency for all monetary fields
     */
    passCurrencyCode: string;
    /**
     * flag indicating that this is the current version for a pass. For a type/name/listing_id,
     * there can only be one record with this attribute true.
     */
    passCurrent: boolean;
    /**
     * free text description set by host
     */
    passDescription?: null | string;
    /**
     * discount amount. Fixed discounts will be in minors units.
     */
    passDiscount: number | null;
    /**
     * type of pass discount num[‘percentage’, ‘fixed’]
     */
    passDiscountType: PassDiscountType | null;
    /**
     * days the pass is eligible
     */
    passEligibleDays?: any[] | null;
    /**
     * id of the pass
     */
    passId: number;
    /**
     * max active passes allowed. This constraint will apply to the (listing_id, type, name)
     * rather than id so that we can be accurate across edits.
     */
    passMaxActivePasses?: number | null;
    /**
     * max bookings allowed under this pass
     */
    passMaxDailyBookings?: number | null;
    /**
     * max duration that may be booked using this pass
     */
    passMaxDuration?: number | null;
    /**
     * max guests that may be booked using this pass
     */
    passMaxGuests?: number | null;
    /**
     * the type of the pass formatted to be LCM friendly
     */
    passName: string;
    /**
     * the ids of all premium amenities included with the pass
     */
    passPremiumAmenities?: any[] | null;
    /**
     * pass price in minor units
     */
    passPrice: string;
    /**
     * ‘draft’ -> pass is being actively edited by the host via the creation flow. The step
     * attribute below tracks the progress of the host through the creation flow.
     * ‘inactive’ -> pass has been created by the host, but not ready for sale yet
     * ‘active’ -> pass has passed the final availability requirements and has been marked by
     * the host as ready for sale.
     */
    passState: PassState;
    /**
     * the pass of the price plus the service fee
     */
    passTotalPrice: string;
    /**
     * the type of pass
     */
    passType: GuestPassPurchaseFailurePassType;
    [property: string]: any;
}

/**
 * [HOST PASS CREATION]
 */
export interface HostSelectedPassMaxHours {
    /**
     * the url for the cover image of the listing the pass is for
     */
    coverImageURL: string;
    /**
     * first name of the host
     */
    hostFirstName: string;
    id?:           string;
    /**
     * id of the listing the pass is for
     */
    listingId: string;
    /**
     * the title of the listing the pass is for
     */
    listingTitle: string;
    /**
     * the url of the listing the pass is for
     */
    listingURL: string;
    /**
     * [{from:”07:00:00”, “11:00:00”}...] Time slots when this pass is eligible
     */
    passAvailableTimes?: any[];
    /**
     * LCM formatted version of available times property
     */
    passAvailableTimesText?: string;
    /**
     * list of blackout dates (e.g. July 4, 2024).
     */
    passBlackoutDays?: any[] | null;
    /**
     * when the pass was created
     */
    passCreatedAt: string;
    /**
     * currency for all monetary fields
     */
    passCurrencyCode: string;
    /**
     * flag indicating that this is the current version for a pass. For a type/name/listing_id,
     * there can only be one record with this attribute true.
     */
    passCurrent: boolean;
    /**
     * free text description set by host
     */
    passDescription?: null | string;
    /**
     * discount amount. Fixed discounts will be in minors units.
     */
    passDiscount: number | null;
    /**
     * type of pass discount num[‘percentage’, ‘fixed’]
     */
    passDiscountType: PassDiscountType | null;
    /**
     * days the pass is eligible
     */
    passEligibleDays?: any[] | null;
    /**
     * id of the pass
     */
    passId: number;
    /**
     * max active passes allowed. This constraint will apply to the (listing_id, type, name)
     * rather than id so that we can be accurate across edits.
     */
    passMaxActivePasses?: number | null;
    /**
     * max bookings allowed under this pass
     */
    passMaxDailyBookings?: number | null;
    /**
     * max duration that may be booked using this pass
     */
    passMaxDuration?: number | null;
    /**
     * max guests that may be booked using this pass
     */
    passMaxGuests?: number | null;
    /**
     * the type of the pass formatted to be LCM friendly
     */
    passName: string;
    /**
     * the ids of all premium amenities included with the pass
     */
    passPremiumAmenities?: any[] | null;
    /**
     * pass price in minor units
     */
    passPrice: string;
    /**
     * ‘draft’ -> pass is being actively edited by the host via the creation flow. The step
     * attribute below tracks the progress of the host through the creation flow.
     * ‘inactive’ -> pass has been created by the host, but not ready for sale yet
     * ‘active’ -> pass has passed the final availability requirements and has been marked by
     * the host as ready for sale.
     */
    passState: PassState;
    /**
     * the pass of the price plus the service fee
     */
    passTotalPrice: string;
    /**
     * the type of pass
     */
    passType: GuestPassPurchaseFailurePassType;
    [property: string]: any;
}

/**
 * [HOST PASS CREATION]
 */
export interface HostSelectedPassPrice {
    /**
     * the url for the cover image of the listing the pass is for
     */
    coverImageURL: string;
    /**
     * first name of the host
     */
    hostFirstName: string;
    id?:           string;
    /**
     * id of the listing the pass is for
     */
    listingId: string;
    /**
     * the title of the listing the pass is for
     */
    listingTitle: string;
    /**
     * the url of the listing the pass is for
     */
    listingURL: string;
    /**
     * [{from:”07:00:00”, “11:00:00”}...] Time slots when this pass is eligible
     */
    passAvailableTimes?: any[];
    /**
     * LCM formatted version of available times property
     */
    passAvailableTimesText?: string;
    /**
     * list of blackout dates (e.g. July 4, 2024).
     */
    passBlackoutDays?: any[] | null;
    /**
     * when the pass was created
     */
    passCreatedAt: string;
    /**
     * currency for all monetary fields
     */
    passCurrencyCode: string;
    /**
     * flag indicating that this is the current version for a pass. For a type/name/listing_id,
     * there can only be one record with this attribute true.
     */
    passCurrent: boolean;
    /**
     * free text description set by host
     */
    passDescription?: null | string;
    /**
     * discount amount. Fixed discounts will be in minors units.
     */
    passDiscount: number | null;
    /**
     * type of pass discount num[‘percentage’, ‘fixed’]
     */
    passDiscountType: PassDiscountType | null;
    /**
     * days the pass is eligible
     */
    passEligibleDays?: any[] | null;
    /**
     * id of the pass
     */
    passId: number;
    /**
     * max active passes allowed. This constraint will apply to the (listing_id, type, name)
     * rather than id so that we can be accurate across edits.
     */
    passMaxActivePasses?: number | null;
    /**
     * max bookings allowed under this pass
     */
    passMaxDailyBookings?: number | null;
    /**
     * max duration that may be booked using this pass
     */
    passMaxDuration?: number | null;
    /**
     * max guests that may be booked using this pass
     */
    passMaxGuests?: number | null;
    /**
     * the type of the pass formatted to be LCM friendly
     */
    passName: string;
    /**
     * the ids of all premium amenities included with the pass
     */
    passPremiumAmenities?: any[] | null;
    /**
     * pass price in minor units
     */
    passPrice: string;
    /**
     * ‘draft’ -> pass is being actively edited by the host via the creation flow. The step
     * attribute below tracks the progress of the host through the creation flow.
     * ‘inactive’ -> pass has been created by the host, but not ready for sale yet
     * ‘active’ -> pass has passed the final availability requirements and has been marked by
     * the host as ready for sale.
     */
    passState: PassState;
    /**
     * the pass of the price plus the service fee
     */
    passTotalPrice: string;
    /**
     * the type of pass
     */
    passType: GuestPassPurchaseFailurePassType;
    [property: string]: any;
}

/**
 * [HOST RESERVATION] host selected one of the reasons to reschedule
 */
export interface HostSelectedRescheduleReason {
    /**
     * id of the booking the reservation pertains to
     */
    bookingId: number;
    /**
     * was the booking made using a pass
     */
    bookingWithPass?: BookingWithPass;
    /**
     * if the booking was made or partially made with a pass, the pass id used
     */
    passId?: number | null;
    /**
     * the type of the pass formatted to be LCM friendly
     */
    passName?: null | string;
    /**
     * if the booking was made or partially made with a pass, what type of pass
     */
    passType?: GuestAcceptReviewChangesFromHostPassType | null;
    /**
     * reason selected by host
     */
    reasonSelected: string;
    /**
     * if the booking was made or partially made with a pass, what was the user pass Id used
     */
    userPassId?: number | null;
    [property: string]: any;
}

/**
 * [HOST ONBOARDING] host read all and agree neighbor guidelines
 */
export interface HostSelectedThirdPartyPublicAccess {
    /**
     * True if the host gives Swimply permissions to post/manage public posts of the host's
     * listing on Google, Yelp, etc (and false if not)
     */
    allowsAccess: boolean;
    [property: string]: any;
}

/**
 * [HOST BOOKING INQUIRY SENDING SPECIAL OFFER]
 */
export interface HostSentSpecialOffer {
    bookingId?:            number | null;
    bookingSpecialOfferId: number;
    courtesyNote?:         null | string;
    /**
     * [LISTING TYPE] The type of the listing associated with this event
     */
    globalListingType: GlobalListingType;
    guestId:           number;
    hostId:            number;
    listingId:         number;
    /**
     * new message id for the message with special offer
     */
    messageSentId:     number;
    originalPrice:     number;
    roomId?:           string;
    specialOfferPrice: number;
    [property: string]: any;
}

/**
 * [HOST ONBOARDING] host edited space details for access
 */
export interface HostSpaceDetailsAccess {
    /**
     * All possible values for enteredFrom in host onboarding
     */
    enteredFrom: HostAdditionalPoolDetailsEnteredEnteredFrom;
    /**
     * blurb for entry instructions
     */
    entryInstructionsEntered: string;
    /**
     * id for the related listing
     */
    listingId: string;
    /**
     * details about photos added
     */
    photosAttached?: PhotosAttached;
    /**
     * legacy name for listing id
     */
    poolId?: string;
    /**
     * pressed "save and exit" to remove from flow
     */
    pressedSaveExit: boolean;
    [property: string]: any;
}

/**
 * details about photos added
 */
export interface PhotosAttached {
    /**
     * did host add any photos
     */
    arePhotosAttached: boolean;
    /**
     * number of photos host attached
     */
    numPhotos: number;
    [property: string]: any;
}

/**
 * [HOST ONBOARDING] host bathroom availability details
 */
export interface HostSpaceDetailsBathroom {
    /**
     * number of bathrooms
     */
    bathroomCount: number;
    /**
     * what kind of bathroom did the host add
     */
    bathroomTypeSelected: string;
    /**
     * All possible values for enteredFrom in host onboarding
     */
    enteredFrom: HostAdditionalPoolDetailsEnteredEnteredFrom;
    /**
     * [LISTING TYPE] The type of the listing associated with this event
     */
    globalListingType: GlobalListingType;
    /**
     * id for the related listing
     */
    listingId: string;
    /**
     * legacy name for listing id
     */
    poolId?: string;
    /**
     * pressed "save and exit" to remove from flow
     */
    pressedSaveExit: boolean;
    [property: string]: any;
}

/**
 * [HOST ONBOARDING] host details about the space
 */
export interface HostSpaceDetailsEntered {
    /**
     * All possible values for enteredFrom in host onboarding
     */
    enteredFrom: HostAdditionalPoolDetailsEnteredEnteredFrom;
    /**
     * id for the related listing
     */
    listingId: string;
    /**
     * num of lounge chairs available
     */
    numLoungeChairs: number;
    /**
     * num of lunch tables available
     */
    numLunchTables: number;
    /**
     * num of umbrellas available
     */
    numUmbrellas: number;
    /**
     * blurb for other furniture available
     */
    otherFurniture: string;
    /**
     * legacy name for listing id
     */
    poolId?: string;
    /**
     * pressed "save and exit" to remove from flow
     */
    pressedSaveExit: boolean;
    [property: string]: any;
}

/**
 * [HOST ONBOARDING] host entered details about parking
 */
export interface HostSpaceDetailsParking {
    /**
     * blurb about parking car information
     */
    carParkContext: string;
    /**
     * All possible values for enteredFrom in host onboarding
     */
    enteredFrom: HostAdditionalPoolDetailsEnteredEnteredFrom;
    /**
     * id for the related listing
     */
    listingId: string;
    /**
     * number of cars that can park at house
     */
    numCarsPark: number;
    /**
     * selection for other nearby parking options
     */
    otherParkOptions: any[] | null;
    /**
     * legacy name for listing id
     */
    poolId?: string;
    /**
     * pressed "save and exit" to remove from flow
     */
    pressedSaveExit: boolean;
    [property: string]: any;
}

/**
 * [HOST ONBOARDING] host entered information about privacy of pool
 */
export interface HostSpaceDetailsPrivacy {
    /**
     * All possible values for enteredFrom in host onboarding
     */
    enteredFrom: HostAdditionalPoolDetailsEnteredEnteredFrom;
    /**
     * id for the related listing
     */
    listingId: string;
    /**
     * legacy name for listing id
     */
    poolId?: string;
    /**
     * pressed "save and exit" to remove from flow
     */
    pressedSaveExit: boolean;
    /**
     * how private is the pool area
     */
    privacySelection: string;
    [property: string]: any;
}

/**
 * [HOST ONBOARDING] host entered information about the setting of the listing
 */
export interface HostSpaceDetailsSetting {
    /**
     * All possible values for enteredFrom in host onboarding
     */
    enteredFrom: HostAdditionalPoolDetailsEnteredEnteredFrom;
    /**
     * [LISTING TYPE] The type of the listing associated with this event
     */
    globalListingType: GlobalListingType;
    /**
     * id for the related listing
     */
    listingId: string;
    /**
     * legacy name for listing id
     */
    poolId?: string;
    /**
     * pressed "save and exit" to remove from flow
     */
    pressedSaveExit: boolean;
    /**
     * the setting of the listing
     */
    setting: SettingEnum;
    [property: string]: any;
}

/**
 * the setting of the listing
 */
export enum SettingEnum {
    Indoor = "indoor",
    Mixed = "mixed",
    Outdoor = "outdoor",
}

/**
 * [HOST CALENDAR SYNCING] after pressing the cog wheel and then "sync external calendars"
 * host pressed "Sync with Cronofy" and then pressed “Sync with Cronofy” again on the pop up
 * to start the sync flow
 */
export interface HostStartedSyncWCronofy {
    enteredFrom: HostStartedSyncWCronofyEnteredFrom;
    listingId:   number;
    [property: string]: any;
}

export enum HostStartedSyncWCronofyEnteredFrom {
    ManageExisting = "manage_existing",
    NewSync = "new_sync",
}

/**
 * [HOST RESERVATION] host pressed to send cancel to guest
 */
export interface HostSubmittedCancellation {
    /**
     * id of the booking this pertains to
     */
    bookingId: number;
    /**
     * was the booking made using a pass
     */
    bookingWithPass?: BookingWithPass;
    /**
     * message id of the message sent to guest regarding the cancellation
     */
    messageId: number;
    /**
     * if the booking was made or partially made with a pass, the pass id used
     */
    passId?: number | null;
    /**
     * the type of the pass formatted to be LCM friendly
     */
    passName?: null | string;
    /**
     * if the booking was made or partially made with a pass, what type of pass
     */
    passType?: GuestAcceptReviewChangesFromHostPassType | null;
    /**
     * reason for cancellation selected by the host
     */
    reasonSelected: string;
    /**
     * if the booking was made or partially made with a pass, what was the user pass Id used
     */
    userPassId?: number | null;
    [property: string]: any;
}

/**
 * [HOST RESERVATION] host pressed to send cancel to guest
 */
export interface HostSubmittedDecline {
    /**
     * id of the booking this pertains to
     */
    bookingId: number;
    /**
     * was the booking made using a pass
     */
    bookingWithPass?: BookingWithPass;
    /**
     * message id of the message sent to guest regarding the decline
     */
    messageId: number;
    /**
     * if the booking was made or partially made with a pass, the pass id used
     */
    passId?: number | null;
    /**
     * the type of the pass formatted to be LCM friendly
     */
    passName?: null | string;
    /**
     * if the booking was made or partially made with a pass, what type of pass
     */
    passType?: GuestAcceptReviewChangesFromHostPassType | null;
    /**
     * reason for decline selected by the host
     */
    reasonSelected: string;
    /**
     * if the booking was made or partially made with a pass, what was the user pass Id used
     */
    userPassId?: number | null;
    [property: string]: any;
}

/**
 * [HOST CALENDAR SYNCING] Host confirmed "Delete Calendar" after having pressed "Done"
 */
export interface HostSubmittedDeleteImportCalendar {
    calendarName: string;
    listingId:    number;
    [property: string]: any;
}

/**
 * [HOST CALENDAR SYNCING] fires when the host pressed "Disconnect Cronofy" on the pop up
 * after deleting the calendar and pressing the "Disconnect Cronofy" CTA
 */
export interface HostSubmittedDisconnectCronofy {
    listingId: string;
    [property: string]: any;
}

/**
 * [HOST CALENDAR SYNCING] fires after the host pressed "Import from iCal" on the pop up
 * after pressing the "Import external iCalendar" and the import fails
 */
export interface HostSubmittedImportCalendarFailure {
    calendarName?: string;
    calendarURL?:  string;
    listingId:     number;
    [property: string]: any;
}

/**
 * [HOST CALENDAR SYNCING] fires after the host pressed "Import from iCal" on the pop up
 * after pressing the "Import external iCalendar" and the import is successful
 */
export interface HostSubmittedImportCalendarSuccess {
    calendarName: string;
    calendarURL:  string;
    listingId:    number;
    [property: string]: any;
}

/**
 * [HOST ONBOARDING] host finished setting up the listing
 */
export interface HostSubmittedListingForReview {
    /**
     * All possible values for enteredFrom in host onboarding
     */
    enteredFrom: HostAdditionalPoolDetailsEnteredEnteredFrom;
    /**
     * [LISTING TYPE] The type of the listing associated with this event
     */
    globalListingType: GlobalListingType;
    /**
     * Lowercase only with no punctuation, no special characters, and no spaces. If using
     * special characters, the text must be encoded in UTF-8 format.
     */
    listingCityMetaFormat: string;
    /**
     * Use the lowercase, 2-letter country codes in ISO 3166-1 alpha-2
     */
    listingCountryCode: string;
    /**
     * id for the related listing
     */
    listingId: string;
    /**
     * Use the 2-character ANSI abbreviation code in lowercase. Normalize states outside the
     * U.S. in lowercase with no punctuation, no special characters, and no spaces.
     */
    listingStateMetaFormat: string;
    /**
     * Use lowercase with no spaces and no dash. Use only the first 5 digits for U.S. zip codes.
     * Use the area, district, and sector format for the UK.
     */
    listingZipcodeMetaFormat: string;
    /**
     * legacy name for listing id
     */
    poolId?: string;
    /**
     * pressed "save and exit" to remove from flow
     */
    pressedSaveExit: boolean;
    [property: string]: any;
}

/**
 * [HOST PASS MANAGEMENT - REFUND]
 */
export interface HostSubmittedPassChangeSurvey {
    /**
     * the host's reason for cancelling the pass
     */
    cancellationReason?: CancellationReason | null;
    /**
     * the url for the cover image of the listing the pass is for
     */
    coverImageURL: string;
    /**
     * first name of the host
     */
    hostFirstName: string;
    id?:           string;
    /**
     * id of the listing the pass is for
     */
    listingId: string;
    /**
     * the title of the listing the pass is for
     */
    listingTitle: string;
    /**
     * the url of the listing the pass is for
     */
    listingURL: string;
    /**
     * [{from:”07:00:00”, “11:00:00”}...] Time slots when this pass is eligible
     */
    passAvailableTimes?: any[];
    /**
     * LCM formatted version of available times property
     */
    passAvailableTimesText?: string;
    /**
     * list of blackout dates (e.g. July 4, 2024).
     */
    passBlackoutDays?: any[] | null;
    /**
     * why is the pass being cancelled
     */
    passChange: PassChange | null;
    /**
     * when the pass was created
     */
    passCreatedAt: string;
    /**
     * currency for all monetary fields
     */
    passCurrencyCode: string;
    /**
     * flag indicating that this is the current version for a pass. For a type/name/listing_id,
     * there can only be one record with this attribute true.
     */
    passCurrent: boolean;
    /**
     * free text description set by host
     */
    passDescription?: null | string;
    /**
     * discount amount. Fixed discounts will be in minors units.
     */
    passDiscount: number | null;
    /**
     * type of pass discount num[‘percentage’, ‘fixed’]
     */
    passDiscountType: PassDiscountType | null;
    /**
     * days the pass is eligible
     */
    passEligibleDays?: any[] | null;
    /**
     * id of the pass
     */
    passId: number;
    /**
     * max active passes allowed. This constraint will apply to the (listing_id, type, name)
     * rather than id so that we can be accurate across edits.
     */
    passMaxActivePasses?: number | null;
    /**
     * max bookings allowed under this pass
     */
    passMaxDailyBookings?: number | null;
    /**
     * max duration that may be booked using this pass
     */
    passMaxDuration?: number | null;
    /**
     * max guests that may be booked using this pass
     */
    passMaxGuests?: number | null;
    /**
     * the type of the pass formatted to be LCM friendly
     */
    passName: string;
    /**
     * the ids of all premium amenities included with the pass
     */
    passPremiumAmenities?: any[] | null;
    /**
     * pass price in minor units
     */
    passPrice: string;
    /**
     * ‘draft’ -> pass is being actively edited by the host via the creation flow. The step
     * attribute below tracks the progress of the host through the creation flow.
     * ‘inactive’ -> pass has been created by the host, but not ready for sale yet
     * ‘active’ -> pass has passed the final availability requirements and has been marked by
     * the host as ready for sale.
     */
    passState: PassState;
    /**
     * the pass of the price plus the service fee
     */
    passTotalPrice: string;
    /**
     * the type of pass
     */
    passType: GuestPassPurchaseFailurePassType;
    [property: string]: any;
}

export enum CancellationReason {
    Availability = "availability",
    Earnings = "earnings",
    Maintenance = "maintenance",
    Other = "other",
    Personal = "personal",
}

export enum PassChange {
    Deactivation = "deactivation",
    Refund = "refund",
}

/**
 * [HOST PASS MANAGEMENT - REFUND]
 */
export interface HostSubmittedPassRefundNote {
    canceled?:       boolean;
    canceledReason?: string;
    courtesyNote?:   string;
    /**
     * the url for the cover image of the listing the pass is for
     */
    coverImageURL:  string;
    createdAt?:     string;
    end:            string;
    hasAutorenewOn: boolean;
    /**
     * first name of the host
     */
    hostFirstName: string;
    id?:           string;
    /**
     * true if the pass is a legacy pass
     */
    isLegacy: boolean;
    /**
     * id of the listing the pass is for
     */
    listingId: string;
    /**
     * the title of the listing the pass is for
     */
    listingTitle: string;
    /**
     * the url of the listing the pass is for
     */
    listingURL: string;
    /**
     * [{from:”07:00:00”, “11:00:00”}...] Time slots when this pass is eligible
     */
    passAvailableTimes?: any[];
    /**
     * LCM formatted version of available times property
     */
    passAvailableTimesText?: string;
    /**
     * list of blackout dates (e.g. July 4, 2024).
     */
    passBlackoutDays?: any[] | null;
    /**
     * when the pass was created
     */
    passCreatedAt: string;
    /**
     * currency for all monetary fields
     */
    passCurrencyCode: string;
    /**
     * flag indicating that this is the current version for a pass. For a type/name/listing_id,
     * there can only be one record with this attribute true.
     */
    passCurrent: boolean;
    /**
     * free text description set by host
     */
    passDescription?: null | string;
    /**
     * discount amount. Fixed discounts will be in minors units.
     */
    passDiscount: number | null;
    /**
     * type of pass discount num[‘percentage’, ‘fixed’]
     */
    passDiscountType: PassDiscountType | null;
    /**
     * days the pass is eligible
     */
    passEligibleDays?: any[] | null;
    /**
     * the status of the pass
     */
    passholderStatus: PassholderStatus;
    /**
     * the user id of the pass holder
     */
    passholderUserId: number;
    /**
     * id of the pass
     */
    passId: number;
    /**
     * max active passes allowed. This constraint will apply to the (listing_id, type, name)
     * rather than id so that we can be accurate across edits.
     */
    passMaxActivePasses?: number | null;
    /**
     * max bookings allowed under this pass
     */
    passMaxDailyBookings?: number | null;
    /**
     * max duration that may be booked using this pass
     */
    passMaxDuration?: number | null;
    /**
     * max guests that may be booked using this pass
     */
    passMaxGuests?: number | null;
    /**
     * the type of the pass formatted to be LCM friendly
     */
    passName: string;
    /**
     * the ids of all premium amenities included with the pass
     */
    passPremiumAmenities?: any[] | null;
    /**
     * pass price in minor units
     */
    passPrice: string;
    /**
     * ‘draft’ -> pass is being actively edited by the host via the creation flow. The step
     * attribute below tracks the progress of the host through the creation flow.
     * ‘inactive’ -> pass has been created by the host, but not ready for sale yet
     * ‘active’ -> pass has passed the final availability requirements and has been marked by
     * the host as ready for sale.
     */
    passState: PassState;
    /**
     * the pass of the price plus the service fee
     */
    passTotalPrice: string;
    /**
     * the type of pass
     */
    passType:   GuestPassPurchaseFailurePassType;
    start:      string;
    userPassId: number;
    [property: string]: any;
}

/**
 * [HOST RESERVATION] host submitted the rescheduling request via "send reschedule request"
 */
export interface HostSubmittedRebookingRequest {
    /**
     * id of the booking the reservation pertains to
     */
    bookingId: number;
    /**
     * was the booking made using a pass
     */
    bookingWithPass?: BookingWithPass;
    /**
     * discount percentage offered for rebooking
     */
    discountOfferedPercentage: number;
    /**
     * message id of message sent from host to guest about reschedule
     */
    messageId: number;
    /**
     * new host proposed booking date
     */
    newRescheduledDate: string;
    /**
     * new host proposed end time
     */
    newRescheduledEndTime: string;
    /**
     * new host proposed start time
     */
    newRescheduledStartTime: string;
    /**
     * original booking date
     */
    originalBookingDate: string;
    /**
     * original booking end time
     */
    originalBookingEndTime: string;
    /**
     * original booking start time
     */
    originalBookingStartTime: string;
    /**
     * if the booking was made or partially made with a pass, the pass id used
     */
    passId?: number | null;
    /**
     * the type of the pass formatted to be LCM friendly
     */
    passName?: null | string;
    /**
     * if the booking was made or partially made with a pass, what type of pass
     */
    passType?: GuestAcceptReviewChangesFromHostPassType | null;
    /**
     * final reason selected for the reschedule
     */
    rescheduleReason: string;
    /**
     * whether the fallback plan is "revert" or "cancel"
     */
    rescheduleRequestDeniedOption: string;
    /**
     * if the booking was made or partially made with a pass, what was the user pass Id used
     */
    userPassId?: number | null;
    [property: string]: any;
}

/**
 * host submitted a refund to the guest
 */
export interface HostSubmittedRefund {
    /**
     * id of the booking
     */
    bookingId: number;
    /**
     * status of the booking
     */
    bookingStatus: string;
    /**
     * full refund or partial refund
     */
    fullOrPartial: FullOrPartial;
    /**
     * id of the guest
     */
    guestId: number;
    /**
     * total value of the refund given to the guest
     */
    refundAmount: number;
    /**
     * currency of the refund
     */
    refundCurrency: string;
    /**
     * message the host sends to the guest regarding the refund
     */
    refundMessage: string;
    /**
     * host-selected refund reason
     */
    refundReason: string;
    [property: string]: any;
}

/**
 * full refund or partial refund
 */
export enum FullOrPartial {
    Full = "full",
    Partial = "partial",
}

/**
 * [HOST PERFORMANCE] Host submitted a reply to a guest's review
 */
export interface HostSubmittedReviewReply {
    bookingId: number;
    /**
     * message sent by the guest when booking
     */
    bookingMessage?: null | string;
    /**
     * if the guest left a rating between 1-5, what was it
     */
    bookingRating?: number | null;
    /**
     * guest selection (listing type specific) for why they're booking
     */
    bookingReason?: BookingReason | null;
    /**
     * if the guest left a review, what was it
     */
    bookingReview?:         null | string;
    bookingSpecialOfferId?: number | null;
    guestId:                number;
    hostId:                 number;
    id?:                    string;
    isInstantBooking?:      boolean;
    listingId:              number;
    listingTitle:           string;
    /**
     * the host's reply
     */
    reply:        string;
    totalGuests?: number;
    totalPrice?:  number;
    [property: string]: any;
}

/**
 * [HOST SD CLAIM]
 */
export interface HostSubmittedSDClaim {
    bookingId:     number;
    damagesAmount: number;
    listingId:     string;
    rationale:     string;
    [property: string]: any;
}

/**
 * [HOST SETTINGS - SECURITY DEPOSIT]
 */
export interface HostSubmittedSecurityDepositSetUp {
    listingId: number;
    /**
     * the size of the deposit required
     */
    newDepositAmount: DepositAmount;
    /**
     * min guest count to charge a security deposit
     */
    newGuestMin: number;
    /**
     * if there was an existing security deposit, the old the size of the deposit required
     */
    oldDepositAmount?: DepositAmount | null;
    /**
     * if there was an existing security deposit, the old min guest count to charge a security
     * deposit
     */
    oldGuestMin?: number | null;
    [property: string]: any;
}

/**
 * [HOST SETTINGS - SECURITY DEPOSIT]
 */
export interface HostSubmittedSecurityDepositToggleOff {
    /**
     * the size of the deposit required
     */
    depositAmount?: DepositAmount | null;
    /**
     * min guest count to charge a security deposit
     */
    guestMin?: number | null;
    listingId: number;
    [property: string]: any;
}

/**
 * [HOST CALENDAR SYNCING] fires if the Cronofy Sync is Successful
 */
export interface HostSubmittedSyncWCronofyFailure {
    listingId: number;
    [property: string]: any;
}

/**
 * [HOST CALENDAR SYNCING] fires when the Cronofy Sync is Successful
 */
export interface HostSubmittedSyncWCronofySuccess {
    calendarName: string;
    listingId:    number;
    [property: string]: any;
}

/**
 * [HOST CALENDAR SYNCING] fires when the host pressed "Delete Calendar" on the pop up after
 * deleting the calendar and pressing the "Manage Cronofy" CTA
 */
export interface HostSubmittedUnsyncCronofy {
    calendarName?: string;
    listingId:     number;
    [property: string]: any;
}

/**
 * [HOST CALENDAR SYNCING] fires when the host pressed "Unsync Calendar" on the confirmation
 * modal
 */
export interface HostSubmittedUnsyncICal {
    calendarName?: string;
    listingId:     number;
    [property: string]: any;
}

/**
 * [TIERED PRICING] host pressed to adjust group price
 */
export interface HostTieredPricingPressedAdjustGroupPrice {
    /**
     * id of the listing
     */
    listingId: string;
    [property: string]: any;
}

/**
 * [TIERED PRICING] host pressed "set price"
 */
export interface HostTieredPricingPressedConfirmPrice {
    dailyPriceCurrency?: string;
    dailyPriceEntered?:  string;
    /**
     * id of the listing
     */
    listingId: string;
    [property: string]: any;
}

/**
 * [TIERED PRICING] host set price for group
 */
export interface HostTieredPricingSetGroupPrice {
    /**
     * 0 - small groups, 1 - large groups, 2 - small gatherings, 3 - large gatherings, 4 - small
     * events, 5 - large events, 6 - huge events
     */
    group: Group;
    /**
     * id of the listing
     */
    listingId: string;
    /**
     * new price entered by host
     */
    newPrice: number;
    /**
     * old price before changed
     */
    oldPrice: number;
    [property: string]: any;
}

/**
 * 0 - small groups, 1 - large groups, 2 - small gatherings, 3 - large gatherings, 4 - small
 * events, 5 - large events, 6 - huge events
 */
export enum Group {
    The0 = "0",
    The1 = "1",
    The2 = "2",
    The3 = "3",
    The4 = "4",
    The5 = "5",
    The6 = "6",
}

/**
 * [TIERED PRICING] host tab do this later to remain in legacy pricing
 */
export interface HostTieredPricingTabDoThisLater {
    /**
     * id of the listing
     */
    listingId: number;
    [property: string]: any;
}

/**
 * [HOST SETTINGS - VIDEO TOUR] when host unsuccessfully uploads a video tour
 */
export interface HostVideoTourUploadFailure {
    failureReason: FailureReason | null;
    listingId:     number;
    [property: string]: any;
}

export enum FailureReason {
    Circumvention = "circumvention",
    Content = "content",
    Duration = "duration",
    Size = "size",
}

/**
 * [HOST SETTINGS - VIDEO TOUR] when host successfully uploads a video tour
 */
export interface HostVideoTourUploadSuccess {
    listingId: number;
    [property: string]: any;
}

/**
 * [HOST PERFORMANCE] Host viewed the performance dashboard by clicking the hosting in menu
 * bar
 */
export interface HostViewedPerfDashboard {
    /**
     * ! DO NOT ADD ID (HACK TO MAKE EVENT DISPLAY IN TYPES)
     */
    id?: string;
    [property: string]: any;
}

export interface LifeguardAccepted {
    bookingId?: string;
    [property: string]: any;
}

export interface LifeguardOffered {
    bookingId?: string;
    [property: string]: any;
}

export interface LifeguardRejected {
    bookingId?: string;
    [property: string]: any;
}

/**
 * [SEARCH] User viewed a listing on search
 */
export interface ListListingImpression {
    /**
     * if the listing has an active deal, what percent amount off of this promo code (1-100)
     */
    amountOff?: number | null;
    /**
     * the displayed badge name
     */
    badgeName: null | string;
    /**
     * daily price displayed
     */
    dailyPrice?: number;
    /**
     * if the listing has an active deal, when is the expiration
     */
    expireDate?: null | string;
    /**
     * [LISTING TYPE] The type of the listing associated with this event
     */
    globalListingType: GlobalListingType;
    /**
     * whether the listing has the offseason availability banner
     */
    hasAvailabilityBanner: boolean;
    /**
     * does the listing have a currently active deal (1 - yes, 0 - no)
     */
    hasDeal: boolean;
    /**
     * whether or not the listing has instant book status displayed
     */
    hasInstantBookStatus: boolean;
    /**
     * whether the listings has passes available (1 if true, 0 if false)
     */
    hasPass: boolean;
    /**
     * hourly price displayed
     */
    hourlyPrice?: number;
    /**
     * id of the listing
     */
    listingId: string;
    /**
     * for listings with the offseason availability banner, when is the next available date
     */
    nextAvailableDateDisplayed?: null | string;
    /**
     * order in search results
     */
    orderInSearchResults: number;
    /**
     * if the listing has one or more active passes, list the pass ids in an array
     */
    passIds?: any[] | null;
    /**
     * the types of passes available for a listing - null if it doesn't have any
     */
    passTypes: any[] | null;
    /**
     * the displayed price type of the listing
     */
    priceType: PriceType;
    /**
     * rating displayed
     */
    rating: number | null;
    /**
     * total amount of ratings displayed
     */
    ratingsVolume: number | null;
    /**
     * distance reported in the list impression
     */
    reportedDistance: number;
    /**
     * unit of the reported distance ('miles' or 'kilometers')
     */
    reportedDistanceUnit: ReportedDistanceUnit;
    /**
     * id of the search which generated the result
     */
    searchId: null | string;
    [property: string]: any;
}

/**
 * the displayed price type of the listing
 *
 * the displayed price type
 *
 * the displayed priceType of listing
 *
 * daily price for the listing (factoring in the guest count)
 *
 * the format of the price of the listing
 */
export enum PriceType {
    BaseTierDailyPrice = "base_tier_daily_price",
    BaseTierHourlyPrice = "base_tier_hourly_price",
}

/**
 * unit of the reported distance ('miles' or 'kilometers')
 */
export enum ReportedDistanceUnit {
    Kilometers = "kilometers",
    Miles = "miles",
}

/**
 * [SEARCH] User viewed a listing on search
 */
export interface ListListingImpressionAISearch {
    /**
     * id of the listing
     */
    listingId: string;
    /**
     * order in search results
     */
    orderInSearchResults?: number;
    /**
     * the price displayed
     */
    price?:    number;
    priceType: ListListingImpressionAISearchPriceType;
    /**
     * distance reported in the list impression
     */
    reportedDistance?: number;
    /**
     * unit of the reported distance ('miles' or 'kilometers')
     */
    reportedDistanceUnit?: ReportedDistanceUnit;
    [property: string]: any;
}

/**
 * price type of the listing
 *
 * the type of pricing structure - hourly or daily
 */
export enum ListListingImpressionAISearchPriceType {
    Daily = "daily",
    Hourly = "hourly",
}

/**
 * [SEARCH] User pressed next photo in carousel
 */
export interface ListingPhotoCarouselChanged {
    /**
     * displayed badge name
     */
    badgeName: null | string;
    /**
     * id of listing
     */
    listingId: string;
    /**
     * [DEPRECATED] photo id of photo now displayed
     */
    newPhotoId?: string;
    /**
     * photo url of photo now displayed
     */
    newPhotoUrl: string;
    /**
     * order of new photo in the carousel
     */
    orderInCarousel: number;
    /**
     * id of search which generated result
     */
    searchId: null | string;
    [property: string]: any;
}

/**
 * [SEARCH] The aggregated information of the search result based on the details and user
 * submitted
 */
export interface LoadSearchResult {
    /**
     * average hourly price of the search result
     */
    avgHourlyPrice?: number | null;
    /**
     * center point of the bounding box
     */
    centerPoint: LoadSearchResultCenterPoint;
    /**
     * radius distance of the bounding box
     */
    distance: number;
    /**
     * maximum price of the listing in the search result
     */
    maxPrice?: number | null;
    /**
     * minimum price of the listing in the search result
     */
    minPrice?: number | null;
    /**
     * the number of listing in that search
     */
    numberOfListings: number;
    /**
     * id of the search which generated the result
     */
    searchId: null | string;
    [property: string]: any;
}

/**
 * center point of the bounding box
 */
export interface LoadSearchResultCenterPoint {
    /**
     * latitude of the center point of the bounding box
     */
    latitude: number;
    /**
     * longitude of the center point of the bounding box
     */
    longitude: number;
    [property: string]: any;
}

/**
 * [SEARCH] map loaded on search
 */
export interface MapLoaded {
    /**
     * average price of pins displayed
     */
    avgPrice?: number | null;
    /**
     * maximum latitude for the display box
     */
    latMaximum: number;
    /**
     * minimum latitude for the display box
     */
    latMinimum: number;
    /**
     * maximum longitude for the display box
     */
    lngMaximum: number;
    /**
     * minimum longitude for the display box
     */
    lngMinimum: number;
    /**
     * maximum price of pins displayed
     */
    maxPrice?: number | null;
    /**
     * minimum price of pins displayed
     */
    minPrice?: number | null;
    /**
     * number of pins displayed on map
     */
    numPinsDisplayed: number;
    /**
     * id of search which generated result
     */
    searchId: null | string;
    [property: string]: any;
}

export interface MonitorAccepted {
    bookingId?: string;
    [property: string]: any;
}

export interface MonitorOffered {
    bookingId?: string;
    [property: string]: any;
}

export interface MonitorRejected {
    bookingId?: string;
    [property: string]: any;
}

/**
 * [DEFAULT WEB EVENTS] standard Segment track event for page
 */
export interface PageViewed {
    path:      string;
    referrer?: string;
    search?:   string;
    title:     string;
    url:       string;
    [property: string]: any;
}

/**
 * [USER SUBSCRIPTION] Send notification to a user with subscription when new listings in
 * search criteria go live
 */
export interface SentNewListingNotification {
    /**
     * the search category subscribed by the user
     */
    category: SentNewListingNotificationCategory;
    /**
     * the distance in mile between the listing and the subscribed zip code
     */
    distanceToZipCode: number;
    /**
     * the email of the user who joined the waitlist
     */
    email: string;
    /**
     * boolean if host has an promo code for this listings (first booking discount)
     */
    isHostHasPromoCode?: boolean;
    /**
     * city of the listing
     */
    listingCity: string;
    /**
     * country of the listing
     */
    listingCountry: string;
    /**
     * the id of the new listing which fits in the user subscribed criteria
     */
    listingId: string;
    /**
     * the cover image url of the listing
     */
    listingImageUrl?: string;
    /**
     * the base hourly price of the listing
     */
    listingPrice: number;
    /**
     * state of the listing
     */
    listingState: string;
    /**
     * tile of the listing
     */
    listingTitle: string;
    /**
     * the type of the listing
     */
    listingType?: ListingType;
    /**
     * the search term subscribed by the user
     */
    searchTerm: string;
    /**
     * country of the user
     */
    userCountry: string;
    /**
     * user id of the user who joined the waitlist
     */
    userId?: string;
    [property: string]: any;
}

/**
 * the search category subscribed by the user
 */
export enum SentNewListingNotificationCategory {
    All = "All",
    Backyards = "Backyards",
    Boats = "Boats",
    Budget = "Budget",
    Family = "Family",
    Heated = "Heated",
    Homes = "Homes",
    Hoops = "Hoops",
    HotTubs = "Hot Tubs",
    Indoors = "Indoors",
    Paddle = "Paddle",
    Parties = "Parties",
    Pets = "Pets",
    Racquet = "Racquet",
    Vip = "Vip",
}

/**
 * the type of the listing
 */
export enum ListingType {
    Basketball = "basketball",
    Pickleball = "pickleball",
    Pool = "pool",
    Tennis = "tennis",
    Yards = "yards",
}

/**
 * [SWIMPLY PREMIUM] Fires when a user successfully purchases, renews, or upgrades a Swimply
 * Premium subscription
 */
export interface SwimplyPremiumPurchaseSuccess {
    /**
     * Where the user initiated the premium purchase from
     */
    entryPoint?: EntryPoint | null;
    /**
     * The type of premium pass purchased (REGULAR, IGLOO, or SUMMER)
     */
    premiumType: PremiumType;
    /**
     * Whether this is a new purchase, renewal, or upgrade
     */
    purchaseType: PurchaseType;
    [property: string]: any;
}

export enum EntryPoint {
    Checkout = "checkout",
    GlobalIgloo = "global-igloo",
    GlobalRegular = "global-regular",
    Manage = "manage",
    Menu = "menu",
    Profile = "profile",
}

/**
 * The type of premium pass purchased (REGULAR, IGLOO, or SUMMER)
 */
export enum PremiumType {
    Igloo = "IGLOO",
    IglooSeasonal = "IGLOO_SEASONAL",
    Regular = "REGULAR",
    Summer = "SUMMER",
}

/**
 * Whether this is a new purchase, renewal, or upgrade
 */
export enum PurchaseType {
    Renew = "renew",
    Start = "start",
    Upgrade = "upgrade",
}

/**
 * [ACCOUNT CREATION] user successfully added photo to account
 */
export interface UserAccountAddedPhotoSuccess {
    /**
     * the authentication session ID
     */
    authId: string;
    /**
     * file extension of uploaded photo
     */
    photoFileExtension: any;
    /**
     * file size of the uploaded photo
     */
    photoFileSize: number;
    [property: string]: any;
}

/**
 * [ACCOUNT CREATION] user entered bio information
 */
export interface UserAccountBioEntered {
    /**
     * the authentication session ID
     */
    authId: string;
    /**
     * user blurb contents
     */
    userBlurb: string;
    [property: string]: any;
}

/**
 * [ACCOUNT CREATION] user skipped birthday + bio entry prompt
 */
export interface UserAccountBirthdayBioSkipped {
    /**
     * the authentication session ID
     */
    authId: string;
    [property: string]: any;
}

/**
 * [ACCOUNT CREATION] user entered birthday information into account
 */
export interface UserAccountBirthdayEntered {
    /**
     * the authentication session ID
     */
    authId: string;
    /**
     * user entered birthday date
     */
    userBirthdayDate: string;
    [property: string]: any;
}

/**
 * [ACCOUNT CREATION] user initiated adding a  photo
 */
export interface UserAccountInitiatedAddPhoto {
    /**
     * the authentication session ID
     */
    authId: string;
    [property: string]: any;
}

/**
 * [ACCOUNT CREATION] user input name
 */
export interface UserAccountName {
    /**
     * the authentication session ID
     */
    authId: string;
    /**
     * user input last name
     */
    userAccountFirstName: string;
    /**
     * user input first name
     */
    userAccountLastName: string;
    [property: string]: any;
}

/**
 * [ACCOUNT CREATION] user skipped name input prompt
 */
export interface UserAccountNameSkipped {
    /**
     * the authentication session ID
     */
    authId: string;
    [property: string]: any;
}

/**
 * [USER ACCOUNT] user skipped adding a profile photo
 */
export interface UserAccountPhotoSkipped {
    /**
     * what the user submitted for how they heard about us
     */
    userOrigin?: UserAccountPhotoSkippedUserOrigin | null;
    /**
     * what space types the user is interested in the most
     */
    userSpaceInterests?: any[];
    [property: string]: any;
}

export enum UserAccountPhotoSkippedUserOrigin {
    AISearch = "ai_search",
    AttendedSwimplyBooking = "attended_swimply_booking",
    Billboard = "billboard",
    DirectMail = "direct_mail",
    Facebook = "facebook",
    FacebookOrInstagramAd = "facebook_or_instagram_ad",
    FriendOrFamily = "friend_or_family",
    FromFriend = "from_friend",
    GoogleSearch = "google_search",
    Instagram = "instagram",
    MailedFlyer = "mailed_flyer",
    NewsArticle = "news_article",
    Other = "other",
    PressOrNewsArticle = "press_or_news_article",
    SharkTank = "shark_tank",
    SocialMediaFollow = "social_media_follow",
    SwimplyHost = "swimply_host",
    Tiktok = "tiktok",
    Youtube = "youtube",
}

/**
 * [USER ACCOUNT] user adds context to their profile, name, profile photo, guest intro, phone
 */
export interface UserAccountProfileContextAdded {
    /**
     * what the user submitted for how they heard about us
     */
    userOrigin?: UserAccountPhotoSkippedUserOrigin | null;
    /**
     * what space types the user is interested in the most
     */
    userSpaceInterests?: any[];
    [property: string]: any;
}

/**
 * [ACCOUNT CREATION] user X'd out of the context questions on their interests and how they
 * heard about us (capture any details that were entered)
 */
export interface UserAccountProfileContextSkipped {
    /**
     * what the user submitted for how they heard about us
     */
    userOrigin?: UserAccountProfileContextSkippedUserOrigin | null;
    /**
     * what space types the user is interested in the most
     */
    userSpaceInterests?: any[];
    [property: string]: any;
}

export enum UserAccountProfileContextSkippedUserOrigin {
    AttendedSwimplyBooking = "attended_swimply_booking",
    Billboard = "billboard",
    Facebook = "facebook",
    FromFriend = "from_friend",
    GoogleSearch = "google_search",
    Instagram = "instagram",
    MailedFlyer = "mailed_flyer",
    NewsArticle = "news_article",
    Other = "other",
    SharkTank = "shark_tank",
    Tiktok = "tiktok",
    Youtube = "youtube",
}

/**
 * [ACCOUNT CREATION] user input details on new account creation form
 */
export interface UserAccountProfileDetailsAdded {
    /**
     * the authentication session ID
     */
    authId: string;
    /**
     * file extension of uploaded photo
     */
    photoFileExtension?: null | string;
    /**
     * file size of the photo
     */
    photoFileSize?: number | null;
    /**
     * user input last name
     */
    userAccountFirstName?: null | string;
    /**
     * user input first name
     */
    userAccountLastName?: null | string;
    /**
     * user entered birthday date
     */
    userBirthdayDate?: null | string;
    /**
     * user blurb entered
     */
    userBlurb?: null | string;
    [property: string]: any;
}

/**
 * [ACCOUNT CREATION] user viewed the page to input their details on new account creation
 * form
 */
export interface UserAccountProfileDetailsFormViewed {
    /**
     * the authentication session ID
     */
    authId: string;
    /**
     * how they accessed the form
     */
    enteredFrom: UserAccountProfileDetailsFormViewedEnteredFrom;
    [property: string]: any;
}

/**
 * how they accessed the form
 */
export enum UserAccountProfileDetailsFormViewedEnteredFrom {
    Checkout = "checkout",
    ClaimReferral = "claim_referral",
    ContactHost = "contact_host",
    EarnCredits = "earn_credits",
    Favoriting = "favoriting",
    HostOnboarding = "host_onboarding",
    JoinWaitlist = "join_waitlist",
    PassCheckout = "pass_checkout",
    PostBookingInvite = "post_booking_invite",
    Review = "review",
    StandardOnboarding = "standard_onboarding",
}

/**
 * [ACCOUNT CREATION] user pressed do this later (capture any details that were entered)
 */
export interface UserAccountProfileDetailsSkipped {
    /**
     * the authentication session ID
     */
    authId: string;
    /**
     * file extension of uploaded photo
     */
    photoFileExtension?: null | string;
    /**
     * file size of the photo
     */
    photoFileSize?: number | null;
    /**
     * user input last name
     */
    userAccountFirstName?: null | string;
    /**
     * user input first name
     */
    userAccountLastName?: null | string;
    /**
     * user entered birthday date
     */
    userBirthdayDate?: null | string;
    /**
     * user blurb entered
     */
    userBlurb?: null | string;
    [property: string]: any;
}

/**
 * [CHECKOUT] submission for total amount of guests
 */
export interface UserAddGuestsConfirmed {
    /**
     * number of adults
     */
    adultNumber: number;
    /**
     * id for the current checkout flow
     */
    checkoutId: string;
    /**
     * number of children
     */
    childrenNumber: number;
    /**
     * currency for all dollar items
     */
    currency: string;
    /**
     * did they enter this item from the "contact host" PLP flow
     */
    enteredFromContactHostFlow: boolean;
    /**
     * did user enter this from PLP
     */
    enteredFromPLP: boolean;
    /**
     * did user come to this screen via a reservation edit
     */
    enteredFromReservationEdit: boolean;
    /**
     * number of infants
     */
    infantNumber: number;
    /**
     * max allowed guest for instant bookings, if applicable
     */
    instantBookingGuestLimit: number;
    /**
     * do total number of guests qualify for instant bookings, if applicable
     */
    isInstantBookingEligible: boolean;
    /**
     * listing has instant booking enabled
     */
    listingHasInstantBooking: boolean;
    /**
     * the id for the pool listing
     */
    listingId: string;
    /**
     * number of pets
     */
    petNumber: number;
    /**
     * max allowed guests for pool
     */
    poolMaximumGuests: number;
    /**
     * id for the search that led to this listing
     */
    searchId: string;
    /**
     * sum of all guests (adults, children, pets, infants)
     */
    totalGuests: number;
    /**
     * total price value displayed
     */
    totalPriceDisplayed: number;
    [property: string]: any;
}

/**
 * [CHECKOUT] user was shown screen to adjust number of guests
 */
export interface UserAddGuestsDisplayed {
    /**
     * information about the per-guest fee if applicable
     */
    additionalGuestFeesDisplayedInfo: AdditionalGuestFeesDisplayedInfo;
    /**
     * id for the current checkout flow
     */
    checkoutId: string;
    /**
     * currency of all dollar items
     */
    currency: string;
    /**
     * number of adults pre-loaded
     */
    defaultAdultNumber: number;
    /**
     * number of children pre-loaded
     */
    defaultChildrenNumber: number;
    /**
     * number of infants pre-loaded
     */
    defaultInfantNumber: number;
    /**
     * number of pets pre-loaded
     */
    defaultPetNumber: number;
    /**
     * where did the user enter this page from
     */
    enteredFrom: string;
    /**
     * did they enter this item from the "contact host" PLP flow
     */
    enteredFromContactHostFlow: boolean;
    /**
     * did user enter this from PLP
     */
    enteredFromPLP: boolean;
    /**
     * did user come to this screen via a reservation edit
     */
    enteredFromReservationEdit: boolean;
    /**
     * total price displayed on screen load
     */
    initialTotalPriceDisplayed: number;
    /**
     * max allowed guest for instant bookings, if applicable
     */
    instantBookingGuestLimit: number;
    /**
     * is the booking initially eligible for instant bookings, if applicable
     */
    isInstantBookingEligible: boolean;
    /**
     * listing has instant bookings enabled
     */
    listingHasInstantBooking: boolean;
    /**
     * the id for the pool listing
     */
    listingId: string;
    /**
     * max allowed guests for pool
     */
    poolMaximumGuests: number;
    /**
     * the total price shown
     */
    price: number;
    /**
     * price type of the listing
     */
    priceType: ListListingImpressionAISearchPriceType;
    /**
     * id for the search that led to this listing
     */
    searchId: string;
    [property: string]: any;
}

/**
 * information about the per-guest fee if applicable
 */
export interface AdditionalGuestFeesDisplayedInfo {
    /**
     * the guest number at which the fee kicks in at
     */
    numberOfGuestsExtraFeeAppliesPast: number;
    /**
     * price applied per additional guest/hour
     */
    pricePerAdditionalGuest: number;
    [property: string]: any;
}

/**
 * [CHECKOUT] user adds an optional message to the host
 */
export interface UserAddedBookingMessage {
    bookingId?:      number;
    bookingMessage?: null | string;
    /**
     * guest selection (listing type specific) for why they're booking
     */
    bookingReason?:         BookingReason | null;
    bookingSpecialOfferId?: number | null;
    bookingStartDateTime?:  string;
    country:                string;
    /**
     * [LISTING TYPE] The type of the listing associated with this event
     */
    globalListingType: GlobalListingType;
    guestId:           number;
    hostId:            number;
    id?:               string;
    isInstantBooking:  boolean;
    listingId:         number;
    listingTitle:      string;
    market?:           string;
    totalGuests?:      number;
    totalPrice?:       number;
    [property: string]: any;
}

/**
 * [CHECKOUT] final checkout screen displayed
 */
export interface UserBookingDetailsDisplay {
    /**
     * id for the current checkout flow
     */
    checkoutId: string;
    /**
     * type of checkout (standard or passes)
     */
    checkoutType: CheckoutTypeEnum;
    /**
     * currency of price
     */
    currency: string;
    /**
     * datetime displayed for booking
     */
    dateDisplayed?: string;
    /**
     * end hour of the booking
     */
    endHour?: number;
    /**
     * [LISTING TYPE] The type of the listing associated with this event
     */
    globalListingType: GlobalListingType;
    /**
     * does the listing have an active pass - 1 if true, 0 if false
     */
    hasActivePass?: boolean;
    /**
     * is the guest shown a pass upsell option - 1 if true, 0 if false
     */
    hasPassUpsellDisplayed?: boolean;
    /**
     * the id for the pool listing
     */
    listingId: string;
    /**
     * object describing stored booking payment details
     */
    savedBookingPaymentMethod: SavedBookingPaymentMethod;
    /**
     * id for the search that led to this listing
     */
    searchId: null | string;
    /**
     * start hour of the booking
     */
    startHour?: number;
    /**
     * number of adults
     */
    totalAdultGuests?: number;
    /**
     * total number of children
     */
    totalChildren?: number;
    /**
     * total duration of the booking, in hours
     */
    totalDurationHours?: number;
    /**
     * total number of guests (adults, children, pets, infants)
     */
    totalGuests?: number;
    /**
     * number of infants
     */
    totalInfantGuests?: number;
    /**
     * number of pets
     */
    totalPetGuests?: number;
    /**
     * total price displayed
     */
    totalPrice: number;
    [property: string]: any;
}

/**
 * type of checkout (standard or passes)
 *
 * was a pass purchase or a standard booking made
 *
 * is the checkout for a pass purchase or a standard booking
 */
export enum CheckoutTypeEnum {
    Pass = "pass",
    StandardBooking = "standard_booking",
}

/**
 * object describing stored booking payment details
 */
export interface SavedBookingPaymentMethod {
    /**
     * payment ids for all stored payment methods
     */
    availablePaymentIds: any[];
    /**
     * is there a payment pre-applied to booking
     */
    isApplied: boolean;
    /**
     * is there a payment available to apply to the booking (anything in wallet)
     */
    isAvailable: boolean;
    /**
     * paymentId of pre-applied payment, if applicable
     */
    whichPaymentApplied: number | null;
    [property: string]: any;
}

/**
 * [CHECKOUT] final checkout submission, only when failed
 */
export interface UserBookingSubmittedFailure {
    /**
     * for now this should be a constant “Swimply”, but could be used in the future with
     * different partnerships/platforms
     */
    affiliation: string;
    /**
     * id of booking
     */
    bookingId?: string;
    /**
     * was the booking made using a pass
     */
    bookingWithPass?: BookingWithPass;
    /**
     * id for the current checkout flow
     */
    checkoutId: string;
    /**
     * promocode name, should equal promoCodeDetails.promoCodeName
     */
    coupon?: string;
    /**
     * currency of price
     */
    currency: string;
    /**
     * datetime selected for booking
     */
    dateSelected?: string;
    /**
     * Total discount in dollars associated with the transaction
     */
    discount?: number;
    /**
     * [LISTING TYPE] The type of the listing associated with this event
     */
    globalListingType: GlobalListingType;
    /**
     * the age of the guest
     */
    guestAge?: number | null;
    /**
     * amount value that swimply is charging the guest
     */
    guestFee: number;
    /**
     * amount value that swimply is charging the host
     */
    hostFee: number;
    /**
     * city for the listing
     */
    listingCity: string;
    /**
     * url for the listing's cover photo
     */
    listingCoverPhotoURL: string;
    /**
     * the id for the pool listing
     */
    listingId: string;
    /**
     * state/region for the listing
     */
    listingState: string;
    /**
     * title of the listing
     */
    listingTitle: string;
    /**
     * if the booking was made or partially made with a pass, the pass id used
     */
    passId?: number | null;
    /**
     * the type of the pass formatted to be LCM friendly
     */
    passName?: null | string;
    /**
     * if the booking was made or partially made with a pass, what type of pass
     */
    passType?: GuestAcceptReviewChangesFromHostPassType | null;
    /**
     * object including payment details
     */
    paymentMethodDetails: UserBookingSubmittedFailurePaymentMethodDetails;
    /**
     * list of items being purchased, used for GA event mapping
     */
    products?: UserBookingSubmittedFailureProduct[];
    /**
     * object including promo code details
     */
    promoCodeDetails?: UserBookingSubmittedFailurePromoCodeDetails;
    /**
     * was a pass purchase or a standard booking made
     */
    purchaseType: CheckoutTypeEnum;
    /**
     * id for the search that led to this listing
     */
    searchId: null | string;
    /**
     * Shipping cost associated with the transaction (for us, this should just always be 0)
     */
    shipping: number;
    /**
     * Order total after discounts but before taxes and shipping
     */
    subtotal: number;
    /**
     * Total tax associated with the transaction
     */
    tax: number;
    /**
     * time from submission to final result, in seconds
     */
    timeToResultSeconds: number;
    /**
     * Revenue with discounts and coupons added in (same as value, revenue, totalPrice)
     */
    total: number;
    /**
     * number of adults
     */
    totalAdultGuests?: number;
    /**
     * total number of children guests
     */
    totalChildrenGuests?: number;
    /**
     * guest fee + host fee
     */
    totalFeesToBeCollected: number;
    /**
     * total number of guests (adults, children, pets, infants)
     */
    totalGuests?: number;
    /**
     * number of infants
     */
    totalInfantGuests?: number;
    /**
     * number of pets
     */
    totalPetGuests?: number;
    /**
     * final price submitted
     */
    totalPrice: number;
    /**
     * if the submission is unsuccessful, a list of the errors
     */
    unSuccessfullySubmittedReasons: any[];
    /**
     * if the booking was made or partially made with a pass, what was the user pass Id used
     */
    userPassId?: number | null;
    /**
     * same as "totalPrice" but needed naming convention for 3P
     */
    value: number;
    [property: string]: any;
}

/**
 * object including payment details
 */
export interface UserBookingSubmittedFailurePaymentMethodDetails {
    /**
     * is this a newly entered payment (not previously stored in wallet)
     */
    isNewPaymentId: boolean;
    /**
     * id of payment
     */
    paymentId: string;
    /**
     * is payment via google pay, apple pay, card, etc
     */
    paymentPlatformType: PaymentPlatformType;
    [property: string]: any;
}

/**
 * is payment via google pay, apple pay, card, etc
 */
export enum PaymentPlatformType {
    ApplePay = "apple pay",
    Card = "card",
    GooglePay = "google pay",
    Klarna = "klarna",
}

export interface UserBookingSubmittedFailureProduct {
    /**
     * promocode name applied
     */
    coupon?: string;
    /**
     * link to the cover photo for the pool
     */
    imageUrl: string;
    /**
     * title of pool -> item_name
     */
    name: string;
    /**
     * should be same as value, total, revenue
     */
    price: number;
    /**
     * id of associated pool/listing -> item_id
     */
    productId: string;
    /**
     * number purchased of this productId (should always be 1 for now)
     */
    quantity: number;
    /**
     * link to the PLP
     */
    url: string;
    [property: string]: any;
}

/**
 * object including promo code details
 */
export interface UserBookingSubmittedFailurePromoCodeDetails {
    /**
     * does order have a promo code applied
     */
    isPromoCodeApplied?: boolean;
    /**
     * amount in dollars saved from promo code
     */
    promoCodeAmountTotal?: number;
    /**
     * text of promoCode
     */
    promoCodeName?: null | string;
    /**
     * percent savings from the promo code
     */
    promoCodePercentSavings?: number;
    [property: string]: any;
}

/**
 * [CHECKOUT] final checkout submission, only when successful
 */
export interface UserBookingSubmittedSuccess {
    /**
     * for now this should be a constant “Swimply”, but could be used in the future with
     * different partnerships/platforms
     */
    affiliation: string;
    /**
     * if the listing has an active deal, what percent amount off of this promo code (1-100)
     */
    amountOff?: null | string;
    /**
     * billing zip code of the guest's credit card, in standard format
     */
    billingZipCode: string;
    /**
     * billing zip code of the guest's credit card, in Meta compatible format. All lowercase, no
     * spaces. US Zip codes only 5 digitis. Canadian postal code example: "K1A 0B1" -> "k1a0b1"
     */
    billingZipCodeMetaFormat: string;
    /**
     * id of booking
     */
    bookingId?: string;
    /**
     * guest added optional message to the host
     */
    bookingMessage?: null | string;
    /**
     * guest selection (listing type specific) for why they're booking
     */
    bookingReason?: BookingReason | null;
    /**
     * id of the special offer (if there was one, null if not)
     */
    bookingSpecialOfferId?: number | null;
    /**
     * was the booking made using a pass
     */
    bookingWithPass?: BookingWithPass;
    /**
     * listing_type. Must be both within event property and product array
     */
    category: string;
    /**
     * id for the current checkout flow
     */
    checkoutId: string;
    /**
     * city of the listing (for meta event)
     */
    city: string;
    /**
     * id of the listing (for meta event)
     */
    content_ids: number;
    /**
     * should be all `destination` (for meta event)
     */
    content_type: ContentType;
    /**
     * country of the listing (for meta event)
     */
    country: string;
    /**
     * promocode name, should equal promoCodeDetails.promoCodeName
     */
    coupon?: null | string;
    /**
     * currency of price
     */
    currency: string;
    /**
     * datetime selected for booking
     */
    dateSelected?: string;
    /**
     * Total discount in dollars associated with the transaction
     */
    discount?: number;
    /**
     * if the listing has an active deal, when is the expiration
     */
    expireDate?: null | string;
    /**
     * the age of the guest
     */
    guestAge?: number | null;
    /**
     * amount value that swimply is charging the guest
     */
    guestFee: number;
    /**
     * does the listing have a currently active deal (1 - yes, 0 - no)
     */
    hasDeal?: boolean;
    /**
     * amount value that swimply is charging the host
     */
    hostFee:               number;
    listingCityMetaFormat: string;
    /**
     * listing country code: Use the lowercase, 2-letter country codes in ISO 3166-1 alpha-2
     */
    listingCountryCode: string;
    /**
     * the id for the pool listing
     */
    listingId: string;
    /**
     * Listing state: Lowercase, two letter state code for US in FIPS format, full name and
     * lowercase with no whitespace when outside the US ("California"->"ca", “Nova Scotia” ->
     * “novascotia”)
     */
    listingStateMetaFormat: string;
    /**
     * listing name. Must be both within event property and product array
     */
    name: string;
    /**
     * if the booking was made or partially made with a pass, the pass id used
     */
    passId?: number | null;
    /**
     * the type of the pass formatted to be LCM friendly
     */
    passName?: null | string;
    /**
     * if the booking was made or partially made with a pass, what type of pass
     */
    passType?: GuestAcceptReviewChangesFromHostPassType | null;
    /**
     * object including payment details
     */
    paymentMethodDetails: UserBookingSubmittedSuccessPaymentMethodDetails;
    /**
     * list of items being purchased, used for GA event mapping
     */
    products?: UserBookingSubmittedSuccessProduct[];
    /**
     * object including promo code details
     */
    promoCodeDetails?: UserBookingSubmittedSuccessPromoCodeDetails;
    /**
     * was a pass purchase or a standard booking made
     */
    purchaseType: CheckoutTypeEnum;
    /**
     * state of the listing (for meta event)
     */
    region: string;
    /**
     * Revenue with discounts and coupons added in (same as value, total, totalPrice)
     */
    revenue: number;
    /**
     * id for the search that led to this listing
     */
    searchId: string;
    /**
     * Shipping cost associated with the transaction (for us, this should just always be 0)
     */
    shipping: number;
    /**
     * Order total after discounts but before taxes and shipping
     */
    subtotal: number;
    /**
     * Attributions that we capture from custom url query param
     */
    swimplyAttribution?: string;
    /**
     * Total tax associated with the transaction
     */
    tax: number;
    /**
     * time from submission to final result, in seconds
     */
    timeToResultSeconds: number;
    /**
     * Revenue with discounts and coupons added in (same as value, revenue, totalPrice)
     */
    total: number;
    /**
     * number of adults
     */
    totalAdultGuests?: number;
    /**
     * total number of children guests
     */
    totalChildrenGuests?: number;
    /**
     * guest fee + host fee
     */
    totalFeesToBeCollected: number;
    /**
     * total number of guests (adults, children, pets, infants)
     */
    totalGuests?: number;
    /**
     * number of infants
     */
    totalInfantGuests?: number;
    /**
     * number of pets
     */
    totalPetGuests?: number;
    /**
     * final price submitted
     */
    totalPrice: number;
    /**
     * if the booking was made or partially made with a pass, what was the user pass Id used
     */
    userPassId?: number | null;
    /**
     * same as "totalPrice" but needed naming convention for 3P
     */
    value: number;
    [property: string]: any;
}

/**
 * should be all `destination` (for meta event)
 *
 * should be destination (for meta event)
 *
 * should be destination (for meta event)
 */
export enum ContentType {
    Destination = "destination",
}

/**
 * object including payment details
 */
export interface UserBookingSubmittedSuccessPaymentMethodDetails {
    /**
     * is this a newly entered payment (not previously stored in wallet)
     */
    isNewPaymentId: boolean;
    /**
     * id of payment
     */
    paymentId: string;
    /**
     * is payment via google pay, apple pay, card, etc
     */
    paymentPlatformType: PaymentPlatformType;
    [property: string]: any;
}

export interface UserBookingSubmittedSuccessProduct {
    /**
     * listing_type. Must be both within event property and product array
     */
    category: string;
    /**
     * promocode name applied
     */
    coupon: string;
    /**
     * currency of price, ISO format. Must be both within event property and product array
     */
    currency?: string;
    /**
     * link to the cover photo for the pool
     */
    imageUrl: string;
    /**
     * title of pool -> item_name
     */
    name: string;
    /**
     * should be same as value, total, revenue
     */
    price: number;
    /**
     * id of associated pool/listing -> item_id
     */
    productId: string;
    /**
     * number purchased of this productId (should always be 1 for now)
     */
    quantity: number;
    /**
     * link to the PLP
     */
    url: string;
    [property: string]: any;
}

/**
 * object including promo code details
 */
export interface UserBookingSubmittedSuccessPromoCodeDetails {
    /**
     * does order have a promo code applied
     */
    isPromoCodeApplied?: boolean;
    /**
     * amount in dollars saved from promo code
     */
    promoCodeAmountTotal?: number;
    /**
     * text of promoCode
     */
    promoCodeName?: null | string;
    /**
     * percent savings from the promo code
     */
    promoCodePercentSavings?: number;
    [property: string]: any;
}

/**
 * [CHECKOUT] user viewed calendar
 */
export interface UserCalenderView {
    /**
     * id for the current checkout flow
     */
    checkoutId: string;
    /**
     * did they enter this item from the "contact host" PLP flow
     */
    enteredFromContactHostFlow: boolean;
    /**
     * did user come to this screen via a reservation edit
     */
    enteredFromReservationEdit: boolean;
    /**
     * existing date applied when user entered calendar
     */
    existingDate: string;
    /**
     * the id for the pool listing
     */
    listingId: string;
    /**
     * id for the search that led to this listing
     */
    searchId: null | string;
    [property: string]: any;
}

/**
 * [CHECKOUT] user selected a date within the checkout flow
 */
export interface UserChoseDate {
    /**
     * id for the current checkout flow
     */
    checkoutId: string;
    /**
     * did they enter this item from the "contact host" PLP flow
     */
    enteredFromContactHostFlow: boolean;
    /**
     * dis user add this date on the PLP
     */
    enteredFromPLP: boolean;
    /**
     * did user come to this screen via a reservation edit
     */
    enteredFromReservationEdit: boolean;
    /**
     * date for which times were displayed prior to press
     */
    existingDate?: string;
    /**
     * was the date chosen from the calendar view?
     */
    fromCalendar: boolean;
    /**
     * the id for the pool listing
     */
    listingId: string;
    /**
     * date for which times were displayed after press
     */
    newDate: string;
    /**
     * date user entered in search id that led to this listing
     */
    originalSearchIdDate: null | string;
    /**
     * id for the search that led to this listing
     */
    searchId: null | string;
    /**
     * times displayed as a result of the new date selection
     */
    timesDisplayed: any[];
    /**
     * all times available for the new date selected
     */
    totalTimesAvailable: any[];
    [property: string]: any;
}

/**
 * [CHECKOUT] user pressed a payment in the wallet
 */
export interface UserChosePaymentMethodInWallet {
    /**
     * id for the current checkout flow
     */
    checkoutId: string;
    /**
     * the previously applied paymentId, if applicable
     */
    existingPaymentId: string;
    /**
     * user selected Apple Pay
     */
    isApplePay: boolean;
    /**
     * user selected Google Pay
     */
    isGooglePay: boolean;
    /**
     * the id for the pool listing
     */
    listingId: string;
    /**
     * the newly applied paymentId
     */
    newPaymentId: string;
    /**
     * id for the search that led to this listing
     */
    searchId: null | string;
    [property: string]: any;
}

/**
 * [POST BOOKING REVIEW] user selected to continue with rebook option
 */
export interface UserContinuedBookAgainOption {
    /**
     * id of the booking associated with the review
     */
    bookingId: number;
    /**
     * id of the checkout flow initiated by continuing to book
     */
    checkoutId: string;
    /**
     * id of the listing being reviewed
     */
    listingId: number;
    /**
     * details for the multi dip offer if applicable
     */
    multiDipDetails?: UserContinuedBookAgainOptionMultiDIPDetails;
    /**
     * value of the rating submitted
     */
    ratingSubmittedValue: number;
    /**
     * details for the single dip offer if applicable
     */
    singleDipDetails: UserContinuedBookAgainOptionSingleDIPDetails;
    [property: string]: any;
}

/**
 * details for the multi dip offer if applicable
 */
export interface UserContinuedBookAgainOptionMultiDIPDetails {
    /**
     * currency of the price
     */
    currency?: string;
    /**
     * discount amount offered in percentage terms for multidip
     */
    discountOffered?: number;
    /**
     * did the user select multi dip
     */
    isMultiDipSelected?: boolean;
    /**
     * price offered for multi dip rebook
     */
    priceOfferedPerHour?: number;
    [property: string]: any;
}

/**
 * details for the single dip offer if applicable
 */
export interface UserContinuedBookAgainOptionSingleDIPDetails {
    /**
     * currency of the price
     */
    currency: string;
    /**
     * did user select single dip
     */
    isSingleDipSelected: boolean;
    /**
     * price offered for single dip rebook
     */
    priceOfferedPerHour: number;
    [property: string]: any;
}

/**
 * [GUEST FAVORITE] user pressed "delete this list" confirmation
 */
export interface UserDeletedFavoriteList {
    /**
     * the user id of the account who created the favorite collection
     */
    alphaUserId?: number;
    /**
     * an array of any favorite collection collaborator's user ids
     */
    betaUserIds?: any[];
    /**
     * the favorite collection id
     */
    favoriteCollectionId: number;
    /**
     * the name of the favorite collection
     */
    favoriteCollectionName: string;
    id?:                    string;
    /**
     * a boolean to identify whether the actions being taken to a favorite collection are being
     * done by the alpha user (1) or a beta user (0)
     */
    isAlphaUserId: boolean;
    [property: string]: any;
}

/**
 * [CHECKOUT] send event *per amenity displayed*
 */
export interface UserDisplayedAmenity {
    /**
     * list of amenities displayed
     */
    amenities: UserDisplayedAmenityAmenity[];
    /**
     * id for the current checkout flow
     */
    checkoutId: string;
    /**
     * currency of fees if applicable
     */
    currency: string;
    /**
     * did user come to this screen via a reservation edit
     */
    enteredFromReservationEdit: boolean;
    /**
     * the id for the pool listing
     */
    listingId: string;
    /**
     * id for the search that led to this listing
     */
    searchId: string;
    [property: string]: any;
}

export interface UserDisplayedAmenityAmenity {
    /**
     * description of the amenity
     */
    amenityDescription?: null | string;
    amenityFeeDetails:   FriskyAmenityFeeDetails;
    /**
     * name of amenity
     */
    amenityName: string;
    /**
     * is this a custom amenity from the host
     */
    isCustomAmenity: boolean;
    /**
     * does this amenity have a fee
     */
    isFee: boolean;
    /**
     * is this amenity pre selected
     */
    isPreSelected: boolean;
    [property: string]: any;
}

export interface FriskyAmenityFeeDetails {
    /**
     * fee of amenity if it's a flat fee, otherwise 0
     */
    flatFeeAmount: number;
    /**
     * fee of amenity if it's an hourly fee, otherwise 0
     */
    hourlyFeeAmount: number;
    /**
     * does this amenity have a flat fee
     */
    isFlatFee: boolean;
    /**
     * does this amenity have an hourly fee
     */
    isHourlyFee: boolean;
    [property: string]: any;
}

/**
 * [POST BOOKING REVIEW] user shown post-booking flow screen
 */
export interface UserDisplayedPostBookingFlow {
    /**
     * id of the booking associated with the review
     */
    bookingId: number;
    /**
     * id of the listing being reviewed
     */
    listingId: number;
    /**
     * minutes since this booking was completed and the user saw this display
     */
    minutesSinceBookingCompleted: number;
    /**
     * the rating value displayed on the listing
     */
    ratingValueDisplayed: number;
    [property: string]: any;
}

/**
 * [SEARCH] user select distance in filter
 */
export interface UserEditedFilterDistance {
    /**
     * the maximum distance the user filter on
     */
    maxDistance: number;
    [property: string]: any;
}

/**
 * [SEARCH] user select price range in filter
 */
export interface UserEditedFilterPrice {
    /**
     * the maximum price the user filtered on
     */
    highPrice: number;
    /**
     * the minimum price the user filtered on
     */
    lowPrice: number;
    [property: string]: any;
}

/**
 * [SEARCH] user select a pool type in filter
 */
export interface UserEditedPoolType {
    /**
     * pool type the user selected
     */
    poolType?:  null | string;
    properties: any;
    [property: string]: any;
}

/**
 * [SEARCH] user select water type in filter
 */
export interface UserEditedWaterType {
    /**
     * water type the user selected (salt water or chlorine)
     */
    waterType?: null | string;
    properties: any;
    [property: string]: any;
}

/**
 * [GUEST FAVORITE] user clicked to enter map view for favorites list
 */
export interface UserEnteredFavoriteListMapView {
    /**
     * the user id of the account who created the favorite collection
     */
    alphaUserId?: number;
    /**
     * an array of any favorite collection collaborator's user ids
     */
    betaUserIds?: any[];
    /**
     * the favorite collection id
     */
    favoriteCollectionId: number;
    /**
     * the name of the favorite collection
     */
    favoriteCollectionName: string;
    id?:                    string;
    /**
     * a boolean to identify whether the actions being taken to a favorite collection are being
     * done by the alpha user (1) or a beta user (0)
     */
    isAlphaUserId: boolean;
    [property: string]: any;
}

/**
 * [SEARCH] user pressed full screen map view
 */
export interface UserEnteredFullScreenMap {
    /**
     * id of search which generated result
     */
    searchId: null | string;
    [property: string]: any;
}

/**
 * [CHECKOUT] user attempted to apply a promo code
 */
export interface UserEnteredPromoCode {
    /**
     * id for the current checkout flow
     */
    checkoutId: string;
    /**
     * if invalid, reasons why it is invalid
     */
    inValidReasons: any[];
    /**
     * did promo code successfully apply to order
     */
    isValid: boolean;
    /**
     * the id for the pool listing
     */
    listingId: string;
    /**
     * promo code deduction in dollars
     */
    promoCodeDollarAmount?: number;
    /**
     * percent off applied due to promo code
     */
    promoCodePercentAmount: number;
    /**
     * text input of promo code
     */
    promoCodeText: string;
    /**
     * id for the search that led to this listing
     */
    searchId: null | string;
    [property: string]: any;
}

/**
 * [ACCOUNT CREATION] user entered ZIP code
 */
export interface UserEnteredZipCode {
    /**
     * the authentication session ID
     */
    authId: string;
    /**
     * zip code entered by user
     */
    zipCode: string;
    [property: string]: any;
}

/**
 * [COZYMEAL] User clicked to exit the Cozymeal catering options page
 */
export interface UserExitedCozymealBookingAdditions {
    bookingId?: number;
    guestId:    number;
    hostId:     number;
    id?:        string;
    listingId:  number;
    [property: string]: any;
}

/**
 * [SEARCH] user entered the filter menu
 */
export interface UserFiltersPressed {
    /**
     * id of search which generated result
     */
    searchId: null | string;
    [property: string]: any;
}

/**
 * [SEARCH] user edited the time in the Find A Space screen
 */
export interface UserFindASpaceScreenEditTime {
    /**
     * The new ending time the user entered in military format
     */
    endTime?: number | null;
    /**
     * The new starting time the user entered in military format
     */
    startTime?: number | null;
    properties: any;
    [property: string]: any;
}

/**
 * [SEARCH]
 * user edited the date in the Find A Space screen
 */
export interface UserFindASpaceScreenEditWhen {
    /**
     * the new date the user entered
     */
    date: string;
    /**
     * the weather details shown in the day button
     */
    weatherSelectedDate?: WeatherSelectedDate;
    [property: string]: any;
}

/**
 * the weather details shown in the day button
 */
export interface WeatherSelectedDate {
    /**
     * temperature shown in day button
     */
    temperature?: number;
    /**
     * unit of the temperature
     */
    temperatureUnit?: string;
    /**
     * weatherIcon
     */
    weatherIcon?: null | string;
    [property: string]: any;
}

/**
 * [SEARCH] user edited the location in the Find A Space screen
 */
export interface UserFindASpaceScreenEditWhere {
    /**
     * the latitude of the location the user entered
     */
    latitude: number;
    /**
     * the longitude of the location the user entered
     */
    longitude: number;
    /**
     * the search term the user entered
     */
    searchTerm: string;
    [property: string]: any;
}

/**
 * [SEARCH] user edit the guest list in the Find A Space screen
 */
export interface UserFindASpaceScreenEditWho {
    /**
     * the adult guest count the user entered
     */
    adultGuests: number;
    /**
     * the children guest count the user entered
     */
    childGuests: number;
    /**
     * the infant guest count the user entered
     */
    infantGuests: number;
    /**
     * the pet guest count the user entered
     */
    petGuests: number;
    [property: string]: any;
}

/**
 * [ACCOUNT CREATION] an anon successfully completed an account creation method (mobile,
 * email, social)
 */
export interface UserLeadCompletedAccountCreationMethod {
    /**
     * the authentication session ID
     */
    authId: string;
    /**
     * which account creation method was completed
     */
    creationMethod: OnMethod;
    /**
     * (Web only) If user entered from homepage, return homepage space type. If user signed up
     * in search and had a space type category selected, return that space type. If 'all space',
     * return pool. If user sign up up PDP or checkout, return the space type of the listing.
     * Otherwise return null
     */
    spaceType?: SpaceType;
    /**
     * Attributions that we capture from custom url query param
     */
    swimplyAttribution?: string;
    /**
     * id of the created user
     */
    userId: string;
    [property: string]: any;
}

/**
 * which account creation method was completed
 *
 * method used to attempt account sign in (mobile, email, etc)
 *
 * which account creation method was initiated
 */
export enum OnMethod {
    Apple = "apple",
    Email = "email",
    Facebook = "facebook",
    Google = "google",
    Mobile = "mobile",
    Social = "social",
}

/**
 * (Web only) If user entered from homepage, return homepage space type. If user signed up
 * in search and had a space type category selected, return that space type. If 'all space',
 * return pool. If user sign up up PDP or checkout, return the space type of the listing.
 * Otherwise return null
 */
export enum SpaceType {
    BasketballCourt = "basketballCourt",
    Home = "home",
    Other = "other",
    Pickleball = "pickleball",
    Pool = "pool",
    TennisCourt = "tennisCourt",
}

/**
 * [ACCOUNT CREATION] user lead entered email info
 */
export interface UserLeadEmail {
    /**
     * the authentication session ID
     */
    authId: string;
    /**
     * full user input email address
     */
    emailAddress: string;
    [property: string]: any;
}

/**
 * [ACCOUNT CREATION] user lead has existing account and is brought to sign on
 */
export interface UserLeadExistingAccount {
    /**
     * the authentication session ID
     */
    authId: string;
    /**
     * the user ID for the existing account
     */
    existingAccountID: number;
    /**
     * method used to attempt account sign in (mobile, email, etc)
     */
    signOnMethod: OnMethod;
    [property: string]: any;
}

/**
 * [ACCOUNT CREATION] user lead failed to log into existing account
 */
export interface UserLeadExistingAccountSignOnFailed {
    /**
     * the authentication session ID
     */
    authId: string;
    /**
     * why did the method fail (invalid password, wrong verificaiton, etc)
     */
    failureReason: string;
    /**
     * method used to attempt account sign in (mobile, email, etc)
     */
    signOnMethod: OnMethod;
    [property: string]: any;
}

/**
 * [ACCOUNT CREATION] user lead successfully signed onto existing account
 */
export interface UserLeadExistingAccountSignOnSuccess {
    /**
     * the authentication session ID
     */
    authId: string;
    /**
     * the user ID for the existing account
     */
    existingAccountID: string;
    /**
     * method used to attempt account sign in (mobile, email, etc)
     */
    signOnMethod: OnMethod;
    [property: string]: any;
}

/**
 * [ACCOUNT CREATION] user lead pressed forgot password after entering email address
 */
export interface UserLeadForgotPassword {
    /**
     * the authentication session ID
     */
    authId: string;
    [property: string]: any;
}

/**
 * [ACCOUNT CREATION] an anon chose a specific account creation method (mobile, email,
 * social)
 */
export interface UserLeadInitiatedAccountCreationMethod {
    /**
     * the authentication session ID
     */
    authId: string;
    /**
     * which account creation method was initiated
     */
    creationMethod: OnMethod;
    /**
     * How did we enter into the user creation flow?
     */
    enteredFrom: UserLeadInitiatedAccountCreationMethodEnteredFrom;
    [property: string]: any;
}

/**
 * How did we enter into the user creation flow?
 */
export enum UserLeadInitiatedAccountCreationMethodEnteredFrom {
    Auth = "auth",
    Booking = "booking",
    Chat = "chat",
    ClaimReferral = "claimReferral",
    ContactHost = "contactHost",
    EarnCredits = "earnCredits",
    EmailVerification = "emailVerification",
    EnterPromoCode = "enterPromoCode",
    FavoriteListing = "favoriteListing",
    HostOnboarding = "hostOnboarding",
    JoinWaitlist = "joinWaitlist",
    PaymentMethods = "paymentMethods",
    PopUp = "popUp",
    PostBookingInvite = "postBookingInvite",
    PurchasePass = "purchasePass",
    Review = "review",
    UnauthenticatedError = "unauthenticatedError",
    Unspecified = "unspecified",
}

/**
 * [ACCOUNT CREATION] information about the user lead phone number entered
 */
export interface UserLeadNumberEntered {
    /**
     * the authentication session ID
     */
    authId: string;
    /**
     * country code for user lead input phone number
     */
    countryCode: string;
    /**
     * user lead input phone number
     */
    mobileNumber: string;
    [property: string]: any;
}

/**
 * [ACCOUNT CREATION] Did the user lead resend the verification code
 */
export interface UserLeadNumberVerificationResend {
    /**
     * the authentication session ID
     */
    authId: string;
    [property: string]: any;
}

/**
 * [ACCOUNT CREATION] user successfully entered in mobile number verification
 */
export interface UserLeadNumberVerificationSuccess {
    /**
     * the authentication session ID
     */
    authId: string;
    [property: string]: any;
}

/**
 * [ACCOUNT CREATION] user came to phone number in use view
 */
export interface UserLeadPhoneNumberInUse {
    /**
     * the authentication session ID
     */
    authId: string;
    /**
     * the user ID for the existing account
     */
    exisingAccountID: string;
    [property: string]: any;
}

/**
 * [ACCOUNT CREATION] user edited number on phone number in use prompt
 */
export interface UserLeadPhoneNumberInUseEditNumber {
    /**
     * the authentication session ID
     */
    authId: string;
    /**
     * final edit for mobile number
     */
    newNumber: string;
    /**
     * original mobile number entered
     */
    originalNumber: string;
    [property: string]: any;
}

/**
 * [ACCOUNT CREATION] user selected the forgot password option
 */
export interface UserLeadSelectedForgotPasswordOption {
    /**
     * the authentication session ID
     */
    authId: string;
    /**
     * reset password or SMS login code
     */
    option: Option;
    [property: string]: any;
}

/**
 * reset password or SMS login code
 */
export enum Option {
    Reset = "reset",
    SMS = "sms",
}

/**
 * [ACCOUNT CREATION] user entered email in forgot password
 */
export interface UserLeadSubmittedForgotPasswordEmail {
    /**
     * the authentication session ID
     */
    authId: string;
    /**
     * the entered email address
     */
    email: string;
    [property: string]: any;
}

/**
 * [SEARCH] user scrolled down to load more in list view
 */
export interface UserLoadMore {
    /**
     * id of search which generated result
     */
    searchId: string;
    [property: string]: any;
}

/**
 * [GUEST FAVORITE] user moved map for favorite list
 */
export interface UserMovedFavoriteListMap {
    /**
     * the user id of the account who created the favorite collection
     */
    alphaUserId?: number;
    /**
     * an array of any favorite collection collaborator's user ids
     */
    betaUserIds?: any[];
    /**
     * the favorite collection id
     */
    favoriteCollectionId: number;
    /**
     * the name of the favorite collection
     */
    favoriteCollectionName: string;
    id?:                    string;
    /**
     * a boolean to identify whether the actions being taken to a favorite collection are being
     * done by the alpha user (1) or a beta user (0)
     */
    isAlphaUserId: boolean;
    [property: string]: any;
}

/**
 * [SEARCH] user move the map to a different map bounding box
 */
export interface UserMovedMap {
    /**
     * center point of the bounding box
     */
    centerPoint: UserMovedMapCenterPoint;
    /**
     * radius distance of the bounding box
     */
    distance: number;
    /**
     * id of search which generated result
     */
    searchId: null | string;
    [property: string]: any;
}

/**
 * center point of the bounding box
 */
export interface UserMovedMapCenterPoint {
    /**
     * latitude of the center point of the bounding box
     */
    latitude: number;
    /**
     * longitude of the center point of the bounding box
     */
    longitude: number;
    [property: string]: any;
}

/**
 * [POST BOOKING REVIEW] user prompted to leave review at app store
 */
export interface UserOfferedAppStoreReview {
    /**
     * id of the booking associated with the review
     */
    bookingId: number;
    /**
     * id of the listing being reviewed
     */
    listingId: number;
    [property: string]: any;
}

/**
 * [POST BOOKING REVIEW] user offered to book listing again post review
 */
export interface UserOfferedBookAgain {
    /**
     * id of the booking associated with the review
     */
    bookingId: number;
    /**
     * id of the listing being reviewed
     */
    listingId: number;
    /**
     * details for the multi dip offer if applicable
     */
    multiDipOffered?: MultiDIPOffered;
    /**
     * value of the rating submitted
     */
    ratingSubmittedValue: number;
    /**
     * details for the single dip offer if applicable
     */
    singleDipOffered: SingleDIPOffered;
    [property: string]: any;
}

/**
 * details for the multi dip offer if applicable
 */
export interface MultiDIPOffered {
    /**
     * currency of the price
     */
    currency?: string;
    /**
     * discount amount offered in percentage terms for multidip
     */
    discountOffered?: number;
    /**
     * is a multi dip rebook offered?
     */
    isMultiDipOffered?: boolean;
    /**
     * price offered for multi dip rebook
     */
    priceOfferedPerHour?: number;
    [property: string]: any;
}

/**
 * details for the single dip offer if applicable
 */
export interface SingleDIPOffered {
    /**
     * currency of the price
     */
    currency: string;
    /**
     * is a single dip rebook offered?
     */
    isSingleDipOffered: boolean;
    /**
     * price offered for single dip rebook
     */
    priceOfferedPerHour: number;
    [property: string]: any;
}

/**
 * [SEARCH] user opened calendar view from search date input
 */
export interface UserOpenedCalendarFromSearch {
    /**
     * id of search which generated result
     */
    searchId: null | string;
    [property: string]: any;
}

/**
 * [CHECKOUT] user selected to change payment method in checkout
 */
export interface UserOpenedPaymentMethodChangeFromCheckout {
    /**
     * id for the current checkout flow
     */
    checkoutId: string;
    /**
     * id of previous payment method if applicable
     */
    existingPaymentId?: string;
    /**
     * is the existing payment method apple pay
     */
    existingPaymentIsApplePay: boolean;
    /**
     * is the existing payment method google pay
     */
    existingPaymentIsGooglePay: boolean;
    /**
     * the id for the pool listing
     */
    listingId: string;
    /**
     * list of all payment ids in wallet
     */
    paymentIdsAvailable: any[];
    /**
     * id for the search that led to this listing
     */
    searchId: null | string;
    [property: string]: any;
}

/**
 * [PLP] user clicks into a 360 Tour
 */
export interface UserPressed360Tour {
    /**
     * how did the user end up on the 360 Tour
     */
    enteredFrom: UserPressed360TourEnteredFrom;
    /**
     * [LISTING TYPE] The type of the listing associated with this event
     */
    globalListingType: GlobalListingType;
    /**
     * id of the listing
     */
    listingId: string;
    [property: string]: any;
}

/**
 * how did the user end up on the 360 Tour
 */
export enum UserPressed360TourEnteredFrom {
    BookingInquiry = "bookingInquiry",
    PDP = "pdp",
    Photos = "photos",
}

/**
 * user pressed to exit the thread to go to reservation action
 */
export interface UserPressedActionCTAFromMessageThread {
    /**
     * the action CTA that they're addressing
     */
    action: null;
    /**
     * the booking shown when the user clicks to see the reservation on chat - logic defined by
     * Mojin in Chat Redesign PRD
     */
    bookingId:    number;
    bookingState: BookingState | null;
    /**
     * the guest for the booking
     */
    guestId: number;
    /**
     * the host for the booking
     */
    hostId: number;
    /**
     * the listing for the booking
     */
    listingId: number;
    /**
     * the room id for the chat
     */
    roomId: string;
    /**
     * is the current user the host (then 1) or are they the guest (then 0)
     */
    userIsHost: boolean;
    [property: string]: any;
}

export enum BookingState {
    Canceled = "canceled",
    Completed = "completed",
    Confirmed = "confirmed",
    Declined = "declined",
    Expired = "expired",
    Inquiry = "inquiry",
    Pending = "pending",
    SpecialOffer = "special_offer",
}

/**
 * [SEARCH] user pressed the ada filter in the filter menu
 */
export interface UserPressedAdaFilter {
    /**
     * DO NOT SEND: This is added as a workaround for this issue:
     * https://github.com/segmentio/typewriter/issues/284
     */
    fakeProperty?: null | string;
    [property: string]: any;
}

/**
 * [REFERRAL] user pressed add another friend in the email option
 */
export interface UserPressedAddAnotherFriendEmail {
    id?: string;
    [property: string]: any;
}

/**
 * [USER SUBSCRIPTION] User pressed the add me to waitlist button
 */
export interface UserPressedAddMeToWaitlist {
    /**
     * the search category subscribed by the user
     */
    category: UserPressedAddMeToWaitlistCategory;
    /**
     * the date searched by the user
     */
    date?: null | string;
    /**
     * the end hour searched by the user
     */
    endTime?: null | string;
    /**
     * true if waitlist button shown in the end of the search result
     */
    enteredFromEndOfSearchResult: boolean;
    /**
     * true if waitlist button shown in no search result
     */
    enteredFromNoSearchResult: boolean;
    /**
     * the address subscribed by the user
     */
    fullAddress?: string;
    /**
     * the start hour searched by the user
     */
    startTime: null | string;
    [property: string]: any;
}

/**
 * the search category subscribed by the user
 */
export enum UserPressedAddMeToWaitlistCategory {
    All = "All",
    Backyards = "Backyards",
    Boats = "Boats",
    Budget = "Budget",
    Discover = "Discover",
    Family = "Family",
    Heated = "Heated",
    Home = "Home",
    Homes = "Homes",
    Hoops = "Hoops",
    HotTubs = "Hot Tubs",
    Indoors = "Indoors",
    Paddle = "Paddle",
    Parties = "Parties",
    Pets = "Pets",
    Pickleball = "Pickleball",
    Pool = "Pool",
    Pools = "Pools",
    Racquet = "Racquet",
    Vip = "Vip",
}

/**
 * [CHECKOUT] user entered screen to add payment, either from checkout or wallet
 */
export interface UserPressedAddPaymentMethod {
    /**
     * id for the current checkout flow
     */
    checkoutId: string;
    /**
     * where did the user enter this option from
     */
    enteredFrom: string;
    /**
     * the id for the pool listing
     */
    listingId: string;
    /**
     * id for the search that led to this listing
     */
    searchId: null | string;
    [property: string]: any;
}

/**
 * [CHECKOUT] user opened promo code entry option
 */
export interface UserPressedAddPromoCode {
    /**
     * id for the current checkout flow
     */
    checkoutId: string;
    /**
     * the id for the pool listing
     */
    listingId: string;
    /**
     * id for the search that led to this listing
     */
    searchId: null | string;
    [property: string]: any;
}

/**
 * [ACCOUNT CREATION] user pressed add my zip code instead
 */
export interface UserPressedAddZipCode {
    /**
     * the authentication session ID
     */
    authId: string;
    [property: string]: any;
}

/**
 * [CHECKOUT] user pressed agree terms and condition checkbox
 */
export interface UserPressedAgreeTermsAndCondition {
    /**
     * id for the current checkout flow
     */
    checkoutId: string;
    /**
     * the id for the pool listing
     */
    listingId: string;
    /**
     * id for the search that led to this listing
     */
    searchId: null | string;
    [property: string]: any;
}

/**
 * [POST BOOKING REVIEW] user pressed to leave review at app store
 */
export interface UserPressedAppStoreReview {
    /**
     * id of the booking associated with the review
     */
    bookingId: number;
    /**
     * id of the listing being reviewed
     */
    listingId: number;
    [property: string]: any;
}

/**
 * [PLP] user clicks on one of the badges on the PLP - bringing up the  badge info card
 */
export interface UserPressedBadgeInfoCard {
    /**
     * [LISTING TYPE] The type of the listing associated with this event
     */
    globalListingType: GlobalListingType;
    /**
     * does the listing currently have the Fan Favorite Badge
     */
    isFanFavorite: boolean;
    /**
     * does the listing currently have the Top Swimply Badge
     */
    isTopSwimply: boolean;
    /**
     * id of the listing
     */
    listingId: string;
    [property: string]: any;
}

/**
 * [SEARCH RESULT BANNER] User pressed on the banner in the search result
 */
export interface UserPressedBanner {
    /**
     * the displayed text on the search banner
     */
    bannerText: string;
    /**
     * the searchId associated with this search when user pressed the banner
     */
    searchId: string;
    [property: string]: any;
}

/**
 * [POST BOOKING REVIEW] user offered to book listing again post review
 */
export interface UserPressedBookAgainOption {
    /**
     * id of the booking associated with the review
     */
    bookingId: number;
    /**
     * id of the listing being reviewed
     */
    listingId: number;
    /**
     * details for the multi dip offer if applicable
     */
    multiDipDetails?: UserPressedBookAgainOptionMultiDIPDetails;
    /**
     * value of the rating submitted
     */
    ratingSubmittedValue: number;
    /**
     * details for the single dip offer if applicable
     */
    singleDipDetails: UserPressedBookAgainOptionSingleDIPDetails;
    [property: string]: any;
}

/**
 * details for the multi dip offer if applicable
 */
export interface UserPressedBookAgainOptionMultiDIPDetails {
    /**
     * currency of the price
     */
    currency?: string;
    /**
     * discount amount offered in percentage terms for multidip
     */
    discountOffered?: number;
    /**
     * did user select multi dip
     */
    isMultiDipPressed?: boolean;
    /**
     * price offered for multi dip rebook
     */
    priceOfferedPerHour?: number;
    [property: string]: any;
}

/**
 * details for the single dip offer if applicable
 */
export interface UserPressedBookAgainOptionSingleDIPDetails {
    /**
     * currency of the price
     */
    currency: string;
    /**
     * did user select single dip
     */
    isSingleDipPressed: boolean;
    /**
     * price offered for single dip rebook
     */
    priceOfferedPerHour: number;
    [property: string]: any;
}

/**
 * [CHECKOUT] after a user purchases a pass and presses the modal to start or finish booking
 */
export interface UserPressedBookPostPassPurchase {
    /**
     * the url for the cover image of the listing the pass is for
     */
    coverImageURL: string;
    /**
     * first name of the host
     */
    hostFirstName: string;
    /**
     * true if the user just bought their pass via upsell, and are shown "finish booking", false
     * if not and they're shown "start booking"
     */
    isFromUpsell: boolean;
    /**
     * id of the listing the pass is for
     */
    listingId: string;
    /**
     * the title of the listing the pass is for
     */
    listingTitle: string;
    /**
     * the url of the listing the pass is for
     */
    listingURL: string;
    /**
     * [{from:”07:00:00”, “11:00:00”}...] Time slots when this pass is eligible
     */
    passAvailableTimes?: any[];
    /**
     * LCM formatted version of available times property
     */
    passAvailableTimesText?: string;
    /**
     * list of blackout dates (e.g. July 4, 2024).
     */
    passBlackoutDays?: any[] | null;
    /**
     * when the pass was created
     */
    passCreatedAt: string;
    /**
     * currency for all monetary fields
     */
    passCurrencyCode: string;
    /**
     * flag indicating that this is the current version for a pass. For a type/name/listing_id,
     * there can only be one record with this attribute true.
     */
    passCurrent: boolean;
    /**
     * free text description set by host
     */
    passDescription?: null | string;
    /**
     * discount amount. Fixed discounts will be in minors units.
     */
    passDiscount: number | null;
    /**
     * type of pass discount num[‘percentage’, ‘fixed’]
     */
    passDiscountType: PassDiscountType | null;
    /**
     * days the pass is eligible
     */
    passEligibleDays?: any[] | null;
    /**
     * id of the pass
     */
    passId: number;
    /**
     * max active passes allowed. This constraint will apply to the (listing_id, type, name)
     * rather than id so that we can be accurate across edits.
     */
    passMaxActivePasses?: number | null;
    /**
     * max bookings allowed under this pass
     */
    passMaxDailyBookings?: number | null;
    /**
     * max duration that may be booked using this pass
     */
    passMaxDuration?: number | null;
    /**
     * max guests that may be booked using this pass
     */
    passMaxGuests?: number | null;
    /**
     * the type of the pass formatted to be LCM friendly
     */
    passName: string;
    /**
     * the ids of all premium amenities included with the pass
     */
    passPremiumAmenities?: any[] | null;
    /**
     * pass price in minor units
     */
    passPrice: string;
    /**
     * ‘draft’ -> pass is being actively edited by the host via the creation flow. The step
     * attribute below tracks the progress of the host through the creation flow.
     * ‘inactive’ -> pass has been created by the host, but not ready for sale yet
     * ‘active’ -> pass has passed the final availability requirements and has been marked by
     * the host as ready for sale.
     */
    passState: PassState;
    /**
     * the pass of the price plus the service fee
     */
    passTotalPrice: string;
    /**
     * the type of pass
     */
    passType: GuestPassPurchaseFailurePassType;
    [property: string]: any;
}

/**
 * [MESSAGING - PHOTOS] after selecting a photo, the user pressed "cancel" or exited out
 */
export interface UserPressedCancelSendPicture {
    /**
     * the booking shown when the user clicks to see the reservation on chat - logic defined by
     * Mojin in Chat Redesign PRD
     */
    bookingId: number;
    /**
     * the guest for the booking
     */
    guestId: number;
    /**
     * the host for the booking
     */
    hostId: number;
    id?:    string;
    /**
     * the listing for the booking
     */
    listingId: number;
    /**
     * the room id for the chat
     */
    roomId: string;
    [property: string]: any;
}

/**
 * [WEB HOMEPAGE] Phase 2 User pressed any of the category inspiration
 */
export interface UserPressedCategoryInspiration {
    /**
     * the name of the category
     */
    categoryName: string;
    [property: string]: any;
}

/**
 * [SEARCH] user pressed any of the tabs on the category bar
 */
export interface UserPressedCategoryTab {
    /**
     * True if the user is in list view, false if in map view
     */
    isListView: boolean;
    /**
     * name of the category tab
     */
    tabName: string;
    [property: string]: any;
}

/**
 * [USER PROFILE - Account Details] user pressed to change their phone number
 */
export interface UserPressedChangePhoneNumber {
    id?: string;
    [property: string]: any;
}

/**
 * [CLAIM REFERRAL] User pressed the claim referral button on the bottom of the referral page
 */
export interface UserPressedClaimReferralButtonBottom {
    /**
     * The text of the claim referral button
     */
    claimReferralButtonText: string;
    /**
     * the referral id of the invite
     */
    referralId: string;
    /**
     * Type of the referral, host or guest
     */
    referralType: string;
    [property: string]: any;
}

/**
 * [CLAIM REFERRAL] When the referee (beta guest) presses the claim referral button on
 * EITHER the top or bottom of the referral page WITH the userId as the Alpha User (or
 * referrer)
 */
export interface UserPressedClaimReferralButtonReferrerTracking {
    /**
     * The text of the claim referral button
     */
    claimReferralButtonText: string;
    /**
     * the id of the referee (the user signed in taking the action)
     */
    refereeId?: string;
    /**
     * the referral id of the invite
     */
    referralId: string;
    /**
     * Type of the referral, host or guest
     */
    referralType: string;
    /**
     * the user id of the user who sent the original invite
     */
    referrerId?: string;
    [property: string]: any;
}

/**
 * [CLAIM REFERRAL] User pressed the claim referral button on the top of the referral page
 */
export interface UserPressedClaimReferralButtonTop {
    /**
     * The text of the claim referral button
     */
    claimReferralButtonText: string;
    /**
     * the referral id of the invite
     */
    referralId: string;
    /**
     * Type of the referral, host or guest
     */
    referralType: string;
    [property: string]: any;
}

/**
 * [USER PROFILE - Account Verification] user pressed the complete verification button from
 * their profile
 */
export interface UserPressedCompleteProfileVerification {
    enteredFrom?: UserPressedCompleteProfileVerificationEnteredFrom;
    id?:          string;
    [property: string]: any;
}

export enum UserPressedCompleteProfileVerificationEnteredFrom {
    AccountSettings = "account_settings",
    UnderageBooking = "underage_booking",
    UnderageContactHost = "underage_contact_host",
    UnderagePassPurchase = "underage_pass_purchase",
}

/**
 * [CHECKOUT] when a user presses to purchase a pass
 */
export interface UserPressedConfirmPurchasePass {
    /**
     * the url for the cover image of the listing the pass is for
     */
    coverImageURL: string;
    /**
     * first name of the host
     */
    hostFirstName: string;
    id?:           string;
    /**
     * id of the listing the pass is for
     */
    listingId: string;
    /**
     * the title of the listing the pass is for
     */
    listingTitle: string;
    /**
     * the url of the listing the pass is for
     */
    listingURL: string;
    /**
     * [{from:”07:00:00”, “11:00:00”}...] Time slots when this pass is eligible
     */
    passAvailableTimes?: any[];
    /**
     * LCM formatted version of available times property
     */
    passAvailableTimesText?: string;
    /**
     * list of blackout dates (e.g. July 4, 2024).
     */
    passBlackoutDays?: any[] | null;
    /**
     * when the pass was created
     */
    passCreatedAt: string;
    /**
     * currency for all monetary fields
     */
    passCurrencyCode: string;
    /**
     * flag indicating that this is the current version for a pass. For a type/name/listing_id,
     * there can only be one record with this attribute true.
     */
    passCurrent: boolean;
    /**
     * free text description set by host
     */
    passDescription?: null | string;
    /**
     * discount amount. Fixed discounts will be in minors units.
     */
    passDiscount: number | null;
    /**
     * type of pass discount num[‘percentage’, ‘fixed’]
     */
    passDiscountType: PassDiscountType | null;
    /**
     * days the pass is eligible
     */
    passEligibleDays?: any[] | null;
    /**
     * id of the pass
     */
    passId: number;
    /**
     * max active passes allowed. This constraint will apply to the (listing_id, type, name)
     * rather than id so that we can be accurate across edits.
     */
    passMaxActivePasses?: number | null;
    /**
     * max bookings allowed under this pass
     */
    passMaxDailyBookings?: number | null;
    /**
     * max duration that may be booked using this pass
     */
    passMaxDuration?: number | null;
    /**
     * max guests that may be booked using this pass
     */
    passMaxGuests?: number | null;
    /**
     * the type of the pass formatted to be LCM friendly
     */
    passName: string;
    /**
     * the ids of all premium amenities included with the pass
     */
    passPremiumAmenities?: any[] | null;
    /**
     * pass price in minor units
     */
    passPrice: string;
    /**
     * ‘draft’ -> pass is being actively edited by the host via the creation flow. The step
     * attribute below tracks the progress of the host through the creation flow.
     * ‘inactive’ -> pass has been created by the host, but not ready for sale yet
     * ‘active’ -> pass has passed the final availability requirements and has been marked by
     * the host as ready for sale.
     */
    passState: PassState;
    /**
     * the pass of the price plus the service fee
     */
    passTotalPrice: string;
    /**
     * the type of pass
     */
    passType: GuestPassPurchaseFailurePassType;
    /**
     * If the guest is shown an expiring discount towards the pass purchase, how much is it for
     * (null if it's expired or not sh...
     */
    passUpsellCreditAmountOffer?: number | null;
    [property: string]: any;
}

/**
 * [PLP] user pressed to contact host from PLP
 */
export interface UserPressedContactHost {
    /**
     * checkoutId created for subsequent time, user, and reason events
     */
    checkoutId: string;
    /**
     * id of the listing
     */
    listingId: string;
    /**
     * search they entered the listing from, if applicable
     */
    searchId: null | string;
    [property: string]: any;
}

/**
 * [POST BOOKING REVIEW] user pressed to continue with the rebook option for rebook screen
 */
export interface UserPressedContinueRebookScreen {
    /**
     * id of the booking associated with the review
     */
    bookingId: number;
    /**
     * id of the checkout flow initiated by continuing to book
     */
    checkoutId: string;
    /**
     * id of the listing being reviewed
     */
    listingId: number;
    /**
     * the hourly price shown in the rebook screen
     */
    price: number;
    /**
     * the type of pricing structure - hourly or daily
     */
    priceType: ListListingImpressionAISearchPriceType;
    /**
     * the rating shown in the rebook screen
     */
    rating: number;
    [property: string]: any;
}

/**
 * [GUEST FAVORITE INVITE] user pressed share invite Favorites List link
 */
export interface UserPressedCopyFLInviteLink {
    id?: string;
    [property: string]: any;
}

/**
 * [REFERRAL] user selected "copy invite link" option
 */
export interface UserPressedCopyInviteLink {
    id?: string;
    [property: string]: any;
}

/**
 * [COZYMEAL] User pressed "book now" to add catering thus directing them to the Cozymeal
 * selections page
 */
export interface UserPressedCozymealBookingAdditions {
    bookingId?: number;
    guestId:    number;
    hostId:     number;
    id?:        string;
    listingId:  number;
    [property: string]: any;
}

/**
 * [COZYMEAL] User pressed a specific Cozymeal catering option
 */
export interface UserPressedCozymealListing {
    bookingId?:        number;
    cozyMealListingId: number;
    guestId:           number;
    hostId:            number;
    id?:               string;
    listingId:         number;
    [property: string]: any;
}

/**
 * [COZYMEAL] User pressed a filter on the Cozymeal catering options page
 */
export interface UserPressedCozymealOptionsFilter {
    bookingId?: number;
    filter:     Filter;
    guestId:    number;
    hostId:     number;
    id?:        string;
    listingId:  number;
    [property: string]: any;
}

export enum Filter {
    All = "all",
    Drinks = "drinks",
    Food = "food",
}

/**
 * [COZYMEAL] User pressed to see the menu of a specific Cozymeal catering option
 */
export interface UserPressedCozymealSeeMenu {
    bookingId?:        number;
    cozyMealListingId: number;
    guestId:           number;
    hostId:            number;
    id?:               string;
    listingId:         number;
    [property: string]: any;
}

/**
 * [POLL] When user pressed the create poll button from the favorite list
 */
export interface UserPressedCreatePoll {
    /**
     * id associated with this favorite list (collection id in backend)
     */
    favoriteListId: number;
    /**
     * name of the favorite list
     */
    favoriteListName: string;
    /**
     * number of listing in this list when user create the poll
     */
    numberOfListing: number;
    [property: string]: any;
}

/**
 * [USER PROFILE - Account Details] user pressed to delete their account
 */
export interface UserPressedDeleteAccount {
    id?: string;
    [property: string]: any;
}

/**
 * [GUEST FAVORITE] user pressed "delete this list"
 */
export interface UserPressedDeleteFavoriteList {
    /**
     * the user id of the account who created the favorite collection
     */
    alphaUserId?: number;
    /**
     * an array of any favorite collection collaborator's user ids
     */
    betaUserIds?: any[];
    /**
     * the favorite collection id
     */
    favoriteCollectionId: number;
    /**
     * the name of the favorite collection
     */
    favoriteCollectionName: string;
    id?:                    string;
    /**
     * a boolean to identify whether the actions being taken to a favorite collection are being
     * done by the alpha user (1) or a beta user (0)
     */
    isAlphaUserId: boolean;
    [property: string]: any;
}

/**
 * [ACCOUNT DELETION] User pressed the Delete my account option in the profile screen
 */
export interface UserPressedDeleteMyAccount {
    id?: string;
    [property: string]: any;
}

/**
 * [USER PROFILE - ACCOUNT SETTINGS: NOTIFICATIONS]
 */
export interface UserPressedDisableEmailNotifications {
    id?: string;
    [property: string]: any;
}

/**
 * [USER PROFILE - ACCOUNT SETTINGS: NOTIFICATIONS]
 */
export interface UserPressedDisableMarketingSMSNotifications {
    id?: string;
    [property: string]: any;
}

/**
 * [USER PROFILE - ACCOUNT SETTINGS: NOTIFICATIONS]
 */
export interface UserPressedDisableTransactionalSMSNotifications {
    id?: string;
    [property: string]: any;
}

/**
 * [SEARCH] user pressed the "Display price with fees" drip pricing toggle
 */
export interface UserPressedDisplayPriceWithFeesToggle {
    id?: string;
    /**
     * true when the toggle is activated and prices shown include fees
     */
    isPriceShownWithFeesOn: boolean;
    [property: string]: any;
}

/**
 * [MESSAGING - CALLING] user pressed NOT to enable notifications after attempting to call
 * via chat
 */
export interface UserPressedDontEnableNotificationsFromStartCall {
    /**
     * the booking shown when the user clicks to see the reservation on chat - logic defined by
     * Mojin in Chat Redesign PRD
     */
    bookingId: number;
    callType:  CallType;
    /**
     * the guest for the booking
     */
    guestId: number;
    /**
     * the host for the booking
     */
    hostId: number;
    id?:    string;
    /**
     * the listing for the booking
     */
    listingId: number;
    /**
     * the room id for the chat
     */
    roomId:     string;
    userIsHost: boolean;
    [property: string]: any;
}

export enum CallType {
    Video = "video",
    Voice = "voice",
}

/**
 * [CHECKOUT] on checkout confirmation screen if user edited date
 */
export interface UserPressedEditDateOnCheckoutConfirmation {
    /**
     * id for the current checkout flow
     */
    checkoutId: string;
    /**
     * the id for the pool listing
     */
    listingId: string;
    /**
     * original date for booking prior to editing
     */
    originalDate?: string;
    /**
     * original end time for booking prior to edit
     */
    originalEndTime: number;
    /**
     * original start time for booking prior to edit
     */
    originalStartTime: number;
    /**
     * id for the search that led to this listing
     */
    searchId: null | string;
    [property: string]: any;
}

/**
 * [CHECKOUT] on checkout confirmation screen if user edited guest
 */
export interface UserPressedEditGuestsOnCheckoutConfirmation {
    /**
     * id for the current checkout flow
     */
    checkoutId: string;
    /**
     * the id for the pool listing
     */
    listingId: string;
    /**
     * original number of adults
     */
    originalAdults: number;
    /**
     * original number of children
     */
    originalChildren: number;
    /**
     * original number of infants
     */
    originalInfants: number;
    /**
     * original number of pets
     */
    originalPets: number;
    /**
     * original number of guests
     */
    originalTotalGuests: number;
    /**
     * id for the search that led to this listing
     */
    searchId: null | string;
    [property: string]: any;
}

/**
 * [CHECKOUT] on checkout confirmation screen if user edited reason for booking
 */
export interface UserPressedEditReasonForBooking {
    /**
     * id for the current checkout flow
     */
    checkoutId: string;
    /**
     * the id for the pool listing
     */
    listingId: string;
    /**
     * original reason for booking
     */
    originalReason: string;
    /**
     * id for the search that led to this listing
     */
    searchId: null | string;
    [property: string]: any;
}

/**
 * [USER PROFILE - ACCOUNT SETTINGS: NOTIFICATIONS]
 */
export interface UserPressedEnableEmailNotifications {
    id?: string;
    [property: string]: any;
}

/**
 * [USER PROFILE - ACCOUNT SETTINGS: NOTIFICATIONS]
 */
export interface UserPressedEnableMarketingSMSNotifications {
    id?: string;
    [property: string]: any;
}

/**
 * [MESSAGING - CALLING] user pressed to enable notifications after attempting to call via
 * chat
 */
export interface UserPressedEnableNotificationsFromStartCall {
    /**
     * the booking shown when the user clicks to see the reservation on chat - logic defined by
     * Mojin in Chat Redesign PRD
     */
    bookingId: number;
    callType:  CallType;
    /**
     * the guest for the booking
     */
    guestId: number;
    /**
     * the host for the booking
     */
    hostId: number;
    id?:    string;
    /**
     * the listing for the booking
     */
    listingId: number;
    /**
     * the room id for the chat
     */
    roomId:     string;
    userIsHost: boolean;
    [property: string]: any;
}

/**
 * [USER PROFILE - ACCOUNT SETTINGS: NOTIFICATIONS]
 */
export interface UserPressedEnableTransactionalSMSNotifications {
    id?: string;
    [property: string]: any;
}

/**
 * [CHECKOUT] user pressed pass upsell button “Get a Pass”
 */
export interface UserPressedEnterPassUpsell {
    id?: string;
    /**
     * id of the listing the pass is for
     */
    listingId: string;
    /**
     * id of the pass
     */
    passId: number;
    /**
     * pass price in minor units
     */
    passPrice: string;
    /**
     * the type of pass
     */
    passType: GuestAcceptReviewChangesFromHostPassType;
    [property: string]: any;
}

/**
 * [MESSAGING - PHOTOS] from chat, when the user presses the small photo icon
 */
export interface UserPressedEnterSendPicture {
    /**
     * the booking shown when the user clicks to see the reservation on chat - logic defined by
     * Mojin in Chat Redesign PRD
     */
    bookingId: number;
    /**
     * the guest for the booking
     */
    guestId: number;
    /**
     * the host for the booking
     */
    hostId: number;
    id?:    string;
    /**
     * the listing for the booking
     */
    listingId: number;
    /**
     * the room id for the chat
     */
    roomId: string;
    [property: string]: any;
}

/**
 * [MESSAGING - CALLING] from chat, when the user presses the small call icon
 */
export interface UserPressedEnterStartCall {
    /**
     * the booking shown when the user clicks to see the reservation on chat - logic defined by
     * Mojin in Chat Redesign PRD
     */
    bookingId: number;
    /**
     * the guest for the booking
     */
    guestId: number;
    /**
     * the host for the booking
     */
    hostId: number;
    id?:    string;
    /**
     * the listing for the booking
     */
    listingId: number;
    /**
     * the room id for the chat
     */
    roomId: string;
    [property: string]: any;
}

/**
 * [GUEST FAVORITE INVITE] user pressed send an email to share Favorites List link
 */
export interface UserPressedFLInviteFriendsViaEmail {
    /**
     * the user id of the account who created the favorite collection
     */
    alphaUserId?: number;
    /**
     * an array of any favorite collection collaborator's user ids
     */
    betaUserIds?: any[];
    /**
     * the favorite collection id
     */
    favoriteCollectionId: number;
    /**
     * the name of the favorite collection
     */
    favoriteCollectionName: string;
    id?:                    string;
    /**
     * a boolean to identify whether the actions being taken to a favorite collection are being
     * done by the alpha user (1) or a beta user (0)
     */
    isAlphaUserId: boolean;
    [property: string]: any;
}

/**
 * [GUEST FAVORITE INVITE] user pressed send a text to share Friends List link
 */
export interface UserPressedFLInviteFriendsViaText {
    /**
     * the user id of the account who created the favorite collection
     */
    alphaUserId?: number;
    /**
     * an array of any favorite collection collaborator's user ids
     */
    betaUserIds?: any[];
    /**
     * the favorite collection id
     */
    favoriteCollectionId: number;
    /**
     * the name of the favorite collection
     */
    favoriteCollectionName: string;
    id?:                    string;
    /**
     * a boolean to identify whether the actions being taken to a favorite collection are being
     * done by the alpha user (1) or a beta user (0)
     */
    isAlphaUserId: boolean;
    [property: string]: any;
}

/**
 * [GUEST FAVORITE] user pressed to view favorite collection listings in map view
 */
export interface UserPressedFavoriteListMapView {
    /**
     * the user id of the account who created the favorite collection
     */
    alphaUserId?: number;
    /**
     * an array of any favorite collection collaborator's user ids
     */
    betaUserIds?: any[];
    /**
     * the favorite collection id
     */
    favoriteCollectionId: number;
    /**
     * the name of the favorite collection
     */
    favoriteCollectionName: string;
    id?:                    string;
    /**
     * a boolean to identify whether the actions being taken to a favorite collection are being
     * done by the alpha user (1) or a beta user (0)
     */
    isAlphaUserId: boolean;
    [property: string]: any;
}

/**
 * [SEARCH] user pressed the heart icon to favorite a listing in the list view
 */
export interface UserPressedFavoriteListing {
    /**
     * displayed badge name
     */
    badgeName: null | string;
    /**
     * [LISTING TYPE] The type of the listing associated with this event
     */
    globalListingType: GlobalListingType;
    /**
     * whether the listings has passes available (1 if true, 0 if false)
     */
    hasPass: boolean;
    /**
     * True if the user search in list view, false if floating card in map view
     */
    isListView: boolean;
    /**
     * id of the listing
     */
    listingId: string;
    /**
     * order in search list (only if isListView is True, null otherwise)
     */
    orderInSearchResults?: number;
    /**
     * if the listing has one or more active passes, list the pass ids in an array
     */
    passIds?: any[] | null;
    /**
     * the types of passes available for a listing - null if it doesn't have any
     */
    passTypes: any[] | null;
    /**
     * the price displayed
     */
    price: number;
    /**
     * the displayed price type
     */
    priceType: PriceType;
    /**
     * photo id of the first photo displayed for the listing
     */
    primaryPhotoId?: null | string;
    /**
     * rating displayed
     */
    rating: number | null;
    /**
     * total amount of ratings displayed
     */
    ratingsVolume: number | null;
    /**
     * id of search which generated result
     */
    searchId: null | string;
    [property: string]: any;
}

/**
 * [CLAIM REFERRAL] User pressed the find pools near me button
 */
export interface UserPressedFindPoolsNearMe {
    categoryName?: string;
    id?:           string;
    [property: string]: any;
}

/**
 * [SEARCH] user pressed full screen list view to minimize map
 */
export interface UserPressedFullScreeenListView {
    /**
     * id of search which generated result
     */
    searchId: null | string;
    [property: string]: any;
}

/**
 * [SEARCH] user pressed full screen list view to minimize map
 */
export interface UserPressedFullScreenListView {
    /**
     * id of search which generated result
     */
    searchId: null | string;
    [property: string]: any;
}

export interface UserPressedGoPuffAd {
    bookingId?: number;
    source?:    Source;
    [property: string]: any;
}

export enum Source {
    Booking = "booking",
    Default = "default",
}

/**
 * [WEB HOMEPAGE] User pressed to download app on homepage
 */
export interface UserPressedHomepageDownloadApp {
    /**
     * button for download at App store or Google play
     */
    downloadAt: DownloadAt;
    /**
     * Type of the listings
     */
    listingType: ListingTypeEnum;
    [property: string]: any;
}

/**
 * button for download at App store or Google play
 */
export enum DownloadAt {
    AppStore = "App store",
    GooglePlay = "Google play",
}

/**
 * Type of the listings
 */
export enum ListingTypeEnum {
    BasketballCourt = "basketballCourt",
    Home = "home",
    Pickleball = "pickleball",
    Pool = "pool",
    TennisCourt = "tennisCourt",
}

/**
 * [WEB HOMEPAGE] Phase 2 User pressed the swimply experience
 */
export interface UserPressedHomepageExperience {
    /**
     * the experience tag in the thumbnail
     */
    experienceName: ExperienceName;
    [property: string]: any;
}

/**
 * the experience tag in the thumbnail
 */
export enum ExperienceName {
    All = "All",
    Backyards = "Backyards",
    Budget = "Budget",
    Family = "Family",
    Heated = "Heated",
    Hoop = "Hoop",
    HotTubs = "Hot Tubs",
    Indoors = "Indoors",
    Paddle = "Paddle",
    Parties = "Parties",
    Pets = "Pets",
    Racquet = "Racquet",
    Vip = "Vip",
}

/**
 * [WEB HOMEPAGE UPDATED]
 */
export interface UserPressedHomepageListing {
    /**
     * [LISTING TYPE] The type of the listing associated with this event
     */
    globalListingType: GlobalListingType;
    /**
     * which section of the homepage was the listing selected from
     */
    homepageCategorySection: HomepageCategorySection;
    listingId:               string;
    [property: string]: any;
}

/**
 * which section of the homepage was the listing selected from
 */
export enum HomepageCategorySection {
    Deals = "deals",
    Everything = "everything",
    Passes = "passes",
}

/**
 * [WEB HOMEPAGE] User pressed listing type in homepage
 */
export interface UserPressedHomepageListingType {
    /**
     * Type of the listings
     */
    listingType: ListingTypeEnum;
    [property: string]: any;
}

/**
 * [GUEST PASS DISCOVERY] when a user selects a different pass type
 */
export interface UserPressedHomepagePassType {
    id?:      string;
    passType: GuestAcceptReviewChangesFromHostPassType;
    [property: string]: any;
}

/**
 * [GUEST PASS DISCOVERY]
 */
export interface UserPressedHomepagePassesLearnMore {
    id?: string;
    [property: string]: any;
}

/**
 * [WEB HOMEPAGE - REFERRALS] user pressed refer a friend referral banner
 */
export interface UserPressedHomepageReferralBanner {
    id?: string;
    /**
     * the user's total credit amount - can be null if they have none
     */
    totalCredits?: number | null;
    [property: string]: any;
}

/**
 * [GUEST PASS DISCOVERY]
 */
export interface UserPressedHomepageSeeAllPassListings {
    id?: string;
    /**
     * the pass type selected when a user selects to see all listings with that pass
     */
    passType: GuestAcceptReviewChangesFromHostPassType;
    [property: string]: any;
}

/**
 * [WEB HOMEPAGE] Phase 2 User pressed social from the homepage
 */
export interface UserPressedHomepageSocial {
    /**
     * Type of the listings
     */
    listingType: ListingTypeEnum;
    /**
     * the id of the thumbnail of the social
     */
    thumbnailId: string;
    /**
     * the order of the thumbnail (most left thumbnail as 0, most right thumbnail as 5)
     */
    thumbnailOrder: number;
    [property: string]: any;
}

/**
 * user pressed on the host guarantee link from a circumvention autowarning message
 */
export interface UserPressedHostGuaranteeFromMessages {
    /**
     * DO NOT SEND: This is added as a workaround for this issue:
     * https://github.com/segmentio/typewriter/issues/284
     */
    id?: string;
    [property: string]: any;
}

/**
 * [CHECKOUT] on checkout confirmation screen if user opened host rules
 */
export interface UserPressedHostRulesCheckoutConfirmation {
    /**
     * id for the current checkout flow
     */
    checkoutId: string;
    /**
     * the id for the pool listing
     */
    listingId: string;
    /**
     * text blurb of rules
     */
    rulesBlurb: string;
    /**
     * listed preset rules
     */
    rulesListed: any[];
    /**
     * id for the search that led to this listing
     */
    searchId: null | string;
    [property: string]: any;
}

/**
 * [WEB HOMEPAGE] User pressed how does Swimply works
 */
export interface UserPressedHowDoesSwimplyWork {
    /**
     * Type of the listings
     */
    listingType: ListingTypeEnum;
    /**
     * guest if user pressed "for swimmer/ player", host if user pressed "for pool/ court owner"
     */
    userType: UserType;
    [property: string]: any;
}

/**
 * guest if user pressed "for swimmer/ player", host if user pressed "for pool/ court owner"
 */
export enum UserType {
    Guest = "guest",
    Host = "host",
}

/**
 * [GUEST FAVORITE INVITE] user pressed "invite my friends" or "invite and manage friends"
 * button (copy will depend on if they've already invited someone)
 */
export interface UserPressedInviteAndManageFriendsToFL {
    /**
     * the user id of the account who created the favorite collection
     */
    alphaUserId?: number;
    /**
     * an array of any favorite collection collaborator's user ids
     */
    betaUserIds?: any[];
    /**
     * the favorite collection id
     */
    favoriteCollectionId: number;
    /**
     * the name of the favorite collection
     */
    favoriteCollectionName: string;
    id?:                    string;
    /**
     * a boolean to identify whether the actions being taken to a favorite collection are being
     * done by the alpha user (1) or a beta user (0)
     */
    isAlphaUserId: boolean;
    [property: string]: any;
}

/**
 * [REFERRAL] user pressed the invite button on the task bar (the menu bar on the bottom in
 * the app)
 */
export interface UserPressedInviteButtonTaskBar {
    /**
     * credit balance on the right top corner
     */
    displayedCreditBalance: DisplayedCreditBalance;
    /**
     * number of joined host on the "x hosts joined" button
     */
    displayedNumberJoinedHost: number;
    /**
     * number of joined swimmer on the "x friends(guests) joined" button
     */
    displayedNumberJoinedSwimmer: number;
    /**
     * previous page before user enter the screen
     */
    enteredFrom: string;
    /**
     * boolean indicator if the screen is a view for guest, 1 if it is for guests, 0 if it is
     * for hosts
     */
    isGuestView: boolean;
    /**
     * the referral offer shown on the text in the screen
     */
    referralOfferedAmount: UserPressedInviteButtonTaskBarReferralOfferedAmount;
    /**
     * the text of the term for inviting friends or guests (swimmer)
     */
    termBlurbInviteFriends: string;
    /**
     * the text of the term for inviting hosts
     */
    termBlurbInviteHost: string;
    [property: string]: any;
}

/**
 * credit balance on the right top corner
 */
export interface DisplayedCreditBalance {
    /**
     * the amount of the balance
     */
    balanceAmount: number;
    /**
     * the currency of the balance amount
     */
    balanceCurrency: string;
    /**
     * the type of balance amount in cash or credit
     */
    balanceType: string;
    [property: string]: any;
}

/**
 * the referral offer shown on the text in the screen
 */
export interface UserPressedInviteButtonTaskBarReferralOfferedAmount {
    /**
     * the reward amount for the referee (the friend or host accepted the invite)
     */
    givingAmount: number;
    /**
     * the currency of the the reward amount for the referee
     */
    givingAmountCurrency: string;
    /**
     * the reward amount for the referrer (the user who invited friends or hosts)
     */
    receivingAmount: number;
    /**
     * the currency of the reward amount for the referrer
     */
    receivingAmountCurrency: string;
    /**
     * referring a host or a guest
     */
    referralType: string;
    /**
     * The type of the reward in cash or credit
     */
    rewardType: string;
    [property: string]: any;
}

/**
 * [REFERRAL] user pressed the "invite friends" button ("invite new guests" for host)
 */
export interface UserPressedInviteFriends {
    /**
     * how the host accessed this property
     */
    enteredFrom: UserPressedInviteFriendsEnteredFrom | null;
    /**
     * the age of the guest
     */
    guestAge?: number | null;
    /**
     * boolean indicator if the screen is a view for guest, 1 if it is for guests, 0 if it is
     * for hosts
     */
    isGuestView: boolean;
    /**
     * the referral amount shown on the text on this screen
     */
    referralOfferedAmount?: null | UserPressedInviteFriendsReferralOfferedAmount;
    [property: string]: any;
}

export enum UserPressedInviteFriendsEnteredFrom {
    ReferFriends = "refer_friends",
    UnderageBooking = "underage_booking",
    UnderageContactHost = "underage_contact_host",
    UnderagePassPurchase = "underage_pass_purchase",
}

export interface UserPressedInviteFriendsReferralOfferedAmount {
    /**
     * the reward amount for the referee (the friend who accepted the invite)
     */
    givingAmount?: number | null;
    /**
     * the currency of the reward amount for the referee
     */
    givingAmountCurrency?: null | string;
    /**
     * the reward amount for the referrer (the user who invited friends)
     */
    receivingAmount?: number | null;
    /**
     * the currency of the reward amount for the referee
     */
    receivingAmountCurrency?: null | string;
    /**
     * the type of the reward in cash or credit
     */
    rewardType?: null | string;
    [property: string]: any;
}

/**
 * [POST BOOKING INVITE] user pressed to invite friends to booking
 */
export interface UserPressedInviteFriendsToBooking {
    /**
     * id of the booking
     */
    bookingId: number;
    /**
     * the button or page the alpha guest entered from
     */
    enteredFrom: UserPressedInviteFriendsToBookingEnteredFrom;
    [property: string]: any;
}

/**
 * the button or page the alpha guest entered from
 */
export enum UserPressedInviteFriendsToBookingEnteredFrom {
    Confirmation = "confirmation",
    ReservationGuestList = "reservationGuestList",
    ReservationInviteMoreFriend = "reservationInviteMoreFriend",
    ReservationPlusButton = "reservationPlusButton",
}

/**
 * [GUEST FAVORITE INVITE] user pressed "collaborate" for how they wanted to share the list
 */
export interface UserPressedInviteFriendsToCollaborateFL {
    /**
     * the user id of the account who created the favorite collection
     */
    alphaUserId?: number;
    /**
     * an array of any favorite collection collaborator's user ids
     */
    betaUserIds?: any[];
    /**
     * the favorite collection id
     */
    favoriteCollectionId: number;
    /**
     * the name of the favorite collection
     */
    favoriteCollectionName: string;
    id?:                    string;
    /**
     * a boolean to identify whether the actions being taken to a favorite collection are being
     * done by the alpha user (1) or a beta user (0)
     */
    isAlphaUserId: boolean;
    [property: string]: any;
}

/**
 * [GUEST FAVORITE INVITE] user pressed "view only" for how they wanted to share the list
 */
export interface UserPressedInviteFriendsToViewFL {
    /**
     * the user id of the account who created the favorite collection
     */
    alphaUserId?: number;
    /**
     * an array of any favorite collection collaborator's user ids
     */
    betaUserIds?: any[];
    /**
     * the favorite collection id
     */
    favoriteCollectionId: number;
    /**
     * the name of the favorite collection
     */
    favoriteCollectionName: string;
    id?:                    string;
    /**
     * a boolean to identify whether the actions being taken to a favorite collection are being
     * done by the alpha user (1) or a beta user (0)
     */
    isAlphaUserId: boolean;
    [property: string]: any;
}

/**
 * [REFERRAL] user selected the invite via email option
 */
export interface UserPressedInviteViaEmail {
    id?: string;
    [property: string]: any;
}

/**
 * [GUEST FAVORITE INVITE] beta user pressed join favorite list after opening invite
 */
export interface UserPressedJoinFavoriteList {
    /**
     * the user id of the account who created the favorite collection
     */
    alphaUserId?: number;
    /**
     * an array of any favorite collection collaborator's user ids
     */
    betaUserIds?: any[];
    /**
     * the favorite collection id
     */
    favoriteCollectionId: number;
    /**
     * the name of the favorite collection
     */
    favoriteCollectionName: string;
    id?:                    string;
    /**
     * a boolean to identify whether the actions being taken to a favorite collection are being
     * done by the alpha user (1) or a beta user (0)
     */
    isAlphaUserId: boolean;
    method?:       string;
    [property: string]: any;
}

/**
 * [POST BOOKING INVITE] user pressed to join reservation (web only)
 */
export interface UserPressedJoinReservation {
    /**
     * id of the booking
     */
    bookingId: number;
    /**
     * displayed city of the listing
     */
    city?: string;
    /**
     * displayed date of the booking
     */
    date: string;
    /**
     * displayed end time of the booking
     */
    endTime: string;
    /**
     * True if the reservation is full, false otherwise
     */
    isReservationFull?: boolean;
    /**
     * True if user is signed in, false otherwise
     */
    isSignIn: boolean;
    /**
     * displayed start time of the booking
     */
    startTime: string;
    /**
     * displayed state of the listing
     */
    state?: string;
    [property: string]: any;
}

/**
 * [SEARCH] user pressed the keyword button to open the keyword search modal on web
 */
export interface UserPressedKeywordSearch {
    id?: string;
    [property: string]: any;
}

/**
 * [CHECKOUT] on checkout when a user pressed more info under Klarna the BNPL option
 */
export interface UserPressedKlarnaMoreInfo {
    bookingId?:            number;
    bookingStartDateTime?: string;
    guestId:               number;
    hostId:                number;
    id?:                   string;
    listingId:             number;
    listingTitle:          string;
    market?:               string;
    totalPrice?:           number;
    [property: string]: any;
}

/**
 * [PLP] user pressed learn more to view Swimply Guard
 */
export interface UserPressedLearnMoreSwimplyGuard {
    /**
     * id of the listing
     */
    listingId: string;
    [property: string]: any;
}

/**
 * [GUEST FAVORITE INVITE] user pressed "leave favorites list"
 */
export interface UserPressedLeaveFavoriteList {
    /**
     * the user id of the account who created the favorite collection
     */
    alphaUserId?: number;
    /**
     * an array of any favorite collection collaborator's user ids
     */
    betaUserIds?: any[];
    /**
     * the favorite collection id
     */
    favoriteCollectionId: number;
    /**
     * the name of the favorite collection
     */
    favoriteCollectionName: string;
    id?:                    string;
    /**
     * a boolean to identify whether the actions being taken to a favorite collection are being
     * done by the alpha user (1) or a beta user (0)
     */
    isAlphaUserId: boolean;
    [property: string]: any;
}

/**
 * [SEARCH] user pressed a listing to navigate to PLP
 */
export interface UserPressedListing {
    /**
     * if the listing has an active deal, what percent amount off of this promo code (1-100)
     */
    amountOff?: number | null;
    /**
     * displayed badge name
     */
    badgeName: null | string;
    /**
     * city of the listing
     */
    city: string;
    /**
     * listing id (for meta event)
     */
    content_ids: number;
    /**
     * should be destination (for meta event)
     */
    content_type: ContentType;
    /**
     * country of the listing (for meta event)
     */
    country: string;
    /**
     * daily price displayed
     */
    dailyPrice?: number;
    /**
     * All possible values for enteredFrom in PLP
     */
    enteredFrom: UserPressedListingEnteredFrom;
    /**
     * if the listing has an active deal, when is the expiration
     */
    expireDate?: null | string;
    /**
     * When a user accesses a listing via favorites, which favorite collection?
     */
    favoriteCollectionId?: number;
    /**
     * [LISTING TYPE] The type of the listing associated with this event
     */
    globalListingType: GlobalListingType;
    /**
     * whether the listing has the offseason availability banner
     */
    hasAvailabilityBanner: boolean;
    /**
     * does the listing have a currently active deal (1 - yes, 0 - no)
     */
    hasDeal: boolean;
    /**
     * whether the listings has passes available (1 if true, 0 if false)
     */
    hasPass: boolean;
    /**
     * hourly price displayed
     */
    hourlyPrice?: number;
    /**
     * True if the user search in list view, false if floating card in map view
     */
    isListView: boolean;
    /**
     * id of the listing
     */
    listingId: string;
    /**
     * for listings with the offseason availability banner, when is the next available date
     */
    nextAvailableDateDisplayed?: null | string;
    /**
     * order in search list (only if isListView is True, null otherwise)
     */
    orderInSearchResults: number;
    /**
     * if the listing has one or more active passes, list the pass ids in an array
     */
    passIds?: any[] | null;
    /**
     * the types of passes available for a listing - null if it doesn't have any
     */
    passTypes: any[] | null;
    /**
     * the displayed priceType of listing
     */
    priceType: PriceType;
    /**
     * photo id of the first photo displayed for the listing
     */
    primaryPhotoId?: null | string;
    /**
     * A products array to satisfy third party event processors
     */
    products?: UserPressedListingProduct[];
    /**
     * rating displayed
     */
    rating: number | null;
    /**
     * total amount of ratings displayed
     */
    ratingsVolume: number | null;
    /**
     * state of the listing (for meta event)
     */
    region: string;
    /**
     * id of search which generated result
     */
    searchId: null | string;
    /**
     * the displayed location in SEO page if they entered PLP from SEO, null otherwise
     */
    seoLocation?: null | string;
    /**
     * the displayed space type in SEO page if they entered PLP from SEO, null otherwise
     */
    seoSpaceType?: ListingTypeEnum | null;
    /**
     * the displayed user case in SEO page if they entered PLP from SEO, null otherwise
     */
    seoUseCase?: NewUseCaseEnum | null;
    [property: string]: any;
}

/**
 * All possible values for enteredFrom in PLP
 */
export enum UserPressedListingEnteredFrom {
    External = "external",
    Favorite = "favorite",
    Homepage = "homepage",
    Referral = "referral",
    SEO = "seo",
    Search = "search",
}

export interface UserPressedListingProduct {
    /**
     * The listing type of the relevant listing
     */
    category: string;
    /**
     * The title of the relevant listing
     */
    name: string;
    /**
     * The id of the relevant listing
     */
    productId: string;
    /**
     * Should always be 1
     */
    quantity: number;
    [property: string]: any;
}

export enum NewUseCaseEnum {
    AdaFriendlySwim = "ada-friendly-swim",
    AnniversaryParty = "anniversary-party",
    BabyShower = "baby-shower",
    BacheloretteParty = "bachelorette-party",
    BarMitzvahParty = "bar-mitzvah-party",
    BatMitzvahParty = "bat-mitzvah-party",
    BridalShower = "bridal-shower",
    CompanyOffsite = "company-offsite",
    CookingEvent = "cooking-event",
    CorporateEvent = "corporate-event",
    CountryClubWithPickleballCourt = "country_club_with_pickleball_court",
    CountryClubWithPool = "country_club_with_pool",
    CountryClubWithTennisCourt = "country_club_with_tennis_court",
    DinnerParty = "dinner-party",
    Event = "event",
    FamilySwim = "family-swim",
    GraduationParty = "graduation-party",
    GymWithPool = "gym_with_pool",
    Meeting = "meeting",
    NightSwim = "night-swim",
    Party = "party",
    PetFriendlySwim = "pet-friendly-swim",
    Photoshoot = "photoshoot",
    PickleballClub = "pickleball_club",
    PickleballLessons = "pickleball_lessons",
    PickleballMembership = "pickleball_membership",
    PoolParty = "pool-party",
    PoolPass = "pool_pass",
    QuinceaneraParty = "quinceanera-party",
    SwimClub = "swim_club",
    SwimLessons = "swim_lessons",
    SwimMembership = "swim_membership",
    TennisClub = "tennis_club",
    TennisLessons = "tennis_lessons",
    TennisMembership = "tennis_membership",
    VideoShoot = "video-shoot",
}

/**
 * [SEARCH] user pressed a listing to navigate to PLP
 */
export interface UserPressedListingAISearch {
    /**
     * All possible values for enteredFrom in PLP
     */
    enteredFrom?: UserPressedListingEnteredFrom;
    /**
     * True if the user search in list view, false if floating card in map view
     */
    isListView?: boolean;
    /**
     * id of the listing
     */
    listingId: string;
    /**
     * order in search list (only if isListView is True, null otherwise)
     */
    orderInSearchResults?: number;
    /**
     * price displayed
     */
    price?: number;
    /**
     * the displayed priceType of listing
     */
    priceType?: PriceType;
    /**
     * id of search which generated result
     */
    searchId?: null | string;
    [property: string]: any;
}

/**
 * [PLP] user pressed on one of the images (or videos) on a given plp
 */
export interface UserPressedListingPhoto {
    /**
     * id of the listing
     */
    listingId: string;
    /**
     * search they entered the listing from, if applicable
     */
    searchId: null | string;
    [property: string]: any;
}

/**
 * [SEARCH] user clicked on the map itself, not a listing on the map
 */
export interface UserPressedMap {
    /**
     * did map reload new results as a result of the press
     */
    didMapReload: boolean;
    /**
     * id of search which generated result
     */
    searchId: null | string;
    [property: string]: any;
}

/**
 * [SEARCH] user pressed pin on map
 */
export interface UserPressedMapListing {
    /**
     * displayed badge name
     */
    badgeName: null | string;
    /**
     * price displayed on the pin
     */
    displayedPrice: number;
    /**
     * [LISTING TYPE] The type of the listing associated with this event
     */
    globalListingType: GlobalListingType;
    /**
     * id of the listing
     */
    listingId: string;
    /**
     * order of listing in search result
     */
    orderInSearchResults: number;
    /**
     * color of the pin
     */
    pinColor: string;
    /**
     * latitude of the pin
     */
    pinLatitude: number;
    /**
     * longitude of the pin
     */
    pinLongitude: number;
    /**
     * photo id of the first photo displayed for the listing
     */
    primaryPhotoId?: string;
    /**
     * id of search which generated result
     */
    searchId: null | string;
    [property: string]: any;
}

/**
 * [SEARCH] user pressed the new pool only filter in the filter menu
 */
export interface UserPressedNewPoolFilter {
    /**
     * DO NOT SEND: This is added as a workaround for this issue:
     * https://github.com/segmentio/typewriter/issues/284
     */
    fakeProperty?: null | string;
    [property: string]: any;
}

/**
 * [USER PROFILE - ACCOUNT SETTINGS: NOTIFICATIONS]
 */
export interface UserPressedNotifications {
    id?: string;
    [property: string]: any;
}

/**
 * [GUEST PASS ACQUISITION] - when the user presses to learn more about passes
 */
export interface UserPressedPassesUpsellLearnMore {
    id?: string;
    [property: string]: any;
}

/**
 * [CHECKOUT] on checkout when a user chooses to pay with Klarna the BNPL option
 */
export interface UserPressedPayWithKlarna {
    bookingId?:            number;
    bookingStartDateTime?: string;
    guestId:               number;
    hostId:                number;
    id?:                   string;
    listingId:             number;
    listingTitle:          string;
    market?:               string;
    totalPrice?:           number;
    [property: string]: any;
}

/**
 * [SEARCH] user pressed the pet filter in the filter menu
 */
export interface UserPressedPetFilter {
    /**
     * DO NOT SEND: This is added as a workaround for this issue:
     * https://github.com/segmentio/typewriter/issues/284
     */
    fakeProperty?: null | string;
    [property: string]: any;
}

/**
 * [POST BOOKING INVITE] (will be refactored) user pressed to invite from the reservation
 * confirmation screen
 */
export interface UserPressedPostBookingInviteFromConfirmation {
    /**
     * id of the booking this pertains to
     */
    bookingId: string;
    [property: string]: any;
}

/**
 * [POST BOOKING INVITE] (will be refactored) user pressed to invite from the reservation
 * confirmation screen
 */
export interface UserPressedPostBookingInviteFromReservationPage {
    /**
     * id of the booking this pertains to
     */
    bookingId: string;
    [property: string]: any;
}

/**
 * [SEARCH] user pressed the price tag of the listing on map view
 */
export interface UserPressedPriceTagMapView {
    /**
     * hourly price displayed
     */
    hourlyPrice: number;
    /**
     * id of the listing
     */
    listingId: string;
    /**
     * photo id of the first photo displayed for the listing
     */
    primaryPhotoId: string;
    /**
     * id of search which generated result
     */
    searchId: null | string;
    [property: string]: any;
}

/**
 * [USER PROFILE - Account Verification] user pressed the upload id option after starting
 * the profile verification process
 */
export interface UserPressedProfileVerificationUploadID {
    id?: string;
    [property: string]: any;
}

/**
 * [GUEST PASS ACQUISITION] - when the user presses to purchase an anytime pass
 */
export interface UserPressedPurchaseAnytimePass {
    /**
     * the url for the cover image of the listing the pass is for
     */
    coverImageURL: string;
    enteredFrom:   UserPressedPurchaseAnytimePassEnteredFrom | null;
    /**
     * first name of the host
     */
    hostFirstName: string;
    id?:           string;
    /**
     * id of the listing the pass is for
     */
    listingId: string;
    /**
     * the title of the listing the pass is for
     */
    listingTitle: string;
    /**
     * the url of the listing the pass is for
     */
    listingURL: string;
    /**
     * [{from:”07:00:00”, “11:00:00”}...] Time slots when this pass is eligible
     */
    passAvailableTimes?: any[];
    /**
     * LCM formatted version of available times property
     */
    passAvailableTimesText?: string;
    /**
     * list of blackout dates (e.g. July 4, 2024).
     */
    passBlackoutDays?: any[] | null;
    /**
     * when the pass was created
     */
    passCreatedAt: string;
    /**
     * currency for all monetary fields
     */
    passCurrencyCode: string;
    /**
     * flag indicating that this is the current version for a pass. For a type/name/listing_id,
     * there can only be one record with this attribute true.
     */
    passCurrent: boolean;
    /**
     * free text description set by host
     */
    passDescription?: null | string;
    /**
     * discount amount. Fixed discounts will be in minors units.
     */
    passDiscount: number | null;
    /**
     * type of pass discount num[‘percentage’, ‘fixed’]
     */
    passDiscountType: PassDiscountType | null;
    /**
     * days the pass is eligible
     */
    passEligibleDays?: any[] | null;
    /**
     * id of the pass
     */
    passId: number;
    /**
     * max active passes allowed. This constraint will apply to the (listing_id, type, name)
     * rather than id so that we can be accurate across edits.
     */
    passMaxActivePasses?: number | null;
    /**
     * max bookings allowed under this pass
     */
    passMaxDailyBookings?: number | null;
    /**
     * max duration that may be booked using this pass
     */
    passMaxDuration?: number | null;
    /**
     * max guests that may be booked using this pass
     */
    passMaxGuests?: number | null;
    /**
     * the type of the pass formatted to be LCM friendly
     */
    passName: string;
    /**
     * the ids of all premium amenities included with the pass
     */
    passPremiumAmenities?: any[] | null;
    /**
     * pass price in minor units
     */
    passPrice: string;
    /**
     * ‘draft’ -> pass is being actively edited by the host via the creation flow. The step
     * attribute below tracks the progress of the host through the creation flow.
     * ‘inactive’ -> pass has been created by the host, but not ready for sale yet
     * ‘active’ -> pass has passed the final availability requirements and has been marked by
     * the host as ready for sale.
     */
    passState: PassState;
    /**
     * the pass of the price plus the service fee
     */
    passTotalPrice: string;
    /**
     * the type of pass
     */
    passType: GuestPassPurchaseFailurePassType;
    [property: string]: any;
}

export enum UserPressedPurchaseAnytimePassEnteredFrom {
    Checkout = "checkout",
    PDP = "pdp",
}

/**
 * [GUEST PASS ACQUISITION] - when the user presses to purchase an earlybird pass
 */
export interface UserPressedPurchaseEarlyBirdPass {
    /**
     * the url for the cover image of the listing the pass is for
     */
    coverImageURL: string;
    enteredFrom:   UserPressedPurchaseAnytimePassEnteredFrom | null;
    /**
     * first name of the host
     */
    hostFirstName: string;
    id?:           string;
    /**
     * id of the listing the pass is for
     */
    listingId: string;
    /**
     * the title of the listing the pass is for
     */
    listingTitle: string;
    /**
     * the url of the listing the pass is for
     */
    listingURL: string;
    /**
     * [{from:”07:00:00”, “11:00:00”}...] Time slots when this pass is eligible
     */
    passAvailableTimes?: any[];
    /**
     * LCM formatted version of available times property
     */
    passAvailableTimesText?: string;
    /**
     * list of blackout dates (e.g. July 4, 2024).
     */
    passBlackoutDays?: any[] | null;
    /**
     * when the pass was created
     */
    passCreatedAt: string;
    /**
     * currency for all monetary fields
     */
    passCurrencyCode: string;
    /**
     * flag indicating that this is the current version for a pass. For a type/name/listing_id,
     * there can only be one record with this attribute true.
     */
    passCurrent: boolean;
    /**
     * free text description set by host
     */
    passDescription?: null | string;
    /**
     * discount amount. Fixed discounts will be in minors units.
     */
    passDiscount: number | null;
    /**
     * type of pass discount num[‘percentage’, ‘fixed’]
     */
    passDiscountType: PassDiscountType | null;
    /**
     * days the pass is eligible
     */
    passEligibleDays?: any[] | null;
    /**
     * id of the pass
     */
    passId: number;
    /**
     * max active passes allowed. This constraint will apply to the (listing_id, type, name)
     * rather than id so that we can be accurate across edits.
     */
    passMaxActivePasses?: number | null;
    /**
     * max bookings allowed under this pass
     */
    passMaxDailyBookings?: number | null;
    /**
     * max duration that may be booked using this pass
     */
    passMaxDuration?: number | null;
    /**
     * max guests that may be booked using this pass
     */
    passMaxGuests?: number | null;
    /**
     * the type of the pass formatted to be LCM friendly
     */
    passName: string;
    /**
     * the ids of all premium amenities included with the pass
     */
    passPremiumAmenities?: any[] | null;
    /**
     * pass price in minor units
     */
    passPrice: string;
    /**
     * ‘draft’ -> pass is being actively edited by the host via the creation flow. The step
     * attribute below tracks the progress of the host through the creation flow.
     * ‘inactive’ -> pass has been created by the host, but not ready for sale yet
     * ‘active’ -> pass has passed the final availability requirements and has been marked by
     * the host as ready for sale.
     */
    passState: PassState;
    /**
     * the pass of the price plus the service fee
     */
    passTotalPrice: string;
    /**
     * the type of pass
     */
    passType: GuestPassPurchaseFailurePassType;
    [property: string]: any;
}

/**
 * [GUEST PASS ACQUISITION] - when the user presses to purchase an week day pass
 */
export interface UserPressedPurchaseWeekdayPass {
    /**
     * the url for the cover image of the listing the pass is for
     */
    coverImageURL: string;
    enteredFrom:   UserPressedPurchaseAnytimePassEnteredFrom | null;
    /**
     * first name of the host
     */
    hostFirstName: string;
    id?:           string;
    /**
     * id of the listing the pass is for
     */
    listingId: string;
    /**
     * the title of the listing the pass is for
     */
    listingTitle: string;
    /**
     * the url of the listing the pass is for
     */
    listingURL: string;
    /**
     * [{from:”07:00:00”, “11:00:00”}...] Time slots when this pass is eligible
     */
    passAvailableTimes?: any[];
    /**
     * LCM formatted version of available times property
     */
    passAvailableTimesText?: string;
    /**
     * list of blackout dates (e.g. July 4, 2024).
     */
    passBlackoutDays?: any[] | null;
    /**
     * when the pass was created
     */
    passCreatedAt: string;
    /**
     * currency for all monetary fields
     */
    passCurrencyCode: string;
    /**
     * flag indicating that this is the current version for a pass. For a type/name/listing_id,
     * there can only be one record with this attribute true.
     */
    passCurrent: boolean;
    /**
     * free text description set by host
     */
    passDescription?: null | string;
    /**
     * discount amount. Fixed discounts will be in minors units.
     */
    passDiscount: number | null;
    /**
     * type of pass discount num[‘percentage’, ‘fixed’]
     */
    passDiscountType: PassDiscountType | null;
    /**
     * days the pass is eligible
     */
    passEligibleDays?: any[] | null;
    /**
     * id of the pass
     */
    passId: number;
    /**
     * max active passes allowed. This constraint will apply to the (listing_id, type, name)
     * rather than id so that we can be accurate across edits.
     */
    passMaxActivePasses?: number | null;
    /**
     * max bookings allowed under this pass
     */
    passMaxDailyBookings?: number | null;
    /**
     * max duration that may be booked using this pass
     */
    passMaxDuration?: number | null;
    /**
     * max guests that may be booked using this pass
     */
    passMaxGuests?: number | null;
    /**
     * the type of the pass formatted to be LCM friendly
     */
    passName: string;
    /**
     * the ids of all premium amenities included with the pass
     */
    passPremiumAmenities?: any[] | null;
    /**
     * pass price in minor units
     */
    passPrice: string;
    /**
     * ‘draft’ -> pass is being actively edited by the host via the creation flow. The step
     * attribute below tracks the progress of the host through the creation flow.
     * ‘inactive’ -> pass has been created by the host, but not ready for sale yet
     * ‘active’ -> pass has passed the final availability requirements and has been marked by
     * the host as ready for sale.
     */
    passState: PassState;
    /**
     * the pass of the price plus the service fee
     */
    passTotalPrice: string;
    /**
     * the type of pass
     */
    passType: GuestPassPurchaseFailurePassType;
    [property: string]: any;
}

/**
 * [POST BOOKING REVIEW] user pressed a rating value on booking review
 */
export interface UserPressedRatingValue {
    /**
     * id of the booking associated with the review
     */
    bookingId: number;
    /**
     * id of the listing being reviewed
     */
    listingId: number;
    /**
     * the maximum value the user could have selected for rating
     */
    ratingValueMaximum: number;
    /**
     * the minimum value the user could have selected for rating
     */
    ratingValueMinimum: number;
    /**
     * rating value selected
     */
    ratingValuePressed: number;
    [property: string]: any;
}

/**
 * [CHECKOUT] after rating a booking 5 stars or not rating, when a user presses to rebook
 * for FREE with a pass
 */
export interface UserPressedRebookWithPass {
    guestId:      number;
    hostId:       number;
    id?:          string;
    listingId:    number;
    listingTitle: string;
    /**
     * If the guest is shown an expiring discount towards the pass purchase, how much is it for
     * (null if it's expired or not shown)
     */
    passUpsellCreditAmountOffer?: number | null;
    [property: string]: any;
}

/**
 * [CLAIM REFERRAL] User pressed the recommended listings on the referral page
 */
export interface UserPressedRecommendedListingInClaims {
    /**
     * Id of the listing
     */
    listingId: number;
    /**
     * order in the recommended list
     */
    orderInRecommendedResults: number;
    /**
     * the referral id of the invite
     */
    referralId: string;
    [property: string]: any;
}

/**
 * [COZYMEAL] User pressed the "redirect to Cozymeal" button on a Cozymeal listing to book
 * on Cozymeal
 */
export interface UserPressedRedirectToCozyMeal {
    bookingId?:         number;
    cozyMealListingId?: number;
    enteredFrom:        UserPressedRedirectToCozyMealEnteredFrom | null;
    guestId:            number;
    hostId:             number;
    id?:                string;
    listingId:          number;
    [property: string]: any;
}

export enum UserPressedRedirectToCozyMealEnteredFrom {
    BookNow = "book_now",
    PopupListing = "popup_listing",
    PopupViewAll = "popup_view_all",
}

/**
 * [REFERRAL] user pressed the "refer host" button
 */
export interface UserPressedReferAHost {
    /**
     * boolean indicator if the screen is a view for guest, 1 if it is for guests, 0 if it is
     * for hosts
     */
    isGuestView: boolean;
    /**
     * the referral amount shown on the text on this screen
     */
    referralOfferedAmount: UserPressedReferAHostReferralOfferedAmount;
    [property: string]: any;
}

/**
 * the referral amount shown on the text on this screen
 */
export interface UserPressedReferAHostReferralOfferedAmount {
    /**
     * the reward amount for the referee (the host who accepted the invite)
     */
    givingAmount: number;
    /**
     * the currency of the reward amount for the referee
     */
    givingAmountCurrency: string;
    /**
     * the reward amount for the referrer (the user who invited hosts)
     */
    receivingAmount: number;
    /**
     * the type of the reward in cash or credit
     */
    rewardType: string;
    [property: string]: any;
}

/**
 * [GUEST FAVORITE INVITE] user pressed remove after selecting friend(s) to remove from a
 * favorite list
 */
export interface UserPressedRemoveFriendsFromFL {
    /**
     * the user id of the account who created the favorite collection
     */
    alphaUserId?: number;
    /**
     * an array of any favorite collection collaborator's user ids
     */
    betaUserIds?: any[];
    /**
     * the favorite collection id
     */
    favoriteCollectionId: number;
    /**
     * the name of the favorite collection
     */
    favoriteCollectionName: string;
    id?:                    string;
    /**
     * a boolean to identify whether the actions being taken to a favorite collection are being
     * done by the alpha user (1) or a beta user (0)
     */
    isAlphaUserId: boolean;
    /**
     * the ids of any users removed from a favorites list
     */
    removedUserIds: any[];
    [property: string]: any;
}

/**
 * user pressed to exit the thread to go to reservations (all reservations on web, the
 * specific thread reservation on mobile)
 */
export interface UserPressedReservationsFromMessageThread {
    /**
     * the booking shown when the user clicks to see the reservation on chat - logic defined by
     * Mojin in Chat Redesign PRD
     */
    bookingId:    number;
    bookingState: BookingState | null;
    /**
     * the guest for the booking
     */
    guestId: number;
    /**
     * the host for the booking
     */
    hostId: number;
    /**
     * the listing for the booking
     */
    listingId: number;
    /**
     * the room id for the chat
     */
    roomId: string;
    [property: string]: any;
}

/**
 * [SEARCH] user pressed the restroom filter in the filter menu
 */
export interface UserPressedRestroomFilter {
    /**
     * DO NOT SEND: This is added as a workaround for this issue:
     * https://github.com/segmentio/typewriter/issues/284
     */
    fakeProperty?: null | string;
    [property: string]: any;
}

/**
 * [WEB HOMEPAGE] User pressed review arrow to switch review
 */
export interface UserPressedReviewArrow {
    /**
     * the booking id associated to the displayed review after pressing the arrow
     */
    bookingId?: string;
    /**
     * true if the user pressed the arrow on the right
     */
    isRightArrow: boolean;
    /**
     * the displayed guest name after pressing the arrow
     */
    reviewGuest: string;
    /**
     * the displayed review text after pressing the arrow
     */
    reviewText: string;
    [property: string]: any;
}

/**
 * [GUEST FAVORITE] user saves a favorite
 */
export interface UserPressedSaveFavoriteFromFavoriteList {
    /**
     * the user id of the account who created the favorite collection
     */
    alphaUserId?: number;
    /**
     * an array of any favorite collection collaborator's user ids
     */
    betaUserIds?: any[];
    /**
     * the favorite collection id
     */
    favoriteCollectionId: number;
    /**
     * the name of the favorite collection
     */
    favoriteCollectionName: string;
    favoriteId:             string;
    /**
     * a boolean to identify whether the actions being taken to a favorite collection are being
     * done by the alpha user (1) or a beta user (0)
     */
    isAlphaUserId: boolean;
    listingId:     string;
    [property: string]: any;
}

/**
 * [PLP] user saves a favorite
 */
export interface UserPressedSaveFavoriteFromPLP {
    favoriteCollectionId: number;
    favoriteId:           string;
    listingId:            string;
    [property: string]: any;
}

/**
 * [SEARCH] user saves a favorite
 */
export interface UserPressedSaveFavoriteFromSearch {
    favoriteCollectionId: number;
    favoriteId:           string;
    listingId:            string;
    [property: string]: any;
}

/**
 * [GUEST FAVORITE] user presses save changes
 */
export interface UserPressedSaveFavoriteListChanges {
    /**
     * the user id of the account who created the favorite collection
     */
    alphaUserId?: number;
    /**
     * an array of any favorite collection collaborator's user ids
     */
    betaUserIds?: any[];
    /**
     * the favorite collection id
     */
    favoriteCollectionId: number;
    /**
     * the name of the favorite collection
     */
    favoriteCollectionName: string;
    id?:                    string;
    /**
     * a boolean to identify whether the actions being taken to a favorite collection are being
     * done by the alpha user (1) or a beta user (0)
     */
    isAlphaUserId: boolean;
    [property: string]: any;
}

/**
 * [PLP - INSTAGRAM] user pressed to scroll to the next cohort of instagram pictures
 */
export interface UserPressedScrollInstagramPhotos {
    /**
     * id the the listing
     */
    listingId: string;
    /**
     * search they entered the listing from, if applicable
     */
    searchId: null | string;
    [property: string]: any;
}

/**
 * [SEARCH - REFERRALS]
 */
export interface UserPressedSearchInviteFriendsReferralBanner {
    id?: string;
    /**
     * the user's total credit amount - can be null if they have none
     */
    totalCredits?: number | null;
    [property: string]: any;
}

/**
 * [GUEST PASS DISCOVERY - SEARCH]
 */
export interface UserPressedSearchPassesCloseIntro {
    id?: string;
    [property: string]: any;
}

/**
 * [GUEST PASS DISCOVERY - SEARCH]
 */
export interface UserPressedSearchPassesLearnMore {
    id?: string;
    [property: string]: any;
}

/**
 * [MESSAGING - CALLING] user selected the type of the call after entering the call flow
 */
export interface UserPressedSelectCallType {
    /**
     * the booking shown when the user clicks to see the reservation on chat - logic defined by
     * Mojin in Chat Redesign PRD
     */
    bookingId: number;
    callType:  CallType | null;
    /**
     * the guest for the booking
     */
    guestId: number;
    /**
     * the host for the booking
     */
    hostId: number;
    /**
     * the listing for the booking
     */
    listingId: number;
    /**
     * the room id for the chat
     */
    roomId: string;
    [property: string]: any;
}

/**
 * [MESSAGING - PHOTOS] after selecting a photo, the user pressed "send"
 */
export interface UserPressedSendPicture {
    /**
     * the booking shown when the user clicks to see the reservation on chat - logic defined by
     * Mojin in Chat Redesign PRD
     */
    bookingId: number;
    /**
     * the guest for the booking
     */
    guestId: number;
    /**
     * the host for the booking
     */
    hostId: number;
    id?:    string;
    /**
     * the listing for the booking
     */
    listingId: number;
    /**
     * the room id for the chat
     */
    roomId: string;
    [property: string]: any;
}

/**
 * [SEARCH] user "presses share my list" from invite friends pop up after adding listing to
 * a favorite list
 */
export interface UserPressedShareFavoriteListFromSearch {
    favoriteCollectionId: number;
    [property: string]: any;
}

/**
 * [POST BOOKING INVITE] alpha user pressed to share link or copy link to share the invite
 */
export interface UserPressedSharePostBookingInviteLink {
    /**
     * id of the booking
     */
    bookingId: number;
    /**
     * link of the post booking invite
     */
    linkUrl: string;
    [property: string]: any;
}

/**
 * [SEARCH] user pressed to display larger map
 */
export interface UserPressedShowMapView {
    /**
     * id of search which generated result
     */
    searchId: null | string;
    [property: string]: any;
}

/**
 * [POST BOOKING REVIEW] user pressed "skip" option to exit review flow
 */
export interface UserPressedSkipBookingReview {
    /**
     * id of the booking associated with the review
     */
    bookingId: number;
    /**
     * id of the listing being reviewed
     */
    listingId: number;
    [property: string]: any;
}

/**
 * [CLAIM REFERRAL] User pressed the button to switch to host or guest referral
 */
export interface UserPressedSwitchReferral {
    /**
     * Type of the original referral, host or guest
     */
    originalReferralType: string;
    /**
     * the referral id of the invite
     */
    referralId: string;
    /**
     * Type of the new referral switched to
     */
    switchTo: string;
    [property: string]: any;
}

/**
 * user pressed on the terms of service link from a circumvention autowarning message
 */
export interface UserPressedTOSFromMessages {
    /**
     * DO NOT SEND: This is added as a workaround for this issue:
     * https://github.com/segmentio/typewriter/issues/284
     */
    id?: string;
    [property: string]: any;
}

/**
 * [WEB HOMEPAGE] User pressed to become a host
 */
export interface UserPressedToBecomeHost {
    /**
     * the button on the hero image or the button at the end of the page
     */
    buttonAt: ButtonAt;
    /**
     * Type of the listings
     */
    listingType: ListingTypeEnum;
    [property: string]: any;
}

/**
 * the button on the hero image or the button at the end of the page
 */
export enum ButtonAt {
    HeroImage = "hero_image",
    PageEnd = "page_end",
}

/**
 * [CHECKOUT] user entered booking flow
 */
export interface UserPressedToEnterBookingFlow {
    /**
     * id for the current checkout flow
     */
    checkoutId: string;
    /**
     * is the checkout for a pass purchase or a standard booking
     */
    checkoutType: CheckoutTypeEnum;
    /**
     * city of the listing (for meta event)
     */
    city: string;
    /**
     * listing id (for meta event)
     */
    content_ids: number;
    /**
     * should be destination (for meta event)
     */
    content_type: ContentType;
    /**
     * country of the listing (for meta event)
     */
    country: string;
    /**
     * current distance of search location to pool, in miles
     */
    distanceFromPool: number;
    /**
     * where the user entered the flow from
     */
    enteredFrom: string;
    /**
     * [LISTING TYPE] The type of the listing associated with this event
     */
    globalListingType: GlobalListingType;
    /**
     * does the listing have an active pass - 1 if true, 0 if false
     */
    hasActivePass: boolean;
    /**
     * city for the listing
     */
    listingCity: string;
    /**
     * cover photo url for the listing
     */
    listingCoverPhotoUrl: string;
    /**
     * the id for the pool listing
     */
    listingId: string;
    /**
     * state/territory of the listing
     */
    listingState: string;
    /**
     * title of the listing
     */
    listingTitle: string;
    /**
     * if the booking was made or partially made with a pass, the pass id used
     */
    passId?: number | null;
    /**
     * the type of the pass formatted to be LCM friendly
     */
    passName?: null | string;
    /**
     * if the booking was made or partially made with a pass, what type of pass
     */
    passType?: GuestAcceptReviewChangesFromHostPassType | null;
    /**
     * list of items being purchased, used for GA event mapping
     */
    products: UserPressedToEnterBookingFlowProduct[];
    /**
     * if there was a promocode used - the percent amount off of the promo code (1-100)
     */
    promoCodeAmountOff?: number | null;
    /**
     * the backend promo code id
     */
    promoCodeId?: null | string;
    /**
     * the name of the promo Code
     */
    promoCodeName?: null | string;
    /**
     * state of the listing (for meta event)
     */
    region: string;
    /**
     * id for the search that led to this listing
     */
    searchId: null | string;
    /**
     * text of the entry point (e.g, "Book Now", "Check Availability")
     */
    textDisplayed: string;
    [property: string]: any;
}

export interface UserPressedToEnterBookingFlowProduct {
    /**
     * the average rating the product (listing) displayed on the PLP
     */
    avgRating: number;
    /**
     * The listing type of the relevant listing
     */
    category: string;
    /**
     * maximum number of guest counts for the product (listing)
     */
    maxGuestCounts: number;
    /**
     * The title of the relevant listing
     */
    name: string;
    /**
     * number of rating the product (listing) has
     */
    numberOfRatings: number;
    /**
     * id of associated pool/listing -> item_id
     */
    productId: string;
    /**
     * Should always be 1
     */
    quantity: number;
    [property: string]: any;
}

/**
 * [PLP] user pressed to favorite a listing
 */
export interface UserPressedToFavorite {
    /**
     * [LISTING TYPE] The type of the listing associated with this event
     */
    globalListingType: GlobalListingType;
    /**
     * id the the listing
     */
    listingId: string;
    /**
     * search they entered the listing from, if applicable
     */
    searchId: null | string;
    [property: string]: any;
}

/**
 * [POST BOOKING INVITE] alpha user pressed to remove the beta guest
 */
export interface UserPressedToRemoveBetaGuest {
    /**
     * array of the displayed first name of the selected beta guest
     */
    betaGuestFirstName: any[];
    /**
     * array of user id of the selected beta guest
     */
    betaGuestId: any[];
    [property: string]: any;
}

/**
 * [PLP] user pressed on the share option on a given plp
 */
export interface UserPressedToSharePLP {
    /**
     * [LISTING TYPE] The type of the listing associated with this event
     */
    globalListingType: GlobalListingType;
    /**
     * id of the listing
     */
    listingId: string;
    /**
     * search they entered the listing from, if applicable
     */
    searchId: null | string;
    [property: string]: any;
}

/**
 * [PLP] user pressed the "share pool with friends" option
 */
export interface UserPressedToSharePLPwFriends {
    /**
     * id of the listing
     */
    listingId: string;
    /**
     * search they entered the listing from, if applicable
     */
    searchId: null | string;
    [property: string]: any;
}

/**
 * [POST BOOKING INVITE] user pressed to view guest list
 */
export interface UserPressedToViewGuestList {
    /**
     * True if user is alpha guest, False otherwise
     */
    isAlphaGuest: boolean;
    /**
     * displayed number of guests on guest list
     */
    numberOfGuest: number;
    [property: string]: any;
}

/**
 * [SEARCH] user pressed "Try AI Serach"
 */
export interface UserPressedTryAISearch {
    id?: string;
    [property: string]: any;
}

/**
 * [GUEST FAVORITE] user saves a favorite change
 */
export interface UserPressedUnsaveFavoriteFromFavoriteList {
    /**
     * the user id of the account who created the favorite collection
     */
    alphaUserId?: number;
    /**
     * an array of any favorite collection collaborator's user ids
     */
    betaUserIds?: any[];
    /**
     * the favorite collection id
     */
    favoriteCollectionId: number;
    /**
     * the name of the favorite collection
     */
    favoriteCollectionName: string;
    /**
     * a boolean to identify whether the actions being taken to a favorite collection are being
     * done by the alpha user (1) or a beta user (0)
     */
    isAlphaUserId: boolean;
    listingId:     string;
    [property: string]: any;
}

/**
 * [PLP] user unsaves a favorite
 */
export interface UserPressedUnsaveFavoriteFromPLP {
    favoriteCollectionId: number;
    listingId:            string;
    [property: string]: any;
}

/**
 * [SEARCH] user unsaves a favorite
 */
export interface UserPressedUnsaveFavoriteFromSearch {
    favoriteCollectionId: number;
    listingId:            string;
    [property: string]: any;
}

/**
 * [COZYMEAL] User pressed the "view all" on the post booking Cozymeal catering options pop
 * up
 */
export interface UserPressedViewAllCozymealOptions {
    bookingId?:              number;
    cozyMealListingIdsShown: any[];
    guestId:                 number;
    hostId:                  number;
    id?:                     string;
    listingId:               number;
    [property: string]: any;
}

/**
 * [COZYMEAL] User pressed the "view all" on the Cozymeal search results catering options
 */
export interface UserPressedViewAllCozymealOptionsFromSearch {
    bookingId?: number;
    guestId:    number;
    hostId:     number;
    id?:        string;
    listingId:  number;
    [property: string]: any;
}

/**
 * [PLP] user pressed "All photos and videos" on a given plp
 */
export interface UserPressedViewAllListingPhotosAndVideos {
    /**
     * id of the listing
     */
    listingId: string;
    /**
     * search they entered the listing from, if applicable
     */
    searchId: null | string;
    [property: string]: any;
}

/**
 * [PLP] user pressed to view a host profile from PLP
 */
export interface UserPressedViewHostProfile {
    /**
     * id of the host
     */
    hostId: string;
    /**
     * Is the host fully verified
     */
    hostVerified: boolean;
    /**
     * id of the listing
     */
    listingId: string;
    [property: string]: any;
}

/**
 * [PLP - INSTAGRAM] user pressed to view a specific one of the listing's instagram photos
 */
export interface UserPressedViewInstagramPhoto {
    /**
     * id the the listing
     */
    listingId: string;
    /**
     * search they entered the listing from, if applicable
     */
    searchId: null | string;
    [property: string]: any;
}

/**
 * [MESSAGING - PHOTOS] after a user sent a photo, a user views the picture sent
 */
export interface UserPressedViewPhoto {
    /**
     * the booking shown when the user clicks to see the reservation on chat - logic defined by
     * Mojin in Chat Redesign PRD
     */
    bookingId: number;
    /**
     * the guest for the booking
     */
    guestId: number;
    /**
     * the host for the booking
     */
    hostId: number;
    /**
     * the listing for the booking
     */
    listingId: number;
    /**
     * the room id for the chat
     */
    roomId: string;
    /**
     * the user who sent the picture
     */
    sentByUserId: number;
    userIsHost:   boolean;
    [property: string]: any;
}

/**
 * [POST BOOKING INVITE]  (will be deprecated) beta guest pressed to "view reservation" from
 * a post booking invite
 */
export interface UserPressedViewReservationFromPostBookingInvite {
    /**
     * id of the booking this pertains to
     */
    bookingId: string;
    [property: string]: any;
}

/**
 * [PLP] user pressed to view reviews from PLP
 */
export interface UserPressedViewReviews {
    /**
     * displayed rating for the listing
     */
    displayedRating: number | null;
    /**
     * id the the listing to share
     */
    listingId: string;
    /**
     * total number of reviews
     */
    numReviews: number;
    /**
     * search they entered the listing from, if applicable
     */
    searchId: null | string;
    [property: string]: any;
}

/**
 * [POST BOOKING REVIEW] user select "x" on web to close the screen for reviews
 */
export interface UserPressedXToExitReview {
    /**
     * id of the booking associated with the review
     */
    bookingId?: number;
    /**
     * id of the listing being reviewed
     */
    listingId?: number;
    [property: string]: any;
}

/**
 * [REFERRAL] user pressed joined friend button under your invites
 */
export interface UserPressedYourInvitesFriends {
    id?: string;
    [property: string]: any;
}

/**
 * [REFERRAL] user pressed joined host button under your invites
 */
export interface UserPressedYourInvitesHosts {
    id?: string;
    [property: string]: any;
}

/**
 * [POST BOOKING INVITE] (will be deprecated) user receives and opens a post booking invite
 */
export interface UserReceivedPostBookingInvite {
    /**
     * id of the booking this pertains to
     */
    bookingId: string;
    /**
     * is this user logged in to an existing account
     */
    isLoggedIn: boolean;
    [property: string]: any;
}

/**
 * [GUEST FAVORITE INVITE] user confirmed they wanted to leave Favorites List by pressing
 * "remove me from list"
 */
export interface UserRemovedThemselfFromFL {
    /**
     * the user id of the account who created the favorite collection
     */
    alphaUserId?: number;
    /**
     * an array of any favorite collection collaborator's user ids
     */
    betaUserIds?: any[];
    /**
     * the favorite collection id
     */
    favoriteCollectionId: number;
    /**
     * the name of the favorite collection
     */
    favoriteCollectionName: string;
    id?:                    string;
    /**
     * a boolean to identify whether the actions being taken to a favorite collection are being
     * done by the alpha user (1) or a beta user (0)
     */
    isAlphaUserId: boolean;
    [property: string]: any;
}

/**
 * [SEARCH] user pressed filter reset in filter menu
 */
export interface UserResetFilters {
    id?: string;
    [property: string]: any;
}

/**
 * [CHECKOUT] user saved new payment method in wallet
 */
export interface UserSavedAddPaymentMethodWallet {
    /**
     * id for the current checkout flow
     */
    checkoutId: string;
    /**
     * where did the user enter the wallet from
     */
    enteredFrom: UserSavedAddPaymentMethodWalletEnteredFrom;
    /**
     * did the payment successfully update
     */
    isSuccessful: boolean;
    /**
     * if the update failed, what is the reason or reasons
     */
    isUnsuccessfulReason: any[];
    /**
     * the id for the pool listing
     */
    listingId: string;
    /**
     * id of the newly saved payment optoin
     */
    paymentId?: string;
    /**
     * A products array to satisfy third party event processors
     */
    products?: UserSavedAddPaymentMethodWalletProduct[];
    /**
     * id for the search that led to this listing
     */
    searchId: null | string;
    /**
     * what type of payment was attempted to be added
     */
    updatedPaymentType?: string;
    [property: string]: any;
}

/**
 * where did the user enter the wallet from
 */
export enum UserSavedAddPaymentMethodWalletEnteredFrom {
    Backup = "backup",
    Checkout = "checkout",
    EditBooking = "edit-booking",
    PassManagement = "pass_management",
    Profile = "profile",
}

export interface UserSavedAddPaymentMethodWalletProduct {
    /**
     * The listing type of the relevant listing
     */
    category: string;
    /**
     * The title of the relevant listing
     */
    name: string;
    /**
     * The id of the relevant listing
     */
    productId: number;
    /**
     * Should always be 1
     */
    quantity: number;
    [property: string]: any;
}

/**
 * When a user screen shots while on Swimply
 */
export interface UserScreenShotted {
    /**
     * If the user is looking at a specific listing, please include the listing id
     */
    listingId?: null | string;
    /**
     * The name of the screen (or page) that the user is on when they screenshot
     */
    screenName: string;
    [property: string]: any;
}

export interface UserSearchedMessages {
    /**
     * Search string for messages
     */
    searchString?: string;
    [property: string]: any;
}

/**
 * [CHECKOUT] user selects the mandatory booking reason
 */
export interface UserSelectedBookingReason {
    bookingId?:      number;
    bookingMessage?: null | string;
    /**
     * guest selection (listing type specific) for why they're booking
     */
    bookingReason?:         BookingReason | null;
    bookingSpecialOfferId?: number | null;
    bookingStartDateTime?:  string;
    country:                string;
    /**
     * [LISTING TYPE] The type of the listing associated with this event
     */
    globalListingType: GlobalListingType;
    guestId:           number;
    hostId:            number;
    id?:               string;
    isInstantBooking:  boolean;
    listingId:         number;
    listingTitle:      string;
    market?:           string;
    totalGuests?:      number;
    totalPrice?:       number;
    [property: string]: any;
}

/**
 * [ACCOUNT CREATION] user selected the check box for sms notifications related to their
 * account
 */
export interface UserSelectedOptInSMSAccountNotification {
    /**
     * the authentication session ID
     */
    authId: string;
    [property: string]: any;
}

/**
 * [ACCOUNT CREATION] user selected the check box for sms notifications related to
 * promotions and marketing
 */
export interface UserSelectedOptInSMSNotification {
    /**
     * the authentication session ID
     */
    authId: string;
    [property: string]: any;
}

/**
 * [SEARCH] user selected popular filter
 */
export interface UserSelectedPopularFilter {
    /**
     * an array contains all amenities the user selected in the filter
     */
    amenities: any[];
    [property: string]: any;
}

/**
 * [POST BOOKING INVITE] user chose the method to send invites
 */
export interface UserSelectedPostBookingInviteMethod {
    /**
     * id of the booking this pertains to
     */
    bookingId: string;
    /**
     * did they enter this from reservation page, confirmation page, or the "who's coming" page
     */
    enteredFrom: string;
    /**
     * email, sms, link
     */
    methodSelected: MethodSelected;
    [property: string]: any;
}

/**
 * email, sms, link
 *
 *
 * emails, sms, etc
 */
export enum MethodSelected {
    Email = "email",
    Link = "link",
    SMS = "sms",
}

/**
 * User sent a message (with properties for lifecycle). Also an API event
 */
export interface UserSentMessage {
    /**
     * the payment currency of the last booking associated between this user and the recipient,
     * if any
     */
    lastAssociatedBookingCurrency?: string;
    /**
     * the date of the last booking associated between this user and the recipient, if any
     */
    lastAssociatedBookingDate?: string;
    /**
     * the end time of the last booking associated between this user and the recipient, if any
     */
    lastAssociatedBookingEndTime?: number;
    /**
     * the guest_id of the last booking associated between this user and the recipient, if any
     */
    lastAssociatedBookingGuestId?: number;
    /**
     * boolean for whether the booking has a pending special offer (so not accepted yet)
     */
    lastAssociatedBookingHasPendingSpecialOffer: boolean;
    /**
     * the host_id of the last booking associated between this user and the recipient, if any
     */
    lastAssociatedBookingHostId?: number;
    /**
     * the id of the last booking associated between this user and the recipient, if any
     */
    lastAssociatedBookingId?: number;
    /**
     * the listing id of the last booking associated between this user and the recipient, if any
     */
    lastAssociatedBookingListingId?: number;
    /**
     * the listing id photo url of the last booking associated between this user and the
     * recipient, if any
     */
    lastAssociatedBookingListingPhotoURL?: string;
    /**
     * the listing type of the last booking associated between this user and the recipient, if
     * any
     */
    lastAssociatedBookingListingType?: string;
    /**
     * the num guests of the last booking associated between this user and the recipient, if any
     */
    lastAssociatedBookingNumGuests?: number;
    /**
     * if the booking has a special offer, what is the special offer id
     */
    lastAssociatedBookingSpecialOfferId?: number | null;
    /**
     * if the booking has a special offer, what is the special offer price
     */
    lastAssociatedBookingSpecialOfferPrice?: number | null;
    /**
     * the start time of the last booking associated between this user and the recipient, if any
     */
    lastAssociatedBookingStartTime?: number;
    /**
     * the status of the last booking associated between this user and the recipient, if any
     */
    lastAssociatedBookingStatus?: string;
    /**
     * the payment total of the last booking associated between this user and the recipient, if
     * any
     */
    lastAssociatedBookingTotal?: number;
    /**
     * id of the message sent
     */
    messageSentId?: string;
    /**
     * sent message text
     */
    messageText: string;
    /**
     * first name of message recipient
     */
    recipientFirstName: string;
    /**
     * profile photo url of message recipient
     */
    recipientProfilePhotoURL: string;
    /**
     * user_id of message recipient
     */
    recipientUserId: number;
    /**
     * room_id for the message thread
     */
    roomId: string;
    /**
     * first name of message sender
     */
    senderFirstName: string;
    /**
     * last name of message sender
     */
    senderLastName: string;
    /**
     * profile photo url of message sender
     */
    senderProfilePhotoURL: string;
    /**
     * userId of message sender
     */
    senderUserId: number;
    [property: string]: any;
}

/**
 * [MESSAGING - PHOTOS]
 */
export interface UserSentPhoto {
    userIsHost: boolean;
    [property: string]: any;
}

/**
 * [SEO] When user select a date in search bar on the SEO page
 */
export interface UserSEOEditDate {
    /**
     * the displayed location of the current seo
     */
    currentSeoLocation: string;
    /**
     * the current seo space type
     */
    currentSeoSpaceType: ListingTypeEnum | null;
    /**
     * the displayed use case of the current seo, null if the seo page is not for use cases
     * (false in isUseCaseSeo)
     */
    currentUseCase: UserSEOEditDateCurrentUseCase | null;
    /**
     * the selected date
     */
    date: Date;
    /**
     * True if the seo is a use case type
     */
    isUseCaseSeo: boolean;
    [property: string]: any;
}

export enum UserSEOEditDateCurrentUseCase {
    AdaFriendlySwim = "ada-friendly-swim",
    AnniversaryParty = "anniversary-party",
    BabyShower = "baby-shower",
    BacheloretteParty = "bachelorette-party",
    BarMitzvahParty = "bar-mitzvah-party",
    BatMitzvahParty = "bat-mitzvah-party",
    BridalShower = "bridal-shower",
    CompanyOffsite = "company-offsite",
    CookingEvent = "cooking-event",
    CorporateEvent = "corporate-event",
    DinnerParty = "dinner-party",
    Event = "event",
    FamilySwim = "family-swim",
    GraduationParty = "graduation-party",
    Meeting = "meeting",
    NightSwim = "night-swim",
    Party = "party",
    PetFriendlySwim = "pet-friendly-swim",
    Photoshoot = "photoshoot",
    PoolParty = "pool-party",
    QuinceaneraParty = "quinceanera-party",
    VideoShoot = "video-shoot",
}

/**
 * [SEO] When user edit space type or use case drop down in search bar on the SEO page
 */
export interface UserSEOEditDropDown {
    /**
     * the displayed location of the current seo
     */
    currentSeoLocation: string;
    /**
     * the current seo space type
     */
    currentSeoSpaceType: ListingTypeEnum | null;
    /**
     * the displayed use case of the current seo, null if the seo page is not for use cases
     * (false in isUseCaseSeo)
     */
    currentUseCase: NewUseCaseEnum | null;
    /**
     * True if the seo is a use case type
     */
    isUseCaseSeo?: boolean;
    /**
     * the new space type, null when seo is a use case
     */
    newSpaceType?: ListingTypeEnum | null;
    /**
     * the new use case, null when seo is not a use case
     */
    newUseCase?: NewUseCaseEnum | null;
    [property: string]: any;
}

/**
 * [SEO] When user edit the location in search bar on the SEO page
 */
export interface UserSEOEditLocation {
    /**
     * the displayed location of the current seo
     */
    currentSeoLocation: string;
    /**
     * the current seo space type
     */
    currentSeoSpaceType: ListingTypeEnum | null;
    /**
     * the displayed use case of the current seo, null if the seo page is not for use cases
     * (false in isUseCaseSeo)
     */
    currentUseCase: NewUseCaseEnum | null;
    /**
     * True if the seo is a use case type
     */
    isUseCaseSeo: boolean;
    /**
     * the new location user entered
     */
    newLocation: string;
    [property: string]: any;
}

/**
 * [SEO] When user press the alternative SEO links in the bottom of the page
 */
export interface UserSEOPressedOtherSEOLink {
    /**
     * the displayed location of the current seo
     */
    currentSeoLocation: string;
    /**
     * the current seo space type
     */
    currentSeoSpaceType: ListingTypeEnum | null;
    /**
     * the displayed use case of the current seo, null if the seo page is not for use cases
     * (false in isUseCaseSeo)
     */
    currentUseCase: NewUseCaseEnum | null;
    /**
     * True if the seo is a use case type
     */
    isUseCaseSeo: boolean;
    /**
     * the new location of the alternative link
     */
    newLinkLocation: string;
    /**
     * the new space type of the alternative link
     */
    newLinkSpaceType: ListingTypeEnum | null;
    /**
     * the new use case of the alternative link
     */
    newLinkUseCase: NewUseCaseEnum | null;
    /**
     * the name of the section of the alternative link
     */
    sectionName: SectionName;
    [property: string]: any;
}

/**
 * the name of the section of the alternative link
 */
export enum SectionName {
    MorePrivateSpace = "morePrivateSpace",
    OtherNearby = "otherNearby",
    PerfectSpaces = "PerfectSpaces",
}

/**
 * [SEO] When user pressed to expand PLP description
 */
export interface UserSEOPressedToExpandReadMorePLP {
    /**
     * number of review displayed on the PLP
     */
    displayNumberReivew: number;
    /**
     * price displayed on the PLP
     */
    displayPrice: number;
    /**
     * rating displayed in the PLP
     */
    displayRating: number;
    /**
     * id of the listing
     */
    listingId: number;
    /**
     * location of the seo page
     */
    seoLocation: string;
    /**
     * space type of the seo page
     */
    seoSpaceType: ListingTypeEnum | null;
    /**
     * useCase of the seo page
     */
    seoUseCase: NewUseCaseEnum | null;
    [property: string]: any;
}

/**
 * [SEO] When user pressed to expand review
 */
export interface UserSEOPressedToExpandReview {
    /**
     * id of the booking review
     */
    reviewId: number;
    /**
     * location of the seo page
     */
    seoLocation: string;
    /**
     * space type of the seo page
     */
    seoSpaceType: ListingTypeEnum | null;
    /**
     * useCase of the seo page
     */
    seoUseCase: UserSEOEditDateCurrentUseCase | null;
    [property: string]: any;
}

/**
 * [CHECKOUT] user set a payment in the wallet
 */
export interface UserSetPaymentMethodInWallet {
    /**
     * id for the current checkout flow
     */
    checkoutId: string;
    /**
     * is the checkout for a pass purchase or a standard booking
     */
    checkoutType: CheckoutTypeEnum;
    /**
     * the previously applied paymentId, if applicable
     */
    existingPaymentId?: string;
    /**
     * is the selected payment option Apple Pay
     */
    isApplePay: boolean;
    /**
     * is the selected payment option Google Pay
     */
    isGooglePay: boolean;
    /**
     * is this a multi dip booking
     */
    isMultiDip: boolean;
    /**
     * the id for the pool listing
     */
    listingId: string;
    /**
     * the newly applied paymentId
     */
    newPaymentId: string;
    /**
     * if the booking was made or partially made with a pass, the pass id used
     */
    passId?: number | null;
    /**
     * the type of the pass formatted to be LCM friendly
     */
    passName?: null | string;
    /**
     * if the booking was made or partially made with a pass, what type of pass
     */
    passType?: GuestAcceptReviewChangesFromHostPassType | null;
    /**
     * id for the search that led to this listing
     */
    searchId: null | string;
    [property: string]: any;
}

/**
 * [SEARCH] did user adjust the map view area
 */
export interface UserShiftedMap {
    /**
     * new lat max of map result
     */
    newLatitudeMaximum: number;
    /**
     * new lat min of map result
     */
    newLatitudeMinimum: number;
    /**
     * new long max of map result
     */
    newLongitudeMaximum: number;
    /**
     * new long min of map result
     */
    newLongitudeMinimum: number;
    /**
     * id of search which generated result
     */
    searchId: null | string;
    [property: string]: any;
}

/**
 * [CHECKOUT] user selected to see more times on time selection screen
 */
export interface UserShowMoreTimesPressed {
    /**
     * id for the current checkout flow
     */
    checkoutId: string;
    /**
     * the id for the pool listing
     */
    listingId: string;
    /**
     * new time values displayed
     */
    newTimesDisplayed: any[];
    /**
     * original time values displayed
     */
    originalTimesDisplayed: any[];
    /**
     * id for the search that led to this listing
     */
    searchId: null | string;
    /**
     * is there still a "still show more" option post press?
     */
    stillShowMore: boolean;
    [property: string]: any;
}

/**
 * [ACCOUNT CREATION] user entered the screen for sign in or sign up
 */
export interface UserStartedAuth {
    /**
     * the authentication session ID
     */
    authId: string;
    /**
     * How did we enter into the user creation flow?
     */
    enteredFrom: UserLeadInitiatedAccountCreationMethodEnteredFrom;
    [property: string]: any;
}

/**
 * [MESSAGING - CALLING]
 */
export interface UserStartedCall {
    /**
     * the booking shown when the user clicks to see the reservation on chat - logic defined by
     * Mojin in Chat Redesign PRD
     */
    bookingId: number;
    callType:  CallType;
    /**
     * the guest for the booking
     */
    guestId: number;
    /**
     * the host for the booking
     */
    hostId: number;
    id?:    string;
    /**
     * the listing for the booking
     */
    listingId: number;
    /**
     * the room id for the chat
     */
    roomId:     string;
    userIsHost: boolean;
    [property: string]: any;
}

/**
 * [REFERRAL] user submitted and sent invites to friends via email
 */
export interface UserSubmitInviteViaEmail {
    /**
     * contact info of all friends in array form
     */
    selectedFriendContactInfo: UserSubmitInviteViaEmailSelectedFriendContactInfo[];
    [property: string]: any;
}

export interface UserSubmitInviteViaEmailSelectedFriendContactInfo {
    /**
     * Email address of friend
     */
    selectedContactEmailAddress: string;
    /**
     * First name of friend
     */
    selectedContactFirstName?: string;
    [property: string]: any;
}

/**
 * [SEARCH] the AI search the user submitted with booking details and filter selections
 */
export interface UserSubmittedAISearch {
    /**
     * date the user entered
     */
    date?: null | string;
    /**
     * True if the user selected instant book, false otherwise
     */
    isInstant?: boolean;
    /**
     * the latitude of the location the user searched
     */
    latitude?: number;
    /**
     * the longitude of the location the user searched
     */
    longitude?: number;
    /**
     * the maximum distance the user filtered on
     */
    maxDistance?: number;
    /**
     * the measurement unit type used to filter on (miles or km)
     */
    maxDistanceMeasurementUnit?: MaxDistanceMeasurementUnit;
    /**
     * the price the user filtered on
     */
    price?: UserSubmittedAISearchPrice;
    /**
     * id of search which generated result
     */
    searchId?: null | string;
    /**
     * starting time the user entered
     */
    startTime?: number | null;
    /**
     * what the user input for their search when using AI search - null when the user didn't
     * search via AI search
     */
    termsInputAISearch?: null | string;
    [property: string]: any;
}

/**
 * the measurement unit type used to filter on (miles or km)
 */
export enum MaxDistanceMeasurementUnit {
    KM = "km",
    Mi = "mi",
}

/**
 * the price the user filtered on
 */
export interface UserSubmittedAISearchPrice {
    /**
     * the maximum price the user filtered on
     */
    highPrice?: number | null;
    /**
     * the minimum price the user filtered on
     */
    lowPrice?: number;
    [property: string]: any;
}

/**
 * [USER PROFILE - Account Details] user pressed save with changes to their account
 */
export interface UserSubmittedAccountChange {
    /**
     * original birthday
     */
    birthdayFrom?: string;
    /**
     * null if no change
     */
    birthdayTo?: null | string;
    /**
     * which account details were changed (possible values are email, birthday, and password -
     * not mutually exclusive)
     */
    changedFields: any[];
    /**
     * original email
     */
    emailFrom?: string;
    /**
     * null if no change
     */
    emailTo?: null | string;
    [property: string]: any;
}

/**
 * [CHECKOUT] send event *per amenity selected*
 */
export interface UserSubmittedAmenity {
    amenities: UserSubmittedAmenityAmenity[];
    /**
     * id for the current checkout flow
     */
    checkoutId: string;
    /**
     * currency of fees if applicable
     */
    currency: string;
    /**
     * did user come to this screen via a reservation edit
     */
    enteredFromReservationEdit: boolean;
    /**
     * the id for the pool listing
     */
    listingId: string;
    /**
     * id for the search that led to this listing
     */
    searchId: null | string;
    [property: string]: any;
}

export interface UserSubmittedAmenityAmenity {
    /**
     * text blurb about the amenity
     */
    amenityDescription?: null | string;
    amenityFeeDetails:   MischievousAmenityFeeDetails;
    /**
     * name of amenity
     */
    amenityName: string;
    /**
     * is this a custom amenity from the host
     */
    isCustomAmenity: boolean;
    /**
     * does this amenity have a fee
     */
    isFee: boolean;
    /**
     * was this amenity pre selected
     */
    wasPreSelected: boolean;
    [property: string]: any;
}

export interface MischievousAmenityFeeDetails {
    /**
     * flat fee amount if it exists, otherwise 0
     */
    flatFeeAmount: number;
    /**
     * hourly fee amount if it exists, otherwise 0
     */
    hourlyFeeAmount: number;
    /**
     * does this amenity have a flat fee
     */
    isFlatFee: boolean;
    /**
     * does this amenity have an hourly fee
     */
    isHourlyFee: boolean;
    [property: string]: any;
}

/**
 * [SEARCH] user submitted the search by pressed "show me pools" in the Find a space screen
 */
export interface UserSubmittedBookingDetails {
    /**
     * number of adult guests the user entered
     */
    adultGuests: number;
    /**
     * the category tab the user selected, default as 'all spaces'
     */
    categoryTab: string;
    /**
     * number of children guests the user entered
     */
    childGuests: number;
    /**
     * date the user entered
     */
    date: null | string;
    /**
     * ending time the user entered
     */
    endTime: number | null;
    /**
     * number of infant guests the user entered
     */
    infantCount: number;
    /**
     * number of pet guests the user entered
     */
    petCount: number;
    /**
     * starting time the user entered
     */
    startTime: number | null;
    [property: string]: any;
}

/**
 * [GUEST FAVORITE] user adjusted or added booking details by changing the date, time, or
 * guest count
 */
export interface UserSubmittedBookingDetailsToFL {
    adultGuests: number;
    /**
     * the user id of the account who created the favorite collection
     */
    alphaUserId?: number;
    /**
     * an array of any favorite collection collaborator's user ids
     */
    betaUserIds?: any[];
    childGuests:  number;
    date:         null | string;
    endTime?:     number | null;
    /**
     * the favorite collection id
     */
    favoriteCollectionId: number;
    /**
     * the name of the favorite collection
     */
    favoriteCollectionName: string;
    infantCount:            number;
    /**
     * a boolean to identify whether the actions being taken to a favorite collection are being
     * done by the alpha user (1) or a beta user (0)
     */
    isAlphaUserId: boolean;
    petCount:      number;
    startTime?:    number | null;
    [property: string]: any;
}

/**
 * [POST BOOKING INVITE] information on all submitted invites
 */
export interface UserSubmittedBookingInvites {
    /**
     * id of the booking this pertains to
     */
    bookingId: string;
    /**
     * list of all recipients the invite was sent to
     */
    inviteRecipients: InviteRecipient[];
    /**
     * message blurb sent to all new guests
     */
    messageAdded?: string;
    /**
     * emails, sms, etc
     */
    methodSelected: MethodSelected;
    [property: string]: any;
}

export interface InviteRecipient {
    /**
     * phone number if phone, email if email
     */
    guestContactInfo: string;
    /**
     * user input first name
     */
    guestFirstName?: string;
    [property: string]: any;
}

/**
 * [PLP] user submitted contact host from PLP
 */
export interface UserSubmittedContactHostRequest {
    /**
     * end time for the booking request, in military format (1:30PM = 13.5)
     */
    bookingEndTime: number;
    /**
     * total number of adults for booking inquiry
     */
    bookingNumAdults: number;
    /**
     * total number of children for booking inquiry
     */
    bookingNumChildren: number;
    /**
     * total number of infants for booking inquiry
     */
    bookingNumInfants: number;
    /**
     * total number of pets for booking inquiry
     */
    bookingNumPets: number;
    /**
     * start time for the booking request, in military format (1:30PM = 13.5)
     */
    bookingStartTime: number;
    /**
     * total number of all guests for booking inquiry
     */
    bookingTotalGuests: number;
    /**
     * total estimated price for booking based on time + guest count
     */
    bookingTotalPrice: number;
    /**
     * checkoutId created for subsequent time, user, and reason events
     */
    checkoutId: string;
    /**
     * date selected for the booking inquiry
     */
    dateSelected: string;
    /**
     * [LISTING TYPE] The type of the listing associated with this event
     */
    globalListingType: GlobalListingType;
    /**
     * city name of the listing
     */
    listingCity: string;
    /**
     * url for the listing cover photo
     */
    listingCoverPhotoUrl: string;
    /**
     * id the the listing favorited
     */
    listingId: string;
    /**
     * price for the listing (factoring in the guest count)
     */
    listingPrice: number;
    /**
     * daily price for the listing (factoring in the guest count)
     */
    listingPriceType: PriceType;
    /**
     * state/region name for the listing
     */
    listingState: string;
    /**
     * title for the listing
     */
    listingTitle: string;
    /**
     * the id of the message created
     */
    messageId: string;
    /**
     * the text contained in the message sent to the host
     */
    messageText: string;
    /**
     * the ID of the message thread started with host
     */
    roomId: string;
    /**
     * search they entered the listing from, if applicable
     */
    searchId: null | string;
    [property: string]: any;
}

/**
 * [GUEST FAVORITE INVITE] fires when a user actually sends an email invite to a favorites
 * list
 */
export interface UserSubmittedFLInviteFriendsViaEmail {
    /**
     * the user id of the account who created the favorite collection
     */
    alphaUserId?: number;
    /**
     * an array of any favorite collection collaborator's user ids
     */
    betaUserIds?: any[];
    /**
     * the favorite collection id
     */
    favoriteCollectionId: number;
    /**
     * the name of the favorite collection
     */
    favoriteCollectionName: string;
    id?:                    string;
    /**
     * a boolean to identify whether the actions being taken to a favorite collection are being
     * done by the alpha user (1) or a beta user (0)
     */
    isAlphaUserId: boolean;
    /**
     * contact info of all friends in array form
     */
    selectedFriendContactInfo: UserSubmittedFLInviteFriendsViaEmailSelectedFriendContactInfo[];
    [property: string]: any;
}

export interface UserSubmittedFLInviteFriendsViaEmailSelectedFriendContactInfo {
    /**
     * email address of friend
     */
    selectedContactEmailAddress: string;
    /**
     * first name of friend
     */
    selectedContactFirstName?: string;
    [property: string]: any;
}

/**
 * [GUEST FAVORITE INVITE] fires when a user actually sends an email invite to a favorites
 * list
 */
export interface UserSubmittedFLInviteFriendsViaText {
    /**
     * the user id of the account who created the favorite collection
     */
    alphaUserId?: number;
    /**
     * an array of any favorite collection collaborator's user ids
     */
    betaUserIds?: any[];
    /**
     * the favorite collection id
     */
    favoriteCollectionId: number;
    /**
     * the name of the favorite collection
     */
    favoriteCollectionName: string;
    id?:                    string;
    /**
     * a boolean to identify whether the actions being taken to a favorite collection are being
     * done by the alpha user (1) or a beta user (0)
     */
    isAlphaUserId: boolean;
    /**
     * contact info of all friends in array form
     */
    selectedFriendContactInfo: UserSubmittedFLInviteFriendsViaTextSelectedFriendContactInfo[];
    [property: string]: any;
}

export interface UserSubmittedFLInviteFriendsViaTextSelectedFriendContactInfo {
    /**
     * first name of friend
     */
    selectedContactFirstName?: string;
    /**
     * last name of friend
     */
    selectedContactLastName?: string;
    /**
     * phone number of friend
     */
    selectedContactPhoneNumber: string;
    [property: string]: any;
}

/**
 * [SEARCH] the filter selections the user submitted
 */
export interface UserSubmittedFilter {
    /**
     * additional spaces requested (ie home with a basketball court)
     */
    additionalSpaces?: string;
    /**
     * any generic space type features that a user filters for
     */
    amenities: any[];
    /**
     * the amount of days before a booking where the user can cancel for free
     */
    cancellationPolicy: string;
    /**
     * the category tab the user selected, default as 'all spaces'
     */
    categoryTab: CategoryTab;
    /**
     * any specific use cases that the user filters for in the categories tab
     */
    categoryUseCase: CategoryUseCase;
    /**
     * any generic space type features that a user filters for
     */
    features: any[];
    /**
     * any great for stickers selected in the great for section
     */
    greatForUseCase?: any[];
    /**
     * whether the listings has passes available (1 if true, 0 if false)
     */
    hasPass: boolean;
    /**
     * true if the user filtered for only listings offering promotions, false otherwise
     */
    isDeal: boolean;
    /**
     * True if the user selected instant book, false otherwise
     */
    isInstant: boolean;
    /**
     * true if the user input a keyword (either via filters or the keyword search option)
     */
    isKeywordSearch: boolean;
    /**
     * the keywords input (null if none)
     */
    keywords?: null | string;
    /**
     * any listing type specific amenities that a user filters for
     */
    listingAmenities: any[];
    /**
     * any listing type specific features that a user filters for
     */
    listingFeatures: any[];
    /**
     * the maximum distance the user filtered on
     */
    maxDistance: number;
    /**
     * the measurement unit type used to filter on (miles or km)
     */
    maxDistanceMeasurementUnit: MaxDistanceMeasurementUnit;
    /**
     * if the listing has one or more active passes, list the pass ids in an array
     */
    passIds: any[] | null;
    /**
     * the types of passes available for a listing - null if it doesn't have any
     */
    passTypes: any[] | null;
    /**
     * the price the user filtered on
     */
    price: UserSubmittedFilterPrice;
    /**
     * how private the user wants the listing
     */
    privacyPreference: string;
    /**
     * listing requirements for the user
     */
    requirements: UserSubmittedFilterRequirements;
    /**
     * where the user wants the booking to occur: indoor, outdoor, or both
     */
    setting: UserSubmittedFilterSetting;
    /**
     * listing type specific requirements
     */
    subSpaceType?: null | string;
    /**
     * type of water in the pool
     */
    waterType?: null | string;
    [property: string]: any;
}

/**
 * the category tab the user selected, default as 'all spaces'
 */
export enum CategoryTab {
    All = "all",
    Discover = "discover",
    Home = "home",
    Hoops = "hoops",
    PC = "pc",
    PetPark = "pet_park",
    Pickleball = "pickleball",
    Pool = "pool",
    Tennis = "tennis",
}

/**
 * any specific use cases that the user filters for in the categories tab
 *
 * any specific use cases that the user filters for (called the great for section)
 */
export enum CategoryUseCase {
    All = "all",
    Apartment = "apartment",
    Backyard = "backyard",
    Bar = "bar",
    Budget = "budget",
    Conference = "conference",
    Corporate = "corporate",
    Deal = "deal",
    Dinner = "dinner",
    EventVenue = "event_venue",
    Family = "family",
    Grill = "grill",
    Heated = "heated",
    HotTub = "hot_tub",
    House = "house",
    Indoor = "indoor",
    Loft = "loft",
    Mansion = "mansion",
    Meeting = "meeting",
    Movie = "movie",
    Multicourt = "multicourt",
    Night = "night",
    Outdoor = "outdoor",
    Party = "party",
    Pass = "pass",
    Pet = "pet",
    Photo = "photo",
    Plunge = "plunge",
    Pool = "pool",
    Restaurant = "restaurant",
    Rooftop = "rooftop",
    Sports = "sports",
    Studio = "studio",
    Vip = "vip",
    Warehouse = "warehouse",
    Wedding = "wedding",
}

/**
 * the price the user filtered on
 */
export interface UserSubmittedFilterPrice {
    /**
     * the maximum price the user filtered on
     */
    highPrice?: number | null;
    /**
     * the minimum price the user filtered on
     */
    lowPrice: number;
    [property: string]: any;
}

/**
 * listing requirements for the user
 */
export interface UserSubmittedFilterRequirements {
    /**
     * selected the ada compliant filter
     */
    adaCompliant: boolean;
    /**
     * user selected to show kid friendly listings only
     */
    kidsRequired: boolean;
    /**
     * user selected to show listings with parking only
     */
    parkingRequired: boolean;
    /**
     * user selected to show pet friendly listings only
     */
    petRequired: boolean;
    /**
     * user selected to show listings with restroom only
     */
    restroomRequired: boolean;
    [property: string]: any;
}

/**
 * where the user wants the booking to occur: indoor, outdoor, or both
 */
export interface UserSubmittedFilterSetting {
    /**
     * true if the user wants to have their booking indoors
     */
    settingIndoor: boolean;
    /**
     * true if the user wants to have their booking outdoors
     */
    settingOutdoor: boolean;
    [property: string]: any;
}

/**
 * [USER PROFILE - Account Verification] user submitted their id to have their profile
 * verified
 */
export interface UserSubmittedProfileVerificationID {
    id?: string;
    [property: string]: any;
}

/**
 * [POST BOOKING REVIEW] user pressed a rating value on booking review
 */
export interface UserSubmittedRatingValue {
    /**
     * id of the booking associated with the review
     */
    bookingId: number;
    /**
     * id of the listing being reviewed
     */
    listingId: number;
    /**
     * the maximum value the user could have selected for rating
     */
    ratingValueMaximum: number;
    /**
     * the minimum value the user could have selected for rating
     */
    ratingValueMinimum: number;
    /**
     * rating value selected
     */
    ratingValueSubmitted: number;
    [property: string]: any;
}

/**
 * [WEB HOMEPAGE] User submitted their phone number on mweb to get a link to download the app
 */
export interface UserSubmittedSMSForm {
    /**
     * the phone number input
     */
    phoneNumber: string;
    [property: string]: any;
}

/**
 * [SEARCH] the search the user submitted with booking details and filter selections
 */
export interface UserSubmittedSearch {
    /**
     * additional spaces requested (ie home with a basketball court)
     */
    additionalSpaces?: string;
    /**
     * number of adult guests the user entered
     */
    adultGuests: number;
    /**
     * any generic space type amenities that a user filters for
     */
    amenities: any[];
    /**
     * the amount of days before a booking where the user can cancel for free
     */
    cancellationPolicy: string;
    /**
     * the category tab the user selected, default as 'all spaces'
     */
    categoryTab: CategoryTab;
    /**
     * any specific use cases that the user filters for (called the great for section)
     */
    categoryUseCase: CategoryUseCase;
    /**
     * number of children guests the user entered
     */
    childGuests?: number;
    /**
     * date the user entered
     */
    date?: null | string;
    /**
     * ending time the user entered
     */
    endTime?: number | null;
    /**
     * any generic space type features that a user filters for
     */
    features?: any[];
    /**
     * any great for stickers selected in the great for section
     */
    greatForUseCase?: any[];
    /**
     * whether the listings has passes available (1 if true, 0 if false)
     */
    hasPass: boolean;
    /**
     * number of infant guests the user entered
     */
    infantGuests?: number;
    /**
     * true if the user filtered for only listings offering promotions, false otherwise
     */
    isDeal: boolean;
    /**
     * True if the user selected instant book, false otherwise
     */
    isInstant?: boolean;
    /**
     * true if the user input a keyword (either via filters or the keyword search option)
     */
    isKeywordSearch: boolean;
    /**
     * the keywords input (null if none)
     */
    keywords?: null | string;
    /**
     * the latitude of the location the user searched
     */
    latitude: number;
    /**
     * any listing type specific amenities that a user filters for
     */
    listingAmenities: any[];
    /**
     * any listing type specific features that a user filters for
     */
    listingFeatures: any[];
    /**
     * the longitude of the location the user searched
     */
    longitude: number;
    /**
     * the maximum distance the user filtered on
     */
    maxDistance: number;
    /**
     * the measurement unit type used to filter on (miles or km)
     */
    maxDistanceMeasurementUnit: MaxDistanceMeasurementUnit;
    /**
     * if the listing has one or more active passes, list the pass ids in an array
     */
    passIds: any[] | null;
    /**
     * the types of passes available for a listing - null if it doesn't have any
     */
    passTypes: any[] | null;
    /**
     * number of pet guests the user entered
     */
    petGuests?: number;
    /**
     * postal code of the user
     */
    postalCode?: null | string;
    /**
     * source of postal code (geolocation or user_input)
     */
    postalCodeSource?: null | string;
    /**
     * the price the user filtered on
     */
    price: UserSubmittedSearchPrice;
    /**
     * how private the user wants the listing
     */
    privacyPreference: string;
    /**
     * listing requirements the user filtered for
     */
    requirements: UserSubmittedSearchRequirements;
    /**
     * id of search which generated result
     */
    searchId: null | string;
    /**
     * search type which indicates which action trigger the search event (find pool near me,
     * homepage - enter location or/and date to search, search - edit date/ location/ add filter
     * in search result)
     */
    searchType: SearchType;
    /**
     * the displaye location if user search in SEO page, null if they search in other flow
     */
    seoLocation?: null | string;
    /**
     * the displayed seo space type if user search in SEO page, null if they search in other flow
     */
    seoSpaceType?: ListingTypeEnum | null;
    /**
     * the displayed use case if user search in SEO page, null if they search in other flow
     */
    seoUseCase?: SEOUseCase | null;
    /**
     * where the user wants the booking to occur: indoor or outdoor
     */
    setting: UserSubmittedSearchSetting;
    /**
     * starting time the user entered
     */
    startTime?: number | null;
    /**
     * listing type specific requirements
     */
    subSpaceType?: null | string;
    /**
     * what the user input for their search when using AI search - null when the user didn't
     * search via AI search
     */
    termsInputAISearch?: null | string;
    /**
     * water type the user selected (salt water or chlorine)
     */
    waterType?: null | string;
    [property: string]: any;
}

/**
 * the price the user filtered on
 */
export interface UserSubmittedSearchPrice {
    /**
     * the maximum price the user filtered on
     */
    highPrice?: number | null;
    /**
     * the minimum price the user filtered on
     */
    lowPrice: number;
    [property: string]: any;
}

/**
 * listing requirements the user filtered for
 */
export interface UserSubmittedSearchRequirements {
    /**
     * True if the user selected the ADA compliant filter, false otherwise
     */
    adaCompliantFilter: boolean;
    /**
     * True if the user selected to see kid friendly listings only
     */
    kidsFilter: boolean;
    /**
     * True if the user selected to only see listings with parking
     */
    parkingFilter: boolean;
    /**
     * True if the user enabled the pet filter, false otherwise
     */
    petFilter: boolean;
    /**
     * true if search has a restroom filter, false otherwise
     */
    restroomFilter: boolean;
    [property: string]: any;
}

/**
 * search type which indicates which action trigger the search event (find pool near me,
 * homepage - enter location or/and date to search, search - edit date/ location/ add filter
 * in search result)
 */
export enum SearchType {
    Default = "default",
    FindPoolNearMe = "find pool near me",
    Homepage = "homepage",
    HomepageCategory = "homepage category",
    MovedMap = "moved map",
    SEOSearchBar = "seo search bar",
    SEOSeeMoreSpaces = "seo see more spaces",
    SearchAddFilters = "search add filters",
    SearchCategoryTab = "search category tab",
    SearchEditDate = "search edit date",
    SearchEditDetailsApp = "search edit details app",
    SearchEditGuestCount = "search edit guest count",
    SearchEditLocation = "search edit location",
    SearchEditTime = "search edit time",
    SearchOnAppLoad = "search on app load",
}

export enum SEOUseCase {
    BabyShower = "baby-shower",
    BridalShower = "bridal-shower",
    CompanyOffsite = "company-offsite",
    CookingEvent = "cooking-event",
    CorporateEvent = "corporate-event",
    DinnerParty = "dinner-party",
    Event = "event",
    Meeting = "meeting",
    Party = "party",
    Photoshoot = "photoshoot",
    VideoShoot = "video-shoot",
}

/**
 * where the user wants the booking to occur: indoor or outdoor
 */
export interface UserSubmittedSearchSetting {
    /**
     * true if the user filtered to have their booking indoors
     */
    settingIndoor: boolean;
    /**
     * true if the user filtered to have their booking outdoors
     */
    settingOutdoor: boolean;
    [property: string]: any;
}

/**
 * [CHECKOUT] selected time range on time+date modification screen
 */
export interface UserSubmittedTimeRange {
    /**
     * start time for booking
     */
    beginTime: number;
    /**
     * id for the current checkout flow
     */
    checkoutId: string;
    /**
     * displayed price thus far
     */
    displayedPriceTotal: number;
    /**
     * end time for booking
     */
    endTime: number;
    /**
     * did they enter this item from the "contact host" PLP flow
     */
    enteredFromContactHostFlow: boolean;
    /**
     * did they enter this item from the PLP
     */
    enteredFromPLP: boolean;
    /**
     * did user come to this screen via a reservation edit
     */
    enteredFromReservationEdit?: boolean;
    /**
     * the id for the pool listing
     */
    listingId: string;
    /**
     * id for the search that led to this listing
     */
    searchId: null | string;
    [property: string]: any;
}

/**
 * [POST BOOKING REVIEW] user submitted written review
 */
export interface UserSubmittedWrittenReviewText {
    /**
     * text submitted for review
     */
    blurb: string;
    /**
     * id of the booking associated with the review
     */
    bookingId: number;
    /**
     * id of the listing being reviewed
     */
    listingId: number;
    [property: string]: any;
}

/**
 * [REFERRAL] user selected the friends tab on the your invites page (Guests tab for hosts)
 */
export interface UserSwitchedToFriendsInviteWithinTrackInvitesPage {
    id?: string;
    [property: string]: any;
}

/**
 * [REFERRAL] user selected the host tab on the your invites page
 */
export interface UserSwitchedToHostsInviteWithinTrackInvitesPage {
    id?: string;
    [property: string]: any;
}

/**
 * [SEARCH] the user updated a filter
 */
export interface UserUpdatedFilters {
    /**
     * the name of the filter selected ie "price"
     */
    updatedFilterName: string;
    /**
     * the value filtered ie "10", "400"
     */
    updatedFilterValue: any[];
    [property: string]: any;
}

/**
 * [USER PROFILE - Account Details] user added a new phone number and pressed update
 */
export interface UserUpdatedPhoneNumber {
    id?: string;
    [property: string]: any;
}

/**
 * [USER PROFILE - Account Details] user verified their new phone number
 */
export interface UserVerifiedPhoneNumber {
    id?: string;
    [property: string]: any;
}

/**
 * [PARTY BANNER] user viewed the form by clicking the party banner
 */
export interface UserViewFormPartyBanner {
    id?: string;
    [property: string]: any;
}

/**
 * [COZYMEAL] User viewed the Cozymeal catering options page
 */
export interface UserViewedCozymealBookingAdditions {
    bookingId?:              number;
    cozyMealListingIdsShown: any[];
    enteredFrom:             UserViewedCozymealBookingAdditionsEnteredFrom;
    guestId:                 number;
    hostId:                  number;
    listingId:               number;
    [property: string]: any;
}

export enum UserViewedCozymealBookingAdditionsEnteredFrom {
    PostBookingPopUp = "post_booking_pop_up",
    ReservationDetails = "reservation_details",
}

/**
 * [COZYMEAL] User viewed the Cozymeal catering post booking pop up
 */
export interface UserViewedCozymealBookingAdditionsPopUp {
    bookingId?: number;
    guestId:    number;
    hostId:     number;
    id?:        string;
    listingId:  number;
    [property: string]: any;
}

/**
 * user pressed to view profile of member in chat
 */
export interface UserViewedMemberProfileFromMessages {
    /**
     * did the profile have a photo
     */
    associatedUserHasPhoto: boolean;
    /**
     * did the profile have reviews
     */
    associatedUserHasReviews: boolean;
    /**
     * user_id of who's profile was viewed
     */
    associatedUserId: number;
    /**
     * is the associated user profile verified
     */
    associatedUserIsVerified: boolean;
    [property: string]: any;
}

/**
 * User viewed an unread message. Replaces current "ViewedMessage" api event. Also an API
 * event
 */
export interface UserViewedMessage {
    /**
     * the payment currency of the last booking associated between this user and the recipient,
     * if any
     */
    lastAssociatedBookingCurrency?: string;
    /**
     * the date of the last booking associated between this user and the recipient, if any
     */
    lastAssociatedBookingDate?: string;
    /**
     * the end time of the last booking associated between this user and the recipient, if any
     */
    lastAssociatedBookingEndTime?: number;
    /**
     * the guest_id of the last booking associated between this user and the recipient, if any
     */
    lastAssociatedBookingGuestId?: number;
    /**
     * the host_id of the last booking associated between this user and the recipient, if any
     */
    lastAssociatedBookingHostId?: number;
    /**
     * the id of the last booking associated between this user and the recipient, if any
     */
    lastAssociatedBookingId?: number;
    /**
     * the listing id of the last booking associated between this user and the recipient, if any
     */
    lastAssociatedBookingListingId?: number;
    /**
     * the listing id photo url of the last booking associated between this user and the
     * recipient, if any
     */
    lastAssociatedBookingListingPhotoURL?: string;
    /**
     * the listing type of the last booking associated between this user and the recipient, if
     * any
     */
    lastAssociatedBookingListingType?: string;
    /**
     * the num guests of the last booking associated between this user and the recipient, if any
     */
    lastAssociatedBookingNumGuests?: number;
    /**
     * the start time of the last booking associated between this user and the recipient, if any
     */
    lastAssociatedBookingStartTime?: number;
    /**
     * the status of the last booking associated between this user and the recipient, if any
     */
    lastAssociatedBookingStatus?: string;
    /**
     * the payment total of the last booking associated between this user and the recipient, if
     * any
     */
    lastAssociatedBookingTotal?: number;
    /**
     * sent message text
     */
    messageText?: null | string;
    /**
     * id of the message viewed
     */
    messageViewedId?: string;
    /**
     * first name of message recipient
     */
    recipientFirstName: string;
    /**
     * profile photo url of message recipient
     */
    recipientProfilePhotoURL: string;
    /**
     * user_id of message recipient
     */
    recipientUserId: number;
    /**
     * room_id for the message thread
     */
    roomId: string;
    /**
     * first name of message sender
     */
    senderFirstName: string;
    /**
     * last name of message sender
     */
    senderLastName: string;
    /**
     * profile photo url of message sender
     */
    senderProfilePhotoURL: string;
    /**
     * userId of message sender
     */
    senderUserId: number;
    [property: string]: any;
}

/**
 * user viewed the message tab
 */
export interface UserViewedMessageTab {
    /**
     * how did the user get to the message tab
     */
    enteredFrom: string;
    /**
     * viewed as host or guest
     */
    viewedAsRole: string;
    [property: string]: any;
}

/**
 * [SEARCH] displayed weather widget in search
 */
export interface UserViewedWeather {
    /**
     * degree of weather displayed
     */
    temperatureDisplayedFahrenheit: number;
    /**
     * where was this weather info displayed
     */
    viewedFrom: ViewedFrom;
    /**
     * string category of weather type displayed (sunny, cloudy, etc)
     */
    weatherTypeDisplayed: null | string;
    [property: string]: any;
}

/**
 * where was this weather info displayed
 */
export enum ViewedFrom {
    CategoriesSearchBar = "categoriesSearchBar",
    DateSelectionToday = "dateSelectionToday",
    DateSelectionTomorrow = "dateSelectionTomorrow",
    HostDashboard = "hostDashboard",
}

/**
 * [PLP] user entered PLP
 */
export interface ViewedListing {
    /**
     * if the listing has an active deal, what percent amount off of this promo code (1-100)
     */
    amountOff?: number | null;
    /**
     * city of the listing
     */
    city: string;
    /**
     * the url of the listing cover image
     */
    coverImageUrl: string;
    /**
     * if the listing has an active deal, when is the expiration
     */
    expireDate?: null | string;
    /**
     * [LISTING TYPE] The type of the listing associated with this event
     */
    globalListingType: GlobalListingType;
    /**
     * does the listing have an active pass
     */
    hasActivePass: boolean;
    /**
     * does the listing have a currently active deal (1 - yes, 0 - no)
     */
    hasDeal: boolean;
    /**
     * whether the listings has passes available (1 if true, 0 if false)
     */
    hasPass: boolean;
    /**
     * does the listing have a pass upsell displayed
     */
    hasPassUpsellDisplayed: boolean;
    /**
     * the id of the listing
     */
    listingId: string;
    /**
     * if the listing has one or more active passes, list the pass ids in an array
     */
    passIds?: any[] | null;
    /**
     * the types of passes available for a listing - null if it doesn't have any
     */
    passTypes: any[] | null;
    /**
     * If the guest is shown an expiring discount towards the pass purchase, how much is it for
     * (null if it's expired or not sh...
     */
    passUpsellCreditAmountOffer?: number;
    /**
     * displayed price of the listing
     */
    price: number;
    /**
     * the format of the price of the listing
     */
    priceType: PriceType;
    /**
     * state of the listing
     */
    state: string;
    [property: string]: any;
}

/**
 * Ajv is a peer dependency for development builds. It's used to apply run-time validation
 * to message payloads before passing them on to the underlying analytics instance.
 *
 * Note that the production bundle does not depend on Ajv.
 * 
 * You can install it with: `npm install --save-dev ajv`.
 */
import Ajv, { ErrorObject } from 'ajv'

/**
 * The analytics.js snippet should be available via window.analytics.
 * You can install it by following instructions at: https://segment.com/docs/connections/sources/catalog/libraries/website/javascript/
 * Make sure to also include the TypeScript declarations with: `npm install @segment/analytics-next` (install with --save-dev for type definitions only).
 *
 * If you don't want to use the snippet, you can also install the `@segment/analytics-next` library as a *production* dependency and use it like this: 
 * ```ts
 * import { AnalyticsBrowser } from '@segment/analytics-next' 
 * import { setTypewriterOptions } from './analytics'
 *
 * const analytics = AnalyticsBrowser.load({ writeKey: 'SEGMENT_WRITE_KEY' })
 * 
 * setTypewriterOptions({ analytics: analytics })
 */
import type { AnalyticsSnippet, Analytics, AnalyticsBrowser, Options } from '@segment/analytics-next'

declare global {
    interface Window {
        analytics: AnalyticsSnippet;
    }
}

type AnyAnalytics = AnalyticsSnippet | Analytics | AnalyticsBrowser

/** The callback exposed by analytics.js. */
export type Callback = () => void

export type ViolationHandler = (
    message: Record<string, any>,
    violations: ErrorObject[]
) => void

/**
 * The default handler that is fired if none is supplied with setTypewriterOptions.
 * This handler will log a warning message to the console.
 */
export const defaultValidationErrorHandler: ViolationHandler = (message, violations) => {
    const msg = JSON.stringify(
        {
            type: 'Typewriter JSON Schema Validation Error',
            description:
                `You made an analytics call (${message.event}) using Typewriter that doesn't match the ` +
                'Tracking Plan spec.',
            errors: violations,
        },
        undefined,
        2,
    );

    console.warn(msg);
};

let onViolation = defaultValidationErrorHandler

let analytics: () => AnyAnalytics | undefined = () => {
    return window.analytics;
};

/** Options to customize the runtime behavior of a Typewriter client. */
export interface TypewriterOptions {
    /**
     * Underlying analytics instance where analytics calls are forwarded on to.
     * Defaults to window.analytics.
     */
    analytics?: AnyAnalytics;
    /**
     * Handler fired when if an event does not match its spec. This handler
     * does not fire in production mode, because it requires inlining the full
     * JSON Schema spec for each event in your Tracking Plan.
     *
     * By default, it will throw errors if NODE_ENV = "test" so that tests will fail
     * if a message does not match the spec. Otherwise, errors will be logged to stderr.
     */
    onViolation?: ViolationHandler;
}

/**
 * Updates the run-time configuration of this Typewriter client.
 *
 * @param {TypewriterOptions} options - the options to upsert
 *
 * @typedef {Object} TypewriterOptions
 * @property {AnyAnalytics} [analytics] - Underlying analytics instance where analytics
 * 		calls are forwarded on to. Defaults to window.analytics.
 * @property {Function} [onViolation] - Handler fired when if an event does not match its spec. This handler does not fire in
 * 		production mode, because it requires inlining the full JSON Schema spec for each event in your Tracking Plan. By default,
 * 		it will throw errors if NODE_ENV="test" so that tests will fail if a message does not match the spec. Otherwise, errors
 * 		will be logged to stderr.
 */
export function setTypewriterOptions(options: TypewriterOptions) {
    analytics = options.analytics ? () => options.analytics || window.analytics : analytics;
    onViolation = options.onViolation || onViolation
}

/**
    * Validates a message against a JSON Schema using Ajv. If the message
    * is invalid, the `onViolation` handler will be called.
    */
function validateAgainstSchema(
    message: Record<string, any>,
    schema: object
) {
    const ajv = new Ajv({ allErrors: true, verbose: true })

    if (!ajv.validate(schema, message) && ajv.errors) {
        onViolation(message, ajv.errors)
    }
}

/**
 * Helper to attach metadata on Typewriter to outbound requests.
 * This is used for attribution and debugging by the Segment team.
 */
function withTypewriterContext(message: Options = {}): Options {
    return {
        ...message,
        context: {
            ...(message.context || {}),
            typewriter: {
                language: 'typescript',
                version: '9.2.0',
            },
        },
    };
}

/**
 * Fires a 'AccountDeletionUserPressedConfirmCancellation' track call.
 *
 * @param AccountDeletionUserPressedConfirmCancellation props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function accountDeletionUserPressedConfirmCancellation(props: AccountDeletionUserPressedConfirmCancellation, options?: Options, callback?: Callback): void {

    const schema = {"$id":"AccountDeletionUserPressedConfirmCancellation","$schema":"http://json-schema.org/draft-07/schema#","description":"[ACCOUNT DELETION] User pressed the button for the confirm cancellation for deleting their account","properties":{"id":{"$id":"/properties/id","description":"","type":"string"}},"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('AccountDeletionUserPressedConfirmCancellation', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'AccountDeletionUserPressedContactSupport' track call.
 *
 * @param AccountDeletionUserPressedContactSupport props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function accountDeletionUserPressedContactSupport(props: AccountDeletionUserPressedContactSupport, options?: Options, callback?: Callback): void {

    const schema = {"$id":"AccountDeletionUserPressedContactSupport","$schema":"http://json-schema.org/draft-07/schema#","description":"[ACCOUNT DELETION] User pressed the contact support link","properties":{"id":{"$id":"/properties/id","description":"","type":"string"}},"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('AccountDeletionUserPressedContactSupport', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'AccountDeletionUserViewedPrivacyPolicy' track call.
 *
 * @param AccountDeletionUserViewedPrivacyPolicy props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function accountDeletionUserViewedPrivacyPolicy(props: AccountDeletionUserViewedPrivacyPolicy, options?: Options, callback?: Callback): void {

    const schema = {"$id":"AccountDeletionUserViewedPrivacyPolicy","$schema":"http://json-schema.org/draft-07/schema#","description":"[ACCOUNT DELETION] User pressed the privacy policy link","properties":{"id":{"$id":"/properties/id","description":"","type":"string"}},"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('AccountDeletionUserViewedPrivacyPolicy', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'BecomeAHostPopupSubmission' track call.
 *
 * @param BecomeAHostPopupSubmission props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function becomeAHostPopupSubmission(props: BecomeAHostPopupSubmission, options?: Options, callback?: Callback): void {

    const schema = {"$id":"BecomeAHostPopupSubmission","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST POPUP] \"become a host\" popup on become a host page submitted","properties":{"Email":{"$id":"/properties/Email","description":"emailed entered from individual (may or may not be signed in user)","type":"string"},"FirstName":{"$id":"/properties/FirstName","description":"first name entered from individual (may or may not be signed in user)","type":"string"},"LastName":{"$id":"/properties/LastName","description":"last name entered from individual (may or may not be signed in user)","type":"string"},"Phone":{"$id":"/properties/Phone","description":"phone number entered from individual (may or may not be signed in user)","type":"string"},"Zipcode":{"$id":"/properties/Zipcode","description":"zip entered from individual (may or may not be signed in user)","type":"string"}},"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('BecomeAHostPopupSubmission', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'BecomeAHostPopupView' track call.
 *
 * @param BecomeAHostPopupView props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function becomeAHostPopupView(props: BecomeAHostPopupView, options?: Options, callback?: Callback): void {

    const schema = {"$id":"BecomeAHostPopupView","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST POPUP] \"become a host\" popup on become a host page shown","properties":{"id":{"$id":"/properties/id","description":"","type":"string"}},"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('BecomeAHostPopupView', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'BookingReasonSelected' track call.
 *
 * @param BookingReasonSelected props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function bookingReasonSelected(props: BookingReasonSelected, options?: Options, callback?: Callback): void {

    const schema = {"$id":"BookingReasonSelected","$schema":"http://json-schema.org/draft-07/schema#","description":"[CHECKOUT] reason selected for booking","properties":{"checkoutId":{"$id":"/properties/checkoutId","description":"id for the current checkout flow ","type":"string"},"enteredFromContactHostFlow":{"$id":"/properties/enteredFromContactHostFlow","description":"did they enter this item from the \"contact host\" PLP flow","type":"boolean"},"listingId":{"$id":"/properties/listingId","description":"the id for the pool listing","type":"string"},"reasonName":{"$id":"/properties/reasonName","description":"name of booking reason","type":"string"},"reasonPositionInList":{"$id":"/properties/reasonPositionInList","description":"which rank was this on the reason list (1st option, 2nd option, etc)","type":"integer"},"searchId":{"$id":"/properties/searchId","description":"id for the search that led to this listing","type":"string"}},"required":["checkoutId","listingId","reasonName","reasonPositionInList","searchId","enteredFromContactHostFlow"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('BookingReasonSelected', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'DisplayedReferral' track call.
 *
 * @param DisplayedReferral props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function displayedReferral(props: DisplayedReferral, options?: Options, callback?: Callback): void {

    const schema = {"$id":"DisplayedReferral","$schema":"http://json-schema.org/draft-07/schema#","description":"[CLAIM REFERRAL] Claim referral page from the invite","properties":{"enteredFrom":{"$id":"/properties/enteredFrom","description":"previous page before user enter the screen","type":"string"},"inviteText":{"$id":"/properties/inviteText","description":"Pre-filled text in the middle of screen","type":"string"},"nameOfReferrer":{"$id":"/properties/nameOfReferrer","description":"User name who sent the invite shown on the blurp","type":"string"},"referralId":{"$id":"/properties/referralId","description":"the referral id of the invite","type":"string"},"referralType":{"$id":"/properties/referralType","description":"Type of the referral, host or guest","type":"string"}},"required":["referralType","referralId","enteredFrom","inviteText","nameOfReferrer"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('DisplayedReferral', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'DisplayedReferralDetailsHost' track call.
 *
 * @param DisplayedReferralDetailsHost props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function displayedReferralDetailsHost(props: DisplayedReferralDetailsHost, options?: Options, callback?: Callback): void {

    const schema = {"$id":"DisplayedReferralDetailsHost","$schema":"http://json-schema.org/draft-07/schema#","description":"[CLAIM REFERRAL] Referral page as a host","properties":{"enteredFrom":{"$id":"/properties/enteredFrom","description":"previous page before user entered the screen","type":"string"},"inviteText":{"$id":"/properties/inviteText","description":"prefilled text in the middle of the screen","type":"string"},"nameOfReferrer":{"$id":"/properties/nameOfReferrer","description":"User name who sent the invite","type":"string"},"referralId":{"$id":"/properties/referralId","description":"The referral id of the invite","type":"string"},"referralType":{"$id":"/properties/referralType","description":"host or guest","type":"string"}},"required":["enteredFrom","inviteText","nameOfReferrer","referralId","referralType"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('DisplayedReferralDetailsHost', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'DisplayedSharingInvitesOptions' track call.
 *
 * @param DisplayedSharingInvitesOptions props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function displayedSharingInvitesOptions(props: DisplayedSharingInvitesOptions, options?: Options, callback?: Callback): void {

    const schema = {"$id":"DisplayedSharingInvitesOptions","$schema":"http://json-schema.org/draft-07/schema#","description":"[REFERRAL] the screen or pop up with all the options for sending or sharing invites","properties":{"inviteOptions":{"$id":"/properties/inviteOptions","description":"The options available for sharing","items":{"$id":"/properties/properties/properties/inviteOptions/items","description":"","properties":{"optionType":{"$id":"/properties/properties/properties/inviteOptions/items/properties/optionType","description":"the type of the sharing option (sms, email or Facebook, etc.)","type":"string"},"referType":{"$id":"/properties/properties/properties/inviteOptions/items/properties/referType","description":"the type of referral for host or friends/ guests","type":"string"}},"required":["optionType","referType"],"type":"object"},"type":"array"}},"required":["inviteOptions"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('DisplayedSharingInvitesOptions', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'FansComposeMessageCTAPressed' track call.
 *
 * @param FansComposeMessageCTAPressed props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function fansComposeMessageCTAPressed(props: FansComposeMessageCTAPressed, options?: Options, callback?: Callback): void {

    const schema = {"$id":"FansComposeMessageCTAPressed","$schema":"http://json-schema.org/draft-07/schema#","description":"[FANS] user completed the message, added a promotion code and pressed continue","properties":{"discountPercentage":{"$id":"/properties/discountPercentage","description":"the discount in percentage that the user is offering\n","type":"number"},"displayedNumberOfFans":{"$id":"/properties/displayedNumberOfFans","description":"the displayed number of fans in the message fans button\n","type":"integer"},"groupTypes":{"$id":"/properties/groupTypes","description":"the fan groups that the user is messaging to\n","type":"array"},"messageBlurb":{"$id":"/properties/messageBlurb","description":"message that the user has composed","type":"string"},"promoCode":{"$id":"/properties/promoCode","description":"the promo code that the user is offering","type":"string"},"promoCodeExpireDate":{"$id":"/properties/promoCodeExpireDate","description":"the displayed expiry date of the promo code","type":"string"}},"required":["discountPercentage","displayedNumberOfFans","groupTypes","messageBlurb","promoCode","promoCodeExpireDate"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('FansComposeMessageCTAPressed', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'FansComposeMessageScreenViewed' track call.
 *
 * @param FansComposeMessageScreenViewed props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function fansComposeMessageScreenViewed(props: FansComposeMessageScreenViewed, options?: Options, callback?: Callback): void {

    const schema = {"$id":"FansComposeMessageScreenViewed","$schema":"http://json-schema.org/draft-07/schema#","description":"[FANS] users viewed the compose message screen","properties":{"id":{"$id":"/properties/id","description":"","type":"string"}},"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('FansComposeMessageScreenViewed', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'FansInfoBottomSheetViewed' track call.
 *
 * @param FansInfoBottomSheetViewed props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function fansInfoBottomSheetViewed(props: FansInfoBottomSheetViewed, options?: Options, callback?: Callback): void {

    const schema = {"$id":"FansInfoBottomSheetViewed","$schema":"http://json-schema.org/draft-07/schema#","description":"[FANS] user viewed the intro of the pool fans sheet - *key additional context* host taps the fans banner to enter the fans creation flow","properties":{"id":{"$id":"/properties/id","description":"","type":"string"}},"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('FansInfoBottomSheetViewed', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'FansInfoCTAPressed' track call.
 *
 * @param FansInfoCTAPressed props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function fansInfoCTAPressed(props: FansInfoCTAPressed, options?: Options, callback?: Callback): void {

    const schema = {"$id":"FansInfoCTAPressed","$schema":"http://json-schema.org/draft-07/schema#","description":"[FANS] user pressed the fans info on the sheet","properties":{"id":{"$id":"/properties/id","description":"","type":"string"}},"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('FansInfoCTAPressed', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'FansIntroCTAPressed' track call.
 *
 * @param FansIntroCTAPressed props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function fansIntroCTAPressed(props: FansIntroCTAPressed, options?: Options, callback?: Callback): void {

    const schema = {"$id":"FansIntroCTAPressed","$schema":"http://json-schema.org/draft-07/schema#","description":"[FANS] user pressed the button on the fan intro sheet","properties":{"id":{"$id":"/properties/id","description":"","type":"string"}},"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('FansIntroCTAPressed', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'FansMessageSentScreenViewed' track call.
 *
 * @param FansMessageSentScreenViewed props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function fansMessageSentScreenViewed(props: FansMessageSentScreenViewed, options?: Options, callback?: Callback): void {

    const schema = {"$id":"FansMessageSentScreenViewed","$schema":"http://json-schema.org/draft-07/schema#","description":"[FANS] user entered the message sent screen","properties":{"id":{"$id":"/properties/id","description":"","type":"string"}},"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('FansMessageSentScreenViewed', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'FansRulesBottomSheetViewed' track call.
 *
 * @param FansRulesBottomSheetViewed props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function fansRulesBottomSheetViewed(props: FansRulesBottomSheetViewed, options?: Options, callback?: Callback): void {

    const schema = {"$id":"FansRulesBottomSheetViewed","$schema":"http://json-schema.org/draft-07/schema#","description":"[FANS] user viewed the rule sheet for messaging fans","properties":{"id":{"$id":"/properties/id","description":"","type":"string"}},"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('FansRulesBottomSheetViewed', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'FansRulesCTAPressed' track call.
 *
 * @param FansRulesCTAPressed props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function fansRulesCTAPressed(props: FansRulesCTAPressed, options?: Options, callback?: Callback): void {

    const schema = {"$id":"FansRulesCTAPressed","$schema":"http://json-schema.org/draft-07/schema#","description":"[FANS] user pressed the button on the rule sheet for messaging fans","properties":{"id":{"$id":"/properties/id","description":"","type":"string"}},"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('FansRulesCTAPressed', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'FansSelectBottomSheetViewed' track call.
 *
 * @param FansSelectBottomSheetViewed props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function fansSelectBottomSheetViewed(props: FansSelectBottomSheetViewed, options?: Options, callback?: Callback): void {

    const schema = {"$id":"FansSelectBottomSheetViewed","$schema":"http://json-schema.org/draft-07/schema#","description":"[FANS] user viewed the sheet for the fans groups selection","properties":{"displayedNumberGuestLeads":{"$id":"/properties/displayedNumberGuestLeads","description":"the number of fans in the guest leads group","type":"integer"},"displayedNumberOneTimeGuests":{"$id":"/properties/displayedNumberOneTimeGuests","description":"the number of fans in the one-time guest group","type":"integer"},"displayedNumberRepeatGuests":{"$id":"/properties/displayedNumberRepeatGuests","description":"the number of fans in the repeat guest group","type":"integer"}},"required":["displayedNumberGuestLeads","displayedNumberOneTimeGuests","displayedNumberRepeatGuests"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('FansSelectBottomSheetViewed', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'FansSelectCTAPressed' track call.
 *
 * @param FansSelectCTAPressed props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function fansSelectCTAPressed(props: FansSelectCTAPressed, options?: Options, callback?: Callback): void {

    const schema = {"$id":"FansSelectCTAPressed","$schema":"http://json-schema.org/draft-07/schema#","description":"[FANS] user selected the fans group and pressed continue","properties":{"selectedFansGroup":{"$id":"/properties/selectedFansGroup","description":"the fans groups that the user selected","type":"array"}},"required":["selectedFansGroup"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('FansSelectCTAPressed', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'GuestAcceptReviewChangesFromHost' track call.
 *
 * @param GuestAcceptReviewChangesFromHost props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function guestAcceptReviewChangesFromHost(props: GuestAcceptReviewChangesFromHost, options?: Options, callback?: Callback): void {

    const schema = {"$id":"GuestAcceptReviewChangesFromHost","$schema":"http://json-schema.org/draft-07/schema#","description":"[GUEST RESERVATION] guest accepted change request from host","properties":{"bookingEditHistoryId":{"$id":"/properties/bookingEditHistoryId","description":"a unique ID to identify the booking_edit_history entry\n","type":"string"},"bookingId":{"$id":"/properties/bookingId","description":"id of the bookings","type":"string"},"bookingWithPass":{"$id":"/properties/bookingWithPass","description":"was the booking made using a pass","enum":["FALSE","PARTIAL","TRUE"],"type":"string"},"hasAmenitiesEdit":{"$id":"/properties/hasAmenitiesEdit","description":"true if amenities is edited, false otherwise","type":"boolean"},"hasBookingDateEdit":{"$id":"/properties/hasBookingDateEdit","description":"true if booking date is edited, false otherwise","type":"boolean"},"hasBookingTimeEdit":{"$id":"/properties/hasBookingTimeEdit","description":"true if booking time is edited, false otherwise","type":"boolean"},"hasGuestCountEdit":{"$id":"/properties/hasGuestCountEdit","description":"true if guest count is edited, false otherwise","type":"boolean"},"hasTotalPriceChange":{"$id":"/properties/hasTotalPriceChange","description":"true if there is any change in total price","type":"boolean"},"isRefund":{"$id":"/properties/isRefund","description":"true if guests has refund amount","type":"boolean"},"newAdultGuests":{"$id":"/properties/newAdultGuests","description":"new number of adult guests","type":"integer"},"newAmenities":{"$id":"/properties/newAmenities","description":"new amenities","items":{"$id":"/properties/properties/properties/newAmenities/items","description":"","properties":{"amenityDescription":{"$id":"/properties/properties/properties/newAmenities/items/properties/amenityDescription","description":"description of the amenity","type":"string"},"amenityFeeDetails":{"$id":"/properties/properties/properties/newAmenities/items/properties/amenityFeeDetails","description":"","properties":{"feeAmount":{"$id":"/properties/properties/properties/newAmenities/items/properties/amenityFeeDetails/properties/feeAmount","description":"fee of amenity","type":"number"},"isFlatFee":{"$id":"/properties/properties/properties/newAmenities/items/properties/amenityFeeDetails/properties/isFlatFee","description":"does this amenity have a flat fee?","type":"boolean"}},"required":["feeAmount","isFlatFee"],"type":"object"},"amenityName":{"$id":"/properties/properties/properties/newAmenities/items/properties/amenityName","description":"name of amenity","type":"string"},"isCustomAmenity":{"$id":"/properties/properties/properties/newAmenities/items/properties/isCustomAmenity","description":"is this a custom amenity from the host?","type":"boolean"},"isFee":{"$id":"/properties/properties/properties/newAmenities/items/properties/isFee","description":"does this amenity have a fee?","type":"boolean"},"isPreSelected":{"$id":"/properties/properties/properties/newAmenities/items/properties/isPreSelected","description":"is this amenity pre selected","type":"boolean"}},"required":["amenityDescription","amenityFeeDetails","amenityName","isCustomAmenity","isFee","isPreSelected"],"type":"object"},"type":"array"},"newCharges":{"$id":"/properties/newCharges","description":"new charges after edit","type":"number"},"newChildrenGuests":{"$id":"/properties/newChildrenGuests","description":"new number of children guests","type":"integer"},"newDate":{"$id":"/properties/newDate","description":"new date of booking","type":"string"},"newEndTime":{"$id":"/properties/newEndTime","description":"new end time of booking","type":"string"},"newInfantGuests":{"$id":"/properties/newInfantGuests","description":"new number of infants guests","type":"integer"},"newNumberAmenities":{"$id":"/properties/newNumberAmenities","description":"new number of amenities","type":"integer"},"newPetGuests":{"$id":"/properties/newPetGuests","description":"new number of pet guests","type":"integer"},"newStartTime":{"$id":"/properties/newStartTime","description":"new start time of booking","type":"string"},"originalAdultGuests":{"$id":"/properties/originalAdultGuests","description":"original number of adult guests before changes","type":"integer"},"originalAmenities":{"$id":"/properties/originalAmenities","description":"the original amenities","items":{"$id":"/properties/properties/properties/originalAmenities/items","description":"","properties":{"amenityDescription":{"$id":"/properties/properties/properties/originalAmenities/items/properties/amenityDescription","description":"description of amenity","type":"string"},"amenityFeeDetails":{"$id":"/properties/properties/properties/originalAmenities/items/properties/amenityFeeDetails","description":"","properties":{"feeAmount":{"$id":"/properties/properties/properties/originalAmenities/items/properties/amenityFeeDetails/properties/feeAmount","description":"fee of amenity","type":"number"},"isFlatFee":{"$id":"/properties/properties/properties/originalAmenities/items/properties/amenityFeeDetails/properties/isFlatFee","description":"does this amenity have a fee","type":"boolean"}},"required":["feeAmount","isFlatFee"],"type":"object"},"amenityName":{"$id":"/properties/properties/properties/originalAmenities/items/properties/amenityName","description":"name of amenity","type":"string"},"isCustomAmenity":{"$id":"/properties/properties/properties/originalAmenities/items/properties/isCustomAmenity","description":"is this a custom amenity from the host","type":"boolean"},"isFee":{"$id":"/properties/properties/properties/originalAmenities/items/properties/isFee","description":"does this amenity have a fee","type":"boolean"},"isPreSelected":{"$id":"/properties/properties/properties/originalAmenities/items/properties/isPreSelected","description":"is this amenity pre selected","type":"boolean"}},"required":["amenityDescription","amenityName","isCustomAmenity","isFee","isPreSelected","amenityFeeDetails"],"type":"object"},"type":"array"},"originalChildrenGuests":{"$id":"/properties/originalChildrenGuests","description":"original number of children guests before changes","type":"integer"},"originalDate":{"$id":"/properties/originalDate","description":"original date of the booking","type":"string"},"originalEndTime":{"$id":"/properties/originalEndTime","description":"original end time before changes","type":"string"},"originalGuestsFullList":{"$id":"/properties/originalGuestsFullList","description":"string formatted display of all guests ex \"13 guests (6 adults, 6 children, 1 infant, 1 pet)\"","type":"string"},"originalInfantGuests":{"$id":"/properties/originalInfantGuests","description":"original number of infants guests before changes","type":"integer"},"originalNumberAmenities":{"$id":"/properties/originalNumberAmenities","description":"original number of amenities before changes","type":"integer"},"originalPetGuests":{"$id":"/properties/originalPetGuests","description":"original number of pet guests before changes","type":"integer"},"originalStartTime":{"$id":"/properties/originalStartTime","description":"original start time before changes","type":"string"},"paidPrice":{"$id":"/properties/paidPrice","description":"paid price of the booking","type":"number"},"passId":{"$id":"/properties/passId","description":"if the booking was made or partially made with a pass, the pass id used","type":["integer","null"]},"passName":{"$id":"/properties/passName","description":"the type of the pass formatted to be LCM friendly\n","type":["string","null"]},"passType":{"$id":"/properties/passType","description":"if the booking was made or partially made with a pass, what type of pass","enum":["ALL_ACCESS","EARLY_BIRD","WEEKDAY",null],"type":["string","null"]},"userPassId":{"$id":"/properties/userPassId","description":"if the booking was made or partially made with a pass, what was the user pass Id used","type":["integer","null"]}},"required":["paidPrice","newInfantGuests","isRefund","originalPetGuests","newChildrenGuests","hasAmenitiesEdit","newEndTime","originalInfantGuests","hasBookingTimeEdit","originalNumberAmenities","originalStartTime","originalGuestsFullList","originalChildrenGuests","bookingId","hasTotalPriceChange","bookingEditHistoryId","newCharges","newNumberAmenities","originalAmenities","hasGuestCountEdit","newDate","hasBookingDateEdit","newPetGuests","originalAdultGuests","originalDate","newStartTime","originalEndTime","newAmenities","newAdultGuests"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('GuestAcceptReviewChangesFromHost', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'GuestConfirmedCancelPass' track call.
 *
 * @param GuestConfirmedCancelPass props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function guestConfirmedCancelPass(props: GuestConfirmedCancelPass, options?: Options, callback?: Callback): void {

    const schema = {"$id":"GuestConfirmedCancelPass","$schema":"http://json-schema.org/draft-07/schema#","description":"[GUEST PASS MANAGEMENT]","properties":{"canceled":{"$id":"/properties/canceled","description":"","type":"boolean"},"canceledReason":{"$id":"/properties/canceledReason","description":"","type":"string"},"createdAt":{"$id":"/properties/createdAt","description":"","type":"string"},"end":{"$id":"/properties/end","description":"","type":"string"},"hasAutorenewOn":{"$id":"/properties/hasAutorenewOn","description":"","type":"boolean"},"id":{"$id":"/properties/id","description":"","type":"string"},"isLegacy":{"$id":"/properties/isLegacy","description":"true if the pass is a legacy pass","type":"boolean"},"listingId":{"$id":"/properties/listingId","description":"","type":"string"},"passId":{"$id":"/properties/passId","description":"","type":"integer"},"passType":{"$id":"/properties/passType","description":"","enum":["ALL_ACCESS","EARLY_BIRD","WEEKDAY"],"type":"string"},"passholderStatus":{"$id":"/properties/passholderStatus","description":"the status of the pass","enum":["ACTIVE","EXPIRED"],"type":"string"},"passholderUserId":{"$id":"/properties/passholderUserId","description":"the user id of the pass holder ","type":"integer"},"start":{"$id":"/properties/start","description":"","type":"string"},"userPassId":{"$id":"/properties/userPassId","description":"","type":"integer"}},"required":["start","passType","isLegacy","passId","passholderUserId","end","passholderStatus","hasAutorenewOn","userPassId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('GuestConfirmedCancelPass', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'GuestDeclineReviewChangesFromHost' track call.
 *
 * @param GuestDeclineReviewChangesFromHost props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function guestDeclineReviewChangesFromHost(props: GuestDeclineReviewChangesFromHost, options?: Options, callback?: Callback): void {

    const schema = {"$id":"GuestDeclineReviewChangesFromHost","$schema":"http://json-schema.org/draft-07/schema#","description":"[GUEST RESERVATION] guest declined change request from host","properties":{"bookingEditHistoryId":{"$id":"/properties/bookingEditHistoryId","description":"a unique ID to identify the booking_edit_history entry\n","type":"string"},"bookingId":{"$id":"/properties/bookingId","description":"id of the bookings","type":"string"},"bookingWithPass":{"$id":"/properties/bookingWithPass","description":"was the booking made using a pass","enum":["FALSE","PARTIAL","TRUE"],"type":"string"},"hasAmenitiesEdit":{"$id":"/properties/hasAmenitiesEdit","description":"true if amenities is edited, false otherwise","type":"boolean"},"hasBookingDateEdit":{"$id":"/properties/hasBookingDateEdit","description":"true if booking date is edited, false otherwise","type":"boolean"},"hasBookingTimeEdit":{"$id":"/properties/hasBookingTimeEdit","description":"true if booking time is edited, false otherwise","type":"boolean"},"hasGuestCountEdit":{"$id":"/properties/hasGuestCountEdit","description":"true if guest count is edited, false otherwise","type":"boolean"},"hasTotalPriceChange":{"$id":"/properties/hasTotalPriceChange","description":"true if there is any change in total price","type":"boolean"},"isRefund":{"$id":"/properties/isRefund","description":"true if guests has refund amount","type":"boolean"},"newAdultGuests":{"$id":"/properties/newAdultGuests","description":"new number of adult guests","type":"integer"},"newAmenities":{"$id":"/properties/newAmenities","description":"new amenities","items":{"$id":"/properties/properties/properties/newAmenities/items","description":"","properties":{"amenityDescription":{"$id":"/properties/properties/properties/newAmenities/items/properties/amenityDescription","description":"description of the amenity","type":"string"},"amenityFeeDetails":{"$id":"/properties/properties/properties/newAmenities/items/properties/amenityFeeDetails","description":"","properties":{"feeAmount":{"$id":"/properties/properties/properties/newAmenities/items/properties/amenityFeeDetails/properties/feeAmount","description":"fee of amenity","type":"number"},"isFlatFee":{"$id":"/properties/properties/properties/newAmenities/items/properties/amenityFeeDetails/properties/isFlatFee","description":"does this amenity have a flat fee?","type":"boolean"}},"required":["feeAmount","isFlatFee"],"type":"object"},"amenityName":{"$id":"/properties/properties/properties/newAmenities/items/properties/amenityName","description":"name of amenity","type":"string"},"isCustomAmenity":{"$id":"/properties/properties/properties/newAmenities/items/properties/isCustomAmenity","description":"is this a custom amenity from the host?","type":"boolean"},"isFee":{"$id":"/properties/properties/properties/newAmenities/items/properties/isFee","description":"does this amenity have a fee?","type":"boolean"},"isPreSelected":{"$id":"/properties/properties/properties/newAmenities/items/properties/isPreSelected","description":"is this amenity pre selected","type":"boolean"}},"required":["amenityDescription","amenityFeeDetails","amenityName","isCustomAmenity","isFee","isPreSelected"],"type":"object"},"type":"array"},"newCharges":{"$id":"/properties/newCharges","description":"new charges after edit","type":"number"},"newChildrenGuests":{"$id":"/properties/newChildrenGuests","description":"new number of children guests","type":"integer"},"newDate":{"$id":"/properties/newDate","description":"new date of booking","type":"string"},"newEndTime":{"$id":"/properties/newEndTime","description":"new end time of booking","type":"string"},"newInfantGuests":{"$id":"/properties/newInfantGuests","description":"new number of infants guests","type":"integer"},"newNumberAmenities":{"$id":"/properties/newNumberAmenities","description":"new number of amenities","type":"integer"},"newPetGuests":{"$id":"/properties/newPetGuests","description":"new number of pet guests","type":"integer"},"newStartTime":{"$id":"/properties/newStartTime","description":"new start time of booking","type":"string"},"originalAdultGuests":{"$id":"/properties/originalAdultGuests","description":"original number of adult guests before changes","type":"integer"},"originalAmenities":{"$id":"/properties/originalAmenities","description":"the original amenities","items":{"$id":"/properties/properties/properties/originalAmenities/items","description":"","properties":{"amenityDescription":{"$id":"/properties/properties/properties/originalAmenities/items/properties/amenityDescription","description":"description of amenity","type":"string"},"amenityFeeDetails":{"$id":"/properties/properties/properties/originalAmenities/items/properties/amenityFeeDetails","description":"","properties":{"feeAmount":{"$id":"/properties/properties/properties/originalAmenities/items/properties/amenityFeeDetails/properties/feeAmount","description":"fee of amenity","type":"number"},"isFlatFee":{"$id":"/properties/properties/properties/originalAmenities/items/properties/amenityFeeDetails/properties/isFlatFee","description":"does this amenity have a fee","type":"boolean"}},"required":["feeAmount","isFlatFee"],"type":"object"},"amenityName":{"$id":"/properties/properties/properties/originalAmenities/items/properties/amenityName","description":"name of amenity","type":"string"},"isCustomAmenity":{"$id":"/properties/properties/properties/originalAmenities/items/properties/isCustomAmenity","description":"is this a custom amenity from the host","type":"boolean"},"isFee":{"$id":"/properties/properties/properties/originalAmenities/items/properties/isFee","description":"does this amenity have a fee","type":"boolean"},"isPreSelected":{"$id":"/properties/properties/properties/originalAmenities/items/properties/isPreSelected","description":"is this amenity pre selected","type":"boolean"}},"required":["amenityDescription","amenityName","isCustomAmenity","isFee","isPreSelected","amenityFeeDetails"],"type":"object"},"type":"array"},"originalChildrenGuests":{"$id":"/properties/originalChildrenGuests","description":"original number of children guests before changes","type":"integer"},"originalDate":{"$id":"/properties/originalDate","description":"original date of the booking","type":"string"},"originalEndTime":{"$id":"/properties/originalEndTime","description":"original end time before changes","type":"string"},"originalGuestsFullList":{"$id":"/properties/originalGuestsFullList","description":"string formatted display of all guests ex \"13 guests (6 adults, 6 children, 1 infant, 1 pet)\"","type":"string"},"originalInfantGuests":{"$id":"/properties/originalInfantGuests","description":"original number of infants guests before changes","type":"integer"},"originalNumberAmenities":{"$id":"/properties/originalNumberAmenities","description":"original number of amenities before changes","type":"integer"},"originalPetGuests":{"$id":"/properties/originalPetGuests","description":"original number of pet guests before changes","type":"integer"},"originalStartTime":{"$id":"/properties/originalStartTime","description":"original start time before changes","type":"string"},"paidPrice":{"$id":"/properties/paidPrice","description":"paid price of the booking","type":"number"},"passId":{"$id":"/properties/passId","description":"if the booking was made or partially made with a pass, the pass id used","type":["integer","null"]},"passName":{"$id":"/properties/passName","description":"the type of the pass formatted to be LCM friendly\n","type":["string","null"]},"passType":{"$id":"/properties/passType","description":"if the booking was made or partially made with a pass, what type of pass","enum":["ALL_ACCESS","EARLY_BIRD","WEEKDAY",null],"type":["string","null"]},"userPassId":{"$id":"/properties/userPassId","description":"if the booking was made or partially made with a pass, what was the user pass Id used","type":["integer","null"]}},"required":["bookingEditHistoryId","bookingId","newAmenities","newEndTime","hasAmenitiesEdit","isRefund","hasBookingDateEdit","originalGuestsFullList","paidPrice","hasGuestCountEdit","hasBookingTimeEdit","originalAmenities","originalEndTime","newPetGuests","newChildrenGuests","newDate","originalNumberAmenities","hasTotalPriceChange","originalDate","originalStartTime","newAdultGuests","originalChildrenGuests","newInfantGuests","newStartTime","originalPetGuests","newNumberAmenities","newCharges","originalInfantGuests","originalAdultGuests"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('GuestDeclineReviewChangesFromHost', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'GuestEnteredOtherCancelReason' track call.
 *
 * @param GuestEnteredOtherCancelReason props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function guestEnteredOtherCancelReason(props: GuestEnteredOtherCancelReason, options?: Options, callback?: Callback): void {

    const schema = {"$id":"GuestEnteredOtherCancelReason","$schema":"http://json-schema.org/draft-07/schema#","description":"[GUEST RESERVATION] guest entered the additional note for 'other' cancel reason","properties":{"additionalReason":{"$id":"/properties/additionalReason","description":"note of the cancel reason","type":"string"},"bookingId":{"$id":"/properties/bookingId","description":"id of the booking","type":"string"},"bookingWithPass":{"$id":"/properties/bookingWithPass","description":"was the booking made using a pass","enum":["FALSE","PARTIAL","TRUE"],"type":"string"},"passId":{"$id":"/properties/passId","description":"if the booking was made or partially made with a pass, the pass id used","type":["integer","null"]},"passName":{"$id":"/properties/passName","description":"the type of the pass formatted to be LCM friendly\n","type":["string","null"]},"passType":{"$id":"/properties/passType","description":"if the booking was made or partially made with a pass, what type of pass","enum":["ALL_ACCESS","EARLY_BIRD","WEEKDAY",null],"type":["string","null"]},"userPassId":{"$id":"/properties/userPassId","description":"if the booking was made or partially made with a pass, what was the user pass Id used","type":["integer","null"]}},"required":["bookingId","additionalReason"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('GuestEnteredOtherCancelReason', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'GuestExitChangeRequest' track call.
 *
 * @param GuestExitChangeRequest props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function guestExitChangeRequest(props: GuestExitChangeRequest, options?: Options, callback?: Callback): void {

    const schema = {"$id":"GuestExitChangeRequest","$schema":"http://json-schema.org/draft-07/schema#","description":"[GUEST RESERVATION] guest pressed 'never mind' in the leave a note screen in change request and cancel changes ","properties":{"bookingId":{"$id":"/properties/bookingId","description":"id of the booking","type":"string"},"bookingWithPass":{"$id":"/properties/bookingWithPass","description":"was the booking made using a pass","enum":["FALSE","PARTIAL","TRUE"],"type":"string"},"passId":{"$id":"/properties/passId","description":"if the booking was made or partially made with a pass, the pass id used","type":["integer","null"]},"passName":{"$id":"/properties/passName","description":"the type of the pass formatted to be LCM friendly\n","type":["string","null"]},"passType":{"$id":"/properties/passType","description":"if the booking was made or partially made with a pass, what type of pass","enum":["ALL_ACCESS","EARLY_BIRD","WEEKDAY",null],"type":["string","null"]},"userPassId":{"$id":"/properties/userPassId","description":"if the booking was made or partially made with a pass, what was the user pass Id used","type":["integer","null"]}},"required":["bookingId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('GuestExitChangeRequest', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'GuestPassHoursUsed' track call.
 *
 * @param GuestPassHoursUsed props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function guestPassHoursUsed(props: GuestPassHoursUsed, options?: Options, callback?: Callback): void {

    const schema = {"$id":"GuestPassHoursUsed","$schema":"http://json-schema.org/draft-07/schema#","description":"[GUEST PASS MANAGEMENT]","properties":{"id":{"$id":"/properties/id","description":"guestPass id","type":"number"}},"required":["id"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('GuestPassHoursUsed', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'GuestPassPurchaseFailure' track call.
 *
 * @param GuestPassPurchaseFailure props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function guestPassPurchaseFailure(props: GuestPassPurchaseFailure, options?: Options, callback?: Callback): void {

    const schema = {"$id":"GuestPassPurchaseFailure","$schema":"http://json-schema.org/draft-07/schema#","description":" [GUEST PASS ACQUISITION - PLP]","properties":{"coverImageURL":{"$id":"/properties/coverImageURL","description":"the url for the cover image of the listing the pass is for","type":"string"},"hostFirstName":{"$id":"/properties/hostFirstName","description":"first name of the host","type":"string"},"id":{"$id":"/properties/id","description":"","type":"string"},"listingId":{"$id":"/properties/listingId","description":"id of the listing the pass is for","type":"string"},"listingTitle":{"$id":"/properties/listingTitle","description":"the title of the listing the pass is for","type":"string"},"listingURL":{"$id":"/properties/listingURL","description":"the url of the listing the pass is for","type":"string"},"passAvailableTimes":{"$id":"/properties/passAvailableTimes","description":"[{from:”07:00:00”, “11:00:00”}...] Time slots when this pass is eligible","type":"array"},"passAvailableTimesText":{"$id":"/properties/passAvailableTimesText","description":"LCM formatted version of available times property","type":"string"},"passBlackoutDays":{"$id":"/properties/passBlackoutDays","description":"list of blackout dates (e.g. July 4, 2024). ","type":["array","null"]},"passCreatedAt":{"$id":"/properties/passCreatedAt","description":"when the pass was created","type":"string"},"passCurrencyCode":{"$id":"/properties/passCurrencyCode","description":"currency for all monetary fields","type":"string"},"passCurrent":{"$id":"/properties/passCurrent","description":"flag indicating that this is the current version for a pass. For a type/name/listing_id, there can only be one record with this attribute true.","type":"boolean"},"passDescription":{"$id":"/properties/passDescription","description":"free text description set by host","type":["string","null"]},"passDiscount":{"$id":"/properties/passDiscount","description":"discount amount. Fixed discounts will be in minors units.","type":["number","null"]},"passDiscountType":{"$id":"/properties/passDiscountType","description":"type of pass discount num[‘percentage’, ‘fixed’]","enum":["FIXED","PERCENTAGE",null],"type":["string","null"]},"passEligibleDays":{"$id":"/properties/passEligibleDays","description":"days the pass is eligible","type":["array","null"]},"passId":{"$id":"/properties/passId","description":"id of the pass","type":"integer"},"passMaxActivePasses":{"$id":"/properties/passMaxActivePasses","description":"max active passes allowed. This constraint will apply to the (listing_id, type, name) rather than id so that we can be accurate across edits.","type":["number","null"]},"passMaxDailyBookings":{"$id":"/properties/passMaxDailyBookings","description":"max bookings allowed under this pass","type":["number","null"]},"passMaxDuration":{"$id":"/properties/passMaxDuration","description":"max duration that may be booked using this pass","type":["number","null"]},"passMaxGuests":{"$id":"/properties/passMaxGuests","description":"max guests that may be booked using this pass","type":["number","null"]},"passName":{"$id":"/properties/passName","description":"the type of the pass formatted to be LCM friendly","pattern":"","type":"string"},"passPremiumAmenities":{"$id":"/properties/passPremiumAmenities","description":"the ids of all premium amenities included with the pass","type":["array","null"]},"passPrice":{"$id":"/properties/passPrice","description":"pass price in minor units","type":"string"},"passState":{"$id":"/properties/passState","description":"‘draft’ -> pass is being actively edited by the host via the creation flow. The step attribute below tracks the progress of the host through the creation flow.\n‘inactive’ -> pass has been created by the host, but not ready for sale yet\n‘active’ -> pass has passed the final availability requirements and has been marked by the host as ready for sale.","enum":["ACTIVE","DRAFT","INACTIVE"],"type":"string"},"passTotalPrice":{"$id":"/properties/passTotalPrice","description":"the pass of the price plus the service fee","type":"string"},"passType":{"$id":"/properties/passType","description":"the type of pass","enum":["ALL_ACCESS","EARLY_BIRD","FIXED_HOURS","WEEKDAY"],"type":"string"},"unSuccessfullySubmittedReasons":{"$id":"/properties/unSuccessfullySubmittedReasons","description":"if the submission is unsuccessful, a list of the errors\n","type":["array","null"]}},"required":["listingURL","passTotalPrice","passCurrent","passCurrencyCode","listingTitle","passType","passName","passDiscount","listingId","passDiscountType","passPrice","hostFirstName","passId","coverImageURL","passCreatedAt","passState"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('GuestPassPurchaseFailure', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'GuestPassPurchaseSuccess' track call.
 *
 * @param GuestPassPurchaseSuccess props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function guestPassPurchaseSuccess(props: GuestPassPurchaseSuccess, options?: Options, callback?: Callback): void {

    const schema = {"$id":"GuestPassPurchaseSuccess","$schema":"http://json-schema.org/draft-07/schema#","description":" [GUEST PASS ACQUISITION - PLP]","properties":{"coverImageURL":{"$id":"/properties/coverImageURL","description":"the url for the cover image of the listing the pass is for","type":"string"},"enteredFrom":{"$id":"/properties/enteredFrom","description":"","enum":["checkout","pdp","rebook"],"type":"string"},"hostFirstName":{"$id":"/properties/hostFirstName","description":"first name of the host","type":"string"},"id":{"$id":"/properties/id","description":"","type":"string"},"listingId":{"$id":"/properties/listingId","description":"id of the listing the pass is for","type":"string"},"listingTitle":{"$id":"/properties/listingTitle","description":"the title of the listing the pass is for","type":"string"},"listingURL":{"$id":"/properties/listingURL","description":"the url of the listing the pass is for","type":"string"},"passAvailableTimes":{"$id":"/properties/passAvailableTimes","description":"[{from:”07:00:00”, “11:00:00”}...] Time slots when this pass is eligible","type":"array"},"passAvailableTimesText":{"$id":"/properties/passAvailableTimesText","description":"LCM formatted version of available times property","type":"string"},"passBlackoutDays":{"$id":"/properties/passBlackoutDays","description":"list of blackout dates (e.g. July 4, 2024). ","type":["array","null"]},"passCreatedAt":{"$id":"/properties/passCreatedAt","description":"when the pass was created","type":"string"},"passCurrencyCode":{"$id":"/properties/passCurrencyCode","description":"currency for all monetary fields","type":"string"},"passCurrent":{"$id":"/properties/passCurrent","description":"flag indicating that this is the current version for a pass. For a type/name/listing_id, there can only be one record with this attribute true.","type":"boolean"},"passDescription":{"$id":"/properties/passDescription","description":"free text description set by host","type":["string","null"]},"passDiscount":{"$id":"/properties/passDiscount","description":"discount amount. Fixed discounts will be in minors units.","type":["number","null"]},"passDiscountType":{"$id":"/properties/passDiscountType","description":"type of pass discount num[‘percentage’, ‘fixed’]","enum":["FIXED","PERCENTAGE",null],"type":["string","null"]},"passEligibleDays":{"$id":"/properties/passEligibleDays","description":"days the pass is eligible","type":["array","null"]},"passId":{"$id":"/properties/passId","description":"id of the pass","type":"integer"},"passMaxActivePasses":{"$id":"/properties/passMaxActivePasses","description":"max active passes allowed. This constraint will apply to the (listing_id, type, name) rather than id so that we can be accurate across edits.","type":["number","null"]},"passMaxDailyBookings":{"$id":"/properties/passMaxDailyBookings","description":"max bookings allowed under this pass","type":["number","null"]},"passMaxDuration":{"$id":"/properties/passMaxDuration","description":"max duration that may be booked using this pass","type":["number","null"]},"passMaxGuests":{"$id":"/properties/passMaxGuests","description":"max guests that may be booked using this pass","type":["number","null"]},"passName":{"$id":"/properties/passName","description":"the type of the pass formatted to be LCM friendly","pattern":"","type":"string"},"passPremiumAmenities":{"$id":"/properties/passPremiumAmenities","description":"the ids of all premium amenities included with the pass","type":["array","null"]},"passPrice":{"$id":"/properties/passPrice","description":"pass price in minor units","type":"string"},"passState":{"$id":"/properties/passState","description":"‘draft’ -> pass is being actively edited by the host via the creation flow. The step attribute below tracks the progress of the host through the creation flow.\n‘inactive’ -> pass has been created by the host, but not ready for sale yet\n‘active’ -> pass has passed the final availability requirements and has been marked by the host as ready for sale.","enum":["ACTIVE","DRAFT","INACTIVE"],"type":"string"},"passTotalPrice":{"$id":"/properties/passTotalPrice","description":"the pass of the price plus the service fee","type":"string"},"passType":{"$id":"/properties/passType","description":"the type of pass","enum":["ALL_ACCESS","EARLY_BIRD","FIXED_HOURS","WEEKDAY"],"type":"string"},"passUpsellCreditAmountOffer":{"$id":"/properties/passUpsellCreditAmountOffer","description":"If the guest is shown an expiring discount towards the pass purchase, how much is it for (null if it's expired or not sh...\n","type":["number","null"]}},"required":["passId","hostFirstName","listingURL","passCurrencyCode","passTotalPrice","passName","passState","passDiscountType","enteredFrom","passCreatedAt","passCurrent","listingId","passPrice","passDiscount","coverImageURL","passType","listingTitle"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('GuestPassPurchaseSuccess', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'GuestPassRenewed' track call.
 *
 * @param GuestPassRenewed props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function guestPassRenewed(props: GuestPassRenewed, options?: Options, callback?: Callback): void {

    const schema = {"$id":"GuestPassRenewed","$schema":"http://json-schema.org/draft-07/schema#","description":"[GUEST PASS MANAGEMENT]","properties":{"id":{"$id":"/properties/id","description":"","type":"string"}},"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('GuestPassRenewed', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'GuestPressedAcceptAndPay' track call.
 *
 * @param GuestPressedAcceptAndPay props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function guestPressedAcceptAndPay(props: GuestPressedAcceptAndPay, options?: Options, callback?: Callback): void {

    const schema = {"$id":"GuestPressedAcceptAndPay","$schema":"http://json-schema.org/draft-07/schema#","description":"[GUEST SPECIAL OFFER RESPONSE]","properties":{"bookingChangeRequestId":{"$id":"/properties/bookingChangeRequestId","description":"","type":"integer"},"bookingId":{"$id":"/properties/bookingId","description":"","type":"integer"},"bookingSpecialOfferId":{"$id":"/properties/bookingSpecialOfferId","description":"","type":"integer"},"messageSentId":{"$id":"/properties/messageSentId","description":"","type":"integer"},"originalPrice":{"$id":"/properties/originalPrice","description":"","type":"number"},"specialOfferPrice":{"$id":"/properties/specialOfferPrice","description":"","type":"number"}},"required":["messageSentId","bookingChangeRequestId","specialOfferPrice","bookingSpecialOfferId","originalPrice","bookingId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('GuestPressedAcceptAndPay', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'GuestPressedAwesomeThanksButton' track call.
 *
 * @param GuestPressedAwesomeThanksButton props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function guestPressedAwesomeThanksButton(props: GuestPressedAwesomeThanksButton, options?: Options, callback?: Callback): void {

    const schema = {"$id":"GuestPressedAwesomeThanksButton","$schema":"http://json-schema.org/draft-07/schema#","description":"[GUEST T&S SWIPE] guest pressed the finish check in button","properties":{"bookingId":{"$id":"/properties/bookingId","description":"the id of the booking","type":"integer"}},"required":["bookingId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('GuestPressedAwesomeThanksButton', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'GuestPressedBookingType' track call.
 *
 * @param GuestPressedBookingType props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function guestPressedBookingType(props: GuestPressedBookingType, options?: Options, callback?: Callback): void {

    const schema = {"$id":"GuestPressedBookingType","$schema":"http://json-schema.org/draft-07/schema#","description":"[GUEST RESERVATION] guest pressed the booking type on the top (today, confirmed, pending, past) ","properties":{"bookingType":{"$id":"/properties/bookingType","description":"Today, all, pending, confirmed, past","enum":["past","pending_and_upcoming"],"type":"string"}},"required":["bookingType"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('GuestPressedBookingType', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'GuestPressedCancelPassNevermind' track call.
 *
 * @param GuestPressedCancelPassNevermind props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function guestPressedCancelPassNevermind(props: GuestPressedCancelPassNevermind, options?: Options, callback?: Callback): void {

    const schema = {"$id":"GuestPressedCancelPassNevermind","$schema":"http://json-schema.org/draft-07/schema#","description":"[GUEST PASS MANAGEMENT]","properties":{"canceled":{"$id":"/properties/canceled","description":"","type":"boolean"},"canceledReason":{"$id":"/properties/canceledReason","description":"","type":"string"},"createdAt":{"$id":"/properties/createdAt","description":"","type":"string"},"end":{"$id":"/properties/end","description":"","type":"string"},"hasAutorenewOn":{"$id":"/properties/hasAutorenewOn","description":"","type":"boolean"},"id":{"$id":"/properties/id","description":"","type":"string"},"isLegacy":{"$id":"/properties/isLegacy","description":"true if the pass is a legacy pass","type":"boolean"},"listingId":{"$id":"/properties/listingId","description":"","type":"string"},"passId":{"$id":"/properties/passId","description":"","type":"integer"},"passType":{"$id":"/properties/passType","description":"","enum":["ALL_ACCESS","EARLY_BIRD","WEEKDAY"],"type":"string"},"passholderStatus":{"$id":"/properties/passholderStatus","description":"the status of the pass","enum":["ACTIVE","EXPIRED"],"type":"string"},"passholderUserId":{"$id":"/properties/passholderUserId","description":"the user id of the pass holder ","type":"integer"},"start":{"$id":"/properties/start","description":"","type":"string"},"userPassId":{"$id":"/properties/userPassId","description":"","type":"integer"}},"required":["passId","passType","passholderUserId","start","end","hasAutorenewOn","isLegacy","passholderStatus","userPassId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('GuestPressedCancelPassNevermind', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'GuestPressedCancelPassNext' track call.
 *
 * @param GuestPressedCancelPassNext props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function guestPressedCancelPassNext(props: GuestPressedCancelPassNext, options?: Options, callback?: Callback): void {

    const schema = {"$id":"GuestPressedCancelPassNext","$schema":"http://json-schema.org/draft-07/schema#","description":"[GUEST PASS MANAGEMENT]","properties":{"canceled":{"$id":"/properties/canceled","description":"","type":"boolean"},"canceledReason":{"$id":"/properties/canceledReason","description":"","type":"string"},"createdAt":{"$id":"/properties/createdAt","description":"","type":"string"},"end":{"$id":"/properties/end","description":"","type":"string"},"hasAutorenewOn":{"$id":"/properties/hasAutorenewOn","description":"","type":"boolean"},"id":{"$id":"/properties/id","description":"","type":"string"},"isLegacy":{"$id":"/properties/isLegacy","description":"true if the pass is a legacy pass","type":"boolean"},"listingId":{"$id":"/properties/listingId","description":"","type":"string"},"passId":{"$id":"/properties/passId","description":"","type":"integer"},"passType":{"$id":"/properties/passType","description":"","enum":["ALL_ACCESS","EARLY_BIRD","WEEKDAY"],"type":"string"},"passholderStatus":{"$id":"/properties/passholderStatus","description":"the status of the pass","enum":["ACTIVE","EXPIRED"],"type":"string"},"passholderUserId":{"$id":"/properties/passholderUserId","description":"the user id of the pass holder ","type":"integer"},"start":{"$id":"/properties/start","description":"","type":"string"},"userPassId":{"$id":"/properties/userPassId","description":"","type":"integer"}},"required":["start","passId","passType","passholderUserId","userPassId","end","isLegacy","passholderStatus","hasAutorenewOn"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('GuestPressedCancelPassNext', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'GuestPressedChatFromReservationDetails' track call.
 *
 * @param GuestPressedChatFromReservationDetails props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function guestPressedChatFromReservationDetails(props: GuestPressedChatFromReservationDetails, options?: Options, callback?: Callback): void {

    const schema = {"$id":"GuestPressedChatFromReservationDetails","$schema":"http://json-schema.org/draft-07/schema#","description":"[GUEST CHAT] guest pressed to enter chat from reservation details","properties":{"bookingId":{"$id":"/properties/bookingId","description":"id of the booking","type":"integer"},"listingId":{"$id":"/properties/listingId","description":"id of the listing","type":"integer"}},"required":["bookingId","listingId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('GuestPressedChatFromReservationDetails', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'GuestPressedCloseFlowTrustAndSafety' track call.
 *
 * @param GuestPressedCloseFlowTrustAndSafety props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function guestPressedCloseFlowTrustAndSafety(props: GuestPressedCloseFlowTrustAndSafety, options?: Options, callback?: Callback): void {

    const schema = {"$id":"GuestPressedCloseFlowTrustAndSafety","$schema":"http://json-schema.org/draft-07/schema#","description":"[GUEST T&S SWIPE] guest pressed the close flow button on the top left","properties":{"bookingId":{"$id":"/properties/bookingId","description":"the id of the booking","type":"integer"},"currentPageNumber":{"$id":"/properties/currentPageNumber","description":"page number of the T&S flow (1, 2, or 3)","type":"integer"}},"required":["bookingId","currentPageNumber"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('GuestPressedCloseFlowTrustAndSafety', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'GuestPressedCloseThanksForReading' track call.
 *
 * @param GuestPressedCloseThanksForReading props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function guestPressedCloseThanksForReading(props: GuestPressedCloseThanksForReading, options?: Options, callback?: Callback): void {

    const schema = {"$id":"GuestPressedCloseThanksForReading","$schema":"http://json-schema.org/draft-07/schema#","description":"[GUEST T&S SWIPE] guest pressed 'X' button to close Thanks for Reading card","properties":{"bookingId":{"$id":"/properties/bookingId","description":"the id of the booking","type":"integer"}},"required":["bookingId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('GuestPressedCloseThanksForReading', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'GuestPressedDeclineSpecialOffer' track call.
 *
 * @param GuestPressedDeclineSpecialOffer props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function guestPressedDeclineSpecialOffer(props: GuestPressedDeclineSpecialOffer, options?: Options, callback?: Callback): void {

    const schema = {"$id":"GuestPressedDeclineSpecialOffer","$schema":"http://json-schema.org/draft-07/schema#","description":"[GUEST SPECIAL OFFER RESPONSE]","properties":{"bookingId":{"$id":"/properties/bookingId","description":"","type":"integer"},"bookingSpecialOfferId":{"$id":"/properties/bookingSpecialOfferId","description":"","type":"integer"},"messageSentId":{"$id":"/properties/messageSentId","description":"","type":"integer"},"originalPrice":{"$id":"/properties/originalPrice","description":"","type":"number"},"specialOfferPrice":{"$id":"/properties/specialOfferPrice","description":"","type":"number"}},"required":["specialOfferPrice","messageSentId","originalPrice"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('GuestPressedDeclineSpecialOffer', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'GuestPressedEditAmenities' track call.
 *
 * @param GuestPressedEditAmenities props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function guestPressedEditAmenities(props: GuestPressedEditAmenities, options?: Options, callback?: Callback): void {

    const schema = {"$id":"GuestPressedEditAmenities","$schema":"http://json-schema.org/draft-07/schema#","description":"[GUEST RESERVATION] guest pressed to view or change amenities","properties":{"bookingId":{"$id":"/properties/bookingId","description":"id of the booking","type":"string"},"bookingWithPass":{"$id":"/properties/bookingWithPass","description":"was the booking made using a pass","enum":["FALSE","PARTIAL","TRUE"],"type":"string"},"passId":{"$id":"/properties/passId","description":"if the booking was made or partially made with a pass, the pass id used","type":["integer","null"]},"passName":{"$id":"/properties/passName","description":"the type of the pass formatted to be LCM friendly\n","type":["string","null"]},"passType":{"$id":"/properties/passType","description":"if the booking was made or partially made with a pass, what type of pass","enum":["ALL_ACCESS","EARLY_BIRD","WEEKDAY",null],"type":["string","null"]},"userPassId":{"$id":"/properties/userPassId","description":"if the booking was made or partially made with a pass, what was the user pass Id used","type":["integer","null"]}},"required":["bookingId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('GuestPressedEditAmenities', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'GuestPressedExtendReservationLiveBooking' track call.
 *
 * @param GuestPressedExtendReservationLiveBooking props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function guestPressedExtendReservationLiveBooking(props: GuestPressedExtendReservationLiveBooking, options?: Options, callback?: Callback): void {

    const schema = {"$id":"GuestPressedExtendReservationLiveBooking","$schema":"http://json-schema.org/draft-07/schema#","description":"[GUEST RESERVATION] guest pressed extend reservation in the live reservation","properties":{"bookingId":{"$id":"/properties/bookingId","description":"id of the booking","type":"string"},"bookingWithPass":{"$id":"/properties/bookingWithPass","description":"was the booking made using a pass","enum":["FALSE","PARTIAL","TRUE"],"type":"string"},"displayedEndTime":{"$id":"/properties/displayedEndTime","description":"displayed end time in the live booking","type":"number"},"displayedStartTime":{"$id":"/properties/displayedStartTime","description":"displayed start time in the live booking ","type":"number"},"extendedCost":{"$id":"/properties/extendedCost","description":"the cost of the extension","type":"string"},"extendedTime":{"$id":"/properties/extendedTime","description":"extend 30 minutes or 60 minutes","type":"number"},"passId":{"$id":"/properties/passId","description":"if the booking was made or partially made with a pass, the pass id used","type":["integer","null"]},"passName":{"$id":"/properties/passName","description":"the type of the pass formatted to be LCM friendly\n","type":["string","null"]},"passType":{"$id":"/properties/passType","description":"if the booking was made or partially made with a pass, what type of pass","enum":["ALL_ACCESS","EARLY_BIRD","WEEKDAY",null],"type":["string","null"]},"userPassId":{"$id":"/properties/userPassId","description":"if the booking was made or partially made with a pass, what was the user pass Id used","type":["integer","null"]}},"required":["extendedCost","extendedTime","bookingId","displayedEndTime","displayedStartTime"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('GuestPressedExtendReservationLiveBooking', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'GuestPressedInitiateRefundRequest' track call.
 *
 * @param GuestPressedInitiateRefundRequest props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function guestPressedInitiateRefundRequest(props: GuestPressedInitiateRefundRequest, options?: Options, callback?: Callback): void {

    const schema = {"$id":"GuestPressedInitiateRefundRequest","$schema":"http://json-schema.org/draft-07/schema#","description":"guest entered the refund request flow","properties":{"bookingId":{"$id":"/properties/bookingId","description":"id of the booking","type":"integer"},"bookingStatus":{"$id":"/properties/bookingStatus","description":"status of the booking","type":"string"},"enteredFrom":{"$id":"/properties/enteredFrom","description":"which screen/tab the user entered from","type":"string"},"hostId":{"$id":"/properties/hostId","description":"id of the host for the booking","type":"integer"}},"required":["bookingId","bookingStatus","enteredFrom","hostId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('GuestPressedInitiateRefundRequest', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'GuestPressedLearnMorePassOnboarding' track call.
 *
 * @param GuestPressedLearnMorePassOnboarding props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function guestPressedLearnMorePassOnboarding(props: GuestPressedLearnMorePassOnboarding, options?: Options, callback?: Callback): void {

    const schema = {"$id":"GuestPressedLearnMorePassOnboarding","$schema":"http://json-schema.org/draft-07/schema#","description":"[GUEST PASS ONBOARDING]","properties":{"enteredFrom":{"$id":"/properties/enteredFrom","description":"how the guest accessed pass onboarding\n","enum":["homepage_learn_more","pop_up","search_banner"],"type":"string"},"id":{"$id":"/properties/id","description":"","type":"string"}},"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('GuestPressedLearnMorePassOnboarding', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'GuestPressedManagePass' track call.
 *
 * @param GuestPressedManagePass props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function guestPressedManagePass(props: GuestPressedManagePass, options?: Options, callback?: Callback): void {

    const schema = {"$id":"GuestPressedManagePass","$schema":"http://json-schema.org/draft-07/schema#","description":"[GUEST PASS MANAGEMENT] the guest clicked into a specific pass","properties":{"canceled":{"$id":"/properties/canceled","description":"","type":"boolean"},"canceledReason":{"$id":"/properties/canceledReason","description":"","type":"string"},"createdAt":{"$id":"/properties/createdAt","description":"","type":"string"},"end":{"$id":"/properties/end","description":"","type":"string"},"hasAutorenewOn":{"$id":"/properties/hasAutorenewOn","description":"","type":"boolean"},"id":{"$id":"/properties/id","description":"","type":"string"},"isLegacy":{"$id":"/properties/isLegacy","description":"true if the pass is a legacy pass","type":"boolean"},"listingId":{"$id":"/properties/listingId","description":"","type":"string"},"passId":{"$id":"/properties/passId","description":"","type":"integer"},"passType":{"$id":"/properties/passType","description":"","enum":["ALL_ACCESS","EARLY_BIRD","WEEKDAY"],"type":"string"},"passholderStatus":{"$id":"/properties/passholderStatus","description":"the status of the pass","enum":["ACTIVE","EXPIRED"],"type":"string"},"passholderUserId":{"$id":"/properties/passholderUserId","description":"the user id of the pass holder ","type":"integer"},"start":{"$id":"/properties/start","description":"","type":"string"},"userPassId":{"$id":"/properties/userPassId","description":"","type":"integer"}},"required":["userPassId","end","passId","passholderUserId","hasAutorenewOn","isLegacy","passType","passholderStatus","start"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('GuestPressedManagePass', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'GuestPressedManagePassCancelPass' track call.
 *
 * @param GuestPressedManagePassCancelPass props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function guestPressedManagePassCancelPass(props: GuestPressedManagePassCancelPass, options?: Options, callback?: Callback): void {

    const schema = {"$id":"GuestPressedManagePassCancelPass","$schema":"http://json-schema.org/draft-07/schema#","description":"[GUEST PASS MANAGEMENT]","properties":{"canceled":{"$id":"/properties/canceled","description":"","type":"boolean"},"canceledReason":{"$id":"/properties/canceledReason","description":"","type":"string"},"createdAt":{"$id":"/properties/createdAt","description":"","type":"string"},"end":{"$id":"/properties/end","description":"","type":"string"},"hasAutorenewOn":{"$id":"/properties/hasAutorenewOn","description":"","type":"boolean"},"id":{"$id":"/properties/id","description":"","type":"string"},"isLegacy":{"$id":"/properties/isLegacy","description":"true if the pass is a legacy pass","type":"boolean"},"listingId":{"$id":"/properties/listingId","description":"","type":"string"},"passId":{"$id":"/properties/passId","description":"","type":"integer"},"passType":{"$id":"/properties/passType","description":"","enum":["ALL_ACCESS","EARLY_BIRD","WEEKDAY"],"type":"string"},"passholderStatus":{"$id":"/properties/passholderStatus","description":"the status of the pass","enum":["ACTIVE","EXPIRED"],"type":"string"},"passholderUserId":{"$id":"/properties/passholderUserId","description":"the user id of the pass holder ","type":"integer"},"start":{"$id":"/properties/start","description":"","type":"string"},"userPassId":{"$id":"/properties/userPassId","description":"","type":"integer"}},"required":["start","isLegacy","passId","hasAutorenewOn","end","passType","passholderStatus","passholderUserId","userPassId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('GuestPressedManagePassCancelPass', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'GuestPressedManagePassContactSupport' track call.
 *
 * @param GuestPressedManagePassContactSupport props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function guestPressedManagePassContactSupport(props: GuestPressedManagePassContactSupport, options?: Options, callback?: Callback): void {

    const schema = {"$id":"GuestPressedManagePassContactSupport","$schema":"http://json-schema.org/draft-07/schema#","description":"[GUEST PASS MANAGEMENT]","properties":{"canceled":{"$id":"/properties/canceled","description":"","type":"boolean"},"canceledReason":{"$id":"/properties/canceledReason","description":"","type":"string"},"createdAt":{"$id":"/properties/createdAt","description":"","type":"string"},"end":{"$id":"/properties/end","description":"","type":"string"},"hasAutorenewOn":{"$id":"/properties/hasAutorenewOn","description":"","type":"boolean"},"id":{"$id":"/properties/id","description":"","type":"string"},"isLegacy":{"$id":"/properties/isLegacy","description":"true if the pass is a legacy pass","type":"boolean"},"listingId":{"$id":"/properties/listingId","description":"","type":"string"},"passId":{"$id":"/properties/passId","description":"","type":"integer"},"passType":{"$id":"/properties/passType","description":"","enum":["ALL_ACCESS","EARLY_BIRD","WEEKDAY"],"type":"string"},"passholderStatus":{"$id":"/properties/passholderStatus","description":"the status of the pass","enum":["ACTIVE","EXPIRED"],"type":"string"},"passholderUserId":{"$id":"/properties/passholderUserId","description":"the user id of the pass holder ","type":"integer"},"start":{"$id":"/properties/start","description":"","type":"string"},"userPassId":{"$id":"/properties/userPassId","description":"","type":"integer"}},"required":["end","passType","start","hasAutorenewOn","isLegacy","passId","passholderStatus","passholderUserId","userPassId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('GuestPressedManagePassContactSupport', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'GuestPressedManagePassMessageHost' track call.
 *
 * @param GuestPressedManagePassMessageHost props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function guestPressedManagePassMessageHost(props: GuestPressedManagePassMessageHost, options?: Options, callback?: Callback): void {

    const schema = {"$id":"GuestPressedManagePassMessageHost","$schema":"http://json-schema.org/draft-07/schema#","description":"[GUEST PASS MANAGEMENT]","properties":{"canceled":{"$id":"/properties/canceled","description":"","type":"boolean"},"canceledReason":{"$id":"/properties/canceledReason","description":"","type":"string"},"createdAt":{"$id":"/properties/createdAt","description":"","type":"string"},"end":{"$id":"/properties/end","description":"","type":"string"},"hasAutorenewOn":{"$id":"/properties/hasAutorenewOn","description":"","type":"boolean"},"id":{"$id":"/properties/id","description":"","type":"string"},"isLegacy":{"$id":"/properties/isLegacy","description":"true if the pass is a legacy pass","type":"boolean"},"listingId":{"$id":"/properties/listingId","description":"","type":"string"},"passId":{"$id":"/properties/passId","description":"","type":"integer"},"passType":{"$id":"/properties/passType","description":"","enum":["ALL_ACCESS","EARLY_BIRD","WEEKDAY"],"type":"string"},"passholderStatus":{"$id":"/properties/passholderStatus","description":"the status of the pass","enum":["ACTIVE","EXPIRED"],"type":"string"},"passholderUserId":{"$id":"/properties/passholderUserId","description":"the user id of the pass holder ","type":"integer"},"start":{"$id":"/properties/start","description":"","type":"string"},"userPassId":{"$id":"/properties/userPassId","description":"","type":"integer"}},"required":["passholderStatus","passholderUserId","isLegacy","passType","userPassId","end","hasAutorenewOn","passId","start"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('GuestPressedManagePassMessageHost', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'GuestPressedManagePassPurchaseHistory' track call.
 *
 * @param GuestPressedManagePassPurchaseHistory props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function guestPressedManagePassPurchaseHistory(props: GuestPressedManagePassPurchaseHistory, options?: Options, callback?: Callback): void {

    const schema = {"$id":"GuestPressedManagePassPurchaseHistory","$schema":"http://json-schema.org/draft-07/schema#","description":"[GUEST PASS MANAGEMENT]","properties":{"canceled":{"$id":"/properties/canceled","description":"","type":"boolean"},"canceledReason":{"$id":"/properties/canceledReason","description":"","type":"string"},"createdAt":{"$id":"/properties/createdAt","description":"","type":"string"},"end":{"$id":"/properties/end","description":"","type":"string"},"hasAutorenewOn":{"$id":"/properties/hasAutorenewOn","description":"","type":"boolean"},"id":{"$id":"/properties/id","description":"","type":"string"},"isLegacy":{"$id":"/properties/isLegacy","description":"true if the pass is a legacy pass","type":"boolean"},"listingId":{"$id":"/properties/listingId","description":"","type":"string"},"passId":{"$id":"/properties/passId","description":"","type":"integer"},"passType":{"$id":"/properties/passType","description":"","enum":["ALL_ACCESS","EARLY_BIRD","WEEKDAY"],"type":"string"},"passholderStatus":{"$id":"/properties/passholderStatus","description":"the status of the pass","enum":["ACTIVE","EXPIRED"],"type":"string"},"passholderUserId":{"$id":"/properties/passholderUserId","description":"the user id of the pass holder ","type":"integer"},"start":{"$id":"/properties/start","description":"","type":"string"},"userPassId":{"$id":"/properties/userPassId","description":"","type":"integer"}},"required":["passholderUserId","end","passId","hasAutorenewOn","start","userPassId","isLegacy","passType","passholderStatus"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('GuestPressedManagePassPurchaseHistory', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'GuestPressedManagePassTurnOffAutoRenew' track call.
 *
 * @param GuestPressedManagePassTurnOffAutoRenew props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function guestPressedManagePassTurnOffAutoRenew(props: GuestPressedManagePassTurnOffAutoRenew, options?: Options, callback?: Callback): void {

    const schema = {"$id":"GuestPressedManagePassTurnOffAutoRenew","$schema":"http://json-schema.org/draft-07/schema#","description":"[GUEST PASS MANAGEMENT] the guest turned OFF autorenew on the pass","properties":{"canceled":{"$id":"/properties/canceled","description":"","type":"boolean"},"canceledReason":{"$id":"/properties/canceledReason","description":"","type":"string"},"createdAt":{"$id":"/properties/createdAt","description":"","type":"string"},"end":{"$id":"/properties/end","description":"","type":"string"},"hasAutorenewOn":{"$id":"/properties/hasAutorenewOn","description":"","type":"boolean"},"id":{"$id":"/properties/id","description":"","type":"string"},"isLegacy":{"$id":"/properties/isLegacy","description":"true if the pass is a legacy pass","type":"boolean"},"listingId":{"$id":"/properties/listingId","description":"","type":"string"},"passId":{"$id":"/properties/passId","description":"","type":"integer"},"passType":{"$id":"/properties/passType","description":"","enum":["ALL_ACCESS","EARLY_BIRD","WEEKDAY"],"type":"string"},"passholderStatus":{"$id":"/properties/passholderStatus","description":"the status of the pass","enum":["ACTIVE","EXPIRED"],"type":"string"},"passholderUserId":{"$id":"/properties/passholderUserId","description":"the user id of the pass holder ","type":"integer"},"start":{"$id":"/properties/start","description":"","type":"string"},"userPassId":{"$id":"/properties/userPassId","description":"","type":"integer"}},"required":["end","isLegacy","passType","userPassId","hasAutorenewOn","passId","passholderStatus","passholderUserId","start"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('GuestPressedManagePassTurnOffAutoRenew', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'GuestPressedManagePassTurnOnAutoRenew' track call.
 *
 * @param GuestPressedManagePassTurnOnAutoRenew props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function guestPressedManagePassTurnOnAutoRenew(props: GuestPressedManagePassTurnOnAutoRenew, options?: Options, callback?: Callback): void {

    const schema = {"$id":"GuestPressedManagePassTurnOnAutoRenew","$schema":"http://json-schema.org/draft-07/schema#","description":"[GUEST PASS MANAGEMENT] the guest turned ON autorenew on the pass","properties":{"canceled":{"$id":"/properties/canceled","description":"","type":"boolean"},"canceledReason":{"$id":"/properties/canceledReason","description":"","type":"string"},"createdAt":{"$id":"/properties/createdAt","description":"","type":"string"},"end":{"$id":"/properties/end","description":"","type":"string"},"hasAutorenewOn":{"$id":"/properties/hasAutorenewOn","description":"","type":"boolean"},"id":{"$id":"/properties/id","description":"","type":"string"},"isLegacy":{"$id":"/properties/isLegacy","description":"true if the pass is a legacy pass","type":"boolean"},"listingId":{"$id":"/properties/listingId","description":"","type":"string"},"passId":{"$id":"/properties/passId","description":"","type":"integer"},"passType":{"$id":"/properties/passType","description":"","enum":["ALL_ACCESS","EARLY_BIRD","WEEKDAY"],"type":"string"},"passholderStatus":{"$id":"/properties/passholderStatus","description":"the status of the pass","enum":["ACTIVE","EXPIRED"],"type":"string"},"passholderUserId":{"$id":"/properties/passholderUserId","description":"the user id of the pass holder ","type":"integer"},"start":{"$id":"/properties/start","description":"","type":"string"},"userPassId":{"$id":"/properties/userPassId","description":"","type":"integer"}},"required":["end","isLegacy","passId","passType","passholderStatus","hasAutorenewOn","passholderUserId","start","userPassId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('GuestPressedManagePassTurnOnAutoRenew', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'GuestPressedManagePassViewBookings' track call.
 *
 * @param GuestPressedManagePassViewBookings props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function guestPressedManagePassViewBookings(props: GuestPressedManagePassViewBookings, options?: Options, callback?: Callback): void {

    const schema = {"$id":"GuestPressedManagePassViewBookings","$schema":"http://json-schema.org/draft-07/schema#","description":"[GUEST PASS MANAGEMENT]","properties":{"canceled":{"$id":"/properties/canceled","description":"","type":"boolean"},"canceledReason":{"$id":"/properties/canceledReason","description":"","type":"string"},"createdAt":{"$id":"/properties/createdAt","description":"","type":"string"},"end":{"$id":"/properties/end","description":"","type":"string"},"hasAutorenewOn":{"$id":"/properties/hasAutorenewOn","description":"","type":"boolean"},"id":{"$id":"/properties/id","description":"","type":"string"},"isLegacy":{"$id":"/properties/isLegacy","description":"true if the pass is a legacy pass","type":"boolean"},"listingId":{"$id":"/properties/listingId","description":"","type":"string"},"passId":{"$id":"/properties/passId","description":"","type":"integer"},"passType":{"$id":"/properties/passType","description":"","enum":["ALL_ACCESS","EARLY_BIRD","WEEKDAY"],"type":"string"},"passholderStatus":{"$id":"/properties/passholderStatus","description":"the status of the pass","enum":["ACTIVE","EXPIRED"],"type":"string"},"passholderUserId":{"$id":"/properties/passholderUserId","description":"the user id of the pass holder ","type":"integer"},"start":{"$id":"/properties/start","description":"","type":"string"},"userPassId":{"$id":"/properties/userPassId","description":"","type":"integer"}},"required":["isLegacy","passId","passType","passholderStatus","userPassId","end","passholderUserId","start","hasAutorenewOn"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('GuestPressedManagePassViewBookings', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'GuestPressedManagePasses' track call.
 *
 * @param GuestPressedManagePasses props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function guestPressedManagePasses(props: GuestPressedManagePasses, options?: Options, callback?: Callback): void {

    const schema = {"$id":"GuestPressedManagePasses","$schema":"http://json-schema.org/draft-07/schema#","description":"[GUEST PASS MANAGEMENT] the guest clicked all passes (possibly more than 1)","properties":{"id":{"$id":"/properties/id","description":"","type":"string"}},"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('GuestPressedManagePasses', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'GuestPressedNextPageTrustAndSafety' track call.
 *
 * @param GuestPressedNextPageTrustAndSafety props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function guestPressedNextPageTrustAndSafety(props: GuestPressedNextPageTrustAndSafety, options?: Options, callback?: Callback): void {

    const schema = {"$id":"GuestPressedNextPageTrustAndSafety","$schema":"http://json-schema.org/draft-07/schema#","description":"[GUEST T&S SWIPE] guest pressed the next page button","properties":{"bookingId":{"$id":"/properties/bookingId","description":"the id of the booking","type":"integer"},"currentPageNumber":{"$id":"/properties/currentPageNumber","description":"page number of the T&S flow (1 or 2)","type":"integer"}},"required":["bookingId","currentPageNumber"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('GuestPressedNextPageTrustAndSafety', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'GuestPressedNextPassOnboarding' track call.
 *
 * @param GuestPressedNextPassOnboarding props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function guestPressedNextPassOnboarding(props: GuestPressedNextPassOnboarding, options?: Options, callback?: Callback): void {

    const schema = {"$id":"GuestPressedNextPassOnboarding","$schema":"http://json-schema.org/draft-07/schema#","description":"[GUEST PASS ONBOARDING]","properties":{"hostPassOnboardingPageName":{"$id":"/properties/hostPassOnboardingPageName","description":"","enum":["billing","discovery",null,"pass_type"],"type":"string"},"id":{"$id":"/properties/id","description":"","type":"string"}},"required":["hostPassOnboardingPageName"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('GuestPressedNextPassOnboarding', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'GuestPressedPurchasePass' track call.
 *
 * @param GuestPressedPurchasePass props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function guestPressedPurchasePass(props: GuestPressedPurchasePass, options?: Options, callback?: Callback): void {

    const schema = {"$id":"GuestPressedPurchasePass","$schema":"http://json-schema.org/draft-07/schema#","description":" [GUEST PASS ACQUISITION - PLP]","properties":{"coverImageURL":{"$id":"/properties/coverImageURL","description":"the url for the cover image of the listing the pass is for","type":"string"},"enteredFrom":{"$id":"/properties/enteredFrom","description":"","enum":["checkout",null,"pdp","rebook"],"type":["string","null"]},"hostFirstName":{"$id":"/properties/hostFirstName","description":"first name of the host","type":"string"},"id":{"$id":"/properties/id","description":"","type":"string"},"listingId":{"$id":"/properties/listingId","description":"id of the listing the pass is for","type":"string"},"listingTitle":{"$id":"/properties/listingTitle","description":"the title of the listing the pass is for","type":"string"},"listingURL":{"$id":"/properties/listingURL","description":"the url of the listing the pass is for","type":"string"},"passAvailableTimes":{"$id":"/properties/passAvailableTimes","description":"[{from:”07:00:00”, “11:00:00”}...] Time slots when this pass is eligible","type":"array"},"passAvailableTimesText":{"$id":"/properties/passAvailableTimesText","description":"LCM formatted version of available times property","type":"string"},"passBlackoutDays":{"$id":"/properties/passBlackoutDays","description":"list of blackout dates (e.g. July 4, 2024). ","type":["array","null"]},"passCreatedAt":{"$id":"/properties/passCreatedAt","description":"when the pass was created","type":"string"},"passCurrencyCode":{"$id":"/properties/passCurrencyCode","description":"currency for all monetary fields","type":"string"},"passCurrent":{"$id":"/properties/passCurrent","description":"flag indicating that this is the current version for a pass. For a type/name/listing_id, there can only be one record with this attribute true.","type":"boolean"},"passDescription":{"$id":"/properties/passDescription","description":"free text description set by host","type":["string","null"]},"passDiscount":{"$id":"/properties/passDiscount","description":"discount amount. Fixed discounts will be in minors units.","type":["number","null"]},"passDiscountType":{"$id":"/properties/passDiscountType","description":"type of pass discount num[‘percentage’, ‘fixed’]","enum":["FIXED","PERCENTAGE",null],"type":["string","null"]},"passEligibleDays":{"$id":"/properties/passEligibleDays","description":"days the pass is eligible","type":["array","null"]},"passId":{"$id":"/properties/passId","description":"id of the pass","type":"integer"},"passMaxActivePasses":{"$id":"/properties/passMaxActivePasses","description":"max active passes allowed. This constraint will apply to the (listing_id, type, name) rather than id so that we can be accurate across edits.","type":["number","null"]},"passMaxDailyBookings":{"$id":"/properties/passMaxDailyBookings","description":"max bookings allowed under this pass","type":["number","null"]},"passMaxDuration":{"$id":"/properties/passMaxDuration","description":"max duration that may be booked using this pass","type":["number","null"]},"passMaxGuests":{"$id":"/properties/passMaxGuests","description":"max guests that may be booked using this pass","type":["number","null"]},"passName":{"$id":"/properties/passName","description":"the type of the pass formatted to be LCM friendly","pattern":"","type":"string"},"passPremiumAmenities":{"$id":"/properties/passPremiumAmenities","description":"the ids of all premium amenities included with the pass","type":["array","null"]},"passPrice":{"$id":"/properties/passPrice","description":"pass price in minor units","type":"string"},"passState":{"$id":"/properties/passState","description":"‘draft’ -> pass is being actively edited by the host via the creation flow. The step attribute below tracks the progress of the host through the creation flow.\n‘inactive’ -> pass has been created by the host, but not ready for sale yet\n‘active’ -> pass has passed the final availability requirements and has been marked by the host as ready for sale.","enum":["ACTIVE","DRAFT","INACTIVE"],"type":"string"},"passTotalPrice":{"$id":"/properties/passTotalPrice","description":"the pass of the price plus the service fee","type":"string"},"passType":{"$id":"/properties/passType","description":"the type of pass","enum":["ALL_ACCESS","EARLY_BIRD","FIXED_HOURS","WEEKDAY"],"type":"string"}},"required":["passDiscountType","passCurrent","passId","listingId","passName","listingURL","passCreatedAt","hostFirstName","passState","enteredFrom","passPrice","passCurrencyCode","passTotalPrice","coverImageURL","listingTitle","passDiscount","passType"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('GuestPressedPurchasePass', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'GuestPressedReadGuideButton' track call.
 *
 * @param GuestPressedReadGuideButton props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function guestPressedReadGuideButton(props: GuestPressedReadGuideButton, options?: Options, callback?: Callback): void {

    const schema = {"$id":"GuestPressedReadGuideButton","$schema":"http://json-schema.org/draft-07/schema#","description":"[GUEST T&S SWIPE] guest pressed the check in button on the reservation page","properties":{"bookingId":{"$id":"/properties/bookingId","description":"the id of the booking","type":"integer"}},"required":["bookingId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('GuestPressedReadGuideButton', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'GuestPressedRequestChanges' track call.
 *
 * @param GuestPressedRequestChanges props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function guestPressedRequestChanges(props: GuestPressedRequestChanges, options?: Options, callback?: Callback): void {

    const schema = {"$id":"GuestPressedRequestChanges","$schema":"http://json-schema.org/draft-07/schema#","description":"[GUEST T&S SWIPE] Guest view the screen \"Arriving at your pool\"","properties":{"bookingId":{"$id":"/properties/bookingId","description":"the id of the booking","type":"integer"}},"required":["bookingId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('GuestPressedRequestChanges', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'GuestPressedReservation' track call.
 *
 * @param GuestPressedReservation props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function guestPressedReservation(props: GuestPressedReservation, options?: Options, callback?: Callback): void {

    const schema = {"$id":"GuestPressedReservation","$schema":"http://json-schema.org/draft-07/schema#","description":"[GUEST RESERVATION] guest pressed reservation option (or 'booking' in app )to enter management flow","properties":{"bookingWithPass":{"$id":"/properties/bookingWithPass","description":"was the booking made using a pass","enum":["FALSE","PARTIAL","TRUE"],"type":"string"},"id":{"$id":"/properties/id","description":"","type":"string"},"passId":{"$id":"/properties/passId","description":"if the booking was made or partially made with a pass, the pass id used","type":["integer","null"]},"passName":{"$id":"/properties/passName","description":"the type of the pass formatted to be LCM friendly\n","type":["string","null"]},"passType":{"$id":"/properties/passType","description":"if the booking was made or partially made with a pass, what type of pass","enum":["ALL_ACCESS","EARLY_BIRD","WEEKDAY",null],"type":["string","null"]},"userPassId":{"$id":"/properties/userPassId","description":"if the booking was made or partially made with a pass, what was the user pass Id used","type":["integer","null"]}},"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('GuestPressedReservation', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'GuestPressedReviewChangesFromHost' track call.
 *
 * @param GuestPressedReviewChangesFromHost props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function guestPressedReviewChangesFromHost(props: GuestPressedReviewChangesFromHost, options?: Options, callback?: Callback): void {

    const schema = {"$id":"GuestPressedReviewChangesFromHost","$schema":"http://json-schema.org/draft-07/schema#","description":"[GUEST RESERVATION] guest pressed review change request from host","properties":{"bookingId":{"$id":"/properties/bookingId","description":"id of the bookings","type":"string"},"bookingWithPass":{"$id":"/properties/bookingWithPass","description":"was the booking made using a pass","enum":["FALSE","PARTIAL","TRUE"],"type":"string"},"passId":{"$id":"/properties/passId","description":"if the booking was made or partially made with a pass, the pass id used","type":["integer","null"]},"passName":{"$id":"/properties/passName","description":"the type of the pass formatted to be LCM friendly\n","type":["string","null"]},"passType":{"$id":"/properties/passType","description":"if the booking was made or partially made with a pass, what type of pass","enum":["ALL_ACCESS","EARLY_BIRD","WEEKDAY",null],"type":["string","null"]},"userPassId":{"$id":"/properties/userPassId","description":"if the booking was made or partially made with a pass, what was the user pass Id used","type":["integer","null"]}},"required":["bookingId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('GuestPressedReviewChangesFromHost', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'GuestPressedSecurityDepositLearnMore' track call.
 *
 * @param GuestPressedSecurityDepositLearnMore props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function guestPressedSecurityDepositLearnMore(props: GuestPressedSecurityDepositLearnMore, options?: Options, callback?: Callback): void {

    const schema = {"$id":"GuestPressedSecurityDepositLearnMore","$schema":"http://json-schema.org/draft-07/schema#","description":"[PLP] when the user presses to learn more about security deposits","properties":{"enteredFrom":{"$id":"/properties/enteredFrom","description":"where did the user press this from - PDP, Checkout, Booking Edit","enum":["booking_edit","checkout","pdp"],"type":"string"},"listingId":{"$id":"/properties/listingId","description":"","type":"string"}},"required":["enteredFrom","listingId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('GuestPressedSecurityDepositLearnMore', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'GuestPressedSecurityDepositLearnMoreExit' track call.
 *
 * @param GuestPressedSecurityDepositLearnMoreExit props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function guestPressedSecurityDepositLearnMoreExit(props: GuestPressedSecurityDepositLearnMoreExit, options?: Options, callback?: Callback): void {

    const schema = {"$id":"GuestPressedSecurityDepositLearnMoreExit","$schema":"http://json-schema.org/draft-07/schema#","description":"[PLP] when the user presses to exit the learn more about security deposits pop up","properties":{"enteredFrom":{"$id":"/properties/enteredFrom","description":"where did the user press this from - PDP, Checkout, Booking Edit","enum":["booking_edit","checkout","pdp"],"type":"string"},"listingId":{"$id":"/properties/listingId","description":"","type":"string"}},"required":["enteredFrom","listingId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('GuestPressedSecurityDepositLearnMoreExit', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'GuestPressedSeeHostRules' track call.
 *
 * @param GuestPressedSeeHostRules props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function guestPressedSeeHostRules(props: GuestPressedSeeHostRules, options?: Options, callback?: Callback): void {

    const schema = {"$id":"GuestPressedSeeHostRules","$schema":"http://json-schema.org/draft-07/schema#","description":"[GUEST T&S SWIPE] guest pressed the see host rules button","properties":{"bookingId":{"$id":"/properties/bookingId","description":"the id of the booking","type":"integer"}},"required":["bookingId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('GuestPressedSeeHostRules', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'GuestPressedSeeParkingDetails' track call.
 *
 * @param GuestPressedSeeParkingDetails props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function guestPressedSeeParkingDetails(props: GuestPressedSeeParkingDetails, options?: Options, callback?: Callback): void {

    const schema = {"$id":"GuestPressedSeeParkingDetails","$schema":"http://json-schema.org/draft-07/schema#","description":"[PLP] user clicks to see more parking details on the listing ","properties":{"listingId":{"$id":"/properties/listingId","description":"id of the listing","type":"string"}},"required":["listingId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('GuestPressedSeeParkingDetails', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'GuestPressedStartExploringPasses' track call.
 *
 * @param GuestPressedStartExploringPasses props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function guestPressedStartExploringPasses(props: GuestPressedStartExploringPasses, options?: Options, callback?: Callback): void {

    const schema = {"$id":"GuestPressedStartExploringPasses","$schema":"http://json-schema.org/draft-07/schema#","description":"[GUEST PASS ONBOARDING]","properties":{"hostPassOnboardingPageName":{"$id":"/properties/hostPassOnboardingPageName","description":"","enum":["billing","discovery","pass_type"],"type":"string"},"id":{"$id":"/properties/id","description":"","type":"string"}},"required":["hostPassOnboardingPageName"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('GuestPressedStartExploringPasses', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'GuestPressedSwimplyPromiseBanner' track call.
 *
 * @param GuestPressedSwimplyPromiseBanner props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function guestPressedSwimplyPromiseBanner(props: GuestPressedSwimplyPromiseBanner, options?: Options, callback?: Callback): void {

    const schema = {"$id":"GuestPressedSwimplyPromiseBanner","$schema":"http://json-schema.org/draft-07/schema#","description":"Fired when a user presses the Swimply Promise/Guarantee/Booking with Confidence banner","properties":{"listingId":{"$id":"/properties/listingId","description":"","type":"string"}},"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('GuestPressedSwimplyPromiseBanner', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'GuestPressedToConfirmBookingEdit' track call.
 *
 * @param GuestPressedToConfirmBookingEdit props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function guestPressedToConfirmBookingEdit(props: GuestPressedToConfirmBookingEdit, options?: Options, callback?: Callback): void {

    const schema = {"$id":"GuestPressedToConfirmBookingEdit","$schema":"http://json-schema.org/draft-07/schema#","description":"[GUEST RESERVATION] guest pressed 'make changes' (instant change) or 'continue'(change request)  button after saving the booking edit and pay","properties":{"bookingId":{"$id":"/properties/bookingId","description":"id of the bookings","type":"string"},"bookingWithPass":{"$id":"/properties/bookingWithPass","description":"was the booking made using a pass","enum":["FALSE","PARTIAL","TRUE"],"type":"string"},"hasAmenitiesEdit":{"$id":"/properties/hasAmenitiesEdit","description":"true if amenities is edited, false otherwise","type":"boolean"},"hasBookingDateEdit":{"$id":"/properties/hasBookingDateEdit","description":"true if booking date is edited, false otherwise","type":"boolean"},"hasBookingTimeEdit":{"$id":"/properties/hasBookingTimeEdit","description":"true if booking time is edited, false otherwise","type":"boolean"},"hasGuestCountEdit":{"$id":"/properties/hasGuestCountEdit","description":"true if guest count is edited, false otherwise","type":"boolean"},"hasTotalPriceChange":{"$id":"/properties/hasTotalPriceChange","description":"true if there is any change in total price","type":"boolean"},"isRefund":{"$id":"/properties/isRefund","description":"true if guests has refund amount","type":"boolean"},"newAdultGuests":{"$id":"/properties/newAdultGuests","description":"new number of adult guests","type":"integer"},"newAmenities":{"$id":"/properties/newAmenities","description":"new amenities","items":{"$id":"/properties/properties/properties/newAmenities/items","description":"","properties":{"amenityDescription":{"$id":"/properties/properties/properties/newAmenities/items/properties/amenityDescription","description":"description of the amenity","type":"string"},"amenityFeeDetails":{"$id":"/properties/properties/properties/newAmenities/items/properties/amenityFeeDetails","description":"","properties":{"feeAmount":{"$id":"/properties/properties/properties/newAmenities/items/properties/amenityFeeDetails/properties/feeAmount","description":"fee of amenity","type":"number"},"isFlatFee":{"$id":"/properties/properties/properties/newAmenities/items/properties/amenityFeeDetails/properties/isFlatFee","description":"does this amenity have a flat fee?","type":"boolean"}},"required":["feeAmount","isFlatFee"],"type":"object"},"amenityName":{"$id":"/properties/properties/properties/newAmenities/items/properties/amenityName","description":"name of amenity","type":"string"},"isCustomAmenity":{"$id":"/properties/properties/properties/newAmenities/items/properties/isCustomAmenity","description":"is this a custom amenity from the host?","type":"boolean"},"isFee":{"$id":"/properties/properties/properties/newAmenities/items/properties/isFee","description":"does this amenity have a fee?","type":"boolean"},"isPreSelected":{"$id":"/properties/properties/properties/newAmenities/items/properties/isPreSelected","description":"is this amenity pre selected","type":"boolean"}},"required":["amenityDescription","amenityFeeDetails","amenityName","isCustomAmenity","isFee","isPreSelected"],"type":"object"},"type":"array"},"newCharges":{"$id":"/properties/newCharges","description":"new charges after edit","type":"number"},"newChildrenGuests":{"$id":"/properties/newChildrenGuests","description":"new number of children guests","type":"integer"},"newDate":{"$id":"/properties/newDate","description":"new date of booking","type":"string"},"newEndTime":{"$id":"/properties/newEndTime","description":"new end time of booking","type":"string"},"newInfantGuests":{"$id":"/properties/newInfantGuests","description":"new number of infants guests","type":"integer"},"newNumberAmenities":{"$id":"/properties/newNumberAmenities","description":"new number of amenities","type":"integer"},"newPetGuests":{"$id":"/properties/newPetGuests","description":"new number of pet guests","type":"integer"},"newStartTime":{"$id":"/properties/newStartTime","description":"new start time of booking","type":"string"},"originalAdultGuests":{"$id":"/properties/originalAdultGuests","description":"original number of adult guests before changes","type":"integer"},"originalAmenities":{"$id":"/properties/originalAmenities","description":"the original amenities","items":{"$id":"/properties/properties/properties/originalAmenities/items","description":"","properties":{"amenityDescription":{"$id":"/properties/properties/properties/originalAmenities/items/properties/amenityDescription","description":"description of amenity","type":"string"},"amenityFeeDetails":{"$id":"/properties/properties/properties/originalAmenities/items/properties/amenityFeeDetails","description":"","properties":{"feeAmount":{"$id":"/properties/properties/properties/originalAmenities/items/properties/amenityFeeDetails/properties/feeAmount","description":"fee of amenity","type":"number"},"isFlatFee":{"$id":"/properties/properties/properties/originalAmenities/items/properties/amenityFeeDetails/properties/isFlatFee","description":"does this amenity have a fee","type":"boolean"}},"required":["feeAmount","isFlatFee"],"type":"object"},"amenityName":{"$id":"/properties/properties/properties/originalAmenities/items/properties/amenityName","description":"name of amenity","type":"string"},"isCustomAmenity":{"$id":"/properties/properties/properties/originalAmenities/items/properties/isCustomAmenity","description":"is this a custom amenity from the host","type":"boolean"},"isFee":{"$id":"/properties/properties/properties/originalAmenities/items/properties/isFee","description":"does this amenity have a fee","type":"boolean"},"isPreSelected":{"$id":"/properties/properties/properties/originalAmenities/items/properties/isPreSelected","description":"is this amenity pre selected","type":"boolean"}},"required":["amenityDescription","amenityName","isCustomAmenity","isFee","isPreSelected","amenityFeeDetails"],"type":"object"},"type":"array"},"originalChildrenGuests":{"$id":"/properties/originalChildrenGuests","description":"original number of children guests before changes","type":"integer"},"originalDate":{"$id":"/properties/originalDate","description":"original date of the booking","type":"string"},"originalEndTime":{"$id":"/properties/originalEndTime","description":"original end time before changes","type":"string"},"originalGuestsFullList":{"$id":"/properties/originalGuestsFullList","description":"string formatted display of all guests ex \"13 guests (6 adults, 6 children, 1 infant, 1 pet)\"","type":"string"},"originalInfantGuests":{"$id":"/properties/originalInfantGuests","description":"original number of infants guests before changes","type":"integer"},"originalNumberAmenities":{"$id":"/properties/originalNumberAmenities","description":"original number of amenities before changes","type":"integer"},"originalPetGuests":{"$id":"/properties/originalPetGuests","description":"original number of pet guests before changes","type":"integer"},"originalStartTime":{"$id":"/properties/originalStartTime","description":"original start time before changes","type":"string"},"paidPrice":{"$id":"/properties/paidPrice","description":"paid price of the booking","type":"number"},"passId":{"$id":"/properties/passId","description":"if the booking was made or partially made with a pass, the pass id used","type":["integer","null"]},"passName":{"$id":"/properties/passName","description":"the type of the pass formatted to be LCM friendly\n","type":["string","null"]},"passType":{"$id":"/properties/passType","description":"if the booking was made or partially made with a pass, what type of pass","enum":["ALL_ACCESS","EARLY_BIRD","WEEKDAY",null],"type":["string","null"]},"userPassId":{"$id":"/properties/userPassId","description":"if the booking was made or partially made with a pass, what was the user pass Id used","type":["integer","null"]}},"required":["newStartTime","bookingId","originalChildrenGuests","originalAdultGuests","newAmenities","hasTotalPriceChange","originalNumberAmenities","isRefund","originalDate","newDate","originalInfantGuests","originalAmenities","hasGuestCountEdit","originalEndTime","originalGuestsFullList","originalPetGuests","hasBookingDateEdit","newPetGuests","newNumberAmenities","newCharges","newEndTime","originalStartTime","newChildrenGuests","newAdultGuests","paidPrice","hasBookingTimeEdit","hasAmenitiesEdit","newInfantGuests"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('GuestPressedToConfirmBookingEdit', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'GuestPressedToConfirmCancellation' track call.
 *
 * @param GuestPressedToConfirmCancellation props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function guestPressedToConfirmCancellation(props: GuestPressedToConfirmCancellation, options?: Options, callback?: Callback): void {

    const schema = {"$id":"GuestPressedToConfirmCancellation","$schema":"http://json-schema.org/draft-07/schema#","description":"[GUEST RESERVATION] guest pressed to confirm cancellation","properties":{"bookingId":{"$id":"/properties/bookingId","description":"id of the booking","type":"string"},"bookingWithPass":{"$id":"/properties/bookingWithPass","description":"was the booking made using a pass","enum":["FALSE","PARTIAL","TRUE"],"type":"string"},"cancellationReason":{"$id":"/properties/cancellationReason","description":"selected cancellation reason ","type":"string"},"isCredit":{"$id":"/properties/isCredit","description":"True if the refund is in credit","type":"boolean"},"isWithinPolicy":{"$id":"/properties/isWithinPolicy","description":"True if the cancellation is within host's cancellation policy","type":"boolean"},"passId":{"$id":"/properties/passId","description":"if the booking was made or partially made with a pass, the pass id used","type":["integer","null"]},"passName":{"$id":"/properties/passName","description":"the type of the pass formatted to be LCM friendly\n","type":["string","null"]},"passType":{"$id":"/properties/passType","description":"if the booking was made or partially made with a pass, what type of pass","enum":["ALL_ACCESS","EARLY_BIRD","WEEKDAY",null],"type":["string","null"]},"refundAmount":{"$id":"/properties/refundAmount","description":"displayed refund amount","type":"number"},"userPassId":{"$id":"/properties/userPassId","description":"if the booking was made or partially made with a pass, what was the user pass Id used","type":["integer","null"]}},"required":["isWithinPolicy","bookingId","cancellationReason","refundAmount","isCredit"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('GuestPressedToConfirmCancellation', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'GuestPressedToEnterFavoriteList' track call.
 *
 * @param GuestPressedToEnterFavoriteList props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function guestPressedToEnterFavoriteList(props: GuestPressedToEnterFavoriteList, options?: Options, callback?: Callback): void {

    const schema = {"$id":"GuestPressedToEnterFavoriteList","$schema":"http://json-schema.org/draft-07/schema#","description":"[GUEST FAVORITE] guest pressed to enter the favorite list (fav tab on app or favorite on user profile on web)","properties":{"id":{"$id":"/properties/id","description":"","type":"string"}},"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('GuestPressedToEnterFavoriteList', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'GuestPressedToShowPriceDetails' track call.
 *
 * @param GuestPressedToShowPriceDetails props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function guestPressedToShowPriceDetails(props: GuestPressedToShowPriceDetails, options?: Options, callback?: Callback): void {

    const schema = {"$id":"GuestPressedToShowPriceDetails","$schema":"http://json-schema.org/draft-07/schema#","description":"[TIERED PRICING] guest pressed show prices details groups in PLP","properties":{"listingId":{"$id":"/properties/listingId","description":"the id of the listing","type":"string"}},"required":["listingId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('GuestPressedToShowPriceDetails', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'GuestPressedViewAndAcceptOfferThread' track call.
 *
 * @param GuestPressedViewAndAcceptOfferThread props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function guestPressedViewAndAcceptOfferThread(props: GuestPressedViewAndAcceptOfferThread, options?: Options, callback?: Callback): void {

    const schema = {"$id":"GuestPressedViewAndAcceptOfferThread","$schema":"http://json-schema.org/draft-07/schema#","description":"[GUEST SPECIAL OFFER RESPONSE]","properties":{"bookingId":{"$id":"/properties/bookingId","description":"","type":"integer"},"bookingSpecialOfferId":{"$id":"/properties/bookingSpecialOfferId","description":"","type":"integer"},"messageSentId":{"$id":"/properties/messageSentId","description":"","type":"integer"},"originalPrice":{"$id":"/properties/originalPrice","description":"","type":"number"},"specialOfferPrice":{"$id":"/properties/specialOfferPrice","description":"","type":"number"}},"required":["bookingId","originalPrice","messageSentId","specialOfferPrice","bookingSpecialOfferId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('GuestPressedViewAndAcceptOfferThread', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'GuestPressedViewReservation' track call.
 *
 * @param GuestPressedViewReservation props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function guestPressedViewReservation(props: GuestPressedViewReservation, options?: Options, callback?: Callback): void {

    const schema = {"$id":"GuestPressedViewReservation","$schema":"http://json-schema.org/draft-07/schema#","description":"[GUEST RESERVATION] guest pressed view reservation in the booking card","properties":{"bookingId":{"$id":"/properties/bookingId","description":"id of the booking","type":"string"},"bookingWithPass":{"$id":"/properties/bookingWithPass","description":"was the booking made using a pass","enum":["FALSE","PARTIAL","TRUE"],"type":"string"},"displayedStatus":{"$id":"/properties/displayedStatus","description":"live, confirmed, cancelled, pending or past","enum":["approved","cancelled","completed","confirmed","declined","expired","payment failed","pending","pre-approved","recently completed"],"type":"string"},"passId":{"$id":"/properties/passId","description":"if the booking was made or partially made with a pass, the pass id used","type":["integer","null"]},"passName":{"$id":"/properties/passName","description":"the type of the pass formatted to be LCM friendly\n","type":["string","null"]},"passType":{"$id":"/properties/passType","description":"if the booking was made or partially made with a pass, what type of pass","enum":["ALL_ACCESS","EARLY_BIRD","WEEKDAY",null],"type":["string","null"]},"userPassId":{"$id":"/properties/userPassId","description":"if the booking was made or partially made with a pass, what was the user pass Id used","type":["integer","null"]}},"required":["bookingId","displayedStatus"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('GuestPressedViewReservation', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'GuestPressedViewSpecialOfferMessages' track call.
 *
 * @param GuestPressedViewSpecialOfferMessages props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function guestPressedViewSpecialOfferMessages(props: GuestPressedViewSpecialOfferMessages, options?: Options, callback?: Callback): void {

    const schema = {"$id":"GuestPressedViewSpecialOfferMessages","$schema":"http://json-schema.org/draft-07/schema#","description":"[GUEST SPECIAL OFFER RESPONSE]","properties":{"bookingId":{"$id":"/properties/bookingId","description":"","type":"integer"},"bookingSpecialOfferId":{"$id":"/properties/bookingSpecialOfferId","description":"","type":"integer"},"messageSentId":{"$id":"/properties/messageSentId","description":"","type":"integer"},"originalPrice":{"$id":"/properties/originalPrice","description":"","type":"number"},"specialOfferPrice":{"$id":"/properties/specialOfferPrice","description":"","type":"number"}},"required":["bookingId","originalPrice","messageSentId","specialOfferPrice","bookingSpecialOfferId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('GuestPressedViewSpecialOfferMessages', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'GuestReservationCancellationPressedReschedule' track call.
 *
 * @param GuestReservationCancellationPressedReschedule props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function guestReservationCancellationPressedReschedule(props: GuestReservationCancellationPressedReschedule, options?: Options, callback?: Callback): void {

    const schema = {"$id":"GuestReservationCancellationPressedReschedule","$schema":"http://json-schema.org/draft-07/schema#","description":"[GUEST RESERVATION] guest pressed reschedule in cancellation flow","properties":{"bookingId":{"$id":"/properties/bookingId","description":"id of the booking","type":"string"},"bookingWithPass":{"$id":"/properties/bookingWithPass","description":"was the booking made using a pass","enum":["FALSE","PARTIAL","TRUE"],"type":"string"},"cancellationReason":{"$id":"/properties/cancellationReason","description":"selected cancellation reason","type":"string"},"passId":{"$id":"/properties/passId","description":"if the booking was made or partially made with a pass, the pass id used","type":["integer","null"]},"passName":{"$id":"/properties/passName","description":"the type of the pass formatted to be LCM friendly\n","type":["string","null"]},"passType":{"$id":"/properties/passType","description":"if the booking was made or partially made with a pass, what type of pass","enum":["ALL_ACCESS","EARLY_BIRD","WEEKDAY",null],"type":["string","null"]},"userPassId":{"$id":"/properties/userPassId","description":"if the booking was made or partially made with a pass, what was the user pass Id used","type":["integer","null"]}},"required":["bookingId","cancellationReason"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('GuestReservationCancellationPressedReschedule', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'GuestReservationEditBookingDateTime' track call.
 *
 * @param GuestReservationEditBookingDateTime props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function guestReservationEditBookingDateTime(props: GuestReservationEditBookingDateTime, options?: Options, callback?: Callback): void {

    const schema = {"$id":"GuestReservationEditBookingDateTime","$schema":"http://json-schema.org/draft-07/schema#","description":"[GUEST RESERVATION] guest pressed to change date time in confirmed booking","properties":{"bookingId":{"$id":"/properties/bookingId","description":"id of the booking","type":"string"},"bookingWithPass":{"$id":"/properties/bookingWithPass","description":"was the booking made using a pass","enum":["FALSE","PARTIAL","TRUE"],"type":"string"},"passId":{"$id":"/properties/passId","description":"if the booking was made or partially made with a pass, the pass id used","type":["integer","null"]},"passName":{"$id":"/properties/passName","description":"the type of the pass formatted to be LCM friendly\n","type":["string","null"]},"passType":{"$id":"/properties/passType","description":"if the booking was made or partially made with a pass, what type of pass","enum":["ALL_ACCESS","EARLY_BIRD","WEEKDAY",null],"type":["string","null"]},"userPassId":{"$id":"/properties/userPassId","description":"if the booking was made or partially made with a pass, what was the user pass Id used","type":["integer","null"]}},"required":["bookingId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('GuestReservationEditBookingDateTime', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'GuestReservationPressedContactHost' track call.
 *
 * @param GuestReservationPressedContactHost props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function guestReservationPressedContactHost(props: GuestReservationPressedContactHost, options?: Options, callback?: Callback): void {

    const schema = {"$id":"GuestReservationPressedContactHost","$schema":"http://json-schema.org/draft-07/schema#","description":"[GUEST RESERVATION] guest pressed contact host or message host","properties":{"bookingId":{"$id":"/properties/bookingId","description":"id of the booking","type":"string"},"bookingWithPass":{"$id":"/properties/bookingWithPass","description":"was the booking made using a pass","enum":["FALSE","PARTIAL","TRUE"],"type":"string"},"enteredFromCancellation":{"$id":"/properties/enteredFromCancellation","description":"True if guests pressed the contact host button from the cancellation flow","type":"boolean"},"enteredFromReservation":{"$id":"/properties/enteredFromReservation","description":"True if guests pressed the send message button from the reservation page","type":"boolean"},"passId":{"$id":"/properties/passId","description":"if the booking was made or partially made with a pass, the pass id used","type":["integer","null"]},"passName":{"$id":"/properties/passName","description":"the type of the pass formatted to be LCM friendly\n","type":["string","null"]},"passType":{"$id":"/properties/passType","description":"if the booking was made or partially made with a pass, what type of pass","enum":["ALL_ACCESS","EARLY_BIRD","WEEKDAY",null],"type":["string","null"]},"userPassId":{"$id":"/properties/userPassId","description":"if the booking was made or partially made with a pass, what was the user pass Id used","type":["integer","null"]}},"required":["bookingId","enteredFromCancellation","enteredFromReservation"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('GuestReservationPressedContactHost', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'GuestReservationPressedContactSupport' track call.
 *
 * @param GuestReservationPressedContactSupport props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function guestReservationPressedContactSupport(props: GuestReservationPressedContactSupport, options?: Options, callback?: Callback): void {

    const schema = {"$id":"GuestReservationPressedContactSupport","$schema":"http://json-schema.org/draft-07/schema#","description":"[GUEST RESERVATION] guest pressed contact support in reservation","properties":{"bookingId":{"$id":"/properties/bookingId","description":"id of the booking","type":"string"},"bookingWithPass":{"$id":"/properties/bookingWithPass","description":"was the booking made using a pass","enum":["FALSE","PARTIAL","TRUE"],"type":"string"},"enteredFromCancellation":{"$id":"/properties/enteredFromCancellation","description":"True if guest pressed contact support after selecting the cancel reason 'I'm uncomfortable with my host '","type":"boolean"},"enteredFromReservation":{"$id":"/properties/enteredFromReservation","description":"True if guest pressed contact support from the reservation page","type":"boolean"},"passId":{"$id":"/properties/passId","description":"if the booking was made or partially made with a pass, the pass id used","type":["integer","null"]},"passName":{"$id":"/properties/passName","description":"the type of the pass formatted to be LCM friendly\n","type":["string","null"]},"passType":{"$id":"/properties/passType","description":"if the booking was made or partially made with a pass, what type of pass","enum":["ALL_ACCESS","EARLY_BIRD","WEEKDAY",null],"type":["string","null"]},"userPassId":{"$id":"/properties/userPassId","description":"if the booking was made or partially made with a pass, what was the user pass Id used","type":["integer","null"]}},"required":["bookingId","enteredFromCancellation","enteredFromReservation"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('GuestReservationPressedContactSupport', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'GuestReservationPressedEditGuest' track call.
 *
 * @param GuestReservationPressedEditGuest props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function guestReservationPressedEditGuest(props: GuestReservationPressedEditGuest, options?: Options, callback?: Callback): void {

    const schema = {"$id":"GuestReservationPressedEditGuest","$schema":"http://json-schema.org/draft-07/schema#","description":"[GUEST RESERVATION] guest pressed to edit guest in confirmed booking","properties":{"bookingId":{"$id":"/properties/bookingId","description":"id of the booking","type":"string"},"bookingWithPass":{"$id":"/properties/bookingWithPass","description":"was the booking made using a pass","enum":["FALSE","PARTIAL","TRUE"],"type":"string"},"passId":{"$id":"/properties/passId","description":"if the booking was made or partially made with a pass, the pass id used","type":["integer","null"]},"passName":{"$id":"/properties/passName","description":"the type of the pass formatted to be LCM friendly\n","type":["string","null"]},"passType":{"$id":"/properties/passType","description":"if the booking was made or partially made with a pass, what type of pass","enum":["ALL_ACCESS","EARLY_BIRD","WEEKDAY",null],"type":["string","null"]},"userPassId":{"$id":"/properties/userPassId","description":"if the booking was made or partially made with a pass, what was the user pass Id used","type":["integer","null"]}},"required":["bookingId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('GuestReservationPressedEditGuest', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'GuestReservationPressedMakeChange' track call.
 *
 * @param GuestReservationPressedMakeChange props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function guestReservationPressedMakeChange(props: GuestReservationPressedMakeChange, options?: Options, callback?: Callback): void {

    const schema = {"$id":"GuestReservationPressedMakeChange","$schema":"http://json-schema.org/draft-07/schema#","description":"[GUEST RESERVATION] guest pressed to make changes in confirmed reservation","properties":{"bookingId":{"$id":"/properties/bookingId","description":"id of the booking","type":"string"},"bookingWithPass":{"$id":"/properties/bookingWithPass","description":"was the booking made using a pass","enum":["FALSE","PARTIAL","TRUE"],"type":"string"},"passId":{"$id":"/properties/passId","description":"if the booking was made or partially made with a pass, the pass id used","type":["integer","null"]},"passName":{"$id":"/properties/passName","description":"the type of the pass formatted to be LCM friendly\n","type":["string","null"]},"passType":{"$id":"/properties/passType","description":"if the booking was made or partially made with a pass, what type of pass","enum":["ALL_ACCESS","EARLY_BIRD","WEEKDAY",null],"type":["string","null"]},"userPassId":{"$id":"/properties/userPassId","description":"if the booking was made or partially made with a pass, what was the user pass Id used","type":["integer","null"]}},"required":["bookingId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('GuestReservationPressedMakeChange', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'GuestReservationPressedPayExtendedHour' track call.
 *
 * @param GuestReservationPressedPayExtendedHour props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function guestReservationPressedPayExtendedHour(props: GuestReservationPressedPayExtendedHour, options?: Options, callback?: Callback): void {

    const schema = {"$id":"GuestReservationPressedPayExtendedHour","$schema":"http://json-schema.org/draft-07/schema#","description":"[GUEST RESERVATION] guest pressed to pay the extend reservation","properties":{"bookingId":{"$id":"/properties/bookingId","description":"id of the booking","type":"string"},"bookingWithPass":{"$id":"/properties/bookingWithPass","description":"was the booking made using a pass","enum":["FALSE","PARTIAL","TRUE"],"type":"string"},"passId":{"$id":"/properties/passId","description":"if the booking was made or partially made with a pass, the pass id used","type":["integer","null"]},"passName":{"$id":"/properties/passName","description":"the type of the pass formatted to be LCM friendly\n","type":["string","null"]},"passType":{"$id":"/properties/passType","description":"if the booking was made or partially made with a pass, what type of pass","enum":["ALL_ACCESS","EARLY_BIRD","WEEKDAY",null],"type":["string","null"]},"paymentMethod":{"$id":"/properties/paymentMethod","description":"payment method","type":"string"},"totalExtendPrice":{"$id":"/properties/totalExtendPrice","description":"price of the extended hour","type":"number"},"userPassId":{"$id":"/properties/userPassId","description":"if the booking was made or partially made with a pass, what was the user pass Id used","type":["integer","null"]}},"required":["bookingId","paymentMethod","totalExtendPrice"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('GuestReservationPressedPayExtendedHour', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'GuestReservationPressedToContinueCancel' track call.
 *
 * @param GuestReservationPressedToContinueCancel props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function guestReservationPressedToContinueCancel(props: GuestReservationPressedToContinueCancel, options?: Options, callback?: Callback): void {

    const schema = {"$id":"GuestReservationPressedToContinueCancel","$schema":"http://json-schema.org/draft-07/schema#","description":"[GUEST RESERVATION] guest pressed 'No I'd like to cancel' in cancellation flow","properties":{"bookingId":{"$id":"/properties/bookingId","description":"id of the booking","type":"string"},"bookingWithPass":{"$id":"/properties/bookingWithPass","description":"was the booking made using a pass","enum":["FALSE","PARTIAL","TRUE"],"type":"string"},"cancellationReason":{"$id":"/properties/cancellationReason","description":"selected cancellation reason","type":"string"},"passId":{"$id":"/properties/passId","description":"if the booking was made or partially made with a pass, the pass id used","type":["integer","null"]},"passName":{"$id":"/properties/passName","description":"the type of the pass formatted to be LCM friendly\n","type":["string","null"]},"passType":{"$id":"/properties/passType","description":"if the booking was made or partially made with a pass, what type of pass","enum":["ALL_ACCESS","EARLY_BIRD","WEEKDAY",null],"type":["string","null"]},"userPassId":{"$id":"/properties/userPassId","description":"if the booking was made or partially made with a pass, what was the user pass Id used","type":["integer","null"]}},"required":["cancellationReason","bookingId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('GuestReservationPressedToContinueCancel', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'GuestReservationPressedToEnterCancellation' track call.
 *
 * @param GuestReservationPressedToEnterCancellation props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function guestReservationPressedToEnterCancellation(props: GuestReservationPressedToEnterCancellation, options?: Options, callback?: Callback): void {

    const schema = {"$id":"GuestReservationPressedToEnterCancellation","$schema":"http://json-schema.org/draft-07/schema#","description":"[GUEST RESERVATION] guest pressed to enter cancellation flow","properties":{"bookingId":{"$id":"/properties/bookingId","description":"id of the booking","type":"string"},"bookingWithPass":{"$id":"/properties/bookingWithPass","description":"was the booking made using a pass","enum":["FALSE","PARTIAL","TRUE"],"type":"string"},"passId":{"$id":"/properties/passId","description":"if the booking was made or partially made with a pass, the pass id used","type":["integer","null"]},"passName":{"$id":"/properties/passName","description":"the type of the pass formatted to be LCM friendly\n","type":["string","null"]},"passType":{"$id":"/properties/passType","description":"if the booking was made or partially made with a pass, what type of pass","enum":["ALL_ACCESS","EARLY_BIRD","WEEKDAY",null],"type":["string","null"]},"userPassId":{"$id":"/properties/userPassId","description":"if the booking was made or partially made with a pass, what was the user pass Id used","type":["integer","null"]}},"required":["bookingId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('GuestReservationPressedToEnterCancellation', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'GuestReservationPressedViewHostCancelPolicy' track call.
 *
 * @param GuestReservationPressedViewHostCancelPolicy props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function guestReservationPressedViewHostCancelPolicy(props: GuestReservationPressedViewHostCancelPolicy, options?: Options, callback?: Callback): void {

    const schema = {"$id":"GuestReservationPressedViewHostCancelPolicy","$schema":"http://json-schema.org/draft-07/schema#","description":"[GUEST RESERVATION] guest pressed to view cancellation policy","properties":{"bookingId":{"$id":"/properties/bookingId","description":"id of the booking","type":"string"},"bookingWithPass":{"$id":"/properties/bookingWithPass","description":"was the booking made using a pass","enum":["FALSE","PARTIAL","TRUE"],"type":"string"},"canellationReason":{"$id":"/properties/canellationReason","description":"selected cancellation reason if guest view policy from the cancellation flow. Null otherwise","type":["string","null"]},"passId":{"$id":"/properties/passId","description":"if the booking was made or partially made with a pass, the pass id used","type":["integer","null"]},"passName":{"$id":"/properties/passName","description":"the type of the pass formatted to be LCM friendly\n","type":["string","null"]},"passType":{"$id":"/properties/passType","description":"if the booking was made or partially made with a pass, what type of pass","enum":["ALL_ACCESS","EARLY_BIRD","WEEKDAY",null],"type":["string","null"]},"userPassId":{"$id":"/properties/userPassId","description":"if the booking was made or partially made with a pass, what was the user pass Id used","type":["integer","null"]}},"required":["bookingId","canellationReason"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('GuestReservationPressedViewHostCancelPolicy', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'GuestReservationSaveChangeAmenities' track call.
 *
 * @param GuestReservationSaveChangeAmenities props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function guestReservationSaveChangeAmenities(props: GuestReservationSaveChangeAmenities, options?: Options, callback?: Callback): void {

    const schema = {"$id":"GuestReservationSaveChangeAmenities","$schema":"http://json-schema.org/draft-07/schema#","description":"[GUEST RESERVATION] guest pressed to change amenities","properties":{"bookingId":{"$id":"/properties/bookingId","description":"id of the booking","type":"string"},"bookingWithPass":{"$id":"/properties/bookingWithPass","description":"was the booking made using a pass","enum":["FALSE","PARTIAL","TRUE"],"type":"string"},"passId":{"$id":"/properties/passId","description":"if the booking was made or partially made with a pass, the pass id used","type":["integer","null"]},"passName":{"$id":"/properties/passName","description":"the type of the pass formatted to be LCM friendly\n","type":["string","null"]},"passType":{"$id":"/properties/passType","description":"if the booking was made or partially made with a pass, what type of pass","enum":["ALL_ACCESS","EARLY_BIRD","WEEKDAY",null],"type":["string","null"]},"selectedAmenitites":{"$id":"/properties/selectedAmenitites","description":"selected amenities the guest wants to add","items":{"$id":"/properties/properties/properties/selectedAmenitites/items","description":"","properties":{"amenityDescription":{"$id":"/properties/properties/properties/selectedAmenitites/items/properties/amenityDescription","description":"description of the amenity\n","type":["string","null"]},"amenityFeeDetails":{"$id":"/properties/properties/properties/selectedAmenitites/items/properties/amenityFeeDetails","description":"","properties":{"feeAmount":{"$id":"/properties/properties/properties/selectedAmenitites/items/properties/amenityFeeDetails/properties/feeAmount","description":"fee of amenity\n","type":"number"},"isFlatFee":{"$id":"/properties/properties/properties/selectedAmenitites/items/properties/amenityFeeDetails/properties/isFlatFee","description":"does this amenity have a flat fee, 1 is flat fee, 0 is hourly fee","type":"boolean"}},"required":["feeAmount","isFlatFee"],"type":"object"},"amenityName":{"$id":"/properties/properties/properties/selectedAmenitites/items/properties/amenityName","description":"name of amenity\n","type":"string"},"isCustomAmenity":{"$id":"/properties/properties/properties/selectedAmenitites/items/properties/isCustomAmenity","description":"is this a custom amenity from the host\n","type":"boolean"},"isFee":{"$id":"/properties/properties/properties/selectedAmenitites/items/properties/isFee","description":"does this amenity have a fee\n","type":"boolean"},"isPreSelected":{"$id":"/properties/properties/properties/selectedAmenitites/items/properties/isPreSelected","description":"is this amenity pre selected\n","type":"boolean"}},"required":["amenityDescription","amenityFeeDetails","amenityName","isCustomAmenity","isFee","isPreSelected"],"type":"object"},"type":"array"},"userPassId":{"$id":"/properties/userPassId","description":"if the booking was made or partially made with a pass, what was the user pass Id used","type":["integer","null"]}},"required":["bookingId","selectedAmenitites"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('GuestReservationSaveChangeAmenities', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'GuestReservationSaveChangeDateTime' track call.
 *
 * @param GuestReservationSaveChangeDateTime props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function guestReservationSaveChangeDateTime(props: GuestReservationSaveChangeDateTime, options?: Options, callback?: Callback): void {

    const schema = {"$id":"GuestReservationSaveChangeDateTime","$schema":"http://json-schema.org/draft-07/schema#","description":"[GUEST RESERVATION] guest pressed save for the changes in booking date time","properties":{"bookingId":{"$id":"/properties/bookingId","description":"id of the booking","type":"string"},"bookingWithPass":{"$id":"/properties/bookingWithPass","description":"was the booking made using a pass","enum":["FALSE","PARTIAL","TRUE"],"type":"string"},"newDate":{"$id":"/properties/newDate","description":"the new date of the booking changed by guest","type":"string"},"newEndTime":{"$id":"/properties/newEndTime","description":"the new end time of the booking changed by guest","type":"number"},"newStartTime":{"$id":"/properties/newStartTime","description":"the new start time of the booking changed by guest","type":"number"},"orginalDate":{"$id":"/properties/orginalDate","description":"the original date of the booking","type":"string"},"originalEndTime":{"$id":"/properties/originalEndTime","description":"the original end time of the booking","type":"number"},"originalStartTime":{"$id":"/properties/originalStartTime","description":"the original start time of the booking","type":"number"},"passId":{"$id":"/properties/passId","description":"if the booking was made or partially made with a pass, the pass id used","type":["integer","null"]},"passName":{"$id":"/properties/passName","description":"the type of the pass formatted to be LCM friendly\n","type":["string","null"]},"passType":{"$id":"/properties/passType","description":"if the booking was made or partially made with a pass, what type of pass","enum":["ALL_ACCESS","EARLY_BIRD","WEEKDAY",null],"type":["string","null"]},"userPassId":{"$id":"/properties/userPassId","description":"if the booking was made or partially made with a pass, what was the user pass Id used","type":["integer","null"]}},"required":["newStartTime","orginalDate","originalEndTime","originalStartTime","bookingId","newDate","newEndTime"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('GuestReservationSaveChangeDateTime', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'GuestReservationSaveChangeGuest' track call.
 *
 * @param GuestReservationSaveChangeGuest props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function guestReservationSaveChangeGuest(props: GuestReservationSaveChangeGuest, options?: Options, callback?: Callback): void {

    const schema = {"$id":"GuestReservationSaveChangeGuest","$schema":"http://json-schema.org/draft-07/schema#","description":"[GUEST RESERVATION] guest pressed to save changes of guest in reservation","properties":{"bookingId":{"$id":"/properties/bookingId","description":"id of the booking","type":"string"},"bookingWithPass":{"$id":"/properties/bookingWithPass","description":"was the booking made using a pass","enum":["FALSE","PARTIAL","TRUE"],"type":"string"},"newAdultGuest":{"$id":"/properties/newAdultGuest","description":"new number of adult guest","type":"integer"},"newChildrenGuest":{"$id":"/properties/newChildrenGuest","description":"new number of children guest","type":"integer"},"newInfantGuest":{"$id":"/properties/newInfantGuest","description":"new number of infant guest","type":"integer"},"newPetGuest":{"$id":"/properties/newPetGuest","description":"new number of pet guest","type":"integer"},"originalAdultGuest":{"$id":"/properties/originalAdultGuest","description":"original number of adult guest","type":"integer"},"originalChildrenGuest":{"$id":"/properties/originalChildrenGuest","description":"original number of children guest","type":"integer"},"originalInfantGuest":{"$id":"/properties/originalInfantGuest","description":"original number of infant guest","type":"integer"},"originalPetGuest":{"$id":"/properties/originalPetGuest","description":"original number of pet guest","type":"integer"},"passId":{"$id":"/properties/passId","description":"if the booking was made or partially made with a pass, the pass id used","type":["integer","null"]},"passName":{"$id":"/properties/passName","description":"the type of the pass formatted to be LCM friendly\n","type":["string","null"]},"passType":{"$id":"/properties/passType","description":"if the booking was made or partially made with a pass, what type of pass","enum":["ALL_ACCESS","EARLY_BIRD","WEEKDAY",null],"type":["string","null"]},"userPassId":{"$id":"/properties/userPassId","description":"if the booking was made or partially made with a pass, what was the user pass Id used","type":["integer","null"]}},"required":["originalPetGuest","newPetGuest","originalInfantGuest","originalAdultGuest","newChildrenGuest","bookingId","newAdultGuest","newInfantGuest","originalChildrenGuest"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('GuestReservationSaveChangeGuest', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'GuestReservationSelectedCancelReason' track call.
 *
 * @param GuestReservationSelectedCancelReason props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function guestReservationSelectedCancelReason(props: GuestReservationSelectedCancelReason, options?: Options, callback?: Callback): void {

    const schema = {"$id":"GuestReservationSelectedCancelReason","$schema":"http://json-schema.org/draft-07/schema#","description":"[GUEST RESERVATION] guest selected cancellation reason","properties":{"bookingWithPass":{"$id":"/properties/bookingWithPass","description":"was the booking made using a pass","enum":["FALSE","PARTIAL","TRUE"],"type":"string"},"cancellationReason":{"$id":"/properties/cancellationReason","description":"cancellation reason selected by guest","type":"string"},"passId":{"$id":"/properties/passId","description":"if the booking was made or partially made with a pass, the pass id used","type":["integer","null"]},"passName":{"$id":"/properties/passName","description":"the type of the pass formatted to be LCM friendly\n","type":["string","null"]},"passType":{"$id":"/properties/passType","description":"if the booking was made or partially made with a pass, what type of pass","enum":["ALL_ACCESS","EARLY_BIRD","WEEKDAY",null],"type":["string","null"]},"userPassId":{"$id":"/properties/userPassId","description":"if the booking was made or partially made with a pass, what was the user pass Id used","type":["integer","null"]}},"required":["cancellationReason"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('GuestReservationSelectedCancelReason', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'GuestSelectFavoriteList' track call.
 *
 * @param GuestSelectFavoriteList props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function guestSelectFavoriteList(props: GuestSelectFavoriteList, options?: Options, callback?: Callback): void {

    const schema = {"$id":"GuestSelectFavoriteList","$schema":"http://json-schema.org/draft-07/schema#","description":"[GUEST FAVORITE] guest pressed to enter one of the favorite lists","properties":{"alphaUserId":{"$id":"/properties/alphaUserId","description":"the user id of the account who created the favorite collection","type":"integer"},"betaUserIds":{"$id":"/properties/betaUserIds","description":"an array of any favorite collection collaborator's user ids","type":"array"},"favoriteCollectionId":{"$id":"/properties/favoriteCollectionId","description":"the favorite collection id","type":"integer"},"favoriteCollectionName":{"$id":"/properties/favoriteCollectionName","description":"the name of the favorite collection","type":"string"},"id":{"$id":"/properties/id","description":"","type":"string"},"isAlphaUserId":{"$id":"/properties/isAlphaUserId","description":"a boolean to identify whether the actions being taken to a favorite collection are being done by the alpha user (1) or a beta user (0)","type":"boolean"}},"required":["isAlphaUserId","favoriteCollectionId","favoriteCollectionName"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('GuestSelectFavoriteList', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'GuestSelectedRefundType' track call.
 *
 * @param GuestSelectedRefundType props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function guestSelectedRefundType(props: GuestSelectedRefundType, options?: Options, callback?: Callback): void {

    const schema = {"$id":"GuestSelectedRefundType","$schema":"http://json-schema.org/draft-07/schema#","description":"[GUEST RESERVATION] guest select and pressed accept refund type after host cancelled booking","properties":{"bookingId":{"$id":"/properties/bookingId","description":"id of the booking","type":"string"},"bookingWithPass":{"$id":"/properties/bookingWithPass","description":"was the booking made using a pass","enum":["FALSE","PARTIAL","TRUE"],"type":"string"},"cashRefundAmount":{"$id":"/properties/cashRefundAmount","description":"amount of the cash refund option","type":"number"},"creditRefundAmount":{"$id":"/properties/creditRefundAmount","description":"amount of the credit refund option","type":"number"},"isCredit":{"$id":"/properties/isCredit","description":"True if guest pressed credit option, false if pressed cash option","type":"boolean"},"passId":{"$id":"/properties/passId","description":"if the booking was made or partially made with a pass, the pass id used","type":["integer","null"]},"passName":{"$id":"/properties/passName","description":"the type of the pass formatted to be LCM friendly\n","type":["string","null"]},"passType":{"$id":"/properties/passType","description":"if the booking was made or partially made with a pass, what type of pass","enum":["ALL_ACCESS","EARLY_BIRD","WEEKDAY",null],"type":["string","null"]},"userPassId":{"$id":"/properties/userPassId","description":"if the booking was made or partially made with a pass, what was the user pass Id used","type":["integer","null"]}},"required":["cashRefundAmount","creditRefundAmount","isCredit","bookingId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('GuestSelectedRefundType', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'GuestSubmittedRefundRequest' track call.
 *
 * @param GuestSubmittedRefundRequest props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function guestSubmittedRefundRequest(props: GuestSubmittedRefundRequest, options?: Options, callback?: Callback): void {

    const schema = {"$id":"GuestSubmittedRefundRequest","$schema":"http://json-schema.org/draft-07/schema#","description":"guest submitted a refund request to host","properties":{"bookingId":{"$id":"/properties/bookingId","description":"id of the booking","type":"integer"},"bookingStatus":{"$id":"/properties/bookingStatus","description":"status of the booking","type":"string"},"hostId":{"$id":"/properties/hostId","description":"id of the host for the booking","type":"integer"},"refundMessage":{"$id":"/properties/refundMessage","description":"message the guest sends to the host regarding the refund","type":"string"},"refundReason":{"$id":"/properties/refundReason","description":"guest-selected refund reason","type":"string"}},"required":["bookingId","bookingStatus","hostId","refundMessage","refundReason"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('GuestSubmittedRefundRequest', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'GuestSubmittedSendRequestWithNote' track call.
 *
 * @param GuestSubmittedSendRequestWithNote props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function guestSubmittedSendRequestWithNote(props: GuestSubmittedSendRequestWithNote, options?: Options, callback?: Callback): void {

    const schema = {"$id":"GuestSubmittedSendRequestWithNote","$schema":"http://json-schema.org/draft-07/schema#","description":"[GUEST RESERVATION] guest submitted change request with note to host","properties":{"bookingId":{"$id":"/properties/bookingId","description":"id of the booking","type":"string"},"bookingWithPass":{"$id":"/properties/bookingWithPass","description":"was the booking made using a pass","enum":["FALSE","PARTIAL","TRUE"],"type":"string"},"enteredNote":{"$id":"/properties/enteredNote","description":"note entered by the guests in the change request for host","type":"string"},"passId":{"$id":"/properties/passId","description":"if the booking was made or partially made with a pass, the pass id used","type":["integer","null"]},"passName":{"$id":"/properties/passName","description":"the type of the pass formatted to be LCM friendly\n","type":["string","null"]},"passType":{"$id":"/properties/passType","description":"if the booking was made or partially made with a pass, what type of pass","enum":["ALL_ACCESS","EARLY_BIRD","WEEKDAY",null],"type":["string","null"]},"userPassId":{"$id":"/properties/userPassId","description":"if the booking was made or partially made with a pass, what was the user pass Id used","type":["integer","null"]}},"required":["bookingId","enteredNote"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('GuestSubmittedSendRequestWithNote', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostAddedPromotionToListing' track call.
 *
 * @param HostAddedPromotionToListing props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostAddedPromotionToListing(props: HostAddedPromotionToListing, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostAddedPromotionToListing","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST PROMO CODE] Host Pressed \"Done\" or \"Skip\" on adding a message to their promocode and this event should fire when the promo is added to the listing","properties":{"amountOff":{"$id":"/properties/amountOff","description":"","type":"number"},"expireDate":{"$id":"/properties/expireDate","description":"","type":"string"},"globalListingType":{"$id":"/properties/globalListingType","description":"[LISTING TYPE] The type of the listing associated with this event","enum":["artStudio","basketballCourt","dockedBoat","home","homeGym","joyspace","kitchen","largeBackyard","musicStudio","other","pending","pickleball","pool","privateLake","roofDeck","tennisCourt"],"type":"string"},"isNew":{"$id":"/properties/isNew","description":"was the promotion created during the flow of adding a promotion to the pdp","type":"boolean"},"listingId":{"$id":"/properties/listingId","description":"","type":"string"},"maxRedemption":{"$id":"/properties/maxRedemption","description":"","type":"integer"},"promoCodeName":{"$id":"/properties/promoCodeName","description":"","type":"string"},"promoMessage":{"$id":"/properties/promoMessage","description":"if the user selected to add a message to go with the promo on the listing","type":"string"},"promocodeId":{"$id":"/properties/promocodeId","description":"","type":"integer"}},"required":["promocodeId","amountOff","expireDate","promoCodeName","isNew","globalListingType","listingId","maxRedemption"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostAddedPromotionToListing', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostAdditionalPoolDetailsEntered' track call.
 *
 * @param HostAdditionalPoolDetailsEntered props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostAdditionalPoolDetailsEntered(props: HostAdditionalPoolDetailsEntered, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostAdditionalPoolDetailsEntered","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST ONBOARDING] host entered additional pool details","properties":{"accessibilityDetails":{"$id":"/properties/accessibilityDetails","description":"if the host indicated the listing is ada compliant, they can add a note for context","type":"string"},"adaCompliantSelected":{"$id":"/properties/adaCompliantSelected","description":"host indicated pool ada compliant","type":"boolean"},"divingBoardSelected":{"$id":"/properties/divingBoardSelected","description":"host indicated pool has diving board","type":"boolean"},"enteredFrom":{"$id":"/properties/enteredFrom","description":"All possible values for enteredFrom in host onboarding","enum":["ProfilePhotosScreen","ProfileScreen","austin","austinFB","clarkRubber","dipApp","directPoolSupplies","existingHostNewListingFlow","hostExistingListingManagement","hostOnboardingFlow","houston","houstonFB","losangeles","losangelesFB","newYork","newYorkFB","noListingsScreen","performanceTips","ph","poolProfits","poolSafetySolutions","portland","portlandFB","precisionPoolsAndLandscape","profileManageListings","sanAntonio","sanAntonioFB","seattle","seattleFB","swimUniversity","toronto","torontoFB","vip"],"type":"string"},"features":{"$id":"/properties/features","description":"any generic features that a listing has","type":"array"},"greatForUseCase":{"$id":"/properties/greatForUseCase","description":"any great for stickers selected in the great for section\n","type":"array"},"greatSunlightSelected":{"$id":"/properties/greatSunlightSelected","description":"host indicated pool has great sunlight","type":"boolean"},"grottoSelected":{"$id":"/properties/grottoSelected","description":"host indicated pool has grotto","type":"boolean"},"kiddiePoolSelected":{"$id":"/properties/kiddiePoolSelected","description":"host indicated pool has kiddie pool","type":"boolean"},"largeShallowAreaSelected":{"$id":"/properties/largeShallowAreaSelected","description":"host indicated pool has large shallow area","type":"boolean"},"listingFeatures":{"$id":"/properties/listingFeatures","description":"any listing type specific features that a listing has\n","type":"array"},"listingId":{"$id":"/properties/listingId","description":"id for the related listing","type":"string"},"nightLightingSelected":{"$id":"/properties/nightLightingSelected","description":"host indicated pool has night lighting","type":"boolean"},"poolBasketballHoopSelected":{"$id":"/properties/poolBasketballHoopSelected","description":"host indicated pool has pool basketball hoop","type":"boolean"},"poolId":{"$id":"/properties/poolId","description":"legacy name for listing id","type":"string"},"pressedSaveExit":{"$id":"/properties/pressedSaveExit","description":"pressed \"save and exit\" to remove from flow","type":"boolean"},"saltWaterSelected":{"$id":"/properties/saltWaterSelected","description":"host indicated pool has saltwater","type":"boolean"},"shadedAreaSelected":{"$id":"/properties/shadedAreaSelected","description":"host indicated pool area has shade","type":"boolean"},"swimmingLanesSelected":{"$id":"/properties/swimmingLanesSelected","description":"host indicated pool has swimming lanes","type":"boolean"},"tanningEdgeSelected":{"$id":"/properties/tanningEdgeSelected","description":"host indicated pool has tanning edge","type":"boolean"},"waterSlideSelected":{"$id":"/properties/waterSlideSelected","description":"host indicated pool has water slide","type":"boolean"},"waterfallSelected":{"$id":"/properties/waterfallSelected","description":"host indicated pool has water fall","type":"boolean"}},"required":["swimmingLanesSelected","waterfallSelected","enteredFrom","features","saltWaterSelected","divingBoardSelected","poolBasketballHoopSelected","grottoSelected","shadedAreaSelected","kiddiePoolSelected","listingFeatures","tanningEdgeSelected","nightLightingSelected","adaCompliantSelected","listingId","greatForUseCase","waterSlideSelected","greatSunlightSelected","largeShallowAreaSelected","pressedSaveExit"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostAdditionalPoolDetailsEntered', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostAgreeNeighborGuidelines' track call.
 *
 * @param HostAgreeNeighborGuidelines props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostAgreeNeighborGuidelines(props: HostAgreeNeighborGuidelines, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostAgreeNeighborGuidelines","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST ONBOARDING] host read all and agree neighbor guidelines","properties":{"enteredFrom":{"$id":"/properties/enteredFrom","description":"All possible values for enteredFrom in host onboarding","enum":["ProfilePhotosScreen","ProfileScreen","austin","austinFB","clarkRubber","dipApp","directPoolSupplies","existingHostNewListingFlow","hostExistingListingManagement","hostOnboardingFlow","houston","houstonFB","losangeles","losangelesFB","newYork","newYorkFB","noListingsScreen","performanceTips","ph","poolProfits","poolSafetySolutions","portland","portlandFB","precisionPoolsAndLandscape","profileManageListings","sanAntonio","sanAntonioFB","seattle","seattleFB","swimUniversity","toronto","torontoFB","vip"],"type":"string"},"id":{"$id":"/properties/id","description":"","type":"string"},"listingId":{"$id":"/properties/listingId","description":"id for the related listing","type":"string"},"poolId":{"$id":"/properties/poolId","description":"legacy name for listing id","type":"string"}},"required":["enteredFrom","listingId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostAgreeNeighborGuidelines', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostAmenitiesAdded' track call.
 *
 * @param HostAmenitiesAdded props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostAmenitiesAdded(props: HostAmenitiesAdded, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostAmenitiesAdded","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST ONBOARDING] host added amenities. Event should fire per amenity selected","properties":{"amenityAdded":{"$id":"/properties/amenityAdded","description":"a host added an amenity","properties":{"amenityDetails":{"$id":"/properties/properties/properties/amenityAdded/properties/amenityDetails","description":"blurb for the amenity","type":["string","null"]},"amenityPricingDetails":{"$id":"/properties/properties/properties/amenityAdded/properties/amenityPricingDetails","description":"details of the amenity price (even if free)","properties":{"amenityPremiumFlatFee":{"$id":"/properties/properties/properties/amenityAdded/properties/amenityPricingDetails/properties/amenityPremiumFlatFee","description":"details for flat fee amenities","properties":{"flatFeeAmount":{"$id":"/properties/properties/properties/amenityAdded/properties/amenityPricingDetails/properties/amenityPremiumFlatFee/properties/flatFeeAmount","description":"flat fee amount","type":"string"},"flatFeeCurrencyType":{"$id":"/properties/properties/properties/amenityAdded/properties/amenityPricingDetails/properties/amenityPremiumFlatFee/properties/flatFeeCurrencyType","description":"currency for the flat fee","type":"string"},"isAmenityFlatFee":{"$id":"/properties/properties/properties/amenityAdded/properties/amenityPricingDetails/properties/amenityPremiumFlatFee/properties/isAmenityFlatFee","description":"is a flat fee charged ","type":"boolean"}},"required":["flatFeeAmount","isAmenityFlatFee","flatFeeCurrencyType"],"type":"object"},"amenityPremiumHourlyFee":{"$id":"/properties/properties/properties/amenityAdded/properties/amenityPricingDetails/properties/amenityPremiumHourlyFee","description":"details for hourly fee amenities","properties":{"hourlyFee":{"$id":"/properties/properties/properties/amenityAdded/properties/amenityPricingDetails/properties/amenityPremiumHourlyFee/properties/hourlyFee","description":"fee per hour","type":["number","null"]},"hourlyFeeCurrencyType":{"$id":"/properties/properties/properties/amenityAdded/properties/amenityPricingDetails/properties/amenityPremiumHourlyFee/properties/hourlyFeeCurrencyType","description":"currency for the hourly fee","type":"string"},"isAmenityPremiumHourlyFee":{"$id":"/properties/properties/properties/amenityAdded/properties/amenityPricingDetails/properties/amenityPremiumHourlyFee/properties/isAmenityPremiumHourlyFee","description":"is there an hourly fee","type":"boolean"}},"required":["hourlyFee","isAmenityPremiumHourlyFee","hourlyFeeCurrencyType"],"type":"object"},"isAmenityPremium":{"$id":"/properties/properties/properties/amenityAdded/properties/amenityPricingDetails/properties/isAmenityPremium","description":"is there an additional fee for this amenity","type":"boolean"}},"required":["isAmenityPremium"],"type":["object","null"]},"amenityType":{"$id":"/properties/properties/properties/amenityAdded/properties/amenityType","description":"name of the amenity added","type":"string"},"isCustomAmenity":{"$id":"/properties/properties/properties/amenityAdded/properties/isCustomAmenity","description":"is this a custom entered amenity (not a Swimply pre-defined amenity)","type":"boolean"}},"required":["amenityType","isCustomAmenity"],"type":"object"},"enteredFrom":{"$id":"/properties/enteredFrom","description":"All possible values for enteredFrom in host onboarding","enum":["ProfilePhotosScreen","ProfileScreen","austin","austinFB","clarkRubber","dipApp","directPoolSupplies","existingHostNewListingFlow","hostExistingListingManagement","hostOnboardingFlow","houston","houstonFB","losangeles","losangelesFB","newYork","newYorkFB","noListingsScreen","performanceTips","ph","poolProfits","poolSafetySolutions","portland","portlandFB","precisionPoolsAndLandscape","profileManageListings","sanAntonio","sanAntonioFB","seattle","seattleFB","swimUniversity","toronto","torontoFB","vip"],"type":"string"},"listingId":{"$id":"/properties/listingId","description":"id for the related listing","type":"string"},"poolId":{"$id":"/properties/poolId","description":"legacy name for listing id","type":"string"},"pressedSaveExit":{"$id":"/properties/pressedSaveExit","description":"pressed \"save and exit\" to remove from flow","type":"boolean"}},"required":["listingId","pressedSaveExit","enteredFrom"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostAmenitiesAdded', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostAmenitiesEntered' track call.
 *
 * @param HostAmenitiesEntered props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostAmenitiesEntered(props: HostAmenitiesEntered, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostAmenitiesEntered","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST ONBOARDING] host saved amenities - event should fire only when the amenity management selection are saved","properties":{"additionalAmenitiesAndServices":{"$id":"/properties/additionalAmenitiesAndServices","description":"","type":"string"},"additionalSpaces":{"$id":"/properties/additionalSpaces","description":"","type":"string"},"amenities":{"$id":"/properties/amenities","description":"any generic space type amenities that are added","type":"array"},"id":{"$id":"/properties/id","description":"","type":"string"},"listingAmenities":{"$id":"/properties/listingAmenities","description":"any listing type specific amenities that are added\n","type":"array"}},"required":["listingAmenities","amenities"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostAmenitiesEntered', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostAvailabilitySettingPressedAdvancedSetting' track call.
 *
 * @param HostAvailabilitySettingPressedAdvancedSetting props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostAvailabilitySettingPressedAdvancedSetting(props: HostAvailabilitySettingPressedAdvancedSetting, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostAvailabilitySettingPressedAdvancedSetting","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST CALENDAR] Host pressed the advanced setting in general availability setting (Cog wheel)","properties":{"listingId":{"$id":"/properties/listingId","description":"listing id","type":"string"}},"required":["listingId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostAvailabilitySettingPressedAdvancedSetting', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostAvailabilitySettingPressedDoneAdvancedSetting' track call.
 *
 * @param HostAvailabilitySettingPressedDoneAdvancedSetting props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostAvailabilitySettingPressedDoneAdvancedSetting(props: HostAvailabilitySettingPressedDoneAdvancedSetting, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostAvailabilitySettingPressedDoneAdvancedSetting","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST CALENDAR] Host pressed done in the advanced setting","properties":{"advancedNotice":{"$id":"/properties/advancedNotice","description":"selected advance notice","type":"number"},"futureBookingNotice":{"$id":"/properties/futureBookingNotice","description":"selected future booking notice","type":"number"},"instantMaxGuest":{"$id":"/properties/instantMaxGuest","description":"selected maximum number of guest for instant book","type":"integer"},"isInstantBook":{"$id":"/properties/isInstantBook","description":"true if enabled instant book, false otherwise","type":"boolean"},"isStillShowMeRequestAdvanceNotice":{"$id":"/properties/isStillShowMeRequestAdvanceNotice","description":"true if checked the box for still show me request under advance notice, false if unchecked","type":"boolean"},"isStillShowMeRequestFutureBooking":{"$id":"/properties/isStillShowMeRequestFutureBooking","description":"true if checked the box for still show me request under future notice, false if unchecked","type":"boolean"},"listingId":{"$id":"/properties/listingId","description":"listing id","type":"string"}},"required":["listingId","advancedNotice","futureBookingNotice","instantMaxGuest","isInstantBook","isStillShowMeRequestAdvanceNotice","isStillShowMeRequestFutureBooking"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostAvailabilitySettingPressedDoneAdvancedSetting', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostAvailabilitySettingPressedDoneGeneralSetting' track call.
 *
 * @param HostAvailabilitySettingPressedDoneGeneralSetting props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostAvailabilitySettingPressedDoneGeneralSetting(props: HostAvailabilitySettingPressedDoneGeneralSetting, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostAvailabilitySettingPressedDoneGeneralSetting","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST CALENDAR] Host pressed done in the general setting","properties":{"availableWeekDay":{"$id":"/properties/availableWeekDay","description":"array of selected available week day [Mon, Tue, Wed, Thur, Fri, Sat, Sun]","type":"array"},"bufferTime":{"$id":"/properties/bufferTime","description":"selected buffer time","type":"integer"},"endHour":{"$id":"/properties/endHour","description":"selected end available hour","type":"string"},"listingId":{"$id":"/properties/listingId","description":"listing id","type":"string"},"startHour":{"$id":"/properties/startHour","description":"selected start available hour","type":"string"}},"required":["bufferTime","listingId","endHour","startHour","availableWeekDay"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostAvailabilitySettingPressedDoneGeneralSetting', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostAvailabilitySettingPressedDoneListingStatus' track call.
 *
 * @param HostAvailabilitySettingPressedDoneListingStatus props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostAvailabilitySettingPressedDoneListingStatus(props: HostAvailabilitySettingPressedDoneListingStatus, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostAvailabilitySettingPressedDoneListingStatus","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST CALENDAR] Host pressed done in the listing setting","properties":{"currentStatus":{"$id":"/properties/currentStatus","description":"current status","type":"string"},"listingId":{"$id":"/properties/listingId","description":"listing id","type":"string"},"newStatus":{"$id":"/properties/newStatus","description":"new status","type":"string"}},"required":["listingId","currentStatus","newStatus"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostAvailabilitySettingPressedDoneListingStatus', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostAvailabilitySettingPressedGeneralSetting' track call.
 *
 * @param HostAvailabilitySettingPressedGeneralSetting props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostAvailabilitySettingPressedGeneralSetting(props: HostAvailabilitySettingPressedGeneralSetting, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostAvailabilitySettingPressedGeneralSetting","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST CALENDAR] Host pressed the general setting in general availability setting (Cog wheel)","properties":{"id":{"$id":"/properties/id","description":"","type":"string"}},"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostAvailabilitySettingPressedGeneralSetting', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostAvailabilitySettingPressedListingStatus' track call.
 *
 * @param HostAvailabilitySettingPressedListingStatus props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostAvailabilitySettingPressedListingStatus(props: HostAvailabilitySettingPressedListingStatus, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostAvailabilitySettingPressedListingStatus","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST CALENDAR] Host pressed the listing setting in general availability setting (Cog wheel)","properties":{"id":{"$id":"/properties/id","description":"","type":"string"}},"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostAvailabilitySettingPressedListingStatus', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostAvailabilitySettingPressedSyncCals' track call.
 *
 * @param HostAvailabilitySettingPressedSyncCals props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostAvailabilitySettingPressedSyncCals(props: HostAvailabilitySettingPressedSyncCals, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostAvailabilitySettingPressedSyncCals","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST CALENDAR SYNCING] host presses \"sync external calendars\"  after pressing the cog wheel","properties":{"listingId":{"$id":"/properties/listingId","description":"","type":"integer"}},"required":["listingId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostAvailabilitySettingPressedSyncCals', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostAvailabilitySettingPressedUnavailabilityRules' track call.
 *
 * @param HostAvailabilitySettingPressedUnavailabilityRules props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostAvailabilitySettingPressedUnavailabilityRules(props: HostAvailabilitySettingPressedUnavailabilityRules, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostAvailabilitySettingPressedUnavailabilityRules","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST CALENDAR] Host pressed the unavailability rule in general availability setting (Cog wheel)","properties":{"id":{"$id":"/properties/id","description":"","type":"string"}},"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostAvailabilitySettingPressedUnavailabilityRules', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostBookingCancellationPolicy' track call.
 *
 * @param HostBookingCancellationPolicy props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostBookingCancellationPolicy(props: HostBookingCancellationPolicy, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostBookingCancellationPolicy","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST ONBOARDING] host entered cancellation policy info","properties":{"cancellationPolicy":{"$id":"/properties/cancellationPolicy","description":"which cancellation policy was selected","type":"string"},"enteredFrom":{"$id":"/properties/enteredFrom","description":"All possible values for enteredFrom in host onboarding","enum":["ProfilePhotosScreen","ProfileScreen","austin","austinFB","clarkRubber","dipApp","directPoolSupplies","existingHostNewListingFlow","hostExistingListingManagement","hostOnboardingFlow","houston","houstonFB","losangeles","losangelesFB","newYork","newYorkFB","noListingsScreen","performanceTips","ph","poolProfits","poolSafetySolutions","portland","portlandFB","precisionPoolsAndLandscape","profileManageListings","sanAntonio","sanAntonioFB","seattle","seattleFB","swimUniversity","toronto","torontoFB","vip"],"type":"string"},"listingId":{"$id":"/properties/listingId","description":"id for the related listing","type":"string"},"poolId":{"$id":"/properties/poolId","description":"legacy name for listing id","type":"string"},"pressedSaveExit":{"$id":"/properties/pressedSaveExit","description":"pressed \"save and exit\" to remove from flow","type":"boolean"}},"required":["cancellationPolicy","pressedSaveExit","enteredFrom","listingId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostBookingCancellationPolicy', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostBookingHostPrivacy' track call.
 *
 * @param HostBookingHostPrivacy props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostBookingHostPrivacy(props: HostBookingHostPrivacy, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostBookingHostPrivacy","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST ONBOARDING] host entered information about cameras and whether they are home","properties":{"enteredFrom":{"$id":"/properties/enteredFrom","description":"All possible values for enteredFrom in host onboarding","enum":["ProfilePhotosScreen","ProfileScreen","austin","austinFB","clarkRubber","dipApp","directPoolSupplies","existingHostNewListingFlow","hostExistingListingManagement","hostOnboardingFlow","houston","houstonFB","losangeles","losangelesFB","newYork","newYorkFB","noListingsScreen","performanceTips","ph","poolProfits","poolSafetySolutions","portland","portlandFB","precisionPoolsAndLandscape","profileManageListings","sanAntonio","sanAntonioFB","seattle","seattleFB","swimUniversity","toronto","torontoFB","vip"],"type":"string"},"hostHasSecurityCameras":{"$id":"/properties/hostHasSecurityCameras","description":"does the pool have security cameras","type":"boolean"},"hostHomeOptionSelected":{"$id":"/properties/hostHomeOptionSelected","description":"host staying at home option","type":"string"},"listingId":{"$id":"/properties/listingId","description":"id for the related listing","type":"string"},"poolId":{"$id":"/properties/poolId","description":"legacy name for listing id","type":"string"},"pressedSaveExit":{"$id":"/properties/pressedSaveExit","description":"pressed \"save and exit\" to remove from flow","type":"boolean"}},"required":["enteredFrom","listingId","hostHasSecurityCameras","pressedSaveExit","hostHomeOptionSelected"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostBookingHostPrivacy', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostBookingRequestReview' track call.
 *
 * @param HostBookingRequestReview props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostBookingRequestReview(props: HostBookingRequestReview, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostBookingRequestReview","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST ONBOARDING] on booking overview page details about whether host requests to review each booking request","properties":{"confirmedReviewEveryRequest":{"$id":"/properties/confirmedReviewEveryRequest","description":"did the host confirm that they would like to review bookings","type":"boolean"},"enteredFrom":{"$id":"/properties/enteredFrom","description":"All possible values for enteredFrom in host onboarding","enum":["ProfilePhotosScreen","ProfileScreen","austin","austinFB","clarkRubber","dipApp","directPoolSupplies","existingHostNewListingFlow","hostExistingListingManagement","hostOnboardingFlow","houston","houstonFB","losangeles","losangelesFB","newYork","newYorkFB","noListingsScreen","performanceTips","ph","poolProfits","poolSafetySolutions","portland","portlandFB","precisionPoolsAndLandscape","profileManageListings","sanAntonio","sanAntonioFB","seattle","seattleFB","swimUniversity","toronto","torontoFB","vip"],"type":"string"},"listingId":{"$id":"/properties/listingId","description":"id for the related listing","type":"string"},"poolId":{"$id":"/properties/poolId","description":"legacy name for listing id","type":"string"},"pressReviewEveryRequest":{"$id":"/properties/pressReviewEveryRequest","description":"did the host press to see information about reviewing bookings","type":"boolean"},"pressedSaveExit":{"$id":"/properties/pressedSaveExit","description":"pressed \"save and exit\" to remove from flow","type":"boolean"}},"required":["enteredFrom","confirmedReviewEveryRequest","pressReviewEveryRequest","pressedSaveExit","listingId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostBookingRequestReview', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostBookingRules' track call.
 *
 * @param HostBookingRules props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostBookingRules(props: HostBookingRules, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostBookingRules","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST ONBOARDING] host entered in rules for pool","properties":{"additionalRules":{"$id":"/properties/additionalRules","description":"any additional rules that the host entered","type":"string"},"alcoholAllowed":{"$id":"/properties/alcoholAllowed","description":"is alcohol allowed","type":"boolean"},"enteredFrom":{"$id":"/properties/enteredFrom","description":"All possible values for enteredFrom in host onboarding","enum":["ProfilePhotosScreen","ProfileScreen","austin","austinFB","clarkRubber","dipApp","directPoolSupplies","existingHostNewListingFlow","hostExistingListingManagement","hostOnboardingFlow","houston","houstonFB","losangeles","losangelesFB","newYork","newYorkFB","noListingsScreen","performanceTips","ph","poolProfits","poolSafetySolutions","portland","portlandFB","precisionPoolsAndLandscape","profileManageListings","sanAntonio","sanAntonioFB","seattle","seattleFB","swimUniversity","toronto","torontoFB","vip"],"type":"string"},"listingId":{"$id":"/properties/listingId","description":"id for the related listing","type":"string"},"loudMusicAllowed":{"$id":"/properties/loudMusicAllowed","description":"is loud music allowed","type":"boolean"},"nudityAllowed":{"$id":"/properties/nudityAllowed","description":"is nudity allowed - pools only","type":["boolean","null"]},"partiesAllowed":{"$id":"/properties/partiesAllowed","description":"are parties allowed","type":"boolean"},"poolId":{"$id":"/properties/poolId","description":"legacy name for listing id","type":"string"},"pressedSaveExit":{"$id":"/properties/pressedSaveExit","description":"pressed \"save and exit\" to remove from flow","type":"boolean"},"smokingAllowed":{"$id":"/properties/smokingAllowed","description":"is smoking allowed","type":"boolean"},"thirdPartyVendorsAllowed":{"$id":"/properties/thirdPartyVendorsAllowed","description":"are 3rd party vendors allowed","type":"boolean"}},"required":["pressedSaveExit","smokingAllowed","additionalRules","alcoholAllowed","thirdPartyVendorsAllowed","loudMusicAllowed","partiesAllowed","listingId","enteredFrom"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostBookingRules', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostCalSyncPressedExportCalendar' track call.
 *
 * @param HostCalSyncPressedExportCalendar props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostCalSyncPressedExportCalendar(props: HostCalSyncPressedExportCalendar, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostCalSyncPressedExportCalendar","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST CALENDAR SYNCING] after pressing the cog wheel and then \"sync external calendars\" host pressed \"Export Swimply iCalendar\"","properties":{"listingId":{"$id":"/properties/listingId","description":"","type":"integer"}},"required":["listingId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostCalSyncPressedExportCalendar', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostCalSyncPressedImportCalendar' track call.
 *
 * @param HostCalSyncPressedImportCalendar props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostCalSyncPressedImportCalendar(props: HostCalSyncPressedImportCalendar, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostCalSyncPressedImportCalendar","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST CALENDAR SYNCING] after pressing the cog wheel and then \"sync external calendars\" host pressed \"Import external iCalendars\"","properties":{"listingId":{"$id":"/properties/listingId","description":"","type":"integer"}},"required":["listingId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostCalSyncPressedImportCalendar', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostCalSyncPressedManageCronofy' track call.
 *
 * @param HostCalSyncPressedManageCronofy props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostCalSyncPressedManageCronofy(props: HostCalSyncPressedManageCronofy, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostCalSyncPressedManageCronofy","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST CALENDAR SYNCING] after pressing the cog wheel and then \"sync external calendars\" host pressed \"Manage Cronofy\"","properties":{"listingId":{"$id":"/properties/listingId","description":"","type":"integer"}},"required":["listingId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostCalSyncPressedManageCronofy', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostCalSyncPressedManageImportedCal' track call.
 *
 * @param HostCalSyncPressedManageImportedCal props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostCalSyncPressedManageImportedCal(props: HostCalSyncPressedManageImportedCal, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostCalSyncPressedManageImportedCal","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST CALENDAR SYNCING] after pressing the cog wheel and then \"sync external calendars\" host pressed \"Manage external iCalendars\"","properties":{"listingId":{"$id":"/properties/listingId","description":"","type":"integer"}},"required":["listingId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostCalSyncPressedManageImportedCal', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostCalSyncPressedSyncWCronofy' track call.
 *
 * @param HostCalSyncPressedSyncWCronofy props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostCalSyncPressedSyncWCronofy(props: HostCalSyncPressedSyncWCronofy, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostCalSyncPressedSyncWCronofy","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST CALENDAR SYNCING] after pressing the cog wheel and then \"sync external calendars\" host pressed \"Sync with Cronofy\"","properties":{"listingId":{"$id":"/properties/listingId","description":"","type":"integer"}},"required":["listingId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostCalSyncPressedSyncWCronofy', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostCalendarApplyDiscountOrBoost' track call.
 *
 * @param HostCalendarApplyDiscountOrBoost props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostCalendarApplyDiscountOrBoost(props: HostCalendarApplyDiscountOrBoost, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostCalendarApplyDiscountOrBoost","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST CALENDAR] Host pressed apply discount/boost button in price","properties":{"listingId":{"$id":"/properties/listingId","description":"Listing id ","type":"string"},"percentChange":{"$id":"/properties/percentChange","description":"Percent change for discount or boost","type":"integer"},"selectedDates":{"$id":"/properties/selectedDates","description":"Array of selected date for this adjustment","type":"array"}},"required":["percentChange","selectedDates","listingId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostCalendarApplyDiscountOrBoost', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostCalendarBottomCardAdjustedStatus' track call.
 *
 * @param HostCalendarBottomCardAdjustedStatus props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostCalendarBottomCardAdjustedStatus(props: HostCalendarBottomCardAdjustedStatus, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostCalendarBottomCardAdjustedStatus","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST CALENDAR] Host pressed to adjust status in the bottom card","properties":{"changedStatus":{"$id":"/properties/changedStatus","description":"Object consists of new status per dates","properties":{"dates":{"$id":"/properties/properties/properties/changedStatus/properties/dates","description":"selected dates","type":"array"},"newStatus":{"$id":"/properties/properties/properties/changedStatus/properties/newStatus","description":"status after changed, instant book or request only ","type":"string"},"originalStatus":{"$id":"/properties/properties/properties/changedStatus/properties/originalStatus","description":"status before changed, instant book or request only ","type":"string"}},"required":[],"type":"object"},"listingId":{"$id":"/properties/listingId","description":"listing id","type":"string"}},"required":["listingId","changedStatus"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostCalendarBottomCardAdjustedStatus', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostCalendarClearDiscountOrBoost' track call.
 *
 * @param HostCalendarClearDiscountOrBoost props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostCalendarClearDiscountOrBoost(props: HostCalendarClearDiscountOrBoost, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostCalendarClearDiscountOrBoost","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST CALENDAR] Host pressed clear in discount/boost in price","properties":{"id":{"$id":"/properties/id","description":"","type":"string"}},"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostCalendarClearDiscountOrBoost', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostCalendarCloseApplyDiscountOrBoost' track call.
 *
 * @param HostCalendarCloseApplyDiscountOrBoost props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostCalendarCloseApplyDiscountOrBoost(props: HostCalendarCloseApplyDiscountOrBoost, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostCalendarCloseApplyDiscountOrBoost","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST CALENDAR] Host pressed close in apply discount/boost card ","properties":{"id":{"$id":"/properties/id","description":"","type":"string"}},"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostCalendarCloseApplyDiscountOrBoost', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostCalendarCloseClearDiscountOrBoost' track call.
 *
 * @param HostCalendarCloseClearDiscountOrBoost props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostCalendarCloseClearDiscountOrBoost(props: HostCalendarCloseClearDiscountOrBoost, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostCalendarCloseClearDiscountOrBoost","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST CALENDAR] Host pressed close in clear card for discount/boost in price","properties":{"id":{"$id":"/properties/id","description":"","type":"string"}},"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostCalendarCloseClearDiscountOrBoost', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostCalendarCloseScheduleConflict' track call.
 *
 * @param HostCalendarCloseScheduleConflict props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostCalendarCloseScheduleConflict(props: HostCalendarCloseScheduleConflict, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostCalendarCloseScheduleConflict","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST CALENDAR] Host pressed close schedule conflicting card","properties":{"id":{"$id":"/properties/id","description":"","type":"string"}},"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostCalendarCloseScheduleConflict', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostCalendarConfirmClearDiscountOrBoost' track call.
 *
 * @param HostCalendarConfirmClearDiscountOrBoost props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostCalendarConfirmClearDiscountOrBoost(props: HostCalendarConfirmClearDiscountOrBoost, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostCalendarConfirmClearDiscountOrBoost","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST CALENDAR] Host pressed confirmed clear discount or boost","properties":{"id":{"$id":"/properties/id","description":"","type":"string"}},"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostCalendarConfirmClearDiscountOrBoost', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostCalendarNoTierPricePressedSetDiscountOrBoost' track call.
 *
 * @param HostCalendarNoTierPricePressedSetDiscountOrBoost props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostCalendarNoTierPricePressedSetDiscountOrBoost(props: HostCalendarNoTierPricePressedSetDiscountOrBoost, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostCalendarNoTierPricePressedSetDiscountOrBoost","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST CALENDAR] Host pressed set discount or boost in no tier pricing","properties":{"id":{"$id":"/properties/id","description":"","type":"string"}},"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostCalendarNoTierPricePressedSetDiscountOrBoost', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostCalendarNoTierPricePressedUpdatePrices' track call.
 *
 * @param HostCalendarNoTierPricePressedUpdatePrices props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostCalendarNoTierPricePressedUpdatePrices(props: HostCalendarNoTierPricePressedUpdatePrices, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostCalendarNoTierPricePressedUpdatePrices","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST CALENDAR] Host pressed update prices in no tier pricing card","properties":{"id":{"$id":"/properties/id","description":"","type":"string"}},"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostCalendarNoTierPricePressedUpdatePrices', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostCalendarPressedApplyBlockScheduleConflict' track call.
 *
 * @param HostCalendarPressedApplyBlockScheduleConflict props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostCalendarPressedApplyBlockScheduleConflict(props: HostCalendarPressedApplyBlockScheduleConflict, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostCalendarPressedApplyBlockScheduleConflict","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST CALENDAR] Host pressed apply block in the schedule conflicting card","properties":{"conflictedBookingId":{"$id":"/properties/conflictedBookingId","description":"Array of booking id got conflicted","type":"array"},"conflictedDate":{"$id":"/properties/conflictedDate","description":"Displayed conflicted date","type":"array"},"conflictedHour":{"$id":"/properties/conflictedHour","description":"Displayed conflicted hour","type":"array"},"listingId":{"$id":"/properties/listingId","description":"listing Id","type":"string"}},"required":["conflictedBookingId","conflictedDate","conflictedHour","listingId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostCalendarPressedApplyBlockScheduleConflict', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostCalendarPressedAvailability' track call.
 *
 * @param HostCalendarPressedAvailability props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostCalendarPressedAvailability(props: HostCalendarPressedAvailability, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostCalendarPressedAvailability","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST CALENDAR] Host pressed availability box","properties":{"id":{"$id":"/properties/id","description":"","type":"string"}},"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostCalendarPressedAvailability', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostCalendarPressedConfirmBlockedHour' track call.
 *
 * @param HostCalendarPressedConfirmBlockedHour props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostCalendarPressedConfirmBlockedHour(props: HostCalendarPressedConfirmBlockedHour, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostCalendarPressedConfirmBlockedHour","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST CALENDAR] Host pressed block hour button to confirm block hour","properties":{"dates":{"$id":"/properties/dates","description":"Array of selected dates","type":"array"},"endHour":{"$id":"/properties/endHour","description":"hour the block end","type":"string"},"listingId":{"$id":"/properties/listingId","description":"listing id","type":"string"},"startHour":{"$id":"/properties/startHour","description":"hour the block start","type":"string"}},"required":["dates","listingId","endHour","startHour"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostCalendarPressedConfirmBlockedHour', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostCalendarPressedEditDiscountorBoost' track call.
 *
 * @param HostCalendarPressedEditDiscountorBoost props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostCalendarPressedEditDiscountorBoost(props: HostCalendarPressedEditDiscountorBoost, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostCalendarPressedEditDiscountorBoost","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST CALENDAR] Host pressed edit for discount/boost","properties":{"id":{"$id":"/properties/id","description":"","type":"string"}},"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostCalendarPressedEditDiscountorBoost', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostCalendarPressedExitManageDate' track call.
 *
 * @param HostCalendarPressedExitManageDate props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostCalendarPressedExitManageDate(props: HostCalendarPressedExitManageDate, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostCalendarPressedExitManageDate","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST CALENDAR] Host pressed cross on top left to exit managing dates","properties":{"id":{"$id":"/properties/id","description":"","type":"string"}},"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostCalendarPressedExitManageDate', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostCalendarPressedManageGeneralAvailability' track call.
 *
 * @param HostCalendarPressedManageGeneralAvailability props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostCalendarPressedManageGeneralAvailability(props: HostCalendarPressedManageGeneralAvailability, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostCalendarPressedManageGeneralAvailability","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST CALENDAR] Host pressed cog wheel for general availability setting","properties":{"id":{"$id":"/properties/id","description":"","type":"string"}},"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostCalendarPressedManageGeneralAvailability', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostCalendarPressedManageSelectDates' track call.
 *
 * @param HostCalendarPressedManageSelectDates props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostCalendarPressedManageSelectDates(props: HostCalendarPressedManageSelectDates, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostCalendarPressedManageSelectDates","$schema":"http://json-schema.org/draft-07/schema#","description":"Host pressed manage in calendar view ","properties":{"dates":{"$id":"/properties/dates","description":"array object of the selected dates","type":"array"},"listingId":{"$id":"/properties/listingId","description":"listingId","type":"string"}},"required":["dates","listingId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostCalendarPressedManageSelectDates', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostCalendarPressedPrice' track call.
 *
 * @param HostCalendarPressedPrice props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostCalendarPressedPrice(props: HostCalendarPressedPrice, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostCalendarPressedPrice","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST CALENDAR] Host pressed price in the manage date view","properties":{"id":{"$id":"/properties/id","description":"","type":"string"}},"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostCalendarPressedPrice', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostCalendarPressedRemoveBlock' track call.
 *
 * @param HostCalendarPressedRemoveBlock props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostCalendarPressedRemoveBlock(props: HostCalendarPressedRemoveBlock, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostCalendarPressedRemoveBlock","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST CALENDAR] Host pressed remove block in the manage date view","properties":{"dates":{"$id":"/properties/dates","description":"array of selected dates","type":"array"},"endHour":{"$id":"/properties/endHour","description":"end of blocked hour","type":"string"},"listingId":{"$id":"/properties/listingId","description":"listing id","type":"string"},"startHour":{"$id":"/properties/startHour","description":"start of blocked hour","type":"string"}},"required":["endHour","startHour","listingId","dates"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostCalendarPressedRemoveBlock', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostCalendarPressedSetDiscountOrBoost' track call.
 *
 * @param HostCalendarPressedSetDiscountOrBoost props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostCalendarPressedSetDiscountOrBoost(props: HostCalendarPressedSetDiscountOrBoost, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostCalendarPressedSetDiscountOrBoost","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST CALENDAR] Host pressed set discount or boost in price view ","properties":{"id":{"$id":"/properties/id","description":"","type":"string"}},"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostCalendarPressedSetDiscountOrBoost', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostCalendarRemoveSelectedDates' track call.
 *
 * @param HostCalendarRemoveSelectedDates props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostCalendarRemoveSelectedDates(props: HostCalendarRemoveSelectedDates, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostCalendarRemoveSelectedDates","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST CALENDAR] Host pressed remove selected dates on top of the manage view (only for multiple selected dates)","properties":{"listingId":{"$id":"/properties/listingId","description":"listing id","type":"string"},"removedDates":{"$id":"/properties/removedDates","description":"removed dates","type":"array"}},"required":["removedDates","listingId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostCalendarRemoveSelectedDates', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostCalendarSelectedDate' track call.
 *
 * @param HostCalendarSelectedDate props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostCalendarSelectedDate(props: HostCalendarSelectedDate, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostCalendarSelectedDate","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST CALENDAR] Host pressed on date in the calendar view","properties":{"id":{"$id":"/properties/id","description":"","type":"string"}},"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostCalendarSelectedDate', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostCalendarViewReservationScheduleConflict' track call.
 *
 * @param HostCalendarViewReservationScheduleConflict props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostCalendarViewReservationScheduleConflict(props: HostCalendarViewReservationScheduleConflict, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostCalendarViewReservationScheduleConflict","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST CALENDAR] Host pressed view reservation on schedule conflict card","properties":{"conflictedBookingId":{"$id":"/properties/conflictedBookingId","description":"Array of booking id got conflicted","type":"array"},"conflictedDate":{"$id":"/properties/conflictedDate","description":"Displayed conflicted date","type":"array"},"conflictedHour":{"$id":"/properties/conflictedHour","description":"Displayed conflicted hour","type":"array"}},"required":["conflictedBookingId","conflictedDate","conflictedHour"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostCalendarViewReservationScheduleConflict', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostCancelledSpecialOffer' track call.
 *
 * @param HostCancelledSpecialOffer props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostCancelledSpecialOffer(props: HostCancelledSpecialOffer, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostCancelledSpecialOffer","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST BOOKING INQUIRY POST-SPECIAL OFFER SENT]","properties":{"bookingId":{"$id":"/properties/bookingId","description":"","type":"integer"},"bookingSpecialOfferId":{"$id":"/properties/bookingSpecialOfferId","description":"","type":"integer"},"courtesyNote":{"$id":"/properties/courtesyNote","description":"","type":["string","null"]},"globalListingType":{"$id":"/properties/globalListingType","description":"[LISTING TYPE] The type of the listing associated with this event","enum":["artStudio","basketballCourt","dockedBoat","home","homeGym","joyspace","kitchen","largeBackyard","musicStudio","other","pending","pickleball","pool","privateLake","roofDeck","tennisCourt"],"type":"string"},"guestId":{"$id":"/properties/guestId","description":"","type":"integer"},"hostId":{"$id":"/properties/hostId","description":"","type":"integer"},"listingId":{"$id":"/properties/listingId","description":"","type":"integer"},"originalPrice":{"$id":"/properties/originalPrice","description":"","type":"number"},"roomId":{"$id":"/properties/roomId","description":"","type":"string"},"specialOfferPrice":{"$id":"/properties/specialOfferPrice","description":"","type":"number"}},"required":["listingId","bookingSpecialOfferId","bookingId","specialOfferPrice","originalPrice","globalListingType","hostId","guestId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostCancelledSpecialOffer', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostConfirmedDeactivatePass' track call.
 *
 * @param HostConfirmedDeactivatePass props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostConfirmedDeactivatePass(props: HostConfirmedDeactivatePass, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostConfirmedDeactivatePass","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST PASS MANAGEMENT - DEACTIVATING]","properties":{"coverImageURL":{"$id":"/properties/coverImageURL","description":"the url for the cover image of the listing the pass is for","type":"string"},"hostFirstName":{"$id":"/properties/hostFirstName","description":"first name of the host","type":"string"},"id":{"$id":"/properties/id","description":"","type":"string"},"listingId":{"$id":"/properties/listingId","description":"id of the listing the pass is for","type":"string"},"listingTitle":{"$id":"/properties/listingTitle","description":"the title of the listing the pass is for","type":"string"},"listingURL":{"$id":"/properties/listingURL","description":"the url of the listing the pass is for","type":"string"},"passAvailableTimes":{"$id":"/properties/passAvailableTimes","description":"[{from:”07:00:00”, “11:00:00”}...] Time slots when this pass is eligible","type":"array"},"passAvailableTimesText":{"$id":"/properties/passAvailableTimesText","description":"LCM formatted version of available times property","type":"string"},"passBlackoutDays":{"$id":"/properties/passBlackoutDays","description":"list of blackout dates (e.g. July 4, 2024). ","type":["array","null"]},"passCreatedAt":{"$id":"/properties/passCreatedAt","description":"when the pass was created","type":"string"},"passCurrencyCode":{"$id":"/properties/passCurrencyCode","description":"currency for all monetary fields","type":"string"},"passCurrent":{"$id":"/properties/passCurrent","description":"flag indicating that this is the current version for a pass. For a type/name/listing_id, there can only be one record with this attribute true.","type":"boolean"},"passDescription":{"$id":"/properties/passDescription","description":"free text description set by host","type":["string","null"]},"passDiscount":{"$id":"/properties/passDiscount","description":"discount amount. Fixed discounts will be in minors units.","type":["number","null"]},"passDiscountType":{"$id":"/properties/passDiscountType","description":"type of pass discount num[‘percentage’, ‘fixed’]","enum":["FIXED","PERCENTAGE",null],"type":["string","null"]},"passEligibleDays":{"$id":"/properties/passEligibleDays","description":"days the pass is eligible","type":["array","null"]},"passId":{"$id":"/properties/passId","description":"id of the pass","type":"integer"},"passMaxActivePasses":{"$id":"/properties/passMaxActivePasses","description":"max active passes allowed. This constraint will apply to the (listing_id, type, name) rather than id so that we can be accurate across edits.","type":["number","null"]},"passMaxDailyBookings":{"$id":"/properties/passMaxDailyBookings","description":"max bookings allowed under this pass","type":["number","null"]},"passMaxDuration":{"$id":"/properties/passMaxDuration","description":"max duration that may be booked using this pass","type":["number","null"]},"passMaxGuests":{"$id":"/properties/passMaxGuests","description":"max guests that may be booked using this pass","type":["number","null"]},"passName":{"$id":"/properties/passName","description":"the type of the pass formatted to be LCM friendly","pattern":"","type":"string"},"passPremiumAmenities":{"$id":"/properties/passPremiumAmenities","description":"the ids of all premium amenities included with the pass","type":["array","null"]},"passPrice":{"$id":"/properties/passPrice","description":"pass price in minor units","type":"string"},"passState":{"$id":"/properties/passState","description":"‘draft’ -> pass is being actively edited by the host via the creation flow. The step attribute below tracks the progress of the host through the creation flow.\n‘inactive’ -> pass has been created by the host, but not ready for sale yet\n‘active’ -> pass has passed the final availability requirements and has been marked by the host as ready for sale.","enum":["ACTIVE","DRAFT","INACTIVE"],"type":"string"},"passTotalPrice":{"$id":"/properties/passTotalPrice","description":"the pass of the price plus the service fee","type":"string"},"passType":{"$id":"/properties/passType","description":"the type of pass","enum":["ALL_ACCESS","EARLY_BIRD","FIXED_HOURS","WEEKDAY"],"type":"string"}},"required":["listingURL","passCreatedAt","passType","passDiscount","passCurrencyCode","passState","listingId","passId","passCurrent","passPrice","passDiscountType","listingTitle","passTotalPrice","hostFirstName","coverImageURL","passName"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostConfirmedDeactivatePass', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostConfirmedRefundPassholder' track call.
 *
 * @param HostConfirmedRefundPassholder props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostConfirmedRefundPassholder(props: HostConfirmedRefundPassholder, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostConfirmedRefundPassholder","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST PASS MANAGEMENT - REFUND]","properties":{"canceled":{"$id":"/properties/canceled","description":"","type":"boolean"},"canceledReason":{"$id":"/properties/canceledReason","description":"","type":"string"},"coverImageURL":{"$id":"/properties/coverImageURL","description":"the url for the cover image of the listing the pass is for","type":"string"},"createdAt":{"$id":"/properties/createdAt","description":"","type":"string"},"end":{"$id":"/properties/end","description":"","type":"string"},"hasAutorenewOn":{"$id":"/properties/hasAutorenewOn","description":"","type":"boolean"},"hostFirstName":{"$id":"/properties/hostFirstName","description":"first name of the host","type":"string"},"id":{"$id":"/properties/id","description":"","type":"string"},"isLegacy":{"$id":"/properties/isLegacy","description":"true if the pass is a legacy pass","type":"boolean"},"listingId":{"$id":"/properties/listingId","description":"id of the listing the pass is for","type":"string"},"listingTitle":{"$id":"/properties/listingTitle","description":"the title of the listing the pass is for","type":"string"},"listingURL":{"$id":"/properties/listingURL","description":"the url of the listing the pass is for","type":"string"},"passAvailableTimes":{"$id":"/properties/passAvailableTimes","description":"[{from:”07:00:00”, “11:00:00”}...] Time slots when this pass is eligible","type":"array"},"passAvailableTimesText":{"$id":"/properties/passAvailableTimesText","description":"LCM formatted version of available times property","type":"string"},"passBlackoutDays":{"$id":"/properties/passBlackoutDays","description":"list of blackout dates (e.g. July 4, 2024). ","type":["array","null"]},"passCreatedAt":{"$id":"/properties/passCreatedAt","description":"when the pass was created","type":"string"},"passCurrencyCode":{"$id":"/properties/passCurrencyCode","description":"currency for all monetary fields","type":"string"},"passCurrent":{"$id":"/properties/passCurrent","description":"flag indicating that this is the current version for a pass. For a type/name/listing_id, there can only be one record with this attribute true.","type":"boolean"},"passDescription":{"$id":"/properties/passDescription","description":"free text description set by host","type":["string","null"]},"passDiscount":{"$id":"/properties/passDiscount","description":"discount amount. Fixed discounts will be in minors units.","type":["number","null"]},"passDiscountType":{"$id":"/properties/passDiscountType","description":"type of pass discount num[‘percentage’, ‘fixed’]","enum":["FIXED","PERCENTAGE",null],"type":["string","null"]},"passEligibleDays":{"$id":"/properties/passEligibleDays","description":"days the pass is eligible","type":["array","null"]},"passId":{"$id":"/properties/passId","description":"id of the pass","type":"integer"},"passMaxActivePasses":{"$id":"/properties/passMaxActivePasses","description":"max active passes allowed. This constraint will apply to the (listing_id, type, name) rather than id so that we can be accurate across edits.","type":["number","null"]},"passMaxDailyBookings":{"$id":"/properties/passMaxDailyBookings","description":"max bookings allowed under this pass","type":["number","null"]},"passMaxDuration":{"$id":"/properties/passMaxDuration","description":"max duration that may be booked using this pass","type":["number","null"]},"passMaxGuests":{"$id":"/properties/passMaxGuests","description":"max guests that may be booked using this pass","type":["number","null"]},"passName":{"$id":"/properties/passName","description":"the type of the pass formatted to be LCM friendly","pattern":"","type":"string"},"passPremiumAmenities":{"$id":"/properties/passPremiumAmenities","description":"the ids of all premium amenities included with the pass","type":["array","null"]},"passPrice":{"$id":"/properties/passPrice","description":"pass price in minor units","type":"string"},"passState":{"$id":"/properties/passState","description":"‘draft’ -> pass is being actively edited by the host via the creation flow. The step attribute below tracks the progress of the host through the creation flow.\n‘inactive’ -> pass has been created by the host, but not ready for sale yet\n‘active’ -> pass has passed the final availability requirements and has been marked by the host as ready for sale.","enum":["ACTIVE","DRAFT","INACTIVE"],"type":"string"},"passTotalPrice":{"$id":"/properties/passTotalPrice","description":"the pass of the price plus the service fee","type":"string"},"passType":{"$id":"/properties/passType","description":"the type of pass","enum":["ALL_ACCESS","EARLY_BIRD","FIXED_HOURS","WEEKDAY"],"type":"string"},"passholderStatus":{"$id":"/properties/passholderStatus","description":"the status of the pass","enum":["ACTIVE","EXPIRED"],"type":"string"},"passholderUserId":{"$id":"/properties/passholderUserId","description":"the user id of the pass holder ","type":"integer"},"start":{"$id":"/properties/start","description":"","type":"string"},"userPassId":{"$id":"/properties/userPassId","description":"","type":"integer"}},"required":["passDiscountType","passName","passDiscount","passId","passCurrent","passType","passCreatedAt","passholderUserId","passTotalPrice","coverImageURL","hostFirstName","end","hasAutorenewOn","passCurrencyCode","passholderStatus","passPrice","userPassId","start","listingURL","listingId","passState","isLegacy","listingTitle"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostConfirmedRefundPassholder', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostDeletedReviewReply' track call.
 *
 * @param HostDeletedReviewReply props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostDeletedReviewReply(props: HostDeletedReviewReply, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostDeletedReviewReply","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST PERFORMANCE] Host deleted their reply to a review","properties":{"bookingId":{"$id":"/properties/bookingId","description":"","type":"integer"},"bookingMessage":{"$id":"/properties/bookingMessage","description":"message sent by the guest when booking","type":["string","null"]},"bookingRating":{"$id":"/properties/bookingRating","description":"if the guest left a rating between 1-5, what was it","type":["integer","null"]},"bookingReason":{"$id":"/properties/bookingReason","description":"guest selection (listing type specific) for why they're booking","enum":["casual_play","competitive_play","corporate_or_meeting","courts","date","exercise","family_hangout","friend_hangout","lessons",null,"other","party_celebration","party_or_celebration","pet_swim","photoshoot","training"],"type":["string","null"]},"bookingReview":{"$id":"/properties/bookingReview","description":"if the guest left a review, what was it","type":["string","null"]},"bookingSpecialOfferId":{"$id":"/properties/bookingSpecialOfferId","description":"","type":["integer","null"]},"guestId":{"$id":"/properties/guestId","description":"","type":"integer"},"hostId":{"$id":"/properties/hostId","description":"","type":"integer"},"id":{"$id":"/properties/id","description":"","type":"string"},"isInstantBooking":{"$id":"/properties/isInstantBooking","description":"","type":"boolean"},"listingId":{"$id":"/properties/listingId","description":"","type":"integer"},"listingTitle":{"$id":"/properties/listingTitle","description":"","type":"string"},"reply":{"$id":"/properties/reply","description":"the host's reply","type":"string"},"totalGuests":{"$id":"/properties/totalGuests","description":"","type":"integer"},"totalPrice":{"$id":"/properties/totalPrice","description":"","type":"number"}},"required":["reply","bookingId","guestId","hostId","listingId","listingTitle"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostDeletedReviewReply', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostEarningHistChangedStartDate' track call.
 *
 * @param HostEarningHistChangedStartDate props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostEarningHistChangedStartDate(props: HostEarningHistChangedStartDate, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostEarningHistChangedStartDate","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST PERFORMANCE] Host pressed to change the start date in the transaction in earning","properties":{"listingId":{"$id":"/properties/listingId","description":"id of the listing","type":"string"},"newStartDate":{"$id":"/properties/newStartDate","description":"the new start date","type":"string"}},"required":["newStartDate","listingId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostEarningHistChangedStartDate', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostEarningHistPressedEndDate' track call.
 *
 * @param HostEarningHistPressedEndDate props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostEarningHistPressedEndDate(props: HostEarningHistPressedEndDate, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostEarningHistPressedEndDate","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST PERFORMANCE] Host pressed the displayed end date in transaction in earning","properties":{"endDate":{"$id":"/properties/endDate","description":"end date of the shown transaction","type":"string"},"listingId":{"$id":"/properties/listingId","description":"id of the listing","type":"string"}},"required":["endDate","listingId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostEarningHistPressedEndDate', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostEarningHistPressedStartDate' track call.
 *
 * @param HostEarningHistPressedStartDate props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostEarningHistPressedStartDate(props: HostEarningHistPressedStartDate, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostEarningHistPressedStartDate","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST PERFORMANCE] Host pressed the displayed start date in transaction in earning","properties":{"listingId":{"$id":"/properties/listingId","description":"id of the listing","type":"string"},"startDate":{"$id":"/properties/startDate","description":"start date of the shown transaction","type":"string"}},"required":["startDate","listingId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostEarningHistPressedStartDate', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostEarningHistSwitchTab' track call.
 *
 * @param HostEarningHistSwitchTab props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostEarningHistSwitchTab(props: HostEarningHistSwitchTab, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostEarningHistSwitchTab","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST PERFORMANCE] Host pressed the completed or upcoming tab in transaction in earning DB","properties":{"listingId":{"$id":"/properties/listingId","description":"id of the listing","type":"string"},"switchTo":{"$id":"/properties/switchTo","description":"the tab that pressed by the host (completed or upcoming)","enum":["completed","upcoming"],"type":"string"}},"required":["switchTo","listingId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostEarningHistSwitchTab', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostEarningsHistChangedEndDate' track call.
 *
 * @param HostEarningsHistChangedEndDate props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostEarningsHistChangedEndDate(props: HostEarningsHistChangedEndDate, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostEarningsHistChangedEndDate","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST PERFORMANCE] Host pressed to change the end date in the transaction in earning","properties":{"listingId":{"$id":"/properties/listingId","description":"id of the listing","type":"string"},"newEndDate":{"$id":"/properties/newEndDate","description":"the new end date","type":"string"}},"required":["newEndDate","listingId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostEarningsHistChangedEndDate', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostEarningsSwitchTab' track call.
 *
 * @param HostEarningsSwitchTab props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostEarningsSwitchTab(props: HostEarningsSwitchTab, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostEarningsSwitchTab","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST PERFORMANCE] Host pressed insight or transactions tab in earning DB","properties":{"listingId":{"$id":"/properties/listingId","description":"id of the listing","type":"string"},"switchTo":{"$id":"/properties/switchTo","description":"the tab that pressed by the host (insight or transactions)","enum":["insights","transactions"],"type":"string"}},"required":["switchTo","listingId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostEarningsSwitchTab', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostEditListingProperty' track call.
 *
 * @param HostEditListingProperty props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostEditListingProperty(props: HostEditListingProperty, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostEditListingProperty","$schema":"http://json-schema.org/draft-07/schema#","description":"when host edit a listing property","properties":{"globalListingType":{"$id":"/properties/globalListingType","description":"[LISTING TYPE] The type of the listing associated with this event","enum":["artStudio","basketballCourt","dockedBoat","home","homeGym","joyspace","kitchen","largeBackyard","musicStudio","other","pending","pickleball","pool","privateLake","roofDeck","tennisCourt"],"type":"string"},"listingId":{"$id":"/properties/listingId","description":"id of the listing","type":"integer"},"spacePropertyCategory":{"$id":"/properties/spacePropertyCategory","description":"category of the space property","enum":["amenities","availability","cancallations","features","guests","hostPreference","parking","pricing","privacy","profile","restroom","spaceDetails","spaceFeatures"],"type":"string"},"value":{"$id":"/properties/value","description":"the values of each edited property","items":{"$id":"/properties/properties/properties/value/items","description":"each item contains the field name and the value edited for the property","properties":{"fieldName":{"$id":"/properties/properties/properties/value/items/properties/fieldName","description":"the field name of the listing property","type":"string"},"value":{"$id":"/properties/properties/properties/value/items/properties/value","description":"the value after edited or selected","type":"string"}},"required":["fieldName","value"],"type":"object"},"type":"array"}},"required":["listingId","globalListingType","spacePropertyCategory","value"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostEditListingProperty', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostEnteredFlatRatePrice' track call.
 *
 * @param HostEnteredFlatRatePrice props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostEnteredFlatRatePrice(props: HostEnteredFlatRatePrice, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostEnteredFlatRatePrice","$schema":"http://json-schema.org/draft-07/schema#","description":"[TIERED PRICING] host entered the price for legacy flat rate pricing ","properties":{"isEditHourlyPrice":{"$id":"/properties/isEditHourlyPrice","description":"boolean true if the price change is for the hourly price, false if the price change is for the fee per guest","type":"boolean"},"newPrice":{"$id":"/properties/newPrice","description":"new price after change","type":"number"},"originalPrice":{"$id":"/properties/originalPrice","description":"original price before change","type":"number"}},"required":["newPrice","originalPrice","isEditHourlyPrice"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostEnteredFlatRatePrice', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostEnteredFullDayPrice' track call.
 *
 * @param HostEnteredFullDayPrice props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostEnteredFullDayPrice(props: HostEnteredFullDayPrice, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostEnteredFullDayPrice","$schema":"http://json-schema.org/draft-07/schema#","description":"[TIERED PRICING] host entered the price for the full day price","properties":{"newPrice":{"$id":"/properties/newPrice","description":"new price after change","type":"number"},"originalPrice":{"$id":"/properties/originalPrice","description":"original price before change","type":"number"}},"required":["originalPrice","newPrice"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostEnteredFullDayPrice', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostExitChangeRequestNeverMind' track call.
 *
 * @param HostExitChangeRequestNeverMind props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostExitChangeRequestNeverMind(props: HostExitChangeRequestNeverMind, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostExitChangeRequestNeverMind","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST RESERVATION] host pressed 'nevermind' button to cancel sending change request","properties":{"bookingId":{"$id":"/properties/bookingId","description":"id of the booking the reservation pertains to ","type":"string"},"bookingWithPass":{"$id":"/properties/bookingWithPass","description":"was the booking made using a pass","enum":["FALSE","PARTIAL","TRUE"],"type":"string"},"enteredFrom":{"$id":"/properties/enteredFrom","description":"entered from with booking edit flow","enum":["cancellation","change request"],"type":"string"},"passId":{"$id":"/properties/passId","description":"if the booking was made or partially made with a pass, the pass id used","type":["integer","null"]},"passName":{"$id":"/properties/passName","description":"the type of the pass formatted to be LCM friendly\n","type":["string","null"]},"passType":{"$id":"/properties/passType","description":"if the booking was made or partially made with a pass, what type of pass","enum":["ALL_ACCESS","EARLY_BIRD","WEEKDAY",null],"type":["string","null"]},"userPassId":{"$id":"/properties/userPassId","description":"if the booking was made or partially made with a pass, what was the user pass Id used","type":["integer","null"]}},"required":["bookingId","enteredFrom"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostExitChangeRequestNeverMind', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostGetVerifiedPressAddressUpload' track call.
 *
 * @param HostGetVerifiedPressAddressUpload props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostGetVerifiedPressAddressUpload(props: HostGetVerifiedPressAddressUpload, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostGetVerifiedPressAddressUpload","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST PROFILE EVENTS] pressed to upload proof of address/ownership","properties":{"photoOption":{"$id":"/properties/photoOption","description":"\"take photo\" or \"choose image\"","type":"string"}},"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostGetVerifiedPressAddressUpload', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostGetVerifiedPressAddressVerif' track call.
 *
 * @param HostGetVerifiedPressAddressVerif props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostGetVerifiedPressAddressVerif(props: HostGetVerifiedPressAddressVerif, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostGetVerifiedPressAddressVerif","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST PROFILE EVENTS] host pressed to \"upload proof of ownership\" on get verified page","properties":{"id":{"$id":"/properties/id","description":"","type":"string"}},"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostGetVerifiedPressAddressVerif', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostGetVerifiedPressIDUpload' track call.
 *
 * @param HostGetVerifiedPressIDUpload props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostGetVerifiedPressIDUpload(props: HostGetVerifiedPressIDUpload, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostGetVerifiedPressIDUpload","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST PROFILE EVENTS] pressed to upload id","properties":{"photoOption":{"$id":"/properties/photoOption","description":"\"take photo\" or \"choose image\"","type":"string"}},"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostGetVerifiedPressIDUpload', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostGetVerifiedPressIDVerif' track call.
 *
 * @param HostGetVerifiedPressIDVerif props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostGetVerifiedPressIDVerif(props: HostGetVerifiedPressIDVerif, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostGetVerifiedPressIDVerif","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST PROFILE EVENTS] host pressed to \"upload your id\" on get verified page","properties":{"id":{"$id":"/properties/id","description":"","type":"string"}},"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostGetVerifiedPressIDVerif', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostGetVerifiedSubmitAddressUpload' track call.
 *
 * @param HostGetVerifiedSubmitAddressUpload props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostGetVerifiedSubmitAddressUpload(props: HostGetVerifiedSubmitAddressUpload, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostGetVerifiedSubmitAddressUpload","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST PROFILE EVENTS] host submitted proof of ownership/address","properties":{"fileSize":{"$id":"/properties/fileSize","description":"file size of photo in kb","type":"integer"},"imageExtention":{"$id":"/properties/imageExtention","description":"png, jif, etc","type":"string"},"photoURL":{"$id":"/properties/photoURL","description":"url of the photo","type":"string"}},"required":["fileSize","imageExtention","photoURL"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostGetVerifiedSubmitAddressUpload', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostGetVerifiedSubmitIDUpload' track call.
 *
 * @param HostGetVerifiedSubmitIDUpload props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostGetVerifiedSubmitIDUpload(props: HostGetVerifiedSubmitIDUpload, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostGetVerifiedSubmitIDUpload","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST PROFILE EVENTS] host submitted id photo ","properties":{"fileSize":{"$id":"/properties/fileSize","description":"file size of photo in kb","type":"number"},"imageExtension":{"$id":"/properties/imageExtension","description":"png, jif, etc","type":"string"},"photoURL":{"$id":"/properties/photoURL","description":"url of the photo","type":"string"}},"required":["fileSize","photoURL","imageExtension"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostGetVerifiedSubmitIDUpload', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostHowSwimplyWorks' track call.
 *
 * @param HostHowSwimplyWorks props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostHowSwimplyWorks(props: HostHowSwimplyWorks, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostHowSwimplyWorks","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST ONBOARDING] - Host selection of either request or instant booking","properties":{"enteredFrom":{"$id":"/properties/enteredFrom","description":"All possible values for enteredFrom in host onboarding","enum":["ProfilePhotosScreen","ProfileScreen","austin","austinFB","clarkRubber","dipApp","directPoolSupplies","existingHostNewListingFlow","hostExistingListingManagement","hostOnboardingFlow","houston","houstonFB","losangeles","losangelesFB","newYork","newYorkFB","noListingsScreen","performanceTips","ph","poolProfits","poolSafetySolutions","portland","portlandFB","precisionPoolsAndLandscape","profileManageListings","sanAntonio","sanAntonioFB","seattle","seattleFB","swimUniversity","toronto","torontoFB","vip"],"type":"string"},"instantGroupSize":{"$id":"/properties/instantGroupSize","description":"If isInstantBook is true, what was the selected size?","type":"number"},"isInstantBook":{"$id":"/properties/isInstantBook","description":"","type":"boolean"},"listingId":{"$id":"/properties/listingId","description":"id for the related listing","type":"string"},"poolId":{"$id":"/properties/poolId","description":"legacy name for listing id","type":"string"},"pressedSaveExit":{"$id":"/properties/pressedSaveExit","description":"Was this event triggered by pressing save and exit?","type":"boolean"}},"required":["listingId","pressedSaveExit","isInstantBook","enteredFrom"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostHowSwimplyWorks', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostInitialCourtDetailsEntered' track call.
 *
 * @param HostInitialCourtDetailsEntered props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostInitialCourtDetailsEntered(props: HostInitialCourtDetailsEntered, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostInitialCourtDetailsEntered","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST ONBOARDING] host set basic details about court type","properties":{"courtCount":{"$id":"/properties/courtCount","description":"the number of courts available (5+ = 5 in the data please)","type":"number"},"courtSurface":{"$id":"/properties/courtSurface","description":"the surface material of the court - tennis and basketball only","type":["string","null"]},"enteredFrom":{"$id":"/properties/enteredFrom","description":"All possible values for enteredFrom in host onboarding","enum":["ProfilePhotosScreen","ProfileScreen","austin","austinFB","clarkRubber","dipApp","directPoolSupplies","existingHostNewListingFlow","hostExistingListingManagement","hostOnboardingFlow","houston","houstonFB","losangeles","losangelesFB","newYork","newYorkFB","noListingsScreen","performanceTips","ph","poolProfits","poolSafetySolutions","portland","portlandFB","precisionPoolsAndLandscape","profileManageListings","sanAntonio","sanAntonioFB","seattle","seattleFB","swimUniversity","toronto","torontoFB","vip"],"type":"string"},"globalListingType":{"$id":"/properties/globalListingType","description":"[LISTING TYPE] The type of the listing associated with this event","enum":["artStudio","basketballCourt","dockedBoat","home","homeGym","joyspace","kitchen","largeBackyard","musicStudio","other","pending","pickleball","pool","privateLake","roofDeck","tennisCourt"],"type":"string"},"isFullCourt":{"$id":"/properties/isFullCourt","description":"is the court a full court - basketball only","type":["boolean","null"]},"isRegulation":{"$id":"/properties/isRegulation","description":"is the court regulation - pickleball only","type":["boolean","null"]},"listingId":{"$id":"/properties/listingId","description":"id for the related listing","type":"string"},"poolId":{"$id":"/properties/poolId","description":"legacy name for listing id","type":"string"},"pressedSaveExit":{"$id":"/properties/pressedSaveExit","description":"pressed \"save and exit\" to remove from flow","type":"boolean"}},"required":["listingId","courtCount","pressedSaveExit","globalListingType","enteredFrom"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostInitialCourtDetailsEntered', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostInitialHomeDetailsEntered' track call.
 *
 * @param HostInitialHomeDetailsEntered props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostInitialHomeDetailsEntered(props: HostInitialHomeDetailsEntered, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostInitialHomeDetailsEntered","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST ONBOARDING] host set basic details about home- actually only fires during post onboard","properties":{"approximateHomeSize":{"$id":"/properties/approximateHomeSize","description":"in sq feet","type":"number"},"id":{"$id":"/properties/id","description":"","type":"string"}},"required":["approximateHomeSize"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostInitialHomeDetailsEntered', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostInitialPoolDetailsEntered' track call.
 *
 * @param HostInitialPoolDetailsEntered props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostInitialPoolDetailsEntered(props: HostInitialPoolDetailsEntered, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostInitialPoolDetailsEntered","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST ONBOARDING] host set basic details about pool (type, water type)","properties":{"deepEnd":{"$id":"/properties/deepEnd","description":"","type":"number"},"enteredFrom":{"$id":"/properties/enteredFrom","description":"All possible values for enteredFrom in host onboarding","enum":["ProfilePhotosScreen","ProfileScreen","austin","austinFB","clarkRubber","dipApp","directPoolSupplies","existingHostNewListingFlow","hostExistingListingManagement","hostOnboardingFlow","houston","houstonFB","losangeles","losangelesFB","newYork","newYorkFB","noListingsScreen","performanceTips","ph","poolProfits","poolSafetySolutions","portland","portlandFB","precisionPoolsAndLandscape","profileManageListings","sanAntonio","sanAntonioFB","seattle","seattleFB","swimUniversity","toronto","torontoFB","vip"],"type":"string"},"globalListingType":{"$id":"/properties/globalListingType","description":"[LISTING TYPE] The type of the listing associated with this event","enum":["artStudio","basketballCourt","dockedBoat","home","homeGym","joyspace","kitchen","largeBackyard","musicStudio","other","pending","pickleball","pool","privateLake","roofDeck","tennisCourt"],"type":"string"},"length":{"$id":"/properties/length","description":"","type":"number"},"listingId":{"$id":"/properties/listingId","description":"id for the related listing","type":"string"},"poolId":{"$id":"/properties/poolId","description":"legacy name for listing id","type":"string"},"poolTypeListing":{"$id":"/properties/poolTypeListing","description":"type of pool listed ","type":"string"},"pressedSaveExit":{"$id":"/properties/pressedSaveExit","description":"pressed \"save and exit\" to remove from flow","type":"boolean"},"shallowEnd":{"$id":"/properties/shallowEnd","description":"","type":"number"},"waterSystemSelected":{"$id":"/properties/waterSystemSelected","description":"type of water system selected","type":"string"},"width":{"$id":"/properties/width","description":"","type":"number"}},"required":["globalListingType","enteredFrom","listingId","waterSystemSelected","poolTypeListing"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostInitialPoolDetailsEntered', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostLeadAddressConfirmation' track call.
 *
 * @param HostLeadAddressConfirmation props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostLeadAddressConfirmation(props: HostLeadAddressConfirmation, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostLeadAddressConfirmation","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST ONBOARDING] confirmation screen for host entering address","properties":{"hostLeadConfirmedAddress":{"$id":"/properties/hostLeadConfirmedAddress","description":"final confirmed address","type":"string"},"hostLeadEditedAddress":{"$id":"/properties/hostLeadEditedAddress","description":"pressed \"edit\" button to return to previous screen","type":"boolean"},"hostLeadMovedMapPin":{"$id":"/properties/hostLeadMovedMapPin","description":"moved pin on map which determines location","type":"boolean"},"listingCityMetaFormat":{"$id":"/properties/listingCityMetaFormat","description":"Lowercase only with no punctuation, no special characters, and no spaces. If using special characters, the text must be encoded in UTF-8 format.","type":"string"},"listingCountryCode":{"$id":"/properties/listingCountryCode","description":"listing country code: Use the lowercase, 2-letter country codes in ISO 3166-1 alpha-2\n","type":"string"},"listingId":{"$id":"/properties/listingId","description":"listing id of the address","type":"string"},"listingStateMetaFormat":{"$id":"/properties/listingStateMetaFormat","description":"Listing state: Use the 2-character ANSI abbreviation code in lowercase. Normalize states outside the U.S. in lowercase w...","type":"string"},"listingZipcodeMetaFormat":{"$id":"/properties/listingZipcodeMetaFormat","description":"Use lowercase with no spaces and no dash. Use only the first 5 digits for U.S. zip codes. Use the area, district, and se...\n","type":"string"},"pressedSaveExit":{"$id":"/properties/pressedSaveExit","description":"pressed \"save and exit\" to remove from flow","type":"boolean"}},"required":["hostLeadConfirmedAddress","listingCityMetaFormat","listingCountryCode","listingStateMetaFormat","listingZipcodeMetaFormat"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostLeadAddressConfirmation', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostLeadLocationEntered' track call.
 *
 * @param HostLeadLocationEntered props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostLeadLocationEntered(props: HostLeadLocationEntered, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostLeadLocationEntered","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST ONBOARDING] initial screen for host entering address","properties":{"enteredFrom":{"$id":"/properties/enteredFrom","description":"All possible values for enteredFrom in host onboarding","enum":["ProfilePhotosScreen","ProfileScreen","austin","austinFB","clarkRubber","dipApp","directPoolSupplies","existingHostNewListingFlow","hostExistingListingManagement","hostOnboardingFlow","houston","houstonFB","losangeles","losangelesFB","newYork","newYorkFB","noListingsScreen","performanceTips","ph","poolProfits","poolSafetySolutions","portland","portlandFB","precisionPoolsAndLandscape","profileManageListings","sanAntonio","sanAntonioFB","seattle","seattleFB","swimUniversity","toronto","torontoFB","vip"],"type":"string"},"initialAddressSubmitted":{"$id":"/properties/initialAddressSubmitted","description":"address which the user originally submitted before confirmation","type":"string"},"listingCityMetaFormat":{"$id":"/properties/listingCityMetaFormat","description":"Lowercase only with no punctuation, no special characters, and no spaces. If using special characters, the text must be encoded in UTF-8 format.","type":"string"},"listingCountryCode":{"$id":"/properties/listingCountryCode","description":"listing country code: Use the lowercase, 2-letter country codes in ISO 3166-1 alpha-2","type":"string"},"listingId":{"$id":"/properties/listingId","description":"id for the related listing","type":"string"},"listingStateMetaFormat":{"$id":"/properties/listingStateMetaFormat","description":"Listing state: Use the 2-character ANSI abbreviation code in lowercase. Normalize states outside the U.S. in lowercase with no punctuation, no special characters, and no spaces.","type":"string"},"listingZipcodeMetaFormat":{"$id":"/properties/listingZipcodeMetaFormat","description":"Use lowercase with no spaces and no dash. Use only the first 5 digits for U.S. zip codes. Use the area, district, and sector format for the UK.","type":"string"},"manuallyEnteredAddress":{"$id":"/properties/manuallyEnteredAddress","description":"did user manually entered or edited address in submission field","type":"boolean"},"poolId":{"$id":"/properties/poolId","description":"legacy name for listing id","type":"string"},"pressedSaveExit":{"$id":"/properties/pressedSaveExit","description":"pressed \"save and exit\" to remove from flow","type":"boolean"},"utilizedCurrentLocationPrompt":{"$id":"/properties/utilizedCurrentLocationPrompt","description":"user used the \"use current location\" prompt to fill address","type":"boolean"}},"required":["listingZipcodeMetaFormat","initialAddressSubmitted","utilizedCurrentLocationPrompt","listingCityMetaFormat","manuallyEnteredAddress","listingStateMetaFormat","listingId","enteredFrom","listingCountryCode"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostLeadLocationEntered', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostMarketingCloseFansMessages' track call.
 *
 * @param HostMarketingCloseFansMessages props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostMarketingCloseFansMessages(props: HostMarketingCloseFansMessages, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostMarketingCloseFansMessages","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST PERFORMANCE] Host pressed cross to close the fan message screen","properties":{"listingId":{"$id":"/properties/listingId","description":"id of the listing","type":"string"}},"required":["listingId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostMarketingCloseFansMessages', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostMarketingCloseInviteFriends' track call.
 *
 * @param HostMarketingCloseInviteFriends props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostMarketingCloseInviteFriends(props: HostMarketingCloseInviteFriends, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostMarketingCloseInviteFriends","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST PERFORMANCE] Host pressed cross to close the invite friends screen","properties":{"listingId":{"$id":"/properties/listingId","description":"id of the listing","type":"string"}},"required":["listingId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostMarketingCloseInviteFriends', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostMarketingPressedCloseTips' track call.
 *
 * @param HostMarketingPressedCloseTips props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostMarketingPressedCloseTips(props: HostMarketingPressedCloseTips, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostMarketingPressedCloseTips","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST PERFORMANCE] Host pressed cross to close the marketing tips screen","properties":{"listingId":{"$id":"/properties/listingId","description":"id of the listing","type":"string"}},"required":["listingId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostMarketingPressedCloseTips', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostMarketingPressedFansCard' track call.
 *
 * @param HostMarketingPressedFansCard props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostMarketingPressedFansCard(props: HostMarketingPressedFansCard, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostMarketingPressedFansCard","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST PERFORMANCE] Host pressed the fan message card in marketing dashboard","properties":{"listingId":{"$id":"/properties/listingId","description":"id of the listing","type":"string"},"numberOfFans":{"$id":"/properties/numberOfFans","description":"the displayed fan numbers","type":"integer"}},"required":["numberOfFans","listingId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostMarketingPressedFansCard', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostMarketingPressedInviteFriends' track call.
 *
 * @param HostMarketingPressedInviteFriends props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostMarketingPressedInviteFriends(props: HostMarketingPressedInviteFriends, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostMarketingPressedInviteFriends","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST PERFORMANCE] Host pressed button invite my friends in the invite friends screen in marketing dashboard","properties":{"listingId":{"$id":"/properties/listingId","description":"id of the listing","type":"string"}},"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostMarketingPressedInviteFriends', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostMarketingPressedInviteFriendsCard' track call.
 *
 * @param HostMarketingPressedInviteFriendsCard props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostMarketingPressedInviteFriendsCard(props: HostMarketingPressedInviteFriendsCard, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostMarketingPressedInviteFriendsCard","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST PERFORMANCE] Host pressed the invite friend card in the marketing dashboard","properties":{"creditCurrency":{"$id":"/properties/creditCurrency","description":"currency of the credit","type":"string"},"displayedCredit":{"$id":"/properties/displayedCredit","description":"the displayed referral credit ","type":"number"},"listingId":{"$id":"/properties/listingId","description":"id of the listing","type":"string"}},"required":["creditCurrency","displayedCredit","listingId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostMarketingPressedInviteFriendsCard', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostMarketingPressedMessageFans' track call.
 *
 * @param HostMarketingPressedMessageFans props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostMarketingPressedMessageFans(props: HostMarketingPressedMessageFans, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostMarketingPressedMessageFans","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST PERFORMANCE] Host pressed button message my fans in the fan message screen in marketing dashboard","properties":{"listingId":{"$id":"/properties/listingId","description":"id of the listing","type":"string"}},"required":["listingId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostMarketingPressedMessageFans', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostMarketingPressedTips' track call.
 *
 * @param HostMarketingPressedTips props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostMarketingPressedTips(props: HostMarketingPressedTips, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostMarketingPressedTips","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST PERFORMANCE] (placeholder) Host pressed the CTA button in marketing tips card","properties":{"listingId":{"$id":"/properties/listingId","description":"id of the listing","type":"string"},"tipName":{"$id":"/properties/tipName","description":"the name of the marketing tip","type":"string"}},"required":["tipName","listingId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostMarketingPressedTips', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostMarketingSwitchTipsCarousel' track call.
 *
 * @param HostMarketingSwitchTipsCarousel props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostMarketingSwitchTipsCarousel(props: HostMarketingSwitchTipsCarousel, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostMarketingSwitchTipsCarousel","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST PERFORMANCE] Host switched to other marketing tips","properties":{"listingId":{"$id":"/properties/listingId","description":"id of the listing","type":"string"}},"required":["listingId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostMarketingSwitchTipsCarousel', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostPerfCancelChangeTimeRange' track call.
 *
 * @param HostPerfCancelChangeTimeRange props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostPerfCancelChangeTimeRange(props: HostPerfCancelChangeTimeRange, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostPerfCancelChangeTimeRange","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST PERFORMANCE] Host pressed cancel to change time range in performance DB","properties":{"listingId":{"$id":"/properties/listingId","description":"id of the listing","type":"string"}},"required":["listingId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostPerfCancelChangeTimeRange', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostPerfOverviewSwitchTimeRange' track call.
 *
 * @param HostPerfOverviewSwitchTimeRange props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostPerfOverviewSwitchTimeRange(props: HostPerfOverviewSwitchTimeRange, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostPerfOverviewSwitchTimeRange","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST PERFORMANCE] Host pressed the time range in the performance dahboard","properties":{"listingId":{"$id":"/properties/listingId","description":"id of the listing","type":"string"},"newTimeRange":{"$id":"/properties/newTimeRange","description":"the selected new time range","enum":["all time","last 30 days","last 365 days","last 7 days","year to date"],"type":"string"},"originalTimeRange":{"$id":"/properties/originalTimeRange","description":"the original time range (last 7 days/ last 14 days etc.)","enum":["all time","last 30 days","last 365 days","last 7 days","year to date"],"type":"string"}},"required":["newTimeRange","originalTimeRange","listingId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostPerfOverviewSwitchTimeRange', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostPerfPressedClosePerfTips' track call.
 *
 * @param HostPerfPressedClosePerfTips props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostPerfPressedClosePerfTips(props: HostPerfPressedClosePerfTips, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostPerfPressedClosePerfTips","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST PERFORMANCE] Host pressed cross to close the performance tips screen","properties":{"listingId":{"$id":"/properties/listingId","description":"id of the listing","type":"string"}},"required":["listingId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostPerfPressedClosePerfTips', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostPerfPressedEarnings' track call.
 *
 * @param HostPerfPressedEarnings props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostPerfPressedEarnings(props: HostPerfPressedEarnings, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostPerfPressedEarnings","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST PERFORMANCE] Host pressed the earning card in the performance DB","properties":{"listingId":{"$id":"/properties/listingId","description":"id of the listing","type":"string"}},"required":["listingId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostPerfPressedEarnings', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostPerfPressedFanFavoriteFAQ' track call.
 *
 * @param HostPerfPressedFanFavoriteFAQ props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostPerfPressedFanFavoriteFAQ(props: HostPerfPressedFanFavoriteFAQ, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostPerfPressedFanFavoriteFAQ","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST PERFORMANCE] Host pressed on the Fan Favorite FAQ in the bookings section of Performance Overview","properties":{"fakeProperty":{"$id":"/properties/fakeProperty","description":"DO NOT SEND: This is added as a workaround for this issue: https://github.com/segmentio/typewriter/issues/284","type":"string"}},"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostPerfPressedFanFavoriteFAQ', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostPerfPressedInfoIconScores' track call.
 *
 * @param HostPerfPressedInfoIconScores props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostPerfPressedInfoIconScores(props: HostPerfPressedInfoIconScores, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostPerfPressedInfoIconScores","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST PERFORMANCE] Host pressed to view the performance scores info (question mark) ","properties":{"listingId":{"$id":"/properties/listingId","description":"id of the listing","type":"string"}},"required":["listingId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostPerfPressedInfoIconScores', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostPerfPressedInfoIconTips' track call.
 *
 * @param HostPerfPressedInfoIconTips props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostPerfPressedInfoIconTips(props: HostPerfPressedInfoIconTips, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostPerfPressedInfoIconTips","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST PERFORMANCE] Host pressed to view the performance tips info (question mark) ","properties":{"listingId":{"$id":"/properties/listingId","description":"id of the listing","type":"string"}},"required":["listingId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostPerfPressedInfoIconTips', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostPerfPressedLeaveReply' track call.
 *
 * @param HostPerfPressedLeaveReply props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostPerfPressedLeaveReply(props: HostPerfPressedLeaveReply, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostPerfPressedLeaveReply","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST PERFORMANCE] Host pressed to leave a reply to a guest's review","properties":{"bookingId":{"$id":"/properties/bookingId","description":"","type":"integer"},"bookingMessage":{"$id":"/properties/bookingMessage","description":"message sent by the guest when booking","type":["string","null"]},"bookingRating":{"$id":"/properties/bookingRating","description":"if the guest left a rating between 1-5, what was it","type":["integer","null"]},"bookingReason":{"$id":"/properties/bookingReason","description":"guest selection (listing type specific) for why they're booking","enum":["casual_play","competitive_play","corporate_or_meeting","courts","date","exercise","family_hangout","friend_hangout","lessons",null,"other","party_celebration","party_or_celebration","pet_swim","photoshoot","training"],"type":["string","null"]},"bookingReview":{"$id":"/properties/bookingReview","description":"if the guest left a review, what was it","type":["string","null"]},"bookingSpecialOfferId":{"$id":"/properties/bookingSpecialOfferId","description":"","type":["integer","null"]},"enteredFrom":{"$id":"/properties/enteredFrom","description":"Did the host click on the reply from the performance screen or after pressing show all","enum":["performance","view_all",null],"type":["string","null"]},"guestId":{"$id":"/properties/guestId","description":"","type":"integer"},"hostId":{"$id":"/properties/hostId","description":"","type":"integer"},"id":{"$id":"/properties/id","description":"","type":"string"},"isInstantBooking":{"$id":"/properties/isInstantBooking","description":"","type":"boolean"},"listingId":{"$id":"/properties/listingId","description":"","type":"integer"},"listingTitle":{"$id":"/properties/listingTitle","description":"","type":"string"},"totalGuests":{"$id":"/properties/totalGuests","description":"","type":"integer"},"totalPrice":{"$id":"/properties/totalPrice","description":"","type":"number"}},"required":["bookingId","guestId","hostId","listingId","listingTitle","enteredFrom"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostPerfPressedLeaveReply', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostPerfPressedManageListings' track call.
 *
 * @param HostPerfPressedManageListings props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostPerfPressedManageListings(props: HostPerfPressedManageListings, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostPerfPressedManageListings","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST PERFORMANCE] Host pressed manage my listing button in the performance dashboard","properties":{"listingId":{"$id":"/properties/listingId","description":"id of the listing","type":"string"}},"required":["listingId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostPerfPressedManageListings', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostPerfPressedPerfTips' track call.
 *
 * @param HostPerfPressedPerfTips props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostPerfPressedPerfTips(props: HostPerfPressedPerfTips, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostPerfPressedPerfTips","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST PERFORMANCE] (placeholder) Host pressed the CTA button in performance tips","properties":{"listingId":{"$id":"/properties/listingId","description":"id of the listing","type":"string"},"tipName":{"$id":"/properties/tipName","description":"the name of the performance tip","type":"string"}},"required":["tipName","listingId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostPerfPressedPerfTips', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostPerfPressedSeeAllReviews' track call.
 *
 * @param HostPerfPressedSeeAllReviews props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostPerfPressedSeeAllReviews(props: HostPerfPressedSeeAllReviews, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostPerfPressedSeeAllReviews","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST PERFORMANCE] Host pressed to see all reviews in the performance dashboard","properties":{"listingId":{"$id":"/properties/listingId","description":"id of the listing","type":"string"}},"required":["listingId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostPerfPressedSeeAllReviews', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostPerfSwitchDashboard' track call.
 *
 * @param HostPerfSwitchDashboard props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostPerfSwitchDashboard(props: HostPerfSwitchDashboard, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostPerfSwitchDashboard","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST PERFORMANCE] Host switched to marketing or performance dashboard","properties":{"listingId":{"$id":"/properties/listingId","description":"id of the listing","type":"string"},"switchTo":{"$id":"/properties/switchTo","description":"the tab that pressed by the host (performance or marketing)","enum":["marketing","performance"],"type":"string"}},"required":["switchTo","listingId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostPerfSwitchDashboard', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostPerfSwitchPerfTipsCarousel' track call.
 *
 * @param HostPerfSwitchPerfTipsCarousel props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostPerfSwitchPerfTipsCarousel(props: HostPerfSwitchPerfTipsCarousel, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostPerfSwitchPerfTipsCarousel","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST PERFORMANCE] Host switched to other performance tips","properties":{"listingId":{"$id":"/properties/listingId","description":"id of the listing","type":"string"}},"required":["listingId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostPerfSwitchPerfTipsCarousel', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostPerfSwitchReviewCarousel' track call.
 *
 * @param HostPerfSwitchReviewCarousel props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostPerfSwitchReviewCarousel(props: HostPerfSwitchReviewCarousel, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostPerfSwitchReviewCarousel","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST PERFORMANCE] Host switched the review card in the performance DB","properties":{"listingId":{"$id":"/properties/listingId","description":"id of the listing","type":"string"}},"required":["listingId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostPerfSwitchReviewCarousel', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostPoolAvailability' track call.
 *
 * @param HostPoolAvailability props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostPoolAvailability(props: HostPoolAvailability, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostPoolAvailability","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST ONBOARDING] host set availability blocks for pool","properties":{"bufferTime":{"$id":"/properties/bufferTime","description":"if there is a buffer time - what is it in minutes","type":"number"},"dailyEndTime":{"$id":"/properties/dailyEndTime","description":"daily end time for pool availability (military time)","type":"number"},"dailyStartTime":{"$id":"/properties/dailyStartTime","description":"daily start time for pool availability (military time)","type":"number"},"enteredFrom":{"$id":"/properties/enteredFrom","description":"All possible values for enteredFrom in host onboarding","enum":["ProfilePhotosScreen","ProfileScreen","austin","austinFB","clarkRubber","dipApp","directPoolSupplies","existingHostNewListingFlow","hostExistingListingManagement","hostOnboardingFlow","houston","houstonFB","losangeles","losangelesFB","newYork","newYorkFB","noListingsScreen","performanceTips","ph","poolProfits","poolSafetySolutions","portland","portlandFB","precisionPoolsAndLandscape","profileManageListings","sanAntonio","sanAntonioFB","seattle","seattleFB","swimUniversity","toronto","torontoFB","vip"],"type":"string"},"firstDayLive":{"$id":"/properties/firstDayLive","description":"the first day the listing will be live (will be the current day if the user selects go live immediately)","type":"string"},"globalListingType":{"$id":"/properties/globalListingType","description":"[LISTING TYPE] The type of the listing associated with this event","enum":["artStudio","basketballCourt","dockedBoat","home","homeGym","joyspace","kitchen","largeBackyard","musicStudio","other","pending","pickleball","pool","privateLake","roofDeck","tennisCourt"],"type":"string"},"listingId":{"$id":"/properties/listingId","description":"id for the related listing","type":"string"},"poolId":{"$id":"/properties/poolId","description":"legacy name for listing id","type":"string"},"pressedSaveExit":{"$id":"/properties/pressedSaveExit","description":"pressed \"save and exit\" to remove from flow","type":"boolean"},"seasonEndMonth":{"$id":"/properties/seasonEndMonth","description":"month for when pool goes offline","type":"string"},"seasonStartMonth":{"$id":"/properties/seasonStartMonth","description":"month for when pool goes online","type":"string"}},"required":["listingId","pressedSaveExit","dailyEndTime","dailyStartTime","globalListingType","enteredFrom"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostPoolAvailability', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostPoolAvailabilityAdvancedSettings' track call.
 *
 * @param HostPoolAvailabilityAdvancedSettings props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostPoolAvailabilityAdvancedSettings(props: HostPoolAvailabilityAdvancedSettings, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostPoolAvailabilityAdvancedSettings","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST ONBOARDING] host added advanced availability settings","properties":{"advanceNotice":{"$id":"/properties/advanceNotice","description":"the advance notice option selected","type":"string"},"instantBook":{"$id":"/properties/instantBook","description":"whether the listing has instant book enabled","type":"boolean"},"instantBookGuestMax":{"$id":"/properties/instantBookGuestMax","description":"","type":"number"}},"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostPoolAvailabilityAdvancedSettings', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostPoolAvailabilityDatesExcluded' track call.
 *
 * @param HostPoolAvailabilityDatesExcluded props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostPoolAvailabilityDatesExcluded(props: HostPoolAvailabilityDatesExcluded, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostPoolAvailabilityDatesExcluded","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST ONBOARDING] host set selected dates unavailable","properties":{"datesExcludedBooking":{"$id":"/properties/datesExcludedBooking","description":"array of every date selected for calendar exclusion","type":"array"},"enteredFrom":{"$id":"/properties/enteredFrom","description":"All possible values for enteredFrom in host onboarding","enum":["ProfilePhotosScreen","ProfileScreen","austin","austinFB","clarkRubber","dipApp","directPoolSupplies","existingHostNewListingFlow","hostExistingListingManagement","hostOnboardingFlow","houston","houstonFB","losangeles","losangelesFB","newYork","newYorkFB","noListingsScreen","performanceTips","ph","poolProfits","poolSafetySolutions","portland","portlandFB","precisionPoolsAndLandscape","profileManageListings","sanAntonio","sanAntonioFB","seattle","seattleFB","swimUniversity","toronto","torontoFB","vip"],"type":"string"},"listingId":{"$id":"/properties/listingId","description":"id for the related listing","type":"string"},"poolId":{"$id":"/properties/poolId","description":"legacy name for listing id","type":"string"},"pressedSaveExit":{"$id":"/properties/pressedSaveExit","description":"pressed \"save and exit\" to remove from flow","type":"boolean"}},"required":["pressedSaveExit","enteredFrom","listingId","datesExcludedBooking"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostPoolAvailabilityDatesExcluded', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostPoolDimensions' track call.
 *
 * @param HostPoolDimensions props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostPoolDimensions(props: HostPoolDimensions, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostPoolDimensions","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST ONBOARDING] host entered pool dimensions","properties":{"deepPointEntered":{"$id":"/properties/deepPointEntered","description":"deep point in feet entered by host","type":"number"},"enteredFrom":{"$id":"/properties/enteredFrom","description":"All possible values for enteredFrom in host onboarding","enum":["ProfilePhotosScreen","ProfileScreen","austin","austinFB","clarkRubber","dipApp","directPoolSupplies","existingHostNewListingFlow","hostExistingListingManagement","hostOnboardingFlow","houston","houstonFB","losangeles","losangelesFB","newYork","newYorkFB","noListingsScreen","performanceTips","ph","poolProfits","poolSafetySolutions","portland","portlandFB","precisionPoolsAndLandscape","profileManageListings","sanAntonio","sanAntonioFB","seattle","seattleFB","swimUniversity","toronto","torontoFB","vip"],"type":"string"},"lengthEntered":{"$id":"/properties/lengthEntered","description":"length in feet entered by host","type":"number"},"listingId":{"$id":"/properties/listingId","description":"id for the related listing","type":"string"},"poolId":{"$id":"/properties/poolId","description":"legacy name for listing id","type":"string"},"pressedSaveExit":{"$id":"/properties/pressedSaveExit","description":"pressed \"save and exit\" to remove from flow","type":"boolean"},"shallowPointEntered":{"$id":"/properties/shallowPointEntered","description":"shallow point in feet entered by host","type":"number"},"widthEntered":{"$id":"/properties/widthEntered","description":"width in feet entered by host","type":"number"}},"required":["enteredFrom","listingId","pressedSaveExit","widthEntered","lengthEntered","deepPointEntered","shallowPointEntered"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostPoolDimensions', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostPoolGuestInformation' track call.
 *
 * @param HostPoolGuestInformation props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostPoolGuestInformation(props: HostPoolGuestInformation, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostPoolGuestInformation","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST ONBOARDING] host requirements for types of guests","properties":{"childrenAllowed":{"$id":"/properties/childrenAllowed","description":"are children allowed in pool","type":"boolean"},"enteredFrom":{"$id":"/properties/enteredFrom","description":"All possible values for enteredFrom in host onboarding","enum":["ProfilePhotosScreen","ProfileScreen","austin","austinFB","clarkRubber","dipApp","directPoolSupplies","existingHostNewListingFlow","hostExistingListingManagement","hostOnboardingFlow","houston","houstonFB","losangeles","losangelesFB","newYork","newYorkFB","noListingsScreen","performanceTips","ph","poolProfits","poolSafetySolutions","portland","portlandFB","precisionPoolsAndLandscape","profileManageListings","sanAntonio","sanAntonioFB","seattle","seattleFB","swimUniversity","toronto","torontoFB","vip"],"type":"string"},"globalListingType":{"$id":"/properties/globalListingType","description":"[LISTING TYPE] The type of the listing associated with this event","enum":["artStudio","basketballCourt","dockedBoat","home","homeGym","joyspace","kitchen","largeBackyard","musicStudio","other","pending","pickleball","pool","privateLake","roofDeck","tennisCourt"],"type":"string"},"infantsAllowed":{"$id":"/properties/infantsAllowed","description":"are infants allowed in pool","type":"boolean"},"listingId":{"$id":"/properties/listingId","description":"id for the related listing","type":"string"},"maxGuestsAmount":{"$id":"/properties/maxGuestsAmount","description":"max number of guests allowed","type":"integer"},"partiesAllowed":{"$id":"/properties/partiesAllowed","description":"are parties allowed","type":"boolean"},"petsRuleDetails":{"$id":"/properties/petsRuleDetails","description":"rule about pet guests","enum":["InSpace","NotAllowed","NotInSpace"],"type":"string"},"poolId":{"$id":"/properties/poolId","description":"legacy name for listing id","type":"string"},"pressedSaveExit":{"$id":"/properties/pressedSaveExit","description":"pressed \"save and exit\" to remove from flow","type":"boolean"}},"required":["partiesAllowed","pressedSaveExit","maxGuestsAmount","listingId","globalListingType","infantsAllowed","childrenAllowed","petsRuleDetails","enteredFrom"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostPoolGuestInformation', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostPoolPricingEntered' track call.
 *
 * @param HostPoolPricingEntered props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostPoolPricingEntered(props: HostPoolPricingEntered, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostPoolPricingEntered","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST ONBOARDING] host entered pricing information","properties":{"dailyPriceCurrency":{"$id":"/properties/dailyPriceCurrency","description":"currency of daily price","type":["string","null"]},"dailyPriceEntered":{"$id":"/properties/dailyPriceEntered","description":"the entered daily price ","type":["integer","null"]},"enteredFrom":{"$id":"/properties/enteredFrom","description":"All possible values for enteredFrom in host onboarding","enum":["ProfilePhotosScreen","ProfileScreen","austin","austinFB","clarkRubber","dipApp","directPoolSupplies","existingHostNewListingFlow","hostExistingListingManagement","hostOnboardingFlow","houston","houstonFB","losangeles","losangelesFB","newYork","newYorkFB","noListingsScreen","performanceTips","ph","poolProfits","poolSafetySolutions","portland","portlandFB","precisionPoolsAndLandscape","profileManageListings","sanAntonio","sanAntonioFB","seattle","seattleFB","swimUniversity","toronto","torontoFB","vip"],"type":"string"},"globalListingType":{"$id":"/properties/globalListingType","description":"[LISTING TYPE] The type of the listing associated with this event","enum":["artStudio","basketballCourt","dockedBoat","home","homeGym","joyspace","kitchen","largeBackyard","musicStudio","other","pending","pickleball","pool","privateLake","roofDeck","tennisCourt"],"type":"string"},"hourlyPriceCurrency":{"$id":"/properties/hourlyPriceCurrency","description":"currency of hourly price","type":["string","null"]},"hourlyPriceEntered":{"$id":"/properties/hourlyPriceEntered","description":"the entered hourly price ","type":["integer","null"]},"listingId":{"$id":"/properties/listingId","description":"id for the related listing","type":"string"},"perGuestFeeCurrency":{"$id":"/properties/perGuestFeeCurrency","description":"currency of additional guest fee","type":["string","null"]},"perGuestFeeEntered":{"$id":"/properties/perGuestFeeEntered","description":"entered fee amount per guest ","type":["integer","null"]},"poolId":{"$id":"/properties/poolId","description":"legacy name for listing id","type":"string"},"pressedSaveExit":{"$id":"/properties/pressedSaveExit","description":"pressed \"save and exit\" to remove from flow","type":"boolean"},"pricingStructure":{"$id":"/properties/pricingStructure","description":"the price structure of the listing","enum":["flat_rate","full_day_single","full_day_tiered",null,"tiered_pricing"],"type":["string","null"]},"tiers":{"$id":"/properties/tiers","description":"the listing pricing tiers","items":{"$id":"/properties/properties/properties/tiers/items","description":"","isNewProperty":true,"properties":{"maxGuests":{"$id":"/properties/properties/properties/tiers/items/properties/maxGuests","description":"","type":"string"},"price":{"$id":"/properties/properties/properties/tiers/items/properties/price","description":"","type":"string"}},"required":[],"type":"object"},"type":"array"}},"required":["pricingStructure","globalListingType","enteredFrom","listingId","pressedSaveExit"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostPoolPricingEntered', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostPoolProfileAdded' track call.
 *
 * @param HostPoolProfileAdded props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostPoolProfileAdded(props: HostPoolProfileAdded, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostPoolProfileAdded","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST ONBOARDING] host title and description information","properties":{"enteredFrom":{"$id":"/properties/enteredFrom","description":"All possible values for enteredFrom in host onboarding","enum":["ProfilePhotosScreen","ProfileScreen","austin","austinFB","clarkRubber","dipApp","directPoolSupplies","existingHostNewListingFlow","hostExistingListingManagement","hostOnboardingFlow","houston","houstonFB","losangeles","losangelesFB","newYork","newYorkFB","noListingsScreen","performanceTips","ph","poolProfits","poolSafetySolutions","portland","portlandFB","precisionPoolsAndLandscape","profileManageListings","sanAntonio","sanAntonioFB","seattle","seattleFB","swimUniversity","toronto","torontoFB","vip"],"type":"string"},"globalListingType":{"$id":"/properties/globalListingType","description":"[LISTING TYPE] The type of the listing associated with this event","enum":["artStudio","basketballCourt","dockedBoat","home","homeGym","joyspace","kitchen","largeBackyard","musicStudio","other","pending","pickleball","pool","privateLake","roofDeck","tennisCourt"],"type":"string"},"listingId":{"$id":"/properties/listingId","description":"id for the related listing","type":"string"},"poolDescription":{"$id":"/properties/poolDescription","description":"","type":"string"},"poolId":{"$id":"/properties/poolId","description":"legacy name for listing id","type":"string"},"poolTitle":{"$id":"/properties/poolTitle","description":"","type":"string"},"pressedSaveExit":{"$id":"/properties/pressedSaveExit","description":"pressed \"save and exit\" to remove from flow","type":"boolean"}},"required":["poolTitle","poolDescription","pressedSaveExit","enteredFrom","listingId","globalListingType"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostPoolProfileAdded', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostPoolReview' track call.
 *
 * @param HostPoolReview props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostPoolReview(props: HostPoolReview, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostPoolReview","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST ONBOARDING] final review screen for host onboarding","properties":{"blockedByPhotos":{"$id":"/properties/blockedByPhotos","description":"was the host blocked from submitting due to needing photos","type":"boolean"},"enteredFrom":{"$id":"/properties/enteredFrom","description":"All possible values for enteredFrom in host onboarding","enum":["ProfilePhotosScreen","ProfileScreen","austin","austinFB","clarkRubber","dipApp","directPoolSupplies","existingHostNewListingFlow","hostExistingListingManagement","hostOnboardingFlow","houston","houstonFB","losangeles","losangelesFB","newYork","newYorkFB","noListingsScreen","performanceTips","ph","poolProfits","poolSafetySolutions","portland","portlandFB","precisionPoolsAndLandscape","profileManageListings","sanAntonio","sanAntonioFB","seattle","seattleFB","swimUniversity","toronto","torontoFB","vip"],"type":"string"},"listingId":{"$id":"/properties/listingId","description":"id for the related listing","type":"string"},"poolId":{"$id":"/properties/poolId","description":"legacy name for listing id","type":"string"},"pressedAddPhotos":{"$id":"/properties/pressedAddPhotos","description":"did the host press to add phoots","type":"boolean"},"pressedSaveExit":{"$id":"/properties/pressedSaveExit","description":"pressed \"save and exit\" to remove from flow","type":"boolean"}},"required":["enteredFrom","blockedByPhotos","pressedAddPhotos","listingId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostPoolReview', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostPressedAbandonCartDiscountGetStarted' track call.
 *
 * @param HostPressedAbandonCartDiscountGetStarted props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostPressedAbandonCartDiscountGetStarted(props: HostPressedAbandonCartDiscountGetStarted, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostPressedAbandonCartDiscountGetStarted","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST PROMO CODE] Host Pressed started on after viewing the abandon cart discount context page","properties":{"id":{"$id":"/properties/id","description":"","type":"string"}},"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostPressedAbandonCartDiscountGetStarted', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostPressedAcceptReservationRequest' track call.
 *
 * @param HostPressedAcceptReservationRequest props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostPressedAcceptReservationRequest(props: HostPressedAcceptReservationRequest, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostPressedAcceptReservationRequest","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST RESERVATION] host pressed the \"view details\" option of a given reservation adjustment request","properties":{"bookingEditHistoryId":{"$id":"/properties/bookingEditHistoryId","description":"id for booking_edit_history entry that the adjustment pertains to","type":"object"},"bookingId":{"$id":"/properties/bookingId","description":"id of the booking the reservation pertains to","type":"integer"},"bookingReason":{"$id":"/properties/bookingReason","description":"guest selection (listing type specific) for why they're booking","enum":["casual_play","competitive_play","corporate_or_meeting","courts","date","exercise","family_hangout","friend_hangout","lessons",null,"other","party_celebration","party_or_celebration","pet_swim","photoshoot","training"],"type":["string","null"]},"bookingWithPass":{"$id":"/properties/bookingWithPass","description":"was the booking made using a pass","enum":["FALSE","PARTIAL","TRUE"],"type":"string"},"passId":{"$id":"/properties/passId","description":"if the booking was made or partially made with a pass, the pass id used","type":["integer","null"]},"passName":{"$id":"/properties/passName","description":"the type of the pass formatted to be LCM friendly\n","type":["string","null"]},"passType":{"$id":"/properties/passType","description":"if the booking was made or partially made with a pass, what type of pass","enum":["ALL_ACCESS","EARLY_BIRD","WEEKDAY",null],"type":["string","null"]},"userPassId":{"$id":"/properties/userPassId","description":"if the booking was made or partially made with a pass, what was the user pass Id used","type":["integer","null"]}},"required":["bookingId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostPressedAcceptReservationRequest', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostPressedActivateAbandonCartDiscount' track call.
 *
 * @param HostPressedActivateAbandonCartDiscount props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostPressedActivateAbandonCartDiscount(props: HostPressedActivateAbandonCartDiscount, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostPressedActivateAbandonCartDiscount","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST PROMO CODE] Host Pressed activate abandon cart promo","properties":{"amountOff":{"$id":"/properties/amountOff","description":"percent amount off of this promo code (1-100) ","type":"number"},"expireDays":{"$id":"/properties/expireDays","description":"","type":"string"},"listingId":{"$id":"/properties/listingId","description":"","type":"string"},"note":{"$id":"/properties/note","description":"","type":["string","null"]}},"required":["amountOff","listingId","expireDays"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostPressedActivateAbandonCartDiscount', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostPressedActivatePass' track call.
 *
 * @param HostPressedActivatePass props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostPressedActivatePass(props: HostPressedActivatePass, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostPressedActivatePass","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST PASS CREATION]","properties":{"coverImageURL":{"$id":"/properties/coverImageURL","description":"the url for the cover image of the listing the pass is for","type":"string"},"hostFirstName":{"$id":"/properties/hostFirstName","description":"first name of the host","type":"string"},"id":{"$id":"/properties/id","description":"","type":"string"},"listingId":{"$id":"/properties/listingId","description":"id of the listing the pass is for","type":"string"},"listingTitle":{"$id":"/properties/listingTitle","description":"the title of the listing the pass is for","type":"string"},"listingURL":{"$id":"/properties/listingURL","description":"the url of the listing the pass is for","type":"string"},"passAvailableTimes":{"$id":"/properties/passAvailableTimes","description":"[{from:”07:00:00”, “11:00:00”}...] Time slots when this pass is eligible","type":"array"},"passAvailableTimesText":{"$id":"/properties/passAvailableTimesText","description":"LCM formatted version of available times property","type":"string"},"passBlackoutDays":{"$id":"/properties/passBlackoutDays","description":"list of blackout dates (e.g. July 4, 2024). ","type":["array","null"]},"passCreatedAt":{"$id":"/properties/passCreatedAt","description":"when the pass was created","type":"string"},"passCurrencyCode":{"$id":"/properties/passCurrencyCode","description":"currency for all monetary fields","type":"string"},"passCurrent":{"$id":"/properties/passCurrent","description":"flag indicating that this is the current version for a pass. For a type/name/listing_id, there can only be one record with this attribute true.","type":"boolean"},"passDescription":{"$id":"/properties/passDescription","description":"free text description set by host","type":["string","null"]},"passDiscount":{"$id":"/properties/passDiscount","description":"discount amount. Fixed discounts will be in minors units.","type":["number","null"]},"passDiscountType":{"$id":"/properties/passDiscountType","description":"type of pass discount num[‘percentage’, ‘fixed’]","enum":["FIXED","PERCENTAGE",null],"type":["string","null"]},"passEligibleDays":{"$id":"/properties/passEligibleDays","description":"days the pass is eligible","type":["array","null"]},"passId":{"$id":"/properties/passId","description":"id of the pass","type":"integer"},"passMaxActivePasses":{"$id":"/properties/passMaxActivePasses","description":"max active passes allowed. This constraint will apply to the (listing_id, type, name) rather than id so that we can be accurate across edits.","type":["number","null"]},"passMaxDailyBookings":{"$id":"/properties/passMaxDailyBookings","description":"max bookings allowed under this pass","type":["number","null"]},"passMaxDuration":{"$id":"/properties/passMaxDuration","description":"max duration that may be booked using this pass","type":["number","null"]},"passMaxGuests":{"$id":"/properties/passMaxGuests","description":"max guests that may be booked using this pass","type":["number","null"]},"passName":{"$id":"/properties/passName","description":"the type of the pass formatted to be LCM friendly","pattern":"","type":"string"},"passPremiumAmenities":{"$id":"/properties/passPremiumAmenities","description":"the ids of all premium amenities included with the pass","type":["array","null"]},"passPrice":{"$id":"/properties/passPrice","description":"pass price in minor units","type":"string"},"passState":{"$id":"/properties/passState","description":"‘draft’ -> pass is being actively edited by the host via the creation flow. The step attribute below tracks the progress of the host through the creation flow.\n‘inactive’ -> pass has been created by the host, but not ready for sale yet\n‘active’ -> pass has passed the final availability requirements and has been marked by the host as ready for sale.","enum":["ACTIVE","DRAFT","INACTIVE"],"type":"string"},"passTotalPrice":{"$id":"/properties/passTotalPrice","description":"the pass of the price plus the service fee","type":"string"},"passType":{"$id":"/properties/passType","description":"the type of pass","enum":["ALL_ACCESS","EARLY_BIRD","FIXED_HOURS","WEEKDAY"],"type":"string"}},"required":["passState","passCurrent","listingURL","passTotalPrice","passCurrencyCode","passPrice","coverImageURL","passDiscount","passId","passCreatedAt","hostFirstName","passName","passDiscountType","listingId","passType","listingTitle"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostPressedActivatePass', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostPressedAddAbandonCartDiscount' track call.
 *
 * @param HostPressedAddAbandonCartDiscount props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostPressedAddAbandonCartDiscount(props: HostPressedAddAbandonCartDiscount, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostPressedAddAbandonCartDiscount","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST PROMO CODE] Host started the creating abandon cart discount flow ","properties":{"enteredFrom":{"$id":"/properties/enteredFrom","description":"how they accessed the flow - either via the section in the marketing tab or after clicking the pop up in the fans flow","enum":["fans","marketing"],"type":"string"}},"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostPressedAddAbandonCartDiscount', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostPressedAddPromotionToListing' track call.
 *
 * @param HostPressedAddPromotionToListing props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostPressedAddPromotionToListing(props: HostPressedAddPromotionToListing, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostPressedAddPromotionToListing","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST PROMO CODE] Host pressed the add a promotion to your listing button\n","properties":{"id":{"$id":"/properties/id","description":"","type":"string"}},"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostPressedAddPromotionToListing', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostPressedAddWeekdayDiscount' track call.
 *
 * @param HostPressedAddWeekdayDiscount props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostPressedAddWeekdayDiscount(props: HostPressedAddWeekdayDiscount, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostPressedAddWeekdayDiscount","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST PROMO CODE] Host pressed the add weekday discounts button in the marketing tab of Host Analytics","properties":{"id":{"$id":"/properties/id","description":"","type":"string"}},"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostPressedAddWeekdayDiscount', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostPressedApproveFromDeclineFlow' track call.
 *
 * @param HostPressedApproveFromDeclineFlow props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostPressedApproveFromDeclineFlow(props: HostPressedApproveFromDeclineFlow, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostPressedApproveFromDeclineFlow","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST RESERVATION] host chose approve instead from the decline flow","properties":{"bookingId":{"$id":"/properties/bookingId","description":"id of the booking the reservation pertains to","type":"integer"},"bookingWithPass":{"$id":"/properties/bookingWithPass","description":"was the booking made using a pass","enum":["FALSE","PARTIAL","TRUE"],"type":"string"},"passId":{"$id":"/properties/passId","description":"if the booking was made or partially made with a pass, the pass id used","type":["integer","null"]},"passName":{"$id":"/properties/passName","description":"the type of the pass formatted to be LCM friendly\n","type":["string","null"]},"passType":{"$id":"/properties/passType","description":"if the booking was made or partially made with a pass, what type of pass","enum":["ALL_ACCESS","EARLY_BIRD","WEEKDAY",null],"type":["string","null"]},"userPassId":{"$id":"/properties/userPassId","description":"if the booking was made or partially made with a pass, what was the user pass Id used","type":["integer","null"]}},"required":["bookingId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostPressedApproveFromDeclineFlow', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostPressedAwesomeThanksButton' track call.
 *
 * @param HostPressedAwesomeThanksButton props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostPressedAwesomeThanksButton(props: HostPressedAwesomeThanksButton, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostPressedAwesomeThanksButton","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST T&S SWIPE] host pressed the Awesome, Thanks! button to finish the T&S flow","properties":{"bookingId":{"$id":"/properties/bookingId","description":"the id of the booking","type":"integer"}},"required":["bookingId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostPressedAwesomeThanksButton', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostPressedBackFromWithdrawSpecialOffer' track call.
 *
 * @param HostPressedBackFromWithdrawSpecialOffer props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostPressedBackFromWithdrawSpecialOffer(props: HostPressedBackFromWithdrawSpecialOffer, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostPressedBackFromWithdrawSpecialOffer","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST BOOKING INQUIRY POST-SPECIAL OFFER SENT]","properties":{"bookingId":{"$id":"/properties/bookingId","description":"","type":"integer"},"bookingSpecialOfferId":{"$id":"/properties/bookingSpecialOfferId","description":"","type":"integer"},"globalListingType":{"$id":"/properties/globalListingType","description":"[LISTING TYPE] The type of the listing associated with this event","enum":["artStudio","basketballCourt","dockedBoat","home","homeGym","joyspace","kitchen","largeBackyard","musicStudio","other","pending","pickleball","pool","privateLake","roofDeck","tennisCourt"],"type":"string"},"guestId":{"$id":"/properties/guestId","description":"","type":"integer"},"hostId":{"$id":"/properties/hostId","description":"","type":"integer"},"listingId":{"$id":"/properties/listingId","description":"","type":"integer"},"originalPrice":{"$id":"/properties/originalPrice","description":"","type":"number"},"roomId":{"$id":"/properties/roomId","description":"","type":"string"},"specialOfferPrice":{"$id":"/properties/specialOfferPrice","description":"","type":"number"}},"required":["globalListingType","bookingSpecialOfferId","hostId","specialOfferPrice","bookingId","listingId","originalPrice","guestId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostPressedBackFromWithdrawSpecialOffer', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostPressedBackOnCreatingSendSo' track call.
 *
 * @param HostPressedBackOnCreatingSendSo props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostPressedBackOnCreatingSendSo(props: HostPressedBackOnCreatingSendSo, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostPressedBackOnCreatingSendSo","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST BOOKING INQUIRY SENDING SPECIAL OFFER]","properties":{"bookingId":{"$id":"/properties/bookingId","description":"","type":["integer","null"]},"originalPrice":{"$id":"/properties/originalPrice","description":"","type":"number"},"specialOfferPrice":{"$id":"/properties/specialOfferPrice","description":"","type":"number"}},"required":["specialOfferPrice","originalPrice"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostPressedBackOnCreatingSendSo', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostPressedBlockFromMessages' track call.
 *
 * @param HostPressedBlockFromMessages props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostPressedBlockFromMessages(props: HostPressedBlockFromMessages, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostPressedBlockFromMessages","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST BOOKING INQUIRY RESPONSE]","properties":{"bookingId":{"$id":"/properties/bookingId","description":"","type":["integer","null"]},"globalListingType":{"$id":"/properties/globalListingType","description":"[LISTING TYPE] The type of the listing associated with this event","enum":["artStudio","basketballCourt","dockedBoat","home","homeGym","joyspace","kitchen","largeBackyard","musicStudio","other","pending","pickleball","pool","privateLake","roofDeck","tennisCourt"],"type":"string"},"guestId":{"$id":"/properties/guestId","description":"","type":"integer"},"hostId":{"$id":"/properties/hostId","description":"","type":"integer"},"listingId":{"$id":"/properties/listingId","description":"","type":"integer"},"roomId":{"$id":"/properties/roomId","description":"","type":"string"}},"required":["listingId","globalListingType","guestId","hostId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostPressedBlockFromMessages', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostPressedCalendar' track call.
 *
 * @param HostPressedCalendar props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostPressedCalendar(props: HostPressedCalendar, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostPressedCalendar","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST CALENDAR] Host Pressed into their calendar (either via the calendar section on web or via the calendar tab on app)","properties":{"listingId":{"$id":"/properties/listingId","description":"","type":"string"}},"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostPressedCalendar', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostPressedCancelChangeRequest' track call.
 *
 * @param HostPressedCancelChangeRequest props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostPressedCancelChangeRequest(props: HostPressedCancelChangeRequest, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostPressedCancelChangeRequest","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST RESERVATION] host pressed to cancel change request","properties":{"bookingId":{"$id":"/properties/bookingId","description":"id of the booking","type":"string"},"bookingWithPass":{"$id":"/properties/bookingWithPass","description":"was the booking made using a pass","enum":["FALSE","PARTIAL","TRUE"],"type":"string"},"isEditAmenities":{"$id":"/properties/isEditAmenities","description":"True if the request contains amenitieschange","type":"boolean"},"isEditDateTime":{"$id":"/properties/isEditDateTime","description":"True if the request contains date time change","type":"boolean"},"isEditGuest":{"$id":"/properties/isEditGuest","description":"True if the request contains guests change","type":"boolean"},"passId":{"$id":"/properties/passId","description":"if the booking was made or partially made with a pass, the pass id used","type":["integer","null"]},"passName":{"$id":"/properties/passName","description":"the type of the pass formatted to be LCM friendly\n","type":["string","null"]},"passType":{"$id":"/properties/passType","description":"if the booking was made or partially made with a pass, what type of pass","enum":["ALL_ACCESS","EARLY_BIRD","WEEKDAY",null],"type":["string","null"]},"userPassId":{"$id":"/properties/userPassId","description":"if the booking was made or partially made with a pass, what was the user pass Id used","type":["integer","null"]}},"required":["isEditAmenities","bookingId","isEditGuest","isEditDateTime"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostPressedCancelChangeRequest', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostPressedCancelDeleteReviewReply' track call.
 *
 * @param HostPressedCancelDeleteReviewReply props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostPressedCancelDeleteReviewReply(props: HostPressedCancelDeleteReviewReply, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostPressedCancelDeleteReviewReply","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST PERFORMANCE] Host pressed to cancel deleting their reply to a review","properties":{"bookingId":{"$id":"/properties/bookingId","description":"","type":"integer"},"bookingMessage":{"$id":"/properties/bookingMessage","description":"message sent by the guest when booking","type":["string","null"]},"bookingRating":{"$id":"/properties/bookingRating","description":"if the guest left a rating between 1-5, what was it","type":["integer","null"]},"bookingReason":{"$id":"/properties/bookingReason","description":"guest selection (listing type specific) for why they're booking","enum":["casual_play","competitive_play","corporate_or_meeting","courts","date","exercise","family_hangout","friend_hangout","lessons",null,"other","party_celebration","party_or_celebration","pet_swim","photoshoot","training"],"type":["string","null"]},"bookingReview":{"$id":"/properties/bookingReview","description":"if the guest left a review, what was it","type":["string","null"]},"bookingSpecialOfferId":{"$id":"/properties/bookingSpecialOfferId","description":"","type":["integer","null"]},"guestId":{"$id":"/properties/guestId","description":"","type":"integer"},"hostId":{"$id":"/properties/hostId","description":"","type":"integer"},"id":{"$id":"/properties/id","description":"","type":"string"},"isInstantBooking":{"$id":"/properties/isInstantBooking","description":"","type":"boolean"},"listingId":{"$id":"/properties/listingId","description":"","type":"integer"},"listingTitle":{"$id":"/properties/listingTitle","description":"","type":"string"},"reply":{"$id":"/properties/reply","description":"the host's reply","type":"string"},"totalGuests":{"$id":"/properties/totalGuests","description":"","type":"integer"},"totalPrice":{"$id":"/properties/totalPrice","description":"","type":"number"}},"required":["hostId","listingId","listingTitle","reply","bookingId","guestId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostPressedCancelDeleteReviewReply', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostPressedCancelFromReservationPage' track call.
 *
 * @param HostPressedCancelFromReservationPage props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostPressedCancelFromReservationPage(props: HostPressedCancelFromReservationPage, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostPressedCancelFromReservationPage","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST RESERVATION] host pressed to initiate cancel from reservation page","properties":{"bookingId":{"$id":"/properties/bookingId","description":"id of the booking the reservation pertains to","type":"integer"},"bookingWithPass":{"$id":"/properties/bookingWithPass","description":"was the booking made using a pass","enum":["FALSE","PARTIAL","TRUE"],"type":"string"},"passId":{"$id":"/properties/passId","description":"if the booking was made or partially made with a pass, the pass id used","type":["integer","null"]},"passName":{"$id":"/properties/passName","description":"the type of the pass formatted to be LCM friendly\n","type":["string","null"]},"passType":{"$id":"/properties/passType","description":"if the booking was made or partially made with a pass, what type of pass","enum":["ALL_ACCESS","EARLY_BIRD","WEEKDAY",null],"type":["string","null"]},"userPassId":{"$id":"/properties/userPassId","description":"if the booking was made or partially made with a pass, what was the user pass Id used","type":["integer","null"]}},"required":["bookingId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostPressedCancelFromReservationPage', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostPressedCancelReschedule' track call.
 *
 * @param HostPressedCancelReschedule props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostPressedCancelReschedule(props: HostPressedCancelReschedule, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostPressedCancelReschedule","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST RESERVATION] host pressed to \"not make changes\" on reschedule confirmation screen","properties":{"bookingId":{"$id":"/properties/bookingId","description":"id of the booking the reservation pertains to","type":"integer"},"bookingWithPass":{"$id":"/properties/bookingWithPass","description":"was the booking made using a pass","enum":["FALSE","PARTIAL","TRUE"],"type":"string"},"passId":{"$id":"/properties/passId","description":"if the booking was made or partially made with a pass, the pass id used","type":["integer","null"]},"passName":{"$id":"/properties/passName","description":"the type of the pass formatted to be LCM friendly\n","type":["string","null"]},"passType":{"$id":"/properties/passType","description":"if the booking was made or partially made with a pass, what type of pass","enum":["ALL_ACCESS","EARLY_BIRD","WEEKDAY",null],"type":["string","null"]},"userPassId":{"$id":"/properties/userPassId","description":"if the booking was made or partially made with a pass, what was the user pass Id used","type":["integer","null"]}},"required":["bookingId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostPressedCancelReschedule', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostPressedCancelReviewReply' track call.
 *
 * @param HostPressedCancelReviewReply props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostPressedCancelReviewReply(props: HostPressedCancelReviewReply, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostPressedCancelReviewReply","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST PERFORMANCE] Host pressed to cancel replying to a guest's review","properties":{"bookingId":{"$id":"/properties/bookingId","description":"","type":"integer"},"bookingMessage":{"$id":"/properties/bookingMessage","description":"message sent by the guest when booking","type":["string","null"]},"bookingRating":{"$id":"/properties/bookingRating","description":"if the guest left a rating between 1-5, what was it","type":["integer","null"]},"bookingReason":{"$id":"/properties/bookingReason","description":"guest selection (listing type specific) for why they're booking","enum":["casual_play","competitive_play","corporate_or_meeting","courts","date","exercise","family_hangout","friend_hangout","lessons",null,"other","party_celebration","party_or_celebration","pet_swim","photoshoot","training"],"type":["string","null"]},"bookingReview":{"$id":"/properties/bookingReview","description":"if the guest left a review, what was it","type":["string","null"]},"bookingSpecialOfferId":{"$id":"/properties/bookingSpecialOfferId","description":"","type":["integer","null"]},"guestId":{"$id":"/properties/guestId","description":"","type":"integer"},"hostId":{"$id":"/properties/hostId","description":"","type":"integer"},"id":{"$id":"/properties/id","description":"","type":"string"},"isInstantBooking":{"$id":"/properties/isInstantBooking","description":"","type":"boolean"},"listingId":{"$id":"/properties/listingId","description":"","type":"integer"},"listingTitle":{"$id":"/properties/listingTitle","description":"","type":"string"},"totalGuests":{"$id":"/properties/totalGuests","description":"","type":"integer"},"totalPrice":{"$id":"/properties/totalPrice","description":"","type":"number"}},"required":["bookingId","guestId","hostId","listingId","listingTitle"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostPressedCancelReviewReply', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostPressedChatFromReservationDetails' track call.
 *
 * @param HostPressedChatFromReservationDetails props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostPressedChatFromReservationDetails(props: HostPressedChatFromReservationDetails, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostPressedChatFromReservationDetails","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST RESERVATION] host pressed to edit booking guest count","properties":{"bookingId":{"$id":"/properties/bookingId","description":"the id of the booking","type":"integer"},"guestId":{"$id":"/properties/guestId","description":"the id of the guest","type":"integer"}},"required":["bookingId","guestId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostPressedChatFromReservationDetails', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostPressedCloseFlowTrustAndSafety' track call.
 *
 * @param HostPressedCloseFlowTrustAndSafety props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostPressedCloseFlowTrustAndSafety(props: HostPressedCloseFlowTrustAndSafety, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostPressedCloseFlowTrustAndSafety","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST T&S SWIPE] Host pressed the close flow button on the top left","properties":{"bookingId":{"$id":"/properties/bookingId","description":"the id of the booking","type":"integer"},"currentPageNumber":{"$id":"/properties/currentPageNumber","description":"page number of the T&S flow (1, 2, or 3)","type":"integer"}},"required":["bookingId","currentPageNumber"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostPressedCloseFlowTrustAndSafety', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostPressedCloseThanksForReading' track call.
 *
 * @param HostPressedCloseThanksForReading props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostPressedCloseThanksForReading(props: HostPressedCloseThanksForReading, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostPressedCloseThanksForReading","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST T&S SWIPE] host pressed the 'X' button to close the Thanks for Reading card","properties":{"bookingId":{"$id":"/properties/bookingId","description":"id of the booking\n","type":"integer"}},"required":["bookingId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostPressedCloseThanksForReading', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostPressedConfirmPreApproval' track call.
 *
 * @param HostPressedConfirmPreApproval props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostPressedConfirmPreApproval(props: HostPressedConfirmPreApproval, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostPressedConfirmPreApproval","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST BOOKING INQUIRY RESPONSE]","properties":{"bookingChangeRequestId":{"$id":"/properties/bookingChangeRequestId","description":"","type":"integer"},"bookingId":{"$id":"/properties/bookingId","description":"","type":"integer"}},"required":["bookingId","bookingChangeRequestId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostPressedConfirmPreApproval', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostPressedConnectToInstagram' track call.
 *
 * @param HostPressedConnectToInstagram props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostPressedConnectToInstagram(props: HostPressedConnectToInstagram, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostPressedConnectToInstagram","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST SETTINGS - INSTAGRAM] when host presses \"Connect Instagram\"in the connect Instagram flow","properties":{"listingId":{"$id":"/properties/listingId","description":"","type":"integer"}},"required":["listingId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostPressedConnectToInstagram', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostPressedContactSupportFromReservationPage' track call.
 *
 * @param HostPressedContactSupportFromReservationPage props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostPressedContactSupportFromReservationPage(props: HostPressedContactSupportFromReservationPage, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostPressedContactSupportFromReservationPage","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST RESERVATION] host pressed to contact support from reservation page","properties":{"bookingId":{"$id":"/properties/bookingId","description":"id of the booking the reservation pertains to","type":"integer"},"bookingWithPass":{"$id":"/properties/bookingWithPass","description":"was the booking made using a pass","enum":["FALSE","PARTIAL","TRUE"],"type":"string"},"passId":{"$id":"/properties/passId","description":"if the booking was made or partially made with a pass, the pass id used","type":["integer","null"]},"passName":{"$id":"/properties/passName","description":"the type of the pass formatted to be LCM friendly\n","type":["string","null"]},"passType":{"$id":"/properties/passType","description":"if the booking was made or partially made with a pass, what type of pass","enum":["ALL_ACCESS","EARLY_BIRD","WEEKDAY",null],"type":["string","null"]},"userPassId":{"$id":"/properties/userPassId","description":"if the booking was made or partially made with a pass, what was the user pass Id used","type":["integer","null"]}},"required":["bookingId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostPressedContactSupportFromReservationPage', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostPressedContinueChangeRequest' track call.
 *
 * @param HostPressedContinueChangeRequest props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostPressedContinueChangeRequest(props: HostPressedContinueChangeRequest, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostPressedContinueChangeRequest","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST RESERVATION] host pressed to continue to change request","properties":{"bookingId":{"$id":"/properties/bookingId","description":"id of the booking","type":"string"},"bookingWithPass":{"$id":"/properties/bookingWithPass","description":"was the booking made using a pass","enum":["FALSE","PARTIAL","TRUE"],"type":"string"},"passId":{"$id":"/properties/passId","description":"if the booking was made or partially made with a pass, the pass id used","type":["integer","null"]},"passName":{"$id":"/properties/passName","description":"the type of the pass formatted to be LCM friendly\n","type":["string","null"]},"passType":{"$id":"/properties/passType","description":"if the booking was made or partially made with a pass, what type of pass","enum":["ALL_ACCESS","EARLY_BIRD","WEEKDAY",null],"type":["string","null"]},"userPassId":{"$id":"/properties/userPassId","description":"if the booking was made or partially made with a pass, what was the user pass Id used","type":["integer","null"]}},"required":["bookingId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostPressedContinueChangeRequest', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostPressedContinueToCreateSo' track call.
 *
 * @param HostPressedContinueToCreateSo props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostPressedContinueToCreateSo(props: HostPressedContinueToCreateSo, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostPressedContinueToCreateSo","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST BOOKING INQUIRY CREATING SPECIAL OFFER]","properties":{"bookingId":{"$id":"/properties/bookingId","description":"","type":["integer","null"]},"originalPrice":{"$id":"/properties/originalPrice","description":"","type":"integer"},"specialOfferPrice":{"$id":"/properties/specialOfferPrice","description":"","type":"integer"}},"required":["specialOfferPrice","originalPrice"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostPressedContinueToCreateSo', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostPressedContinueToSetUpTieredPrice' track call.
 *
 * @param HostPressedContinueToSetUpTieredPrice props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostPressedContinueToSetUpTieredPrice(props: HostPressedContinueToSetUpTieredPrice, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostPressedContinueToSetUpTieredPrice","$schema":"http://json-schema.org/draft-07/schema#","description":"[TIERED PRICING] Host pressed to continue to set up tiered price","properties":{"listingId":{"$id":"/properties/listingId","description":"id of the listing","type":"integer"}},"required":["listingId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostPressedContinueToSetUpTieredPrice', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostPressedCreatePromoCode' track call.
 *
 * @param HostPressedCreatePromoCode props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostPressedCreatePromoCode(props: HostPressedCreatePromoCode, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostPressedCreatePromoCode","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST PROMO CODE] Host pressed the create a promo code button","properties":{"enteredFrom":{"$id":"/properties/enteredFrom","description":"the page of the button","enum":["add_to_listing","fans","manage","pop_up"],"type":"string"},"listingId":{"$id":"/properties/listingId","description":"id of the listing of that marketing page","type":"string"}},"required":["listingId","enteredFrom"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostPressedCreatePromoCode', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostPressedDeactivateAbandonCartDiscount' track call.
 *
 * @param HostPressedDeactivateAbandonCartDiscount props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostPressedDeactivateAbandonCartDiscount(props: HostPressedDeactivateAbandonCartDiscount, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostPressedDeactivateAbandonCartDiscount","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST PROMO CODE] ","properties":{"amountOff":{"$id":"/properties/amountOff","description":"percent amount off of this promo code (1-100) ","type":"number"},"expireDays":{"$id":"/properties/expireDays","description":"","type":"string"},"listingId":{"$id":"/properties/listingId","description":"","type":"string"},"note":{"$id":"/properties/note","description":"","type":["string","null"]},"promocodeId":{"$id":"/properties/promocodeId","description":"","type":"integer"}},"required":["listingId","promocodeId","amountOff","expireDays"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostPressedDeactivateAbandonCartDiscount', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostPressedDeactivatePass' track call.
 *
 * @param HostPressedDeactivatePass props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostPressedDeactivatePass(props: HostPressedDeactivatePass, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostPressedDeactivatePass","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST PASS MANAGEMENT - DEACTIVATING]","properties":{"coverImageURL":{"$id":"/properties/coverImageURL","description":"the url for the cover image of the listing the pass is for","type":"string"},"hostFirstName":{"$id":"/properties/hostFirstName","description":"first name of the host","type":"string"},"id":{"$id":"/properties/id","description":"","type":"string"},"listingId":{"$id":"/properties/listingId","description":"id of the listing the pass is for","type":"string"},"listingTitle":{"$id":"/properties/listingTitle","description":"the title of the listing the pass is for","type":"string"},"listingURL":{"$id":"/properties/listingURL","description":"the url of the listing the pass is for","type":"string"},"passAvailableTimes":{"$id":"/properties/passAvailableTimes","description":"[{from:”07:00:00”, “11:00:00”}...] Time slots when this pass is eligible","type":"array"},"passAvailableTimesText":{"$id":"/properties/passAvailableTimesText","description":"LCM formatted version of available times property","type":"string"},"passBlackoutDays":{"$id":"/properties/passBlackoutDays","description":"list of blackout dates (e.g. July 4, 2024). ","type":["array","null"]},"passCreatedAt":{"$id":"/properties/passCreatedAt","description":"when the pass was created","type":"string"},"passCurrencyCode":{"$id":"/properties/passCurrencyCode","description":"currency for all monetary fields","type":"string"},"passCurrent":{"$id":"/properties/passCurrent","description":"flag indicating that this is the current version for a pass. For a type/name/listing_id, there can only be one record with this attribute true.","type":"boolean"},"passDescription":{"$id":"/properties/passDescription","description":"free text description set by host","type":["string","null"]},"passDiscount":{"$id":"/properties/passDiscount","description":"discount amount. Fixed discounts will be in minors units.","type":["number","null"]},"passDiscountType":{"$id":"/properties/passDiscountType","description":"type of pass discount num[‘percentage’, ‘fixed’]","enum":["FIXED","PERCENTAGE",null],"type":["string","null"]},"passEligibleDays":{"$id":"/properties/passEligibleDays","description":"days the pass is eligible","type":["array","null"]},"passId":{"$id":"/properties/passId","description":"id of the pass","type":"integer"},"passMaxActivePasses":{"$id":"/properties/passMaxActivePasses","description":"max active passes allowed. This constraint will apply to the (listing_id, type, name) rather than id so that we can be accurate across edits.","type":["number","null"]},"passMaxDailyBookings":{"$id":"/properties/passMaxDailyBookings","description":"max bookings allowed under this pass","type":["number","null"]},"passMaxDuration":{"$id":"/properties/passMaxDuration","description":"max duration that may be booked using this pass","type":["number","null"]},"passMaxGuests":{"$id":"/properties/passMaxGuests","description":"max guests that may be booked using this pass","type":["number","null"]},"passName":{"$id":"/properties/passName","description":"the type of the pass formatted to be LCM friendly","pattern":"","type":"string"},"passPremiumAmenities":{"$id":"/properties/passPremiumAmenities","description":"the ids of all premium amenities included with the pass","type":["array","null"]},"passPrice":{"$id":"/properties/passPrice","description":"pass price in minor units","type":"string"},"passState":{"$id":"/properties/passState","description":"‘draft’ -> pass is being actively edited by the host via the creation flow. The step attribute below tracks the progress of the host through the creation flow.\n‘inactive’ -> pass has been created by the host, but not ready for sale yet\n‘active’ -> pass has passed the final availability requirements and has been marked by the host as ready for sale.","enum":["ACTIVE","DRAFT","INACTIVE"],"type":"string"},"passTotalPrice":{"$id":"/properties/passTotalPrice","description":"the pass of the price plus the service fee","type":"string"},"passType":{"$id":"/properties/passType","description":"the type of pass","enum":["ALL_ACCESS","EARLY_BIRD","FIXED_HOURS","WEEKDAY"],"type":"string"}},"required":["passCreatedAt","hostFirstName","coverImageURL","passCurrencyCode","passTotalPrice","passType","passPrice","passDiscount","passName","passState","passDiscountType","passId","passCurrent","listingURL","listingTitle","listingId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostPressedDeactivatePass', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostPressedDeclineReservationRequest' track call.
 *
 * @param HostPressedDeclineReservationRequest props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostPressedDeclineReservationRequest(props: HostPressedDeclineReservationRequest, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostPressedDeclineReservationRequest","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST RESERVATION] host initiated decline reservation flow","properties":{"bookingId":{"$id":"/properties/bookingId","description":"id of the booking the reservation pertains to","type":"integer"},"bookingWithPass":{"$id":"/properties/bookingWithPass","description":"was the booking made using a pass","enum":["FALSE","PARTIAL","TRUE"],"type":"string"},"passId":{"$id":"/properties/passId","description":"if the booking was made or partially made with a pass, the pass id used","type":["integer","null"]},"passName":{"$id":"/properties/passName","description":"the type of the pass formatted to be LCM friendly\n","type":["string","null"]},"passType":{"$id":"/properties/passType","description":"if the booking was made or partially made with a pass, what type of pass","enum":["ALL_ACCESS","EARLY_BIRD","WEEKDAY",null],"type":["string","null"]},"userPassId":{"$id":"/properties/userPassId","description":"if the booking was made or partially made with a pass, what was the user pass Id used","type":["integer","null"]}},"required":["bookingId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostPressedDeclineReservationRequest', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostPressedDeleteImportCalendar' track call.
 *
 * @param HostPressedDeleteImportCalendar props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostPressedDeleteImportCalendar(props: HostPressedDeleteImportCalendar, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostPressedDeleteImportCalendar","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST CALENDAR SYNCING] Host pressed \"Done\" after having pressed the trash can next to an external calendar after having pressed \"Manage external iCalendars\"","properties":{"calendarName":{"$id":"/properties/calendarName","description":"","type":"string"},"calendarURL":{"$id":"/properties/calendarURL","description":"","type":"string"},"listingId":{"$id":"/properties/listingId","description":"","type":"integer"}},"required":["listingId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostPressedDeleteImportCalendar', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostPressedDeleteReviewReply' track call.
 *
 * @param HostPressedDeleteReviewReply props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostPressedDeleteReviewReply(props: HostPressedDeleteReviewReply, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostPressedDeleteReviewReply","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST PERFORMANCE] Host pressed to delete their reply to a guest's review","properties":{"bookingId":{"$id":"/properties/bookingId","description":"","type":"integer"},"bookingMessage":{"$id":"/properties/bookingMessage","description":"message sent by the guest when booking","type":["string","null"]},"bookingRating":{"$id":"/properties/bookingRating","description":"if the guest left a rating between 1-5, what was it","type":["integer","null"]},"bookingReason":{"$id":"/properties/bookingReason","description":"guest selection (listing type specific) for why they're booking","enum":["casual_play","competitive_play","corporate_or_meeting","courts","date","exercise","family_hangout","friend_hangout","lessons",null,"other","party_celebration","party_or_celebration","pet_swim","photoshoot","training"],"type":["string","null"]},"bookingReview":{"$id":"/properties/bookingReview","description":"if the guest left a review, what was it","type":["string","null"]},"bookingSpecialOfferId":{"$id":"/properties/bookingSpecialOfferId","description":"","type":["integer","null"]},"guestId":{"$id":"/properties/guestId","description":"","type":"integer"},"hostId":{"$id":"/properties/hostId","description":"","type":"integer"},"id":{"$id":"/properties/id","description":"","type":"string"},"isInstantBooking":{"$id":"/properties/isInstantBooking","description":"","type":"boolean"},"listingId":{"$id":"/properties/listingId","description":"","type":"integer"},"listingTitle":{"$id":"/properties/listingTitle","description":"","type":"string"},"reply":{"$id":"/properties/reply","description":"the host's reply","type":"string"},"totalGuests":{"$id":"/properties/totalGuests","description":"","type":"integer"},"totalPrice":{"$id":"/properties/totalPrice","description":"","type":"number"}},"required":["listingTitle","reply","bookingId","guestId","hostId","listingId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostPressedDeleteReviewReply', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostPressedDeleteVideoTour' track call.
 *
 * @param HostPressedDeleteVideoTour props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostPressedDeleteVideoTour(props: HostPressedDeleteVideoTour, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostPressedDeleteVideoTour","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST SETTINGS - VIDEO TOUR] when host presses \"the trash can\" after having uploaded a video tour","properties":{"listingId":{"$id":"/properties/listingId","description":"","type":"integer"}},"required":["listingId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostPressedDeleteVideoTour', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostPressedDisconnectCronofy' track call.
 *
 * @param HostPressedDisconnectCronofy props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostPressedDisconnectCronofy(props: HostPressedDisconnectCronofy, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostPressedDisconnectCronofy","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST CALENDAR SYNCING] Host pressed \"Disconnect Cronofy\"","properties":{"listingId":{"$id":"/properties/listingId","description":"","type":"string"}},"required":["listingId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostPressedDisconnectCronofy', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostPressedDisconnectInstagram' track call.
 *
 * @param HostPressedDisconnectInstagram props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostPressedDisconnectInstagram(props: HostPressedDisconnectInstagram, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostPressedDisconnectInstagram","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST SETTINGS - INSTAGRAM] when host presses \"Disconnect Instagram\" in the connect Instagram flow","properties":{"listingId":{"$id":"/properties/listingId","description":"","type":"integer"}},"required":["listingId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostPressedDisconnectInstagram', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostPressedEditAmenities' track call.
 *
 * @param HostPressedEditAmenities props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostPressedEditAmenities(props: HostPressedEditAmenities, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostPressedEditAmenities","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST RESERVATION] host pressed to edit amenities","properties":{"bookingId":{"$id":"/properties/bookingId","description":"id of the booking the reservation pertains to","type":"string"},"bookingWithPass":{"$id":"/properties/bookingWithPass","description":"was the booking made using a pass","enum":["FALSE","PARTIAL","TRUE"],"type":"string"},"passId":{"$id":"/properties/passId","description":"if the booking was made or partially made with a pass, the pass id used","type":["integer","null"]},"passName":{"$id":"/properties/passName","description":"the type of the pass formatted to be LCM friendly\n","type":["string","null"]},"passType":{"$id":"/properties/passType","description":"if the booking was made or partially made with a pass, what type of pass","enum":["ALL_ACCESS","EARLY_BIRD","WEEKDAY",null],"type":["string","null"]},"userPassId":{"$id":"/properties/userPassId","description":"if the booking was made or partially made with a pass, what was the user pass Id used","type":["integer","null"]}},"required":["bookingId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostPressedEditAmenities', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostPressedEditConnectToInstagram' track call.
 *
 * @param HostPressedEditConnectToInstagram props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostPressedEditConnectToInstagram(props: HostPressedEditConnectToInstagram, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostPressedEditConnectToInstagram","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST SETTINGS - INSTAGRAM] when host presses \"Edit\" to enter the connect their Instagram flow","properties":{"listingId":{"$id":"/properties/listingId","description":"","type":"integer"}},"required":["listingId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostPressedEditConnectToInstagram', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostPressedEditDateTime' track call.
 *
 * @param HostPressedEditDateTime props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostPressedEditDateTime(props: HostPressedEditDateTime, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostPressedEditDateTime","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST RESERVATION] host pressed to edit booking date or time","properties":{"bookingId":{"$id":"/properties/bookingId","description":"id of the booking the reservation pertains to","type":"string"},"bookingWithPass":{"$id":"/properties/bookingWithPass","description":"was the booking made using a pass","enum":["FALSE","PARTIAL","TRUE"],"type":"string"},"passId":{"$id":"/properties/passId","description":"if the booking was made or partially made with a pass, the pass id used","type":["integer","null"]},"passName":{"$id":"/properties/passName","description":"the type of the pass formatted to be LCM friendly\n","type":["string","null"]},"passType":{"$id":"/properties/passType","description":"if the booking was made or partially made with a pass, what type of pass","enum":["ALL_ACCESS","EARLY_BIRD","WEEKDAY",null],"type":["string","null"]},"userPassId":{"$id":"/properties/userPassId","description":"if the booking was made or partially made with a pass, what was the user pass Id used","type":["integer","null"]}},"required":["bookingId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostPressedEditDateTime', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostPressedEditGuest' track call.
 *
 * @param HostPressedEditGuest props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostPressedEditGuest(props: HostPressedEditGuest, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostPressedEditGuest","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST RESERVATION] host pressed to edit booking guest count","properties":{"bookingId":{"$id":"/properties/bookingId","description":"","type":"string"},"bookingWithPass":{"$id":"/properties/bookingWithPass","description":"was the booking made using a pass","enum":["FALSE","PARTIAL","TRUE"],"type":"string"},"passId":{"$id":"/properties/passId","description":"if the booking was made or partially made with a pass, the pass id used","type":["integer","null"]},"passName":{"$id":"/properties/passName","description":"the type of the pass formatted to be LCM friendly\n","type":["string","null"]},"passType":{"$id":"/properties/passType","description":"if the booking was made or partially made with a pass, what type of pass","enum":["ALL_ACCESS","EARLY_BIRD","WEEKDAY",null],"type":["string","null"]},"userPassId":{"$id":"/properties/userPassId","description":"if the booking was made or partially made with a pass, what was the user pass Id used","type":["integer","null"]}},"required":["bookingId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostPressedEditGuest', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostPressedEditPass' track call.
 *
 * @param HostPressedEditPass props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostPressedEditPass(props: HostPressedEditPass, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostPressedEditPass","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST PASS MANAGEMENT - UPDATING]","properties":{"coverImageURL":{"$id":"/properties/coverImageURL","description":"the url for the cover image of the listing the pass is for","type":"string"},"hostFirstName":{"$id":"/properties/hostFirstName","description":"first name of the host","type":"string"},"id":{"$id":"/properties/id","description":"","type":"string"},"listingId":{"$id":"/properties/listingId","description":"id of the listing the pass is for","type":"string"},"listingTitle":{"$id":"/properties/listingTitle","description":"the title of the listing the pass is for","type":"string"},"listingURL":{"$id":"/properties/listingURL","description":"the url of the listing the pass is for","type":"string"},"passAvailableTimes":{"$id":"/properties/passAvailableTimes","description":"[{from:”07:00:00”, “11:00:00”}...] Time slots when this pass is eligible","type":"array"},"passAvailableTimesText":{"$id":"/properties/passAvailableTimesText","description":"LCM formatted version of available times property","type":"string"},"passBlackoutDays":{"$id":"/properties/passBlackoutDays","description":"list of blackout dates (e.g. July 4, 2024). ","type":["array","null"]},"passCreatedAt":{"$id":"/properties/passCreatedAt","description":"when the pass was created","type":"string"},"passCurrencyCode":{"$id":"/properties/passCurrencyCode","description":"currency for all monetary fields","type":"string"},"passCurrent":{"$id":"/properties/passCurrent","description":"flag indicating that this is the current version for a pass. For a type/name/listing_id, there can only be one record with this attribute true.","type":"boolean"},"passDescription":{"$id":"/properties/passDescription","description":"free text description set by host","type":["string","null"]},"passDetailSelected":{"$id":"/properties/passDetailSelected","description":"","enum":["passAvailableTimes","passDescription","passEligibleDays","passMaxDuration","passMaxGuests","passPremiumAmenities","passPrice"],"type":"string"},"passDiscount":{"$id":"/properties/passDiscount","description":"discount amount. Fixed discounts will be in minors units.","type":["number","null"]},"passDiscountType":{"$id":"/properties/passDiscountType","description":"type of pass discount num[‘percentage’, ‘fixed’]","enum":["FIXED","PERCENTAGE",null],"type":["string","null"]},"passEligibleDays":{"$id":"/properties/passEligibleDays","description":"days the pass is eligible","type":["array","null"]},"passId":{"$id":"/properties/passId","description":"id of the pass","type":"integer"},"passMaxActivePasses":{"$id":"/properties/passMaxActivePasses","description":"max active passes allowed. This constraint will apply to the (listing_id, type, name) rather than id so that we can be accurate across edits.","type":["number","null"]},"passMaxDailyBookings":{"$id":"/properties/passMaxDailyBookings","description":"max bookings allowed under this pass","type":["number","null"]},"passMaxDuration":{"$id":"/properties/passMaxDuration","description":"max duration that may be booked using this pass","type":["number","null"]},"passMaxGuests":{"$id":"/properties/passMaxGuests","description":"max guests that may be booked using this pass","type":["number","null"]},"passName":{"$id":"/properties/passName","description":"the type of the pass formatted to be LCM friendly","pattern":"","type":"string"},"passPremiumAmenities":{"$id":"/properties/passPremiumAmenities","description":"the ids of all premium amenities included with the pass","type":["array","null"]},"passPrice":{"$id":"/properties/passPrice","description":"pass price in minor units","type":"string"},"passState":{"$id":"/properties/passState","description":"‘draft’ -> pass is being actively edited by the host via the creation flow. The step attribute below tracks the progress of the host through the creation flow.\n‘inactive’ -> pass has been created by the host, but not ready for sale yet\n‘active’ -> pass has passed the final availability requirements and has been marked by the host as ready for sale.","enum":["ACTIVE","DRAFT","INACTIVE"],"type":"string"},"passTotalPrice":{"$id":"/properties/passTotalPrice","description":"the pass of the price plus the service fee","type":"string"},"passType":{"$id":"/properties/passType","description":"the type of pass","enum":["ALL_ACCESS","EARLY_BIRD","FIXED_HOURS","WEEKDAY"],"type":"string"}},"required":["passPrice","listingId","passCurrent","passTotalPrice","hostFirstName","listingURL","passDetailSelected","passDiscountType","passState","passName","passDiscount","coverImageURL","passId","listingTitle","passCreatedAt","passCurrencyCode","passType"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostPressedEditPass', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostPressedExportCalendarCopyLink' track call.
 *
 * @param HostPressedExportCalendarCopyLink props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostPressedExportCalendarCopyLink(props: HostPressedExportCalendarCopyLink, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostPressedExportCalendarCopyLink","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST CALENDAR SYNCING] fires when the host pressed \"Copy link\" on the pop up after pressing \"Export Swimply iCalendar\"","properties":{"calendarURL":{"$id":"/properties/calendarURL","description":"","type":"string"},"listingId":{"$id":"/properties/listingId","description":"","type":"integer"}},"required":["calendarURL","listingId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostPressedExportCalendarCopyLink', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostPressedFileSDClaim' track call.
 *
 * @param HostPressedFileSDClaim props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostPressedFileSDClaim(props: HostPressedFileSDClaim, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostPressedFileSDClaim","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST SD CLAIM]","properties":{"bookingId":{"$id":"/properties/bookingId","description":"","type":"string"},"listingId":{"$id":"/properties/listingId","description":"","type":"integer"}},"required":["bookingId","listingId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostPressedFileSDClaim', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostPressedFileSDClaimExit' track call.
 *
 * @param HostPressedFileSDClaimExit props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostPressedFileSDClaimExit(props: HostPressedFileSDClaimExit, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostPressedFileSDClaimExit","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST SD CLAIM]","properties":{"bookingId":{"$id":"/properties/bookingId","description":"","type":"string"},"listingId":{"$id":"/properties/listingId","description":"","type":"integer"}},"required":["bookingId","listingId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostPressedFileSDClaimExit', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostPressedGetStartedOnboardingListing' track call.
 *
 * @param HostPressedGetStartedOnboardingListing props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostPressedGetStartedOnboardingListing(props: HostPressedGetStartedOnboardingListing, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostPressedGetStartedOnboardingListing","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST ONBOARDING] first screen a user sees to begin onboarding and they press get started","properties":{"enteredFrom":{"$id":"/properties/enteredFrom","description":"All possible values for enteredFrom in host onboarding","enum":["ProfilePhotosScreen","ProfileScreen","austin","austinFB","clarkRubber","dipApp","directPoolSupplies","existingHostNewListingFlow","hostExistingListingManagement","hostOnboardingFlow","houston","houstonFB","losangeles","losangelesFB","newYork","newYorkFB","noListingsScreen","performanceTips","ph","poolProfits","poolSafetySolutions","portland","portlandFB","precisionPoolsAndLandscape","profileManageListings","sanAntonio","sanAntonioFB","seattle","seattleFB","swimUniversity","toronto","torontoFB","vip"],"type":"string"},"id":{"$id":"/properties/id","description":"","type":"string"},"listingId":{"$id":"/properties/listingId","description":"id for the related listing","type":"string"},"poolId":{"$id":"/properties/poolId","description":"legacy name for listing id","type":"string"}},"required":["listingId","enteredFrom"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostPressedGetStartedOnboardingListing', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostPressedGetStartedPromoOnPDPEdu' track call.
 *
 * @param HostPressedGetStartedPromoOnPDPEdu props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostPressedGetStartedPromoOnPDPEdu(props: HostPressedGetStartedPromoOnPDPEdu, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostPressedGetStartedPromoOnPDPEdu","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST PROMO CODE] Host pressed get started after seeing the promocodes on PDP Educational card","properties":{"id":{"$id":"/properties/id","description":"","type":"string"}},"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostPressedGetStartedPromoOnPDPEdu', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostPressedHelpCenterFromMessages' track call.
 *
 * @param HostPressedHelpCenterFromMessages props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostPressedHelpCenterFromMessages(props: HostPressedHelpCenterFromMessages, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostPressedHelpCenterFromMessages","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST BOOKING INQUIRY RESPONSE]","properties":{"bookingId":{"$id":"/properties/bookingId","description":"","type":["integer","null"]},"globalListingType":{"$id":"/properties/globalListingType","description":"[LISTING TYPE] The type of the listing associated with this event","enum":["artStudio","basketballCourt","dockedBoat","home","homeGym","joyspace","kitchen","largeBackyard","musicStudio","other","pending","pickleball","pool","privateLake","roofDeck","tennisCourt"],"type":"string"},"guestId":{"$id":"/properties/guestId","description":"","type":"integer"},"hostId":{"$id":"/properties/hostId","description":"","type":"integer"},"listingId":{"$id":"/properties/listingId","description":"","type":"integer"},"roomId":{"$id":"/properties/roomId","description":"","type":"string"}},"required":["listingId","guestId","hostId","globalListingType"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostPressedHelpCenterFromMessages', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostPressedHelpCenterFromReservationPage' track call.
 *
 * @param HostPressedHelpCenterFromReservationPage props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostPressedHelpCenterFromReservationPage(props: HostPressedHelpCenterFromReservationPage, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostPressedHelpCenterFromReservationPage","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST RESERVATION] host pressed to see help center from reservation page","properties":{"bookingId":{"$id":"/properties/bookingId","description":"id of the booking the reservation pertains to","type":"integer"},"bookingWithPass":{"$id":"/properties/bookingWithPass","description":"was the booking made using a pass","enum":["FALSE","PARTIAL","TRUE"],"type":"string"},"passId":{"$id":"/properties/passId","description":"if the booking was made or partially made with a pass, the pass id used","type":["integer","null"]},"passName":{"$id":"/properties/passName","description":"the type of the pass formatted to be LCM friendly\n","type":["string","null"]},"passType":{"$id":"/properties/passType","description":"if the booking was made or partially made with a pass, what type of pass","enum":["ALL_ACCESS","EARLY_BIRD","WEEKDAY",null],"type":["string","null"]},"userPassId":{"$id":"/properties/userPassId","description":"if the booking was made or partially made with a pass, what was the user pass Id used","type":["integer","null"]}},"required":["bookingId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostPressedHelpCenterFromReservationPage', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostPressedHostWakeUpBannerLearnMore' track call.
 *
 * @param HostPressedHostWakeUpBannerLearnMore props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostPressedHostWakeUpBannerLearnMore(props: HostPressedHostWakeUpBannerLearnMore, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostPressedHostWakeUpBannerLearnMore","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST PERFORMANCE] Host clicked on the host wake up banner learn more link","properties":{"id":{"$id":"/properties/id","description":"","type":"string"}},"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostPressedHostWakeUpBannerLearnMore', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostPressedInitiateFullRefund' track call.
 *
 * @param HostPressedInitiateFullRefund props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostPressedInitiateFullRefund(props: HostPressedInitiateFullRefund, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostPressedInitiateFullRefund","$schema":"http://json-schema.org/draft-07/schema#","description":"within refund flow, host entered full refund option","properties":{"bookingId":{"$id":"/properties/bookingId","description":"id of the booking","type":"integer"},"bookingStatus":{"$id":"/properties/bookingStatus","description":"status of the booking","type":"string"},"guestId":{"$id":"/properties/guestId","description":"id of the guest","type":"integer"}},"required":["bookingId","bookingStatus","guestId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostPressedInitiateFullRefund', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostPressedInitiatePartialRefund' track call.
 *
 * @param HostPressedInitiatePartialRefund props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostPressedInitiatePartialRefund(props: HostPressedInitiatePartialRefund, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostPressedInitiatePartialRefund","$schema":"http://json-schema.org/draft-07/schema#","description":"within refund flow, host entered partial refund option","properties":{"bookingId":{"$id":"/properties/bookingId","description":"id of the booking","type":"integer"},"bookingStatus":{"$id":"/properties/bookingStatus","description":"status of the booking","type":"string"},"guestId":{"$id":"/properties/guestId","description":"id of the guest","type":"integer"}},"required":["bookingId","bookingStatus","guestId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostPressedInitiatePartialRefund', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostPressedInitiateRefund' track call.
 *
 * @param HostPressedInitiateRefund props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostPressedInitiateRefund(props: HostPressedInitiateRefund, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostPressedInitiateRefund","$schema":"http://json-schema.org/draft-07/schema#","description":"host entered the refund request flow","properties":{"bookingId":{"$id":"/properties/bookingId","description":"id of the booking","type":"integer"},"bookingStatus":{"$id":"/properties/bookingStatus","description":"status of the booking","type":"string"},"enteredFrom":{"$id":"/properties/enteredFrom","description":"which screen/tab the user entered from","type":"string"},"guestId":{"$id":"/properties/guestId","description":"id of the guest","type":"integer"}},"required":["bookingId","bookingStatus","enteredFrom","guestId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostPressedInitiateRefund', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostPressedLearnMorePassOnboarding' track call.
 *
 * @param HostPressedLearnMorePassOnboarding props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostPressedLearnMorePassOnboarding(props: HostPressedLearnMorePassOnboarding, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostPressedLearnMorePassOnboarding","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST PASS ONBOARDING]","properties":{"enteredFrom":{"$id":"/properties/enteredFrom","description":"how the host accessed onboarding","enum":["auto_popup","host_banner","listing_management","marketing_tab"],"type":"string"},"id":{"$id":"/properties/id","description":"","type":"string"}},"required":["enteredFrom"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostPressedLearnMorePassOnboarding', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostPressedListFromExternalSite' track call.
 *
 * @param HostPressedListFromExternalSite props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostPressedListFromExternalSite(props: HostPressedListFromExternalSite, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostPressedListFromExternalSite","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST ONBOARDING] first screen a user sees to begin onboarding and they select to import their listing from another site","properties":{"enteredFrom":{"$id":"/properties/enteredFrom","description":"All possible values for enteredFrom in host onboarding","enum":["ProfilePhotosScreen","ProfileScreen","austin","austinFB","clarkRubber","dipApp","directPoolSupplies","existingHostNewListingFlow","hostExistingListingManagement","hostOnboardingFlow","houston","houstonFB","losangeles","losangelesFB","newYork","newYorkFB","noListingsScreen","performanceTips","ph","poolProfits","poolSafetySolutions","portland","portlandFB","precisionPoolsAndLandscape","profileManageListings","sanAntonio","sanAntonioFB","seattle","seattleFB","swimUniversity","toronto","torontoFB","vip"],"type":"string"},"id":{"$id":"/properties/id","description":"","type":"string"},"listingId":{"$id":"/properties/listingId","description":"id for the related listing","type":"string"},"poolId":{"$id":"/properties/poolId","description":"legacy name for listing id","type":"string"}},"required":["enteredFrom","listingId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostPressedListFromExternalSite', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostPressedMakeChanges' track call.
 *
 * @param HostPressedMakeChanges props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostPressedMakeChanges(props: HostPressedMakeChanges, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostPressedMakeChanges","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST RESERVATION] host pressed to make changes in the booking","properties":{"bookingId":{"$id":"/properties/bookingId","description":"id of the booking","type":"string"},"bookingWithPass":{"$id":"/properties/bookingWithPass","description":"was the booking made using a pass","enum":["FALSE","PARTIAL","TRUE"],"type":"string"},"passId":{"$id":"/properties/passId","description":"if the booking was made or partially made with a pass, the pass id used","type":["integer","null"]},"passName":{"$id":"/properties/passName","description":"the type of the pass formatted to be LCM friendly\n","type":["string","null"]},"passType":{"$id":"/properties/passType","description":"if the booking was made or partially made with a pass, what type of pass","enum":["ALL_ACCESS","EARLY_BIRD","WEEKDAY",null],"type":["string","null"]},"userPassId":{"$id":"/properties/userPassId","description":"if the booking was made or partially made with a pass, what was the user pass Id used","type":["integer","null"]}},"required":["bookingId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostPressedMakeChanges', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostPressedManagePassFromPassOverview' track call.
 *
 * @param HostPressedManagePassFromPassOverview props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostPressedManagePassFromPassOverview(props: HostPressedManagePassFromPassOverview, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostPressedManagePassFromPassOverview","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST PASS MANAGEMENT] fires when a user presses manage pass from a SPECIFIC pass' page ","properties":{"coverImageURL":{"$id":"/properties/coverImageURL","description":"the url for the cover image of the listing the pass is for","type":"string"},"hostFirstName":{"$id":"/properties/hostFirstName","description":"first name of the host","type":"string"},"id":{"$id":"/properties/id","description":"","type":"string"},"listingId":{"$id":"/properties/listingId","description":"id of the listing the pass is for","type":"string"},"listingTitle":{"$id":"/properties/listingTitle","description":"the title of the listing the pass is for","type":"string"},"listingURL":{"$id":"/properties/listingURL","description":"the url of the listing the pass is for","type":"string"},"passAvailableTimes":{"$id":"/properties/passAvailableTimes","description":"[{from:”07:00:00”, “11:00:00”}...] Time slots when this pass is eligible","type":"array"},"passAvailableTimesText":{"$id":"/properties/passAvailableTimesText","description":"LCM formatted version of available times property","type":"string"},"passBlackoutDays":{"$id":"/properties/passBlackoutDays","description":"list of blackout dates (e.g. July 4, 2024). ","type":["array","null"]},"passCreatedAt":{"$id":"/properties/passCreatedAt","description":"when the pass was created","type":"string"},"passCurrencyCode":{"$id":"/properties/passCurrencyCode","description":"currency for all monetary fields","type":"string"},"passCurrent":{"$id":"/properties/passCurrent","description":"flag indicating that this is the current version for a pass. For a type/name/listing_id, there can only be one record with this attribute true.","type":"boolean"},"passDescription":{"$id":"/properties/passDescription","description":"free text description set by host","type":["string","null"]},"passDiscount":{"$id":"/properties/passDiscount","description":"discount amount. Fixed discounts will be in minors units.","type":["number","null"]},"passDiscountType":{"$id":"/properties/passDiscountType","description":"type of pass discount num[‘percentage’, ‘fixed’]","enum":["FIXED","PERCENTAGE",null],"type":["string","null"]},"passEligibleDays":{"$id":"/properties/passEligibleDays","description":"days the pass is eligible","type":["array","null"]},"passId":{"$id":"/properties/passId","description":"id of the pass","type":"integer"},"passMaxActivePasses":{"$id":"/properties/passMaxActivePasses","description":"max active passes allowed. This constraint will apply to the (listing_id, type, name) rather than id so that we can be accurate across edits.","type":["number","null"]},"passMaxDailyBookings":{"$id":"/properties/passMaxDailyBookings","description":"max bookings allowed under this pass","type":["number","null"]},"passMaxDuration":{"$id":"/properties/passMaxDuration","description":"max duration that may be booked using this pass","type":["number","null"]},"passMaxGuests":{"$id":"/properties/passMaxGuests","description":"max guests that may be booked using this pass","type":["number","null"]},"passName":{"$id":"/properties/passName","description":"the type of the pass formatted to be LCM friendly","pattern":"","type":"string"},"passPremiumAmenities":{"$id":"/properties/passPremiumAmenities","description":"the ids of all premium amenities included with the pass","type":["array","null"]},"passPrice":{"$id":"/properties/passPrice","description":"pass price in minor units","type":"string"},"passState":{"$id":"/properties/passState","description":"‘draft’ -> pass is being actively edited by the host via the creation flow. The step attribute below tracks the progress of the host through the creation flow.\n‘inactive’ -> pass has been created by the host, but not ready for sale yet\n‘active’ -> pass has passed the final availability requirements and has been marked by the host as ready for sale.","enum":["ACTIVE","DRAFT","INACTIVE"],"type":"string"},"passTotalPrice":{"$id":"/properties/passTotalPrice","description":"the pass of the price plus the service fee","type":"string"},"passType":{"$id":"/properties/passType","description":"the type of pass","enum":["ALL_ACCESS","EARLY_BIRD","FIXED_HOURS","WEEKDAY"],"type":"string"}},"required":["passDiscountType","listingId","passDiscount","passCurrent","passTotalPrice","passPrice","passState","passName","hostFirstName","coverImageURL","passId","passType","passCurrencyCode","listingURL","passCreatedAt","listingTitle"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostPressedManagePassFromPassOverview', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostPressedManagePassFromPasses' track call.
 *
 * @param HostPressedManagePassFromPasses props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostPressedManagePassFromPasses(props: HostPressedManagePassFromPasses, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostPressedManagePassFromPasses","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST PASS MANAGEMENT] fires when a user is on the generic passes page with the 3 different pass types shown","properties":{"coverImageURL":{"$id":"/properties/coverImageURL","description":"the url for the cover image of the listing the pass is for","type":"string"},"hostFirstName":{"$id":"/properties/hostFirstName","description":"first name of the host","type":"string"},"id":{"$id":"/properties/id","description":"","type":"string"},"listingId":{"$id":"/properties/listingId","description":"id of the listing the pass is for","type":"string"},"listingTitle":{"$id":"/properties/listingTitle","description":"the title of the listing the pass is for","type":"string"},"listingURL":{"$id":"/properties/listingURL","description":"the url of the listing the pass is for","type":"string"},"pageName":{"$id":"/properties/pageName","description":"","enum":["creation","management"],"type":"string"},"passAvailableTimes":{"$id":"/properties/passAvailableTimes","description":"[{from:”07:00:00”, “11:00:00”}...] Time slots when this pass is eligible","type":"array"},"passAvailableTimesText":{"$id":"/properties/passAvailableTimesText","description":"LCM formatted version of available times property","type":"string"},"passBlackoutDays":{"$id":"/properties/passBlackoutDays","description":"list of blackout dates (e.g. July 4, 2024). ","type":["array","null"]},"passCreatedAt":{"$id":"/properties/passCreatedAt","description":"when the pass was created","type":"string"},"passCurrencyCode":{"$id":"/properties/passCurrencyCode","description":"currency for all monetary fields","type":"string"},"passCurrent":{"$id":"/properties/passCurrent","description":"flag indicating that this is the current version for a pass. For a type/name/listing_id, there can only be one record with this attribute true.","type":"boolean"},"passDescription":{"$id":"/properties/passDescription","description":"free text description set by host","type":["string","null"]},"passDiscount":{"$id":"/properties/passDiscount","description":"discount amount. Fixed discounts will be in minors units.","type":["number","null"]},"passDiscountType":{"$id":"/properties/passDiscountType","description":"type of pass discount num[‘percentage’, ‘fixed’]","enum":["FIXED","PERCENTAGE",null],"type":["string","null"]},"passEligibleDays":{"$id":"/properties/passEligibleDays","description":"days the pass is eligible","type":["array","null"]},"passId":{"$id":"/properties/passId","description":"id of the pass","type":"integer"},"passIds":{"$id":"/properties/passIds","description":"","type":"array"},"passMaxActivePasses":{"$id":"/properties/passMaxActivePasses","description":"max active passes allowed. This constraint will apply to the (listing_id, type, name) rather than id so that we can be accurate across edits.","type":["number","null"]},"passMaxDailyBookings":{"$id":"/properties/passMaxDailyBookings","description":"max bookings allowed under this pass","type":["number","null"]},"passMaxDuration":{"$id":"/properties/passMaxDuration","description":"max duration that may be booked using this pass","type":["number","null"]},"passMaxGuests":{"$id":"/properties/passMaxGuests","description":"max guests that may be booked using this pass","type":["number","null"]},"passName":{"$id":"/properties/passName","description":"the type of the pass formatted to be LCM friendly","pattern":"","type":"string"},"passPremiumAmenities":{"$id":"/properties/passPremiumAmenities","description":"the ids of all premium amenities included with the pass","type":["array","null"]},"passPrice":{"$id":"/properties/passPrice","description":"pass price in minor units","type":"string"},"passState":{"$id":"/properties/passState","description":"‘draft’ -> pass is being actively edited by the host via the creation flow. The step attribute below tracks the progress of the host through the creation flow.\n‘inactive’ -> pass has been created by the host, but not ready for sale yet\n‘active’ -> pass has passed the final availability requirements and has been marked by the host as ready for sale.","enum":["ACTIVE","DRAFT","INACTIVE"],"type":"string"},"passTotalPrice":{"$id":"/properties/passTotalPrice","description":"the pass of the price plus the service fee","type":"string"},"passType":{"$id":"/properties/passType","description":"the type of pass","enum":["ALL_ACCESS","EARLY_BIRD","FIXED_HOURS","WEEKDAY"],"type":"string"}},"required":["passDiscount","passCreatedAt","listingTitle","passId","passState","passTotalPrice","passCurrent","passName","passPrice","listingURL","passCurrencyCode","listingId","hostFirstName","pageName","passIds","passDiscountType","coverImageURL","passType"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostPressedManagePassFromPasses', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostPressedManagePromoCode' track call.
 *
 * @param HostPressedManagePromoCode props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostPressedManagePromoCode(props: HostPressedManagePromoCode, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostPressedManagePromoCode","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST PROMO CODE] Host pressed to manage promo code in the host setting tabe","properties":{"enteredFrom":{"$id":"/properties/enteredFrom","description":"Where was the user before opening host promo codes?","enum":["host_settings","marketing"],"type":"string"},"listingId":{"$id":"/properties/listingId","description":"id of the listing for this promocode","type":"integer"}},"required":["enteredFrom","listingId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostPressedManagePromoCode', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostPressedMangeSpecialOffer' track call.
 *
 * @param HostPressedMangeSpecialOffer props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostPressedMangeSpecialOffer(props: HostPressedMangeSpecialOffer, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostPressedMangeSpecialOffer","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST BOOKING INQUIRY POST-SPECIAL OFFER SENT]","properties":{"bookingId":{"$id":"/properties/bookingId","description":"","type":"integer"},"bookingSpecialOfferId":{"$id":"/properties/bookingSpecialOfferId","description":"","type":"integer"},"globalListingType":{"$id":"/properties/globalListingType","description":"[LISTING TYPE] The type of the listing associated with this event","enum":["artStudio","basketballCourt","dockedBoat","home","homeGym","joyspace","kitchen","largeBackyard","musicStudio","other","pending","pickleball","pool","privateLake","roofDeck","tennisCourt"],"type":"string"},"guestId":{"$id":"/properties/guestId","description":"","type":"integer"},"hostId":{"$id":"/properties/hostId","description":"","type":"integer"},"listingId":{"$id":"/properties/listingId","description":"","type":"integer"},"originalPrice":{"$id":"/properties/originalPrice","description":"","type":"number"},"roomId":{"$id":"/properties/roomId","description":"","type":"string"},"specialOfferPrice":{"$id":"/properties/specialOfferPrice","description":"","type":"number"}},"required":["hostId","specialOfferPrice","globalListingType","bookingSpecialOfferId","originalPrice","listingId","guestId","bookingId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostPressedMangeSpecialOffer', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostPressedMessageFromReservationPage' track call.
 *
 * @param HostPressedMessageFromReservationPage props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostPressedMessageFromReservationPage(props: HostPressedMessageFromReservationPage, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostPressedMessageFromReservationPage","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST RESERVATION] host pressed to send guest a message from the reservation management page","properties":{"bookingId":{"$id":"/properties/bookingId","description":"id of the booking the reservation pertains to","type":"integer"},"bookingWithPass":{"$id":"/properties/bookingWithPass","description":"was the booking made using a pass","enum":["FALSE","PARTIAL","TRUE"],"type":"string"},"passId":{"$id":"/properties/passId","description":"if the booking was made or partially made with a pass, the pass id used","type":["integer","null"]},"passName":{"$id":"/properties/passName","description":"the type of the pass formatted to be LCM friendly\n","type":["string","null"]},"passType":{"$id":"/properties/passType","description":"if the booking was made or partially made with a pass, what type of pass","enum":["ALL_ACCESS","EARLY_BIRD","WEEKDAY",null],"type":["string","null"]},"userPassId":{"$id":"/properties/userPassId","description":"if the booking was made or partially made with a pass, what was the user pass Id used","type":["integer","null"]}},"required":["bookingId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostPressedMessageFromReservationPage', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostPressedMessagePassholder' track call.
 *
 * @param HostPressedMessagePassholder props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostPressedMessagePassholder(props: HostPressedMessagePassholder, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostPressedMessagePassholder","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST PASS MANAGEMENT - REFUND]","properties":{"canceled":{"$id":"/properties/canceled","description":"","type":"boolean"},"canceledReason":{"$id":"/properties/canceledReason","description":"","type":"string"},"coverImageURL":{"$id":"/properties/coverImageURL","description":"the url for the cover image of the listing the pass is for","type":"string"},"createdAt":{"$id":"/properties/createdAt","description":"","type":"string"},"end":{"$id":"/properties/end","description":"","type":"string"},"hasAutorenewOn":{"$id":"/properties/hasAutorenewOn","description":"","type":"boolean"},"hostFirstName":{"$id":"/properties/hostFirstName","description":"first name of the host","type":"string"},"id":{"$id":"/properties/id","description":"","type":"string"},"isLegacy":{"$id":"/properties/isLegacy","description":"true if the pass is a legacy pass","type":"boolean"},"listingId":{"$id":"/properties/listingId","description":"id of the listing the pass is for","type":"string"},"listingTitle":{"$id":"/properties/listingTitle","description":"the title of the listing the pass is for","type":"string"},"listingURL":{"$id":"/properties/listingURL","description":"the url of the listing the pass is for","type":"string"},"passAvailableTimes":{"$id":"/properties/passAvailableTimes","description":"[{from:”07:00:00”, “11:00:00”}...] Time slots when this pass is eligible","type":"array"},"passAvailableTimesText":{"$id":"/properties/passAvailableTimesText","description":"LCM formatted version of available times property","type":"string"},"passBlackoutDays":{"$id":"/properties/passBlackoutDays","description":"list of blackout dates (e.g. July 4, 2024). ","type":["array","null"]},"passCreatedAt":{"$id":"/properties/passCreatedAt","description":"when the pass was created","type":"string"},"passCurrencyCode":{"$id":"/properties/passCurrencyCode","description":"currency for all monetary fields","type":"string"},"passCurrent":{"$id":"/properties/passCurrent","description":"flag indicating that this is the current version for a pass. For a type/name/listing_id, there can only be one record with this attribute true.","type":"boolean"},"passDescription":{"$id":"/properties/passDescription","description":"free text description set by host","type":["string","null"]},"passDiscount":{"$id":"/properties/passDiscount","description":"discount amount. Fixed discounts will be in minors units.","type":["number","null"]},"passDiscountType":{"$id":"/properties/passDiscountType","description":"type of pass discount num[‘percentage’, ‘fixed’]","enum":["FIXED","PERCENTAGE",null],"type":["string","null"]},"passEligibleDays":{"$id":"/properties/passEligibleDays","description":"days the pass is eligible","type":["array","null"]},"passId":{"$id":"/properties/passId","description":"id of the pass","type":"integer"},"passMaxActivePasses":{"$id":"/properties/passMaxActivePasses","description":"max active passes allowed. This constraint will apply to the (listing_id, type, name) rather than id so that we can be accurate across edits.","type":["number","null"]},"passMaxDailyBookings":{"$id":"/properties/passMaxDailyBookings","description":"max bookings allowed under this pass","type":["number","null"]},"passMaxDuration":{"$id":"/properties/passMaxDuration","description":"max duration that may be booked using this pass","type":["number","null"]},"passMaxGuests":{"$id":"/properties/passMaxGuests","description":"max guests that may be booked using this pass","type":["number","null"]},"passName":{"$id":"/properties/passName","description":"the type of the pass formatted to be LCM friendly","pattern":"","type":"string"},"passPremiumAmenities":{"$id":"/properties/passPremiumAmenities","description":"the ids of all premium amenities included with the pass","type":["array","null"]},"passPrice":{"$id":"/properties/passPrice","description":"pass price in minor units","type":"string"},"passState":{"$id":"/properties/passState","description":"‘draft’ -> pass is being actively edited by the host via the creation flow. The step attribute below tracks the progress of the host through the creation flow.\n‘inactive’ -> pass has been created by the host, but not ready for sale yet\n‘active’ -> pass has passed the final availability requirements and has been marked by the host as ready for sale.","enum":["ACTIVE","DRAFT","INACTIVE"],"type":"string"},"passTotalPrice":{"$id":"/properties/passTotalPrice","description":"the pass of the price plus the service fee","type":"string"},"passType":{"$id":"/properties/passType","description":"the type of pass","enum":["ALL_ACCESS","EARLY_BIRD","FIXED_HOURS","WEEKDAY"],"type":"string"},"passholderStatus":{"$id":"/properties/passholderStatus","description":"the status of the pass","enum":["ACTIVE","EXPIRED"],"type":"string"},"passholderUserId":{"$id":"/properties/passholderUserId","description":"the user id of the pass holder ","type":"integer"},"start":{"$id":"/properties/start","description":"","type":"string"},"userPassId":{"$id":"/properties/userPassId","description":"","type":"integer"}},"required":["passCurrencyCode","userPassId","coverImageURL","passState","passDiscount","passType","passPrice","isLegacy","hostFirstName","listingId","end","passDiscountType","listingURL","hasAutorenewOn","listingTitle","passName","passholderUserId","passTotalPrice","passId","passCreatedAt","passCurrent","passholderStatus","start"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostPressedMessagePassholder', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostPressedNeverMindOnCreatingSendSo' track call.
 *
 * @param HostPressedNeverMindOnCreatingSendSo props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostPressedNeverMindOnCreatingSendSo(props: HostPressedNeverMindOnCreatingSendSo, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostPressedNeverMindOnCreatingSendSo","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST BOOKING INQUIRY SENDING SPECIAL OFFER]","properties":{"bookingId":{"$id":"/properties/bookingId","description":"","type":["integer","null"]},"originalPrice":{"$id":"/properties/originalPrice","description":"","type":"number"},"specialOfferPrice":{"$id":"/properties/specialOfferPrice","description":"","type":"number"}},"required":["specialOfferPrice","originalPrice"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostPressedNeverMindOnCreatingSendSo', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostPressedNeverMindOnWithdrawingSo' track call.
 *
 * @param HostPressedNeverMindOnWithdrawingSo props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostPressedNeverMindOnWithdrawingSo(props: HostPressedNeverMindOnWithdrawingSo, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostPressedNeverMindOnWithdrawingSo","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST BOOKING INQUIRY POST-SPECIAL OFFER SENT]","properties":{"bookingId":{"$id":"/properties/bookingId","description":"","type":"integer"},"bookingSpecialOfferId":{"$id":"/properties/bookingSpecialOfferId","description":"","type":"integer"},"originalPrice":{"$id":"/properties/originalPrice","description":"","type":"number"},"specialOfferPrice":{"$id":"/properties/specialOfferPrice","description":"","type":"number"}},"required":["specialOfferPrice","bookingSpecialOfferId","bookingId","originalPrice"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostPressedNeverMindOnWithdrawingSo', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostPressedNevermindCancel' track call.
 *
 * @param HostPressedNevermindCancel props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostPressedNevermindCancel(props: HostPressedNevermindCancel, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostPressedNevermindCancel","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST RESERVATION] host pressed \"nevermind\" button to exit cancel","properties":{"bookingId":{"$id":"/properties/bookingId","description":"id of the booking the reservation pertains to","type":"integer"},"bookingWithPass":{"$id":"/properties/bookingWithPass","description":"was the booking made using a pass","enum":["FALSE","PARTIAL","TRUE"],"type":"string"},"passId":{"$id":"/properties/passId","description":"if the booking was made or partially made with a pass, the pass id used","type":["integer","null"]},"passName":{"$id":"/properties/passName","description":"the type of the pass formatted to be LCM friendly\n","type":["string","null"]},"passType":{"$id":"/properties/passType","description":"if the booking was made or partially made with a pass, what type of pass","enum":["ALL_ACCESS","EARLY_BIRD","WEEKDAY",null],"type":["string","null"]},"userPassId":{"$id":"/properties/userPassId","description":"if the booking was made or partially made with a pass, what was the user pass Id used","type":["integer","null"]}},"required":["bookingId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostPressedNevermindCancel', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostPressedNevermindDeactivatePass' track call.
 *
 * @param HostPressedNevermindDeactivatePass props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostPressedNevermindDeactivatePass(props: HostPressedNevermindDeactivatePass, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostPressedNevermindDeactivatePass","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST PASS MANAGEMENT - DEACTIVATING]","properties":{"coverImageURL":{"$id":"/properties/coverImageURL","description":"the url for the cover image of the listing the pass is for","type":"string"},"hostFirstName":{"$id":"/properties/hostFirstName","description":"first name of the host","type":"string"},"id":{"$id":"/properties/id","description":"","type":"string"},"listingId":{"$id":"/properties/listingId","description":"id of the listing the pass is for","type":"string"},"listingTitle":{"$id":"/properties/listingTitle","description":"the title of the listing the pass is for","type":"string"},"listingURL":{"$id":"/properties/listingURL","description":"the url of the listing the pass is for","type":"string"},"passAvailableTimes":{"$id":"/properties/passAvailableTimes","description":"[{from:”07:00:00”, “11:00:00”}...] Time slots when this pass is eligible","type":"array"},"passAvailableTimesText":{"$id":"/properties/passAvailableTimesText","description":"LCM formatted version of available times property","type":"string"},"passBlackoutDays":{"$id":"/properties/passBlackoutDays","description":"list of blackout dates (e.g. July 4, 2024). ","type":["array","null"]},"passCreatedAt":{"$id":"/properties/passCreatedAt","description":"when the pass was created","type":"string"},"passCurrencyCode":{"$id":"/properties/passCurrencyCode","description":"currency for all monetary fields","type":"string"},"passCurrent":{"$id":"/properties/passCurrent","description":"flag indicating that this is the current version for a pass. For a type/name/listing_id, there can only be one record with this attribute true.","type":"boolean"},"passDescription":{"$id":"/properties/passDescription","description":"free text description set by host","type":["string","null"]},"passDiscount":{"$id":"/properties/passDiscount","description":"discount amount. Fixed discounts will be in minors units.","type":["number","null"]},"passDiscountType":{"$id":"/properties/passDiscountType","description":"type of pass discount num[‘percentage’, ‘fixed’]","enum":["FIXED","PERCENTAGE",null],"type":["string","null"]},"passEligibleDays":{"$id":"/properties/passEligibleDays","description":"days the pass is eligible","type":["array","null"]},"passId":{"$id":"/properties/passId","description":"id of the pass","type":"integer"},"passMaxActivePasses":{"$id":"/properties/passMaxActivePasses","description":"max active passes allowed. This constraint will apply to the (listing_id, type, name) rather than id so that we can be accurate across edits.","type":["number","null"]},"passMaxDailyBookings":{"$id":"/properties/passMaxDailyBookings","description":"max bookings allowed under this pass","type":["number","null"]},"passMaxDuration":{"$id":"/properties/passMaxDuration","description":"max duration that may be booked using this pass","type":["number","null"]},"passMaxGuests":{"$id":"/properties/passMaxGuests","description":"max guests that may be booked using this pass","type":["number","null"]},"passName":{"$id":"/properties/passName","description":"the type of the pass formatted to be LCM friendly","pattern":"","type":"string"},"passPremiumAmenities":{"$id":"/properties/passPremiumAmenities","description":"the ids of all premium amenities included with the pass","type":["array","null"]},"passPrice":{"$id":"/properties/passPrice","description":"pass price in minor units","type":"string"},"passState":{"$id":"/properties/passState","description":"‘draft’ -> pass is being actively edited by the host via the creation flow. The step attribute below tracks the progress of the host through the creation flow.\n‘inactive’ -> pass has been created by the host, but not ready for sale yet\n‘active’ -> pass has passed the final availability requirements and has been marked by the host as ready for sale.","enum":["ACTIVE","DRAFT","INACTIVE"],"type":"string"},"passTotalPrice":{"$id":"/properties/passTotalPrice","description":"the pass of the price plus the service fee","type":"string"},"passType":{"$id":"/properties/passType","description":"the type of pass","enum":["ALL_ACCESS","EARLY_BIRD","FIXED_HOURS","WEEKDAY"],"type":"string"}},"required":["hostFirstName","passTotalPrice","passDiscount","passState","passPrice","passCurrencyCode","listingURL","passName","passCurrent","listingId","listingTitle","passCreatedAt","passType","passDiscountType","passId","coverImageURL"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostPressedNevermindDeactivatePass', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostPressedNevermindDecline' track call.
 *
 * @param HostPressedNevermindDecline props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostPressedNevermindDecline(props: HostPressedNevermindDecline, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostPressedNevermindDecline","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST RESERVATION] host pressed \"nevermind\" button to exit decline","properties":{"bookingId":{"$id":"/properties/bookingId","description":"id of the booking the reservation pertains to","type":"integer"},"bookingWithPass":{"$id":"/properties/bookingWithPass","description":"was the booking made using a pass","enum":["FALSE","PARTIAL","TRUE"],"type":"string"},"passId":{"$id":"/properties/passId","description":"if the booking was made or partially made with a pass, the pass id used","type":["integer","null"]},"passName":{"$id":"/properties/passName","description":"the type of the pass formatted to be LCM friendly\n","type":["string","null"]},"passType":{"$id":"/properties/passType","description":"if the booking was made or partially made with a pass, what type of pass","enum":["ALL_ACCESS","EARLY_BIRD","WEEKDAY",null],"type":["string","null"]},"userPassId":{"$id":"/properties/userPassId","description":"if the booking was made or partially made with a pass, what was the user pass Id used","type":["integer","null"]}},"required":["bookingId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostPressedNevermindDecline', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostPressedNevermindPassholderRefund' track call.
 *
 * @param HostPressedNevermindPassholderRefund props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostPressedNevermindPassholderRefund(props: HostPressedNevermindPassholderRefund, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostPressedNevermindPassholderRefund","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST PASS MANAGEMENT - REFUND]","properties":{"canceled":{"$id":"/properties/canceled","description":"","type":"boolean"},"canceledReason":{"$id":"/properties/canceledReason","description":"","type":"string"},"coverImageURL":{"$id":"/properties/coverImageURL","description":"the url for the cover image of the listing the pass is for","type":"string"},"createdAt":{"$id":"/properties/createdAt","description":"","type":"string"},"end":{"$id":"/properties/end","description":"","type":"string"},"hasAutorenewOn":{"$id":"/properties/hasAutorenewOn","description":"","type":"boolean"},"hostFirstName":{"$id":"/properties/hostFirstName","description":"first name of the host","type":"string"},"id":{"$id":"/properties/id","description":"","type":"string"},"isLegacy":{"$id":"/properties/isLegacy","description":"true if the pass is a legacy pass","type":"boolean"},"listingId":{"$id":"/properties/listingId","description":"id of the listing the pass is for","type":"string"},"listingTitle":{"$id":"/properties/listingTitle","description":"the title of the listing the pass is for","type":"string"},"listingURL":{"$id":"/properties/listingURL","description":"the url of the listing the pass is for","type":"string"},"passAvailableTimes":{"$id":"/properties/passAvailableTimes","description":"[{from:”07:00:00”, “11:00:00”}...] Time slots when this pass is eligible","type":"array"},"passAvailableTimesText":{"$id":"/properties/passAvailableTimesText","description":"LCM formatted version of available times property","type":"string"},"passBlackoutDays":{"$id":"/properties/passBlackoutDays","description":"list of blackout dates (e.g. July 4, 2024). ","type":["array","null"]},"passCreatedAt":{"$id":"/properties/passCreatedAt","description":"when the pass was created","type":"string"},"passCurrencyCode":{"$id":"/properties/passCurrencyCode","description":"currency for all monetary fields","type":"string"},"passCurrent":{"$id":"/properties/passCurrent","description":"flag indicating that this is the current version for a pass. For a type/name/listing_id, there can only be one record with this attribute true.","type":"boolean"},"passDescription":{"$id":"/properties/passDescription","description":"free text description set by host","type":["string","null"]},"passDiscount":{"$id":"/properties/passDiscount","description":"discount amount. Fixed discounts will be in minors units.","type":["number","null"]},"passDiscountType":{"$id":"/properties/passDiscountType","description":"type of pass discount num[‘percentage’, ‘fixed’]","enum":["FIXED","PERCENTAGE",null],"type":["string","null"]},"passEligibleDays":{"$id":"/properties/passEligibleDays","description":"days the pass is eligible","type":["array","null"]},"passId":{"$id":"/properties/passId","description":"id of the pass","type":"integer"},"passMaxActivePasses":{"$id":"/properties/passMaxActivePasses","description":"max active passes allowed. This constraint will apply to the (listing_id, type, name) rather than id so that we can be accurate across edits.","type":["number","null"]},"passMaxDailyBookings":{"$id":"/properties/passMaxDailyBookings","description":"max bookings allowed under this pass","type":["number","null"]},"passMaxDuration":{"$id":"/properties/passMaxDuration","description":"max duration that may be booked using this pass","type":["number","null"]},"passMaxGuests":{"$id":"/properties/passMaxGuests","description":"max guests that may be booked using this pass","type":["number","null"]},"passName":{"$id":"/properties/passName","description":"the type of the pass formatted to be LCM friendly","pattern":"","type":"string"},"passPremiumAmenities":{"$id":"/properties/passPremiumAmenities","description":"the ids of all premium amenities included with the pass","type":["array","null"]},"passPrice":{"$id":"/properties/passPrice","description":"pass price in minor units","type":"string"},"passState":{"$id":"/properties/passState","description":"‘draft’ -> pass is being actively edited by the host via the creation flow. The step attribute below tracks the progress of the host through the creation flow.\n‘inactive’ -> pass has been created by the host, but not ready for sale yet\n‘active’ -> pass has passed the final availability requirements and has been marked by the host as ready for sale.","enum":["ACTIVE","DRAFT","INACTIVE"],"type":"string"},"passTotalPrice":{"$id":"/properties/passTotalPrice","description":"the pass of the price plus the service fee","type":"string"},"passType":{"$id":"/properties/passType","description":"the type of pass","enum":["ALL_ACCESS","EARLY_BIRD","FIXED_HOURS","WEEKDAY"],"type":"string"},"passholderStatus":{"$id":"/properties/passholderStatus","description":"the status of the pass","enum":["ACTIVE","EXPIRED"],"type":"string"},"passholderUserId":{"$id":"/properties/passholderUserId","description":"the user id of the pass holder ","type":"integer"},"start":{"$id":"/properties/start","description":"","type":"string"},"userPassId":{"$id":"/properties/userPassId","description":"","type":"integer"}},"required":["userPassId","start","passDiscount","passDiscountType","listingId","passTotalPrice","passPrice","passCreatedAt","passCurrent","passType","listingTitle","passState","hasAutorenewOn","passName","passholderUserId","coverImageURL","passId","listingURL","hostFirstName","isLegacy","passholderStatus","end","passCurrencyCode"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostPressedNevermindPassholderRefund', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostPressedNextPageTrustAndSafety' track call.
 *
 * @param HostPressedNextPageTrustAndSafety props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostPressedNextPageTrustAndSafety(props: HostPressedNextPageTrustAndSafety, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostPressedNextPageTrustAndSafety","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST T&S SWIPE] host pressed the next page button","properties":{"bookingId":{"$id":"/properties/bookingId","description":"the id of the booking","type":"integer"},"currentPageNumber":{"$id":"/properties/currentPageNumber","description":"page number of the T&S flow (1, 2, or 3)","type":"integer"}},"required":["bookingId","currentPageNumber"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostPressedNextPageTrustAndSafety', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostPressedNextPassOnboarding' track call.
 *
 * @param HostPressedNextPassOnboarding props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostPressedNextPassOnboarding(props: HostPressedNextPassOnboarding, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostPressedNextPassOnboarding","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST PASS ONBOARDING]\n","properties":{"hostPassOnboardingPageName":{"$id":"/properties/hostPassOnboardingPageName","description":"the name of the pass onboarding page the host is on","enum":["details","pass_type"],"type":"string"},"id":{"$id":"/properties/id","description":"","type":"string"}},"required":["hostPassOnboardingPageName"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostPressedNextPassOnboarding', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostPressedPassFAQ' track call.
 *
 * @param HostPressedPassFAQ props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostPressedPassFAQ(props: HostPressedPassFAQ, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostPressedPassFAQ","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST PASS ONBOARDING]","properties":{"id":{"$id":"/properties/id","description":"","type":"string"},"linkName":{"$id":"/properties/linkName","description":"name of the link clicked on","type":"string"},"linkURL":{"$id":"/properties/linkURL","description":"url to the link clicked on","type":"string"}},"required":["linkName"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostPressedPassFAQ', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostPressedPassFailedManageAvailability' track call.
 *
 * @param HostPressedPassFailedManageAvailability props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostPressedPassFailedManageAvailability(props: HostPressedPassFailedManageAvailability, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostPressedPassFailedManageAvailability","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST PASS CREATION]","properties":{"coverImageURL":{"$id":"/properties/coverImageURL","description":"the url for the cover image of the listing the pass is for","type":"string"},"failureReason":{"$id":"/properties/failureReason","description":"","type":"array"},"hostFirstName":{"$id":"/properties/hostFirstName","description":"first name of the host","type":"string"},"id":{"$id":"/properties/id","description":"","type":"string"},"listingId":{"$id":"/properties/listingId","description":"id of the listing the pass is for","type":"string"},"listingTitle":{"$id":"/properties/listingTitle","description":"the title of the listing the pass is for","type":"string"},"listingURL":{"$id":"/properties/listingURL","description":"the url of the listing the pass is for","type":"string"},"passAvailableTimes":{"$id":"/properties/passAvailableTimes","description":"[{from:”07:00:00”, “11:00:00”}...] Time slots when this pass is eligible","type":"array"},"passAvailableTimesText":{"$id":"/properties/passAvailableTimesText","description":"LCM formatted version of available times property","type":"string"},"passBlackoutDays":{"$id":"/properties/passBlackoutDays","description":"list of blackout dates (e.g. July 4, 2024). ","type":["array","null"]},"passCreatedAt":{"$id":"/properties/passCreatedAt","description":"when the pass was created","type":"string"},"passCurrencyCode":{"$id":"/properties/passCurrencyCode","description":"currency for all monetary fields","type":"string"},"passCurrent":{"$id":"/properties/passCurrent","description":"flag indicating that this is the current version for a pass. For a type/name/listing_id, there can only be one record with this attribute true.","type":"boolean"},"passDescription":{"$id":"/properties/passDescription","description":"free text description set by host","type":["string","null"]},"passDiscount":{"$id":"/properties/passDiscount","description":"discount amount. Fixed discounts will be in minors units.","type":["number","null"]},"passDiscountType":{"$id":"/properties/passDiscountType","description":"type of pass discount num[‘percentage’, ‘fixed’]","enum":["FIXED","PERCENTAGE",null],"type":["string","null"]},"passEligibleDays":{"$id":"/properties/passEligibleDays","description":"days the pass is eligible","type":["array","null"]},"passId":{"$id":"/properties/passId","description":"id of the pass","type":"integer"},"passMaxActivePasses":{"$id":"/properties/passMaxActivePasses","description":"max active passes allowed. This constraint will apply to the (listing_id, type, name) rather than id so that we can be accurate across edits.","type":["number","null"]},"passMaxDailyBookings":{"$id":"/properties/passMaxDailyBookings","description":"max bookings allowed under this pass","type":["number","null"]},"passMaxDuration":{"$id":"/properties/passMaxDuration","description":"max duration that may be booked using this pass","type":["number","null"]},"passMaxGuests":{"$id":"/properties/passMaxGuests","description":"max guests that may be booked using this pass","type":["number","null"]},"passName":{"$id":"/properties/passName","description":"the type of the pass formatted to be LCM friendly","pattern":"","type":"string"},"passPremiumAmenities":{"$id":"/properties/passPremiumAmenities","description":"the ids of all premium amenities included with the pass","type":["array","null"]},"passPrice":{"$id":"/properties/passPrice","description":"pass price in minor units","type":"string"},"passState":{"$id":"/properties/passState","description":"‘draft’ -> pass is being actively edited by the host via the creation flow. The step attribute below tracks the progress of the host through the creation flow.\n‘inactive’ -> pass has been created by the host, but not ready for sale yet\n‘active’ -> pass has passed the final availability requirements and has been marked by the host as ready for sale.","enum":["ACTIVE","DRAFT","INACTIVE"],"type":"string"},"passTotalPrice":{"$id":"/properties/passTotalPrice","description":"the pass of the price plus the service fee","type":"string"},"passType":{"$id":"/properties/passType","description":"the type of pass","enum":["ALL_ACCESS","EARLY_BIRD","FIXED_HOURS","WEEKDAY"],"type":"string"}},"required":["passName","listingId","passPrice","passDiscountType","passState","passTotalPrice","passDiscount","coverImageURL","passCurrent","hostFirstName","passCreatedAt","listingTitle","passType","listingURL","passId","passCurrencyCode","failureReason"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostPressedPassFailedManageAvailability', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostPressedPassGetHelp' track call.
 *
 * @param HostPressedPassGetHelp props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostPressedPassGetHelp(props: HostPressedPassGetHelp, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostPressedPassGetHelp","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST PASS ONBOARDING]","properties":{"id":{"$id":"/properties/id","description":"","type":"string"}},"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostPressedPassGetHelp', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostPressedPassholder' track call.
 *
 * @param HostPressedPassholder props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostPressedPassholder(props: HostPressedPassholder, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostPressedPassholder","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST PASS MANAGEMENT - REFUND]","properties":{"canceled":{"$id":"/properties/canceled","description":"","type":"boolean"},"canceledReason":{"$id":"/properties/canceledReason","description":"","type":"string"},"coverImageURL":{"$id":"/properties/coverImageURL","description":"the url for the cover image of the listing the pass is for","type":"string"},"createdAt":{"$id":"/properties/createdAt","description":"","type":"string"},"end":{"$id":"/properties/end","description":"","type":"string"},"hasAutorenewOn":{"$id":"/properties/hasAutorenewOn","description":"","type":"boolean"},"hostFirstName":{"$id":"/properties/hostFirstName","description":"first name of the host","type":"string"},"id":{"$id":"/properties/id","description":"","type":"string"},"isLegacy":{"$id":"/properties/isLegacy","description":"true if the pass is a legacy pass","type":"boolean"},"listingId":{"$id":"/properties/listingId","description":"id of the listing the pass is for","type":"string"},"listingTitle":{"$id":"/properties/listingTitle","description":"the title of the listing the pass is for","type":"string"},"listingURL":{"$id":"/properties/listingURL","description":"the url of the listing the pass is for","type":"string"},"passAvailableTimes":{"$id":"/properties/passAvailableTimes","description":"[{from:”07:00:00”, “11:00:00”}...] Time slots when this pass is eligible","type":"array"},"passAvailableTimesText":{"$id":"/properties/passAvailableTimesText","description":"LCM formatted version of available times property","type":"string"},"passBlackoutDays":{"$id":"/properties/passBlackoutDays","description":"list of blackout dates (e.g. July 4, 2024). ","type":["array","null"]},"passCreatedAt":{"$id":"/properties/passCreatedAt","description":"when the pass was created","type":"string"},"passCurrencyCode":{"$id":"/properties/passCurrencyCode","description":"currency for all monetary fields","type":"string"},"passCurrent":{"$id":"/properties/passCurrent","description":"flag indicating that this is the current version for a pass. For a type/name/listing_id, there can only be one record with this attribute true.","type":"boolean"},"passDescription":{"$id":"/properties/passDescription","description":"free text description set by host","type":["string","null"]},"passDiscount":{"$id":"/properties/passDiscount","description":"discount amount. Fixed discounts will be in minors units.","type":["number","null"]},"passDiscountType":{"$id":"/properties/passDiscountType","description":"type of pass discount num[‘percentage’, ‘fixed’]","enum":["FIXED","PERCENTAGE",null],"type":["string","null"]},"passEligibleDays":{"$id":"/properties/passEligibleDays","description":"days the pass is eligible","type":["array","null"]},"passId":{"$id":"/properties/passId","description":"id of the pass","type":"integer"},"passMaxActivePasses":{"$id":"/properties/passMaxActivePasses","description":"max active passes allowed. This constraint will apply to the (listing_id, type, name) rather than id so that we can be accurate across edits.","type":["number","null"]},"passMaxDailyBookings":{"$id":"/properties/passMaxDailyBookings","description":"max bookings allowed under this pass","type":["number","null"]},"passMaxDuration":{"$id":"/properties/passMaxDuration","description":"max duration that may be booked using this pass","type":["number","null"]},"passMaxGuests":{"$id":"/properties/passMaxGuests","description":"max guests that may be booked using this pass","type":["number","null"]},"passName":{"$id":"/properties/passName","description":"the type of the pass formatted to be LCM friendly","pattern":"","type":"string"},"passPremiumAmenities":{"$id":"/properties/passPremiumAmenities","description":"the ids of all premium amenities included with the pass","type":["array","null"]},"passPrice":{"$id":"/properties/passPrice","description":"pass price in minor units","type":"string"},"passState":{"$id":"/properties/passState","description":"‘draft’ -> pass is being actively edited by the host via the creation flow. The step attribute below tracks the progress of the host through the creation flow.\n‘inactive’ -> pass has been created by the host, but not ready for sale yet\n‘active’ -> pass has passed the final availability requirements and has been marked by the host as ready for sale.","enum":["ACTIVE","DRAFT","INACTIVE"],"type":"string"},"passTotalPrice":{"$id":"/properties/passTotalPrice","description":"the pass of the price plus the service fee","type":"string"},"passType":{"$id":"/properties/passType","description":"the type of pass","enum":["ALL_ACCESS","EARLY_BIRD","FIXED_HOURS","WEEKDAY"],"type":"string"},"passholderStatus":{"$id":"/properties/passholderStatus","description":"the status of the pass","enum":["ACTIVE","EXPIRED"],"type":"string"},"passholderUserId":{"$id":"/properties/passholderUserId","description":"the user id of the pass holder ","type":"integer"},"start":{"$id":"/properties/start","description":"","type":"string"},"userPassId":{"$id":"/properties/userPassId","description":"","type":"integer"}},"required":["passName","passDiscountType","listingURL","passCurrent","passState","coverImageURL","passTotalPrice","passId","passCreatedAt","passType","passholderUserId","passholderStatus","start","hostFirstName","passCurrencyCode","hasAutorenewOn","userPassId","end","listingTitle","isLegacy","passDiscount","listingId","passPrice"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostPressedPassholder', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostPressedReadGuideButton' track call.
 *
 * @param HostPressedReadGuideButton props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostPressedReadGuideButton(props: HostPressedReadGuideButton, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostPressedReadGuideButton","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST T&S SWIPE] host pressed the read guide button on the reservation page","properties":{"bookingId":{"$id":"/properties/bookingId","description":"the id of the booking","type":"integer"}},"required":["bookingId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostPressedReadGuideButton', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostPressedRefreshCalendar' track call.
 *
 * @param HostPressedRefreshCalendar props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostPressedRefreshCalendar(props: HostPressedRefreshCalendar, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostPressedRefreshCalendar","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST CALENDAR SYNCING] after having imported external iCalendars, fires when the host presses refresh one of them ","properties":{"calendarName":{"$id":"/properties/calendarName","description":"","type":"string"},"listingId":{"$id":"/properties/listingId","description":"","type":"integer"}},"required":["listingId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostPressedRefreshCalendar', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostPressedRefundPassholder' track call.
 *
 * @param HostPressedRefundPassholder props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostPressedRefundPassholder(props: HostPressedRefundPassholder, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostPressedRefundPassholder","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST PASS MANAGEMENT - REFUND]","properties":{"canceled":{"$id":"/properties/canceled","description":"","type":"boolean"},"canceledReason":{"$id":"/properties/canceledReason","description":"","type":"string"},"coverImageURL":{"$id":"/properties/coverImageURL","description":"the url for the cover image of the listing the pass is for","type":"string"},"createdAt":{"$id":"/properties/createdAt","description":"","type":"string"},"end":{"$id":"/properties/end","description":"","type":"string"},"hasAutorenewOn":{"$id":"/properties/hasAutorenewOn","description":"","type":"boolean"},"hostFirstName":{"$id":"/properties/hostFirstName","description":"first name of the host","type":"string"},"id":{"$id":"/properties/id","description":"","type":"string"},"isLegacy":{"$id":"/properties/isLegacy","description":"true if the pass is a legacy pass","type":"boolean"},"listingId":{"$id":"/properties/listingId","description":"id of the listing the pass is for","type":"string"},"listingTitle":{"$id":"/properties/listingTitle","description":"the title of the listing the pass is for","type":"string"},"listingURL":{"$id":"/properties/listingURL","description":"the url of the listing the pass is for","type":"string"},"passAvailableTimes":{"$id":"/properties/passAvailableTimes","description":"[{from:”07:00:00”, “11:00:00”}...] Time slots when this pass is eligible","type":"array"},"passAvailableTimesText":{"$id":"/properties/passAvailableTimesText","description":"LCM formatted version of available times property","type":"string"},"passBlackoutDays":{"$id":"/properties/passBlackoutDays","description":"list of blackout dates (e.g. July 4, 2024). ","type":["array","null"]},"passCreatedAt":{"$id":"/properties/passCreatedAt","description":"when the pass was created","type":"string"},"passCurrencyCode":{"$id":"/properties/passCurrencyCode","description":"currency for all monetary fields","type":"string"},"passCurrent":{"$id":"/properties/passCurrent","description":"flag indicating that this is the current version for a pass. For a type/name/listing_id, there can only be one record with this attribute true.","type":"boolean"},"passDescription":{"$id":"/properties/passDescription","description":"free text description set by host","type":["string","null"]},"passDiscount":{"$id":"/properties/passDiscount","description":"discount amount. Fixed discounts will be in minors units.","type":["number","null"]},"passDiscountType":{"$id":"/properties/passDiscountType","description":"type of pass discount num[‘percentage’, ‘fixed’]","enum":["FIXED","PERCENTAGE",null],"type":["string","null"]},"passEligibleDays":{"$id":"/properties/passEligibleDays","description":"days the pass is eligible","type":["array","null"]},"passId":{"$id":"/properties/passId","description":"id of the pass","type":"integer"},"passMaxActivePasses":{"$id":"/properties/passMaxActivePasses","description":"max active passes allowed. This constraint will apply to the (listing_id, type, name) rather than id so that we can be accurate across edits.","type":["number","null"]},"passMaxDailyBookings":{"$id":"/properties/passMaxDailyBookings","description":"max bookings allowed under this pass","type":["number","null"]},"passMaxDuration":{"$id":"/properties/passMaxDuration","description":"max duration that may be booked using this pass","type":["number","null"]},"passMaxGuests":{"$id":"/properties/passMaxGuests","description":"max guests that may be booked using this pass","type":["number","null"]},"passName":{"$id":"/properties/passName","description":"the type of the pass formatted to be LCM friendly","pattern":"","type":"string"},"passPremiumAmenities":{"$id":"/properties/passPremiumAmenities","description":"the ids of all premium amenities included with the pass","type":["array","null"]},"passPrice":{"$id":"/properties/passPrice","description":"pass price in minor units","type":"string"},"passState":{"$id":"/properties/passState","description":"‘draft’ -> pass is being actively edited by the host via the creation flow. The step attribute below tracks the progress of the host through the creation flow.\n‘inactive’ -> pass has been created by the host, but not ready for sale yet\n‘active’ -> pass has passed the final availability requirements and has been marked by the host as ready for sale.","enum":["ACTIVE","DRAFT","INACTIVE"],"type":"string"},"passTotalPrice":{"$id":"/properties/passTotalPrice","description":"the pass of the price plus the service fee","type":"string"},"passType":{"$id":"/properties/passType","description":"the type of pass","enum":["ALL_ACCESS","EARLY_BIRD","FIXED_HOURS","WEEKDAY"],"type":"string"},"passholderStatus":{"$id":"/properties/passholderStatus","description":"the status of the pass","enum":["ACTIVE","EXPIRED"],"type":"string"},"passholderUserId":{"$id":"/properties/passholderUserId","description":"the user id of the pass holder ","type":"integer"},"start":{"$id":"/properties/start","description":"","type":"string"},"userPassId":{"$id":"/properties/userPassId","description":"","type":"integer"}},"required":["passId","passCurrencyCode","passType","passPrice","listingTitle","passName","listingURL","passCreatedAt","end","passTotalPrice","passCurrent","passState","start","listingId","passholderStatus","passDiscount","hostFirstName","hasAutorenewOn","passDiscountType","userPassId","isLegacy","passholderUserId","coverImageURL"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostPressedRefundPassholder', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostPressedRemoveSecurityDeposit' track call.
 *
 * @param HostPressedRemoveSecurityDeposit props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostPressedRemoveSecurityDeposit(props: HostPressedRemoveSecurityDeposit, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostPressedRemoveSecurityDeposit","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST SETTINGS - SECURITY DEPOSIT] ","properties":{"depositAmount":{"$id":"/properties/depositAmount","description":"the size of the deposit required","enum":["100","1000","250","500",null],"type":["string","null"]},"guestMin":{"$id":"/properties/guestMin","description":"min guest count to charge a security deposit","type":["number","null"]},"listingId":{"$id":"/properties/listingId","description":"","type":"integer"}},"required":["listingId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostPressedRemoveSecurityDeposit', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostPressedRescheduleFromCancelFlow' track call.
 *
 * @param HostPressedRescheduleFromCancelFlow props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostPressedRescheduleFromCancelFlow(props: HostPressedRescheduleFromCancelFlow, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostPressedRescheduleFromCancelFlow","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST RESERVATION] host pressed \"reschedule instead\" from the cancellation flow","properties":{"bookingId":{"$id":"/properties/bookingId","description":"id of the booking the reservation pertains to","type":"integer"},"bookingWithPass":{"$id":"/properties/bookingWithPass","description":"was the booking made using a pass","enum":["FALSE","PARTIAL","TRUE"],"type":"string"},"passId":{"$id":"/properties/passId","description":"if the booking was made or partially made with a pass, the pass id used","type":["integer","null"]},"passName":{"$id":"/properties/passName","description":"the type of the pass formatted to be LCM friendly\n","type":["string","null"]},"passType":{"$id":"/properties/passType","description":"if the booking was made or partially made with a pass, what type of pass","enum":["ALL_ACCESS","EARLY_BIRD","WEEKDAY",null],"type":["string","null"]},"userPassId":{"$id":"/properties/userPassId","description":"if the booking was made or partially made with a pass, what was the user pass Id used","type":["integer","null"]}},"required":["bookingId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostPressedRescheduleFromCancelFlow', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostPressedRescheduleFromReservationPage' track call.
 *
 * @param HostPressedRescheduleFromReservationPage props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostPressedRescheduleFromReservationPage(props: HostPressedRescheduleFromReservationPage, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostPressedRescheduleFromReservationPage","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST RESERVATION] host pressed to initiate reschedule from reservation page","properties":{"bookingId":{"$id":"/properties/bookingId","description":"id of the booking the reservation pertains to","type":"integer"},"bookingWithPass":{"$id":"/properties/bookingWithPass","description":"was the booking made using a pass","enum":["FALSE","PARTIAL","TRUE"],"type":"string"},"passId":{"$id":"/properties/passId","description":"if the booking was made or partially made with a pass, the pass id used","type":["integer","null"]},"passName":{"$id":"/properties/passName","description":"the type of the pass formatted to be LCM friendly\n","type":["string","null"]},"passType":{"$id":"/properties/passType","description":"if the booking was made or partially made with a pass, what type of pass","enum":["ALL_ACCESS","EARLY_BIRD","WEEKDAY",null],"type":["string","null"]},"userPassId":{"$id":"/properties/userPassId","description":"if the booking was made or partially made with a pass, what was the user pass Id used","type":["integer","null"]}},"required":["bookingId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostPressedRescheduleFromReservationPage', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostPressedReturnToChatFomManageSo' track call.
 *
 * @param HostPressedReturnToChatFomManageSo props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostPressedReturnToChatFomManageSo(props: HostPressedReturnToChatFomManageSo, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostPressedReturnToChatFomManageSo","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST BOOKING INQUIRY POST-SPECIAL OFFER SENT]","properties":{"bookingId":{"$id":"/properties/bookingId","description":"","type":"integer"},"bookingSpecialOfferId":{"$id":"/properties/bookingSpecialOfferId","description":"","type":"integer"},"originalPrice":{"$id":"/properties/originalPrice","description":"","type":"number"},"specialOfferPrice":{"$id":"/properties/specialOfferPrice","description":"","type":"number"}},"required":["bookingSpecialOfferId","bookingId","originalPrice","specialOfferPrice"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostPressedReturnToChatFomManageSo', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostPressedReviewBookingInquiry' track call.
 *
 * @param HostPressedReviewBookingInquiry props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostPressedReviewBookingInquiry(props: HostPressedReviewBookingInquiry, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostPressedReviewBookingInquiry","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST BOOKING INQUIRY RESPONSE]","properties":{"bookingId":{"$id":"/properties/bookingId","description":"","type":"integer"},"messageSentId":{"$id":"/properties/messageSentId","description":"id of the booking inquiry message sent","type":"integer"}},"required":["messageSentId","bookingId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostPressedReviewBookingInquiry', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostPressedSaveChangeAmenities' track call.
 *
 * @param HostPressedSaveChangeAmenities props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostPressedSaveChangeAmenities(props: HostPressedSaveChangeAmenities, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostPressedSaveChangeAmenities","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST RESERVATION] host pressed to change amenities","properties":{"bookingId":{"$id":"/properties/bookingId","description":"id of the booking","type":"string"},"bookingWithPass":{"$id":"/properties/bookingWithPass","description":"was the booking made using a pass","enum":["FALSE","PARTIAL","TRUE"],"type":"string"},"passId":{"$id":"/properties/passId","description":"if the booking was made or partially made with a pass, the pass id used","type":["integer","null"]},"passName":{"$id":"/properties/passName","description":"the type of the pass formatted to be LCM friendly\n","type":["string","null"]},"passType":{"$id":"/properties/passType","description":"if the booking was made or partially made with a pass, what type of pass","enum":["ALL_ACCESS","EARLY_BIRD","WEEKDAY",null],"type":["string","null"]},"selectedAmenitites":{"$id":"/properties/selectedAmenitites","description":"selected amenities the guest wants to add","items":{"$id":"/properties/properties/properties/selectedAmenitites/items","description":"","properties":{"amenityDescription":{"$id":"/properties/properties/properties/selectedAmenitites/items/properties/amenityDescription","description":"description of the amenity\n","type":"string"},"amenityFeeDetails":{"$id":"/properties/properties/properties/selectedAmenitites/items/properties/amenityFeeDetails","description":"","properties":{"feeAmount":{"$id":"/properties/properties/properties/selectedAmenitites/items/properties/amenityFeeDetails/properties/feeAmount","description":"fee of amenity\n","type":"number"},"isFlatFee":{"$id":"/properties/properties/properties/selectedAmenitites/items/properties/amenityFeeDetails/properties/isFlatFee","description":"does this amenity have a flat fee, 1 is flat fee, 0 is hourly fee","type":"boolean"}},"required":["feeAmount","isFlatFee"],"type":"object"},"amenityName":{"$id":"/properties/properties/properties/selectedAmenitites/items/properties/amenityName","description":"name of amenity\n","type":"string"},"isCustomAmenity":{"$id":"/properties/properties/properties/selectedAmenitites/items/properties/isCustomAmenity","description":"is this a custom amenity from the host\n","type":"boolean"},"isFee":{"$id":"/properties/properties/properties/selectedAmenitites/items/properties/isFee","description":"does this amenity have a fee\n","type":"boolean"},"isPreSelected":{"$id":"/properties/properties/properties/selectedAmenitites/items/properties/isPreSelected","description":"is this amenity pre selected\n","type":"boolean"}},"required":["amenityDescription","amenityFeeDetails","amenityName","isCustomAmenity","isFee","isPreSelected"],"type":"object"},"type":"array"},"userPassId":{"$id":"/properties/userPassId","description":"if the booking was made or partially made with a pass, what was the user pass Id used","type":["integer","null"]}},"required":["selectedAmenitites","bookingId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostPressedSaveChangeAmenities', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostPressedSaveChangeDateTime' track call.
 *
 * @param HostPressedSaveChangeDateTime props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostPressedSaveChangeDateTime(props: HostPressedSaveChangeDateTime, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostPressedSaveChangeDateTime","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST RESERVATION] host pressed save for the changes in booking date time","properties":{"bookingId":{"$id":"/properties/bookingId","description":"id of the booking","type":"string"},"bookingWithPass":{"$id":"/properties/bookingWithPass","description":"was the booking made using a pass","enum":["FALSE","PARTIAL","TRUE"],"type":"string"},"newDate":{"$id":"/properties/newDate","description":"the new date of the booking changed by guest","type":"string"},"newEndTime":{"$id":"/properties/newEndTime","description":"the new end time of the booking changed by guest","type":"number"},"newStartTime":{"$id":"/properties/newStartTime","description":"the new start time of the booking changed by guest","type":"number"},"orginalDate":{"$id":"/properties/orginalDate","description":"the original date of the booking","type":"string"},"originalEndTime":{"$id":"/properties/originalEndTime","description":"the original end time of the booking","type":"number"},"originalStartTime":{"$id":"/properties/originalStartTime","description":"the original start time of the booking","type":"number"},"passId":{"$id":"/properties/passId","description":"if the booking was made or partially made with a pass, the pass id used","type":["integer","null"]},"passName":{"$id":"/properties/passName","description":"the type of the pass formatted to be LCM friendly\n","type":["string","null"]},"passType":{"$id":"/properties/passType","description":"if the booking was made or partially made with a pass, what type of pass","enum":["ALL_ACCESS","EARLY_BIRD","WEEKDAY",null],"type":["string","null"]},"userPassId":{"$id":"/properties/userPassId","description":"if the booking was made or partially made with a pass, what was the user pass Id used","type":["integer","null"]}},"required":["newDate","newEndTime","newStartTime","orginalDate","originalEndTime","originalStartTime","bookingId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostPressedSaveChangeDateTime', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostPressedSaveChangeGuest' track call.
 *
 * @param HostPressedSaveChangeGuest props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostPressedSaveChangeGuest(props: HostPressedSaveChangeGuest, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostPressedSaveChangeGuest","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST RESERVATION] host pressed to save changes of guest in reservation","properties":{"bookingId":{"$id":"/properties/bookingId","description":"id of the booking","type":"string"},"bookingWithPass":{"$id":"/properties/bookingWithPass","description":"was the booking made using a pass","enum":["FALSE","PARTIAL","TRUE"],"type":"string"},"newAdultGuest":{"$id":"/properties/newAdultGuest","description":"new number of adult guest","type":"integer"},"newChildrenGuest":{"$id":"/properties/newChildrenGuest","description":"new number of children guest","type":"integer"},"newInfantGuest":{"$id":"/properties/newInfantGuest","description":"new number of infant guest","type":"integer"},"newPetGuest":{"$id":"/properties/newPetGuest","description":"new number of pet guest","type":"integer"},"originalAdultGuest":{"$id":"/properties/originalAdultGuest","description":"original number of adult guest","type":"integer"},"originalChildrenGuest":{"$id":"/properties/originalChildrenGuest","description":"original number of children guest","type":"integer"},"originalInfantGuest":{"$id":"/properties/originalInfantGuest","description":"original number of infant guest","type":"integer"},"originalPetGuest":{"$id":"/properties/originalPetGuest","description":"original number of pet guest","type":"integer"},"passId":{"$id":"/properties/passId","description":"if the booking was made or partially made with a pass, the pass id used","type":["integer","null"]},"passName":{"$id":"/properties/passName","description":"the type of the pass formatted to be LCM friendly\n","type":["string","null"]},"passType":{"$id":"/properties/passType","description":"if the booking was made or partially made with a pass, what type of pass","enum":["ALL_ACCESS","EARLY_BIRD","WEEKDAY",null],"type":["string","null"]},"userPassId":{"$id":"/properties/userPassId","description":"if the booking was made or partially made with a pass, what was the user pass Id used","type":["integer","null"]}},"required":["originalInfantGuest","bookingId","newAdultGuest","originalChildrenGuest","newPetGuest","newChildrenGuest","newInfantGuest","originalPetGuest","originalAdultGuest"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostPressedSaveChangeGuest', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostPressedSavePassAndActivateLater' track call.
 *
 * @param HostPressedSavePassAndActivateLater props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostPressedSavePassAndActivateLater(props: HostPressedSavePassAndActivateLater, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostPressedSavePassAndActivateLater","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST PASS CREATION]","properties":{"coverImageURL":{"$id":"/properties/coverImageURL","description":"the url for the cover image of the listing the pass is for","type":"string"},"hostFirstName":{"$id":"/properties/hostFirstName","description":"first name of the host","type":"string"},"id":{"$id":"/properties/id","description":"","type":"string"},"listingId":{"$id":"/properties/listingId","description":"id of the listing the pass is for","type":"string"},"listingTitle":{"$id":"/properties/listingTitle","description":"the title of the listing the pass is for","type":"string"},"listingURL":{"$id":"/properties/listingURL","description":"the url of the listing the pass is for","type":"string"},"passAvailableTimes":{"$id":"/properties/passAvailableTimes","description":"[{from:”07:00:00”, “11:00:00”}...] Time slots when this pass is eligible","type":"array"},"passAvailableTimesText":{"$id":"/properties/passAvailableTimesText","description":"LCM formatted version of available times property","type":"string"},"passBlackoutDays":{"$id":"/properties/passBlackoutDays","description":"list of blackout dates (e.g. July 4, 2024). ","type":["array","null"]},"passCreatedAt":{"$id":"/properties/passCreatedAt","description":"when the pass was created","type":"string"},"passCurrencyCode":{"$id":"/properties/passCurrencyCode","description":"currency for all monetary fields","type":"string"},"passCurrent":{"$id":"/properties/passCurrent","description":"flag indicating that this is the current version for a pass. For a type/name/listing_id, there can only be one record with this attribute true.","type":"boolean"},"passDescription":{"$id":"/properties/passDescription","description":"free text description set by host","type":["string","null"]},"passDiscount":{"$id":"/properties/passDiscount","description":"discount amount. Fixed discounts will be in minors units.","type":["number","null"]},"passDiscountType":{"$id":"/properties/passDiscountType","description":"type of pass discount num[‘percentage’, ‘fixed’]","enum":["FIXED","PERCENTAGE",null],"type":["string","null"]},"passEligibleDays":{"$id":"/properties/passEligibleDays","description":"days the pass is eligible","type":["array","null"]},"passId":{"$id":"/properties/passId","description":"id of the pass","type":"integer"},"passMaxActivePasses":{"$id":"/properties/passMaxActivePasses","description":"max active passes allowed. This constraint will apply to the (listing_id, type, name) rather than id so that we can be accurate across edits.","type":["number","null"]},"passMaxDailyBookings":{"$id":"/properties/passMaxDailyBookings","description":"max bookings allowed under this pass","type":["number","null"]},"passMaxDuration":{"$id":"/properties/passMaxDuration","description":"max duration that may be booked using this pass","type":["number","null"]},"passMaxGuests":{"$id":"/properties/passMaxGuests","description":"max guests that may be booked using this pass","type":["number","null"]},"passName":{"$id":"/properties/passName","description":"the type of the pass formatted to be LCM friendly","pattern":"","type":"string"},"passPremiumAmenities":{"$id":"/properties/passPremiumAmenities","description":"the ids of all premium amenities included with the pass","type":["array","null"]},"passPrice":{"$id":"/properties/passPrice","description":"pass price in minor units","type":"string"},"passState":{"$id":"/properties/passState","description":"‘draft’ -> pass is being actively edited by the host via the creation flow. The step attribute below tracks the progress of the host through the creation flow.\n‘inactive’ -> pass has been created by the host, but not ready for sale yet\n‘active’ -> pass has passed the final availability requirements and has been marked by the host as ready for sale.","enum":["ACTIVE","DRAFT","INACTIVE"],"type":"string"},"passTotalPrice":{"$id":"/properties/passTotalPrice","description":"the pass of the price plus the service fee","type":"string"},"passType":{"$id":"/properties/passType","description":"the type of pass","enum":["ALL_ACCESS","EARLY_BIRD","FIXED_HOURS","WEEKDAY"],"type":"string"}},"required":["passName","passId","coverImageURL","listingTitle","listingURL","passCurrencyCode","passCreatedAt","passDiscountType","hostFirstName","passCurrent","passPrice","passDiscount","passState","passType","passTotalPrice","listingId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostPressedSavePassAndActivateLater', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostPressedSavePassChanges' track call.
 *
 * @param HostPressedSavePassChanges props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostPressedSavePassChanges(props: HostPressedSavePassChanges, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostPressedSavePassChanges","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST PASS MANAGEMENT - UPDATING]","properties":{"coverImageURL":{"$id":"/properties/coverImageURL","description":"the url for the cover image of the listing the pass is for","type":"string"},"hostFirstName":{"$id":"/properties/hostFirstName","description":"first name of the host","type":"string"},"id":{"$id":"/properties/id","description":"","type":"string"},"listingId":{"$id":"/properties/listingId","description":"id of the listing the pass is for","type":"string"},"listingTitle":{"$id":"/properties/listingTitle","description":"the title of the listing the pass is for","type":"string"},"listingURL":{"$id":"/properties/listingURL","description":"the url of the listing the pass is for","type":"string"},"passAvailableTimes":{"$id":"/properties/passAvailableTimes","description":"[{from:”07:00:00”, “11:00:00”}...] Time slots when this pass is eligible","type":"array"},"passAvailableTimesText":{"$id":"/properties/passAvailableTimesText","description":"LCM formatted version of available times property","type":"string"},"passBlackoutDays":{"$id":"/properties/passBlackoutDays","description":"list of blackout dates (e.g. July 4, 2024). ","type":["array","null"]},"passCreatedAt":{"$id":"/properties/passCreatedAt","description":"when the pass was created","type":"string"},"passCurrencyCode":{"$id":"/properties/passCurrencyCode","description":"currency for all monetary fields","type":"string"},"passCurrent":{"$id":"/properties/passCurrent","description":"flag indicating that this is the current version for a pass. For a type/name/listing_id, there can only be one record with this attribute true.","type":"boolean"},"passDescription":{"$id":"/properties/passDescription","description":"free text description set by host","type":["string","null"]},"passDiscount":{"$id":"/properties/passDiscount","description":"discount amount. Fixed discounts will be in minors units.","type":["number","null"]},"passDiscountType":{"$id":"/properties/passDiscountType","description":"type of pass discount num[‘percentage’, ‘fixed’]","enum":["FIXED","PERCENTAGE",null],"type":["string","null"]},"passEligibleDays":{"$id":"/properties/passEligibleDays","description":"days the pass is eligible","type":["array","null"]},"passId":{"$id":"/properties/passId","description":"id of the pass","type":"integer"},"passMaxActivePasses":{"$id":"/properties/passMaxActivePasses","description":"max active passes allowed. This constraint will apply to the (listing_id, type, name) rather than id so that we can be accurate across edits.","type":["number","null"]},"passMaxDailyBookings":{"$id":"/properties/passMaxDailyBookings","description":"max bookings allowed under this pass","type":["number","null"]},"passMaxDuration":{"$id":"/properties/passMaxDuration","description":"max duration that may be booked using this pass","type":["number","null"]},"passMaxGuests":{"$id":"/properties/passMaxGuests","description":"max guests that may be booked using this pass","type":["number","null"]},"passName":{"$id":"/properties/passName","description":"the type of the pass formatted to be LCM friendly","pattern":"","type":"string"},"passPremiumAmenities":{"$id":"/properties/passPremiumAmenities","description":"the ids of all premium amenities included with the pass","type":["array","null"]},"passPrice":{"$id":"/properties/passPrice","description":"pass price in minor units","type":"string"},"passState":{"$id":"/properties/passState","description":"‘draft’ -> pass is being actively edited by the host via the creation flow. The step attribute below tracks the progress of the host through the creation flow.\n‘inactive’ -> pass has been created by the host, but not ready for sale yet\n‘active’ -> pass has passed the final availability requirements and has been marked by the host as ready for sale.","enum":["ACTIVE","DRAFT","INACTIVE"],"type":"string"},"passTotalPrice":{"$id":"/properties/passTotalPrice","description":"the pass of the price plus the service fee","type":"string"},"passType":{"$id":"/properties/passType","description":"the type of pass","enum":["ALL_ACCESS","EARLY_BIRD","FIXED_HOURS","WEEKDAY"],"type":"string"}},"required":["passId","passCurrencyCode","passDiscountType","passCurrent","listingId","listingTitle","passDiscount","coverImageURL","passCreatedAt","passType","passTotalPrice","passName","passPrice","hostFirstName","listingURL","passState"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostPressedSavePassChanges', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostPressedSavePromoCode' track call.
 *
 * @param HostPressedSavePromoCode props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostPressedSavePromoCode(props: HostPressedSavePromoCode, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostPressedSavePromoCode","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST PROMO CODE] When host pressed the save code button to create promo code","properties":{"amountOff":{"$id":"/properties/amountOff","description":"percent amount off of this promo code (1-100) ","type":"number"},"expireDate":{"$id":"/properties/expireDate","description":"expiration date of this promo code ","type":"string"},"listingId":{"$id":"/properties/listingId","description":"id of the listing for this promocode","type":"string"},"maxRedemption":{"$id":"/properties/maxRedemption","description":"the maximum time of redemption of this promo code","type":"integer"},"promoCodeName":{"$id":"/properties/promoCodeName","description":"the name of this promo code","type":"string"}},"required":["amountOff","expireDate","maxRedemption","promoCodeName","listingId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostPressedSavePromoCode', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostPressedSecurityDepositMoreInformation' track call.
 *
 * @param HostPressedSecurityDepositMoreInformation props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostPressedSecurityDepositMoreInformation(props: HostPressedSecurityDepositMoreInformation, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostPressedSecurityDepositMoreInformation","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST SETTINGS - SECURITY DEPOSIT] ","properties":{"id":{"$id":"/properties/id","description":"","type":"string"},"listingId":{"$id":"/properties/listingId","description":"","type":"integer"}},"required":["listingId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostPressedSecurityDepositMoreInformation', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostPressedSelfServeSignUp' track call.
 *
 * @param HostPressedSelfServeSignUp props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostPressedSelfServeSignUp(props: HostPressedSelfServeSignUp, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostPressedSelfServeSignUp","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST ONBOARDING] host pressed I got this for self serve sign up","properties":{"id":{"$id":"/properties/id","description":"","type":"string"}},"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostPressedSelfServeSignUp', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostPressedSendChangeRequest' track call.
 *
 * @param HostPressedSendChangeRequest props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostPressedSendChangeRequest(props: HostPressedSendChangeRequest, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostPressedSendChangeRequest","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST RESERVATION] host pressed send change request","properties":{"bookingId":{"$id":"/properties/bookingId","description":"id of the bookings","type":"string"},"bookingWithPass":{"$id":"/properties/bookingWithPass","description":"was the booking made using a pass","enum":["FALSE","PARTIAL","TRUE"],"type":"string"},"isRefund":{"$id":"/properties/isRefund","description":"true if guests has refund amount (host's update earning is less than original earnings)","type":"boolean"},"newAdultGuests":{"$id":"/properties/newAdultGuests","description":"new number of adult guests","type":"integer"},"newAmenities":{"$id":"/properties/newAmenities","description":"new amenities","items":{"$id":"/properties/properties/properties/newAmenities/items","description":"","properties":{"amenityDescription":{"$id":"/properties/properties/properties/newAmenities/items/properties/amenityDescription","description":"description of the amenity\n","type":["string","null"]},"amenityFeeDetails":{"$id":"/properties/properties/properties/newAmenities/items/properties/amenityFeeDetails","description":"","properties":{"feeAmount":{"$id":"/properties/properties/properties/newAmenities/items/properties/amenityFeeDetails/properties/feeAmount","description":"fee of amenity\n","type":"number"},"isFlatFee":{"$id":"/properties/properties/properties/newAmenities/items/properties/amenityFeeDetails/properties/isFlatFee","description":"does this amenity have a flat fee, 1 is flat fee, 0 is hourly fee","type":"boolean"}},"required":["feeAmount","isFlatFee"],"type":"object"},"amenityName":{"$id":"/properties/properties/properties/newAmenities/items/properties/amenityName","description":"name of amenity\n","type":"string"},"isCustomAmenity":{"$id":"/properties/properties/properties/newAmenities/items/properties/isCustomAmenity","description":"is this a custom amenity from the host\n","type":"boolean"},"isFee":{"$id":"/properties/properties/properties/newAmenities/items/properties/isFee","description":"does this amenity have a fee\n","type":"boolean"},"isPreSelected":{"$id":"/properties/properties/properties/newAmenities/items/properties/isPreSelected","description":"is this amenity pre selected\n","type":"boolean"}},"required":["amenityFeeDetails","amenityName","isCustomAmenity","isFee","isPreSelected"],"type":"object"},"type":"array"},"newCharges":{"$id":"/properties/newCharges","description":"new charges after edit","type":"number"},"newChildrenGuests":{"$id":"/properties/newChildrenGuests","description":"new number of children guests","type":"integer"},"newDate":{"$id":"/properties/newDate","description":"new date of booking","type":"string"},"newEndTime":{"$id":"/properties/newEndTime","description":"new end time of booking","type":"string"},"newInfantGuests":{"$id":"/properties/newInfantGuests","description":"new number of infants guests","type":"integer"},"newNumberAmenities":{"$id":"/properties/newNumberAmenities","description":"new number of amenities","type":"integer"},"newPetGuests":{"$id":"/properties/newPetGuests","description":"new number of pet guests","type":"integer"},"newStartTime":{"$id":"/properties/newStartTime","description":"new start time of booking","type":"string"},"originalAdultGuests":{"$id":"/properties/originalAdultGuests","description":"original number of adult guests before changes","type":"integer"},"originalAmenities":{"$id":"/properties/originalAmenities","description":"","items":{"$id":"/properties/properties/properties/originalAmenities/items","description":"","properties":{"amenityDescription":{"$id":"/properties/properties/properties/originalAmenities/items/properties/amenityDescription","description":"description of the amenity\n","type":["string","null"]},"amenityFeeDetails":{"$id":"/properties/properties/properties/originalAmenities/items/properties/amenityFeeDetails","description":"","properties":{"feeAmount":{"$id":"/properties/properties/properties/originalAmenities/items/properties/amenityFeeDetails/properties/feeAmount","description":"fee of amenity\n","type":"number"},"isFlatFee":{"$id":"/properties/properties/properties/originalAmenities/items/properties/amenityFeeDetails/properties/isFlatFee","description":"does this amenity have a flat fee, 1 is flat fee, 0 is hourly fee","type":"boolean"}},"required":["feeAmount","isFlatFee"],"type":"object"},"amenityName":{"$id":"/properties/properties/properties/originalAmenities/items/properties/amenityName","description":"name of amenity\n","type":"string"},"isCustomAmenity":{"$id":"/properties/properties/properties/originalAmenities/items/properties/isCustomAmenity","description":"is this a custom amenity from the host\n","type":"boolean"},"isFee":{"$id":"/properties/properties/properties/originalAmenities/items/properties/isFee","description":"does this amenity have a fee\n","type":"boolean"},"isPreSelected":{"$id":"/properties/properties/properties/originalAmenities/items/properties/isPreSelected","description":"is this amenity pre selected\n","type":"boolean"}},"required":["amenityFeeDetails","amenityName","isCustomAmenity","isFee","isPreSelected"],"type":"object"},"type":"array"},"originalChildrenGuests":{"$id":"/properties/originalChildrenGuests","description":"original number of children guests before changes","type":"integer"},"originalDate":{"$id":"/properties/originalDate","description":"original date of the booking","type":"string"},"originalEndTime":{"$id":"/properties/originalEndTime","description":"original end time before changes","type":"string"},"originalInfantGuests":{"$id":"/properties/originalInfantGuests","description":"original number of infants guests before changes","type":"integer"},"originalNumberAmenities":{"$id":"/properties/originalNumberAmenities","description":"original number of amenities before changes","type":"integer"},"originalPetGuests":{"$id":"/properties/originalPetGuests","description":"original number of pet guests before changes","type":"integer"},"originalStartTime":{"$id":"/properties/originalStartTime","description":"original start time before changes","type":"string"},"paidPrice":{"$id":"/properties/paidPrice","description":"paid price of the booking","type":"number"},"passId":{"$id":"/properties/passId","description":"if the booking was made or partially made with a pass, the pass id used","type":["integer","null"]},"passName":{"$id":"/properties/passName","description":"the type of the pass formatted to be LCM friendly\n","type":["string","null"]},"passType":{"$id":"/properties/passType","description":"if the booking was made or partially made with a pass, what type of pass","enum":["ALL_ACCESS","EARLY_BIRD","WEEKDAY",null],"type":["string","null"]},"requestMessage":{"$id":"/properties/requestMessage","description":"the additional message entered by host","type":"string"},"userPassId":{"$id":"/properties/userPassId","description":"if the booking was made or partially made with a pass, what was the user pass Id used","type":["integer","null"]}},"required":["originalInfantGuests","originalAdultGuests","newAdultGuests","newStartTime","requestMessage","originalNumberAmenities","paidPrice","originalPetGuests","newInfantGuests","newChildrenGuests","originalAmenities","newAmenities","newDate","newEndTime","newCharges","newNumberAmenities","bookingId","isRefund","originalDate","originalStartTime","newPetGuests","originalEndTime","originalChildrenGuests"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostPressedSendChangeRequest', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostPressedSendSpecialOfferFromMessages' track call.
 *
 * @param HostPressedSendSpecialOfferFromMessages props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostPressedSendSpecialOfferFromMessages(props: HostPressedSendSpecialOfferFromMessages, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostPressedSendSpecialOfferFromMessages","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST BOOKING INQUIRY RESPONSE]","properties":{"bookingId":{"$id":"/properties/bookingId","description":"","type":["integer","null"]},"enteredFrom":{"$id":"/properties/enteredFrom","description":"how the host accessed the send special offer option","enum":["messages","view-inquiry"],"type":"string"},"globalListingType":{"$id":"/properties/globalListingType","description":"[LISTING TYPE] The type of the listing associated with this event","enum":["artStudio","basketballCourt","dockedBoat","home","homeGym","joyspace","kitchen","largeBackyard","musicStudio","other","pending","pickleball","pool","privateLake","roofDeck","tennisCourt"],"type":"string"},"guestId":{"$id":"/properties/guestId","description":"","type":"integer"},"hostId":{"$id":"/properties/hostId","description":"","type":"integer"},"listingId":{"$id":"/properties/listingId","description":"","type":"integer"},"roomId":{"$id":"/properties/roomId","description":"","type":"string"}},"required":["listingId","guestId","hostId","enteredFrom","globalListingType"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostPressedSendSpecialOfferFromMessages', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostPressedSetSpecialPrice' track call.
 *
 * @param HostPressedSetSpecialPrice props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostPressedSetSpecialPrice(props: HostPressedSetSpecialPrice, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostPressedSetSpecialPrice","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST BOOKING INQUIRY CREATING SPECIAL OFFER]","properties":{"bookingId":{"$id":"/properties/bookingId","description":"","type":["integer","null"]},"globalListingType":{"$id":"/properties/globalListingType","description":"[LISTING TYPE] The type of the listing associated with this event","enum":["artStudio","basketballCourt","dockedBoat","home","homeGym","joyspace","kitchen","largeBackyard","musicStudio","other","pending","pickleball","pool","privateLake","roofDeck","tennisCourt"],"type":"string"},"guestId":{"$id":"/properties/guestId","description":"","type":"integer"},"hostId":{"$id":"/properties/hostId","description":"","type":"integer"},"listingId":{"$id":"/properties/listingId","description":"","type":"integer"},"roomId":{"$id":"/properties/roomId","description":"","type":"string"}},"required":["globalListingType","listingId","hostId","guestId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostPressedSetSpecialPrice', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostPressedSetUpPass' track call.
 *
 * @param HostPressedSetUpPass props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostPressedSetUpPass(props: HostPressedSetUpPass, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostPressedSetUpPass","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST PASS ONBOARDING]","properties":{"id":{"$id":"/properties/id","description":"","type":"string"},"listingId":{"$id":"/properties/listingId","description":"","type":"integer"},"passType":{"$id":"/properties/passType","description":"","enum":["ALL_ACCESS","EARLY_BIRD","WEEKDAY"],"type":"string"}},"required":["passType","listingId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostPressedSetUpPass', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostPressedSetUpSecurityDeposit' track call.
 *
 * @param HostPressedSetUpSecurityDeposit props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostPressedSetUpSecurityDeposit(props: HostPressedSetUpSecurityDeposit, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostPressedSetUpSecurityDeposit","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST SETTINGS - SECURITY DEPOSIT] ","properties":{"id":{"$id":"/properties/id","description":"","type":"string"},"listingId":{"$id":"/properties/listingId","description":"","type":"integer"}},"required":["listingId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostPressedSetUpSecurityDeposit', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostPressedSetUpSecurityDepositExit' track call.
 *
 * @param HostPressedSetUpSecurityDepositExit props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostPressedSetUpSecurityDepositExit(props: HostPressedSetUpSecurityDepositExit, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostPressedSetUpSecurityDepositExit","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST SETTINGS - SECURITY DEPOSIT] ","properties":{"hasActiveSecurityDesposit":{"$id":"/properties/hasActiveSecurityDesposit","description":"","type":"boolean"},"id":{"$id":"/properties/id","description":"","type":"string"},"listingId":{"$id":"/properties/listingId","description":"","type":"integer"}},"required":["listingId","hasActiveSecurityDesposit"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostPressedSetUpSecurityDepositExit', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostPressedSignUpTogether' track call.
 *
 * @param HostPressedSignUpTogether props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostPressedSignUpTogether(props: HostPressedSignUpTogether, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostPressedSignUpTogether","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST ONBOARDING] host pressed to sign up with concierge onboarding","properties":{"id":{"$id":"/properties/id","description":"","type":"string"}},"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostPressedSignUpTogether', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostPressedStartSellingPassOnboarding' track call.
 *
 * @param HostPressedStartSellingPassOnboarding props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostPressedStartSellingPassOnboarding(props: HostPressedStartSellingPassOnboarding, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostPressedStartSellingPassOnboarding","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST PASS ONBOARDING]\n","properties":{"id":{"$id":"/properties/id","description":"","type":"string"}},"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostPressedStartSellingPassOnboarding', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostPressedSwitchListing' track call.
 *
 * @param HostPressedSwitchListing props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostPressedSwitchListing(props: HostPressedSwitchListing, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostPressedSwitchListing","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST PERFORMANCE] Host pressed to switch listing if they have multiple ones","properties":{"id":{"$id":"/properties/id","description":"! DO NOT ADD ID (HACK TO MAKE EVENT DISPLAY IN TYPES)","type":"string"}},"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostPressedSwitchListing', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostPressedSwitchPricingType' track call.
 *
 * @param HostPressedSwitchPricingType props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostPressedSwitchPricingType(props: HostPressedSwitchPricingType, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostPressedSwitchPricingType","$schema":"http://json-schema.org/draft-07/schema#","description":"[TIERED PRICING] host pressed to switch to tiered pricing or legacy price","properties":{"listingId":{"$id":"/properties/listingId","description":"id of the listing","type":"integer"},"newPricingType":{"$id":"/properties/newPricingType","description":"the pricing type after switching","enum":["flat_rate","full_day_single","full_day_tiered","tiered_pricing"],"type":"string"},"originalPricingType":{"$id":"/properties/originalPricingType","description":"the pricing type before switching","enum":["flat_rate","full_day_single","full_day_tiered","tiered_pricing"],"type":"string"}},"required":["originalPricingType","newPricingType","listingId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostPressedSwitchPricingType', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostPressedToConfirmChangeToFlatRatePricing' track call.
 *
 * @param HostPressedToConfirmChangeToFlatRatePricing props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostPressedToConfirmChangeToFlatRatePricing(props: HostPressedToConfirmChangeToFlatRatePricing, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostPressedToConfirmChangeToFlatRatePricing","$schema":"http://json-schema.org/draft-07/schema#","description":"[TIERED PRICING] host pressed to confirm to change to flat rate price","properties":{"listingId":{"$id":"/properties/listingId","description":"id of the listing","type":"integer"}},"required":["listingId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostPressedToConfirmChangeToFlatRatePricing', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostPressedToConfirmChangeToFullDayPricing' track call.
 *
 * @param HostPressedToConfirmChangeToFullDayPricing props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostPressedToConfirmChangeToFullDayPricing(props: HostPressedToConfirmChangeToFullDayPricing, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostPressedToConfirmChangeToFullDayPricing","$schema":"http://json-schema.org/draft-07/schema#","description":"[TIERED PRICING] host pressed to confirm to change to full day pricing","properties":{"listingId":{"$id":"/properties/listingId","description":"id of the listing","type":"integer"}},"required":["listingId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostPressedToConfirmChangeToFullDayPricing', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostPressedToConfirmChangeToTieredDayPricing' track call.
 *
 * @param HostPressedToConfirmChangeToTieredDayPricing props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostPressedToConfirmChangeToTieredDayPricing(props: HostPressedToConfirmChangeToTieredDayPricing, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostPressedToConfirmChangeToTieredDayPricing","$schema":"http://json-schema.org/draft-07/schema#","description":"[TIERED PRICING] host pressed to confirm to change to full day pricing","properties":{"listingId":{"$id":"/properties/listingId","description":"id of the listing","type":"integer"}},"required":["listingId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostPressedToConfirmChangeToTieredDayPricing', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostPressedToContinueCancellation' track call.
 *
 * @param HostPressedToContinueCancellation props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostPressedToContinueCancellation(props: HostPressedToContinueCancellation, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostPressedToContinueCancellation","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST RESERVATION] on initial cancellation text, host opted to continue with the cancellation","properties":{"bookingId":{"$id":"/properties/bookingId","description":"id of the booking the reservation pertains to","type":"integer"},"bookingWithPass":{"$id":"/properties/bookingWithPass","description":"was the booking made using a pass","enum":["FALSE","PARTIAL","TRUE"],"type":"string"},"passId":{"$id":"/properties/passId","description":"if the booking was made or partially made with a pass, the pass id used","type":["integer","null"]},"passName":{"$id":"/properties/passName","description":"the type of the pass formatted to be LCM friendly\n","type":["string","null"]},"passType":{"$id":"/properties/passType","description":"if the booking was made or partially made with a pass, what type of pass","enum":["ALL_ACCESS","EARLY_BIRD","WEEKDAY",null],"type":["string","null"]},"userPassId":{"$id":"/properties/userPassId","description":"if the booking was made or partially made with a pass, what was the user pass Id used","type":["integer","null"]}},"required":["bookingId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostPressedToContinueCancellation', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostPressedToContinueDecline' track call.
 *
 * @param HostPressedToContinueDecline props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostPressedToContinueDecline(props: HostPressedToContinueDecline, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostPressedToContinueDecline","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST RESERVATION] on approve-instead step, host opted to continue with the decline","properties":{"bookingId":{"$id":"/properties/bookingId","description":"id of the booking the reservation pertains to","type":"integer"},"bookingWithPass":{"$id":"/properties/bookingWithPass","description":"was the booking made using a pass","enum":["FALSE","PARTIAL","TRUE"],"type":"string"},"passId":{"$id":"/properties/passId","description":"if the booking was made or partially made with a pass, the pass id used","type":["integer","null"]},"passName":{"$id":"/properties/passName","description":"the type of the pass formatted to be LCM friendly\n","type":["string","null"]},"passType":{"$id":"/properties/passType","description":"if the booking was made or partially made with a pass, what type of pass","enum":["ALL_ACCESS","EARLY_BIRD","WEEKDAY",null],"type":["string","null"]},"userPassId":{"$id":"/properties/userPassId","description":"if the booking was made or partially made with a pass, what was the user pass Id used","type":["integer","null"]}},"required":["bookingId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostPressedToContinueDecline', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostPressedToEditSecurityDeposit' track call.
 *
 * @param HostPressedToEditSecurityDeposit props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostPressedToEditSecurityDeposit(props: HostPressedToEditSecurityDeposit, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostPressedToEditSecurityDeposit","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST SETTINGS - SECURITY DEPOSIT] ","properties":{"depositAmount":{"$id":"/properties/depositAmount","description":"the size of the deposit required","enum":["100","1000","250","500",null],"type":["string","null"]},"guestMin":{"$id":"/properties/guestMin","description":"min guest count to charge a security deposit","type":["number","null"]},"hasActiveSecurityDesposit":{"$id":"/properties/hasActiveSecurityDesposit","description":"true (1) if the listings has an active security deposit, false (0) if not ","type":"boolean"},"listingId":{"$id":"/properties/listingId","description":"","type":"integer"}},"required":["hasActiveSecurityDesposit","listingId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostPressedToEditSecurityDeposit', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostPressedToSharePromoCode' track call.
 *
 * @param HostPressedToSharePromoCode props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostPressedToSharePromoCode(props: HostPressedToSharePromoCode, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostPressedToSharePromoCode","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST PROMO CODE] hose pressed copy promo code (on web) or share promo code (on mobile) ","properties":{"currentRedemption":{"$id":"/properties/currentRedemption","description":"the redemption made by guests for this promo code","type":"integer"},"listingId":{"$id":"/properties/listingId","description":"id of the listing for this promocode","type":"string"},"promoCodeName":{"$id":"/properties/promoCodeName","description":"the name of this promo code","type":"string"}},"required":["listingId","promoCodeName","currentRedemption"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostPressedToSharePromoCode', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostPressedToViewPromoCode' track call.
 *
 * @param HostPressedToViewPromoCode props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostPressedToViewPromoCode(props: HostPressedToViewPromoCode, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostPressedToViewPromoCode","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST PROMO CODE] Host pressed the promo code in the Your promo code card","properties":{"currentRedemption":{"$id":"/properties/currentRedemption","description":"the redemption made by guests for this promo code","type":"number"},"isActive":{"$id":"/properties/isActive","description":"True if the promo code is in the active table, false if it is in the expired tab","type":"boolean"},"listingId":{"$id":"/properties/listingId","description":"id of the listing for this promocode","type":"string"},"promoCodeName":{"$id":"/properties/promoCodeName","description":"the name of this promo code","type":"string"}},"required":["isActive","listingId","promoCodeName","currentRedemption"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostPressedToViewPromoCode', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostPressedUnsyncCronofy' track call.
 *
 * @param HostPressedUnsyncCronofy props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostPressedUnsyncCronofy(props: HostPressedUnsyncCronofy, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostPressedUnsyncCronofy","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST CALENDAR SYNCING] Host pressed the toggle for a synced Cronofy calendar","properties":{"calendarName":{"$id":"/properties/calendarName","description":"","type":"string"},"listingId":{"$id":"/properties/listingId","description":"","type":"integer"}},"required":["calendarName","listingId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostPressedUnsyncCronofy', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostPressedUnsyncICal' track call.
 *
 * @param HostPressedUnsyncICal props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostPressedUnsyncICal(props: HostPressedUnsyncICal, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostPressedUnsyncICal","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST CALENDAR SYNCING] Host pressed the toggle for a synced iCal calendar","properties":{"calendarName":{"$id":"/properties/calendarName","description":"","type":"string"},"listingId":{"$id":"/properties/listingId","description":"","type":"integer"}},"required":["calendarName","listingId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostPressedUnsyncICal', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostPressedUploadVideoTour' track call.
 *
 * @param HostPressedUploadVideoTour props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostPressedUploadVideoTour(props: HostPressedUploadVideoTour, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostPressedUploadVideoTour","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST SETTINGS - VIDEO TOUR] when host presses \"Upload a video\" after having entered the add video tour","properties":{"listingId":{"$id":"/properties/listingId","description":"","type":"integer"}},"required":["listingId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostPressedUploadVideoTour', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostPressedViewDetailsReservationAdjustment' track call.
 *
 * @param HostPressedViewDetailsReservationAdjustment props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostPressedViewDetailsReservationAdjustment(props: HostPressedViewDetailsReservationAdjustment, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostPressedViewDetailsReservationAdjustment","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST RESERVATION] host pressed the \"view details\" option of a given reservation adjustment request","properties":{"bookingEditHistoryId":{"$id":"/properties/bookingEditHistoryId","description":"id for booking_edit_history entry that the adjustment pertains to","type":"object"},"bookingId":{"$id":"/properties/bookingId","description":"id of the booking the reservation pertains to","type":"integer"},"bookingWithPass":{"$id":"/properties/bookingWithPass","description":"was the booking made using a pass","enum":["FALSE","PARTIAL","TRUE"],"type":"string"},"passId":{"$id":"/properties/passId","description":"if the booking was made or partially made with a pass, the pass id used","type":["integer","null"]},"passName":{"$id":"/properties/passName","description":"the type of the pass formatted to be LCM friendly\n","type":["string","null"]},"passType":{"$id":"/properties/passType","description":"if the booking was made or partially made with a pass, what type of pass","enum":["ALL_ACCESS","EARLY_BIRD","WEEKDAY",null],"type":["string","null"]},"userPassId":{"$id":"/properties/userPassId","description":"if the booking was made or partially made with a pass, what was the user pass Id used","type":["integer","null"]}},"required":["bookingId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostPressedViewDetailsReservationAdjustment', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostPressedViewLatestBookingAmenityModifications' track call.
 *
 * @param HostPressedViewLatestBookingAmenityModifications props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostPressedViewLatestBookingAmenityModifications(props: HostPressedViewLatestBookingAmenityModifications, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostPressedViewLatestBookingAmenityModifications","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST RESERVATION] host pressed the \"see details\" option of a the latest booking modification","properties":{"bookingId":{"$id":"/properties/bookingId","description":"id of the booking the reservation pertains to","type":"integer"}},"required":["bookingId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostPressedViewLatestBookingAmenityModifications', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostPressedViewLatestBookingModifications' track call.
 *
 * @param HostPressedViewLatestBookingModifications props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostPressedViewLatestBookingModifications(props: HostPressedViewLatestBookingModifications, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostPressedViewLatestBookingModifications","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST RESERVATION] host pressed \"view\" amenity modifications after clicking the \"see details\" option of a the latest booking modification","properties":{"bookingId":{"$id":"/properties/bookingId","description":"id of the booking the reservation pertains to","type":"integer"}},"required":["bookingId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostPressedViewLatestBookingModifications', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostPressedViewReservation' track call.
 *
 * @param HostPressedViewReservation props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostPressedViewReservation(props: HostPressedViewReservation, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostPressedViewReservation","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST RESERVATION] host pressed \"view reservation\" on the reservation list page","properties":{"bookingId":{"$id":"/properties/bookingId","description":"id of the associated booking","type":"integer"},"bookingReason":{"$id":"/properties/bookingReason","description":"guest selection (listing type specific) for why they're booking","enum":["casual_play","competitive_play","corporate_or_meeting","courts","date","exercise","family_hangout","friend_hangout","lessons",null,"other","party_celebration","party_or_celebration","pet_swim","photoshoot","training"],"type":["string","null"]},"bookingWithPass":{"$id":"/properties/bookingWithPass","description":"was the booking made using a pass","enum":["FALSE","PARTIAL","TRUE"],"type":"string"},"passId":{"$id":"/properties/passId","description":"if the booking was made or partially made with a pass, the pass id used","type":["integer","null"]},"passName":{"$id":"/properties/passName","description":"the type of the pass formatted to be LCM friendly\n","type":["string","null"]},"passType":{"$id":"/properties/passType","description":"if the booking was made or partially made with a pass, what type of pass","enum":["ALL_ACCESS","EARLY_BIRD","WEEKDAY",null],"type":["string","null"]},"userPassId":{"$id":"/properties/userPassId","description":"if the booking was made or partially made with a pass, what was the user pass Id used","type":["integer","null"]}},"required":["bookingId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostPressedViewReservation', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostPressedWithdrawSpecialOffer' track call.
 *
 * @param HostPressedWithdrawSpecialOffer props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostPressedWithdrawSpecialOffer(props: HostPressedWithdrawSpecialOffer, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostPressedWithdrawSpecialOffer","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST BOOKING INQUIRY POST-SPECIAL OFFER SENT]","properties":{"bookingId":{"$id":"/properties/bookingId","description":"","type":"integer"},"bookingSpecialOfferId":{"$id":"/properties/bookingSpecialOfferId","description":"","type":"integer"},"globalListingType":{"$id":"/properties/globalListingType","description":"[LISTING TYPE] The type of the listing associated with this event","enum":["artStudio","basketballCourt","dockedBoat","home","homeGym","joyspace","kitchen","largeBackyard","musicStudio","other","pending","pickleball","pool","privateLake","roofDeck","tennisCourt"],"type":"string"},"guestId":{"$id":"/properties/guestId","description":"","type":"integer"},"hostId":{"$id":"/properties/hostId","description":"","type":"integer"},"listingId":{"$id":"/properties/listingId","description":"","type":"integer"},"originalPrice":{"$id":"/properties/originalPrice","description":"","type":"number"},"roomId":{"$id":"/properties/roomId","description":"","type":"string"},"specialOfferPrice":{"$id":"/properties/specialOfferPrice","description":"","type":"number"}},"required":["bookingSpecialOfferId","originalPrice","specialOfferPrice","guestId","hostId","globalListingType","bookingId","listingId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostPressedWithdrawSpecialOffer', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostProfileAccount' track call.
 *
 * @param HostProfileAccount props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostProfileAccount(props: HostProfileAccount, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostProfileAccount","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST PROFILE EVENTS] host pressed \"account\" tab on host profile","properties":{"id":{"$id":"/properties/id","description":"","type":"string"}},"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostProfileAccount', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostProfileConfirmedRegionSwitch' track call.
 *
 * @param HostProfileConfirmedRegionSwitch props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostProfileConfirmedRegionSwitch(props: HostProfileConfirmedRegionSwitch, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostProfileConfirmedRegionSwitch","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST PROFILE EVENTS] host confirmed switching region on host profile","properties":{"newRegion":{"$id":"/properties/newRegion","description":"the region they were in post button press","type":"string"},"previousRegion":{"$id":"/properties/previousRegion","description":"the region they were in prior to button press","type":"string"}},"required":["newRegion","previousRegion"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostProfileConfirmedRegionSwitch', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostProfilePaymentMethods' track call.
 *
 * @param HostProfilePaymentMethods props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostProfilePaymentMethods(props: HostProfilePaymentMethods, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostProfilePaymentMethods","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST PROFILE EVENTS] host pressed to enter payment methods","properties":{"id":{"$id":"/properties/id","description":"","type":"string"}},"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostProfilePaymentMethods', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostProfilePhotosAdded' track call.
 *
 * @param HostProfilePhotosAdded props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostProfilePhotosAdded(props: HostProfilePhotosAdded, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostProfilePhotosAdded","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST ONBOARDING] host profiles uploaded","properties":{"enteredFrom":{"$id":"/properties/enteredFrom","description":"All possible values for enteredFrom in host onboarding","enum":["ProfilePhotosScreen","ProfileScreen","austin","austinFB","clarkRubber","dipApp","directPoolSupplies","existingHostNewListingFlow","hostExistingListingManagement","hostOnboardingFlow","houston","houstonFB","losangeles","losangelesFB","newYork","newYorkFB","noListingsScreen","performanceTips","ph","poolProfits","poolSafetySolutions","portland","portlandFB","precisionPoolsAndLandscape","profileManageListings","sanAntonio","sanAntonioFB","seattle","seattleFB","swimUniversity","toronto","torontoFB","vip"],"type":"string"},"globalListingType":{"$id":"/properties/globalListingType","description":"[LISTING TYPE] The type of the listing associated with this event","enum":["artStudio","basketballCourt","dockedBoat","home","homeGym","joyspace","kitchen","largeBackyard","musicStudio","other","pending","pickleball","pool","privateLake","roofDeck","tennisCourt"],"type":"string"},"listingId":{"$id":"/properties/listingId","description":"id for the related listing","type":"string"},"poolId":{"$id":"/properties/poolId","description":"legacy name for listing id","type":"string"},"pressedSaveExit":{"$id":"/properties/pressedSaveExit","description":"pressed \"save and exit\" to remove from flow","type":"boolean"},"uploadPhotosPressed":{"$id":"/properties/uploadPhotosPressed","description":"did host select option to add photos","type":"boolean"}},"required":["globalListingType","enteredFrom","uploadPhotosPressed","listingId","pressedSaveExit"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostProfilePhotosAdded', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostProfilePressReferralBanner' track call.
 *
 * @param HostProfilePressReferralBanner props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostProfilePressReferralBanner(props: HostProfilePressReferralBanner, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostProfilePressReferralBanner","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST PROFILE EVENTS] host pressed the referral banner","properties":{"bannerText":{"$id":"/properties/bannerText","description":"text value of the banner","type":"string"}},"required":["bannerText"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostProfilePressReferralBanner', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostProfilePressTermsofUse' track call.
 *
 * @param HostProfilePressTermsofUse props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostProfilePressTermsofUse(props: HostProfilePressTermsofUse, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostProfilePressTermsofUse","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST PROFILE EVENTS] host pressed to enter terms of use","properties":{"urlDestination":{"$id":"/properties/urlDestination","description":"destination of the terms of use link","type":"string"}},"required":["urlDestination"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostProfilePressTermsofUse', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostProfilePressedContactUs' track call.
 *
 * @param HostProfilePressedContactUs props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostProfilePressedContactUs(props: HostProfilePressedContactUs, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostProfilePressedContactUs","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST PROFILE EVENTS] host pressed \"contact us\" on profile","properties":{"urlDestination":{"$id":"/properties/urlDestination","description":"destination of the \"contact us\" link","type":"string"}},"required":["urlDestination"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostProfilePressedContactUs', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostProfilePressedGetVerified' track call.
 *
 * @param HostProfilePressedGetVerified props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostProfilePressedGetVerified(props: HostProfilePressedGetVerified, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostProfilePressedGetVerified","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST PROFILE EVENTS] host pressed \"get verified\" on profile","properties":{"currentAddressVerified":{"$id":"/properties/currentAddressVerified","description":"is the host currently address verified","type":"boolean"},"currentIsBookingsVerified":{"$id":"/properties/currentIsBookingsVerified","description":"is the host currently bookings verified","type":"boolean"},"currentIsIdVerified":{"$id":"/properties/currentIsIdVerified","description":"is the host currently id verified","type":"boolean"}},"required":["currentAddressVerified","currentIsBookingsVerified","currentIsIdVerified"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostProfilePressedGetVerified', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostProfilePressedGiftCards' track call.
 *
 * @param HostProfilePressedGiftCards props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostProfilePressedGiftCards(props: HostProfilePressedGiftCards, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostProfilePressedGiftCards","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST PROFILE EVENTS] host pressed \"gift cards\" on profile","properties":{"urlDestination":{"$id":"/properties/urlDestination","description":"destination of the \"gift cards\" link","type":"string"}},"required":["urlDestination"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostProfilePressedGiftCards', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostProfilePressedHelpCenter' track call.
 *
 * @param HostProfilePressedHelpCenter props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostProfilePressedHelpCenter(props: HostProfilePressedHelpCenter, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostProfilePressedHelpCenter","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST PROFILE EVENTS] host pressed \"help center\" on profile","properties":{"urlDestination":{"$id":"/properties/urlDestination","description":"destination of the \"help center\" link","type":"string"}},"required":["urlDestination"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostProfilePressedHelpCenter', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostProfilePressedLogout' track call.
 *
 * @param HostProfilePressedLogout props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostProfilePressedLogout(props: HostProfilePressedLogout, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostProfilePressedLogout","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST PROFILE EVENTS] host pressed to logout from profile","properties":{"id":{"$id":"/properties/id","description":"","type":"string"}},"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostProfilePressedLogout', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostProfilePressedPrivacyPolicy' track call.
 *
 * @param HostProfilePressedPrivacyPolicy props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostProfilePressedPrivacyPolicy(props: HostProfilePressedPrivacyPolicy, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostProfilePressedPrivacyPolicy","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST PROFILE EVENTS] host pressed \"privacy policy\" on profile","properties":{"urlDestination":{"$id":"/properties/urlDestination","description":"destination of the privacy policy link","type":"string"}},"required":["urlDestination"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostProfilePressedPrivacyPolicy', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostProfilePressedRateApp' track call.
 *
 * @param HostProfilePressedRateApp props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostProfilePressedRateApp(props: HostProfilePressedRateApp, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostProfilePressedRateApp","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST PROFILE EVENTS] host pressed \"rate app\" on profile","properties":{"id":{"$id":"/properties/id","description":"","type":"string"}},"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostProfilePressedRateApp', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostProfilePressedRegionSwitch' track call.
 *
 * @param HostProfilePressedRegionSwitch props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostProfilePressedRegionSwitch(props: HostProfilePressedRegionSwitch, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostProfilePressedRegionSwitch","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST PROFILE EVENTS] host pressed to switch region on host profile","properties":{"existingRegion":{"$id":"/properties/existingRegion","description":"the region they are already in ","type":"string"}},"required":["existingRegion"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostProfilePressedRegionSwitch', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostProfilePressedStripeConnect' track call.
 *
 * @param HostProfilePressedStripeConnect props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostProfilePressedStripeConnect(props: HostProfilePressedStripeConnect, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostProfilePressedStripeConnect","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST PROFILE EVENTS] host pressed to connect stripe","properties":{"id":{"$id":"/properties/id","description":"","type":"string"}},"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostProfilePressedStripeConnect', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostProfilePressedSwimplyStuff' track call.
 *
 * @param HostProfilePressedSwimplyStuff props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostProfilePressedSwimplyStuff(props: HostProfilePressedSwimplyStuff, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostProfilePressedSwimplyStuff","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST PROFILE EVENTS] host pressed \"Swimply Stuff\" on profile","properties":{"id":{"$id":"/properties/id","description":"","type":"string"}},"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostProfilePressedSwimplyStuff', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostProfileSelectProfile' track call.
 *
 * @param HostProfileSelectProfile props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostProfileSelectProfile(props: HostProfileSelectProfile, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostProfileSelectProfile","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST PROFILE EVENTS] host pressed \"profile\" on profile","properties":{"id":{"$id":"/properties/id","description":"","type":"string"}},"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostProfileSelectProfile', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostProfileStripeSelectCountry' track call.
 *
 * @param HostProfileStripeSelectCountry props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostProfileStripeSelectCountry(props: HostProfileStripeSelectCountry, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostProfileStripeSelectCountry","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST PROFILE EVENTS] host submitted country on stripe connect menu","properties":{"countrySelected":{"$id":"/properties/countrySelected","description":"country selectec","type":"string"}},"required":["countrySelected"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostProfileStripeSelectCountry', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostProfileSwitchGuestView' track call.
 *
 * @param HostProfileSwitchGuestView props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostProfileSwitchGuestView(props: HostProfileSwitchGuestView, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostProfileSwitchGuestView","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST PROFILE EVENTS] host pressed \"switch to guest view\"  or \"switch to swimmer view\" on profile","properties":{"id":{"$id":"/properties/id","description":"","type":"string"}},"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostProfileSwitchGuestView', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostReceivedReservationAdjustmentRequest' track call.
 *
 * @param HostReceivedReservationAdjustmentRequest props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostReceivedReservationAdjustmentRequest(props: HostReceivedReservationAdjustmentRequest, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostReceivedReservationAdjustmentRequest","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST RESERVATION] host received a reservation change request from guest","properties":{"amenitiesAdded":{"$id":"/properties/amenitiesAdded","description":"array of amenity ids added in the request, if any","type":"array"},"bookingEditHistoryId":{"$id":"/properties/bookingEditHistoryId","description":"a unique ID to identify the booking_edit_history entry","type":"integer"},"bookingId":{"$id":"/properties/bookingId","description":"id of the booking the reservation pertains to","type":"integer"},"bookingWithPass":{"$id":"/properties/bookingWithPass","description":"was the booking made using a pass","enum":["FALSE","PARTIAL","TRUE"],"type":"string"},"passId":{"$id":"/properties/passId","description":"if the booking was made or partially made with a pass, the pass id used","type":["integer","null"]},"passName":{"$id":"/properties/passName","description":"the type of the pass formatted to be LCM friendly\n","type":["string","null"]},"passType":{"$id":"/properties/passType","description":"if the booking was made or partially made with a pass, what type of pass","enum":["ALL_ACCESS","EARLY_BIRD","WEEKDAY",null],"type":["string","null"]},"userPassId":{"$id":"/properties/userPassId","description":"if the booking was made or partially made with a pass, what was the user pass Id used","type":["integer","null"]}},"required":["bookingEditHistoryId","amenitiesAdded","bookingId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostReceivedReservationAdjustmentRequest', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostRemovedPromotionFromListing' track call.
 *
 * @param HostRemovedPromotionFromListing props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostRemovedPromotionFromListing(props: HostRemovedPromotionFromListing, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostRemovedPromotionFromListing","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST PROMO CODE] host pressed to remove a promotion from their PDP","properties":{"globalListingType":{"$id":"/properties/globalListingType","description":"[LISTING TYPE] The type of the listing associated with this event","enum":["artStudio","basketballCourt","dockedBoat","home","homeGym","joyspace","kitchen","largeBackyard","musicStudio","other","pending","pickleball","pool","privateLake","roofDeck","tennisCourt"],"type":"string"},"listingId":{"$id":"/properties/listingId","description":"","type":"string"},"promocodeId":{"$id":"/properties/promocodeId","description":"","type":"integer"}},"required":["listingId","promocodeId","globalListingType"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostRemovedPromotionFromListing', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostRescheduleDiscountSelected' track call.
 *
 * @param HostRescheduleDiscountSelected props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostRescheduleDiscountSelected(props: HostRescheduleDiscountSelected, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostRescheduleDiscountSelected","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST RESERVATION] discount amount host selected, or \"none\"","properties":{"bookingId":{"$id":"/properties/bookingId","description":"id of the booking the reservation pertains to","type":"integer"},"bookingWithPass":{"$id":"/properties/bookingWithPass","description":"was the booking made using a pass","enum":["FALSE","PARTIAL","TRUE"],"type":"string"},"discountAmountOffered":{"$id":"/properties/discountAmountOffered","description":"discount offer in percentage","type":"integer"},"passId":{"$id":"/properties/passId","description":"if the booking was made or partially made with a pass, the pass id used","type":["integer","null"]},"passName":{"$id":"/properties/passName","description":"the type of the pass formatted to be LCM friendly\n","type":["string","null"]},"passType":{"$id":"/properties/passType","description":"if the booking was made or partially made with a pass, what type of pass","enum":["ALL_ACCESS","EARLY_BIRD","WEEKDAY",null],"type":["string","null"]},"userPassId":{"$id":"/properties/userPassId","description":"if the booking was made or partially made with a pass, what was the user pass Id used","type":["integer","null"]}},"required":["bookingId","discountAmountOffered"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostRescheduleDiscountSelected', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostRespondedReservationAdjustmentRequest' track call.
 *
 * @param HostRespondedReservationAdjustmentRequest props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostRespondedReservationAdjustmentRequest(props: HostRespondedReservationAdjustmentRequest, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostRespondedReservationAdjustmentRequest","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST RESERVATION] host responded to a reservation change request from guest","properties":{"amenitiesAdded":{"$id":"/properties/amenitiesAdded","description":"array of amenity ids added in the request, if any","type":"array"},"bookingEditHistoryId":{"$id":"/properties/bookingEditHistoryId","description":"a unique ID to identify the booking_edit_history entry","type":"integer"},"bookingId":{"$id":"/properties/bookingId","description":"id of the booking the reservation pertains to","type":"integer"},"bookingWithPass":{"$id":"/properties/bookingWithPass","description":"was the booking made using a pass","enum":["FALSE","PARTIAL","TRUE"],"type":"string"},"isAccepted":{"$id":"/properties/isAccepted","description":"is this adjustment accepted or declined?","type":"boolean"},"passId":{"$id":"/properties/passId","description":"if the booking was made or partially made with a pass, the pass id used","type":["integer","null"]},"passName":{"$id":"/properties/passName","description":"the type of the pass formatted to be LCM friendly\n","type":["string","null"]},"passType":{"$id":"/properties/passType","description":"if the booking was made or partially made with a pass, what type of pass","enum":["ALL_ACCESS","EARLY_BIRD","WEEKDAY",null],"type":["string","null"]},"userPassId":{"$id":"/properties/userPassId","description":"if the booking was made or partially made with a pass, what was the user pass Id used","type":["integer","null"]}},"required":["bookingEditHistoryId","amenitiesAdded","isAccepted","bookingId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostRespondedReservationAdjustmentRequest', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostSavedSpecialPrice' track call.
 *
 * @param HostSavedSpecialPrice props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostSavedSpecialPrice(props: HostSavedSpecialPrice, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostSavedSpecialPrice","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST BOOKING INQUIRY CREATING SPECIAL OFFER]","properties":{"bookingId":{"$id":"/properties/bookingId","description":"","type":"integer"},"originalPrice":{"$id":"/properties/originalPrice","description":"","type":"integer"},"specialOfferPrice":{"$id":"/properties/specialOfferPrice","description":"","type":"integer"}},"required":["originalPrice","specialOfferPrice"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostSavedSpecialPrice', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostSelectExpirationDate' track call.
 *
 * @param HostSelectExpirationDate props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostSelectExpirationDate(props: HostSelectExpirationDate, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostSelectExpirationDate","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST PROMO CODE] host pressed save to select a expiration date for the promo code","properties":{"expireDate":{"$id":"/properties/expireDate","description":"expiration date of this promo code ","type":"string"},"listingId":{"$id":"/properties/listingId","description":"id of the listing for this promocode","type":"string"}},"required":["expireDate"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostSelectExpirationDate', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostSelectedCancellationReason' track call.
 *
 * @param HostSelectedCancellationReason props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostSelectedCancellationReason(props: HostSelectedCancellationReason, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostSelectedCancellationReason","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST RESERVATION] host chose a cancellation reason","properties":{"bookingId":{"$id":"/properties/bookingId","description":"id of the booking the reservation pertains to","type":"integer"},"bookingWithPass":{"$id":"/properties/bookingWithPass","description":"was the booking made using a pass","enum":["FALSE","PARTIAL","TRUE"],"type":"string"},"passId":{"$id":"/properties/passId","description":"if the booking was made or partially made with a pass, the pass id used","type":["integer","null"]},"passName":{"$id":"/properties/passName","description":"the type of the pass formatted to be LCM friendly\n","type":["string","null"]},"passType":{"$id":"/properties/passType","description":"if the booking was made or partially made with a pass, what type of pass","enum":["ALL_ACCESS","EARLY_BIRD","WEEKDAY",null],"type":["string","null"]},"reasonSelected":{"$id":"/properties/reasonSelected","description":"reason for cancel selected by host","type":"string"},"userPassId":{"$id":"/properties/userPassId","description":"if the booking was made or partially made with a pass, what was the user pass Id used","type":["integer","null"]}},"required":["reasonSelected","bookingId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostSelectedCancellationReason', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostSelectedDeclineReason' track call.
 *
 * @param HostSelectedDeclineReason props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostSelectedDeclineReason(props: HostSelectedDeclineReason, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostSelectedDeclineReason","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST RESERVATION] host chose a decline reason","properties":{"bookingId":{"$id":"/properties/bookingId","description":"id of the booking the reservation pertains to","type":"integer"},"bookingWithPass":{"$id":"/properties/bookingWithPass","description":"was the booking made using a pass","enum":["FALSE","PARTIAL","TRUE"],"type":"string"},"passId":{"$id":"/properties/passId","description":"if the booking was made or partially made with a pass, the pass id used","type":["integer","null"]},"passName":{"$id":"/properties/passName","description":"the type of the pass formatted to be LCM friendly\n","type":["string","null"]},"passType":{"$id":"/properties/passType","description":"if the booking was made or partially made with a pass, what type of pass","enum":["ALL_ACCESS","EARLY_BIRD","WEEKDAY",null],"type":["string","null"]},"reasonSelected":{"$id":"/properties/reasonSelected","description":"reason for cancel selected by host","type":"string"},"userPassId":{"$id":"/properties/userPassId","description":"if the booking was made or partially made with a pass, what was the user pass Id used","type":["integer","null"]}},"required":["bookingId","reasonSelected"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostSelectedDeclineReason', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostSelectedListingType' track call.
 *
 * @param HostSelectedListingType props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostSelectedListingType(props: HostSelectedListingType, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostSelectedListingType","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST ONBOARDING] host selected the listing type","properties":{"globalListingType":{"$id":"/properties/globalListingType","description":"[LISTING TYPE] The type of the listing associated with this event","enum":["artStudio","basketballCourt","dockedBoat","home","homeGym","joyspace","kitchen","largeBackyard","musicStudio","other","pending","pickleball","pool","privateLake","roofDeck","tennisCourt"],"type":"string"},"listingId":{"$id":"/properties/listingId","description":"ld of the listing","type":"integer"},"pressedSaveExit":{"$id":"/properties/pressedSaveExit","description":"pressed \"save and exit\" to remove from flow","type":"boolean"}},"required":["globalListingType","listingId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostSelectedListingType', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostSelectedNewPoolDiscountOption' track call.
 *
 * @param HostSelectedNewPoolDiscountOption props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostSelectedNewPoolDiscountOption(props: HostSelectedNewPoolDiscountOption, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostSelectedNewPoolDiscountOption","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST ONBOARDING] host selected new pool discount option","properties":{"enteredFrom":{"$id":"/properties/enteredFrom","description":"All possible values for enteredFrom in host onboarding","enum":["ProfilePhotosScreen","ProfileScreen","austin","austinFB","clarkRubber","dipApp","directPoolSupplies","existingHostNewListingFlow","hostExistingListingManagement","hostOnboardingFlow","houston","houstonFB","losangeles","losangelesFB","newYork","newYorkFB","noListingsScreen","performanceTips","ph","poolProfits","poolSafetySolutions","portland","portlandFB","precisionPoolsAndLandscape","profileManageListings","sanAntonio","sanAntonioFB","seattle","seattleFB","swimUniversity","toronto","torontoFB","vip"],"type":"string"},"isAddedDiscount":{"$id":"/properties/isAddedDiscount","description":"true if host added the new pool 20% discount, false if host chose not to add special offer","type":"boolean"},"listingId":{"$id":"/properties/listingId","description":"id for the related listing","type":"string"},"poolId":{"$id":"/properties/poolId","description":"legacy name for listing id","type":"string"}},"required":["listingId","isAddedDiscount","enteredFrom"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostSelectedNewPoolDiscountOption', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostSelectedNewRescheduleTime' track call.
 *
 * @param HostSelectedNewRescheduleTime props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostSelectedNewRescheduleTime(props: HostSelectedNewRescheduleTime, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostSelectedNewRescheduleTime","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST RESERVATION] host selected the new date and time for the booking, prior to the \"send reschedule request\"","properties":{"bookingId":{"$id":"/properties/bookingId","description":"id of the booking the reservation pertains to","type":"integer"},"bookingWithPass":{"$id":"/properties/bookingWithPass","description":"was the booking made using a pass","enum":["FALSE","PARTIAL","TRUE"],"type":"string"},"newRescheduleDate":{"$id":"/properties/newRescheduleDate","description":"new start date of booking","type":"string"},"newRescheduleEndTime":{"$id":"/properties/newRescheduleEndTime","description":"new end time of booking","type":"number"},"newRescheduleStartTime":{"$id":"/properties/newRescheduleStartTime","description":"new start time of booking","type":"number"},"originalDate":{"$id":"/properties/originalDate","description":"original date of booking","type":"string"},"originalEndTime":{"$id":"/properties/originalEndTime","description":"original end hour of booking","type":"number"},"originalStartTime":{"$id":"/properties/originalStartTime","description":"original start time of booking","type":"number"},"passId":{"$id":"/properties/passId","description":"if the booking was made or partially made with a pass, the pass id used","type":["integer","null"]},"passName":{"$id":"/properties/passName","description":"the type of the pass formatted to be LCM friendly\n","type":["string","null"]},"passType":{"$id":"/properties/passType","description":"if the booking was made or partially made with a pass, what type of pass","enum":["ALL_ACCESS","EARLY_BIRD","WEEKDAY",null],"type":["string","null"]},"userPassId":{"$id":"/properties/userPassId","description":"if the booking was made or partially made with a pass, what was the user pass Id used","type":["integer","null"]}},"required":["bookingId","newRescheduleDate","newRescheduleEndTime","newRescheduleStartTime","originalDate","originalEndTime","originalStartTime"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostSelectedNewRescheduleTime', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostSelectedPassAmenitiesIncluded' track call.
 *
 * @param HostSelectedPassAmenitiesIncluded props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostSelectedPassAmenitiesIncluded(props: HostSelectedPassAmenitiesIncluded, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostSelectedPassAmenitiesIncluded","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST PASS CREATION]","properties":{"coverImageURL":{"$id":"/properties/coverImageURL","description":"the url for the cover image of the listing the pass is for","type":"string"},"hostFirstName":{"$id":"/properties/hostFirstName","description":"first name of the host","type":"string"},"id":{"$id":"/properties/id","description":"","type":"string"},"listingId":{"$id":"/properties/listingId","description":"id of the listing the pass is for","type":"string"},"listingTitle":{"$id":"/properties/listingTitle","description":"the title of the listing the pass is for","type":"string"},"listingURL":{"$id":"/properties/listingURL","description":"the url of the listing the pass is for","type":"string"},"passAvailableTimes":{"$id":"/properties/passAvailableTimes","description":"[{from:”07:00:00”, “11:00:00”}...] Time slots when this pass is eligible","type":"array"},"passAvailableTimesText":{"$id":"/properties/passAvailableTimesText","description":"LCM formatted version of available times property","type":"string"},"passBlackoutDays":{"$id":"/properties/passBlackoutDays","description":"list of blackout dates (e.g. July 4, 2024). ","type":["array","null"]},"passCreatedAt":{"$id":"/properties/passCreatedAt","description":"when the pass was created","type":"string"},"passCurrencyCode":{"$id":"/properties/passCurrencyCode","description":"currency for all monetary fields","type":"string"},"passCurrent":{"$id":"/properties/passCurrent","description":"flag indicating that this is the current version for a pass. For a type/name/listing_id, there can only be one record with this attribute true.","type":"boolean"},"passDescription":{"$id":"/properties/passDescription","description":"free text description set by host","type":["string","null"]},"passDiscount":{"$id":"/properties/passDiscount","description":"discount amount. Fixed discounts will be in minors units.","type":["number","null"]},"passDiscountType":{"$id":"/properties/passDiscountType","description":"type of pass discount num[‘percentage’, ‘fixed’]","enum":["FIXED","PERCENTAGE",null],"type":["string","null"]},"passEligibleDays":{"$id":"/properties/passEligibleDays","description":"days the pass is eligible","type":["array","null"]},"passId":{"$id":"/properties/passId","description":"id of the pass","type":"integer"},"passMaxActivePasses":{"$id":"/properties/passMaxActivePasses","description":"max active passes allowed. This constraint will apply to the (listing_id, type, name) rather than id so that we can be accurate across edits.","type":["number","null"]},"passMaxDailyBookings":{"$id":"/properties/passMaxDailyBookings","description":"max bookings allowed under this pass","type":["number","null"]},"passMaxDuration":{"$id":"/properties/passMaxDuration","description":"max duration that may be booked using this pass","type":["number","null"]},"passMaxGuests":{"$id":"/properties/passMaxGuests","description":"max guests that may be booked using this pass","type":["number","null"]},"passName":{"$id":"/properties/passName","description":"the type of the pass formatted to be LCM friendly","pattern":"","type":"string"},"passPremiumAmenities":{"$id":"/properties/passPremiumAmenities","description":"the ids of all premium amenities included with the pass","type":["array","null"]},"passPrice":{"$id":"/properties/passPrice","description":"pass price in minor units","type":"string"},"passState":{"$id":"/properties/passState","description":"‘draft’ -> pass is being actively edited by the host via the creation flow. The step attribute below tracks the progress of the host through the creation flow.\n‘inactive’ -> pass has been created by the host, but not ready for sale yet\n‘active’ -> pass has passed the final availability requirements and has been marked by the host as ready for sale.","enum":["ACTIVE","DRAFT","INACTIVE"],"type":"string"},"passTotalPrice":{"$id":"/properties/passTotalPrice","description":"the pass of the price plus the service fee","type":"string"},"passType":{"$id":"/properties/passType","description":"the type of pass","enum":["ALL_ACCESS","EARLY_BIRD","FIXED_HOURS","WEEKDAY"],"type":"string"}},"required":["passTotalPrice","coverImageURL","listingURL","passDiscount","hostFirstName","passState","listingTitle","passName","passType","passCurrent","passDiscountType","passPrice","passCurrencyCode","passCreatedAt","passId","listingId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostSelectedPassAmenitiesIncluded', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostSelectedPassDayAndTimes' track call.
 *
 * @param HostSelectedPassDayAndTimes props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostSelectedPassDayAndTimes(props: HostSelectedPassDayAndTimes, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostSelectedPassDayAndTimes","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST PASS CREATION]","properties":{"coverImageURL":{"$id":"/properties/coverImageURL","description":"the url for the cover image of the listing the pass is for","type":"string"},"hostFirstName":{"$id":"/properties/hostFirstName","description":"first name of the host","type":"string"},"id":{"$id":"/properties/id","description":"","type":"string"},"listingId":{"$id":"/properties/listingId","description":"id of the listing the pass is for","type":"string"},"listingTitle":{"$id":"/properties/listingTitle","description":"the title of the listing the pass is for","type":"string"},"listingURL":{"$id":"/properties/listingURL","description":"the url of the listing the pass is for","type":"string"},"passAvailableTimes":{"$id":"/properties/passAvailableTimes","description":"[{from:”07:00:00”, “11:00:00”}...] Time slots when this pass is eligible","type":"array"},"passAvailableTimesText":{"$id":"/properties/passAvailableTimesText","description":"LCM formatted version of available times property","type":"string"},"passBlackoutDays":{"$id":"/properties/passBlackoutDays","description":"list of blackout dates (e.g. July 4, 2024). ","type":["array","null"]},"passCreatedAt":{"$id":"/properties/passCreatedAt","description":"when the pass was created","type":"string"},"passCurrencyCode":{"$id":"/properties/passCurrencyCode","description":"currency for all monetary fields","type":"string"},"passCurrent":{"$id":"/properties/passCurrent","description":"flag indicating that this is the current version for a pass. For a type/name/listing_id, there can only be one record with this attribute true.","type":"boolean"},"passDescription":{"$id":"/properties/passDescription","description":"free text description set by host","type":["string","null"]},"passDiscount":{"$id":"/properties/passDiscount","description":"discount amount. Fixed discounts will be in minors units.","type":["number","null"]},"passDiscountType":{"$id":"/properties/passDiscountType","description":"type of pass discount num[‘percentage’, ‘fixed’]","enum":["FIXED","PERCENTAGE",null],"type":["string","null"]},"passEligibleDays":{"$id":"/properties/passEligibleDays","description":"days the pass is eligible","type":["array","null"]},"passId":{"$id":"/properties/passId","description":"id of the pass","type":"integer"},"passMaxActivePasses":{"$id":"/properties/passMaxActivePasses","description":"max active passes allowed. This constraint will apply to the (listing_id, type, name) rather than id so that we can be accurate across edits.","type":["number","null"]},"passMaxDailyBookings":{"$id":"/properties/passMaxDailyBookings","description":"max bookings allowed under this pass","type":["number","null"]},"passMaxDuration":{"$id":"/properties/passMaxDuration","description":"max duration that may be booked using this pass","type":["number","null"]},"passMaxGuests":{"$id":"/properties/passMaxGuests","description":"max guests that may be booked using this pass","type":["number","null"]},"passName":{"$id":"/properties/passName","description":"the type of the pass formatted to be LCM friendly","pattern":"","type":"string"},"passPremiumAmenities":{"$id":"/properties/passPremiumAmenities","description":"the ids of all premium amenities included with the pass","type":["array","null"]},"passPrice":{"$id":"/properties/passPrice","description":"pass price in minor units","type":"string"},"passState":{"$id":"/properties/passState","description":"‘draft’ -> pass is being actively edited by the host via the creation flow. The step attribute below tracks the progress of the host through the creation flow.\n‘inactive’ -> pass has been created by the host, but not ready for sale yet\n‘active’ -> pass has passed the final availability requirements and has been marked by the host as ready for sale.","enum":["ACTIVE","DRAFT","INACTIVE"],"type":"string"},"passTotalPrice":{"$id":"/properties/passTotalPrice","description":"the pass of the price plus the service fee","type":"string"},"passType":{"$id":"/properties/passType","description":"the type of pass","enum":["ALL_ACCESS","EARLY_BIRD","FIXED_HOURS","WEEKDAY"],"type":"string"}},"required":["hostFirstName","passPrice","passCreatedAt","listingURL","passId","passState","passTotalPrice","passDiscountType","listingTitle","listingId","passType","passName","passCurrent","passDiscount","coverImageURL","passCurrencyCode"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostSelectedPassDayAndTimes', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostSelectedPassDescription' track call.
 *
 * @param HostSelectedPassDescription props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostSelectedPassDescription(props: HostSelectedPassDescription, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostSelectedPassDescription","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST PASS CREATION]","properties":{"coverImageURL":{"$id":"/properties/coverImageURL","description":"the url for the cover image of the listing the pass is for","type":"string"},"hostFirstName":{"$id":"/properties/hostFirstName","description":"first name of the host","type":"string"},"id":{"$id":"/properties/id","description":"","type":"string"},"listingId":{"$id":"/properties/listingId","description":"id of the listing the pass is for","type":"string"},"listingTitle":{"$id":"/properties/listingTitle","description":"the title of the listing the pass is for","type":"string"},"listingURL":{"$id":"/properties/listingURL","description":"the url of the listing the pass is for","type":"string"},"passAvailableTimes":{"$id":"/properties/passAvailableTimes","description":"[{from:”07:00:00”, “11:00:00”}...] Time slots when this pass is eligible","type":"array"},"passAvailableTimesText":{"$id":"/properties/passAvailableTimesText","description":"LCM formatted version of available times property","type":"string"},"passBlackoutDays":{"$id":"/properties/passBlackoutDays","description":"list of blackout dates (e.g. July 4, 2024). ","type":["array","null"]},"passCreatedAt":{"$id":"/properties/passCreatedAt","description":"when the pass was created","type":"string"},"passCurrencyCode":{"$id":"/properties/passCurrencyCode","description":"currency for all monetary fields","type":"string"},"passCurrent":{"$id":"/properties/passCurrent","description":"flag indicating that this is the current version for a pass. For a type/name/listing_id, there can only be one record with this attribute true.","type":"boolean"},"passDescription":{"$id":"/properties/passDescription","description":"free text description set by host","type":["string","null"]},"passDiscount":{"$id":"/properties/passDiscount","description":"discount amount. Fixed discounts will be in minors units.","type":["number","null"]},"passDiscountType":{"$id":"/properties/passDiscountType","description":"type of pass discount num[‘percentage’, ‘fixed’]","enum":["FIXED","PERCENTAGE",null],"type":["string","null"]},"passEligibleDays":{"$id":"/properties/passEligibleDays","description":"days the pass is eligible","type":["array","null"]},"passId":{"$id":"/properties/passId","description":"id of the pass","type":"integer"},"passMaxActivePasses":{"$id":"/properties/passMaxActivePasses","description":"max active passes allowed. This constraint will apply to the (listing_id, type, name) rather than id so that we can be accurate across edits.","type":["number","null"]},"passMaxDailyBookings":{"$id":"/properties/passMaxDailyBookings","description":"max bookings allowed under this pass","type":["number","null"]},"passMaxDuration":{"$id":"/properties/passMaxDuration","description":"max duration that may be booked using this pass","type":["number","null"]},"passMaxGuests":{"$id":"/properties/passMaxGuests","description":"max guests that may be booked using this pass","type":["number","null"]},"passName":{"$id":"/properties/passName","description":"the type of the pass formatted to be LCM friendly","pattern":"","type":"string"},"passPremiumAmenities":{"$id":"/properties/passPremiumAmenities","description":"the ids of all premium amenities included with the pass","type":["array","null"]},"passPrice":{"$id":"/properties/passPrice","description":"pass price in minor units","type":"string"},"passState":{"$id":"/properties/passState","description":"‘draft’ -> pass is being actively edited by the host via the creation flow. The step attribute below tracks the progress of the host through the creation flow.\n‘inactive’ -> pass has been created by the host, but not ready for sale yet\n‘active’ -> pass has passed the final availability requirements and has been marked by the host as ready for sale.","enum":["ACTIVE","DRAFT","INACTIVE"],"type":"string"},"passTotalPrice":{"$id":"/properties/passTotalPrice","description":"the pass of the price plus the service fee","type":"string"},"passType":{"$id":"/properties/passType","description":"the type of pass","enum":["ALL_ACCESS","EARLY_BIRD","FIXED_HOURS","WEEKDAY"],"type":"string"}},"required":["passCreatedAt","listingId","hostFirstName","listingURL","passState","passDiscount","listingTitle","passType","passTotalPrice","passId","passCurrencyCode","passDiscountType","passPrice","passName","coverImageURL","passCurrent"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostSelectedPassDescription', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostSelectedPassMaxGuests' track call.
 *
 * @param HostSelectedPassMaxGuests props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostSelectedPassMaxGuests(props: HostSelectedPassMaxGuests, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostSelectedPassMaxGuests","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST PASS CREATION]","properties":{"coverImageURL":{"$id":"/properties/coverImageURL","description":"the url for the cover image of the listing the pass is for","type":"string"},"hostFirstName":{"$id":"/properties/hostFirstName","description":"first name of the host","type":"string"},"id":{"$id":"/properties/id","description":"","type":"string"},"listingId":{"$id":"/properties/listingId","description":"id of the listing the pass is for","type":"string"},"listingTitle":{"$id":"/properties/listingTitle","description":"the title of the listing the pass is for","type":"string"},"listingURL":{"$id":"/properties/listingURL","description":"the url of the listing the pass is for","type":"string"},"passAvailableTimes":{"$id":"/properties/passAvailableTimes","description":"[{from:”07:00:00”, “11:00:00”}...] Time slots when this pass is eligible","type":"array"},"passAvailableTimesText":{"$id":"/properties/passAvailableTimesText","description":"LCM formatted version of available times property","type":"string"},"passBlackoutDays":{"$id":"/properties/passBlackoutDays","description":"list of blackout dates (e.g. July 4, 2024). ","type":["array","null"]},"passCreatedAt":{"$id":"/properties/passCreatedAt","description":"when the pass was created","type":"string"},"passCurrencyCode":{"$id":"/properties/passCurrencyCode","description":"currency for all monetary fields","type":"string"},"passCurrent":{"$id":"/properties/passCurrent","description":"flag indicating that this is the current version for a pass. For a type/name/listing_id, there can only be one record with this attribute true.","type":"boolean"},"passDescription":{"$id":"/properties/passDescription","description":"free text description set by host","type":["string","null"]},"passDiscount":{"$id":"/properties/passDiscount","description":"discount amount. Fixed discounts will be in minors units.","type":["number","null"]},"passDiscountType":{"$id":"/properties/passDiscountType","description":"type of pass discount num[‘percentage’, ‘fixed’]","enum":["FIXED","PERCENTAGE",null],"type":["string","null"]},"passEligibleDays":{"$id":"/properties/passEligibleDays","description":"days the pass is eligible","type":["array","null"]},"passId":{"$id":"/properties/passId","description":"id of the pass","type":"integer"},"passMaxActivePasses":{"$id":"/properties/passMaxActivePasses","description":"max active passes allowed. This constraint will apply to the (listing_id, type, name) rather than id so that we can be accurate across edits.","type":["number","null"]},"passMaxDailyBookings":{"$id":"/properties/passMaxDailyBookings","description":"max bookings allowed under this pass","type":["number","null"]},"passMaxDuration":{"$id":"/properties/passMaxDuration","description":"max duration that may be booked using this pass","type":["number","null"]},"passMaxGuests":{"$id":"/properties/passMaxGuests","description":"max guests that may be booked using this pass","type":["number","null"]},"passName":{"$id":"/properties/passName","description":"the type of the pass formatted to be LCM friendly","pattern":"","type":"string"},"passPremiumAmenities":{"$id":"/properties/passPremiumAmenities","description":"the ids of all premium amenities included with the pass","type":["array","null"]},"passPrice":{"$id":"/properties/passPrice","description":"pass price in minor units","type":"string"},"passState":{"$id":"/properties/passState","description":"‘draft’ -> pass is being actively edited by the host via the creation flow. The step attribute below tracks the progress of the host through the creation flow.\n‘inactive’ -> pass has been created by the host, but not ready for sale yet\n‘active’ -> pass has passed the final availability requirements and has been marked by the host as ready for sale.","enum":["ACTIVE","DRAFT","INACTIVE"],"type":"string"},"passTotalPrice":{"$id":"/properties/passTotalPrice","description":"the pass of the price plus the service fee","type":"string"},"passType":{"$id":"/properties/passType","description":"the type of pass","enum":["ALL_ACCESS","EARLY_BIRD","FIXED_HOURS","WEEKDAY"],"type":"string"}},"required":["hostFirstName","passState","coverImageURL","passDiscountType","passCurrencyCode","passId","passCurrent","passDiscount","listingURL","passType","passName","passCreatedAt","passPrice","passTotalPrice","listingId","listingTitle"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostSelectedPassMaxGuests', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostSelectedPassMaxHours' track call.
 *
 * @param HostSelectedPassMaxHours props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostSelectedPassMaxHours(props: HostSelectedPassMaxHours, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostSelectedPassMaxHours","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST PASS CREATION]","properties":{"coverImageURL":{"$id":"/properties/coverImageURL","description":"the url for the cover image of the listing the pass is for","type":"string"},"hostFirstName":{"$id":"/properties/hostFirstName","description":"first name of the host","type":"string"},"id":{"$id":"/properties/id","description":"","type":"string"},"listingId":{"$id":"/properties/listingId","description":"id of the listing the pass is for","type":"string"},"listingTitle":{"$id":"/properties/listingTitle","description":"the title of the listing the pass is for","type":"string"},"listingURL":{"$id":"/properties/listingURL","description":"the url of the listing the pass is for","type":"string"},"passAvailableTimes":{"$id":"/properties/passAvailableTimes","description":"[{from:”07:00:00”, “11:00:00”}...] Time slots when this pass is eligible","type":"array"},"passAvailableTimesText":{"$id":"/properties/passAvailableTimesText","description":"LCM formatted version of available times property","type":"string"},"passBlackoutDays":{"$id":"/properties/passBlackoutDays","description":"list of blackout dates (e.g. July 4, 2024). ","type":["array","null"]},"passCreatedAt":{"$id":"/properties/passCreatedAt","description":"when the pass was created","type":"string"},"passCurrencyCode":{"$id":"/properties/passCurrencyCode","description":"currency for all monetary fields","type":"string"},"passCurrent":{"$id":"/properties/passCurrent","description":"flag indicating that this is the current version for a pass. For a type/name/listing_id, there can only be one record with this attribute true.","type":"boolean"},"passDescription":{"$id":"/properties/passDescription","description":"free text description set by host","type":["string","null"]},"passDiscount":{"$id":"/properties/passDiscount","description":"discount amount. Fixed discounts will be in minors units.","type":["number","null"]},"passDiscountType":{"$id":"/properties/passDiscountType","description":"type of pass discount num[‘percentage’, ‘fixed’]","enum":["FIXED","PERCENTAGE",null],"type":["string","null"]},"passEligibleDays":{"$id":"/properties/passEligibleDays","description":"days the pass is eligible","type":["array","null"]},"passId":{"$id":"/properties/passId","description":"id of the pass","type":"integer"},"passMaxActivePasses":{"$id":"/properties/passMaxActivePasses","description":"max active passes allowed. This constraint will apply to the (listing_id, type, name) rather than id so that we can be accurate across edits.","type":["number","null"]},"passMaxDailyBookings":{"$id":"/properties/passMaxDailyBookings","description":"max bookings allowed under this pass","type":["number","null"]},"passMaxDuration":{"$id":"/properties/passMaxDuration","description":"max duration that may be booked using this pass","type":["number","null"]},"passMaxGuests":{"$id":"/properties/passMaxGuests","description":"max guests that may be booked using this pass","type":["number","null"]},"passName":{"$id":"/properties/passName","description":"the type of the pass formatted to be LCM friendly","pattern":"","type":"string"},"passPremiumAmenities":{"$id":"/properties/passPremiumAmenities","description":"the ids of all premium amenities included with the pass","type":["array","null"]},"passPrice":{"$id":"/properties/passPrice","description":"pass price in minor units","type":"string"},"passState":{"$id":"/properties/passState","description":"‘draft’ -> pass is being actively edited by the host via the creation flow. The step attribute below tracks the progress of the host through the creation flow.\n‘inactive’ -> pass has been created by the host, but not ready for sale yet\n‘active’ -> pass has passed the final availability requirements and has been marked by the host as ready for sale.","enum":["ACTIVE","DRAFT","INACTIVE"],"type":"string"},"passTotalPrice":{"$id":"/properties/passTotalPrice","description":"the pass of the price plus the service fee","type":"string"},"passType":{"$id":"/properties/passType","description":"the type of pass","enum":["ALL_ACCESS","EARLY_BIRD","FIXED_HOURS","WEEKDAY"],"type":"string"}},"required":["passType","listingTitle","passTotalPrice","passState","passName","listingId","listingURL","passCurrencyCode","coverImageURL","passCurrent","hostFirstName","passDiscount","passPrice","passDiscountType","passCreatedAt","passId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostSelectedPassMaxHours', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostSelectedPassPrice' track call.
 *
 * @param HostSelectedPassPrice props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostSelectedPassPrice(props: HostSelectedPassPrice, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostSelectedPassPrice","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST PASS CREATION]","properties":{"coverImageURL":{"$id":"/properties/coverImageURL","description":"the url for the cover image of the listing the pass is for","type":"string"},"hostFirstName":{"$id":"/properties/hostFirstName","description":"first name of the host","type":"string"},"id":{"$id":"/properties/id","description":"","type":"string"},"listingId":{"$id":"/properties/listingId","description":"id of the listing the pass is for","type":"string"},"listingTitle":{"$id":"/properties/listingTitle","description":"the title of the listing the pass is for","type":"string"},"listingURL":{"$id":"/properties/listingURL","description":"the url of the listing the pass is for","type":"string"},"passAvailableTimes":{"$id":"/properties/passAvailableTimes","description":"[{from:”07:00:00”, “11:00:00”}...] Time slots when this pass is eligible","type":"array"},"passAvailableTimesText":{"$id":"/properties/passAvailableTimesText","description":"LCM formatted version of available times property","type":"string"},"passBlackoutDays":{"$id":"/properties/passBlackoutDays","description":"list of blackout dates (e.g. July 4, 2024). ","type":["array","null"]},"passCreatedAt":{"$id":"/properties/passCreatedAt","description":"when the pass was created","type":"string"},"passCurrencyCode":{"$id":"/properties/passCurrencyCode","description":"currency for all monetary fields","type":"string"},"passCurrent":{"$id":"/properties/passCurrent","description":"flag indicating that this is the current version for a pass. For a type/name/listing_id, there can only be one record with this attribute true.","type":"boolean"},"passDescription":{"$id":"/properties/passDescription","description":"free text description set by host","type":["string","null"]},"passDiscount":{"$id":"/properties/passDiscount","description":"discount amount. Fixed discounts will be in minors units.","type":["number","null"]},"passDiscountType":{"$id":"/properties/passDiscountType","description":"type of pass discount num[‘percentage’, ‘fixed’]","enum":["FIXED","PERCENTAGE",null],"type":["string","null"]},"passEligibleDays":{"$id":"/properties/passEligibleDays","description":"days the pass is eligible","type":["array","null"]},"passId":{"$id":"/properties/passId","description":"id of the pass","type":"integer"},"passMaxActivePasses":{"$id":"/properties/passMaxActivePasses","description":"max active passes allowed. This constraint will apply to the (listing_id, type, name) rather than id so that we can be accurate across edits.","type":["number","null"]},"passMaxDailyBookings":{"$id":"/properties/passMaxDailyBookings","description":"max bookings allowed under this pass","type":["number","null"]},"passMaxDuration":{"$id":"/properties/passMaxDuration","description":"max duration that may be booked using this pass","type":["number","null"]},"passMaxGuests":{"$id":"/properties/passMaxGuests","description":"max guests that may be booked using this pass","type":["number","null"]},"passName":{"$id":"/properties/passName","description":"the type of the pass formatted to be LCM friendly","pattern":"","type":"string"},"passPremiumAmenities":{"$id":"/properties/passPremiumAmenities","description":"the ids of all premium amenities included with the pass","type":["array","null"]},"passPrice":{"$id":"/properties/passPrice","description":"pass price in minor units","type":"string"},"passState":{"$id":"/properties/passState","description":"‘draft’ -> pass is being actively edited by the host via the creation flow. The step attribute below tracks the progress of the host through the creation flow.\n‘inactive’ -> pass has been created by the host, but not ready for sale yet\n‘active’ -> pass has passed the final availability requirements and has been marked by the host as ready for sale.","enum":["ACTIVE","DRAFT","INACTIVE"],"type":"string"},"passTotalPrice":{"$id":"/properties/passTotalPrice","description":"the pass of the price plus the service fee","type":"string"},"passType":{"$id":"/properties/passType","description":"the type of pass","enum":["ALL_ACCESS","EARLY_BIRD","FIXED_HOURS","WEEKDAY"],"type":"string"}},"required":["passCurrencyCode","passCreatedAt","listingTitle","passState","passCurrent","passDiscountType","passPrice","passDiscount","listingURL","passId","hostFirstName","passName","passType","passTotalPrice","listingId","coverImageURL"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostSelectedPassPrice', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostSelectedRescheduleReason' track call.
 *
 * @param HostSelectedRescheduleReason props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostSelectedRescheduleReason(props: HostSelectedRescheduleReason, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostSelectedRescheduleReason","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST RESERVATION] host selected one of the reasons to reschedule","properties":{"bookingId":{"$id":"/properties/bookingId","description":"id of the booking the reservation pertains to","type":"integer"},"bookingWithPass":{"$id":"/properties/bookingWithPass","description":"was the booking made using a pass","enum":["FALSE","PARTIAL","TRUE"],"type":"string"},"passId":{"$id":"/properties/passId","description":"if the booking was made or partially made with a pass, the pass id used","type":["integer","null"]},"passName":{"$id":"/properties/passName","description":"the type of the pass formatted to be LCM friendly\n","type":["string","null"]},"passType":{"$id":"/properties/passType","description":"if the booking was made or partially made with a pass, what type of pass","enum":["ALL_ACCESS","EARLY_BIRD","WEEKDAY",null],"type":["string","null"]},"reasonSelected":{"$id":"/properties/reasonSelected","description":"reason selected by host","type":"string"},"userPassId":{"$id":"/properties/userPassId","description":"if the booking was made or partially made with a pass, what was the user pass Id used","type":["integer","null"]}},"required":["bookingId","reasonSelected"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostSelectedRescheduleReason', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostSelectedThirdPartyPublicAccess' track call.
 *
 * @param HostSelectedThirdPartyPublicAccess props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostSelectedThirdPartyPublicAccess(props: HostSelectedThirdPartyPublicAccess, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostSelectedThirdPartyPublicAccess","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST ONBOARDING] host read all and agree neighbor guidelines","properties":{"allowsAccess":{"$id":"/properties/allowsAccess","description":"True if the host gives Swimply permissions to post/manage public posts of the host's listing on Google, Yelp, etc (and false if not)","type":"boolean"}},"required":["allowsAccess"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostSelectedThirdPartyPublicAccess', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostSentSpecialOffer' track call.
 *
 * @param HostSentSpecialOffer props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostSentSpecialOffer(props: HostSentSpecialOffer, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostSentSpecialOffer","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST BOOKING INQUIRY SENDING SPECIAL OFFER]","properties":{"bookingId":{"$id":"/properties/bookingId","description":"","type":["number","null"]},"bookingSpecialOfferId":{"$id":"/properties/bookingSpecialOfferId","description":"","type":"number"},"courtesyNote":{"$id":"/properties/courtesyNote","description":"","type":["string","null"]},"globalListingType":{"$id":"/properties/globalListingType","description":"[LISTING TYPE] The type of the listing associated with this event","enum":["artStudio","basketballCourt","dockedBoat","home","homeGym","joyspace","kitchen","largeBackyard","musicStudio","other","pending","pickleball","pool","privateLake","roofDeck","tennisCourt"],"type":"string"},"guestId":{"$id":"/properties/guestId","description":"","type":"integer"},"hostId":{"$id":"/properties/hostId","description":"","type":"integer"},"listingId":{"$id":"/properties/listingId","description":"","type":"integer"},"messageSentId":{"$id":"/properties/messageSentId","description":"new message id for the message with special offer","type":"number"},"originalPrice":{"$id":"/properties/originalPrice","description":"","type":"number"},"roomId":{"$id":"/properties/roomId","description":"","type":"string"},"specialOfferPrice":{"$id":"/properties/specialOfferPrice","description":"","type":"number"}},"required":["guestId","hostId","listingId","bookingSpecialOfferId","messageSentId","originalPrice","globalListingType","specialOfferPrice"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostSentSpecialOffer', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostSpaceDetailsAccess' track call.
 *
 * @param HostSpaceDetailsAccess props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostSpaceDetailsAccess(props: HostSpaceDetailsAccess, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostSpaceDetailsAccess","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST ONBOARDING] host edited space details for access","properties":{"enteredFrom":{"$id":"/properties/enteredFrom","description":"All possible values for enteredFrom in host onboarding","enum":["ProfilePhotosScreen","ProfileScreen","austin","austinFB","clarkRubber","dipApp","directPoolSupplies","existingHostNewListingFlow","hostExistingListingManagement","hostOnboardingFlow","houston","houstonFB","losangeles","losangelesFB","newYork","newYorkFB","noListingsScreen","performanceTips","ph","poolProfits","poolSafetySolutions","portland","portlandFB","precisionPoolsAndLandscape","profileManageListings","sanAntonio","sanAntonioFB","seattle","seattleFB","swimUniversity","toronto","torontoFB","vip"],"type":"string"},"entryInstructionsEntered":{"$id":"/properties/entryInstructionsEntered","description":"blurb for entry instructions","type":"string"},"listingId":{"$id":"/properties/listingId","description":"id for the related listing","type":"string"},"photosAttached":{"$id":"/properties/photosAttached","description":"details about photos added","properties":{"arePhotosAttached":{"$id":"/properties/properties/properties/photosAttached/properties/arePhotosAttached","description":"did host add any photos","type":"boolean"},"numPhotos":{"$id":"/properties/properties/properties/photosAttached/properties/numPhotos","description":"number of photos host attached","type":"integer"}},"required":["numPhotos","arePhotosAttached"],"type":"object"},"poolId":{"$id":"/properties/poolId","description":"legacy name for listing id","type":"string"},"pressedSaveExit":{"$id":"/properties/pressedSaveExit","description":"pressed \"save and exit\" to remove from flow","type":"boolean"}},"required":["pressedSaveExit","entryInstructionsEntered","enteredFrom","listingId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostSpaceDetailsAccess', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostSpaceDetailsBathroom' track call.
 *
 * @param HostSpaceDetailsBathroom props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostSpaceDetailsBathroom(props: HostSpaceDetailsBathroom, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostSpaceDetailsBathroom","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST ONBOARDING] host bathroom availability details","properties":{"bathroomCount":{"$id":"/properties/bathroomCount","description":"number of bathrooms","type":"number"},"bathroomTypeSelected":{"$id":"/properties/bathroomTypeSelected","description":"what kind of bathroom did the host add","type":"string"},"enteredFrom":{"$id":"/properties/enteredFrom","description":"All possible values for enteredFrom in host onboarding","enum":["ProfilePhotosScreen","ProfileScreen","austin","austinFB","clarkRubber","dipApp","directPoolSupplies","existingHostNewListingFlow","hostExistingListingManagement","hostOnboardingFlow","houston","houstonFB","losangeles","losangelesFB","newYork","newYorkFB","noListingsScreen","performanceTips","ph","poolProfits","poolSafetySolutions","portland","portlandFB","precisionPoolsAndLandscape","profileManageListings","sanAntonio","sanAntonioFB","seattle","seattleFB","swimUniversity","toronto","torontoFB","vip"],"type":"string"},"globalListingType":{"$id":"/properties/globalListingType","description":"[LISTING TYPE] The type of the listing associated with this event","enum":["artStudio","basketballCourt","dockedBoat","home","homeGym","joyspace","kitchen","largeBackyard","musicStudio","other","pending","pickleball","pool","privateLake","roofDeck","tennisCourt"],"type":"string"},"listingId":{"$id":"/properties/listingId","description":"id for the related listing","type":"string"},"poolId":{"$id":"/properties/poolId","description":"legacy name for listing id","type":"string"},"pressedSaveExit":{"$id":"/properties/pressedSaveExit","description":"pressed \"save and exit\" to remove from flow","type":"boolean"}},"required":["bathroomTypeSelected","globalListingType","pressedSaveExit","bathroomCount","listingId","enteredFrom"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostSpaceDetailsBathroom', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostSpaceDetailsEntered' track call.
 *
 * @param HostSpaceDetailsEntered props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostSpaceDetailsEntered(props: HostSpaceDetailsEntered, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostSpaceDetailsEntered","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST ONBOARDING] host details about the space ","properties":{"enteredFrom":{"$id":"/properties/enteredFrom","description":"All possible values for enteredFrom in host onboarding","enum":["ProfilePhotosScreen","ProfileScreen","austin","austinFB","clarkRubber","dipApp","directPoolSupplies","existingHostNewListingFlow","hostExistingListingManagement","hostOnboardingFlow","houston","houstonFB","losangeles","losangelesFB","newYork","newYorkFB","noListingsScreen","performanceTips","ph","poolProfits","poolSafetySolutions","portland","portlandFB","precisionPoolsAndLandscape","profileManageListings","sanAntonio","sanAntonioFB","seattle","seattleFB","swimUniversity","toronto","torontoFB","vip"],"type":"string"},"listingId":{"$id":"/properties/listingId","description":"id for the related listing","type":"string"},"numLoungeChairs":{"$id":"/properties/numLoungeChairs","description":"num of lounge chairs available","type":"integer"},"numLunchTables":{"$id":"/properties/numLunchTables","description":"num of lunch tables available","type":"integer"},"numUmbrellas":{"$id":"/properties/numUmbrellas","description":"num of umbrellas available","type":"integer"},"otherFurniture":{"$id":"/properties/otherFurniture","description":"blurb for other furniture available","type":"string"},"poolId":{"$id":"/properties/poolId","description":"legacy name for listing id","type":"string"},"pressedSaveExit":{"$id":"/properties/pressedSaveExit","description":"\npressed \"save and exit\" to remove from flow","type":"boolean"}},"required":["otherFurniture","pressedSaveExit","numUmbrellas","enteredFrom","listingId","numLoungeChairs","numLunchTables"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostSpaceDetailsEntered', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostSpaceDetailsParking' track call.
 *
 * @param HostSpaceDetailsParking props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostSpaceDetailsParking(props: HostSpaceDetailsParking, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostSpaceDetailsParking","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST ONBOARDING] host entered details about parking","properties":{"carParkContext":{"$id":"/properties/carParkContext","description":"blurb about parking car information","type":"string"},"enteredFrom":{"$id":"/properties/enteredFrom","description":"All possible values for enteredFrom in host onboarding","enum":["ProfilePhotosScreen","ProfileScreen","austin","austinFB","clarkRubber","dipApp","directPoolSupplies","existingHostNewListingFlow","hostExistingListingManagement","hostOnboardingFlow","houston","houstonFB","losangeles","losangelesFB","newYork","newYorkFB","noListingsScreen","performanceTips","ph","poolProfits","poolSafetySolutions","portland","portlandFB","precisionPoolsAndLandscape","profileManageListings","sanAntonio","sanAntonioFB","seattle","seattleFB","swimUniversity","toronto","torontoFB","vip"],"type":"string"},"listingId":{"$id":"/properties/listingId","description":"id for the related listing","type":"string"},"numCarsPark":{"$id":"/properties/numCarsPark","description":"number of cars that can park at house","type":"integer"},"otherParkOptions":{"$id":"/properties/otherParkOptions","description":"selection for other nearby parking options","type":["array","null"]},"poolId":{"$id":"/properties/poolId","description":"legacy name for listing id","type":"string"},"pressedSaveExit":{"$id":"/properties/pressedSaveExit","description":"pressed \"save and exit\" to remove from flow","type":"boolean"}},"required":["pressedSaveExit","numCarsPark","carParkContext","otherParkOptions","listingId","enteredFrom"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostSpaceDetailsParking', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostSpaceDetailsPrivacy' track call.
 *
 * @param HostSpaceDetailsPrivacy props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostSpaceDetailsPrivacy(props: HostSpaceDetailsPrivacy, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostSpaceDetailsPrivacy","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST ONBOARDING] host entered information about privacy of pool","properties":{"enteredFrom":{"$id":"/properties/enteredFrom","description":"All possible values for enteredFrom in host onboarding","enum":["ProfilePhotosScreen","ProfileScreen","austin","austinFB","clarkRubber","dipApp","directPoolSupplies","existingHostNewListingFlow","hostExistingListingManagement","hostOnboardingFlow","houston","houstonFB","losangeles","losangelesFB","newYork","newYorkFB","noListingsScreen","performanceTips","ph","poolProfits","poolSafetySolutions","portland","portlandFB","precisionPoolsAndLandscape","profileManageListings","sanAntonio","sanAntonioFB","seattle","seattleFB","swimUniversity","toronto","torontoFB","vip"],"type":"string"},"listingId":{"$id":"/properties/listingId","description":"id for the related listing","type":"string"},"poolId":{"$id":"/properties/poolId","description":"legacy name for listing id","type":"string"},"pressedSaveExit":{"$id":"/properties/pressedSaveExit","description":"pressed \"save and exit\" to remove from flow","type":"boolean"},"privacySelection":{"$id":"/properties/privacySelection","description":"how private is the pool area","type":"string"}},"required":["enteredFrom","privacySelection","listingId","pressedSaveExit"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostSpaceDetailsPrivacy', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostSpaceDetailsSetting' track call.
 *
 * @param HostSpaceDetailsSetting props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostSpaceDetailsSetting(props: HostSpaceDetailsSetting, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostSpaceDetailsSetting","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST ONBOARDING] host entered information about the setting of the listing ","properties":{"enteredFrom":{"$id":"/properties/enteredFrom","description":"All possible values for enteredFrom in host onboarding","enum":["ProfilePhotosScreen","ProfileScreen","austin","austinFB","clarkRubber","dipApp","directPoolSupplies","existingHostNewListingFlow","hostExistingListingManagement","hostOnboardingFlow","houston","houstonFB","losangeles","losangelesFB","newYork","newYorkFB","noListingsScreen","performanceTips","ph","poolProfits","poolSafetySolutions","portland","portlandFB","precisionPoolsAndLandscape","profileManageListings","sanAntonio","sanAntonioFB","seattle","seattleFB","swimUniversity","toronto","torontoFB","vip"],"type":"string"},"globalListingType":{"$id":"/properties/globalListingType","description":"[LISTING TYPE] The type of the listing associated with this event","enum":["artStudio","basketballCourt","dockedBoat","home","homeGym","joyspace","kitchen","largeBackyard","musicStudio","other","pending","pickleball","pool","privateLake","roofDeck","tennisCourt"],"type":"string"},"listingId":{"$id":"/properties/listingId","description":"id for the related listing","type":"string"},"poolId":{"$id":"/properties/poolId","description":"legacy name for listing id","type":"string"},"pressedSaveExit":{"$id":"/properties/pressedSaveExit","description":"pressed \"save and exit\" to remove from flow","type":"boolean"},"setting":{"$id":"/properties/setting","description":"the setting of the listing ","enum":["indoor","mixed","outdoor"],"type":"string"}},"required":["listingId","setting","pressedSaveExit","globalListingType","enteredFrom"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostSpaceDetailsSetting', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostStartedSyncWCronofy' track call.
 *
 * @param HostStartedSyncWCronofy props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostStartedSyncWCronofy(props: HostStartedSyncWCronofy, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostStartedSyncWCronofy","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST CALENDAR SYNCING] after pressing the cog wheel and then \"sync external calendars\" host pressed \"Sync with Cronofy\" and then pressed “Sync with Cronofy” again on the pop up to start the sync flow","properties":{"enteredFrom":{"$id":"/properties/enteredFrom","description":"","enum":["manage_existing","new_sync"],"type":"string"},"listingId":{"$id":"/properties/listingId","description":"","type":"integer"}},"required":["listingId","enteredFrom"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostStartedSyncWCronofy', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostSubmittedCancellation' track call.
 *
 * @param HostSubmittedCancellation props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostSubmittedCancellation(props: HostSubmittedCancellation, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostSubmittedCancellation","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST RESERVATION] host pressed to send cancel to guest","properties":{"bookingId":{"$id":"/properties/bookingId","description":"id of the booking this pertains to","type":"integer"},"bookingWithPass":{"$id":"/properties/bookingWithPass","description":"was the booking made using a pass","enum":["FALSE","PARTIAL","TRUE"],"type":"string"},"messageId":{"$id":"/properties/messageId","description":"message id of the message sent to guest regarding the cancellation","type":"integer"},"passId":{"$id":"/properties/passId","description":"if the booking was made or partially made with a pass, the pass id used","type":["integer","null"]},"passName":{"$id":"/properties/passName","description":"the type of the pass formatted to be LCM friendly\n","type":["string","null"]},"passType":{"$id":"/properties/passType","description":"if the booking was made or partially made with a pass, what type of pass","enum":["ALL_ACCESS","EARLY_BIRD","WEEKDAY",null],"type":["string","null"]},"reasonSelected":{"$id":"/properties/reasonSelected","description":"reason for cancellation selected by the host","type":"string"},"userPassId":{"$id":"/properties/userPassId","description":"if the booking was made or partially made with a pass, what was the user pass Id used","type":["integer","null"]}},"required":["reasonSelected","messageId","bookingId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostSubmittedCancellation', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostSubmittedDecline' track call.
 *
 * @param HostSubmittedDecline props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostSubmittedDecline(props: HostSubmittedDecline, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostSubmittedDecline","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST RESERVATION] host pressed to send cancel to guest","properties":{"bookingId":{"$id":"/properties/bookingId","description":"id of the booking this pertains to","type":"integer"},"bookingWithPass":{"$id":"/properties/bookingWithPass","description":"was the booking made using a pass","enum":["FALSE","PARTIAL","TRUE"],"type":"string"},"messageId":{"$id":"/properties/messageId","description":"message id of the message sent to guest regarding the decline","type":"integer"},"passId":{"$id":"/properties/passId","description":"if the booking was made or partially made with a pass, the pass id used","type":["integer","null"]},"passName":{"$id":"/properties/passName","description":"the type of the pass formatted to be LCM friendly\n","type":["string","null"]},"passType":{"$id":"/properties/passType","description":"if the booking was made or partially made with a pass, what type of pass","enum":["ALL_ACCESS","EARLY_BIRD","WEEKDAY",null],"type":["string","null"]},"reasonSelected":{"$id":"/properties/reasonSelected","description":"reason for decline selected by the host","type":"string"},"userPassId":{"$id":"/properties/userPassId","description":"if the booking was made or partially made with a pass, what was the user pass Id used","type":["integer","null"]}},"required":["reasonSelected","messageId","bookingId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostSubmittedDecline', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostSubmittedDeleteImportCalendar' track call.
 *
 * @param HostSubmittedDeleteImportCalendar props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostSubmittedDeleteImportCalendar(props: HostSubmittedDeleteImportCalendar, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostSubmittedDeleteImportCalendar","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST CALENDAR SYNCING] Host confirmed \"Delete Calendar\" after having pressed \"Done\" ","properties":{"calendarName":{"$id":"/properties/calendarName","description":"","type":"string"},"listingId":{"$id":"/properties/listingId","description":"","type":"integer"}},"required":["calendarName","listingId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostSubmittedDeleteImportCalendar', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostSubmittedDisconnectCronofy' track call.
 *
 * @param HostSubmittedDisconnectCronofy props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostSubmittedDisconnectCronofy(props: HostSubmittedDisconnectCronofy, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostSubmittedDisconnectCronofy","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST CALENDAR SYNCING] fires when the host pressed \"Disconnect Cronofy\" on the pop up after deleting the calendar and pressing the \"Disconnect Cronofy\" CTA","properties":{"listingId":{"$id":"/properties/listingId","description":"","type":"string"}},"required":["listingId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostSubmittedDisconnectCronofy', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostSubmittedImportCalendarFailure' track call.
 *
 * @param HostSubmittedImportCalendarFailure props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostSubmittedImportCalendarFailure(props: HostSubmittedImportCalendarFailure, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostSubmittedImportCalendarFailure","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST CALENDAR SYNCING] fires after the host pressed \"Import from iCal\" on the pop up after pressing the \"Import external iCalendar\" and the import fails","properties":{"calendarName":{"$id":"/properties/calendarName","description":"","type":"string"},"calendarURL":{"$id":"/properties/calendarURL","description":"","type":"string"},"listingId":{"$id":"/properties/listingId","description":"","type":"integer"}},"required":["listingId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostSubmittedImportCalendarFailure', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostSubmittedImportCalendarSuccess' track call.
 *
 * @param HostSubmittedImportCalendarSuccess props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostSubmittedImportCalendarSuccess(props: HostSubmittedImportCalendarSuccess, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostSubmittedImportCalendarSuccess","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST CALENDAR SYNCING] fires after the host pressed \"Import from iCal\" on the pop up after pressing the \"Import external iCalendar\" and the import is successful","properties":{"calendarName":{"$id":"/properties/calendarName","description":"","type":"string"},"calendarURL":{"$id":"/properties/calendarURL","description":"","type":"string"},"listingId":{"$id":"/properties/listingId","description":"","type":"integer"}},"required":["calendarURL","calendarName","listingId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostSubmittedImportCalendarSuccess', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostSubmittedListingForReview' track call.
 *
 * @param HostSubmittedListingForReview props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostSubmittedListingForReview(props: HostSubmittedListingForReview, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostSubmittedListingForReview","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST ONBOARDING] host finished setting up the listing","properties":{"enteredFrom":{"$id":"/properties/enteredFrom","description":"All possible values for enteredFrom in host onboarding","enum":["ProfilePhotosScreen","ProfileScreen","austin","austinFB","clarkRubber","dipApp","directPoolSupplies","existingHostNewListingFlow","hostExistingListingManagement","hostOnboardingFlow","houston","houstonFB","losangeles","losangelesFB","newYork","newYorkFB","noListingsScreen","performanceTips","ph","poolProfits","poolSafetySolutions","portland","portlandFB","precisionPoolsAndLandscape","profileManageListings","sanAntonio","sanAntonioFB","seattle","seattleFB","swimUniversity","toronto","torontoFB","vip"],"type":"string"},"globalListingType":{"$id":"/properties/globalListingType","description":"[LISTING TYPE] The type of the listing associated with this event","enum":["artStudio","basketballCourt","dockedBoat","home","homeGym","joyspace","kitchen","largeBackyard","musicStudio","other","pending","pickleball","pool","privateLake","roofDeck","tennisCourt"],"type":"string"},"listingCityMetaFormat":{"$id":"/properties/listingCityMetaFormat","description":"Lowercase only with no punctuation, no special characters, and no spaces. If using special characters, the text must be encoded in UTF-8 format.","type":"string"},"listingCountryCode":{"$id":"/properties/listingCountryCode","description":"Use the lowercase, 2-letter country codes in ISO 3166-1 alpha-2","type":"string"},"listingId":{"$id":"/properties/listingId","description":"id for the related listing","type":"string"},"listingStateMetaFormat":{"$id":"/properties/listingStateMetaFormat","description":"Use the 2-character ANSI abbreviation code in lowercase. Normalize states outside the U.S. in lowercase with no punctuation, no special characters, and no spaces.","type":"string"},"listingZipcodeMetaFormat":{"$id":"/properties/listingZipcodeMetaFormat","description":"Use lowercase with no spaces and no dash. Use only the first 5 digits for U.S. zip codes. Use the area, district, and sector format for the UK.","type":"string"},"poolId":{"$id":"/properties/poolId","description":"legacy name for listing id","type":"string"},"pressedSaveExit":{"$id":"/properties/pressedSaveExit","description":"pressed \"save and exit\" to remove from flow","type":"boolean"}},"required":["enteredFrom","pressedSaveExit","listingCountryCode","listingStateMetaFormat","listingZipcodeMetaFormat","globalListingType","listingId","listingCityMetaFormat"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostSubmittedListingForReview', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostSubmittedPassChangeSurvey' track call.
 *
 * @param HostSubmittedPassChangeSurvey props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostSubmittedPassChangeSurvey(props: HostSubmittedPassChangeSurvey, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostSubmittedPassChangeSurvey","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST PASS MANAGEMENT - REFUND]","properties":{"cancellationReason":{"$id":"/properties/cancellationReason","description":"the host's reason for cancelling the pass","enum":["availability","earnings","maintenance","other","personal",null],"type":["string","null"]},"coverImageURL":{"$id":"/properties/coverImageURL","description":"the url for the cover image of the listing the pass is for","type":"string"},"hostFirstName":{"$id":"/properties/hostFirstName","description":"first name of the host","type":"string"},"id":{"$id":"/properties/id","description":"","type":"string"},"listingId":{"$id":"/properties/listingId","description":"id of the listing the pass is for","type":"string"},"listingTitle":{"$id":"/properties/listingTitle","description":"the title of the listing the pass is for","type":"string"},"listingURL":{"$id":"/properties/listingURL","description":"the url of the listing the pass is for","type":"string"},"passAvailableTimes":{"$id":"/properties/passAvailableTimes","description":"[{from:”07:00:00”, “11:00:00”}...] Time slots when this pass is eligible","type":"array"},"passAvailableTimesText":{"$id":"/properties/passAvailableTimesText","description":"LCM formatted version of available times property","type":"string"},"passBlackoutDays":{"$id":"/properties/passBlackoutDays","description":"list of blackout dates (e.g. July 4, 2024). ","type":["array","null"]},"passChange":{"$id":"/properties/passChange","description":"why is the pass being cancelled","enum":["deactivation","refund",null],"type":["string","null"]},"passCreatedAt":{"$id":"/properties/passCreatedAt","description":"when the pass was created","type":"string"},"passCurrencyCode":{"$id":"/properties/passCurrencyCode","description":"currency for all monetary fields","type":"string"},"passCurrent":{"$id":"/properties/passCurrent","description":"flag indicating that this is the current version for a pass. For a type/name/listing_id, there can only be one record with this attribute true.","type":"boolean"},"passDescription":{"$id":"/properties/passDescription","description":"free text description set by host","type":["string","null"]},"passDiscount":{"$id":"/properties/passDiscount","description":"discount amount. Fixed discounts will be in minors units.","type":["number","null"]},"passDiscountType":{"$id":"/properties/passDiscountType","description":"type of pass discount num[‘percentage’, ‘fixed’]","enum":["FIXED","PERCENTAGE",null],"type":["string","null"]},"passEligibleDays":{"$id":"/properties/passEligibleDays","description":"days the pass is eligible","type":["array","null"]},"passId":{"$id":"/properties/passId","description":"id of the pass","type":"integer"},"passMaxActivePasses":{"$id":"/properties/passMaxActivePasses","description":"max active passes allowed. This constraint will apply to the (listing_id, type, name) rather than id so that we can be accurate across edits.","type":["number","null"]},"passMaxDailyBookings":{"$id":"/properties/passMaxDailyBookings","description":"max bookings allowed under this pass","type":["number","null"]},"passMaxDuration":{"$id":"/properties/passMaxDuration","description":"max duration that may be booked using this pass","type":["number","null"]},"passMaxGuests":{"$id":"/properties/passMaxGuests","description":"max guests that may be booked using this pass","type":["number","null"]},"passName":{"$id":"/properties/passName","description":"the type of the pass formatted to be LCM friendly","pattern":"","type":"string"},"passPremiumAmenities":{"$id":"/properties/passPremiumAmenities","description":"the ids of all premium amenities included with the pass","type":["array","null"]},"passPrice":{"$id":"/properties/passPrice","description":"pass price in minor units","type":"string"},"passState":{"$id":"/properties/passState","description":"‘draft’ -> pass is being actively edited by the host via the creation flow. The step attribute below tracks the progress of the host through the creation flow.\n‘inactive’ -> pass has been created by the host, but not ready for sale yet\n‘active’ -> pass has passed the final availability requirements and has been marked by the host as ready for sale.","enum":["ACTIVE","DRAFT","INACTIVE"],"type":"string"},"passTotalPrice":{"$id":"/properties/passTotalPrice","description":"the pass of the price plus the service fee","type":"string"},"passType":{"$id":"/properties/passType","description":"the type of pass","enum":["ALL_ACCESS","EARLY_BIRD","FIXED_HOURS","WEEKDAY"],"type":"string"}},"required":["passType","passState","listingTitle","listingURL","coverImageURL","passDiscount","passCurrent","hostFirstName","passPrice","passName","passCreatedAt","passCurrencyCode","passTotalPrice","passDiscountType","passChange","passId","listingId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostSubmittedPassChangeSurvey', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostSubmittedPassRefundNote' track call.
 *
 * @param HostSubmittedPassRefundNote props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostSubmittedPassRefundNote(props: HostSubmittedPassRefundNote, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostSubmittedPassRefundNote","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST PASS MANAGEMENT - REFUND]","properties":{"canceled":{"$id":"/properties/canceled","description":"","type":"boolean"},"canceledReason":{"$id":"/properties/canceledReason","description":"","type":"string"},"courtesyNote":{"$id":"/properties/courtesyNote","description":"","type":"string"},"coverImageURL":{"$id":"/properties/coverImageURL","description":"the url for the cover image of the listing the pass is for","type":"string"},"createdAt":{"$id":"/properties/createdAt","description":"","type":"string"},"end":{"$id":"/properties/end","description":"","type":"string"},"hasAutorenewOn":{"$id":"/properties/hasAutorenewOn","description":"","type":"boolean"},"hostFirstName":{"$id":"/properties/hostFirstName","description":"first name of the host","type":"string"},"id":{"$id":"/properties/id","description":"","type":"string"},"isLegacy":{"$id":"/properties/isLegacy","description":"true if the pass is a legacy pass","type":"boolean"},"listingId":{"$id":"/properties/listingId","description":"id of the listing the pass is for","type":"string"},"listingTitle":{"$id":"/properties/listingTitle","description":"the title of the listing the pass is for","type":"string"},"listingURL":{"$id":"/properties/listingURL","description":"the url of the listing the pass is for","type":"string"},"passAvailableTimes":{"$id":"/properties/passAvailableTimes","description":"[{from:”07:00:00”, “11:00:00”}...] Time slots when this pass is eligible","type":"array"},"passAvailableTimesText":{"$id":"/properties/passAvailableTimesText","description":"LCM formatted version of available times property","type":"string"},"passBlackoutDays":{"$id":"/properties/passBlackoutDays","description":"list of blackout dates (e.g. July 4, 2024). ","type":["array","null"]},"passCreatedAt":{"$id":"/properties/passCreatedAt","description":"when the pass was created","type":"string"},"passCurrencyCode":{"$id":"/properties/passCurrencyCode","description":"currency for all monetary fields","type":"string"},"passCurrent":{"$id":"/properties/passCurrent","description":"flag indicating that this is the current version for a pass. For a type/name/listing_id, there can only be one record with this attribute true.","type":"boolean"},"passDescription":{"$id":"/properties/passDescription","description":"free text description set by host","type":["string","null"]},"passDiscount":{"$id":"/properties/passDiscount","description":"discount amount. Fixed discounts will be in minors units.","type":["number","null"]},"passDiscountType":{"$id":"/properties/passDiscountType","description":"type of pass discount num[‘percentage’, ‘fixed’]","enum":["FIXED","PERCENTAGE",null],"type":["string","null"]},"passEligibleDays":{"$id":"/properties/passEligibleDays","description":"days the pass is eligible","type":["array","null"]},"passId":{"$id":"/properties/passId","description":"id of the pass","type":"integer"},"passMaxActivePasses":{"$id":"/properties/passMaxActivePasses","description":"max active passes allowed. This constraint will apply to the (listing_id, type, name) rather than id so that we can be accurate across edits.","type":["number","null"]},"passMaxDailyBookings":{"$id":"/properties/passMaxDailyBookings","description":"max bookings allowed under this pass","type":["number","null"]},"passMaxDuration":{"$id":"/properties/passMaxDuration","description":"max duration that may be booked using this pass","type":["number","null"]},"passMaxGuests":{"$id":"/properties/passMaxGuests","description":"max guests that may be booked using this pass","type":["number","null"]},"passName":{"$id":"/properties/passName","description":"the type of the pass formatted to be LCM friendly","pattern":"","type":"string"},"passPremiumAmenities":{"$id":"/properties/passPremiumAmenities","description":"the ids of all premium amenities included with the pass","type":["array","null"]},"passPrice":{"$id":"/properties/passPrice","description":"pass price in minor units","type":"string"},"passState":{"$id":"/properties/passState","description":"‘draft’ -> pass is being actively edited by the host via the creation flow. The step attribute below tracks the progress of the host through the creation flow.\n‘inactive’ -> pass has been created by the host, but not ready for sale yet\n‘active’ -> pass has passed the final availability requirements and has been marked by the host as ready for sale.","enum":["ACTIVE","DRAFT","INACTIVE"],"type":"string"},"passTotalPrice":{"$id":"/properties/passTotalPrice","description":"the pass of the price plus the service fee","type":"string"},"passType":{"$id":"/properties/passType","description":"the type of pass","enum":["ALL_ACCESS","EARLY_BIRD","FIXED_HOURS","WEEKDAY"],"type":"string"},"passholderStatus":{"$id":"/properties/passholderStatus","description":"the status of the pass","enum":["ACTIVE","EXPIRED"],"type":"string"},"passholderUserId":{"$id":"/properties/passholderUserId","description":"the user id of the pass holder ","type":"integer"},"start":{"$id":"/properties/start","description":"","type":"string"},"userPassId":{"$id":"/properties/userPassId","description":"","type":"integer"}},"required":["passholderStatus","passId","end","coverImageURL","userPassId","passCurrencyCode","passName","passType","passDiscount","passTotalPrice","passCurrent","listingTitle","listingURL","hasAutorenewOn","passholderUserId","hostFirstName","passState","passCreatedAt","listingId","passPrice","isLegacy","start","passDiscountType"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostSubmittedPassRefundNote', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostSubmittedRebookingRequest' track call.
 *
 * @param HostSubmittedRebookingRequest props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostSubmittedRebookingRequest(props: HostSubmittedRebookingRequest, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostSubmittedRebookingRequest","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST RESERVATION] host submitted the rescheduling request via \"send reschedule request\"","properties":{"bookingId":{"$id":"/properties/bookingId","description":"id of the booking the reservation pertains to","type":"integer"},"bookingWithPass":{"$id":"/properties/bookingWithPass","description":"was the booking made using a pass","enum":["FALSE","PARTIAL","TRUE"],"type":"string"},"discountOfferedPercentage":{"$id":"/properties/discountOfferedPercentage","description":"discount percentage offered for rebooking","type":"integer"},"messageId":{"$id":"/properties/messageId","description":"message id of message sent from host to guest about reschedule","type":"integer"},"newRescheduledDate":{"$id":"/properties/newRescheduledDate","description":"new host proposed booking date","type":"string"},"newRescheduledEndTime":{"$id":"/properties/newRescheduledEndTime","description":"new host proposed end time","type":"string"},"newRescheduledStartTime":{"$id":"/properties/newRescheduledStartTime","description":"new host proposed start time","type":"string"},"originalBookingDate":{"$id":"/properties/originalBookingDate","description":"original booking date","type":"string"},"originalBookingEndTime":{"$id":"/properties/originalBookingEndTime","description":"original booking end time","type":"string"},"originalBookingStartTime":{"$id":"/properties/originalBookingStartTime","description":"original booking start time","type":"string"},"passId":{"$id":"/properties/passId","description":"if the booking was made or partially made with a pass, the pass id used","type":["integer","null"]},"passName":{"$id":"/properties/passName","description":"the type of the pass formatted to be LCM friendly\n","type":["string","null"]},"passType":{"$id":"/properties/passType","description":"if the booking was made or partially made with a pass, what type of pass","enum":["ALL_ACCESS","EARLY_BIRD","WEEKDAY",null],"type":["string","null"]},"rescheduleReason":{"$id":"/properties/rescheduleReason","description":"final reason selected for the reschedule","type":"string"},"rescheduleRequestDeniedOption":{"$id":"/properties/rescheduleRequestDeniedOption","description":"whether the fallback plan is \"revert\" or \"cancel\"","type":"string"},"userPassId":{"$id":"/properties/userPassId","description":"if the booking was made or partially made with a pass, what was the user pass Id used","type":["integer","null"]}},"required":["rescheduleRequestDeniedOption","originalBookingStartTime","originalBookingEndTime","newRescheduledDate","originalBookingDate","rescheduleReason","bookingId","newRescheduledEndTime","messageId","newRescheduledStartTime","discountOfferedPercentage"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostSubmittedRebookingRequest', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostSubmittedRefund' track call.
 *
 * @param HostSubmittedRefund props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostSubmittedRefund(props: HostSubmittedRefund, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostSubmittedRefund","$schema":"http://json-schema.org/draft-07/schema#","description":"host submitted a refund to the guest","properties":{"bookingId":{"$id":"/properties/bookingId","description":"id of the booking","type":"integer"},"bookingStatus":{"$id":"/properties/bookingStatus","description":"status of the booking","type":"string"},"fullOrPartial":{"$id":"/properties/fullOrPartial","description":"full refund or partial refund","enum":["full","partial"],"type":"string"},"guestId":{"$id":"/properties/guestId","description":"id of the guest","type":"integer"},"refundAmount":{"$id":"/properties/refundAmount","description":"total value of the refund given to the guest","type":"number"},"refundCurrency":{"$id":"/properties/refundCurrency","description":"currency of the refund","type":"string"},"refundMessage":{"$id":"/properties/refundMessage","description":"message the host sends to the guest regarding the refund","type":"string"},"refundReason":{"$id":"/properties/refundReason","description":"host-selected refund reason","type":"string"}},"required":["bookingId","bookingStatus","fullOrPartial","guestId","refundAmount","refundCurrency","refundMessage","refundReason"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostSubmittedRefund', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostSubmittedReviewReply' track call.
 *
 * @param HostSubmittedReviewReply props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostSubmittedReviewReply(props: HostSubmittedReviewReply, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostSubmittedReviewReply","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST PERFORMANCE] Host submitted a reply to a guest's review","properties":{"bookingId":{"$id":"/properties/bookingId","description":"","type":"integer"},"bookingMessage":{"$id":"/properties/bookingMessage","description":"message sent by the guest when booking","type":["string","null"]},"bookingRating":{"$id":"/properties/bookingRating","description":"if the guest left a rating between 1-5, what was it","type":["integer","null"]},"bookingReason":{"$id":"/properties/bookingReason","description":"guest selection (listing type specific) for why they're booking","enum":["casual_play","competitive_play","corporate_or_meeting","courts","date","exercise","family_hangout","friend_hangout","lessons",null,"other","party_celebration","party_or_celebration","pet_swim","photoshoot","training"],"type":["string","null"]},"bookingReview":{"$id":"/properties/bookingReview","description":"if the guest left a review, what was it","type":["string","null"]},"bookingSpecialOfferId":{"$id":"/properties/bookingSpecialOfferId","description":"","type":["integer","null"]},"guestId":{"$id":"/properties/guestId","description":"","type":"integer"},"hostId":{"$id":"/properties/hostId","description":"","type":"integer"},"id":{"$id":"/properties/id","description":"","type":"string"},"isInstantBooking":{"$id":"/properties/isInstantBooking","description":"","type":"boolean"},"listingId":{"$id":"/properties/listingId","description":"","type":"integer"},"listingTitle":{"$id":"/properties/listingTitle","description":"","type":"string"},"reply":{"$id":"/properties/reply","description":"the host's reply","type":"string"},"totalGuests":{"$id":"/properties/totalGuests","description":"","type":"integer"},"totalPrice":{"$id":"/properties/totalPrice","description":"","type":"number"}},"required":["guestId","hostId","listingId","listingTitle","reply","bookingId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostSubmittedReviewReply', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostSubmittedSDClaim' track call.
 *
 * @param HostSubmittedSDClaim props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostSubmittedSDClaim(props: HostSubmittedSDClaim, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostSubmittedSDClaim","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST SD CLAIM] ","properties":{"bookingId":{"$id":"/properties/bookingId","description":"","type":"integer"},"damagesAmount":{"$id":"/properties/damagesAmount","description":"","type":"number"},"listingId":{"$id":"/properties/listingId","description":"","type":"string"},"rationale":{"$id":"/properties/rationale","description":"","type":"string"}},"required":["bookingId","damagesAmount","listingId","rationale"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostSubmittedSDClaim', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostSubmittedSecurityDepositSetUp' track call.
 *
 * @param HostSubmittedSecurityDepositSetUp props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostSubmittedSecurityDepositSetUp(props: HostSubmittedSecurityDepositSetUp, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostSubmittedSecurityDepositSetUp","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST SETTINGS - SECURITY DEPOSIT] ","properties":{"listingId":{"$id":"/properties/listingId","description":"","type":"integer"},"newDepositAmount":{"$id":"/properties/newDepositAmount","description":"the size of the deposit required","enum":["100","1000","250","500"],"type":"string"},"newGuestMin":{"$id":"/properties/newGuestMin","description":"min guest count to charge a security deposit","type":"number"},"oldDepositAmount":{"$id":"/properties/oldDepositAmount","description":"if there was an existing security deposit, the old the size of the deposit required","enum":["100","1000","250","500",null],"type":["string","null"]},"oldGuestMin":{"$id":"/properties/oldGuestMin","description":"if there was an existing security deposit, the old min guest count to charge a security deposit","type":["number","null"]}},"required":["newGuestMin","listingId","newDepositAmount"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostSubmittedSecurityDepositSetUp', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostSubmittedSecurityDepositToggleOff' track call.
 *
 * @param HostSubmittedSecurityDepositToggleOff props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostSubmittedSecurityDepositToggleOff(props: HostSubmittedSecurityDepositToggleOff, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostSubmittedSecurityDepositToggleOff","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST SETTINGS - SECURITY DEPOSIT] ","properties":{"depositAmount":{"$id":"/properties/depositAmount","description":"the size of the deposit required","enum":["100","1000","250","500",null],"type":["string","null"]},"guestMin":{"$id":"/properties/guestMin","description":"min guest count to charge a security deposit","type":["number","null"]},"listingId":{"$id":"/properties/listingId","description":"","type":"integer"}},"required":["listingId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostSubmittedSecurityDepositToggleOff', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostSubmittedSyncWCronofyFailure' track call.
 *
 * @param HostSubmittedSyncWCronofyFailure props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostSubmittedSyncWCronofyFailure(props: HostSubmittedSyncWCronofyFailure, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostSubmittedSyncWCronofyFailure","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST CALENDAR SYNCING] fires if the Cronofy Sync is Successful","properties":{"listingId":{"$id":"/properties/listingId","description":"","type":"integer"}},"required":["listingId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostSubmittedSyncWCronofyFailure', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostSubmittedSyncWCronofySuccess' track call.
 *
 * @param HostSubmittedSyncWCronofySuccess props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostSubmittedSyncWCronofySuccess(props: HostSubmittedSyncWCronofySuccess, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostSubmittedSyncWCronofySuccess","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST CALENDAR SYNCING] fires when the Cronofy Sync is Successful","properties":{"calendarName":{"$id":"/properties/calendarName","description":"","type":"string"},"listingId":{"$id":"/properties/listingId","description":"","type":"integer"}},"required":["calendarName","listingId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostSubmittedSyncWCronofySuccess', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostSubmittedUnsyncCronofy' track call.
 *
 * @param HostSubmittedUnsyncCronofy props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostSubmittedUnsyncCronofy(props: HostSubmittedUnsyncCronofy, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostSubmittedUnsyncCronofy","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST CALENDAR SYNCING] fires when the host pressed \"Delete Calendar\" on the pop up after deleting the calendar and pressing the \"Manage Cronofy\" CTA","properties":{"calendarName":{"$id":"/properties/calendarName","description":"","type":"string"},"listingId":{"$id":"/properties/listingId","description":"","type":"integer"}},"required":["listingId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostSubmittedUnsyncCronofy', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostSubmittedUnsyncICal' track call.
 *
 * @param HostSubmittedUnsyncICal props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostSubmittedUnsyncICal(props: HostSubmittedUnsyncICal, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostSubmittedUnsyncICal","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST CALENDAR SYNCING] fires when the host pressed \"Unsync Calendar\" on the confirmation modal","properties":{"calendarName":{"$id":"/properties/calendarName","description":"","type":"string"},"listingId":{"$id":"/properties/listingId","description":"","type":"integer"}},"required":["listingId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostSubmittedUnsyncICal', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostTieredPricingPressedAdjustGroupPrice' track call.
 *
 * @param HostTieredPricingPressedAdjustGroupPrice props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostTieredPricingPressedAdjustGroupPrice(props: HostTieredPricingPressedAdjustGroupPrice, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostTieredPricingPressedAdjustGroupPrice","$schema":"http://json-schema.org/draft-07/schema#","description":"[TIERED PRICING] host pressed to adjust group price","properties":{"listingId":{"$id":"/properties/listingId","description":"id of the listing","type":"string"}},"required":["listingId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostTieredPricingPressedAdjustGroupPrice', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostTieredPricingPressedConfirmPrice' track call.
 *
 * @param HostTieredPricingPressedConfirmPrice props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostTieredPricingPressedConfirmPrice(props: HostTieredPricingPressedConfirmPrice, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostTieredPricingPressedConfirmPrice","$schema":"http://json-schema.org/draft-07/schema#","description":"[TIERED PRICING] host pressed \"set price\"","properties":{"dailyPriceCurrency":{"$id":"/properties/dailyPriceCurrency","description":"","type":"string"},"dailyPriceEntered":{"$id":"/properties/dailyPriceEntered","description":"","type":"string"},"listingId":{"$id":"/properties/listingId","description":"id of the listing","type":"string"}},"required":["listingId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostTieredPricingPressedConfirmPrice', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostTieredPricingSetGroupPrice' track call.
 *
 * @param HostTieredPricingSetGroupPrice props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostTieredPricingSetGroupPrice(props: HostTieredPricingSetGroupPrice, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostTieredPricingSetGroupPrice","$schema":"http://json-schema.org/draft-07/schema#","description":"[TIERED PRICING] host set price for group","properties":{"group":{"$id":"/properties/group","description":"0 - small groups, 1 - large groups, 2 - small gatherings, 3 - large gatherings, 4 - small events, 5 - large events, 6 - huge events","enum":["0","1","2","3","4","5","6"],"type":"string"},"listingId":{"$id":"/properties/listingId","description":"id of the listing","type":"string"},"newPrice":{"$id":"/properties/newPrice","description":"new price entered by host","type":"integer"},"oldPrice":{"$id":"/properties/oldPrice","description":"old price before changed","type":"integer"}},"required":["newPrice","oldPrice","group","listingId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostTieredPricingSetGroupPrice', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostTieredPricingTabDoThisLater' track call.
 *
 * @param HostTieredPricingTabDoThisLater props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostTieredPricingTabDoThisLater(props: HostTieredPricingTabDoThisLater, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostTieredPricingTabDoThisLater","$schema":"http://json-schema.org/draft-07/schema#","description":"[TIERED PRICING] host tab do this later to remain in legacy pricing","properties":{"listingId":{"$id":"/properties/listingId","description":"id of the listing","type":"integer"}},"required":["listingId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostTieredPricingTabDoThisLater', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostVideoTourUploadFailure' track call.
 *
 * @param HostVideoTourUploadFailure props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostVideoTourUploadFailure(props: HostVideoTourUploadFailure, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostVideoTourUploadFailure","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST SETTINGS - VIDEO TOUR] when host unsuccessfully uploads a video tour","properties":{"failureReason":{"$id":"/properties/failureReason","description":"","enum":["circumvention","content","duration",null,"size"],"type":["string","null"]},"listingId":{"$id":"/properties/listingId","description":"","type":"integer"}},"required":["listingId","failureReason"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostVideoTourUploadFailure', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostVideoTourUploadSuccess' track call.
 *
 * @param HostVideoTourUploadSuccess props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostVideoTourUploadSuccess(props: HostVideoTourUploadSuccess, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostVideoTourUploadSuccess","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST SETTINGS - VIDEO TOUR] when host successfully uploads a video tour","properties":{"listingId":{"$id":"/properties/listingId","description":"","type":"integer"}},"required":["listingId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostVideoTourUploadSuccess', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'HostViewedPerfDashboard' track call.
 *
 * @param HostViewedPerfDashboard props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function hostViewedPerfDashboard(props: HostViewedPerfDashboard, options?: Options, callback?: Callback): void {

    const schema = {"$id":"HostViewedPerfDashboard","$schema":"http://json-schema.org/draft-07/schema#","description":"[HOST PERFORMANCE] Host viewed the performance dashboard by clicking the hosting in menu bar","properties":{"id":{"$id":"/properties/id","description":"! DO NOT ADD ID (HACK TO MAKE EVENT DISPLAY IN TYPES)","type":"string"}},"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('HostViewedPerfDashboard', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'LifeguardAccepted' track call.
 *
 * @param LifeguardAccepted props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function lifeguardAccepted(props: LifeguardAccepted, options?: Options, callback?: Callback): void {

    const schema = {"$id":"LifeguardAccepted","$schema":"http://json-schema.org/draft-07/schema#","properties":{"bookingId":{"$id":"/properties/bookingId","description":"","type":"string"}},"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('LifeguardAccepted', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'LifeguardOffered' track call.
 *
 * @param LifeguardOffered props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function lifeguardOffered(props: LifeguardOffered, options?: Options, callback?: Callback): void {

    const schema = {"$id":"LifeguardOffered","$schema":"http://json-schema.org/draft-07/schema#","properties":{"bookingId":{"$id":"/properties/bookingId","description":"","type":"string"}},"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('LifeguardOffered', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'LifeguardRejected' track call.
 *
 * @param LifeguardRejected props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function lifeguardRejected(props: LifeguardRejected, options?: Options, callback?: Callback): void {

    const schema = {"$id":"LifeguardRejected","$schema":"http://json-schema.org/draft-07/schema#","properties":{"bookingId":{"$id":"/properties/bookingId","description":"","type":"string"}},"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('LifeguardRejected', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'ListListingImpression' track call.
 *
 * @param ListListingImpression props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function listListingImpression(props: ListListingImpression, options?: Options, callback?: Callback): void {

    const schema = {"$id":"ListListingImpression","$schema":"http://json-schema.org/draft-07/schema#","description":"[SEARCH] User viewed a listing on search","properties":{"amountOff":{"$id":"/properties/amountOff","description":"if the listing has an active deal, what percent amount off of this promo code (1-100)","type":["number","null"]},"badgeName":{"$id":"/properties/badgeName","description":"the displayed badge name","type":["string","null"]},"dailyPrice":{"$id":"/properties/dailyPrice","description":"daily price displayed","type":"number"},"expireDate":{"$id":"/properties/expireDate","description":"if the listing has an active deal, when is the expiration","type":["string","null"]},"globalListingType":{"$id":"/properties/globalListingType","description":"[LISTING TYPE] The type of the listing associated with this event","enum":["artStudio","basketballCourt","dockedBoat","home","homeGym","joyspace","kitchen","largeBackyard","musicStudio","other","pending","pickleball","pool","privateLake","roofDeck","tennisCourt"],"type":"string"},"hasAvailabilityBanner":{"$id":"/properties/hasAvailabilityBanner","description":"whether the listing has the offseason availability banner","type":"boolean"},"hasDeal":{"$id":"/properties/hasDeal","description":"does the listing have a currently active deal (1 - yes, 0 - no)","type":"boolean"},"hasInstantBookStatus":{"$id":"/properties/hasInstantBookStatus","description":"whether or not the listing has instant book status displayed","type":"boolean"},"hasPass":{"$id":"/properties/hasPass","description":"whether the listings has passes available (1 if true, 0 if false)","type":"boolean"},"hourlyPrice":{"$id":"/properties/hourlyPrice","description":"hourly price displayed","type":"number"},"listingId":{"$id":"/properties/listingId","description":"id of the listing","type":"string"},"nextAvailableDateDisplayed":{"$id":"/properties/nextAvailableDateDisplayed","description":"for listings with the offseason availability banner, when is the next available date","type":["string","null"]},"orderInSearchResults":{"$id":"/properties/orderInSearchResults","description":"order in search results","type":"integer"},"passIds":{"$id":"/properties/passIds","description":"if the listing has one or more active passes, list the pass ids in an array","type":["array","null"]},"passTypes":{"$id":"/properties/passTypes","description":"the types of passes available for a listing - null if it doesn't have any","type":["array","null"]},"priceType":{"$id":"/properties/priceType","description":"the displayed price type of the listing","enum":["base_tier_daily_price","base_tier_hourly_price"],"type":"string"},"rating":{"$id":"/properties/rating","description":"rating displayed","type":["number","null"]},"ratingsVolume":{"$id":"/properties/ratingsVolume","description":"total amount of ratings displayed","type":["number","null"]},"reportedDistance":{"$id":"/properties/reportedDistance","description":"distance reported in the list impression","type":"number"},"reportedDistanceUnit":{"$id":"/properties/reportedDistanceUnit","description":"unit of the reported distance ('miles' or 'kilometers')","enum":["kilometers","miles"],"type":"string"},"searchId":{"$id":"/properties/searchId","description":"id of the search which generated the result","type":["string","null"]}},"required":["ratingsVolume","reportedDistanceUnit","hasAvailabilityBanner","hasInstantBookStatus","hasPass","orderInSearchResults","badgeName","rating","hasDeal","passTypes","reportedDistance","listingId","globalListingType","searchId","priceType"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('ListListingImpression', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'ListListingImpressionAISearch' track call.
 *
 * @param ListListingImpressionAISearch props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function listListingImpressionAISearch(props: ListListingImpressionAISearch, options?: Options, callback?: Callback): void {

    const schema = {"$id":"ListListingImpressionAISearch","$schema":"http://json-schema.org/draft-07/schema#","description":"[SEARCH] User viewed a listing on search","properties":{"listingId":{"$id":"/properties/listingId","description":"id of the listing","type":"string"},"orderInSearchResults":{"$id":"/properties/orderInSearchResults","description":"order in search results","type":"integer"},"price":{"$id":"/properties/price","description":"the price displayed","type":"number"},"priceType":{"$id":"/properties/priceType","description":"","enum":["daily","hourly"],"type":"string"},"reportedDistance":{"$id":"/properties/reportedDistance","description":"distance reported in the list impression","type":"number"},"reportedDistanceUnit":{"$id":"/properties/reportedDistanceUnit","description":"unit of the reported distance ('miles' or 'kilometers')","enum":["kilometers","miles"],"type":"string"}},"required":["listingId","priceType"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('ListListingImpressionAISearch', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'ListingPhotoCarouselChanged' track call.
 *
 * @param ListingPhotoCarouselChanged props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function listingPhotoCarouselChanged(props: ListingPhotoCarouselChanged, options?: Options, callback?: Callback): void {

    const schema = {"$id":"ListingPhotoCarouselChanged","$schema":"http://json-schema.org/draft-07/schema#","description":"[SEARCH] User pressed next photo in carousel","properties":{"badgeName":{"$id":"/properties/badgeName","description":"displayed badge name","type":["string","null"]},"listingId":{"$id":"/properties/listingId","description":"id of listing","type":"string"},"newPhotoId":{"$id":"/properties/newPhotoId","description":"[DEPRECATED] photo id of photo now displayed","type":"string"},"newPhotoUrl":{"$id":"/properties/newPhotoUrl","description":"photo url of photo now displayed","type":"string"},"orderInCarousel":{"$id":"/properties/orderInCarousel","description":"order of new photo in the carousel","type":"integer"},"searchId":{"$id":"/properties/searchId","description":"id of search which generated result","type":["string","null"]}},"required":["orderInCarousel","listingId","newPhotoUrl","badgeName","searchId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('ListingPhotoCarouselChanged', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'LoadSearchResult' track call.
 *
 * @param LoadSearchResult props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function loadSearchResult(props: LoadSearchResult, options?: Options, callback?: Callback): void {

    const schema = {"$id":"LoadSearchResult","$schema":"http://json-schema.org/draft-07/schema#","description":"[SEARCH] The aggregated information of the search result based on the details and user submitted","properties":{"avgHourlyPrice":{"$id":"/properties/avgHourlyPrice","description":"average hourly price of the search result","type":["number","null"]},"centerPoint":{"$id":"/properties/centerPoint","description":"center point of the bounding box","properties":{"latitude":{"$id":"/properties/properties/properties/centerPoint/properties/latitude","description":"latitude of the center point of the bounding box","type":"number"},"longitude":{"$id":"/properties/properties/properties/centerPoint/properties/longitude","description":"longitude of the center point of the bounding box","type":"number"}},"required":["latitude","longitude"],"type":"object"},"distance":{"$id":"/properties/distance","description":"radius distance of the bounding box","type":"number"},"maxPrice":{"$id":"/properties/maxPrice","description":"maximum price of the listing in the search result","type":["number","null"]},"minPrice":{"$id":"/properties/minPrice","description":"minimum price of the listing in the search result","type":["number","null"]},"numberOfListings":{"$id":"/properties/numberOfListings","description":"the number of listing in that search","type":"integer"},"searchId":{"$id":"/properties/searchId","description":"id of the search which generated the result","type":["string","null"]}},"required":["distance","numberOfListings","searchId","centerPoint"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('LoadSearchResult', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'MapLoaded' track call.
 *
 * @param MapLoaded props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function mapLoaded(props: MapLoaded, options?: Options, callback?: Callback): void {

    const schema = {"$id":"MapLoaded","$schema":"http://json-schema.org/draft-07/schema#","description":"[SEARCH] map loaded on search","properties":{"avgPrice":{"$id":"/properties/avgPrice","description":"average price of pins displayed","type":["number","null"]},"latMaximum":{"$id":"/properties/latMaximum","description":"maximum latitude for the display box","type":"number"},"latMinimum":{"$id":"/properties/latMinimum","description":"minimum latitude for the display box","type":"number"},"lngMaximum":{"$id":"/properties/lngMaximum","description":"maximum longitude for the display box","type":"number"},"lngMinimum":{"$id":"/properties/lngMinimum","description":"minimum longitude for the display box","type":"number"},"maxPrice":{"$id":"/properties/maxPrice","description":"maximum price of pins displayed","type":["number","null"]},"minPrice":{"$id":"/properties/minPrice","description":"minimum price of pins displayed","type":["number","null"]},"numPinsDisplayed":{"$id":"/properties/numPinsDisplayed","description":"number of pins displayed on map","type":"integer"},"searchId":{"$id":"/properties/searchId","description":"id of search which generated result","type":["string","null"]}},"required":["lngMaximum","searchId","latMinimum","lngMinimum","numPinsDisplayed","latMaximum"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('MapLoaded', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'MonitorAccepted' track call.
 *
 * @param MonitorAccepted props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function monitorAccepted(props: MonitorAccepted, options?: Options, callback?: Callback): void {

    const schema = {"$id":"MonitorAccepted","$schema":"http://json-schema.org/draft-07/schema#","properties":{"bookingId":{"$id":"/properties/bookingId","description":"","type":"string"}},"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('MonitorAccepted', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'MonitorOffered' track call.
 *
 * @param MonitorOffered props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function monitorOffered(props: MonitorOffered, options?: Options, callback?: Callback): void {

    const schema = {"$id":"MonitorOffered","$schema":"http://json-schema.org/draft-07/schema#","properties":{"bookingId":{"$id":"/properties/bookingId","description":"","type":"string"}},"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('MonitorOffered', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'MonitorRejected' track call.
 *
 * @param MonitorRejected props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function monitorRejected(props: MonitorRejected, options?: Options, callback?: Callback): void {

    const schema = {"$id":"MonitorRejected","$schema":"http://json-schema.org/draft-07/schema#","properties":{"bookingId":{"$id":"/properties/bookingId","description":"","type":"string"}},"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('MonitorRejected', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'PageViewed' track call.
 *
 * @param PageViewed props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function pageViewed(props: PageViewed, options?: Options, callback?: Callback): void {

    const schema = {"$id":"Page_Viewed","$schema":"http://json-schema.org/draft-07/schema#","description":"[DEFAULT WEB EVENTS] standard Segment track event for page","properties":{"path":{"$id":"/properties/path","description":"","type":"string"},"referrer":{"$id":"/properties/referrer","description":"","type":"string"},"search":{"$id":"/properties/search","description":"","type":"string"},"title":{"$id":"/properties/title","description":"","type":"string"},"url":{"$id":"/properties/url","description":"","type":"string"}},"required":["url","title","path"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('Page Viewed', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'SentNewListingNotification' track call.
 *
 * @param SentNewListingNotification props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function sentNewListingNotification(props: SentNewListingNotification, options?: Options, callback?: Callback): void {

    const schema = {"$id":"SentNewListingNotification","$schema":"http://json-schema.org/draft-07/schema#","description":"[USER SUBSCRIPTION] Send notification to a user with subscription when new listings in search criteria go live","properties":{"category":{"$id":"/properties/category","description":"the search category subscribed by the user","enum":["All","Backyards","Boats","Budget","Family","Heated","Homes","Hoops","Hot Tubs","Indoors","Paddle","Parties","Pets","Racquet","Vip"],"type":"string"},"distanceToZipCode":{"$id":"/properties/distanceToZipCode","description":"the distance in mile between the listing and the subscribed zip code","type":"number"},"email":{"$id":"/properties/email","description":"the email of the user who joined the waitlist","type":"string"},"isHostHasPromoCode":{"$id":"/properties/isHostHasPromoCode","description":"boolean if host has an promo code for this listings (first booking discount)","type":"boolean"},"listingCity":{"$id":"/properties/listingCity","description":"city of the listing","type":"string"},"listingCountry":{"$id":"/properties/listingCountry","description":"country of the listing","type":"string"},"listingId":{"$id":"/properties/listingId","description":"the id of the new listing which fits in the user subscribed criteria","type":"string"},"listingImageUrl":{"$id":"/properties/listingImageUrl","description":"the cover image url of the listing","type":"string"},"listingPrice":{"$id":"/properties/listingPrice","description":"the base hourly price of the listing","type":"number"},"listingState":{"$id":"/properties/listingState","description":"state of the listing","type":"string"},"listingTitle":{"$id":"/properties/listingTitle","description":"tile of the listing","type":"string"},"listingType":{"$id":"/properties/listingType","description":"the type of the listing","enum":["basketball","pickleball","pool","tennis","yards"],"type":"string"},"searchTerm":{"$id":"/properties/searchTerm","description":"the search term subscribed by the user","type":"string"},"userCountry":{"$id":"/properties/userCountry","description":"country of the user","type":"string"},"userId":{"$id":"/properties/userId","description":"user id of the user who joined the waitlist","type":"string"}},"required":["userCountry","category","listingPrice","listingState","distanceToZipCode","email","searchTerm","listingCity","listingCountry","listingTitle","listingId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('SentNewListingNotification', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'SwimplyPremiumPurchaseSuccess' track call.
 *
 * @param SwimplyPremiumPurchaseSuccess props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function swimplyPremiumPurchaseSuccess(props: SwimplyPremiumPurchaseSuccess, options?: Options, callback?: Callback): void {

    const schema = {"$id":"SwimplyPremiumPurchaseSuccess","$schema":"http://json-schema.org/draft-07/schema#","description":"[SWIMPLY PREMIUM] Fires when a user successfully purchases, renews, or upgrades a Swimply Premium subscription","properties":{"entryPoint":{"$id":"/properties/entryPoint","description":"Where the user initiated the premium purchase from","enum":["menu","checkout","profile","manage","global-igloo","global-regular",null],"type":["string","null"]},"premiumType":{"$id":"/properties/premiumType","description":"The type of premium pass purchased (REGULAR, IGLOO, or SUMMER)","enum":["IGLOO","IGLOO_SEASONAL","REGULAR","SUMMER"],"type":"string"},"purchaseType":{"$id":"/properties/purchaseType","description":"Whether this is a new purchase, renewal, or upgrade","enum":["start","renew","upgrade"],"type":"string"}},"required":["premiumType","purchaseType"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('SwimplyPremiumPurchaseSuccess', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserAccountAddedPhotoSuccess' track call.
 *
 * @param UserAccountAddedPhotoSuccess props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userAccountAddedPhotoSuccess(props: UserAccountAddedPhotoSuccess, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserAccountAddedPhotoSuccess","$schema":"http://json-schema.org/draft-07/schema#","description":"[ACCOUNT CREATION] user successfully added photo to account","properties":{"authId":{"$id":"/properties/authId","description":"the authentication session ID","type":"string"},"photoFileExtension":{"$id":"/properties/photoFileExtension","description":"file extension of uploaded photo"},"photoFileSize":{"$id":"/properties/photoFileSize","description":"file size of the uploaded photo","type":"number"}},"required":["photoFileSize","photoFileExtension","authId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserAccountAddedPhotoSuccess', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserAccountBioEntered' track call.
 *
 * @param UserAccountBioEntered props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userAccountBioEntered(props: UserAccountBioEntered, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserAccountBioEntered","$schema":"http://json-schema.org/draft-07/schema#","description":"[ACCOUNT CREATION] user entered bio information","properties":{"authId":{"$id":"/properties/authId","description":"the authentication session ID","type":"string"},"userBlurb":{"$id":"/properties/userBlurb","description":"user blurb contents","type":"string"}},"required":["userBlurb","authId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserAccountBioEntered', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserAccountBirthdayBioSkipped' track call.
 *
 * @param UserAccountBirthdayBioSkipped props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userAccountBirthdayBioSkipped(props: UserAccountBirthdayBioSkipped, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserAccountBirthdayBioSkipped","$schema":"http://json-schema.org/draft-07/schema#","description":"[ACCOUNT CREATION] user skipped birthday + bio entry prompt","properties":{"authId":{"$id":"/properties/authId","description":"the authentication session ID","type":"string"}},"required":["authId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserAccountBirthdayBioSkipped', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserAccountBirthdayEntered' track call.
 *
 * @param UserAccountBirthdayEntered props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userAccountBirthdayEntered(props: UserAccountBirthdayEntered, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserAccountBirthdayEntered","$schema":"http://json-schema.org/draft-07/schema#","description":"[ACCOUNT CREATION] user entered birthday information into account","properties":{"authId":{"$id":"/properties/authId","description":"the authentication session ID","type":"string"},"userBirthdayDate":{"$id":"/properties/userBirthdayDate","description":"user entered birthday date","type":"string"}},"required":["userBirthdayDate","authId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserAccountBirthdayEntered', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserAccountInitiatedAddPhoto' track call.
 *
 * @param UserAccountInitiatedAddPhoto props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userAccountInitiatedAddPhoto(props: UserAccountInitiatedAddPhoto, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserAccountInitiatedAddPhoto","$schema":"http://json-schema.org/draft-07/schema#","description":"[ACCOUNT CREATION] user initiated adding a  photo","properties":{"authId":{"$id":"/properties/authId","description":"the authentication session ID","type":"string"}},"required":["authId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserAccountInitiatedAddPhoto', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserAccountName' track call.
 *
 * @param UserAccountName props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userAccountName(props: UserAccountName, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserAccountName","$schema":"http://json-schema.org/draft-07/schema#","description":"[ACCOUNT CREATION] user input name ","properties":{"authId":{"$id":"/properties/authId","description":"the authentication session ID","type":"string"},"userAccountFirstName":{"$id":"/properties/userAccountFirstName","description":"user input last name","type":"string"},"userAccountLastName":{"$id":"/properties/userAccountLastName","description":"user input first name","type":"string"}},"required":["userAccountLastName","userAccountFirstName","authId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserAccountName', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserAccountNameSkipped' track call.
 *
 * @param UserAccountNameSkipped props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userAccountNameSkipped(props: UserAccountNameSkipped, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserAccountNameSkipped","$schema":"http://json-schema.org/draft-07/schema#","description":"[ACCOUNT CREATION] user skipped name input prompt","properties":{"authId":{"$id":"/properties/authId","description":"the authentication session ID","type":"string"}},"required":["authId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserAccountNameSkipped', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserAccountPhotoSkipped' track call.
 *
 * @param UserAccountPhotoSkipped props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userAccountPhotoSkipped(props: UserAccountPhotoSkipped, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserAccountPhotoSkipped","$schema":"http://json-schema.org/draft-07/schema#","description":"[USER ACCOUNT] user skipped adding a profile photo","properties":{"userOrigin":{"$id":"/properties/properties/properties/userOrigin","description":"what the user submitted for how they heard about us","enum":["ai_search","attended_swimply_booking","billboard","direct_mail","facebook","facebook_or_instagram_ad","friend_or_family","from_friend","google_search","instagram","mailed_flyer","news_article","other","press_or_news_article","shark_tank","social_media_follow","swimply_host","tiktok","youtube",null],"type":["string","null"]},"userSpaceInterests":{"$id":"/properties/properties/properties/userSpaceInterests","description":"what space types the user is interested in the most","type":"array"}},"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserAccountPhotoSkipped', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserAccountProfileContextAdded' track call.
 *
 * @param UserAccountProfileContextAdded props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userAccountProfileContextAdded(props: UserAccountProfileContextAdded, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserAccountProfileContextAdded","$schema":"http://json-schema.org/draft-07/schema#","description":"[USER ACCOUNT] user adds context to their profile, name, profile photo, guest intro, phone","properties":{"userOrigin":{"$id":"/properties/properties/properties/userOrigin","description":"what the user submitted for how they heard about us","enum":["ai_search","attended_swimply_booking","billboard","direct_mail","facebook","facebook_or_instagram_ad","friend_or_family","from_friend","google_search","instagram","mailed_flyer","news_article","other","press_or_news_article","shark_tank","social_media_follow","swimply_host","tiktok","youtube",null],"type":["string","null"]},"userSpaceInterests":{"$id":"/properties/properties/properties/userSpaceInterests","description":"what space types the user is interested in the most","type":"array"}},"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserAccountProfileContextAdded', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserAccountProfileContextSkipped' track call.
 *
 * @param UserAccountProfileContextSkipped props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userAccountProfileContextSkipped(props: UserAccountProfileContextSkipped, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserAccountProfileContextSkipped","$schema":"http://json-schema.org/draft-07/schema#","description":"[ACCOUNT CREATION] user X'd out of the context questions on their interests and how they heard about us (capture any details that were entered)","properties":{"userOrigin":{"$id":"/properties/userOrigin","description":"what the user submitted for how they heard about us","enum":["attended_swimply_booking","billboard","facebook","from_friend","google_search","instagram","mailed_flyer","news_article","other","shark_tank","tiktok","youtube",null],"type":["string","null"]},"userSpaceInterests":{"$id":"/properties/userSpaceInterests","description":"what space types the user is interested in the most","type":"array"}},"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserAccountProfileContextSkipped', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserAccountProfileDetailsAdded' track call.
 *
 * @param UserAccountProfileDetailsAdded props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userAccountProfileDetailsAdded(props: UserAccountProfileDetailsAdded, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserAccountProfileDetailsAdded","$schema":"http://json-schema.org/draft-07/schema#","description":"[ACCOUNT CREATION] user input details on new account creation form","properties":{"authId":{"$id":"/properties/authId","description":"the authentication session ID","type":"string"},"photoFileExtension":{"$id":"/properties/photoFileExtension","description":"file extension of uploaded photo","type":["string","null"]},"photoFileSize":{"$id":"/properties/photoFileSize","description":"file size of the photo","type":["number","null"]},"userAccountFirstName":{"$id":"/properties/userAccountFirstName","description":"user input last name","type":["string","null"]},"userAccountLastName":{"$id":"/properties/userAccountLastName","description":"user input first name","type":["string","null"]},"userBirthdayDate":{"$id":"/properties/userBirthdayDate","description":"user entered birthday date","type":["string","null"]},"userBlurb":{"$id":"/properties/userBlurb","description":"user blurb entered","type":["string","null"]}},"required":["authId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserAccountProfileDetailsAdded', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserAccountProfileDetailsFormViewed' track call.
 *
 * @param UserAccountProfileDetailsFormViewed props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userAccountProfileDetailsFormViewed(props: UserAccountProfileDetailsFormViewed, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserAccountProfileDetailsFormViewed","$schema":"http://json-schema.org/draft-07/schema#","description":"[ACCOUNT CREATION] user viewed the page to input their details on new account creation form","properties":{"authId":{"$id":"/properties/authId","description":"the authentication session ID","type":"string"},"enteredFrom":{"$id":"/properties/enteredFrom","description":"how they accessed the form","enum":["checkout","claim_referral","contact_host","earn_credits","favoriting","host_onboarding","join_waitlist","pass_checkout","post_booking_invite","review","standard_onboarding"],"type":"string"}},"required":["enteredFrom","authId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserAccountProfileDetailsFormViewed', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserAccountProfileDetailsSkipped' track call.
 *
 * @param UserAccountProfileDetailsSkipped props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userAccountProfileDetailsSkipped(props: UserAccountProfileDetailsSkipped, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserAccountProfileDetailsSkipped","$schema":"http://json-schema.org/draft-07/schema#","description":"[ACCOUNT CREATION] user pressed do this later (capture any details that were entered)","properties":{"authId":{"$id":"/properties/authId","description":"the authentication session ID","type":"string"},"photoFileExtension":{"$id":"/properties/photoFileExtension","description":"file extension of uploaded photo","type":["string","null"]},"photoFileSize":{"$id":"/properties/photoFileSize","description":"file size of the photo","type":["number","null"]},"userAccountFirstName":{"$id":"/properties/userAccountFirstName","description":"user input last name","type":["string","null"]},"userAccountLastName":{"$id":"/properties/userAccountLastName","description":"user input first name","type":["string","null"]},"userBirthdayDate":{"$id":"/properties/userBirthdayDate","description":"user entered birthday date","type":["string","null"]},"userBlurb":{"$id":"/properties/userBlurb","description":"user blurb entered","type":["string","null"]}},"required":["authId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserAccountProfileDetailsSkipped', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserAddGuestsConfirmed' track call.
 *
 * @param UserAddGuestsConfirmed props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userAddGuestsConfirmed(props: UserAddGuestsConfirmed, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserAddGuestsConfirmed","$schema":"http://json-schema.org/draft-07/schema#","description":"[CHECKOUT] submission for total amount of guests","properties":{"adultNumber":{"$id":"/properties/adultNumber","description":"number of adults","type":"integer"},"checkoutId":{"$id":"/properties/checkoutId","description":"id for the current checkout flow ","type":"string"},"childrenNumber":{"$id":"/properties/childrenNumber","description":"number of children","type":"integer"},"currency":{"$id":"/properties/currency","description":"currency for all dollar items","type":"string"},"enteredFromContactHostFlow":{"$id":"/properties/enteredFromContactHostFlow","description":"did they enter this item from the \"contact host\" PLP flow","type":"boolean"},"enteredFromPLP":{"$id":"/properties/enteredFromPLP","description":"did user enter this from PLP","type":"boolean"},"enteredFromReservationEdit":{"$id":"/properties/enteredFromReservationEdit","description":"did user come to this screen via a reservation edit","type":"boolean"},"infantNumber":{"$id":"/properties/infantNumber","description":"number of infants","type":"integer"},"instantBookingGuestLimit":{"$id":"/properties/instantBookingGuestLimit","description":"max allowed guest for instant bookings, if applicable","type":"integer"},"isInstantBookingEligible":{"$id":"/properties/isInstantBookingEligible","description":"do total number of guests qualify for instant bookings, if applicable","type":"boolean"},"listingHasInstantBooking":{"$id":"/properties/listingHasInstantBooking","description":"listing has instant booking enabled","type":"boolean"},"listingId":{"$id":"/properties/listingId","description":"the id for the pool listing","type":"string"},"petNumber":{"$id":"/properties/petNumber","description":"number of pets","type":"integer"},"poolMaximumGuests":{"$id":"/properties/poolMaximumGuests","description":"max allowed guests for pool","type":"integer"},"searchId":{"$id":"/properties/searchId","description":"id for the search that led to this listing","type":"string"},"totalGuests":{"$id":"/properties/totalGuests","description":"sum of all guests (adults, children, pets, infants)","type":"integer"},"totalPriceDisplayed":{"$id":"/properties/totalPriceDisplayed","description":"total price value displayed","type":"number"}},"required":["enteredFromContactHostFlow","infantNumber","currency","listingId","searchId","enteredFromPLP","poolMaximumGuests","totalGuests","checkoutId","instantBookingGuestLimit","petNumber","listingHasInstantBooking","childrenNumber","isInstantBookingEligible","enteredFromReservationEdit","totalPriceDisplayed","adultNumber"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserAddGuestsConfirmed', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserAddGuestsDisplayed' track call.
 *
 * @param UserAddGuestsDisplayed props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userAddGuestsDisplayed(props: UserAddGuestsDisplayed, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserAddGuestsDisplayed","$schema":"http://json-schema.org/draft-07/schema#","description":"[CHECKOUT] user was shown screen to adjust number of guests","properties":{"additionalGuestFeesDisplayedInfo":{"$id":"/properties/additionalGuestFeesDisplayedInfo","description":"information about the per-guest fee if applicable","properties":{"numberOfGuestsExtraFeeAppliesPast":{"$id":"/properties/properties/properties/additionalGuestFeesDisplayedInfo/properties/numberOfGuestsExtraFeeAppliesPast","description":"the guest number at which the fee kicks in at","type":"integer"},"pricePerAdditionalGuest":{"$id":"/properties/properties/properties/additionalGuestFeesDisplayedInfo/properties/pricePerAdditionalGuest","description":"price applied per additional guest/hour ","type":"number"}},"required":["numberOfGuestsExtraFeeAppliesPast","pricePerAdditionalGuest"],"type":"object"},"checkoutId":{"$id":"/properties/checkoutId","description":"id for the current checkout flow","type":"string"},"currency":{"$id":"/properties/currency","description":"currency of all dollar items","type":"string"},"defaultAdultNumber":{"$id":"/properties/defaultAdultNumber","description":"number of adults pre-loaded ","type":"integer"},"defaultChildrenNumber":{"$id":"/properties/defaultChildrenNumber","description":"number of children pre-loaded ","type":"integer"},"defaultInfantNumber":{"$id":"/properties/defaultInfantNumber","description":"number of infants pre-loaded ","type":"integer"},"defaultPetNumber":{"$id":"/properties/defaultPetNumber","description":"number of pets pre-loaded ","type":"integer"},"enteredFrom":{"$id":"/properties/enteredFrom","description":"where did the user enter this page from","type":"string"},"enteredFromContactHostFlow":{"$id":"/properties/enteredFromContactHostFlow","description":"did they enter this item from the \"contact host\" PLP flow","type":"boolean"},"enteredFromPLP":{"$id":"/properties/enteredFromPLP","description":"did user enter this from PLP","type":"boolean"},"enteredFromReservationEdit":{"$id":"/properties/enteredFromReservationEdit","description":"did user come to this screen via a reservation edit","type":"boolean"},"initialTotalPriceDisplayed":{"$id":"/properties/initialTotalPriceDisplayed","description":"total price displayed on screen load","type":"number"},"instantBookingGuestLimit":{"$id":"/properties/instantBookingGuestLimit","description":"max allowed guest for instant bookings, if applicable","type":"integer"},"isInstantBookingEligible":{"$id":"/properties/isInstantBookingEligible","description":"is the booking initially eligible for instant bookings, if applicable","type":"boolean"},"listingHasInstantBooking":{"$id":"/properties/listingHasInstantBooking","description":"listing has instant bookings enabled","type":"boolean"},"listingId":{"$id":"/properties/listingId","description":"the id for the pool listing","type":"string"},"poolMaximumGuests":{"$id":"/properties/poolMaximumGuests","description":"\nmax allowed guests for pool","type":"integer"},"price":{"$id":"/properties/price","description":"the total price shown","type":"number"},"priceType":{"$id":"/properties/priceType","description":"price type of the listing","enum":["daily","hourly"],"type":"string"},"searchId":{"$id":"/properties/searchId","description":"id for the search that led to this listing","type":"string"}},"required":["defaultAdultNumber","priceType","enteredFromPLP","currency","enteredFromReservationEdit","searchId","isInstantBookingEligible","enteredFromContactHostFlow","defaultInfantNumber","listingHasInstantBooking","instantBookingGuestLimit","initialTotalPriceDisplayed","defaultPetNumber","listingId","poolMaximumGuests","price","checkoutId","additionalGuestFeesDisplayedInfo","enteredFrom","defaultChildrenNumber"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserAddGuestsDisplayed', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserAddedBookingMessage' track call.
 *
 * @param UserAddedBookingMessage props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userAddedBookingMessage(props: UserAddedBookingMessage, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserAddedBookingMessage","$schema":"http://json-schema.org/draft-07/schema#","description":"[CHECKOUT] user adds an optional message to the host","properties":{"bookingId":{"$id":"/properties/bookingId","description":"","type":"integer"},"bookingMessage":{"$id":"/properties/bookingMessage","description":"","type":["string","null"]},"bookingReason":{"$id":"/properties/bookingReason","description":"guest selection (listing type specific) for why they're booking","enum":["casual_play","competitive_play","corporate_or_meeting","courts","date","exercise","family_hangout","friend_hangout","lessons",null,"other","party_celebration","party_or_celebration","pet_swim","photoshoot","training"],"type":["string","null"]},"bookingSpecialOfferId":{"$id":"/properties/bookingSpecialOfferId","description":"","type":["integer","null"]},"bookingStartDateTime":{"$id":"/properties/bookingStartDateTime","description":"","type":"string"},"country":{"$id":"/properties/country","description":"","type":"string"},"globalListingType":{"$id":"/properties/globalListingType","description":"[LISTING TYPE] The type of the listing associated with this event","enum":["artStudio","basketballCourt","dockedBoat","home","homeGym","joyspace","kitchen","largeBackyard","musicStudio","other","pending","pickleball","pool","privateLake","roofDeck","tennisCourt"],"type":"string"},"guestId":{"$id":"/properties/guestId","description":"","type":"integer"},"hostId":{"$id":"/properties/hostId","description":"","type":"integer"},"id":{"$id":"/properties/id","description":"","type":"string"},"isInstantBooking":{"$id":"/properties/isInstantBooking","description":"","type":"boolean"},"listingId":{"$id":"/properties/listingId","description":"","type":"integer"},"listingTitle":{"$id":"/properties/listingTitle","description":"","type":"string"},"market":{"$id":"/properties/market","description":"","type":"string"},"totalGuests":{"$id":"/properties/totalGuests","description":"","type":"integer"},"totalPrice":{"$id":"/properties/totalPrice","description":"","type":"number"}},"required":["guestId","listingTitle","isInstantBooking","globalListingType","hostId","listingId","country"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserAddedBookingMessage', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserBookingDetailsDisplay' track call.
 *
 * @param UserBookingDetailsDisplay props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userBookingDetailsDisplay(props: UserBookingDetailsDisplay, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserBookingDetailsDisplay","$schema":"http://json-schema.org/draft-07/schema#","description":"[CHECKOUT] final checkout screen displayed","properties":{"checkoutId":{"$id":"/properties/checkoutId","description":"id for the current checkout flow ","type":"string"},"checkoutType":{"$id":"/properties/checkoutType","description":"type of checkout (standard or passes)","enum":["pass","standard_booking"],"type":"string"},"currency":{"$id":"/properties/currency","description":"currency of price","type":"string"},"dateDisplayed":{"$id":"/properties/dateDisplayed","description":"datetime displayed for booking","type":"string"},"endHour":{"$id":"/properties/endHour","description":"end hour of the booking","type":"number"},"globalListingType":{"$id":"/properties/globalListingType","description":"[LISTING TYPE] The type of the listing associated with this event","enum":["artStudio","basketballCourt","dockedBoat","home","homeGym","joyspace","kitchen","largeBackyard","musicStudio","other","pending","pickleball","pool","privateLake","roofDeck","tennisCourt"],"type":"string"},"hasActivePass":{"$id":"/properties/hasActivePass","description":"does the listing have an active pass - 1 if true, 0 if false","type":"boolean"},"hasPassUpsellDisplayed":{"$id":"/properties/hasPassUpsellDisplayed","description":"is the guest shown a pass upsell option - 1 if true, 0 if false","type":"boolean"},"listingId":{"$id":"/properties/listingId","description":"the id for the pool listing","type":"string"},"savedBookingPaymentMethod":{"$id":"/properties/savedBookingPaymentMethod","description":"object describing stored booking payment details","properties":{"availablePaymentIds":{"$id":"/properties/properties/properties/savedBookingPaymentMethod/properties/availablePaymentIds","description":"payment ids for all stored payment methods","type":"array"},"isApplied":{"$id":"/properties/properties/properties/savedBookingPaymentMethod/properties/isApplied","description":"is there a payment pre-applied to booking","type":"boolean"},"isAvailable":{"$id":"/properties/properties/properties/savedBookingPaymentMethod/properties/isAvailable","description":"is there a payment available to apply to the booking (anything in wallet)","type":"boolean"},"whichPaymentApplied":{"$id":"/properties/properties/properties/savedBookingPaymentMethod/properties/whichPaymentApplied","description":"paymentId of pre-applied payment, if applicable","type":["integer","null"]}},"required":["availablePaymentIds","isApplied","isAvailable","whichPaymentApplied"],"type":"object"},"searchId":{"$id":"/properties/searchId","description":"id for the search that led to this listing","type":["string","null"]},"startHour":{"$id":"/properties/startHour","description":"start hour of the booking","type":"number"},"totalAdultGuests":{"$id":"/properties/totalAdultGuests","description":"number of adults","type":"integer"},"totalChildren":{"$id":"/properties/totalChildren","description":"total number of children","type":"integer"},"totalDurationHours":{"$id":"/properties/totalDurationHours","description":"total duration of the booking, in hours","type":"number"},"totalGuests":{"$id":"/properties/totalGuests","description":"total number of guests (adults, children, pets, infants)","type":"integer"},"totalInfantGuests":{"$id":"/properties/totalInfantGuests","description":"number of infants","type":"integer"},"totalPetGuests":{"$id":"/properties/totalPetGuests","description":"number of pets","type":"integer"},"totalPrice":{"$id":"/properties/totalPrice","description":"total price displayed ","type":"number"}},"required":["checkoutType","checkoutId","listingId","totalPrice","savedBookingPaymentMethod","currency","searchId","globalListingType"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserBookingDetailsDisplay', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserBookingSubmittedFailure' track call.
 *
 * @param UserBookingSubmittedFailure props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userBookingSubmittedFailure(props: UserBookingSubmittedFailure, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserBookingSubmittedFailure","$schema":"http://json-schema.org/draft-07/schema#","description":"[CHECKOUT] final checkout submission, only when failed","properties":{"affiliation":{"$id":"/properties/affiliation","description":"for now this should be a constant “Swimply”, but could be used in the future with different partnerships/platforms","type":"string"},"bookingId":{"$id":"/properties/bookingId","description":"id of booking","type":"string"},"bookingWithPass":{"$id":"/properties/bookingWithPass","description":"was the booking made using a pass","enum":["FALSE","PARTIAL","TRUE"],"type":"string"},"checkoutId":{"$id":"/properties/checkoutId","description":"id for the current checkout flow ","type":"string"},"coupon":{"$id":"/properties/coupon","description":"promocode name, should equal promoCodeDetails.promoCodeName","type":"string"},"currency":{"$id":"/properties/currency","description":"currency of price","type":"string"},"dateSelected":{"$id":"/properties/dateSelected","description":"datetime selected for booking","type":"string"},"discount":{"$id":"/properties/discount","description":"Total discount in dollars associated with the transaction","type":"number"},"globalListingType":{"$id":"/properties/globalListingType","description":"[LISTING TYPE] The type of the listing associated with this event","enum":["artStudio","basketballCourt","dockedBoat","home","homeGym","joyspace","kitchen","largeBackyard","musicStudio","other","pending","pickleball","pool","privateLake","roofDeck","tennisCourt"],"type":"string"},"guestAge":{"$id":"/properties/guestAge","description":"the age of the guest","type":["number","null"]},"guestFee":{"$id":"/properties/guestFee","description":"amount value that swimply is charging the guest","type":"number"},"hostFee":{"$id":"/properties/hostFee","description":"amount value that swimply is charging the host","type":"number"},"listingCity":{"$id":"/properties/listingCity","description":"city for the listing","type":"string"},"listingCoverPhotoURL":{"$id":"/properties/listingCoverPhotoURL","description":"url for the listing's cover photo","type":"string"},"listingId":{"$id":"/properties/listingId","description":"the id for the pool listing","type":"string"},"listingState":{"$id":"/properties/listingState","description":"state/region for the listing","type":"string"},"listingTitle":{"$id":"/properties/listingTitle","description":"title of the listing","type":"string"},"passId":{"$id":"/properties/passId","description":"if the booking was made or partially made with a pass, the pass id used","type":["integer","null"]},"passName":{"$id":"/properties/passName","description":"the type of the pass formatted to be LCM friendly\n","type":["string","null"]},"passType":{"$id":"/properties/passType","description":"if the booking was made or partially made with a pass, what type of pass","enum":["ALL_ACCESS","EARLY_BIRD","WEEKDAY",null],"type":["string","null"]},"paymentMethodDetails":{"$id":"/properties/paymentMethodDetails","description":"object including payment details","properties":{"isNewPaymentId":{"$id":"/properties/properties/properties/paymentMethodDetails/properties/isNewPaymentId","description":"is this a newly entered payment (not previously stored in wallet)","type":"boolean"},"paymentId":{"$id":"/properties/properties/properties/paymentMethodDetails/properties/paymentId","description":"id of payment","type":"string"},"paymentPlatformType":{"$id":"/properties/properties/properties/paymentMethodDetails/properties/paymentPlatformType","description":"is payment via google pay, apple pay, card, etc","enum":["apple pay","card","google pay","klarna"],"type":"string"}},"required":["isNewPaymentId","paymentId","paymentPlatformType"],"type":"object"},"products":{"$id":"/properties/products","description":"list of items being purchased, used for GA event mapping","items":{"$id":"/properties/properties/properties/products/items","description":"","properties":{"coupon":{"$id":"/properties/properties/properties/products/items/properties/coupon","description":"promocode name applied","type":"string"},"imageUrl":{"$id":"/properties/properties/properties/products/items/properties/imageUrl","description":"link to the cover photo for the pool","type":"string"},"name":{"$id":"/properties/properties/properties/products/items/properties/name","description":"title of pool -> item_name","type":"string"},"price":{"$id":"/properties/properties/properties/products/items/properties/price","description":"should be same as value, total, revenue","type":"number"},"productId":{"$id":"/properties/properties/properties/products/items/properties/productId","description":"id of associated pool/listing -> item_id","type":"string"},"quantity":{"$id":"/properties/properties/properties/products/items/properties/quantity","description":"number purchased of this productId (should always be 1 for now)","type":"integer"},"url":{"$id":"/properties/properties/properties/products/items/properties/url","description":"link to the PLP","type":"string"}},"required":["productId","name","price","quantity","url","imageUrl"],"type":"object"},"type":"array"},"promoCodeDetails":{"$id":"/properties/promoCodeDetails","description":"object including promo code details","properties":{"isPromoCodeApplied":{"$id":"/properties/properties/properties/promoCodeDetails/properties/isPromoCodeApplied","description":"does order have a promo code applied","type":"boolean"},"promoCodeAmountTotal":{"$id":"/properties/properties/properties/promoCodeDetails/properties/promoCodeAmountTotal","description":"amount in dollars saved from promo code","type":"number"},"promoCodeName":{"$id":"/properties/properties/properties/promoCodeDetails/properties/promoCodeName","description":"text of promoCode","type":["string","null"]},"promoCodePercentSavings":{"$id":"/properties/properties/properties/promoCodeDetails/properties/promoCodePercentSavings","description":"percent savings from the promo code","type":"number"}},"required":[],"type":"object"},"purchaseType":{"$id":"/properties/purchaseType","description":"was a pass purchase or a standard booking made","enum":["pass","standard_booking"],"type":"string"},"searchId":{"$id":"/properties/searchId","description":"id for the search that led to this listing","type":["string","null"]},"shipping":{"$id":"/properties/shipping","description":"Shipping cost associated with the transaction (for us, this should just always be 0)","type":"number"},"subtotal":{"$id":"/properties/subtotal","description":"Order total after discounts but before taxes and shipping","type":"number"},"tax":{"$id":"/properties/tax","description":"Total tax associated with the transaction","type":"number"},"timeToResultSeconds":{"$id":"/properties/timeToResultSeconds","description":"time from submission to final result, in seconds","type":"number"},"total":{"$id":"/properties/total","description":"Revenue with discounts and coupons added in (same as value, revenue, totalPrice)","type":"number"},"totalAdultGuests":{"$id":"/properties/totalAdultGuests","description":"number of adults","type":"integer"},"totalChildrenGuests":{"$id":"/properties/totalChildrenGuests","description":"total number of children guests","type":"integer"},"totalFeesToBeCollected":{"$id":"/properties/totalFeesToBeCollected","description":"guest fee + host fee","type":"number"},"totalGuests":{"$id":"/properties/totalGuests","description":"total number of guests (adults, children, pets, infants)","type":"integer"},"totalInfantGuests":{"$id":"/properties/totalInfantGuests","description":"number of infants","type":"integer"},"totalPetGuests":{"$id":"/properties/totalPetGuests","description":"number of pets","type":"integer"},"totalPrice":{"$id":"/properties/totalPrice","description":"final price submitted","type":"number"},"unSuccessfullySubmittedReasons":{"$id":"/properties/unSuccessfullySubmittedReasons","description":"if the submission is unsuccessful, a list of the errors","type":"array"},"userPassId":{"$id":"/properties/userPassId","description":"if the booking was made or partially made with a pass, what was the user pass Id used","type":["integer","null"]},"value":{"$id":"/properties/value","description":"same as \"totalPrice\" but needed naming convention for 3P ","type":"number"}},"required":["value","totalPrice","subtotal","tax","guestFee","shipping","listingCity","paymentMethodDetails","listingState","totalFeesToBeCollected","total","timeToResultSeconds","searchId","hostFee","listingId","unSuccessfullySubmittedReasons","globalListingType","currency","affiliation","listingTitle","listingCoverPhotoURL","purchaseType","checkoutId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserBookingSubmittedFailure', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserBookingSubmittedSuccess' track call.
 *
 * @param UserBookingSubmittedSuccess props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userBookingSubmittedSuccess(props: UserBookingSubmittedSuccess, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserBookingSubmittedSuccess","$schema":"http://json-schema.org/draft-07/schema#","description":"[CHECKOUT] final checkout submission, only when successful","properties":{"affiliation":{"$id":"/properties/affiliation","description":"for now this should be a constant “Swimply”, but could be used in the future with different partnerships/platforms","type":"string"},"amountOff":{"$id":"/properties/amountOff","description":"if the listing has an active deal, what percent amount off of this promo code (1-100)\n","type":["string","null"]},"billingZipCode":{"$id":"/properties/billingZipCode","description":"billing zip code of the guest's credit card, in standard format","type":"string"},"billingZipCodeMetaFormat":{"$id":"/properties/billingZipCodeMetaFormat","description":"billing zip code of the guest's credit card, in Meta compatible format. All lowercase, no spaces. US Zip codes only 5 digitis. Canadian postal code example: \"K1A 0B1\" -> \"k1a0b1\"","type":"string"},"bookingId":{"$id":"/properties/bookingId","description":"id of booking","type":"string"},"bookingMessage":{"$id":"/properties/bookingMessage","description":"guest added optional message to the host","type":["string","null"]},"bookingReason":{"$id":"/properties/bookingReason","description":"guest selection (listing type specific) for why they're booking","enum":["casual_play","competitive_play","corporate_or_meeting","courts","date","exercise","family_hangout","friend_hangout","lessons",null,"other","party_celebration","party_or_celebration","pet_swim","photoshoot","training"],"type":["string","null"]},"bookingSpecialOfferId":{"$id":"/properties/bookingSpecialOfferId","description":"id of the special offer (if there was one, null if not)","type":["integer","null"]},"bookingWithPass":{"$id":"/properties/bookingWithPass","description":"was the booking made using a pass","enum":["FALSE","PARTIAL","TRUE"],"type":"string"},"category":{"$id":"/properties/category","description":"listing_type. Must be both within event property and product array","type":"string"},"checkoutId":{"$id":"/properties/checkoutId","description":"id for the current checkout flow ","type":"string"},"city":{"$id":"/properties/city","description":"city of the listing (for meta event) ","type":"string"},"content_ids":{"$id":"/properties/content_ids","description":"id of the listing (for meta event) ","type":"integer"},"content_type":{"$id":"/properties/content_type","description":"should be all `destination` (for meta event) ","enum":["destination"],"type":"string"},"country":{"$id":"/properties/country","description":"country of the listing (for meta event) ","type":"string"},"coupon":{"$id":"/properties/coupon","description":"promocode name, should equal promoCodeDetails.promoCodeName","type":["string","null"]},"currency":{"$id":"/properties/currency","description":"currency of price","type":"string"},"dateSelected":{"$id":"/properties/dateSelected","description":"datetime selected for booking","type":"string"},"discount":{"$id":"/properties/discount","description":"Total discount in dollars associated with the transaction","type":"number"},"expireDate":{"$id":"/properties/expireDate","description":"if the listing has an active deal, when is the expiration\n","type":["string","null"]},"guestAge":{"$id":"/properties/guestAge","description":"the age of the guest","type":["number","null"]},"guestFee":{"$id":"/properties/guestFee","description":"amount value that swimply is charging the guest","type":"number"},"hasDeal":{"$id":"/properties/hasDeal","description":"does the listing have a currently active deal (1 - yes, 0 - no)","type":"boolean"},"hostFee":{"$id":"/properties/hostFee","description":"amount value that swimply is charging the host","type":"number"},"listingCityMetaFormat":{"$id":"/properties/listingCityMetaFormat","description":"","type":"string"},"listingCountryCode":{"$id":"/properties/listingCountryCode","description":"listing country code: Use the lowercase, 2-letter country codes in ISO 3166-1 alpha-2","type":"string"},"listingId":{"$id":"/properties/listingId","description":"the id for the pool listing","type":"string"},"listingStateMetaFormat":{"$id":"/properties/listingStateMetaFormat","description":"Listing state: Lowercase, two letter state code for US in FIPS format, full name and lowercase with no whitespace when outside the US (\"California\"->\"ca\", “Nova Scotia” -> “novascotia”)","type":"string"},"name":{"$id":"/properties/name","description":"listing name. Must be both within event property and product array","type":"string"},"passId":{"$id":"/properties/passId","description":"if the booking was made or partially made with a pass, the pass id used","type":["integer","null"]},"passName":{"$id":"/properties/passName","description":"the type of the pass formatted to be LCM friendly\n","type":["string","null"]},"passType":{"$id":"/properties/passType","description":"if the booking was made or partially made with a pass, what type of pass","enum":["ALL_ACCESS","EARLY_BIRD","WEEKDAY",null],"type":["string","null"]},"paymentMethodDetails":{"$id":"/properties/paymentMethodDetails","description":"object including payment details","properties":{"isNewPaymentId":{"$id":"/properties/properties/properties/paymentMethodDetails/properties/isNewPaymentId","description":"is this a newly entered payment (not previously stored in wallet)","type":"boolean"},"paymentId":{"$id":"/properties/properties/properties/paymentMethodDetails/properties/paymentId","description":"id of payment","type":"string"},"paymentPlatformType":{"$id":"/properties/properties/properties/paymentMethodDetails/properties/paymentPlatformType","description":"is payment via google pay, apple pay, card, etc","enum":["apple pay","card","google pay","klarna"],"type":"string"}},"required":["isNewPaymentId","paymentId","paymentPlatformType"],"type":"object"},"products":{"$id":"/properties/products","description":"list of items being purchased, used for GA event mapping","items":{"$id":"/properties/properties/properties/products/items","description":"","properties":{"category":{"$id":"/properties/properties/properties/products/items/properties/category","description":"listing_type. Must be both within event property and product array","type":"string"},"coupon":{"$id":"/properties/properties/properties/products/items/properties/coupon","description":"promocode name applied","type":"string"},"currency":{"$id":"/properties/properties/properties/products/items/properties/currency","description":"currency of price, ISO format. Must be both within event property and product array","type":"string"},"imageUrl":{"$id":"/properties/properties/properties/products/items/properties/imageUrl","description":"link to the cover photo for the pool","type":"string"},"name":{"$id":"/properties/properties/properties/products/items/properties/name","description":"title of pool -> item_name","type":"string"},"price":{"$id":"/properties/properties/properties/products/items/properties/price","description":"should be same as value, total, revenue","type":"number"},"productId":{"$id":"/properties/properties/properties/products/items/properties/productId","description":"id of associated pool/listing -> item_id","type":"string"},"quantity":{"$id":"/properties/properties/properties/products/items/properties/quantity","description":"number purchased of this productId (should always be 1 for now)","type":"integer"},"url":{"$id":"/properties/properties/properties/products/items/properties/url","description":"link to the PLP","type":"string"}},"required":["productId","name","price","quantity","coupon","url","category","imageUrl"],"type":"object"},"type":"array"},"promoCodeDetails":{"$id":"/properties/promoCodeDetails","description":"object including promo code details","properties":{"isPromoCodeApplied":{"$id":"/properties/properties/properties/promoCodeDetails/properties/isPromoCodeApplied","description":"does order have a promo code applied","type":"boolean"},"promoCodeAmountTotal":{"$id":"/properties/properties/properties/promoCodeDetails/properties/promoCodeAmountTotal","description":"amount in dollars saved from promo code","type":"number"},"promoCodeName":{"$id":"/properties/properties/properties/promoCodeDetails/properties/promoCodeName","description":"text of promoCode","type":["string","null"]},"promoCodePercentSavings":{"$id":"/properties/properties/properties/promoCodeDetails/properties/promoCodePercentSavings","description":"percent savings from the promo code","type":"number"}},"required":[],"type":"object"},"purchaseType":{"$id":"/properties/purchaseType","description":"was a pass purchase or a standard booking made","enum":["pass","standard_booking"],"type":"string"},"region":{"$id":"/properties/region","description":"state of the listing (for meta event) ","type":"string"},"revenue":{"$id":"/properties/revenue","description":"Revenue with discounts and coupons added in (same as value, total, totalPrice)","type":"number"},"searchId":{"$id":"/properties/searchId","description":"id for the search that led to this listing","type":"string"},"shipping":{"$id":"/properties/shipping","description":"Shipping cost associated with the transaction (for us, this should just always be 0)","type":"number"},"subtotal":{"$id":"/properties/subtotal","description":"Order total after discounts but before taxes and shipping","type":"number"},"swimplyAttribution":{"$id":"/properties/swimplyAttribution","description":"Attributions that we capture from custom url query param","type":"string"},"tax":{"$id":"/properties/tax","description":"Total tax associated with the transaction","type":"number"},"timeToResultSeconds":{"$id":"/properties/timeToResultSeconds","description":"time from submission to final result, in seconds","type":"number"},"total":{"$id":"/properties/total","description":"Revenue with discounts and coupons added in (same as value, revenue, totalPrice)","type":"number"},"totalAdultGuests":{"$id":"/properties/totalAdultGuests","description":"number of adults","type":"integer"},"totalChildrenGuests":{"$id":"/properties/totalChildrenGuests","description":"total number of children guests","type":"integer"},"totalFeesToBeCollected":{"$id":"/properties/totalFeesToBeCollected","description":"guest fee + host fee","type":"number"},"totalGuests":{"$id":"/properties/totalGuests","description":"total number of guests (adults, children, pets, infants)","type":"integer"},"totalInfantGuests":{"$id":"/properties/totalInfantGuests","description":"number of infants","type":"integer"},"totalPetGuests":{"$id":"/properties/totalPetGuests","description":"number of pets","type":"integer"},"totalPrice":{"$id":"/properties/totalPrice","description":"final price submitted","type":"number"},"userPassId":{"$id":"/properties/userPassId","description":"if the booking was made or partially made with a pass, what was the user pass Id used","type":["integer","null"]},"value":{"$id":"/properties/value","description":"same as \"totalPrice\" but needed naming convention for 3P ","type":"number"}},"required":["total","affiliation","listingStateMetaFormat","currency","billingZipCode","country","purchaseType","region","paymentMethodDetails","hostFee","revenue","content_ids","checkoutId","totalFeesToBeCollected","guestFee","value","city","subtotal","tax","category","name","searchId","listingId","totalPrice","shipping","listingCountryCode","billingZipCodeMetaFormat","timeToResultSeconds","content_type","listingCityMetaFormat"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserBookingSubmittedSuccess', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserCalenderView' track call.
 *
 * @param UserCalenderView props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userCalenderView(props: UserCalenderView, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserCalenderView","$schema":"http://json-schema.org/draft-07/schema#","description":"[CHECKOUT] user viewed calendar","properties":{"checkoutId":{"$id":"/properties/checkoutId","description":"id for the current checkout flow ","type":"string"},"enteredFromContactHostFlow":{"$id":"/properties/enteredFromContactHostFlow","description":"did they enter this item from the \"contact host\" PLP flow","type":"boolean"},"enteredFromReservationEdit":{"$id":"/properties/enteredFromReservationEdit","description":"did user come to this screen via a reservation edit","type":"boolean"},"existingDate":{"$id":"/properties/existingDate","description":"existing date applied when user entered calendar","type":"string"},"listingId":{"$id":"/properties/listingId","description":"the id for the pool listing","type":"string"},"searchId":{"$id":"/properties/searchId","description":"id for the search that led to this listing","type":["string","null"]}},"required":["checkoutId","existingDate","searchId","listingId","enteredFromContactHostFlow","enteredFromReservationEdit"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserCalenderView', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserChoseDate' track call.
 *
 * @param UserChoseDate props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userChoseDate(props: UserChoseDate, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserChoseDate","$schema":"http://json-schema.org/draft-07/schema#","description":"[CHECKOUT] user selected a date within the checkout flow ","properties":{"checkoutId":{"$id":"/properties/checkoutId","description":"id for the current checkout flow ","type":"string"},"enteredFromContactHostFlow":{"$id":"/properties/enteredFromContactHostFlow","description":"did they enter this item from the \"contact host\" PLP flow","type":"boolean"},"enteredFromPLP":{"$id":"/properties/enteredFromPLP","description":"dis user add this date on the PLP","type":"boolean"},"enteredFromReservationEdit":{"$id":"/properties/enteredFromReservationEdit","description":"did user come to this screen via a reservation edit","type":"boolean"},"existingDate":{"$id":"/properties/existingDate","description":"date for which times were displayed prior to press","type":"string"},"fromCalendar":{"$id":"/properties/fromCalendar","description":"was the date chosen from the calendar view?","type":"boolean"},"listingId":{"$id":"/properties/listingId","description":"the id for the pool listing","type":"string"},"newDate":{"$id":"/properties/newDate","description":"date for which times were displayed after press","type":"string"},"originalSearchIdDate":{"$id":"/properties/originalSearchIdDate","description":"date user entered in search id that led to this listing","type":["string","null"]},"searchId":{"$id":"/properties/searchId","description":"id for the search that led to this listing","type":["string","null"]},"timesDisplayed":{"$id":"/properties/timesDisplayed","description":"times displayed as a result of the new date selection","type":"array"},"totalTimesAvailable":{"$id":"/properties/totalTimesAvailable","description":"all times available for the new date selected","type":"array"}},"required":["checkoutId","originalSearchIdDate","totalTimesAvailable","enteredFromPLP","listingId","searchId","timesDisplayed","fromCalendar","enteredFromContactHostFlow","enteredFromReservationEdit","newDate"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserChoseDate', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserChosePaymentMethodInWallet' track call.
 *
 * @param UserChosePaymentMethodInWallet props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userChosePaymentMethodInWallet(props: UserChosePaymentMethodInWallet, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserChosePaymentMethodInWallet","$schema":"http://json-schema.org/draft-07/schema#","description":"[CHECKOUT] user pressed a payment in the wallet","properties":{"checkoutId":{"$id":"/properties/checkoutId","description":"id for the current checkout flow ","type":"string"},"existingPaymentId":{"$id":"/properties/existingPaymentId","description":"the previously applied paymentId, if applicable ","type":"string"},"isApplePay":{"$id":"/properties/isApplePay","description":"user selected Apple Pay","type":"boolean"},"isGooglePay":{"$id":"/properties/isGooglePay","description":"user selected Google Pay","type":"boolean"},"listingId":{"$id":"/properties/listingId","description":"the id for the pool listing","type":"string"},"newPaymentId":{"$id":"/properties/newPaymentId","description":"the newly applied paymentId","type":"string"},"searchId":{"$id":"/properties/searchId","description":"id for the search that led to this listing","type":["string","null"]}},"required":["isApplePay","isGooglePay","checkoutId","existingPaymentId","listingId","newPaymentId","searchId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserChosePaymentMethodInWallet', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserContinuedBookAgainOption' track call.
 *
 * @param UserContinuedBookAgainOption props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userContinuedBookAgainOption(props: UserContinuedBookAgainOption, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserContinuedBookAgainOption","$schema":"http://json-schema.org/draft-07/schema#","description":"[POST BOOKING REVIEW] user selected to continue with rebook option","properties":{"bookingId":{"$id":"/properties/bookingId","description":"id of the booking associated with the review","type":"integer"},"checkoutId":{"$id":"/properties/checkoutId","description":"id of the checkout flow initiated by continuing to book","type":"string"},"listingId":{"$id":"/properties/listingId","description":"id of the listing being reviewed","type":"integer"},"multiDipDetails":{"$id":"/properties/multiDipDetails","description":"details for the multi dip offer if applicable","properties":{"currency":{"$id":"/properties/properties/properties/multiDipDetails/properties/currency","description":"\ncurrency of the price","type":"string"},"discountOffered":{"$id":"/properties/properties/properties/multiDipDetails/properties/discountOffered","description":"discount amount offered in percentage terms for multidip ","type":"number"},"isMultiDipSelected":{"$id":"/properties/properties/properties/multiDipDetails/properties/isMultiDipSelected","description":"did the user select multi dip","type":"boolean"},"priceOfferedPerHour":{"$id":"/properties/properties/properties/multiDipDetails/properties/priceOfferedPerHour","description":"price offered for multi dip rebook","type":"number"}},"required":[],"type":"object"},"ratingSubmittedValue":{"$id":"/properties/ratingSubmittedValue","description":"value of the rating submitted","type":"integer"},"singleDipDetails":{"$id":"/properties/singleDipDetails","description":"details for the single dip offer if applicable","properties":{"currency":{"$id":"/properties/properties/properties/singleDipDetails/properties/currency","description":"currency of the price","type":"string"},"isSingleDipSelected":{"$id":"/properties/properties/properties/singleDipDetails/properties/isSingleDipSelected","description":"did user select single dip","type":"boolean"},"priceOfferedPerHour":{"$id":"/properties/properties/properties/singleDipDetails/properties/priceOfferedPerHour","description":"price offered for single dip rebook","type":"number"}},"required":["priceOfferedPerHour","currency","isSingleDipSelected"],"type":"object"}},"required":["bookingId","listingId","ratingSubmittedValue","singleDipDetails","checkoutId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserContinuedBookAgainOption', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserDeletedFavoriteList' track call.
 *
 * @param UserDeletedFavoriteList props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userDeletedFavoriteList(props: UserDeletedFavoriteList, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserDeletedFavoriteList","$schema":"http://json-schema.org/draft-07/schema#","description":"[GUEST FAVORITE] user pressed \"delete this list\" confirmation","properties":{"alphaUserId":{"$id":"/properties/alphaUserId","description":"the user id of the account who created the favorite collection","type":"integer"},"betaUserIds":{"$id":"/properties/betaUserIds","description":"an array of any favorite collection collaborator's user ids","type":"array"},"favoriteCollectionId":{"$id":"/properties/favoriteCollectionId","description":"the favorite collection id","type":"integer"},"favoriteCollectionName":{"$id":"/properties/favoriteCollectionName","description":"the name of the favorite collection","type":"string"},"id":{"$id":"/properties/id","description":"","type":"string"},"isAlphaUserId":{"$id":"/properties/isAlphaUserId","description":"a boolean to identify whether the actions being taken to a favorite collection are being done by the alpha user (1) or a beta user (0)","type":"boolean"}},"required":["favoriteCollectionName","isAlphaUserId","favoriteCollectionId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserDeletedFavoriteList', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserDisplayedAmenity' track call.
 *
 * @param UserDisplayedAmenity props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userDisplayedAmenity(props: UserDisplayedAmenity, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserDisplayedAmenity","$schema":"http://json-schema.org/draft-07/schema#","description":"[CHECKOUT] send event *per amenity displayed*","properties":{"amenities":{"$id":"/properties/amenities","description":"list of amenities displayed","items":{"$id":"/properties/properties/properties/amenities/items","description":"","properties":{"amenityDescription":{"$id":"/properties/properties/properties/amenities/items/properties/amenityDescription","description":"description of the amenity","type":["string","null"]},"amenityFeeDetails":{"$id":"/properties/properties/properties/amenities/items/properties/amenityFeeDetails","description":"","properties":{"flatFeeAmount":{"$id":"/properties/properties/properties/amenities/items/properties/amenityFeeDetails/properties/flatFeeAmount","description":"fee of amenity if it's a flat fee, otherwise 0","type":"number"},"hourlyFeeAmount":{"$id":"/properties/properties/properties/amenities/items/properties/amenityFeeDetails/properties/hourlyFeeAmount","description":"fee of amenity if it's an hourly fee, otherwise 0","type":"number"},"isFlatFee":{"$id":"/properties/properties/properties/amenities/items/properties/amenityFeeDetails/properties/isFlatFee","description":"does this amenity have a flat fee","type":"boolean"},"isHourlyFee":{"$id":"/properties/properties/properties/amenities/items/properties/amenityFeeDetails/properties/isHourlyFee","description":"does this amenity have an hourly fee","type":"boolean"}},"required":["flatFeeAmount","hourlyFeeAmount","isFlatFee","isHourlyFee"],"type":"object"},"amenityName":{"$id":"/properties/properties/properties/amenities/items/properties/amenityName","description":"name of amenity","type":"string"},"isCustomAmenity":{"$id":"/properties/properties/properties/amenities/items/properties/isCustomAmenity","description":"is this a custom amenity from the host","type":"boolean"},"isFee":{"$id":"/properties/properties/properties/amenities/items/properties/isFee","description":"does this amenity have a fee","type":"boolean"},"isPreSelected":{"$id":"/properties/properties/properties/amenities/items/properties/isPreSelected","description":"is this amenity pre selected","type":"boolean"}},"required":["amenityFeeDetails","amenityName","isCustomAmenity","isFee","isPreSelected"],"type":"object"},"type":"array"},"checkoutId":{"$id":"/properties/checkoutId","description":"id for the current checkout flow ","type":"string"},"currency":{"$id":"/properties/currency","description":"currency of fees if applicable","type":"string"},"enteredFromReservationEdit":{"$id":"/properties/enteredFromReservationEdit","description":"did user come to this screen via a reservation edit","type":"boolean"},"listingId":{"$id":"/properties/listingId","description":"the id for the pool listing","type":"string"},"searchId":{"$id":"/properties/searchId","description":"id for the search that led to this listing","type":"string"}},"required":["listingId","enteredFromReservationEdit","searchId","currency","checkoutId","amenities"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserDisplayedAmenity', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserDisplayedPostBookingFlow' track call.
 *
 * @param UserDisplayedPostBookingFlow props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userDisplayedPostBookingFlow(props: UserDisplayedPostBookingFlow, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserDisplayedPostBookingFlow","$schema":"http://json-schema.org/draft-07/schema#","description":"[POST BOOKING REVIEW] user shown post-booking flow screen","properties":{"bookingId":{"$id":"/properties/bookingId","description":"id of the booking associated with the review","type":"integer"},"listingId":{"$id":"/properties/listingId","description":"id of the listing being reviewed","type":"integer"},"minutesSinceBookingCompleted":{"$id":"/properties/minutesSinceBookingCompleted","description":"minutes since this booking was completed and the user saw this display","type":"number"},"ratingValueDisplayed":{"$id":"/properties/ratingValueDisplayed","description":"the rating value displayed on the listing","type":"number"}},"required":["minutesSinceBookingCompleted","ratingValueDisplayed","listingId","bookingId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserDisplayedPostBookingFlow', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserEditedFilterDistance' track call.
 *
 * @param UserEditedFilterDistance props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userEditedFilterDistance(props: UserEditedFilterDistance, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserEditedFilterDistance","$schema":"http://json-schema.org/draft-07/schema#","description":"[SEARCH] user select distance in filter","properties":{"maxDistance":{"$id":"/properties/maxDistance","description":"the maximum distance the user filter on","type":"number"}},"required":["maxDistance"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserEditedFilterDistance', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserEditedFilterPrice' track call.
 *
 * @param UserEditedFilterPrice props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userEditedFilterPrice(props: UserEditedFilterPrice, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserEditedFilterPrice","$schema":"http://json-schema.org/draft-07/schema#","description":"[SEARCH] user select price range in filter","properties":{"highPrice":{"$id":"/properties/highPrice","description":"the maximum price the user filtered on","type":"number"},"lowPrice":{"$id":"/properties/lowPrice","description":"the minimum price the user filtered on","type":"number"}},"required":["highPrice","lowPrice"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserEditedFilterPrice', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserEditedPoolType' track call.
 *
 * @param UserEditedPoolType props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userEditedPoolType(props: UserEditedPoolType, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserEditedPoolType","$schema":"http://json-schema.org/draft-07/schema#","description":"[SEARCH] user select a pool type in filter","properties":{"poolType":{"$id":"/properties/poolType","description":"pool type the user selected","type":["string","null"]}},"required":["properties"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserEditedPoolType', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserEditedWaterType' track call.
 *
 * @param UserEditedWaterType props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userEditedWaterType(props: UserEditedWaterType, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserEditedWaterType","$schema":"http://json-schema.org/draft-07/schema#","description":"[SEARCH] user select water type in filter","properties":{"waterType":{"$id":"/properties/waterType","description":"water type the user selected (salt water or chlorine)","type":["string","null"]}},"required":["properties"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserEditedWaterType', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserEnteredFavoriteListMapView' track call.
 *
 * @param UserEnteredFavoriteListMapView props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userEnteredFavoriteListMapView(props: UserEnteredFavoriteListMapView, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserEnteredFavoriteListMapView","$schema":"http://json-schema.org/draft-07/schema#","description":"[GUEST FAVORITE] user clicked to enter map view for favorites list","properties":{"alphaUserId":{"$id":"/properties/alphaUserId","description":"the user id of the account who created the favorite collection","type":"integer"},"betaUserIds":{"$id":"/properties/betaUserIds","description":"an array of any favorite collection collaborator's user ids","type":"array"},"favoriteCollectionId":{"$id":"/properties/favoriteCollectionId","description":"the favorite collection id","type":"integer"},"favoriteCollectionName":{"$id":"/properties/favoriteCollectionName","description":"the name of the favorite collection","type":"string"},"id":{"$id":"/properties/id","description":"","type":"string"},"isAlphaUserId":{"$id":"/properties/isAlphaUserId","description":"a boolean to identify whether the actions being taken to a favorite collection are being done by the alpha user (1) or a beta user (0)","type":"boolean"}},"required":["favoriteCollectionId","favoriteCollectionName","isAlphaUserId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserEnteredFavoriteListMapView', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserEnteredFullScreenMap' track call.
 *
 * @param UserEnteredFullScreenMap props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userEnteredFullScreenMap(props: UserEnteredFullScreenMap, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserEnteredFullScreenMap","$schema":"http://json-schema.org/draft-07/schema#","description":"[SEARCH] user pressed full screen map view ","properties":{"searchId":{"$id":"/properties/searchId","description":"id of search which generated result","type":["string","null"]}},"required":["searchId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserEnteredFullScreenMap', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserEnteredPromoCode' track call.
 *
 * @param UserEnteredPromoCode props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userEnteredPromoCode(props: UserEnteredPromoCode, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserEnteredPromoCode","$schema":"http://json-schema.org/draft-07/schema#","description":"[CHECKOUT] user attempted to apply a promo code","properties":{"checkoutId":{"$id":"/properties/checkoutId","description":"id for the current checkout flow","type":"string"},"inValidReasons":{"$id":"/properties/inValidReasons","description":"if invalid, reasons why it is invalid","type":"array"},"isValid":{"$id":"/properties/isValid","description":"did promo code successfully apply to order","type":"boolean"},"listingId":{"$id":"/properties/listingId","description":"the id for the pool listing","type":"string"},"promoCodeDollarAmount":{"$id":"/properties/promoCodeDollarAmount","description":"promo code deduction in dollars","type":"number"},"promoCodePercentAmount":{"$id":"/properties/promoCodePercentAmount","description":"percent off applied due to promo code","type":"number"},"promoCodeText":{"$id":"/properties/promoCodeText","description":"text input of promo code","type":"string"},"searchId":{"$id":"/properties/searchId","description":"id for the search that led to this listing","type":["string","null"]}},"required":["searchId","isValid","promoCodePercentAmount","inValidReasons","promoCodeText","listingId","checkoutId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserEnteredPromoCode', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserEnteredZipCode' track call.
 *
 * @param UserEnteredZipCode props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userEnteredZipCode(props: UserEnteredZipCode, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserEnteredZipCode","$schema":"http://json-schema.org/draft-07/schema#","description":"[ACCOUNT CREATION] user entered ZIP code ","properties":{"authId":{"$id":"/properties/authId","description":"the authentication session ID","type":"string"},"zipCode":{"$id":"/properties/zipCode","description":"zip code entered by user","type":"string"}},"required":["authId","zipCode"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserEnteredZipCode', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserExitedCozymealBookingAdditions' track call.
 *
 * @param UserExitedCozymealBookingAdditions props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userExitedCozymealBookingAdditions(props: UserExitedCozymealBookingAdditions, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserExitedCozymealBookingAdditions","$schema":"http://json-schema.org/draft-07/schema#","description":"[COZYMEAL] User clicked to exit the Cozymeal catering options page","properties":{"bookingId":{"$id":"/properties/bookingId","description":"","type":"integer"},"guestId":{"$id":"/properties/guestId","description":"","type":"integer"},"hostId":{"$id":"/properties/hostId","description":"","type":"integer"},"id":{"$id":"/properties/id","description":"","type":"string"},"listingId":{"$id":"/properties/listingId","description":"","type":"integer"}},"required":["listingId","guestId","hostId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserExitedCozymealBookingAdditions', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserFiltersPressed' track call.
 *
 * @param UserFiltersPressed props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userFiltersPressed(props: UserFiltersPressed, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserFiltersPressed","$schema":"http://json-schema.org/draft-07/schema#","description":"[SEARCH] user entered the filter menu","properties":{"searchId":{"$id":"/properties/searchId","description":"id of search which generated result","type":["string","null"]}},"required":["searchId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserFiltersPressed', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserFindASpaceScreenEditTime' track call.
 *
 * @param UserFindASpaceScreenEditTime props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userFindASpaceScreenEditTime(props: UserFindASpaceScreenEditTime, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserFindASpaceScreenEditTime","$schema":"http://json-schema.org/draft-07/schema#","description":"[SEARCH] user edited the time in the Find A Space screen","properties":{"endTime":{"$id":"/properties/endTime","description":"The new ending time the user entered in military format","type":["number","null"]},"startTime":{"$id":"/properties/startTime","description":"The new starting time the user entered in military format","type":["number","null"]}},"required":["properties"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserFindASpaceScreenEditTime', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserFindASpaceScreenEditWhen' track call.
 *
 * @param UserFindASpaceScreenEditWhen props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userFindASpaceScreenEditWhen(props: UserFindASpaceScreenEditWhen, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserFindASpaceScreenEditWhen","$schema":"http://json-schema.org/draft-07/schema#","description":"[SEARCH]\nuser edited the date in the Find A Space screen\n","properties":{"date":{"$id":"/properties/date","description":"the new date the user entered\n","type":"string"},"weatherSelectedDate":{"$id":"/properties/weatherSelectedDate","description":"the weather details shown in the day button","properties":{"temperature":{"$id":"/properties/properties/properties/weatherSelectedDate/properties/temperature","description":"temperature shown in day button","type":"integer"},"temperatureUnit":{"$id":"/properties/properties/properties/weatherSelectedDate/properties/temperatureUnit","description":"unit of the temperature","type":"string"},"weatherIcon":{"$id":"/properties/properties/properties/weatherSelectedDate/properties/weatherIcon","description":"weatherIcon","type":["string","null"]}},"required":[],"type":"object"}},"required":["date"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserFindASpaceScreenEditWhen', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserFindASpaceScreenEditWhere' track call.
 *
 * @param UserFindASpaceScreenEditWhere props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userFindASpaceScreenEditWhere(props: UserFindASpaceScreenEditWhere, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserFindASpaceScreenEditWhere","$schema":"http://json-schema.org/draft-07/schema#","description":"[SEARCH] user edited the location in the Find A Space screen","properties":{"latitude":{"$id":"/properties/latitude","description":"the latitude of the location the user entered","type":"number"},"longitude":{"$id":"/properties/longitude","description":"the longitude of the location the user entered","type":"number"},"searchTerm":{"$id":"/properties/searchTerm","description":"the search term the user entered","type":"string"}},"required":["latitude","longitude","searchTerm"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserFindASpaceScreenEditWhere', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserFindASpaceScreenEditWho' track call.
 *
 * @param UserFindASpaceScreenEditWho props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userFindASpaceScreenEditWho(props: UserFindASpaceScreenEditWho, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserFindASpaceScreenEditWho","$schema":"http://json-schema.org/draft-07/schema#","description":"[SEARCH] user edit the guest list in the Find A Space screen","properties":{"adultGuests":{"$id":"/properties/adultGuests","description":"the adult guest count the user entered","type":"integer"},"childGuests":{"$id":"/properties/childGuests","description":"the children guest count the user entered","type":"integer"},"infantGuests":{"$id":"/properties/infantGuests","description":"the infant guest count the user entered","type":"integer"},"petGuests":{"$id":"/properties/petGuests","description":"the pet guest count the user entered","type":"integer"}},"required":["adultGuests","childGuests","infantGuests","petGuests"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserFindASpaceScreenEditWho', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserLeadCompletedAccountCreationMethod' track call.
 *
 * @param UserLeadCompletedAccountCreationMethod props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userLeadCompletedAccountCreationMethod(props: UserLeadCompletedAccountCreationMethod, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserLeadCompletedAccountCreationMethod","$schema":"http://json-schema.org/draft-07/schema#","description":"[ACCOUNT CREATION] an anon successfully completed an account creation method (mobile, email, social)","properties":{"authId":{"$id":"/properties/authId","description":"the authentication session ID","type":"string"},"creationMethod":{"$id":"/properties/creationMethod","description":"which account creation method was completed","enum":["apple","email","facebook","google","mobile","social"],"type":"string"},"spaceType":{"$id":"/properties/spaceType","description":"(Web only) If user entered from homepage, return homepage space type. If user signed up in search and had a space type category selected, return that space type. If 'all space', return pool. If user sign up up PDP or checkout, return the space type of the listing. Otherwise return null ","enum":["basketballCourt","home","other","pickleball","pool","tennisCourt"],"type":"string"},"swimplyAttribution":{"$id":"/properties/swimplyAttribution","description":"Attributions that we capture from custom url query param","type":"string"},"userId":{"$id":"/properties/userId","description":"id of the created user","type":"string"}},"required":["userId","creationMethod","authId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserLeadCompletedAccountCreationMethod', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserLeadEmail' track call.
 *
 * @param UserLeadEmail props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userLeadEmail(props: UserLeadEmail, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserLeadEmail","$schema":"http://json-schema.org/draft-07/schema#","description":"[ACCOUNT CREATION] user lead entered email info","properties":{"authId":{"$id":"/properties/authId","description":"the authentication session ID","type":"string"},"emailAddress":{"$id":"/properties/emailAddress","description":"full user input email address","type":"string"}},"required":["emailAddress","authId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserLeadEmail', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserLeadExistingAccount' track call.
 *
 * @param UserLeadExistingAccount props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userLeadExistingAccount(props: UserLeadExistingAccount, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserLeadExistingAccount","$schema":"http://json-schema.org/draft-07/schema#","description":"[ACCOUNT CREATION] user lead has existing account and is brought to sign on","properties":{"authId":{"$id":"/properties/authId","description":"the authentication session ID","type":"string"},"existingAccountID":{"$id":"/properties/existingAccountID","description":"the user ID for the existing account","type":"integer"},"signOnMethod":{"$id":"/properties/signOnMethod","description":"method used to attempt account sign in (mobile, email, etc)","enum":["apple","email","facebook","google","mobile","social"],"type":"string"}},"required":["existingAccountID","authId","signOnMethod"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserLeadExistingAccount', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserLeadExistingAccountSignOnFailed' track call.
 *
 * @param UserLeadExistingAccountSignOnFailed props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userLeadExistingAccountSignOnFailed(props: UserLeadExistingAccountSignOnFailed, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserLeadExistingAccountSignOnFailed","$schema":"http://json-schema.org/draft-07/schema#","description":"[ACCOUNT CREATION] user lead failed to log into existing account","properties":{"authId":{"$id":"/properties/authId","description":"the authentication session ID","type":"string"},"failureReason":{"$id":"/properties/failureReason","description":"why did the method fail (invalid password, wrong verificaiton, etc)","type":"string"},"signOnMethod":{"$id":"/properties/signOnMethod","description":"method used to attempt account sign in (mobile, email, etc)","enum":["apple","email","facebook","google","mobile","social"],"type":"string"}},"required":["authId","signOnMethod","failureReason"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserLeadExistingAccountSignOnFailed', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserLeadExistingAccountSignOnSuccess' track call.
 *
 * @param UserLeadExistingAccountSignOnSuccess props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userLeadExistingAccountSignOnSuccess(props: UserLeadExistingAccountSignOnSuccess, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserLeadExistingAccountSignOnSuccess","$schema":"http://json-schema.org/draft-07/schema#","description":"[ACCOUNT CREATION] user lead successfully signed onto existing account","properties":{"authId":{"$id":"/properties/authId","description":"the authentication session ID","type":"string"},"existingAccountID":{"$id":"/properties/existingAccountID","description":"the user ID for the existing account","type":"string"},"signOnMethod":{"$id":"/properties/signOnMethod","description":"method used to attempt account sign in (mobile, email, etc)","enum":["apple","email","facebook","google","mobile","social"],"type":"string"}},"required":["existingAccountID","authId","signOnMethod"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserLeadExistingAccountSignOnSuccess', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserLeadForgotPassword' track call.
 *
 * @param UserLeadForgotPassword props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userLeadForgotPassword(props: UserLeadForgotPassword, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserLeadForgotPassword","$schema":"http://json-schema.org/draft-07/schema#","description":"[ACCOUNT CREATION] user lead pressed forgot password after entering email address","properties":{"authId":{"$id":"/properties/authId","description":"the authentication session ID","type":"string"}},"required":["authId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserLeadForgotPassword', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserLeadInitiatedAccountCreationMethod' track call.
 *
 * @param UserLeadInitiatedAccountCreationMethod props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userLeadInitiatedAccountCreationMethod(props: UserLeadInitiatedAccountCreationMethod, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserLeadInitiatedAccountCreationMethod","$schema":"http://json-schema.org/draft-07/schema#","description":"[ACCOUNT CREATION] an anon chose a specific account creation method (mobile, email, social)","properties":{"authId":{"$id":"/properties/authId","description":"the authentication session ID","type":"string"},"creationMethod":{"$id":"/properties/creationMethod","description":"which account creation method was initiated ","enum":["apple","email","facebook","google","mobile","social"],"type":"string"},"enteredFrom":{"$id":"/properties/enteredFrom","description":"How did we enter into the user creation flow?","enum":["auth","booking","chat","claimReferral","contactHost","earnCredits","emailVerification","enterPromoCode","favoriteListing","hostOnboarding","joinWaitlist","paymentMethods","popUp","postBookingInvite","purchasePass","review","unauthenticatedError","unspecified"],"type":"string"}},"required":["enteredFrom","creationMethod","authId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserLeadInitiatedAccountCreationMethod', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserLeadNumberEntered' track call.
 *
 * @param UserLeadNumberEntered props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userLeadNumberEntered(props: UserLeadNumberEntered, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserLeadNumberEntered","$schema":"http://json-schema.org/draft-07/schema#","description":"[ACCOUNT CREATION] information about the user lead phone number entered","properties":{"authId":{"$id":"/properties/authId","description":"the authentication session ID","type":"string"},"countryCode":{"$id":"/properties/countryCode","description":"country code for user lead input phone number","type":"string"},"mobileNumber":{"$id":"/properties/mobileNumber","description":"user lead input phone number","type":"string"}},"required":["authId","countryCode","mobileNumber"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserLeadNumberEntered', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserLeadNumberVerificationResend' track call.
 *
 * @param UserLeadNumberVerificationResend props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userLeadNumberVerificationResend(props: UserLeadNumberVerificationResend, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserLeadNumberVerificationResend","$schema":"http://json-schema.org/draft-07/schema#","description":"[ACCOUNT CREATION] Did the user lead resend the verification code","properties":{"authId":{"$id":"/properties/authId","description":"the authentication session ID","type":"string"}},"required":["authId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserLeadNumberVerificationResend', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserLeadNumberVerificationSuccess' track call.
 *
 * @param UserLeadNumberVerificationSuccess props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userLeadNumberVerificationSuccess(props: UserLeadNumberVerificationSuccess, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserLeadNumberVerificationSuccess","$schema":"http://json-schema.org/draft-07/schema#","description":"[ACCOUNT CREATION] user successfully entered in mobile number verification","properties":{"authId":{"$id":"/properties/authId","description":"the authentication session ID","type":"string"}},"required":["authId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserLeadNumberVerificationSuccess', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserLeadPhoneNumberInUse' track call.
 *
 * @param UserLeadPhoneNumberInUse props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userLeadPhoneNumberInUse(props: UserLeadPhoneNumberInUse, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserLeadPhoneNumberInUse","$schema":"http://json-schema.org/draft-07/schema#","description":"[ACCOUNT CREATION] user came to phone number in use view","properties":{"authId":{"$id":"/properties/authId","description":"the authentication session ID","type":"string"},"exisingAccountID":{"$id":"/properties/exisingAccountID","description":"the user ID for the existing account","type":"string"}},"required":["exisingAccountID","authId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserLeadPhoneNumberInUse', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserLeadPhoneNumberInUseEditNumber' track call.
 *
 * @param UserLeadPhoneNumberInUseEditNumber props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userLeadPhoneNumberInUseEditNumber(props: UserLeadPhoneNumberInUseEditNumber, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserLeadPhoneNumberInUseEditNumber","$schema":"http://json-schema.org/draft-07/schema#","description":"[ACCOUNT CREATION] user edited number on phone number in use prompt","properties":{"authId":{"$id":"/properties/authId","description":"the authentication session ID","type":"string"},"newNumber":{"$id":"/properties/newNumber","description":"final edit for mobile number","pattern":"","type":"string"},"originalNumber":{"$id":"/properties/originalNumber","description":"original mobile number entered","pattern":"","type":"string"}},"required":["newNumber","originalNumber","authId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserLeadPhoneNumberInUseEditNumber', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserLeadSelectedForgotPasswordOption' track call.
 *
 * @param UserLeadSelectedForgotPasswordOption props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userLeadSelectedForgotPasswordOption(props: UserLeadSelectedForgotPasswordOption, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserLeadSelectedForgotPasswordOption","$schema":"http://json-schema.org/draft-07/schema#","description":"[ACCOUNT CREATION] user selected the forgot password option","properties":{"authId":{"$id":"/properties/authId","description":"the authentication session ID","type":"string"},"option":{"$id":"/properties/option","description":"reset password or SMS login code","enum":["reset","sms"],"type":"string"}},"required":["authId","option"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserLeadSelectedForgotPasswordOption', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserLeadSubmittedForgotPasswordEmail' track call.
 *
 * @param UserLeadSubmittedForgotPasswordEmail props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userLeadSubmittedForgotPasswordEmail(props: UserLeadSubmittedForgotPasswordEmail, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserLeadSubmittedForgotPasswordEmail","$schema":"http://json-schema.org/draft-07/schema#","description":"[ACCOUNT CREATION] user entered email in forgot password","properties":{"authId":{"$id":"/properties/authId","description":"the authentication session ID","type":"string"},"email":{"$id":"/properties/email","description":"the entered email address","type":"string"}},"required":["authId","email"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserLeadSubmittedForgotPasswordEmail', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserLoadMore' track call.
 *
 * @param UserLoadMore props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userLoadMore(props: UserLoadMore, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserLoadMore","$schema":"http://json-schema.org/draft-07/schema#","description":"[SEARCH] user scrolled down to load more in list view","properties":{"searchId":{"$id":"/properties/searchId","description":"id of search which generated result","type":"string"}},"required":["searchId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserLoadMore', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserMovedFavoriteListMap' track call.
 *
 * @param UserMovedFavoriteListMap props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userMovedFavoriteListMap(props: UserMovedFavoriteListMap, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserMovedFavoriteListMap","$schema":"http://json-schema.org/draft-07/schema#","description":"[GUEST FAVORITE] user moved map for favorite list","properties":{"alphaUserId":{"$id":"/properties/alphaUserId","description":"the user id of the account who created the favorite collection","type":"integer"},"betaUserIds":{"$id":"/properties/betaUserIds","description":"an array of any favorite collection collaborator's user ids","type":"array"},"favoriteCollectionId":{"$id":"/properties/favoriteCollectionId","description":"the favorite collection id","type":"integer"},"favoriteCollectionName":{"$id":"/properties/favoriteCollectionName","description":"the name of the favorite collection","type":"string"},"id":{"$id":"/properties/id","description":"","type":"string"},"isAlphaUserId":{"$id":"/properties/isAlphaUserId","description":"a boolean to identify whether the actions being taken to a favorite collection are being done by the alpha user (1) or a beta user (0)","type":"boolean"}},"required":["favoriteCollectionName","isAlphaUserId","favoriteCollectionId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserMovedFavoriteListMap', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserMovedMap' track call.
 *
 * @param UserMovedMap props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userMovedMap(props: UserMovedMap, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserMovedMap","$schema":"http://json-schema.org/draft-07/schema#","description":"[SEARCH] user move the map to a different map bounding box","properties":{"centerPoint":{"$id":"/properties/centerPoint","description":"center point of the bounding box","properties":{"latitude":{"$id":"/properties/properties/properties/centerPoint/properties/latitude","description":"latitude of the center point of the bounding box","type":"number"},"longitude":{"$id":"/properties/properties/properties/centerPoint/properties/longitude","description":"longitude of the center point of the bounding box","type":"number"}},"required":["latitude","longitude"],"type":"object"},"distance":{"$id":"/properties/distance","description":"radius distance of the bounding box","type":"number"},"searchId":{"$id":"/properties/searchId","description":"id of search which generated result","type":["string","null"]}},"required":["centerPoint","distance","searchId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserMovedMap', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserOfferedAppStoreReview' track call.
 *
 * @param UserOfferedAppStoreReview props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userOfferedAppStoreReview(props: UserOfferedAppStoreReview, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserOfferedAppStoreReview","$schema":"http://json-schema.org/draft-07/schema#","description":"[POST BOOKING REVIEW] user prompted to leave review at app store","properties":{"bookingId":{"$id":"/properties/bookingId","description":"id of the booking associated with the review","type":"integer"},"listingId":{"$id":"/properties/listingId","description":"id of the listing being reviewed","type":"integer"}},"required":["listingId","bookingId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserOfferedAppStoreReview', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserOfferedBookAgain' track call.
 *
 * @param UserOfferedBookAgain props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userOfferedBookAgain(props: UserOfferedBookAgain, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserOfferedBookAgain","$schema":"http://json-schema.org/draft-07/schema#","description":"[POST BOOKING REVIEW] user offered to book listing again post review","properties":{"bookingId":{"$id":"/properties/bookingId","description":"id of the booking associated with the review","type":"integer"},"listingId":{"$id":"/properties/listingId","description":"id of the listing being reviewed","type":"integer"},"multiDipOffered":{"$id":"/properties/multiDipOffered","description":"details for the multi dip offer if applicable","properties":{"currency":{"$id":"/properties/properties/properties/multiDipOffered/properties/currency","description":"\ncurrency of the price","type":"string"},"discountOffered":{"$id":"/properties/properties/properties/multiDipOffered/properties/discountOffered","description":"discount amount offered in percentage terms for multidip ","type":"number"},"isMultiDipOffered":{"$id":"/properties/properties/properties/multiDipOffered/properties/isMultiDipOffered","description":"is a multi dip rebook offered?","type":"boolean"},"priceOfferedPerHour":{"$id":"/properties/properties/properties/multiDipOffered/properties/priceOfferedPerHour","description":"price offered for multi dip rebook","type":"number"}},"required":[],"type":"object"},"ratingSubmittedValue":{"$id":"/properties/ratingSubmittedValue","description":"value of the rating submitted","type":"integer"},"singleDipOffered":{"$id":"/properties/singleDipOffered","description":"details for the single dip offer if applicable","properties":{"currency":{"$id":"/properties/properties/properties/singleDipOffered/properties/currency","description":"currency of the price","type":"string"},"isSingleDipOffered":{"$id":"/properties/properties/properties/singleDipOffered/properties/isSingleDipOffered","description":"is a single dip rebook offered?","type":"boolean"},"priceOfferedPerHour":{"$id":"/properties/properties/properties/singleDipOffered/properties/priceOfferedPerHour","description":"price offered for single dip rebook","type":"number"}},"required":["isSingleDipOffered","priceOfferedPerHour","currency"],"type":"object"}},"required":["ratingSubmittedValue","singleDipOffered","bookingId","listingId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserOfferedBookAgain', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserOpenedCalendarFromSearch' track call.
 *
 * @param UserOpenedCalendarFromSearch props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userOpenedCalendarFromSearch(props: UserOpenedCalendarFromSearch, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserOpenedCalendarFromSearch","$schema":"http://json-schema.org/draft-07/schema#","description":"[SEARCH] user opened calendar view from search date input","properties":{"searchId":{"$id":"/properties/searchId","description":"id of search which generated result","type":["string","null"]}},"required":["searchId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserOpenedCalendarFromSearch', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserOpenedPaymentMethodChangeFromCheckout' track call.
 *
 * @param UserOpenedPaymentMethodChangeFromCheckout props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userOpenedPaymentMethodChangeFromCheckout(props: UserOpenedPaymentMethodChangeFromCheckout, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserOpenedPaymentMethodChangeFromCheckout","$schema":"http://json-schema.org/draft-07/schema#","description":"[CHECKOUT] user selected to change payment method in checkout","properties":{"checkoutId":{"$id":"/properties/checkoutId","description":"id for the current checkout flow ","type":"string"},"existingPaymentId":{"$id":"/properties/existingPaymentId","description":"id of previous payment method if applicable","type":"string"},"existingPaymentIsApplePay":{"$id":"/properties/existingPaymentIsApplePay","description":"is the existing payment method apple pay","type":"boolean"},"existingPaymentIsGooglePay":{"$id":"/properties/existingPaymentIsGooglePay","description":"is the existing payment method google pay","type":"boolean"},"listingId":{"$id":"/properties/listingId","description":"the id for the pool listing","type":"string"},"paymentIdsAvailable":{"$id":"/properties/paymentIdsAvailable","description":"list of all payment ids in wallet","type":"array"},"searchId":{"$id":"/properties/searchId","description":"id for the search that led to this listing","type":["string","null"]}},"required":["existingPaymentIsApplePay","existingPaymentIsGooglePay","checkoutId","listingId","paymentIdsAvailable","searchId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserOpenedPaymentMethodChangeFromCheckout', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserPressed360Tour' track call.
 *
 * @param UserPressed360Tour props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userPressed360Tour(props: UserPressed360Tour, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserPressed360Tour","$schema":"http://json-schema.org/draft-07/schema#","description":"[PLP] user clicks into a 360 Tour","properties":{"enteredFrom":{"$id":"/properties/enteredFrom","description":"how did the user end up on the 360 Tour","enum":["bookingInquiry","pdp","photos"],"type":"string"},"globalListingType":{"$id":"/properties/globalListingType","description":"[LISTING TYPE] The type of the listing associated with this event","enum":["artStudio","basketballCourt","dockedBoat","home","homeGym","joyspace","kitchen","largeBackyard","musicStudio","other","pending","pickleball","pool","privateLake","roofDeck","tennisCourt"],"type":"string"},"listingId":{"$id":"/properties/listingId","description":"id of the listing","type":"string"}},"required":["enteredFrom","listingId","globalListingType"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserPressed360Tour', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserPressedActionCTAFromMessageThread' track call.
 *
 * @param UserPressedActionCTAFromMessageThread props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userPressedActionCTAFromMessageThread(props: UserPressedActionCTAFromMessageThread, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserPressedActionCTAFromMessageThread","$schema":"http://json-schema.org/draft-07/schema#","description":"user pressed to exit the thread to go to reservation action","properties":{"action":{"$id":"/properties/action","description":"the action CTA that they're addressing","enum":[null],"type":["string","null"]},"bookingId":{"$id":"/properties/bookingId","description":"the booking shown when the user clicks to see the reservation on chat - logic defined by Mojin in Chat Redesign PRD","type":"integer"},"bookingState":{"$id":"/properties/bookingState","description":"","enum":["canceled","completed","confirmed","declined","expired","inquiry",null,"pending","special_offer"],"type":["string","null"]},"guestId":{"$id":"/properties/guestId","description":"the guest for the booking","type":"integer"},"hostId":{"$id":"/properties/hostId","description":"the host for the booking","type":"integer"},"listingId":{"$id":"/properties/listingId","description":"the listing for the booking","type":"integer"},"roomId":{"$id":"/properties/roomId","description":"the room id for the chat","type":"string"},"userIsHost":{"$id":"/properties/userIsHost","description":"is the current user the host (then 1) or are they the guest (then 0)","type":"boolean"}},"required":["userIsHost","guestId","hostId","listingId","roomId","bookingId","bookingState","action"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserPressedActionCTAFromMessageThread', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserPressedAdaFilter' track call.
 *
 * @param UserPressedAdaFilter props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userPressedAdaFilter(props: UserPressedAdaFilter, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserPressedAdaFilter","$schema":"http://json-schema.org/draft-07/schema#","description":"[SEARCH] user pressed the ada filter in the filter menu","properties":{"fakeProperty":{"$id":"/properties/fakeProperty","description":"DO NOT SEND: This is added as a workaround for this issue: https://github.com/segmentio/typewriter/issues/284","type":["string","null"]}},"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserPressedAdaFilter', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserPressedAddAnotherFriendEmail' track call.
 *
 * @param UserPressedAddAnotherFriendEmail props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userPressedAddAnotherFriendEmail(props: UserPressedAddAnotherFriendEmail, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserPressedAddAnotherFriendEmail","$schema":"http://json-schema.org/draft-07/schema#","description":"[REFERRAL] user pressed add another friend in the email option","properties":{"id":{"$id":"/properties/id","description":"","type":"string"}},"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserPressedAddAnotherFriendEmail', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserPressedAddMeToWaitlist' track call.
 *
 * @param UserPressedAddMeToWaitlist props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userPressedAddMeToWaitlist(props: UserPressedAddMeToWaitlist, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserPressedAddMeToWaitlist","$schema":"http://json-schema.org/draft-07/schema#","description":"[USER SUBSCRIPTION] User pressed the add me to waitlist button","properties":{"category":{"$id":"/properties/category","description":"the search category subscribed by the user","enum":["All","Backyards","Boats","Budget","Discover","Family","Heated","Home","Homes","Hoops","Hot Tubs","Indoors","Paddle","Parties","Pets","Pickleball","Pool","Pools","Racquet","Vip"],"type":"string"},"date":{"$id":"/properties/date","description":"the date searched by the user","type":["string","null"]},"endTime":{"$id":"/properties/endTime","description":"the end hour searched by the user","type":["string","null"]},"enteredFromEndOfSearchResult":{"$id":"/properties/enteredFromEndOfSearchResult","description":"true if waitlist button shown in the end of the search result","type":"boolean"},"enteredFromNoSearchResult":{"$id":"/properties/enteredFromNoSearchResult","description":"true if waitlist button shown in no search result","type":"boolean"},"fullAddress":{"$id":"/properties/fullAddress","description":"the address subscribed by the user","type":"string"},"startTime":{"$id":"/properties/startTime","description":"the start hour searched by the user","type":["string","null"]}},"required":["category","startTime","enteredFromNoSearchResult","enteredFromEndOfSearchResult"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserPressedAddMeToWaitlist', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserPressedAddPaymentMethod' track call.
 *
 * @param UserPressedAddPaymentMethod props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userPressedAddPaymentMethod(props: UserPressedAddPaymentMethod, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserPressedAddPaymentMethod","$schema":"http://json-schema.org/draft-07/schema#","description":"[CHECKOUT] user entered screen to add payment, either from checkout or wallet","properties":{"checkoutId":{"$id":"/properties/checkoutId","description":"id for the current checkout flow ","type":"string"},"enteredFrom":{"$id":"/properties/enteredFrom","description":"where did the user enter this option from","type":"string"},"listingId":{"$id":"/properties/listingId","description":"the id for the pool listing","type":"string"},"searchId":{"$id":"/properties/searchId","description":"id for the search that led to this listing","type":["string","null"]}},"required":["checkoutId","listingId","searchId","enteredFrom"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserPressedAddPaymentMethod', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserPressedAddPromoCode' track call.
 *
 * @param UserPressedAddPromoCode props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userPressedAddPromoCode(props: UserPressedAddPromoCode, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserPressedAddPromoCode","$schema":"http://json-schema.org/draft-07/schema#","description":"[CHECKOUT] user opened promo code entry option","properties":{"checkoutId":{"$id":"/properties/checkoutId","description":"id for the current checkout flow ","type":"string"},"listingId":{"$id":"/properties/listingId","description":"the id for the pool listing","type":"string"},"searchId":{"$id":"/properties/searchId","description":"id for the search that led to this listing","type":["string","null"]}},"required":["searchId","checkoutId","listingId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserPressedAddPromoCode', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserPressedAddZipCode' track call.
 *
 * @param UserPressedAddZipCode props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userPressedAddZipCode(props: UserPressedAddZipCode, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserPressedAddZipCode","$schema":"http://json-schema.org/draft-07/schema#","description":"[ACCOUNT CREATION] user pressed add my zip code instead","properties":{"authId":{"$id":"/properties/authId","description":"the authentication session ID","type":"string"}},"required":["authId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserPressedAddZipCode', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserPressedAgreeTermsAndCondition' track call.
 *
 * @param UserPressedAgreeTermsAndCondition props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userPressedAgreeTermsAndCondition(props: UserPressedAgreeTermsAndCondition, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserPressedAgreeTermsAndCondition","$schema":"http://json-schema.org/draft-07/schema#","description":"[CHECKOUT] user pressed agree terms and condition checkbox","properties":{"checkoutId":{"$id":"/properties/checkoutId","description":"id for the current checkout flow ","type":"string"},"listingId":{"$id":"/properties/listingId","description":"the id for the pool listing","type":"string"},"searchId":{"$id":"/properties/searchId","description":"id for the search that led to this listing","type":["string","null"]}},"required":["searchId","listingId","checkoutId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserPressedAgreeTermsAndCondition', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserPressedAppStoreReview' track call.
 *
 * @param UserPressedAppStoreReview props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userPressedAppStoreReview(props: UserPressedAppStoreReview, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserPressedAppStoreReview","$schema":"http://json-schema.org/draft-07/schema#","description":"[POST BOOKING REVIEW] user pressed to leave review at app store","properties":{"bookingId":{"$id":"/properties/bookingId","description":"id of the booking associated with the review","type":"integer"},"listingId":{"$id":"/properties/listingId","description":"id of the listing being reviewed","type":"integer"}},"required":["listingId","bookingId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserPressedAppStoreReview', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserPressedBadgeInfoCard' track call.
 *
 * @param UserPressedBadgeInfoCard props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userPressedBadgeInfoCard(props: UserPressedBadgeInfoCard, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserPressedBadgeInfoCard","$schema":"http://json-schema.org/draft-07/schema#","description":"[PLP] user clicks on one of the badges on the PLP - bringing up the  badge info card","properties":{"globalListingType":{"$id":"/properties/globalListingType","description":"[LISTING TYPE] The type of the listing associated with this event","enum":["artStudio","basketballCourt","dockedBoat","home","homeGym","joyspace","kitchen","largeBackyard","musicStudio","other","pending","pickleball","pool","privateLake","roofDeck","tennisCourt"],"type":"string"},"isFanFavorite":{"$id":"/properties/isFanFavorite","description":"does the listing currently have the Fan Favorite Badge","type":"boolean"},"isTopSwimply":{"$id":"/properties/isTopSwimply","description":"does the listing currently have the Top Swimply Badge","type":"boolean"},"listingId":{"$id":"/properties/listingId","description":"id of the listing","type":"string"}},"required":["isFanFavorite","globalListingType","isTopSwimply","listingId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserPressedBadgeInfoCard', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserPressedBanner' track call.
 *
 * @param UserPressedBanner props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userPressedBanner(props: UserPressedBanner, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserPressedBanner","$schema":"http://json-schema.org/draft-07/schema#","description":"[SEARCH RESULT BANNER] User pressed on the banner in the search result","properties":{"bannerText":{"$id":"/properties/bannerText","description":"the displayed text on the search banner","type":"string"},"searchId":{"$id":"/properties/searchId","description":"the searchId associated with this search when user pressed the banner","type":"string"}},"required":["bannerText","searchId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserPressedBanner', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserPressedBookAgainOption' track call.
 *
 * @param UserPressedBookAgainOption props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userPressedBookAgainOption(props: UserPressedBookAgainOption, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserPressedBookAgainOption","$schema":"http://json-schema.org/draft-07/schema#","description":"[POST BOOKING REVIEW] user offered to book listing again post review","properties":{"bookingId":{"$id":"/properties/bookingId","description":"id of the booking associated with the review","type":"integer"},"listingId":{"$id":"/properties/listingId","description":"id of the listing being reviewed","type":"integer"},"multiDipDetails":{"$id":"/properties/multiDipDetails","description":"details for the multi dip offer if applicable","properties":{"currency":{"$id":"/properties/properties/properties/multiDipDetails/properties/currency","description":"\ncurrency of the price","type":"string"},"discountOffered":{"$id":"/properties/properties/properties/multiDipDetails/properties/discountOffered","description":"discount amount offered in percentage terms for multidip ","type":"number"},"isMultiDipPressed":{"$id":"/properties/properties/properties/multiDipDetails/properties/isMultiDipPressed","description":"did user select multi dip","type":"boolean"},"priceOfferedPerHour":{"$id":"/properties/properties/properties/multiDipDetails/properties/priceOfferedPerHour","description":"price offered for multi dip rebook","type":"number"}},"required":[],"type":"object"},"ratingSubmittedValue":{"$id":"/properties/ratingSubmittedValue","description":"value of the rating submitted","type":"integer"},"singleDipDetails":{"$id":"/properties/singleDipDetails","description":"details for the single dip offer if applicable","properties":{"currency":{"$id":"/properties/properties/properties/singleDipDetails/properties/currency","description":"currency of the price","type":"string"},"isSingleDipPressed":{"$id":"/properties/properties/properties/singleDipDetails/properties/isSingleDipPressed","description":"did user select single dip","type":"boolean"},"priceOfferedPerHour":{"$id":"/properties/properties/properties/singleDipDetails/properties/priceOfferedPerHour","description":"price offered for single dip rebook","type":"number"}},"required":["priceOfferedPerHour","currency","isSingleDipPressed"],"type":"object"}},"required":["listingId","ratingSubmittedValue","singleDipDetails","bookingId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserPressedBookAgainOption', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserPressedBookPostPassPurchase' track call.
 *
 * @param UserPressedBookPostPassPurchase props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userPressedBookPostPassPurchase(props: UserPressedBookPostPassPurchase, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserPressedBookPostPassPurchase","$schema":"http://json-schema.org/draft-07/schema#","description":"[CHECKOUT] after a user purchases a pass and presses the modal to start or finish booking","properties":{"coverImageURL":{"$id":"/properties/coverImageURL","description":"the url for the cover image of the listing the pass is for","type":"string"},"hostFirstName":{"$id":"/properties/hostFirstName","description":"first name of the host","type":"string"},"isFromUpsell":{"$id":"/properties/isFromUpsell","description":"true if the user just bought their pass via upsell, and are shown \"finish booking\", false if not and they're shown \"start booking\"","type":"boolean"},"listingId":{"$id":"/properties/listingId","description":"id of the listing the pass is for","type":"string"},"listingTitle":{"$id":"/properties/listingTitle","description":"the title of the listing the pass is for","type":"string"},"listingURL":{"$id":"/properties/listingURL","description":"the url of the listing the pass is for","type":"string"},"passAvailableTimes":{"$id":"/properties/passAvailableTimes","description":"[{from:”07:00:00”, “11:00:00”}...] Time slots when this pass is eligible","type":"array"},"passAvailableTimesText":{"$id":"/properties/passAvailableTimesText","description":"LCM formatted version of available times property","type":"string"},"passBlackoutDays":{"$id":"/properties/passBlackoutDays","description":"list of blackout dates (e.g. July 4, 2024). ","type":["array","null"]},"passCreatedAt":{"$id":"/properties/passCreatedAt","description":"when the pass was created","type":"string"},"passCurrencyCode":{"$id":"/properties/passCurrencyCode","description":"currency for all monetary fields","type":"string"},"passCurrent":{"$id":"/properties/passCurrent","description":"flag indicating that this is the current version for a pass. For a type/name/listing_id, there can only be one record with this attribute true.","type":"boolean"},"passDescription":{"$id":"/properties/passDescription","description":"free text description set by host","type":["string","null"]},"passDiscount":{"$id":"/properties/passDiscount","description":"discount amount. Fixed discounts will be in minors units.","type":["number","null"]},"passDiscountType":{"$id":"/properties/passDiscountType","description":"type of pass discount num[‘percentage’, ‘fixed’]","enum":["FIXED","PERCENTAGE",null],"type":["string","null"]},"passEligibleDays":{"$id":"/properties/passEligibleDays","description":"days the pass is eligible","type":["array","null"]},"passId":{"$id":"/properties/passId","description":"id of the pass","type":"integer"},"passMaxActivePasses":{"$id":"/properties/passMaxActivePasses","description":"max active passes allowed. This constraint will apply to the (listing_id, type, name) rather than id so that we can be accurate across edits.","type":["number","null"]},"passMaxDailyBookings":{"$id":"/properties/passMaxDailyBookings","description":"max bookings allowed under this pass","type":["number","null"]},"passMaxDuration":{"$id":"/properties/passMaxDuration","description":"max duration that may be booked using this pass","type":["number","null"]},"passMaxGuests":{"$id":"/properties/passMaxGuests","description":"max guests that may be booked using this pass","type":["number","null"]},"passName":{"$id":"/properties/passName","description":"the type of the pass formatted to be LCM friendly","pattern":"","type":"string"},"passPremiumAmenities":{"$id":"/properties/passPremiumAmenities","description":"the ids of all premium amenities included with the pass","type":["array","null"]},"passPrice":{"$id":"/properties/passPrice","description":"pass price in minor units","type":"string"},"passState":{"$id":"/properties/passState","description":"‘draft’ -> pass is being actively edited by the host via the creation flow. The step attribute below tracks the progress of the host through the creation flow.\n‘inactive’ -> pass has been created by the host, but not ready for sale yet\n‘active’ -> pass has passed the final availability requirements and has been marked by the host as ready for sale.","enum":["ACTIVE","DRAFT","INACTIVE"],"type":"string"},"passTotalPrice":{"$id":"/properties/passTotalPrice","description":"the pass of the price plus the service fee","type":"string"},"passType":{"$id":"/properties/passType","description":"the type of pass","enum":["ALL_ACCESS","EARLY_BIRD","FIXED_HOURS","WEEKDAY"],"type":"string"}},"required":["passType","listingId","passDiscount","passPrice","listingURL","passCurrent","passName","isFromUpsell","passState","coverImageURL","passTotalPrice","hostFirstName","passDiscountType","passId","listingTitle","passCreatedAt","passCurrencyCode"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserPressedBookPostPassPurchase', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserPressedCancelSendPicture' track call.
 *
 * @param UserPressedCancelSendPicture props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userPressedCancelSendPicture(props: UserPressedCancelSendPicture, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserPressedCancelSendPicture","$schema":"http://json-schema.org/draft-07/schema#","description":"[MESSAGING - PHOTOS] after selecting a photo, the user pressed \"cancel\" or exited out","properties":{"bookingId":{"$id":"/properties/bookingId","description":"the booking shown when the user clicks to see the reservation on chat - logic defined by Mojin in Chat Redesign PRD","type":"integer"},"guestId":{"$id":"/properties/guestId","description":"the guest for the booking","type":"integer"},"hostId":{"$id":"/properties/hostId","description":"the host for the booking","type":"integer"},"id":{"$id":"/properties/id","description":"","type":"string"},"listingId":{"$id":"/properties/listingId","description":"the listing for the booking","type":"integer"},"roomId":{"$id":"/properties/roomId","description":"the room id for the chat","type":"string"}},"required":["guestId","hostId","bookingId","listingId","roomId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserPressedCancelSendPicture', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserPressedCategoryInspiration' track call.
 *
 * @param UserPressedCategoryInspiration props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userPressedCategoryInspiration(props: UserPressedCategoryInspiration, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserPressedCategoryInspiration","$schema":"http://json-schema.org/draft-07/schema#","description":"[WEB HOMEPAGE] Phase 2 User pressed any of the category inspiration ","properties":{"categoryName":{"$id":"/properties/categoryName","description":"the name of the category","type":"string"}},"required":["categoryName"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserPressedCategoryInspiration', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserPressedCategoryTab' track call.
 *
 * @param UserPressedCategoryTab props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userPressedCategoryTab(props: UserPressedCategoryTab, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserPressedCategoryTab","$schema":"http://json-schema.org/draft-07/schema#","description":"[SEARCH] user pressed any of the tabs on the category bar","properties":{"isListView":{"$id":"/properties/isListView","description":"True if the user is in list view, false if in map view","type":"boolean"},"tabName":{"$id":"/properties/tabName","description":"name of the category tab","type":"string"}},"required":["isListView","tabName"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserPressedCategoryTab', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserPressedChangePhoneNumber' track call.
 *
 * @param UserPressedChangePhoneNumber props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userPressedChangePhoneNumber(props: UserPressedChangePhoneNumber, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserPressedChangePhoneNumber","$schema":"http://json-schema.org/draft-07/schema#","description":"[USER PROFILE - Account Details] user pressed to change their phone number","properties":{"id":{"$id":"/properties/id","description":"","type":"string"}},"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserPressedChangePhoneNumber', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserPressedClaimReferralButtonBottom' track call.
 *
 * @param UserPressedClaimReferralButtonBottom props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userPressedClaimReferralButtonBottom(props: UserPressedClaimReferralButtonBottom, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserPressedClaimReferralButtonBottom","$schema":"http://json-schema.org/draft-07/schema#","description":"[CLAIM REFERRAL] User pressed the claim referral button on the bottom of the referral page","properties":{"claimReferralButtonText":{"$id":"/properties/claimReferralButtonText","description":"The text of the claim referral button","type":"string"},"referralId":{"$id":"/properties/referralId","description":"the referral id of the invite","type":"string"},"referralType":{"$id":"/properties/referralType","description":"Type of the referral, host or guest","type":"string"}},"required":["referralType","claimReferralButtonText","referralId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserPressedClaimReferralButtonBottom', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserPressedClaimReferralButtonReferrerTracking' track call.
 *
 * @param UserPressedClaimReferralButtonReferrerTracking props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userPressedClaimReferralButtonReferrerTracking(props: UserPressedClaimReferralButtonReferrerTracking, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserPressedClaimReferralButtonReferrerTracking","$schema":"http://json-schema.org/draft-07/schema#","description":"[CLAIM REFERRAL] When the referee (beta guest) presses the claim referral button on EITHER the top or bottom of the referral page WITH the userId as the Alpha User (or referrer)","properties":{"claimReferralButtonText":{"$id":"/properties/claimReferralButtonText","description":"The text of the claim referral button","type":"string"},"refereeId":{"$id":"/properties/refereeId","description":"the id of the referee (the user signed in taking the action)","type":"string"},"referralId":{"$id":"/properties/referralId","description":"the referral id of the invite","type":"string"},"referralType":{"$id":"/properties/referralType","description":"Type of the referral, host or guest","type":"string"},"referrerId":{"$id":"/properties/referrerId","description":"the user id of the user who sent the original invite","type":"string"}},"required":["referralType","claimReferralButtonText","referralId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserPressedClaimReferralButtonReferrerTracking', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserPressedClaimReferralButtonTop' track call.
 *
 * @param UserPressedClaimReferralButtonTop props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userPressedClaimReferralButtonTop(props: UserPressedClaimReferralButtonTop, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserPressedClaimReferralButtonTop","$schema":"http://json-schema.org/draft-07/schema#","description":"[CLAIM REFERRAL] User pressed the claim referral button on the top of the referral page","properties":{"claimReferralButtonText":{"$id":"/properties/claimReferralButtonText","description":"The text of the claim referral button ","type":"string"},"referralId":{"$id":"/properties/referralId","description":"the referral id of the invite","type":"string"},"referralType":{"$id":"/properties/referralType","description":"Type of the referral, host or guest","type":"string"}},"required":["claimReferralButtonText","referralType","referralId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserPressedClaimReferralButtonTop', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserPressedCompleteProfileVerification' track call.
 *
 * @param UserPressedCompleteProfileVerification props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userPressedCompleteProfileVerification(props: UserPressedCompleteProfileVerification, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserPressedCompleteProfileVerification","$schema":"http://json-schema.org/draft-07/schema#","description":"[USER PROFILE - Account Verification] user pressed the complete verification button from their profile","properties":{"enteredFrom":{"$id":"/properties/enteredFrom","description":"","enum":["account_settings","underage_booking","underage_contact_host","underage_pass_purchase"],"type":"string"},"id":{"$id":"/properties/id","description":"","type":"string"}},"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserPressedCompleteProfileVerification', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserPressedConfirmPurchasePass' track call.
 *
 * @param UserPressedConfirmPurchasePass props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userPressedConfirmPurchasePass(props: UserPressedConfirmPurchasePass, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserPressedConfirmPurchasePass","$schema":"http://json-schema.org/draft-07/schema#","description":"[CHECKOUT] when a user presses to purchase a pass","properties":{"coverImageURL":{"$id":"/properties/coverImageURL","description":"the url for the cover image of the listing the pass is for","type":"string"},"hostFirstName":{"$id":"/properties/hostFirstName","description":"first name of the host","type":"string"},"id":{"$id":"/properties/id","description":"","type":"string"},"listingId":{"$id":"/properties/listingId","description":"id of the listing the pass is for","type":"string"},"listingTitle":{"$id":"/properties/listingTitle","description":"the title of the listing the pass is for","type":"string"},"listingURL":{"$id":"/properties/listingURL","description":"the url of the listing the pass is for","type":"string"},"passAvailableTimes":{"$id":"/properties/passAvailableTimes","description":"[{from:”07:00:00”, “11:00:00”}...] Time slots when this pass is eligible","type":"array"},"passAvailableTimesText":{"$id":"/properties/passAvailableTimesText","description":"LCM formatted version of available times property","type":"string"},"passBlackoutDays":{"$id":"/properties/passBlackoutDays","description":"list of blackout dates (e.g. July 4, 2024). ","type":["array","null"]},"passCreatedAt":{"$id":"/properties/passCreatedAt","description":"when the pass was created","type":"string"},"passCurrencyCode":{"$id":"/properties/passCurrencyCode","description":"currency for all monetary fields","type":"string"},"passCurrent":{"$id":"/properties/passCurrent","description":"flag indicating that this is the current version for a pass. For a type/name/listing_id, there can only be one record with this attribute true.","type":"boolean"},"passDescription":{"$id":"/properties/passDescription","description":"free text description set by host","type":["string","null"]},"passDiscount":{"$id":"/properties/passDiscount","description":"discount amount. Fixed discounts will be in minors units.","type":["number","null"]},"passDiscountType":{"$id":"/properties/passDiscountType","description":"type of pass discount num[‘percentage’, ‘fixed’]","enum":["FIXED","PERCENTAGE",null],"type":["string","null"]},"passEligibleDays":{"$id":"/properties/passEligibleDays","description":"days the pass is eligible","type":["array","null"]},"passId":{"$id":"/properties/passId","description":"id of the pass","type":"integer"},"passMaxActivePasses":{"$id":"/properties/passMaxActivePasses","description":"max active passes allowed. This constraint will apply to the (listing_id, type, name) rather than id so that we can be accurate across edits.","type":["number","null"]},"passMaxDailyBookings":{"$id":"/properties/passMaxDailyBookings","description":"max bookings allowed under this pass","type":["number","null"]},"passMaxDuration":{"$id":"/properties/passMaxDuration","description":"max duration that may be booked using this pass","type":["number","null"]},"passMaxGuests":{"$id":"/properties/passMaxGuests","description":"max guests that may be booked using this pass","type":["number","null"]},"passName":{"$id":"/properties/passName","description":"the type of the pass formatted to be LCM friendly","pattern":"","type":"string"},"passPremiumAmenities":{"$id":"/properties/passPremiumAmenities","description":"the ids of all premium amenities included with the pass","type":["array","null"]},"passPrice":{"$id":"/properties/passPrice","description":"pass price in minor units","type":"string"},"passState":{"$id":"/properties/passState","description":"‘draft’ -> pass is being actively edited by the host via the creation flow. The step attribute below tracks the progress of the host through the creation flow.\n‘inactive’ -> pass has been created by the host, but not ready for sale yet\n‘active’ -> pass has passed the final availability requirements and has been marked by the host as ready for sale.","enum":["ACTIVE","DRAFT","INACTIVE"],"type":"string"},"passTotalPrice":{"$id":"/properties/passTotalPrice","description":"the pass of the price plus the service fee","type":"string"},"passType":{"$id":"/properties/passType","description":"the type of pass","enum":["ALL_ACCESS","EARLY_BIRD","FIXED_HOURS","WEEKDAY"],"type":"string"},"passUpsellCreditAmountOffer":{"$id":"/properties/passUpsellCreditAmountOffer","description":"If the guest is shown an expiring discount towards the pass purchase, how much is it for (null if it's expired or not sh...\n","type":["number","null"]}},"required":["passCurrent","passDiscountType","passState","passCurrencyCode","passPrice","passName","passId","passTotalPrice","listingId","passDiscount","hostFirstName","coverImageURL","listingTitle","passType","listingURL","passCreatedAt"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserPressedConfirmPurchasePass', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserPressedContactHost' track call.
 *
 * @param UserPressedContactHost props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userPressedContactHost(props: UserPressedContactHost, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserPressedContactHost","$schema":"http://json-schema.org/draft-07/schema#","description":"[PLP] user pressed to contact host from PLP","properties":{"checkoutId":{"$id":"/properties/checkoutId","description":"checkoutId created for subsequent time, user, and reason events","type":"string"},"listingId":{"$id":"/properties/listingId","description":"id of the listing","type":"string"},"searchId":{"$id":"/properties/searchId","description":"search they entered the listing from, if applicable","type":["string","null"]}},"required":["checkoutId","listingId","searchId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserPressedContactHost', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserPressedContinueRebookScreen' track call.
 *
 * @param UserPressedContinueRebookScreen props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userPressedContinueRebookScreen(props: UserPressedContinueRebookScreen, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserPressedContinueRebookScreen","$schema":"http://json-schema.org/draft-07/schema#","description":"[POST BOOKING REVIEW] user pressed to continue with the rebook option for rebook screen","properties":{"bookingId":{"$id":"/properties/bookingId","description":"id of the booking associated with the review","type":"integer"},"checkoutId":{"$id":"/properties/checkoutId","description":"id of the checkout flow initiated by continuing to book","type":"string"},"listingId":{"$id":"/properties/listingId","description":"id of the listing being reviewed","type":"integer"},"price":{"$id":"/properties/price","description":"the hourly price shown in the rebook screen","type":"number"},"priceType":{"$id":"/properties/priceType","description":"the type of pricing structure - hourly or daily","enum":["daily","hourly"],"type":"string"},"rating":{"$id":"/properties/rating","description":"the rating shown in the rebook screen","type":"number"}},"required":["bookingId","rating","price","listingId","checkoutId","priceType"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserPressedContinueRebookScreen', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserPressedCopyFLInviteLink' track call.
 *
 * @param UserPressedCopyFLInviteLink props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userPressedCopyFLInviteLink(props: UserPressedCopyFLInviteLink, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserPressedCopyFLInviteLink","$schema":"http://json-schema.org/draft-07/schema#","description":"[GUEST FAVORITE INVITE] user pressed share invite Favorites List link","properties":{"id":{"$id":"/properties/id","description":"","type":"string"}},"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserPressedCopyFLInviteLink', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserPressedCopyInviteLink' track call.
 *
 * @param UserPressedCopyInviteLink props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userPressedCopyInviteLink(props: UserPressedCopyInviteLink, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserPressedCopyInviteLink","$schema":"http://json-schema.org/draft-07/schema#","description":"[REFERRAL] user selected \"copy invite link\" option","properties":{"id":{"$id":"/properties/id","description":"","type":"string"}},"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserPressedCopyInviteLink', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserPressedCozymealBookingAdditions' track call.
 *
 * @param UserPressedCozymealBookingAdditions props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userPressedCozymealBookingAdditions(props: UserPressedCozymealBookingAdditions, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserPressedCozymealBookingAdditions","$schema":"http://json-schema.org/draft-07/schema#","description":"[COZYMEAL] User pressed \"book now\" to add catering thus directing them to the Cozymeal selections page","properties":{"bookingId":{"$id":"/properties/bookingId","description":"","type":"integer"},"guestId":{"$id":"/properties/guestId","description":"","type":"integer"},"hostId":{"$id":"/properties/hostId","description":"","type":"integer"},"id":{"$id":"/properties/id","description":"","type":"string"},"listingId":{"$id":"/properties/listingId","description":"","type":"integer"}},"required":["listingId","guestId","hostId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserPressedCozymealBookingAdditions', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserPressedCozymealListing' track call.
 *
 * @param UserPressedCozymealListing props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userPressedCozymealListing(props: UserPressedCozymealListing, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserPressedCozymealListing","$schema":"http://json-schema.org/draft-07/schema#","description":"[COZYMEAL] User pressed a specific Cozymeal catering option","properties":{"bookingId":{"$id":"/properties/bookingId","description":"","type":"integer"},"cozyMealListingId":{"$id":"/properties/cozyMealListingId","description":"","type":"integer"},"guestId":{"$id":"/properties/guestId","description":"","type":"integer"},"hostId":{"$id":"/properties/hostId","description":"","type":"integer"},"id":{"$id":"/properties/id","description":"","type":"string"},"listingId":{"$id":"/properties/listingId","description":"","type":"integer"}},"required":["hostId","listingId","cozyMealListingId","guestId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserPressedCozymealListing', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserPressedCozymealOptionsFilter' track call.
 *
 * @param UserPressedCozymealOptionsFilter props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userPressedCozymealOptionsFilter(props: UserPressedCozymealOptionsFilter, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserPressedCozymealOptionsFilter","$schema":"http://json-schema.org/draft-07/schema#","description":"[COZYMEAL] User pressed a filter on the Cozymeal catering options page","properties":{"bookingId":{"$id":"/properties/bookingId","description":"","type":"integer"},"filter":{"$id":"/properties/filter","description":"","enum":["all","drinks","food"],"type":"string"},"guestId":{"$id":"/properties/guestId","description":"","type":"integer"},"hostId":{"$id":"/properties/hostId","description":"","type":"integer"},"id":{"$id":"/properties/id","description":"","type":"string"},"listingId":{"$id":"/properties/listingId","description":"","type":"integer"}},"required":["filter","guestId","hostId","listingId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserPressedCozymealOptionsFilter', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserPressedCozymealSeeMenu' track call.
 *
 * @param UserPressedCozymealSeeMenu props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userPressedCozymealSeeMenu(props: UserPressedCozymealSeeMenu, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserPressedCozymealSeeMenu","$schema":"http://json-schema.org/draft-07/schema#","description":"[COZYMEAL] User pressed to see the menu of a specific Cozymeal catering option","properties":{"bookingId":{"$id":"/properties/bookingId","description":"","type":"integer"},"cozyMealListingId":{"$id":"/properties/cozyMealListingId","description":"","type":"integer"},"guestId":{"$id":"/properties/guestId","description":"","type":"integer"},"hostId":{"$id":"/properties/hostId","description":"","type":"integer"},"id":{"$id":"/properties/id","description":"","type":"string"},"listingId":{"$id":"/properties/listingId","description":"","type":"integer"}},"required":["cozyMealListingId","guestId","hostId","listingId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserPressedCozymealSeeMenu', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserPressedCreatePoll' track call.
 *
 * @param UserPressedCreatePoll props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userPressedCreatePoll(props: UserPressedCreatePoll, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserPressedCreatePoll","$schema":"http://json-schema.org/draft-07/schema#","description":"[POLL] When user pressed the create poll button from the favorite list","properties":{"favoriteListId":{"$id":"/properties/favoriteListId","description":"id associated with this favorite list (collection id in backend)","type":"integer"},"favoriteListName":{"$id":"/properties/favoriteListName","description":"name of the favorite list","type":"string"},"numberOfListing":{"$id":"/properties/numberOfListing","description":"number of listing in this list when user create the poll","type":"integer"}},"required":["favoriteListName","numberOfListing","favoriteListId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserPressedCreatePoll', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserPressedDeleteAccount' track call.
 *
 * @param UserPressedDeleteAccount props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userPressedDeleteAccount(props: UserPressedDeleteAccount, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserPressedDeleteAccount","$schema":"http://json-schema.org/draft-07/schema#","description":"[USER PROFILE - Account Details] user pressed to delete their account","properties":{"id":{"$id":"/properties/id","description":"","type":"string"}},"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserPressedDeleteAccount', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserPressedDeleteFavoriteList' track call.
 *
 * @param UserPressedDeleteFavoriteList props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userPressedDeleteFavoriteList(props: UserPressedDeleteFavoriteList, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserPressedDeleteFavoriteList","$schema":"http://json-schema.org/draft-07/schema#","description":"[GUEST FAVORITE] user pressed \"delete this list\"","properties":{"alphaUserId":{"$id":"/properties/alphaUserId","description":"the user id of the account who created the favorite collection","type":"integer"},"betaUserIds":{"$id":"/properties/betaUserIds","description":"an array of any favorite collection collaborator's user ids","type":"array"},"favoriteCollectionId":{"$id":"/properties/favoriteCollectionId","description":"the favorite collection id","type":"integer"},"favoriteCollectionName":{"$id":"/properties/favoriteCollectionName","description":"the name of the favorite collection","type":"string"},"id":{"$id":"/properties/id","description":"","type":"string"},"isAlphaUserId":{"$id":"/properties/isAlphaUserId","description":"a boolean to identify whether the actions being taken to a favorite collection are being done by the alpha user (1) or a beta user (0)","type":"boolean"}},"required":["favoriteCollectionId","favoriteCollectionName","isAlphaUserId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserPressedDeleteFavoriteList', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserPressedDeleteMyAccount' track call.
 *
 * @param UserPressedDeleteMyAccount props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userPressedDeleteMyAccount(props: UserPressedDeleteMyAccount, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserPressedDeleteMyAccount","$schema":"http://json-schema.org/draft-07/schema#","description":"[ACCOUNT DELETION] User pressed the Delete my account option in the profile screen","properties":{"id":{"$id":"/properties/id","description":"","type":"string"}},"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserPressedDeleteMyAccount', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserPressedDisableEmailNotifications' track call.
 *
 * @param UserPressedDisableEmailNotifications props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userPressedDisableEmailNotifications(props: UserPressedDisableEmailNotifications, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserPressedDisableEmailNotifications","$schema":"http://json-schema.org/draft-07/schema#","description":"[USER PROFILE - ACCOUNT SETTINGS: NOTIFICATIONS]","properties":{"id":{"$id":"/properties/id","description":"","type":"string"}},"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserPressedDisableEmailNotifications', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserPressedDisableMarketingSMSNotifications' track call.
 *
 * @param UserPressedDisableMarketingSMSNotifications props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userPressedDisableMarketingSMSNotifications(props: UserPressedDisableMarketingSMSNotifications, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserPressedDisableMarketingSMSNotifications","$schema":"http://json-schema.org/draft-07/schema#","description":"[USER PROFILE - ACCOUNT SETTINGS: NOTIFICATIONS]","properties":{"id":{"$id":"/properties/id","description":"","type":"string"}},"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserPressedDisableMarketingSMSNotifications', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserPressedDisableTransactionalSMSNotifications' track call.
 *
 * @param UserPressedDisableTransactionalSMSNotifications props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userPressedDisableTransactionalSMSNotifications(props: UserPressedDisableTransactionalSMSNotifications, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserPressedDisableTransactionalSMSNotifications","$schema":"http://json-schema.org/draft-07/schema#","description":"[USER PROFILE - ACCOUNT SETTINGS: NOTIFICATIONS]","properties":{"id":{"$id":"/properties/id","description":"","type":"string"}},"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserPressedDisableTransactionalSMSNotifications', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserPressedDisplayPriceWithFeesToggle' track call.
 *
 * @param UserPressedDisplayPriceWithFeesToggle props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userPressedDisplayPriceWithFeesToggle(props: UserPressedDisplayPriceWithFeesToggle, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserPressedDisplayPriceWithFeesToggle","$schema":"http://json-schema.org/draft-07/schema#","description":"[SEARCH] user pressed the \"Display price with fees\" drip pricing toggle","properties":{"id":{"$id":"/properties/id","description":"","type":"string"},"isPriceShownWithFeesOn":{"$id":"/properties/isPriceShownWithFeesOn","description":"true when the toggle is activated and prices shown include fees","type":"boolean"}},"required":["isPriceShownWithFeesOn"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserPressedDisplayPriceWithFeesToggle', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserPressedDontEnableNotificationsFromStartCall' track call.
 *
 * @param UserPressedDontEnableNotificationsFromStartCall props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userPressedDontEnableNotificationsFromStartCall(props: UserPressedDontEnableNotificationsFromStartCall, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserPressedDontEnableNotificationsFromStartCall","$schema":"http://json-schema.org/draft-07/schema#","description":"[MESSAGING - CALLING] user pressed NOT to enable notifications after attempting to call via chat","properties":{"bookingId":{"$id":"/properties/bookingId","description":"the booking shown when the user clicks to see the reservation on chat - logic defined by Mojin in Chat Redesign PRD","type":"integer"},"callType":{"$id":"/properties/callType","description":"","enum":["video","voice"],"type":"string"},"guestId":{"$id":"/properties/guestId","description":"the guest for the booking","type":"integer"},"hostId":{"$id":"/properties/hostId","description":"the host for the booking","type":"integer"},"id":{"$id":"/properties/id","description":"","type":"string"},"listingId":{"$id":"/properties/listingId","description":"the listing for the booking","type":"integer"},"roomId":{"$id":"/properties/roomId","description":"the room id for the chat","type":"string"},"userIsHost":{"$id":"/properties/userIsHost","description":"","type":"boolean"}},"required":["listingId","userIsHost","roomId","callType","bookingId","guestId","hostId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserPressedDontEnableNotificationsFromStartCall', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserPressedEditDateOnCheckoutConfirmation' track call.
 *
 * @param UserPressedEditDateOnCheckoutConfirmation props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userPressedEditDateOnCheckoutConfirmation(props: UserPressedEditDateOnCheckoutConfirmation, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserPressedEditDateOnCheckoutConfirmation","$schema":"http://json-schema.org/draft-07/schema#","description":"[CHECKOUT] on checkout confirmation screen if user edited date","properties":{"checkoutId":{"$id":"/properties/checkoutId","description":"id for the current checkout flow ","type":"string"},"listingId":{"$id":"/properties/listingId","description":"the id for the pool listing","type":"string"},"originalDate":{"$id":"/properties/originalDate","description":"original date for booking prior to editing","type":"string"},"originalEndTime":{"$id":"/properties/originalEndTime","description":"original end time for booking prior to edit","type":"number"},"originalStartTime":{"$id":"/properties/originalStartTime","description":"original start time for booking prior to edit","type":"number"},"searchId":{"$id":"/properties/searchId","description":"id for the search that led to this listing","type":["string","null"]}},"required":["searchId","checkoutId","listingId","originalEndTime","originalStartTime"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserPressedEditDateOnCheckoutConfirmation', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserPressedEditGuestsOnCheckoutConfirmation' track call.
 *
 * @param UserPressedEditGuestsOnCheckoutConfirmation props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userPressedEditGuestsOnCheckoutConfirmation(props: UserPressedEditGuestsOnCheckoutConfirmation, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserPressedEditGuestsOnCheckoutConfirmation","$schema":"http://json-schema.org/draft-07/schema#","description":"[CHECKOUT] on checkout confirmation screen if user edited guest","properties":{"checkoutId":{"$id":"/properties/checkoutId","description":"id for the current checkout flow ","type":"string"},"listingId":{"$id":"/properties/listingId","description":"the id for the pool listing","type":"string"},"originalAdults":{"$id":"/properties/originalAdults","description":"original number of adults","type":"integer"},"originalChildren":{"$id":"/properties/originalChildren","description":"original number of children","type":"integer"},"originalInfants":{"$id":"/properties/originalInfants","description":"original number of infants","type":"integer"},"originalPets":{"$id":"/properties/originalPets","description":"original number of pets","type":"integer"},"originalTotalGuests":{"$id":"/properties/originalTotalGuests","description":"original number of guests ","type":"integer"},"searchId":{"$id":"/properties/searchId","description":"id for the search that led to this listing","type":["string","null"]}},"required":["originalTotalGuests","originalAdults","originalPets","checkoutId","listingId","searchId","originalChildren","originalInfants"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserPressedEditGuestsOnCheckoutConfirmation', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserPressedEditReasonForBooking' track call.
 *
 * @param UserPressedEditReasonForBooking props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userPressedEditReasonForBooking(props: UserPressedEditReasonForBooking, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserPressedEditReasonForBooking","$schema":"http://json-schema.org/draft-07/schema#","description":"[CHECKOUT] on checkout confirmation screen if user edited reason for booking","properties":{"checkoutId":{"$id":"/properties/checkoutId","description":"id for the current checkout flow ","type":"string"},"listingId":{"$id":"/properties/listingId","description":"the id for the pool listing","type":"string"},"originalReason":{"$id":"/properties/originalReason","description":"original reason for booking","type":"string"},"searchId":{"$id":"/properties/searchId","description":"id for the search that led to this listing","type":["string","null"]}},"required":["checkoutId","originalReason","searchId","listingId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserPressedEditReasonForBooking', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserPressedEnableEmailNotifications' track call.
 *
 * @param UserPressedEnableEmailNotifications props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userPressedEnableEmailNotifications(props: UserPressedEnableEmailNotifications, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserPressedEnableEmailNotifications","$schema":"http://json-schema.org/draft-07/schema#","description":"[USER PROFILE - ACCOUNT SETTINGS: NOTIFICATIONS]","properties":{"id":{"$id":"/properties/id","description":"","type":"string"}},"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserPressedEnableEmailNotifications', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserPressedEnableMarketingSMSNotifications' track call.
 *
 * @param UserPressedEnableMarketingSMSNotifications props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userPressedEnableMarketingSMSNotifications(props: UserPressedEnableMarketingSMSNotifications, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserPressedEnableMarketingSMSNotifications","$schema":"http://json-schema.org/draft-07/schema#","description":"[USER PROFILE - ACCOUNT SETTINGS: NOTIFICATIONS]","properties":{"id":{"$id":"/properties/id","description":"","type":"string"}},"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserPressedEnableMarketingSMSNotifications', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserPressedEnableNotificationsFromStartCall' track call.
 *
 * @param UserPressedEnableNotificationsFromStartCall props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userPressedEnableNotificationsFromStartCall(props: UserPressedEnableNotificationsFromStartCall, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserPressedEnableNotificationsFromStartCall","$schema":"http://json-schema.org/draft-07/schema#","description":"[MESSAGING - CALLING] user pressed to enable notifications after attempting to call via chat","properties":{"bookingId":{"$id":"/properties/bookingId","description":"the booking shown when the user clicks to see the reservation on chat - logic defined by Mojin in Chat Redesign PRD","type":"integer"},"callType":{"$id":"/properties/callType","description":"","enum":["video","voice"],"type":"string"},"guestId":{"$id":"/properties/guestId","description":"the guest for the booking","type":"integer"},"hostId":{"$id":"/properties/hostId","description":"the host for the booking","type":"integer"},"id":{"$id":"/properties/id","description":"","type":"string"},"listingId":{"$id":"/properties/listingId","description":"the listing for the booking","type":"integer"},"roomId":{"$id":"/properties/roomId","description":"the room id for the chat","type":"string"},"userIsHost":{"$id":"/properties/userIsHost","description":"","type":"boolean"}},"required":["roomId","bookingId","guestId","hostId","listingId","userIsHost","callType"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserPressedEnableNotificationsFromStartCall', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserPressedEnableTransactionalSMSNotifications' track call.
 *
 * @param UserPressedEnableTransactionalSMSNotifications props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userPressedEnableTransactionalSMSNotifications(props: UserPressedEnableTransactionalSMSNotifications, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserPressedEnableTransactionalSMSNotifications","$schema":"http://json-schema.org/draft-07/schema#","description":"[USER PROFILE - ACCOUNT SETTINGS: NOTIFICATIONS]","properties":{"id":{"$id":"/properties/id","description":"","type":"string"}},"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserPressedEnableTransactionalSMSNotifications', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserPressedEnterPassUpsell' track call.
 *
 * @param UserPressedEnterPassUpsell props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userPressedEnterPassUpsell(props: UserPressedEnterPassUpsell, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserPressedEnterPassUpsell","$schema":"http://json-schema.org/draft-07/schema#","description":"[CHECKOUT] user pressed pass upsell button “Get a Pass”","properties":{"id":{"$id":"/properties/id","description":"","type":"string"},"listingId":{"$id":"/properties/listingId","description":"id of the listing the pass is for","type":"string"},"passId":{"$id":"/properties/passId","description":"id of the pass","type":"integer"},"passPrice":{"$id":"/properties/passPrice","description":"pass price in minor units","type":"string"},"passType":{"$id":"/properties/passType","description":"the type of pass","enum":["ALL_ACCESS","EARLY_BIRD","WEEKDAY"],"type":"string"}},"required":["listingId","passId","passPrice","passType"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserPressedEnterPassUpsell', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserPressedEnterSendPicture' track call.
 *
 * @param UserPressedEnterSendPicture props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userPressedEnterSendPicture(props: UserPressedEnterSendPicture, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserPressedEnterSendPicture","$schema":"http://json-schema.org/draft-07/schema#","description":"[MESSAGING - PHOTOS] from chat, when the user presses the small photo icon","properties":{"bookingId":{"$id":"/properties/bookingId","description":"the booking shown when the user clicks to see the reservation on chat - logic defined by Mojin in Chat Redesign PRD","type":"integer"},"guestId":{"$id":"/properties/guestId","description":"the guest for the booking","type":"integer"},"hostId":{"$id":"/properties/hostId","description":"the host for the booking","type":"integer"},"id":{"$id":"/properties/id","description":"","type":"string"},"listingId":{"$id":"/properties/listingId","description":"the listing for the booking","type":"integer"},"roomId":{"$id":"/properties/roomId","description":"the room id for the chat","type":"string"}},"required":["roomId","hostId","listingId","bookingId","guestId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserPressedEnterSendPicture', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserPressedEnterStartCall' track call.
 *
 * @param UserPressedEnterStartCall props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userPressedEnterStartCall(props: UserPressedEnterStartCall, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserPressedEnterStartCall","$schema":"http://json-schema.org/draft-07/schema#","description":"[MESSAGING - CALLING] from chat, when the user presses the small call icon","properties":{"bookingId":{"$id":"/properties/bookingId","description":"the booking shown when the user clicks to see the reservation on chat - logic defined by Mojin in Chat Redesign PRD","type":"integer"},"guestId":{"$id":"/properties/guestId","description":"the guest for the booking","type":"integer"},"hostId":{"$id":"/properties/hostId","description":"the host for the booking","type":"integer"},"id":{"$id":"/properties/id","description":"","type":"string"},"listingId":{"$id":"/properties/listingId","description":"the listing for the booking","type":"integer"},"roomId":{"$id":"/properties/roomId","description":"the room id for the chat","type":"string"}},"required":["hostId","roomId","listingId","bookingId","guestId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserPressedEnterStartCall', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserPressedFLInviteFriendsViaEmail' track call.
 *
 * @param UserPressedFLInviteFriendsViaEmail props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userPressedFLInviteFriendsViaEmail(props: UserPressedFLInviteFriendsViaEmail, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserPressedFLInviteFriendsViaEmail","$schema":"http://json-schema.org/draft-07/schema#","description":"[GUEST FAVORITE INVITE] user pressed send an email to share Favorites List link","properties":{"alphaUserId":{"$id":"/properties/alphaUserId","description":"the user id of the account who created the favorite collection","type":"integer"},"betaUserIds":{"$id":"/properties/betaUserIds","description":"an array of any favorite collection collaborator's user ids","type":"array"},"favoriteCollectionId":{"$id":"/properties/favoriteCollectionId","description":"the favorite collection id","type":"integer"},"favoriteCollectionName":{"$id":"/properties/favoriteCollectionName","description":"the name of the favorite collection","type":"string"},"id":{"$id":"/properties/id","description":"","type":"string"},"isAlphaUserId":{"$id":"/properties/isAlphaUserId","description":"a boolean to identify whether the actions being taken to a favorite collection are being done by the alpha user (1) or a beta user (0)","type":"boolean"}},"required":["favoriteCollectionName","isAlphaUserId","favoriteCollectionId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserPressedFLInviteFriendsViaEmail', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserPressedFLInviteFriendsViaText' track call.
 *
 * @param UserPressedFLInviteFriendsViaText props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userPressedFLInviteFriendsViaText(props: UserPressedFLInviteFriendsViaText, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserPressedFLInviteFriendsViaText","$schema":"http://json-schema.org/draft-07/schema#","description":"[GUEST FAVORITE INVITE] user pressed send a text to share Friends List link","properties":{"alphaUserId":{"$id":"/properties/alphaUserId","description":"the user id of the account who created the favorite collection","type":"integer"},"betaUserIds":{"$id":"/properties/betaUserIds","description":"an array of any favorite collection collaborator's user ids","type":"array"},"favoriteCollectionId":{"$id":"/properties/favoriteCollectionId","description":"the favorite collection id","type":"integer"},"favoriteCollectionName":{"$id":"/properties/favoriteCollectionName","description":"the name of the favorite collection","type":"string"},"id":{"$id":"/properties/id","description":"","type":"string"},"isAlphaUserId":{"$id":"/properties/isAlphaUserId","description":"a boolean to identify whether the actions being taken to a favorite collection are being done by the alpha user (1) or a beta user (0)","type":"boolean"}},"required":["favoriteCollectionName","isAlphaUserId","favoriteCollectionId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserPressedFLInviteFriendsViaText', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserPressedFavoriteListMapView' track call.
 *
 * @param UserPressedFavoriteListMapView props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userPressedFavoriteListMapView(props: UserPressedFavoriteListMapView, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserPressedFavoriteListMapView","$schema":"http://json-schema.org/draft-07/schema#","description":"[GUEST FAVORITE] user pressed to view favorite collection listings in map view","properties":{"alphaUserId":{"$id":"/properties/alphaUserId","description":"the user id of the account who created the favorite collection","type":"integer"},"betaUserIds":{"$id":"/properties/betaUserIds","description":"an array of any favorite collection collaborator's user ids","type":"array"},"favoriteCollectionId":{"$id":"/properties/favoriteCollectionId","description":"the favorite collection id","type":"integer"},"favoriteCollectionName":{"$id":"/properties/favoriteCollectionName","description":"the name of the favorite collection","type":"string"},"id":{"$id":"/properties/id","description":"","type":"string"},"isAlphaUserId":{"$id":"/properties/isAlphaUserId","description":"a boolean to identify whether the actions being taken to a favorite collection are being done by the alpha user (1) or a beta user (0)","type":"boolean"}},"required":["isAlphaUserId","favoriteCollectionId","favoriteCollectionName"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserPressedFavoriteListMapView', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserPressedFavoriteListing' track call.
 *
 * @param UserPressedFavoriteListing props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userPressedFavoriteListing(props: UserPressedFavoriteListing, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserPressedFavoriteListing","$schema":"http://json-schema.org/draft-07/schema#","description":"[SEARCH] user pressed the heart icon to favorite a listing in the list view","properties":{"badgeName":{"$id":"/properties/badgeName","description":"displayed badge name","type":["string","null"]},"globalListingType":{"$id":"/properties/globalListingType","description":"[LISTING TYPE] The type of the listing associated with this event","enum":["artStudio","basketballCourt","dockedBoat","home","homeGym","joyspace","kitchen","largeBackyard","musicStudio","other","pending","pickleball","pool","privateLake","roofDeck","tennisCourt"],"type":"string"},"hasPass":{"$id":"/properties/hasPass","description":"whether the listings has passes available (1 if true, 0 if false)","type":"boolean"},"isListView":{"$id":"/properties/isListView","description":"True if the user search in list view, false if floating card in map view","type":"boolean"},"listingId":{"$id":"/properties/listingId","description":"id of the listing","type":"string"},"orderInSearchResults":{"$id":"/properties/orderInSearchResults","description":"order in search list (only if isListView is True, null otherwise)","type":"integer"},"passIds":{"$id":"/properties/passIds","description":"if the listing has one or more active passes, list the pass ids in an array","type":["array","null"]},"passTypes":{"$id":"/properties/passTypes","description":"the types of passes available for a listing - null if it doesn't have any","type":["array","null"]},"price":{"$id":"/properties/price","description":"the price displayed","type":"number"},"priceType":{"$id":"/properties/priceType","description":"the displayed price type","enum":["base_tier_daily_price","base_tier_hourly_price"],"type":"string"},"primaryPhotoId":{"$id":"/properties/primaryPhotoId","description":"photo id of the first photo displayed for the listing","type":["string","null"]},"rating":{"$id":"/properties/rating","description":"rating displayed","type":["number","null"]},"ratingsVolume":{"$id":"/properties/ratingsVolume","description":"total amount of ratings displayed","type":["integer","null"]},"searchId":{"$id":"/properties/searchId","description":"id of search which generated result","type":["string","null"]}},"required":["hasPass","isListView","globalListingType","listingId","badgeName","searchId","priceType","ratingsVolume","rating","passTypes","price"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserPressedFavoriteListing', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserPressedFindPoolsNearMe' track call.
 *
 * @param UserPressedFindPoolsNearMe props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userPressedFindPoolsNearMe(props: UserPressedFindPoolsNearMe, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserPressedFindPoolsNearMe","$schema":"http://json-schema.org/draft-07/schema#","description":"[CLAIM REFERRAL] User pressed the find pools near me button","properties":{"categoryName":{"$id":"/properties/categoryName","description":"","type":"string"},"id":{"$id":"/properties/id","description":"","type":"string"}},"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserPressedFindPoolsNearMe', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserPressedFullScreeenListView' track call.
 *
 * @param UserPressedFullScreeenListView props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userPressedFullScreeenListView(props: UserPressedFullScreeenListView, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserPressedFullScreeenListView","$schema":"http://json-schema.org/draft-07/schema#","description":"[SEARCH] user pressed full screen list view to minimize map","properties":{"searchId":{"$id":"/properties/searchId","description":"id of search which generated result","type":["string","null"]}},"required":["searchId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserPressedFullScreeenListView', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserPressedFullScreenListView' track call.
 *
 * @param UserPressedFullScreenListView props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userPressedFullScreenListView(props: UserPressedFullScreenListView, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserPressedFullScreenListView","$schema":"http://json-schema.org/draft-07/schema#","description":"[SEARCH] user pressed full screen list view to minimize map","properties":{"searchId":{"$id":"/properties/searchId","description":"id of search which generated result","type":["string","null"]}},"required":["searchId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserPressedFullScreenListView', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserPressedGoPuffAd' track call.
 *
 * @param UserPressedGoPuffAd props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userPressedGoPuffAd(props: UserPressedGoPuffAd, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserPressedGoPuffAd","$schema":"http://json-schema.org/draft-07/schema#","properties":{"bookingId":{"$id":"/properties/bookingId","description":"","type":"number"},"source":{"$id":"/properties/source","description":"","enum":["booking","default"],"type":"string"}},"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserPressedGoPuffAd', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserPressedHomepageDownloadApp' track call.
 *
 * @param UserPressedHomepageDownloadApp props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userPressedHomepageDownloadApp(props: UserPressedHomepageDownloadApp, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserPressedHomepageDownloadApp","$schema":"http://json-schema.org/draft-07/schema#","description":"[WEB HOMEPAGE] User pressed to download app on homepage","properties":{"downloadAt":{"$id":"/properties/downloadAt","description":"button for download at App store or Google play","enum":["App store","Google play"],"type":"string"},"listingType":{"$id":"/properties/listingType","description":"Type of the listings","enum":["basketballCourt","home","pickleball","pool","tennisCourt"],"type":"string"}},"required":["listingType","downloadAt"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserPressedHomepageDownloadApp', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserPressedHomepageExperience' track call.
 *
 * @param UserPressedHomepageExperience props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userPressedHomepageExperience(props: UserPressedHomepageExperience, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserPressedHomepageExperience","$schema":"http://json-schema.org/draft-07/schema#","description":"[WEB HOMEPAGE] Phase 2 User pressed the swimply experience","properties":{"experienceName":{"$id":"/properties/experienceName","description":"the experience tag in the thumbnail ","enum":["All","Backyards","Budget","Family","Heated","Hoop","Hot Tubs","Indoors","Paddle","Parties","Pets","Racquet","Vip"],"type":"string"}},"required":["experienceName"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserPressedHomepageExperience', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserPressedHomepageListing' track call.
 *
 * @param UserPressedHomepageListing props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userPressedHomepageListing(props: UserPressedHomepageListing, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserPressedHomepageListing","$schema":"http://json-schema.org/draft-07/schema#","description":"[WEB HOMEPAGE UPDATED]","properties":{"globalListingType":{"$id":"/properties/globalListingType","description":"[LISTING TYPE] The type of the listing associated with this event","enum":["artStudio","basketballCourt","dockedBoat","home","homeGym","joyspace","kitchen","largeBackyard","musicStudio","other","pending","pickleball","pool","privateLake","roofDeck","tennisCourt"],"type":"string"},"homepageCategorySection":{"$id":"/properties/homepageCategorySection","description":"which section of the homepage was the listing selected from","enum":["deals","everything","passes"],"type":"string"},"listingId":{"$id":"/properties/listingId","description":"","type":"string"}},"required":["homepageCategorySection","globalListingType","listingId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserPressedHomepageListing', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserPressedHomepageListingType' track call.
 *
 * @param UserPressedHomepageListingType props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userPressedHomepageListingType(props: UserPressedHomepageListingType, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserPressedHomepageListingType","$schema":"http://json-schema.org/draft-07/schema#","description":"[WEB HOMEPAGE] User pressed listing type in homepage","properties":{"listingType":{"$id":"/properties/listingType","description":"Type of the listings","enum":["basketballCourt","home","pickleball","pool","tennisCourt"],"type":"string"}},"required":["listingType"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserPressedHomepageListingType', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserPressedHomepagePassType' track call.
 *
 * @param UserPressedHomepagePassType props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userPressedHomepagePassType(props: UserPressedHomepagePassType, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserPressedHomepagePassType","$schema":"http://json-schema.org/draft-07/schema#","description":"[GUEST PASS DISCOVERY] when a user selects a different pass type\n","properties":{"id":{"$id":"/properties/id","description":"","type":"string"},"passType":{"$id":"/properties/passType","description":"","enum":["ALL_ACCESS","EARLY_BIRD","WEEKDAY"],"type":"string"}},"required":["passType"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserPressedHomepagePassType', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserPressedHomepagePassesLearnMore' track call.
 *
 * @param UserPressedHomepagePassesLearnMore props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userPressedHomepagePassesLearnMore(props: UserPressedHomepagePassesLearnMore, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserPressedHomepagePassesLearnMore","$schema":"http://json-schema.org/draft-07/schema#","description":"[GUEST PASS DISCOVERY]\n","properties":{"id":{"$id":"/properties/id","description":"","type":"string"}},"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserPressedHomepagePassesLearnMore', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserPressedHomepageReferralBanner' track call.
 *
 * @param UserPressedHomepageReferralBanner props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userPressedHomepageReferralBanner(props: UserPressedHomepageReferralBanner, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserPressedHomepageReferralBanner","$schema":"http://json-schema.org/draft-07/schema#","description":"[WEB HOMEPAGE - REFERRALS] user pressed refer a friend referral banner","properties":{"id":{"$id":"/properties/id","description":"","type":"string"},"totalCredits":{"$id":"/properties/totalCredits","description":"the user's total credit amount - can be null if they have none","type":["number","null"]}},"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserPressedHomepageReferralBanner', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserPressedHomepageSeeAllPassListings' track call.
 *
 * @param UserPressedHomepageSeeAllPassListings props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userPressedHomepageSeeAllPassListings(props: UserPressedHomepageSeeAllPassListings, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserPressedHomepageSeeAllPassListings","$schema":"http://json-schema.org/draft-07/schema#","description":"[GUEST PASS DISCOVERY]\n","properties":{"id":{"$id":"/properties/id","description":"","type":"string"},"passType":{"$id":"/properties/passType","description":"the pass type selected when a user selects to see all listings with that pass","enum":["ALL_ACCESS","EARLY_BIRD","WEEKDAY"],"type":"string"}},"required":["passType"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserPressedHomepageSeeAllPassListings', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserPressedHomepageSocial' track call.
 *
 * @param UserPressedHomepageSocial props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userPressedHomepageSocial(props: UserPressedHomepageSocial, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserPressedHomepageSocial","$schema":"http://json-schema.org/draft-07/schema#","description":"[WEB HOMEPAGE] Phase 2 User pressed social from the homepage","properties":{"listingType":{"$id":"/properties/listingType","description":"Type of the listings","enum":["basketballCourt","home","pickleball","pool","tennisCourt"],"type":"string"},"thumbnailId":{"$id":"/properties/thumbnailId","description":"the id of the thumbnail of the social","type":"string"},"thumbnailOrder":{"$id":"/properties/thumbnailOrder","description":"the order of the thumbnail (most left thumbnail as 0, most right thumbnail as 5)","type":"integer"}},"required":["thumbnailOrder","thumbnailId","listingType"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserPressedHomepageSocial', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserPressedHostGuaranteeFromMessages' track call.
 *
 * @param UserPressedHostGuaranteeFromMessages props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userPressedHostGuaranteeFromMessages(props: UserPressedHostGuaranteeFromMessages, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserPressedHostGuaranteeFromMessages","$schema":"http://json-schema.org/draft-07/schema#","description":"user pressed on the host guarantee link from a circumvention autowarning message","properties":{"id":{"$id":"/properties/id","description":"DO NOT SEND: This is added as a workaround for this issue: https://github.com/segmentio/typewriter/issues/284","type":"string"}},"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserPressedHostGuaranteeFromMessages', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserPressedHostRulesCheckoutConfirmation' track call.
 *
 * @param UserPressedHostRulesCheckoutConfirmation props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userPressedHostRulesCheckoutConfirmation(props: UserPressedHostRulesCheckoutConfirmation, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserPressedHostRulesCheckoutConfirmation","$schema":"http://json-schema.org/draft-07/schema#","description":"[CHECKOUT] on checkout confirmation screen if user opened host rules","properties":{"checkoutId":{"$id":"/properties/checkoutId","description":"id for the current checkout flow ","type":"string"},"listingId":{"$id":"/properties/listingId","description":"the id for the pool listing","type":"string"},"rulesBlurb":{"$id":"/properties/rulesBlurb","description":"text blurb of rules","type":"string"},"rulesListed":{"$id":"/properties/rulesListed","description":"listed preset rules","type":"array"},"searchId":{"$id":"/properties/searchId","description":"id for the search that led to this listing","type":["string","null"]}},"required":["rulesListed","searchId","checkoutId","listingId","rulesBlurb"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserPressedHostRulesCheckoutConfirmation', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserPressedHowDoesSwimplyWork' track call.
 *
 * @param UserPressedHowDoesSwimplyWork props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userPressedHowDoesSwimplyWork(props: UserPressedHowDoesSwimplyWork, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserPressedHowDoesSwimplyWork","$schema":"http://json-schema.org/draft-07/schema#","description":"[WEB HOMEPAGE] User pressed how does Swimply works","properties":{"listingType":{"$id":"/properties/listingType","description":"Type of the listings","enum":["basketballCourt","home","pickleball","pool","tennisCourt"],"type":"string"},"userType":{"$id":"/properties/userType","description":"guest if user pressed \"for swimmer/ player\", host if user pressed \"for pool/ court owner\"","enum":["guest","host"],"type":"string"}},"required":["userType","listingType"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserPressedHowDoesSwimplyWork', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserPressedInviteAndManageFriendsToFL' track call.
 *
 * @param UserPressedInviteAndManageFriendsToFL props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userPressedInviteAndManageFriendsToFL(props: UserPressedInviteAndManageFriendsToFL, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserPressedInviteAndManageFriendsToFL","$schema":"http://json-schema.org/draft-07/schema#","description":"[GUEST FAVORITE INVITE] user pressed \"invite my friends\" or \"invite and manage friends\" button (copy will depend on if they've already invited someone)","properties":{"alphaUserId":{"$id":"/properties/alphaUserId","description":"the user id of the account who created the favorite collection","type":"integer"},"betaUserIds":{"$id":"/properties/betaUserIds","description":"an array of any favorite collection collaborator's user ids","type":"array"},"favoriteCollectionId":{"$id":"/properties/favoriteCollectionId","description":"the favorite collection id","type":"integer"},"favoriteCollectionName":{"$id":"/properties/favoriteCollectionName","description":"the name of the favorite collection","type":"string"},"id":{"$id":"/properties/id","description":"","type":"string"},"isAlphaUserId":{"$id":"/properties/isAlphaUserId","description":"a boolean to identify whether the actions being taken to a favorite collection are being done by the alpha user (1) or a beta user (0)","type":"boolean"}},"required":["favoriteCollectionId","favoriteCollectionName","isAlphaUserId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserPressedInviteAndManageFriendsToFL', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserPressedInviteButtonTaskBar' track call.
 *
 * @param UserPressedInviteButtonTaskBar props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userPressedInviteButtonTaskBar(props: UserPressedInviteButtonTaskBar, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserPressedInviteButtonTaskBar","$schema":"http://json-schema.org/draft-07/schema#","description":"[REFERRAL] user pressed the invite button on the task bar (the menu bar on the bottom in the app)","properties":{"displayedCreditBalance":{"$id":"/properties/displayedCreditBalance","description":"credit balance on the right top corner","properties":{"balanceAmount":{"$id":"/properties/properties/properties/displayedCreditBalance/properties/balanceAmount","description":"the amount of the balance","type":"number"},"balanceCurrency":{"$id":"/properties/properties/properties/displayedCreditBalance/properties/balanceCurrency","description":"the currency of the balance amount","type":"string"},"balanceType":{"$id":"/properties/properties/properties/displayedCreditBalance/properties/balanceType","description":"the type of balance amount in cash or credit","type":"string"}},"required":["balanceAmount","balanceCurrency","balanceType"],"type":"object"},"displayedNumberJoinedHost":{"$id":"/properties/displayedNumberJoinedHost","description":"number of joined host on the \"x hosts joined\" button","type":"integer"},"displayedNumberJoinedSwimmer":{"$id":"/properties/displayedNumberJoinedSwimmer","description":"number of joined swimmer on the \"x friends(guests) joined\" button","type":"integer"},"enteredFrom":{"$id":"/properties/enteredFrom","description":"previous page before user enter the screen","type":"string"},"isGuestView":{"$id":"/properties/isGuestView","description":"boolean indicator if the screen is a view for guest, 1 if it is for guests, 0 if it is for hosts","type":"boolean"},"referralOfferedAmount":{"$id":"/properties/referralOfferedAmount","description":"the referral offer shown on the text in the screen","properties":{"givingAmount":{"$id":"/properties/properties/properties/referralOfferedAmount/properties/givingAmount","description":"the reward amount for the referee (the friend or host accepted the invite)","type":"number"},"givingAmountCurrency":{"$id":"/properties/properties/properties/referralOfferedAmount/properties/givingAmountCurrency","description":"the currency of the the reward amount for the referee","type":"string"},"receivingAmount":{"$id":"/properties/properties/properties/referralOfferedAmount/properties/receivingAmount","description":"the reward amount for the referrer (the user who invited friends or hosts)","type":"number"},"receivingAmountCurrency":{"$id":"/properties/properties/properties/referralOfferedAmount/properties/receivingAmountCurrency","description":"the currency of the reward amount for the referrer","type":"string"},"referralType":{"$id":"/properties/properties/properties/referralOfferedAmount/properties/referralType","description":"referring a host or a guest","type":"string"},"rewardType":{"$id":"/properties/properties/properties/referralOfferedAmount/properties/rewardType","description":"The type of the reward in cash or credit","type":"string"}},"required":["givingAmount","givingAmountCurrency","receivingAmount","receivingAmountCurrency","referralType","rewardType"],"type":"object"},"termBlurbInviteFriends":{"$id":"/properties/termBlurbInviteFriends","description":"the text of the term for inviting friends or guests (swimmer)","type":"string"},"termBlurbInviteHost":{"$id":"/properties/termBlurbInviteHost","description":"the text of the term for inviting hosts","type":"string"}},"required":["displayedNumberJoinedSwimmer","enteredFrom","isGuestView","referralOfferedAmount","termBlurbInviteFriends","termBlurbInviteHost","displayedCreditBalance","displayedNumberJoinedHost"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserPressedInviteButtonTaskBar', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserPressedInviteFriends' track call.
 *
 * @param UserPressedInviteFriends props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userPressedInviteFriends(props: UserPressedInviteFriends, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserPressedInviteFriends","$schema":"http://json-schema.org/draft-07/schema#","description":"[REFERRAL] user pressed the \"invite friends\" button (\"invite new guests\" for host)","properties":{"enteredFrom":{"$id":"/properties/enteredFrom","description":"how the host accessed this property","enum":[null,"refer_friends","underage_booking","underage_contact_host","underage_pass_purchase"],"type":["string","null"]},"guestAge":{"$id":"/properties/guestAge","description":"the age of the guest","type":["number","null"]},"isGuestView":{"$id":"/properties/isGuestView","description":"boolean indicator if the screen is a view for guest, 1 if it is for guests, 0 if it is for hosts","type":"boolean"},"referralOfferedAmount":{"$id":"/properties/referralOfferedAmount","description":"the referral amount shown on the text on this screen","properties":{"givingAmount":{"$id":"/properties/properties/properties/referralOfferedAmount/properties/givingAmount","description":"the reward amount for the referee (the friend who accepted the invite)","type":["number","null"]},"givingAmountCurrency":{"$id":"/properties/properties/properties/referralOfferedAmount/properties/givingAmountCurrency","description":"the currency of the reward amount for the referee","type":["string","null"]},"receivingAmount":{"$id":"/properties/properties/properties/referralOfferedAmount/properties/receivingAmount","description":"the reward amount for the referrer (the user who invited friends)","type":["number","null"]},"receivingAmountCurrency":{"$id":"/properties/properties/properties/referralOfferedAmount/properties/receivingAmountCurrency","description":"the currency of the reward amount for the referee","type":["string","null"]},"rewardType":{"$id":"/properties/properties/properties/referralOfferedAmount/properties/rewardType","description":"the type of the reward in cash or credit","type":["string","null"]}},"required":[],"type":["object","null"]}},"required":["isGuestView","enteredFrom"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserPressedInviteFriends', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserPressedInviteFriendsToBooking' track call.
 *
 * @param UserPressedInviteFriendsToBooking props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userPressedInviteFriendsToBooking(props: UserPressedInviteFriendsToBooking, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserPressedInviteFriendsToBooking","$schema":"http://json-schema.org/draft-07/schema#","description":"[POST BOOKING INVITE] user pressed to invite friends to booking","properties":{"bookingId":{"$id":"/properties/bookingId","description":"id of the booking","type":"integer"},"enteredFrom":{"$id":"/properties/enteredFrom","description":"the button or page the alpha guest entered from","enum":["confirmation","reservationGuestList","reservationInviteMoreFriend","reservationPlusButton"],"type":"string"}},"required":["bookingId","enteredFrom"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserPressedInviteFriendsToBooking', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserPressedInviteFriendsToCollaborateFL' track call.
 *
 * @param UserPressedInviteFriendsToCollaborateFL props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userPressedInviteFriendsToCollaborateFL(props: UserPressedInviteFriendsToCollaborateFL, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserPressedInviteFriendsToCollaborateFL","$schema":"http://json-schema.org/draft-07/schema#","description":"[GUEST FAVORITE INVITE] user pressed \"collaborate\" for how they wanted to share the list","properties":{"alphaUserId":{"$id":"/properties/alphaUserId","description":"the user id of the account who created the favorite collection","type":"integer"},"betaUserIds":{"$id":"/properties/betaUserIds","description":"an array of any favorite collection collaborator's user ids","type":"array"},"favoriteCollectionId":{"$id":"/properties/favoriteCollectionId","description":"the favorite collection id","type":"integer"},"favoriteCollectionName":{"$id":"/properties/favoriteCollectionName","description":"the name of the favorite collection","type":"string"},"id":{"$id":"/properties/id","description":"","type":"string"},"isAlphaUserId":{"$id":"/properties/isAlphaUserId","description":"a boolean to identify whether the actions being taken to a favorite collection are being done by the alpha user (1) or a beta user (0)","type":"boolean"}},"required":["favoriteCollectionName","isAlphaUserId","favoriteCollectionId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserPressedInviteFriendsToCollaborateFL', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserPressedInviteFriendsToViewFL' track call.
 *
 * @param UserPressedInviteFriendsToViewFL props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userPressedInviteFriendsToViewFL(props: UserPressedInviteFriendsToViewFL, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserPressedInviteFriendsToViewFL","$schema":"http://json-schema.org/draft-07/schema#","description":"[GUEST FAVORITE INVITE] user pressed \"view only\" for how they wanted to share the list","properties":{"alphaUserId":{"$id":"/properties/alphaUserId","description":"the user id of the account who created the favorite collection","type":"integer"},"betaUserIds":{"$id":"/properties/betaUserIds","description":"an array of any favorite collection collaborator's user ids","type":"array"},"favoriteCollectionId":{"$id":"/properties/favoriteCollectionId","description":"the favorite collection id","type":"integer"},"favoriteCollectionName":{"$id":"/properties/favoriteCollectionName","description":"the name of the favorite collection","type":"string"},"id":{"$id":"/properties/id","description":"","type":"string"},"isAlphaUserId":{"$id":"/properties/isAlphaUserId","description":"a boolean to identify whether the actions being taken to a favorite collection are being done by the alpha user (1) or a beta user (0)","type":"boolean"}},"required":["favoriteCollectionId","favoriteCollectionName","isAlphaUserId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserPressedInviteFriendsToViewFL', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserPressedInviteViaEmail' track call.
 *
 * @param UserPressedInviteViaEmail props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userPressedInviteViaEmail(props: UserPressedInviteViaEmail, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserPressedInviteViaEmail","$schema":"http://json-schema.org/draft-07/schema#","description":"[REFERRAL] user selected the invite via email option","properties":{"id":{"$id":"/properties/id","description":"","type":"string"}},"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserPressedInviteViaEmail', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserPressedJoinFavoriteList' track call.
 *
 * @param UserPressedJoinFavoriteList props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userPressedJoinFavoriteList(props: UserPressedJoinFavoriteList, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserPressedJoinFavoriteList","$schema":"http://json-schema.org/draft-07/schema#","description":"[GUEST FAVORITE INVITE] beta user pressed join favorite list after opening invite","properties":{"alphaUserId":{"$id":"/properties/alphaUserId","description":"the user id of the account who created the favorite collection","type":"integer"},"betaUserIds":{"$id":"/properties/betaUserIds","description":"an array of any favorite collection collaborator's user ids","type":"array"},"favoriteCollectionId":{"$id":"/properties/favoriteCollectionId","description":"the favorite collection id","type":"integer"},"favoriteCollectionName":{"$id":"/properties/favoriteCollectionName","description":"the name of the favorite collection","type":"string"},"id":{"$id":"/properties/id","description":"","type":"string"},"isAlphaUserId":{"$id":"/properties/isAlphaUserId","description":"a boolean to identify whether the actions being taken to a favorite collection are being done by the alpha user (1) or a beta user (0)","type":"boolean"},"method":{"$id":"/properties/method","description":"","type":"string"}},"required":["favoriteCollectionId","favoriteCollectionName","isAlphaUserId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserPressedJoinFavoriteList', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserPressedJoinReservation' track call.
 *
 * @param UserPressedJoinReservation props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userPressedJoinReservation(props: UserPressedJoinReservation, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserPressedJoinReservation","$schema":"http://json-schema.org/draft-07/schema#","description":"[POST BOOKING INVITE] user pressed to join reservation (web only) ","properties":{"bookingId":{"$id":"/properties/bookingId","description":"id of the booking","type":"integer"},"city":{"$id":"/properties/city","description":"displayed city of the listing","type":"string"},"date":{"$id":"/properties/date","description":"displayed date of the booking","type":"string"},"endTime":{"$id":"/properties/endTime","description":"displayed end time of the booking","type":"string"},"isReservationFull":{"$id":"/properties/isReservationFull","description":"True if the reservation is full, false otherwise","type":"boolean"},"isSignIn":{"$id":"/properties/isSignIn","description":"True if user is signed in, false otherwise","type":"boolean"},"startTime":{"$id":"/properties/startTime","description":"displayed start time of the booking","type":"string"},"state":{"$id":"/properties/state","description":"displayed state of the listing","type":"string"}},"required":["endTime","isSignIn","startTime","bookingId","date"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserPressedJoinReservation', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserPressedKeywordSearch' track call.
 *
 * @param UserPressedKeywordSearch props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userPressedKeywordSearch(props: UserPressedKeywordSearch, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserPressedKeywordSearch","$schema":"http://json-schema.org/draft-07/schema#","description":"[SEARCH] user pressed the keyword button to open the keyword search modal on web","properties":{"id":{"$id":"/properties/id","description":"","type":"string"}},"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserPressedKeywordSearch', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserPressedKlarnaMoreInfo' track call.
 *
 * @param UserPressedKlarnaMoreInfo props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userPressedKlarnaMoreInfo(props: UserPressedKlarnaMoreInfo, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserPressedKlarnaMoreInfo","$schema":"http://json-schema.org/draft-07/schema#","description":"[CHECKOUT] on checkout when a user pressed more info under Klarna the BNPL option","properties":{"bookingId":{"$id":"/properties/bookingId","description":"","type":"integer"},"bookingStartDateTime":{"$id":"/properties/bookingStartDateTime","description":"","type":"string"},"guestId":{"$id":"/properties/guestId","description":"","type":"integer"},"hostId":{"$id":"/properties/hostId","description":"","type":"integer"},"id":{"$id":"/properties/id","description":"","type":"string"},"listingId":{"$id":"/properties/listingId","description":"","type":"integer"},"listingTitle":{"$id":"/properties/listingTitle","description":"","type":"string"},"market":{"$id":"/properties/market","description":"","type":"string"},"totalPrice":{"$id":"/properties/totalPrice","description":"","type":"number"}},"required":["guestId","hostId","listingId","listingTitle"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserPressedKlarnaMoreInfo', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserPressedLearnMoreSwimplyGuard' track call.
 *
 * @param UserPressedLearnMoreSwimplyGuard props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userPressedLearnMoreSwimplyGuard(props: UserPressedLearnMoreSwimplyGuard, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserPressedLearnMoreSwimplyGuard","$schema":"http://json-schema.org/draft-07/schema#","description":"[PLP] user pressed learn more to view Swimply Guard","properties":{"listingId":{"$id":"/properties/listingId","description":"id of the listing","type":"string"}},"required":["listingId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserPressedLearnMoreSwimplyGuard', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserPressedLeaveFavoriteList' track call.
 *
 * @param UserPressedLeaveFavoriteList props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userPressedLeaveFavoriteList(props: UserPressedLeaveFavoriteList, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserPressedLeaveFavoriteList","$schema":"http://json-schema.org/draft-07/schema#","description":"[GUEST FAVORITE INVITE] user pressed \"leave favorites list\"","properties":{"alphaUserId":{"$id":"/properties/alphaUserId","description":"the user id of the account who created the favorite collection","type":"integer"},"betaUserIds":{"$id":"/properties/betaUserIds","description":"an array of any favorite collection collaborator's user ids","type":"array"},"favoriteCollectionId":{"$id":"/properties/favoriteCollectionId","description":"the favorite collection id","type":"integer"},"favoriteCollectionName":{"$id":"/properties/favoriteCollectionName","description":"the name of the favorite collection","type":"string"},"id":{"$id":"/properties/id","description":"","type":"string"},"isAlphaUserId":{"$id":"/properties/isAlphaUserId","description":"a boolean to identify whether the actions being taken to a favorite collection are being done by the alpha user (1) or a beta user (0)","type":"boolean"}},"required":["favoriteCollectionId","favoriteCollectionName","isAlphaUserId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserPressedLeaveFavoriteList', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserPressedListing' track call.
 *
 * @param UserPressedListing props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userPressedListing(props: UserPressedListing, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserPressedListing","$schema":"http://json-schema.org/draft-07/schema#","description":"[SEARCH] user pressed a listing to navigate to PLP","properties":{"amountOff":{"$id":"/properties/amountOff","description":"if the listing has an active deal, what percent amount off of this promo code (1-100)","type":["number","null"]},"badgeName":{"$id":"/properties/badgeName","description":"displayed badge name","type":["string","null"]},"city":{"$id":"/properties/city","description":"city of the listing","type":"string"},"content_ids":{"$id":"/properties/content_ids","description":"listing id (for meta event)","type":"integer"},"content_type":{"$id":"/properties/content_type","description":"should be destination (for meta event)","enum":["destination"],"type":"string"},"country":{"$id":"/properties/country","description":"country of the listing (for meta event)","type":"string"},"dailyPrice":{"$id":"/properties/dailyPrice","description":"daily price displayed","type":"number"},"enteredFrom":{"$id":"/properties/enteredFrom","description":"All possible values for enteredFrom in PLP\n","enum":["external","favorite","homepage","referral","search","seo"],"type":"string"},"expireDate":{"$id":"/properties/expireDate","description":"if the listing has an active deal, when is the expiration","type":["string","null"]},"favoriteCollectionId":{"$id":"/properties/favoriteCollectionId","description":"When a user accesses a listing via favorites, which favorite collection?","type":"integer"},"globalListingType":{"$id":"/properties/globalListingType","description":"[LISTING TYPE] The type of the listing associated with this event","enum":["artStudio","basketballCourt","dockedBoat","home","homeGym","joyspace","kitchen","largeBackyard","musicStudio","other","pending","pickleball","pool","privateLake","roofDeck","tennisCourt"],"type":"string"},"hasAvailabilityBanner":{"$id":"/properties/hasAvailabilityBanner","description":"whether the listing has the offseason availability banner","type":"boolean"},"hasDeal":{"$id":"/properties/hasDeal","description":"does the listing have a currently active deal (1 - yes, 0 - no)","type":"boolean"},"hasPass":{"$id":"/properties/hasPass","description":"whether the listings has passes available (1 if true, 0 if false)","type":"boolean"},"hourlyPrice":{"$id":"/properties/hourlyPrice","description":"hourly price displayed","type":"number"},"isListView":{"$id":"/properties/isListView","description":"True if the user search in list view, false if floating card in map view","type":"boolean"},"listingId":{"$id":"/properties/listingId","description":"id of the listing","type":"string"},"nextAvailableDateDisplayed":{"$id":"/properties/nextAvailableDateDisplayed","description":"for listings with the offseason availability banner, when is the next available date","type":["string","null"]},"orderInSearchResults":{"$id":"/properties/orderInSearchResults","description":"order in search list (only if isListView is True, null otherwise)","type":"integer"},"passIds":{"$id":"/properties/passIds","description":"if the listing has one or more active passes, list the pass ids in an array","type":["array","null"]},"passTypes":{"$id":"/properties/passTypes","description":"the types of passes available for a listing - null if it doesn't have any","type":["array","null"]},"priceType":{"$id":"/properties/priceType","description":"the displayed priceType of listing","enum":["base_tier_daily_price","base_tier_hourly_price"],"type":"string"},"primaryPhotoId":{"$id":"/properties/primaryPhotoId","description":"photo id of the first photo displayed for the listing","type":["string","null"]},"products":{"$id":"/properties/products","description":"A products array to satisfy third party event processors","items":{"$id":"/properties/properties/properties/products/items","description":"","properties":{"category":{"$id":"/properties/properties/properties/products/items/properties/category","description":"The listing type of the relevant listing\n","type":"string"},"name":{"$id":"/properties/properties/properties/products/items/properties/name","description":"The title of the relevant listing\n","type":"string"},"productId":{"$id":"/properties/properties/properties/products/items/properties/productId","description":"The id of the relevant listing","type":"string"},"quantity":{"$id":"/properties/properties/properties/products/items/properties/quantity","description":"Should always be 1","type":"integer"}},"required":["category","name","productId","quantity"],"type":"object"},"type":"array"},"rating":{"$id":"/properties/rating","description":"rating displayed","type":["number","null"]},"ratingsVolume":{"$id":"/properties/ratingsVolume","description":"total amount of ratings displayed","type":["integer","null"]},"region":{"$id":"/properties/region","description":"state of the listing (for meta event) ","type":"string"},"searchId":{"$id":"/properties/searchId","description":"id of search which generated result","type":["string","null"]},"seoLocation":{"$id":"/properties/seoLocation","description":"the displayed location in SEO page if they entered PLP from SEO, null otherwise","type":["string","null"]},"seoSpaceType":{"$id":"/properties/seoSpaceType","description":"the displayed space type in SEO page if they entered PLP from SEO, null otherwise","enum":["basketballCourt","home",null,"pickleball","pool","tennisCourt"],"type":["string","null"]},"seoUseCase":{"$id":"/properties/seoUseCase","description":"the displayed user case in SEO page if they entered PLP from SEO, null otherwise","enum":["ada-friendly-swim","anniversary-party","baby-shower","bachelorette-party","bar-mitzvah-party","bat-mitzvah-party","bridal-shower","company-offsite","cooking-event","corporate-event","country_club_with_pickleball_court","country_club_with_pool","country_club_with_tennis_court","dinner-party","event","family-swim","graduation-party","gym_with_pool","meeting","night-swim",null,"party","pet-friendly-swim","photoshoot","pickleball_club","pickleball_lessons","pickleball_membership","pool-party","pool_pass","quinceanera-party","swim_club","swim_lessons","swim_membership","tennis_club","tennis_lessons","tennis_membership","video-shoot"],"type":["string","null"]}},"required":["region","passTypes","rating","content_type","isListView","searchId","badgeName","hasPass","hasDeal","city","listingId","ratingsVolume","hasAvailabilityBanner","orderInSearchResults","country","globalListingType","priceType","content_ids","enteredFrom"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserPressedListing', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserPressedListingAISearch' track call.
 *
 * @param UserPressedListingAISearch props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userPressedListingAISearch(props: UserPressedListingAISearch, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserPressedListingAISearch","$schema":"http://json-schema.org/draft-07/schema#","description":"[SEARCH] user pressed a listing to navigate to PLP","properties":{"enteredFrom":{"$id":"/properties/enteredFrom","description":"All possible values for enteredFrom in PLP\n","enum":["external","favorite","homepage","referral","search","seo"],"type":"string"},"isListView":{"$id":"/properties/isListView","description":"True if the user search in list view, false if floating card in map view","type":"boolean"},"listingId":{"$id":"/properties/listingId","description":"id of the listing","type":"string"},"orderInSearchResults":{"$id":"/properties/orderInSearchResults","description":"order in search list (only if isListView is True, null otherwise)","type":"integer"},"price":{"$id":"/properties/price","description":"price displayed","type":"number"},"priceType":{"$id":"/properties/priceType","description":"the displayed priceType of listing","enum":["base_tier_daily_price","base_tier_hourly_price"],"type":"string"},"searchId":{"$id":"/properties/searchId","description":"id of search which generated result","type":["string","null"]}},"required":["listingId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserPressedListingAISearch', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserPressedListingPhoto' track call.
 *
 * @param UserPressedListingPhoto props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userPressedListingPhoto(props: UserPressedListingPhoto, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserPressedListingPhoto","$schema":"http://json-schema.org/draft-07/schema#","description":"[PLP] user pressed on one of the images (or videos) on a given plp","properties":{"listingId":{"$id":"/properties/listingId","description":"id of the listing","type":"string"},"searchId":{"$id":"/properties/searchId","description":"search they entered the listing from, if applicable","type":["string","null"]}},"required":["listingId","searchId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserPressedListingPhoto', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserPressedMap' track call.
 *
 * @param UserPressedMap props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userPressedMap(props: UserPressedMap, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserPressedMap","$schema":"http://json-schema.org/draft-07/schema#","description":"[SEARCH] user clicked on the map itself, not a listing on the map","properties":{"didMapReload":{"$id":"/properties/didMapReload","description":"did map reload new results as a result of the press","type":"boolean"},"searchId":{"$id":"/properties/searchId","description":"id of search which generated result","type":["string","null"]}},"required":["searchId","didMapReload"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserPressedMap', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserPressedMapListing' track call.
 *
 * @param UserPressedMapListing props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userPressedMapListing(props: UserPressedMapListing, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserPressedMapListing","$schema":"http://json-schema.org/draft-07/schema#","description":"[SEARCH] user pressed pin on map","properties":{"badgeName":{"$id":"/properties/badgeName","description":"displayed badge name","type":["string","null"]},"displayedPrice":{"$id":"/properties/displayedPrice","description":"price displayed on the pin","type":"number"},"globalListingType":{"$id":"/properties/globalListingType","description":"[LISTING TYPE] The type of the listing associated with this event","enum":["artStudio","basketballCourt","dockedBoat","home","homeGym","joyspace","kitchen","largeBackyard","musicStudio","other","pending","pickleball","pool","privateLake","roofDeck","tennisCourt"],"type":"string"},"listingId":{"$id":"/properties/listingId","description":"id of the listing","type":"string"},"orderInSearchResults":{"$id":"/properties/orderInSearchResults","description":"order of listing in search result","type":"integer"},"pinColor":{"$id":"/properties/pinColor","description":"color of the pin","type":"string"},"pinLatitude":{"$id":"/properties/pinLatitude","description":"latitude of the pin","type":"number"},"pinLongitude":{"$id":"/properties/pinLongitude","description":"longitude of the pin ","type":"number"},"primaryPhotoId":{"$id":"/properties/primaryPhotoId","description":"photo id of the first photo displayed for the listing","type":"string"},"searchId":{"$id":"/properties/searchId","description":"id of search which generated result","type":["string","null"]}},"required":["badgeName","globalListingType","pinLatitude","orderInSearchResults","displayedPrice","pinColor","listingId","searchId","pinLongitude"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserPressedMapListing', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserPressedNewPoolFilter' track call.
 *
 * @param UserPressedNewPoolFilter props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userPressedNewPoolFilter(props: UserPressedNewPoolFilter, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserPressedNewPoolFilter","$schema":"http://json-schema.org/draft-07/schema#","description":"[SEARCH] user pressed the new pool only filter in the filter menu","properties":{"fakeProperty":{"$id":"/properties/fakeProperty","description":"DO NOT SEND: This is added as a workaround for this issue: https://github.com/segmentio/typewriter/issues/284","type":["string","null"]}},"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserPressedNewPoolFilter', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserPressedNotifications' track call.
 *
 * @param UserPressedNotifications props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userPressedNotifications(props: UserPressedNotifications, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserPressedNotifications","$schema":"http://json-schema.org/draft-07/schema#","description":"[USER PROFILE - ACCOUNT SETTINGS: NOTIFICATIONS]","properties":{"id":{"$id":"/properties/id","description":"","type":"string"}},"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserPressedNotifications', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserPressedPassesUpsellLearnMore' track call.
 *
 * @param UserPressedPassesUpsellLearnMore props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userPressedPassesUpsellLearnMore(props: UserPressedPassesUpsellLearnMore, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserPressedPassesUpsellLearnMore","$schema":"http://json-schema.org/draft-07/schema#","description":" [GUEST PASS ACQUISITION] - when the user presses to learn more about passes","properties":{"id":{"$id":"/properties/id","description":"","type":"string"}},"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserPressedPassesUpsellLearnMore', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserPressedPayWithKlarna' track call.
 *
 * @param UserPressedPayWithKlarna props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userPressedPayWithKlarna(props: UserPressedPayWithKlarna, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserPressedPayWithKlarna","$schema":"http://json-schema.org/draft-07/schema#","description":"[CHECKOUT] on checkout when a user chooses to pay with Klarna the BNPL option","properties":{"bookingId":{"$id":"/properties/bookingId","description":"","type":"integer"},"bookingStartDateTime":{"$id":"/properties/bookingStartDateTime","description":"","type":"string"},"guestId":{"$id":"/properties/guestId","description":"","type":"integer"},"hostId":{"$id":"/properties/hostId","description":"","type":"integer"},"id":{"$id":"/properties/id","description":"","type":"string"},"listingId":{"$id":"/properties/listingId","description":"","type":"integer"},"listingTitle":{"$id":"/properties/listingTitle","description":"","type":"string"},"market":{"$id":"/properties/market","description":"","type":"string"},"totalPrice":{"$id":"/properties/totalPrice","description":"","type":"number"}},"required":["listingId","listingTitle","guestId","hostId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserPressedPayWithKlarna', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserPressedPetFilter' track call.
 *
 * @param UserPressedPetFilter props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userPressedPetFilter(props: UserPressedPetFilter, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserPressedPetFilter","$schema":"http://json-schema.org/draft-07/schema#","description":"[SEARCH] user pressed the pet filter in the filter menu","properties":{"fakeProperty":{"$id":"/properties/fakeProperty","description":"DO NOT SEND: This is added as a workaround for this issue: https://github.com/segmentio/typewriter/issues/284","type":["string","null"]}},"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserPressedPetFilter', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserPressedPostBookingInviteFromConfirmation' track call.
 *
 * @param UserPressedPostBookingInviteFromConfirmation props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userPressedPostBookingInviteFromConfirmation(props: UserPressedPostBookingInviteFromConfirmation, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserPressedPostBookingInviteFromConfirmation","$schema":"http://json-schema.org/draft-07/schema#","description":"[POST BOOKING INVITE] (will be refactored) user pressed to invite from the reservation confirmation screen","properties":{"bookingId":{"$id":"/properties/bookingId","description":"id of the booking this pertains to","type":"string"}},"required":["bookingId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserPressedPostBookingInviteFromConfirmation', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserPressedPostBookingInviteFromReservationPage' track call.
 *
 * @param UserPressedPostBookingInviteFromReservationPage props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userPressedPostBookingInviteFromReservationPage(props: UserPressedPostBookingInviteFromReservationPage, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserPressedPostBookingInviteFromReservationPage","$schema":"http://json-schema.org/draft-07/schema#","description":"[POST BOOKING INVITE] (will be refactored) user pressed to invite from the reservation confirmation screen","properties":{"bookingId":{"$id":"/properties/bookingId","description":"id of the booking this pertains to","type":"string"}},"required":["bookingId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserPressedPostBookingInviteFromReservationPage', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserPressedPriceTagMapView' track call.
 *
 * @param UserPressedPriceTagMapView props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userPressedPriceTagMapView(props: UserPressedPriceTagMapView, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserPressedPriceTagMapView","$schema":"http://json-schema.org/draft-07/schema#","description":"[SEARCH] user pressed the price tag of the listing on map view","properties":{"hourlyPrice":{"$id":"/properties/hourlyPrice","description":"hourly price displayed","type":"number"},"listingId":{"$id":"/properties/listingId","description":"id of the listing","type":"string"},"primaryPhotoId":{"$id":"/properties/primaryPhotoId","description":"photo id of the first photo displayed for the listing","type":"string"},"searchId":{"$id":"/properties/searchId","description":"id of search which generated result","type":["string","null"]}},"required":["primaryPhotoId","hourlyPrice","listingId","searchId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserPressedPriceTagMapView', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserPressedProfileVerificationUploadID' track call.
 *
 * @param UserPressedProfileVerificationUploadID props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userPressedProfileVerificationUploadID(props: UserPressedProfileVerificationUploadID, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserPressedProfileVerificationUploadId","$schema":"http://json-schema.org/draft-07/schema#","description":"[USER PROFILE - Account Verification] user pressed the upload id option after starting the profile verification process","properties":{"id":{"$id":"/properties/id","description":"","type":"string"}},"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserPressedProfileVerificationUploadId', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserPressedPurchaseAnytimePass' track call.
 *
 * @param UserPressedPurchaseAnytimePass props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userPressedPurchaseAnytimePass(props: UserPressedPurchaseAnytimePass, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserPressedPurchaseAnytimePass","$schema":"http://json-schema.org/draft-07/schema#","description":" [GUEST PASS ACQUISITION] - when the user presses to purchase an anytime pass","properties":{"coverImageURL":{"$id":"/properties/coverImageURL","description":"the url for the cover image of the listing the pass is for","type":"string"},"enteredFrom":{"$id":"/properties/enteredFrom","description":"","enum":["checkout",null,"pdp"],"type":["string","null"]},"hostFirstName":{"$id":"/properties/hostFirstName","description":"first name of the host","type":"string"},"id":{"$id":"/properties/id","description":"","type":"string"},"listingId":{"$id":"/properties/listingId","description":"id of the listing the pass is for","type":"string"},"listingTitle":{"$id":"/properties/listingTitle","description":"the title of the listing the pass is for","type":"string"},"listingURL":{"$id":"/properties/listingURL","description":"the url of the listing the pass is for","type":"string"},"passAvailableTimes":{"$id":"/properties/passAvailableTimes","description":"[{from:”07:00:00”, “11:00:00”}...] Time slots when this pass is eligible","type":"array"},"passAvailableTimesText":{"$id":"/properties/passAvailableTimesText","description":"LCM formatted version of available times property","type":"string"},"passBlackoutDays":{"$id":"/properties/passBlackoutDays","description":"list of blackout dates (e.g. July 4, 2024). ","type":["array","null"]},"passCreatedAt":{"$id":"/properties/passCreatedAt","description":"when the pass was created","type":"string"},"passCurrencyCode":{"$id":"/properties/passCurrencyCode","description":"currency for all monetary fields","type":"string"},"passCurrent":{"$id":"/properties/passCurrent","description":"flag indicating that this is the current version for a pass. For a type/name/listing_id, there can only be one record with this attribute true.","type":"boolean"},"passDescription":{"$id":"/properties/passDescription","description":"free text description set by host","type":["string","null"]},"passDiscount":{"$id":"/properties/passDiscount","description":"discount amount. Fixed discounts will be in minors units.","type":["number","null"]},"passDiscountType":{"$id":"/properties/passDiscountType","description":"type of pass discount num[‘percentage’, ‘fixed’]","enum":["FIXED","PERCENTAGE",null],"type":["string","null"]},"passEligibleDays":{"$id":"/properties/passEligibleDays","description":"days the pass is eligible","type":["array","null"]},"passId":{"$id":"/properties/passId","description":"id of the pass","type":"integer"},"passMaxActivePasses":{"$id":"/properties/passMaxActivePasses","description":"max active passes allowed. This constraint will apply to the (listing_id, type, name) rather than id so that we can be accurate across edits.","type":["number","null"]},"passMaxDailyBookings":{"$id":"/properties/passMaxDailyBookings","description":"max bookings allowed under this pass","type":["number","null"]},"passMaxDuration":{"$id":"/properties/passMaxDuration","description":"max duration that may be booked using this pass","type":["number","null"]},"passMaxGuests":{"$id":"/properties/passMaxGuests","description":"max guests that may be booked using this pass","type":["number","null"]},"passName":{"$id":"/properties/passName","description":"the type of the pass formatted to be LCM friendly","pattern":"","type":"string"},"passPremiumAmenities":{"$id":"/properties/passPremiumAmenities","description":"the ids of all premium amenities included with the pass","type":["array","null"]},"passPrice":{"$id":"/properties/passPrice","description":"pass price in minor units","type":"string"},"passState":{"$id":"/properties/passState","description":"‘draft’ -> pass is being actively edited by the host via the creation flow. The step attribute below tracks the progress of the host through the creation flow.\n‘inactive’ -> pass has been created by the host, but not ready for sale yet\n‘active’ -> pass has passed the final availability requirements and has been marked by the host as ready for sale.","enum":["ACTIVE","DRAFT","INACTIVE"],"type":"string"},"passTotalPrice":{"$id":"/properties/passTotalPrice","description":"the pass of the price plus the service fee","type":"string"},"passType":{"$id":"/properties/passType","description":"the type of pass","enum":["ALL_ACCESS","EARLY_BIRD","FIXED_HOURS","WEEKDAY"],"type":"string"}},"required":["passPrice","passType","listingTitle","passDiscount","passCurrent","hostFirstName","coverImageURL","listingURL","passCreatedAt","passCurrencyCode","listingId","passState","enteredFrom","passId","passTotalPrice","passName","passDiscountType"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserPressedPurchaseAnytimePass', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserPressedPurchaseEarlyBirdPass' track call.
 *
 * @param UserPressedPurchaseEarlyBirdPass props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userPressedPurchaseEarlyBirdPass(props: UserPressedPurchaseEarlyBirdPass, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserPressedPurchaseEarlyBirdPass","$schema":"http://json-schema.org/draft-07/schema#","description":" [GUEST PASS ACQUISITION] - when the user presses to purchase an earlybird pass","properties":{"coverImageURL":{"$id":"/properties/coverImageURL","description":"the url for the cover image of the listing the pass is for","type":"string"},"enteredFrom":{"$id":"/properties/enteredFrom","description":"","enum":["checkout",null,"pdp"],"type":["string","null"]},"hostFirstName":{"$id":"/properties/hostFirstName","description":"first name of the host","type":"string"},"id":{"$id":"/properties/id","description":"","type":"string"},"listingId":{"$id":"/properties/listingId","description":"id of the listing the pass is for","type":"string"},"listingTitle":{"$id":"/properties/listingTitle","description":"the title of the listing the pass is for","type":"string"},"listingURL":{"$id":"/properties/listingURL","description":"the url of the listing the pass is for","type":"string"},"passAvailableTimes":{"$id":"/properties/passAvailableTimes","description":"[{from:”07:00:00”, “11:00:00”}...] Time slots when this pass is eligible","type":"array"},"passAvailableTimesText":{"$id":"/properties/passAvailableTimesText","description":"LCM formatted version of available times property","type":"string"},"passBlackoutDays":{"$id":"/properties/passBlackoutDays","description":"list of blackout dates (e.g. July 4, 2024). ","type":["array","null"]},"passCreatedAt":{"$id":"/properties/passCreatedAt","description":"when the pass was created","type":"string"},"passCurrencyCode":{"$id":"/properties/passCurrencyCode","description":"currency for all monetary fields","type":"string"},"passCurrent":{"$id":"/properties/passCurrent","description":"flag indicating that this is the current version for a pass. For a type/name/listing_id, there can only be one record with this attribute true.","type":"boolean"},"passDescription":{"$id":"/properties/passDescription","description":"free text description set by host","type":["string","null"]},"passDiscount":{"$id":"/properties/passDiscount","description":"discount amount. Fixed discounts will be in minors units.","type":["number","null"]},"passDiscountType":{"$id":"/properties/passDiscountType","description":"type of pass discount num[‘percentage’, ‘fixed’]","enum":["FIXED","PERCENTAGE",null],"type":["string","null"]},"passEligibleDays":{"$id":"/properties/passEligibleDays","description":"days the pass is eligible","type":["array","null"]},"passId":{"$id":"/properties/passId","description":"id of the pass","type":"integer"},"passMaxActivePasses":{"$id":"/properties/passMaxActivePasses","description":"max active passes allowed. This constraint will apply to the (listing_id, type, name) rather than id so that we can be accurate across edits.","type":["number","null"]},"passMaxDailyBookings":{"$id":"/properties/passMaxDailyBookings","description":"max bookings allowed under this pass","type":["number","null"]},"passMaxDuration":{"$id":"/properties/passMaxDuration","description":"max duration that may be booked using this pass","type":["number","null"]},"passMaxGuests":{"$id":"/properties/passMaxGuests","description":"max guests that may be booked using this pass","type":["number","null"]},"passName":{"$id":"/properties/passName","description":"the type of the pass formatted to be LCM friendly","pattern":"","type":"string"},"passPremiumAmenities":{"$id":"/properties/passPremiumAmenities","description":"the ids of all premium amenities included with the pass","type":["array","null"]},"passPrice":{"$id":"/properties/passPrice","description":"pass price in minor units","type":"string"},"passState":{"$id":"/properties/passState","description":"‘draft’ -> pass is being actively edited by the host via the creation flow. The step attribute below tracks the progress of the host through the creation flow.\n‘inactive’ -> pass has been created by the host, but not ready for sale yet\n‘active’ -> pass has passed the final availability requirements and has been marked by the host as ready for sale.","enum":["ACTIVE","DRAFT","INACTIVE"],"type":"string"},"passTotalPrice":{"$id":"/properties/passTotalPrice","description":"the pass of the price plus the service fee","type":"string"},"passType":{"$id":"/properties/passType","description":"the type of pass","enum":["ALL_ACCESS","EARLY_BIRD","FIXED_HOURS","WEEKDAY"],"type":"string"}},"required":["listingTitle","passCurrencyCode","passDiscount","passDiscountType","coverImageURL","listingURL","enteredFrom","passPrice","passTotalPrice","passName","listingId","passCreatedAt","passType","passId","passState","hostFirstName","passCurrent"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserPressedPurchaseEarlyBirdPass', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserPressedPurchaseWeekdayPass' track call.
 *
 * @param UserPressedPurchaseWeekdayPass props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userPressedPurchaseWeekdayPass(props: UserPressedPurchaseWeekdayPass, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserPressedPurchaseWeekdayPass","$schema":"http://json-schema.org/draft-07/schema#","description":" [GUEST PASS ACQUISITION] - when the user presses to purchase an week day pass","properties":{"coverImageURL":{"$id":"/properties/coverImageURL","description":"the url for the cover image of the listing the pass is for","type":"string"},"enteredFrom":{"$id":"/properties/enteredFrom","description":"","enum":["checkout",null,"pdp"],"type":["string","null"]},"hostFirstName":{"$id":"/properties/hostFirstName","description":"first name of the host","type":"string"},"id":{"$id":"/properties/id","description":"","type":"string"},"listingId":{"$id":"/properties/listingId","description":"id of the listing the pass is for","type":"string"},"listingTitle":{"$id":"/properties/listingTitle","description":"the title of the listing the pass is for","type":"string"},"listingURL":{"$id":"/properties/listingURL","description":"the url of the listing the pass is for","type":"string"},"passAvailableTimes":{"$id":"/properties/passAvailableTimes","description":"[{from:”07:00:00”, “11:00:00”}...] Time slots when this pass is eligible","type":"array"},"passAvailableTimesText":{"$id":"/properties/passAvailableTimesText","description":"LCM formatted version of available times property","type":"string"},"passBlackoutDays":{"$id":"/properties/passBlackoutDays","description":"list of blackout dates (e.g. July 4, 2024). ","type":["array","null"]},"passCreatedAt":{"$id":"/properties/passCreatedAt","description":"when the pass was created","type":"string"},"passCurrencyCode":{"$id":"/properties/passCurrencyCode","description":"currency for all monetary fields","type":"string"},"passCurrent":{"$id":"/properties/passCurrent","description":"flag indicating that this is the current version for a pass. For a type/name/listing_id, there can only be one record with this attribute true.","type":"boolean"},"passDescription":{"$id":"/properties/passDescription","description":"free text description set by host","type":["string","null"]},"passDiscount":{"$id":"/properties/passDiscount","description":"discount amount. Fixed discounts will be in minors units.","type":["number","null"]},"passDiscountType":{"$id":"/properties/passDiscountType","description":"type of pass discount num[‘percentage’, ‘fixed’]","enum":["FIXED","PERCENTAGE",null],"type":["string","null"]},"passEligibleDays":{"$id":"/properties/passEligibleDays","description":"days the pass is eligible","type":["array","null"]},"passId":{"$id":"/properties/passId","description":"id of the pass","type":"integer"},"passMaxActivePasses":{"$id":"/properties/passMaxActivePasses","description":"max active passes allowed. This constraint will apply to the (listing_id, type, name) rather than id so that we can be accurate across edits.","type":["number","null"]},"passMaxDailyBookings":{"$id":"/properties/passMaxDailyBookings","description":"max bookings allowed under this pass","type":["number","null"]},"passMaxDuration":{"$id":"/properties/passMaxDuration","description":"max duration that may be booked using this pass","type":["number","null"]},"passMaxGuests":{"$id":"/properties/passMaxGuests","description":"max guests that may be booked using this pass","type":["number","null"]},"passName":{"$id":"/properties/passName","description":"the type of the pass formatted to be LCM friendly","pattern":"","type":"string"},"passPremiumAmenities":{"$id":"/properties/passPremiumAmenities","description":"the ids of all premium amenities included with the pass","type":["array","null"]},"passPrice":{"$id":"/properties/passPrice","description":"pass price in minor units","type":"string"},"passState":{"$id":"/properties/passState","description":"‘draft’ -> pass is being actively edited by the host via the creation flow. The step attribute below tracks the progress of the host through the creation flow.\n‘inactive’ -> pass has been created by the host, but not ready for sale yet\n‘active’ -> pass has passed the final availability requirements and has been marked by the host as ready for sale.","enum":["ACTIVE","DRAFT","INACTIVE"],"type":"string"},"passTotalPrice":{"$id":"/properties/passTotalPrice","description":"the pass of the price plus the service fee","type":"string"},"passType":{"$id":"/properties/passType","description":"the type of pass","enum":["ALL_ACCESS","EARLY_BIRD","FIXED_HOURS","WEEKDAY"],"type":"string"}},"required":["passTotalPrice","passId","passName","passState","coverImageURL","passDiscountType","passCurrencyCode","hostFirstName","listingId","passCurrent","listingTitle","passDiscount","passType","passCreatedAt","listingURL","passPrice","enteredFrom"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserPressedPurchaseWeekdayPass', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserPressedRatingValue' track call.
 *
 * @param UserPressedRatingValue props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userPressedRatingValue(props: UserPressedRatingValue, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserPressedRatingValue","$schema":"http://json-schema.org/draft-07/schema#","description":"[POST BOOKING REVIEW] user pressed a rating value on booking review","properties":{"bookingId":{"$id":"/properties/bookingId","description":"id of the booking associated with the review","type":"integer"},"listingId":{"$id":"/properties/listingId","description":"id of the listing being reviewed","type":"integer"},"ratingValueMaximum":{"$id":"/properties/ratingValueMaximum","description":"the maximum value the user could have selected for rating","type":"integer"},"ratingValueMinimum":{"$id":"/properties/ratingValueMinimum","description":"the minimum value the user could have selected for rating","type":"integer"},"ratingValuePressed":{"$id":"/properties/ratingValuePressed","description":"rating value selected","type":"integer"}},"required":["ratingValueMaximum","bookingId","listingId","ratingValuePressed","ratingValueMinimum"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserPressedRatingValue', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserPressedRebookWithPass' track call.
 *
 * @param UserPressedRebookWithPass props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userPressedRebookWithPass(props: UserPressedRebookWithPass, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserPressedRebookWithPass","$schema":"http://json-schema.org/draft-07/schema#","description":"[CHECKOUT] after rating a booking 5 stars or not rating, when a user presses to rebook for FREE with a pass","properties":{"guestId":{"$id":"/properties/guestId","description":"","type":"integer"},"hostId":{"$id":"/properties/hostId","description":"","type":"integer"},"id":{"$id":"/properties/id","description":"","type":"string"},"listingId":{"$id":"/properties/listingId","description":"","type":"integer"},"listingTitle":{"$id":"/properties/listingTitle","description":"","type":"string"},"passUpsellCreditAmountOffer":{"$id":"/properties/passUpsellCreditAmountOffer","description":"If the guest is shown an expiring discount towards the pass purchase, how much is it for (null if it's expired or not shown)","type":["number","null"]}},"required":["guestId","hostId","listingId","listingTitle"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserPressedRebookWithPass', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserPressedRecommendedListingInClaims' track call.
 *
 * @param UserPressedRecommendedListingInClaims props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userPressedRecommendedListingInClaims(props: UserPressedRecommendedListingInClaims, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserPressedRecommendedListingInClaims","$schema":"http://json-schema.org/draft-07/schema#","description":"[CLAIM REFERRAL] User pressed the recommended listings on the referral page","properties":{"listingId":{"$id":"/properties/listingId","description":"Id of the listing","type":"integer"},"orderInRecommendedResults":{"$id":"/properties/orderInRecommendedResults","description":"order in the recommended list","type":"integer"},"referralId":{"$id":"/properties/referralId","description":"the referral id of the invite","type":"string"}},"required":["listingId","orderInRecommendedResults","referralId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserPressedRecommendedListingInClaims', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserPressedRedirectToCozyMeal' track call.
 *
 * @param UserPressedRedirectToCozyMeal props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userPressedRedirectToCozyMeal(props: UserPressedRedirectToCozyMeal, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserPressedRedirectToCozyMeal","$schema":"http://json-schema.org/draft-07/schema#","description":"[COZYMEAL] User pressed the \"redirect to Cozymeal\" button on a Cozymeal listing to book on Cozymeal","properties":{"bookingId":{"$id":"/properties/bookingId","description":"","type":"integer"},"cozyMealListingId":{"$id":"/properties/cozyMealListingId","description":"","type":"integer"},"enteredFrom":{"$id":"/properties/enteredFrom","description":"","enum":["book_now","popup_listing","popup_view_all",null],"type":["string","null"]},"guestId":{"$id":"/properties/guestId","description":"","type":"integer"},"hostId":{"$id":"/properties/hostId","description":"","type":"integer"},"id":{"$id":"/properties/id","description":"","type":"string"},"listingId":{"$id":"/properties/listingId","description":"","type":"integer"}},"required":["guestId","hostId","listingId","enteredFrom"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserPressedRedirectToCozyMeal', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserPressedReferAHost' track call.
 *
 * @param UserPressedReferAHost props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userPressedReferAHost(props: UserPressedReferAHost, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserPressedReferAHost","$schema":"http://json-schema.org/draft-07/schema#","description":"[REFERRAL] user pressed the \"refer host\" button","properties":{"isGuestView":{"$id":"/properties/isGuestView","description":"boolean indicator if the screen is a view for guest, 1 if it is for guests, 0 if it is for hosts","type":"boolean"},"referralOfferedAmount":{"$id":"/properties/referralOfferedAmount","description":"the referral amount shown on the text on this screen","properties":{"givingAmount":{"$id":"/properties/properties/properties/referralOfferedAmount/properties/givingAmount","description":"the reward amount for the referee (the host who accepted the invite)\n","type":"number"},"givingAmountCurrency":{"$id":"/properties/properties/properties/referralOfferedAmount/properties/givingAmountCurrency","description":"the currency of the reward amount for the referee","type":"string"},"receivingAmount":{"$id":"/properties/properties/properties/referralOfferedAmount/properties/receivingAmount","description":"the reward amount for the referrer (the user who invited hosts)","type":"number"},"rewardType":{"$id":"/properties/properties/properties/referralOfferedAmount/properties/rewardType","description":"the type of the reward in cash or credit","type":"string"}},"required":["givingAmount","givingAmountCurrency","receivingAmount","rewardType"],"type":"object"}},"required":["referralOfferedAmount","isGuestView"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserPressedReferAHost', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserPressedRemoveFriendsFromFL' track call.
 *
 * @param UserPressedRemoveFriendsFromFL props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userPressedRemoveFriendsFromFL(props: UserPressedRemoveFriendsFromFL, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserPressedRemoveFriendsFromFL","$schema":"http://json-schema.org/draft-07/schema#","description":"[GUEST FAVORITE INVITE] user pressed remove after selecting friend(s) to remove from a favorite list","properties":{"alphaUserId":{"$id":"/properties/alphaUserId","description":"the user id of the account who created the favorite collection","type":"integer"},"betaUserIds":{"$id":"/properties/betaUserIds","description":"an array of any favorite collection collaborator's user ids","type":"array"},"favoriteCollectionId":{"$id":"/properties/favoriteCollectionId","description":"the favorite collection id","type":"integer"},"favoriteCollectionName":{"$id":"/properties/favoriteCollectionName","description":"the name of the favorite collection","type":"string"},"id":{"$id":"/properties/id","description":"","type":"string"},"isAlphaUserId":{"$id":"/properties/isAlphaUserId","description":"a boolean to identify whether the actions being taken to a favorite collection are being done by the alpha user (1) or a beta user (0)","type":"boolean"},"removedUserIds":{"$id":"/properties/removedUserIds","description":"the ids of any users removed from a favorites list","type":"array"}},"required":["favoriteCollectionName","isAlphaUserId","removedUserIds","favoriteCollectionId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserPressedRemoveFriendsFromFL', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserPressedReservationsFromMessageThread' track call.
 *
 * @param UserPressedReservationsFromMessageThread props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userPressedReservationsFromMessageThread(props: UserPressedReservationsFromMessageThread, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserPressedReservationsFromMessageThread","$schema":"http://json-schema.org/draft-07/schema#","description":"user pressed to exit the thread to go to reservations (all reservations on web, the specific thread reservation on mobile)","properties":{"bookingId":{"$id":"/properties/bookingId","description":"the booking shown when the user clicks to see the reservation on chat - logic defined by Mojin in Chat Redesign PRD","type":"integer"},"bookingState":{"$id":"/properties/bookingState","description":"","enum":["canceled","completed","confirmed","declined","expired","inquiry",null,"pending","special_offer"],"type":["string","null"]},"guestId":{"$id":"/properties/guestId","description":"the guest for the booking","type":"integer"},"hostId":{"$id":"/properties/hostId","description":"the host for the booking","type":"integer"},"listingId":{"$id":"/properties/listingId","description":"the listing for the booking","type":"integer"},"roomId":{"$id":"/properties/roomId","description":"the room id for the chat","type":"string"}},"required":["guestId","hostId","roomId","listingId","bookingState","bookingId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserPressedReservationsFromMessageThread', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserPressedRestroomFilter' track call.
 *
 * @param UserPressedRestroomFilter props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userPressedRestroomFilter(props: UserPressedRestroomFilter, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserPressedRestroomFilter","$schema":"http://json-schema.org/draft-07/schema#","description":"[SEARCH] user pressed the restroom filter in the filter menu","properties":{"fakeProperty":{"$id":"/properties/fakeProperty","description":"DO NOT SEND: This is added as a workaround for this issue: https://github.com/segmentio/typewriter/issues/284","type":["string","null"]}},"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserPressedRestroomFilter', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserPressedReviewArrow' track call.
 *
 * @param UserPressedReviewArrow props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userPressedReviewArrow(props: UserPressedReviewArrow, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserPressedReviewArrow","$schema":"http://json-schema.org/draft-07/schema#","description":"[WEB HOMEPAGE] User pressed review arrow to switch review","properties":{"bookingId":{"$id":"/properties/bookingId","description":"the booking id associated to the displayed review after pressing the arrow","type":"string"},"isRightArrow":{"$id":"/properties/isRightArrow","description":"true if the user pressed the arrow on the right","type":"boolean"},"reviewGuest":{"$id":"/properties/reviewGuest","description":"the displayed guest name after pressing the arrow","type":"string"},"reviewText":{"$id":"/properties/reviewText","description":"the displayed review text after pressing the arrow","type":"string"}},"required":["reviewText","reviewGuest","isRightArrow"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserPressedReviewArrow', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserPressedSaveFavoriteFromFavoriteList' track call.
 *
 * @param UserPressedSaveFavoriteFromFavoriteList props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userPressedSaveFavoriteFromFavoriteList(props: UserPressedSaveFavoriteFromFavoriteList, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserPressedSaveFavoriteFromFavoriteList","$schema":"http://json-schema.org/draft-07/schema#","description":"[GUEST FAVORITE] user saves a favorite","properties":{"alphaUserId":{"$id":"/properties/alphaUserId","description":"the user id of the account who created the favorite collection","type":"integer"},"betaUserIds":{"$id":"/properties/betaUserIds","description":"an array of any favorite collection collaborator's user ids","type":"array"},"favoriteCollectionId":{"$id":"/properties/favoriteCollectionId","description":"the favorite collection id","type":"integer"},"favoriteCollectionName":{"$id":"/properties/favoriteCollectionName","description":"the name of the favorite collection","type":"string"},"favoriteId":{"$id":"/properties/favoriteId","description":"","type":"string"},"isAlphaUserId":{"$id":"/properties/isAlphaUserId","description":"a boolean to identify whether the actions being taken to a favorite collection are being done by the alpha user (1) or a beta user (0)","type":"boolean"},"listingId":{"$id":"/properties/listingId","description":"","type":"string"}},"required":["favoriteCollectionId","favoriteCollectionName","isAlphaUserId","listingId","favoriteId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserPressedSaveFavoriteFromFavoriteList', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserPressedSaveFavoriteFromPLP' track call.
 *
 * @param UserPressedSaveFavoriteFromPLP props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userPressedSaveFavoriteFromPLP(props: UserPressedSaveFavoriteFromPLP, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserPressedSaveFavoriteFromPLP","$schema":"http://json-schema.org/draft-07/schema#","description":"[PLP] user saves a favorite","properties":{"favoriteCollectionId":{"$id":"/properties/favoriteCollectionId","description":"","type":"integer"},"favoriteId":{"$id":"/properties/favoriteId","description":"","type":"string"},"listingId":{"$id":"/properties/listingId","description":"","type":"string"}},"required":["favoriteCollectionId","favoriteId","listingId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserPressedSaveFavoriteFromPLP', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserPressedSaveFavoriteFromSearch' track call.
 *
 * @param UserPressedSaveFavoriteFromSearch props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userPressedSaveFavoriteFromSearch(props: UserPressedSaveFavoriteFromSearch, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserPressedSaveFavoriteFromSearch","$schema":"http://json-schema.org/draft-07/schema#","description":"[SEARCH] user saves a favorite","properties":{"favoriteCollectionId":{"$id":"/properties/favoriteCollectionId","description":"","type":"integer"},"favoriteId":{"$id":"/properties/favoriteId","description":"","type":"string"},"listingId":{"$id":"/properties/listingId","description":"","type":"string"}},"required":["favoriteId","listingId","favoriteCollectionId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserPressedSaveFavoriteFromSearch', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserPressedSaveFavoriteListChanges' track call.
 *
 * @param UserPressedSaveFavoriteListChanges props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userPressedSaveFavoriteListChanges(props: UserPressedSaveFavoriteListChanges, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserPressedSaveFavoriteListChanges","$schema":"http://json-schema.org/draft-07/schema#","description":"[GUEST FAVORITE] user presses save changes","properties":{"alphaUserId":{"$id":"/properties/alphaUserId","description":"the user id of the account who created the favorite collection","type":"integer"},"betaUserIds":{"$id":"/properties/betaUserIds","description":"an array of any favorite collection collaborator's user ids","type":"array"},"favoriteCollectionId":{"$id":"/properties/favoriteCollectionId","description":"the favorite collection id","type":"integer"},"favoriteCollectionName":{"$id":"/properties/favoriteCollectionName","description":"the name of the favorite collection","type":"string"},"id":{"$id":"/properties/id","description":"","type":"string"},"isAlphaUserId":{"$id":"/properties/isAlphaUserId","description":"a boolean to identify whether the actions being taken to a favorite collection are being done by the alpha user (1) or a beta user (0)","type":"boolean"}},"required":["favoriteCollectionId","favoriteCollectionName","isAlphaUserId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserPressedSaveFavoriteListChanges', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserPressedScrollInstagramPhotos' track call.
 *
 * @param UserPressedScrollInstagramPhotos props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userPressedScrollInstagramPhotos(props: UserPressedScrollInstagramPhotos, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserPressedScrollInstagramPhotos","$schema":"http://json-schema.org/draft-07/schema#","description":"[PLP - INSTAGRAM] user pressed to scroll to the next cohort of instagram pictures","properties":{"listingId":{"$id":"/properties/listingId","description":"id the the listing","type":"string"},"searchId":{"$id":"/properties/searchId","description":"search they entered the listing from, if applicable","type":["string","null"]}},"required":["listingId","searchId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserPressedScrollInstagramPhotos', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserPressedSearchInviteFriendsReferralBanner' track call.
 *
 * @param UserPressedSearchInviteFriendsReferralBanner props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userPressedSearchInviteFriendsReferralBanner(props: UserPressedSearchInviteFriendsReferralBanner, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserPressedSearchInviteFriendsReferralBanner","$schema":"http://json-schema.org/draft-07/schema#","description":"[SEARCH - REFERRALS] ","properties":{"id":{"$id":"/properties/id","description":"","type":"string"},"totalCredits":{"$id":"/properties/totalCredits","description":"the user's total credit amount - can be null if they have none\n","type":["number","null"]}},"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserPressedSearchInviteFriendsReferralBanner', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserPressedSearchPassesCloseIntro' track call.
 *
 * @param UserPressedSearchPassesCloseIntro props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userPressedSearchPassesCloseIntro(props: UserPressedSearchPassesCloseIntro, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserPressedSearchPassesCloseIntro","$schema":"http://json-schema.org/draft-07/schema#","description":"[GUEST PASS DISCOVERY - SEARCH]","properties":{"id":{"$id":"/properties/id","description":"","type":"string"}},"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserPressedSearchPassesCloseIntro', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserPressedSearchPassesLearnMore' track call.
 *
 * @param UserPressedSearchPassesLearnMore props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userPressedSearchPassesLearnMore(props: UserPressedSearchPassesLearnMore, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserPressedSearchPassesLearnMore","$schema":"http://json-schema.org/draft-07/schema#","description":"[GUEST PASS DISCOVERY - SEARCH]","properties":{"id":{"$id":"/properties/id","description":"","type":"string"}},"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserPressedSearchPassesLearnMore', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserPressedSelectCallType' track call.
 *
 * @param UserPressedSelectCallType props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userPressedSelectCallType(props: UserPressedSelectCallType, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserPressedSelectCallType","$schema":"http://json-schema.org/draft-07/schema#","description":"[MESSAGING - CALLING] user selected the type of the call after entering the call flow","properties":{"bookingId":{"$id":"/properties/bookingId","description":"the booking shown when the user clicks to see the reservation on chat - logic defined by Mojin in Chat Redesign PRD","type":"integer"},"callType":{"$id":"/properties/callType","description":"","enum":[null,"video","voice"],"type":["string","null"]},"guestId":{"$id":"/properties/guestId","description":"the guest for the booking","type":"integer"},"hostId":{"$id":"/properties/hostId","description":"the host for the booking","type":"integer"},"listingId":{"$id":"/properties/listingId","description":"the listing for the booking","type":"integer"},"roomId":{"$id":"/properties/roomId","description":"the room id for the chat","type":"string"}},"required":["roomId","hostId","listingId","bookingId","callType","guestId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserPressedSelectCallType', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserPressedSendPicture' track call.
 *
 * @param UserPressedSendPicture props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userPressedSendPicture(props: UserPressedSendPicture, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserPressedSendPicture","$schema":"http://json-schema.org/draft-07/schema#","description":"[MESSAGING - PHOTOS] after selecting a photo, the user pressed \"send\"","properties":{"bookingId":{"$id":"/properties/bookingId","description":"the booking shown when the user clicks to see the reservation on chat - logic defined by Mojin in Chat Redesign PRD","type":"integer"},"guestId":{"$id":"/properties/guestId","description":"the guest for the booking","type":"integer"},"hostId":{"$id":"/properties/hostId","description":"the host for the booking","type":"integer"},"id":{"$id":"/properties/id","description":"","type":"string"},"listingId":{"$id":"/properties/listingId","description":"the listing for the booking","type":"integer"},"roomId":{"$id":"/properties/roomId","description":"the room id for the chat","type":"string"}},"required":["roomId","guestId","hostId","listingId","bookingId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserPressedSendPicture', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserPressedShareFavoriteListFromSearch' track call.
 *
 * @param UserPressedShareFavoriteListFromSearch props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userPressedShareFavoriteListFromSearch(props: UserPressedShareFavoriteListFromSearch, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserPressedShareFavoriteListFromSearch","$schema":"http://json-schema.org/draft-07/schema#","description":"[SEARCH] user \"presses share my list\" from invite friends pop up after adding listing to a favorite list","properties":{"favoriteCollectionId":{"$id":"/properties/favoriteCollectionId","description":"","type":"integer"}},"required":["favoriteCollectionId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserPressedShareFavoriteListFromSearch', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserPressedSharePostBookingInviteLink' track call.
 *
 * @param UserPressedSharePostBookingInviteLink props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userPressedSharePostBookingInviteLink(props: UserPressedSharePostBookingInviteLink, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserPressedSharePostBookingInviteLink","$schema":"http://json-schema.org/draft-07/schema#","description":"[POST BOOKING INVITE] alpha user pressed to share link or copy link to share the invite","properties":{"bookingId":{"$id":"/properties/bookingId","description":"id of the booking","type":"integer"},"linkUrl":{"$id":"/properties/linkUrl","description":"link of the post booking invite","type":"string"}},"required":["linkUrl","bookingId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserPressedSharePostBookingInviteLink', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserPressedShowMapView' track call.
 *
 * @param UserPressedShowMapView props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userPressedShowMapView(props: UserPressedShowMapView, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserPressedShowMapView","$schema":"http://json-schema.org/draft-07/schema#","description":"[SEARCH] user pressed to display larger map ","properties":{"searchId":{"$id":"/properties/searchId","description":"id of search which generated result","type":["string","null"]}},"required":["searchId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserPressedShowMapView', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserPressedSkipBookingReview' track call.
 *
 * @param UserPressedSkipBookingReview props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userPressedSkipBookingReview(props: UserPressedSkipBookingReview, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserPressedSkipBookingReview","$schema":"http://json-schema.org/draft-07/schema#","description":"[POST BOOKING REVIEW] user pressed \"skip\" option to exit review flow","properties":{"bookingId":{"$id":"/properties/bookingId","description":"id of the booking associated with the review","type":"integer"},"listingId":{"$id":"/properties/listingId","description":"id of the listing being reviewed","type":"integer"}},"required":["bookingId","listingId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserPressedSkipBookingReview', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserPressedSwitchReferral' track call.
 *
 * @param UserPressedSwitchReferral props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userPressedSwitchReferral(props: UserPressedSwitchReferral, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserPressedSwitchReferral","$schema":"http://json-schema.org/draft-07/schema#","description":"[CLAIM REFERRAL] User pressed the button to switch to host or guest referral","properties":{"originalReferralType":{"$id":"/properties/originalReferralType","description":"Type of the original referral, host or guest","type":"string"},"referralId":{"$id":"/properties/referralId","description":"the referral id of the invite","type":"string"},"switchTo":{"$id":"/properties/switchTo","description":"Type of the new referral switched to","type":"string"}},"required":["originalReferralType","switchTo","referralId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserPressedSwitchReferral', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserPressedTOSFromMessages' track call.
 *
 * @param UserPressedTOSFromMessages props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userPressedTOSFromMessages(props: UserPressedTOSFromMessages, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserPressedTOSFromMessages","$schema":"http://json-schema.org/draft-07/schema#","description":"user pressed on the terms of service link from a circumvention autowarning message","properties":{"id":{"$id":"/properties/id","description":"DO NOT SEND: This is added as a workaround for this issue: https://github.com/segmentio/typewriter/issues/284","type":"string"}},"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserPressedTOSFromMessages', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserPressedToBecomeHost' track call.
 *
 * @param UserPressedToBecomeHost props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userPressedToBecomeHost(props: UserPressedToBecomeHost, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserPressedToBecomeHost","$schema":"http://json-schema.org/draft-07/schema#","description":"[WEB HOMEPAGE] User pressed to become a host","properties":{"buttonAt":{"$id":"/properties/buttonAt","description":"the button on the hero image or the button at the end of the page","enum":["hero_image","page_end"],"type":"string"},"listingType":{"$id":"/properties/listingType","description":"Type of the listings","enum":["basketballCourt","home","pickleball","pool","tennisCourt"],"type":"string"}},"required":["listingType","buttonAt"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserPressedToBecomeHost', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserPressedToEnterBookingFlow' track call.
 *
 * @param UserPressedToEnterBookingFlow props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userPressedToEnterBookingFlow(props: UserPressedToEnterBookingFlow, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserPressedToEnterBookingFlow","$schema":"http://json-schema.org/draft-07/schema#","description":"[CHECKOUT] user entered booking flow ","properties":{"checkoutId":{"$id":"/properties/checkoutId","description":"id for the current checkout flow ","type":"string"},"checkoutType":{"$id":"/properties/checkoutType","description":"is the checkout for a pass purchase or a standard booking","enum":["pass","standard_booking"],"type":"string"},"city":{"$id":"/properties/city","description":"city of the listing (for meta event) ","type":"string"},"content_ids":{"$id":"/properties/content_ids","description":"listing id (for meta event) ","type":"integer"},"content_type":{"$id":"/properties/content_type","description":"should be destination (for meta event) ","enum":["destination"],"type":"string"},"country":{"$id":"/properties/country","description":"country of the listing (for meta event) ","type":"string"},"distanceFromPool":{"$id":"/properties/distanceFromPool","description":"current distance of search location to pool, in miles","type":"number"},"enteredFrom":{"$id":"/properties/enteredFrom","description":"where the user entered the flow from","type":"string"},"globalListingType":{"$id":"/properties/globalListingType","description":"[LISTING TYPE] The type of the listing associated with this event","enum":["artStudio","basketballCourt","dockedBoat","home","homeGym","joyspace","kitchen","largeBackyard","musicStudio","other","pending","pickleball","pool","privateLake","roofDeck","tennisCourt"],"type":"string"},"hasActivePass":{"$id":"/properties/hasActivePass","description":"does the listing have an active pass - 1 if true, 0 if false","type":"boolean"},"listingCity":{"$id":"/properties/listingCity","description":"city for the listing","type":"string"},"listingCoverPhotoUrl":{"$id":"/properties/listingCoverPhotoUrl","description":"cover photo url for the listing","type":"string"},"listingId":{"$id":"/properties/listingId","description":"the id for the pool listing","type":"string"},"listingState":{"$id":"/properties/listingState","description":"state/territory of the listing","type":"string"},"listingTitle":{"$id":"/properties/listingTitle","description":"title of the listing","type":"string"},"passId":{"$id":"/properties/passId","description":"if the booking was made or partially made with a pass, the pass id used","type":["integer","null"]},"passName":{"$id":"/properties/passName","description":"the type of the pass formatted to be LCM friendly\n","type":["string","null"]},"passType":{"$id":"/properties/passType","description":"if the booking was made or partially made with a pass, what type of pass","enum":["ALL_ACCESS","EARLY_BIRD","WEEKDAY",null],"type":["string","null"]},"products":{"$id":"/properties/products","description":"list of items being purchased, used for GA event mapping\n","items":{"$id":"/properties/properties/properties/products/items","description":"","properties":{"avgRating":{"$id":"/properties/properties/properties/products/items/properties/avgRating","description":"the average rating the product (listing) displayed on the PLP","type":"number"},"category":{"$id":"/properties/properties/properties/products/items/properties/category","description":"The listing type of the relevant listing\n","type":"string"},"maxGuestCounts":{"$id":"/properties/properties/properties/products/items/properties/maxGuestCounts","description":"maximum number of guest counts for the product (listing)","type":"number"},"name":{"$id":"/properties/properties/properties/products/items/properties/name","description":"The title of the relevant listing\n","type":"string"},"numberOfRatings":{"$id":"/properties/properties/properties/products/items/properties/numberOfRatings","description":"number of rating the product (listing) has","type":"number"},"productId":{"$id":"/properties/properties/properties/products/items/properties/productId","description":"id of associated pool/listing -> item_id","type":"string"},"quantity":{"$id":"/properties/properties/properties/products/items/properties/quantity","description":"Should always be 1\n","type":"integer"}},"required":["avgRating","maxGuestCounts","numberOfRatings","productId","name","category","quantity"],"type":"object"},"type":"array"},"promoCodeAmountOff":{"$id":"/properties/promoCodeAmountOff","description":"if there was a promocode used - the percent amount off of the promo code (1-100)","type":["integer","null"]},"promoCodeId":{"$id":"/properties/promoCodeId","description":"the backend promo code id\n","type":["string","null"]},"promoCodeName":{"$id":"/properties/promoCodeName","description":"the name of the promo Code","type":["string","null"]},"region":{"$id":"/properties/region","description":"state of the listing (for meta event) ","type":"string"},"searchId":{"$id":"/properties/searchId","description":"id for the search that led to this listing","type":["string","null"]},"textDisplayed":{"$id":"/properties/textDisplayed","description":"text of the entry point (e.g, \"Book Now\", \"Check Availability\")","type":"string"}},"required":["enteredFrom","globalListingType","searchId","listingCity","products","textDisplayed","listingTitle","listingCoverPhotoUrl","listingState","checkoutType","content_type","country","distanceFromPool","checkoutId","region","listingId","hasActivePass","city","content_ids"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserPressedToEnterBookingFlow', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserPressedToFavorite' track call.
 *
 * @param UserPressedToFavorite props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userPressedToFavorite(props: UserPressedToFavorite, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserPressedToFavorite","$schema":"http://json-schema.org/draft-07/schema#","description":"[PLP] user pressed to favorite a listing","properties":{"globalListingType":{"$id":"/properties/globalListingType","description":"[LISTING TYPE] The type of the listing associated with this event","enum":["artStudio","basketballCourt","dockedBoat","home","homeGym","joyspace","kitchen","largeBackyard","musicStudio","other","pending","pickleball","pool","privateLake","roofDeck","tennisCourt"],"type":"string"},"listingId":{"$id":"/properties/listingId","description":"id the the listing","type":"string"},"searchId":{"$id":"/properties/searchId","description":"search they entered the listing from, if applicable","type":["string","null"]}},"required":["listingId","searchId","globalListingType"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserPressedToFavorite', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserPressedToRemoveBetaGuest' track call.
 *
 * @param UserPressedToRemoveBetaGuest props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userPressedToRemoveBetaGuest(props: UserPressedToRemoveBetaGuest, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserPressedToRemoveBetaGuest","$schema":"http://json-schema.org/draft-07/schema#","description":"[POST BOOKING INVITE] alpha user pressed to remove the beta guest","properties":{"betaGuestFirstName":{"$id":"/properties/betaGuestFirstName","description":"array of the displayed first name of the selected beta guest","type":"array"},"betaGuestId":{"$id":"/properties/betaGuestId","description":"array of user id of the selected beta guest","type":"array"}},"required":["betaGuestId","betaGuestFirstName"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserPressedToRemoveBetaGuest', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserPressedToSharePLP' track call.
 *
 * @param UserPressedToSharePLP props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userPressedToSharePLP(props: UserPressedToSharePLP, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserPressedToSharePLP","$schema":"http://json-schema.org/draft-07/schema#","description":"[PLP] user pressed on the share option on a given plp","properties":{"globalListingType":{"$id":"/properties/globalListingType","description":"[LISTING TYPE] The type of the listing associated with this event","enum":["artStudio","basketballCourt","dockedBoat","home","homeGym","joyspace","kitchen","largeBackyard","musicStudio","other","pending","pickleball","pool","privateLake","roofDeck","tennisCourt"],"type":"string"},"listingId":{"$id":"/properties/listingId","description":"id of the listing","type":"string"},"searchId":{"$id":"/properties/searchId","description":"search they entered the listing from, if applicable","type":["string","null"]}},"required":["searchId","listingId","globalListingType"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserPressedToSharePLP', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserPressedToSharePLPwFriends' track call.
 *
 * @param UserPressedToSharePLPwFriends props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userPressedToSharePLPwFriends(props: UserPressedToSharePLPwFriends, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserPressedToSharePLPwFriends","$schema":"http://json-schema.org/draft-07/schema#","description":"[PLP] user pressed the \"share pool with friends\" option","properties":{"listingId":{"$id":"/properties/listingId","description":"\nid of the listing\n","type":"string"},"searchId":{"$id":"/properties/searchId","description":"search they entered the listing from, if applicable","type":["string","null"]}},"required":["searchId","listingId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserPressedToSharePLPwFriends', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserPressedToViewGuestList' track call.
 *
 * @param UserPressedToViewGuestList props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userPressedToViewGuestList(props: UserPressedToViewGuestList, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserPressedToViewGuestList","$schema":"http://json-schema.org/draft-07/schema#","description":"[POST BOOKING INVITE] user pressed to view guest list","properties":{"isAlphaGuest":{"$id":"/properties/isAlphaGuest","description":"True if user is alpha guest, False otherwise","type":"boolean"},"numberOfGuest":{"$id":"/properties/numberOfGuest","description":"displayed number of guests on guest list","type":"integer"}},"required":["isAlphaGuest","numberOfGuest"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserPressedToViewGuestList', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserPressedTryAISearch' track call.
 *
 * @param UserPressedTryAISearch props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userPressedTryAISearch(props: UserPressedTryAISearch, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserPressedTryAISearch","$schema":"http://json-schema.org/draft-07/schema#","description":"[SEARCH] user pressed \"Try AI Serach\"","properties":{"id":{"$id":"/properties/id","description":"","type":"string"}},"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserPressedTryAISearch', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserPressedUnsaveFavoriteFromFavoriteList' track call.
 *
 * @param UserPressedUnsaveFavoriteFromFavoriteList props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userPressedUnsaveFavoriteFromFavoriteList(props: UserPressedUnsaveFavoriteFromFavoriteList, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserPressedUnsaveFavoriteFromFavoriteList","$schema":"http://json-schema.org/draft-07/schema#","description":"[GUEST FAVORITE] user saves a favorite change","properties":{"alphaUserId":{"$id":"/properties/alphaUserId","description":"the user id of the account who created the favorite collection","type":"integer"},"betaUserIds":{"$id":"/properties/betaUserIds","description":"an array of any favorite collection collaborator's user ids","type":"array"},"favoriteCollectionId":{"$id":"/properties/favoriteCollectionId","description":"the favorite collection id","type":"integer"},"favoriteCollectionName":{"$id":"/properties/favoriteCollectionName","description":"the name of the favorite collection","type":"string"},"isAlphaUserId":{"$id":"/properties/isAlphaUserId","description":"a boolean to identify whether the actions being taken to a favorite collection are being done by the alpha user (1) or a beta user (0)","type":"boolean"},"listingId":{"$id":"/properties/listingId","description":"","type":"string"}},"required":["listingId","favoriteCollectionId","favoriteCollectionName","isAlphaUserId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserPressedUnsaveFavoriteFromFavoriteList', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserPressedUnsaveFavoriteFromPLP' track call.
 *
 * @param UserPressedUnsaveFavoriteFromPLP props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userPressedUnsaveFavoriteFromPLP(props: UserPressedUnsaveFavoriteFromPLP, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserPressedUnsaveFavoriteFromPLP","$schema":"http://json-schema.org/draft-07/schema#","description":"[PLP] user unsaves a favorite","properties":{"favoriteCollectionId":{"$id":"/properties/favoriteCollectionId","description":"","type":"integer"},"listingId":{"$id":"/properties/listingId","description":"","type":"string"}},"required":["favoriteCollectionId","listingId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserPressedUnsaveFavoriteFromPLP', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserPressedUnsaveFavoriteFromSearch' track call.
 *
 * @param UserPressedUnsaveFavoriteFromSearch props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userPressedUnsaveFavoriteFromSearch(props: UserPressedUnsaveFavoriteFromSearch, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserPressedUnsaveFavoriteFromSearch","$schema":"http://json-schema.org/draft-07/schema#","description":"[SEARCH] user unsaves a favorite","properties":{"favoriteCollectionId":{"$id":"/properties/favoriteCollectionId","description":"","type":"integer"},"listingId":{"$id":"/properties/listingId","description":"","type":"string"}},"required":["favoriteCollectionId","listingId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserPressedUnsaveFavoriteFromSearch', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserPressedViewAllCozymealOptions' track call.
 *
 * @param UserPressedViewAllCozymealOptions props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userPressedViewAllCozymealOptions(props: UserPressedViewAllCozymealOptions, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserPressedViewAllCozymealOptions","$schema":"http://json-schema.org/draft-07/schema#","description":"[COZYMEAL] User pressed the \"view all\" on the post booking Cozymeal catering options pop up","properties":{"bookingId":{"$id":"/properties/bookingId","description":"","type":"integer"},"cozyMealListingIdsShown":{"$id":"/properties/cozyMealListingIdsShown","description":"","type":"array"},"guestId":{"$id":"/properties/guestId","description":"","type":"integer"},"hostId":{"$id":"/properties/hostId","description":"","type":"integer"},"id":{"$id":"/properties/id","description":"","type":"string"},"listingId":{"$id":"/properties/listingId","description":"","type":"integer"}},"required":["cozyMealListingIdsShown","guestId","hostId","listingId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserPressedViewAllCozymealOptions', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserPressedViewAllCozymealOptionsFromSearch' track call.
 *
 * @param UserPressedViewAllCozymealOptionsFromSearch props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userPressedViewAllCozymealOptionsFromSearch(props: UserPressedViewAllCozymealOptionsFromSearch, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserPressedViewAllCozymealOptionsFromSearch","$schema":"http://json-schema.org/draft-07/schema#","description":"[COZYMEAL] User pressed the \"view all\" on the Cozymeal search results catering options","properties":{"bookingId":{"$id":"/properties/bookingId","description":"","type":"integer"},"guestId":{"$id":"/properties/guestId","description":"","type":"integer"},"hostId":{"$id":"/properties/hostId","description":"","type":"integer"},"id":{"$id":"/properties/id","description":"","type":"string"},"listingId":{"$id":"/properties/listingId","description":"","type":"integer"}},"required":["listingId","guestId","hostId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserPressedViewAllCozymealOptionsFromSearch', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserPressedViewAllListingPhotosAndVideos' track call.
 *
 * @param UserPressedViewAllListingPhotosAndVideos props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userPressedViewAllListingPhotosAndVideos(props: UserPressedViewAllListingPhotosAndVideos, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserPressedViewAllListingPhotosAndVideos","$schema":"http://json-schema.org/draft-07/schema#","description":"[PLP] user pressed \"All photos and videos\" on a given plp","properties":{"listingId":{"$id":"/properties/listingId","description":"id of the listing","type":"string"},"searchId":{"$id":"/properties/searchId","description":"search they entered the listing from, if applicable","type":["string","null"]}},"required":["listingId","searchId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserPressedViewAllListingPhotosAndVideos', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserPressedViewHostProfile' track call.
 *
 * @param UserPressedViewHostProfile props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userPressedViewHostProfile(props: UserPressedViewHostProfile, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserPressedViewHostProfile","$schema":"http://json-schema.org/draft-07/schema#","description":"[PLP] user pressed to view a host profile from PLP","properties":{"hostId":{"$id":"/properties/hostId","description":"id of the host","type":"string"},"hostVerified":{"$id":"/properties/hostVerified","description":"Is the host fully verified","type":"boolean"},"listingId":{"$id":"/properties/listingId","description":"id of the listing","type":"string"}},"required":["listingId","hostVerified","hostId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserPressedViewHostProfile', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserPressedViewInstagramPhoto' track call.
 *
 * @param UserPressedViewInstagramPhoto props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userPressedViewInstagramPhoto(props: UserPressedViewInstagramPhoto, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserPressedViewInstagramPhoto","$schema":"http://json-schema.org/draft-07/schema#","description":"[PLP - INSTAGRAM] user pressed to view a specific one of the listing's instagram photos","properties":{"listingId":{"$id":"/properties/listingId","description":"id the the listing","type":"string"},"searchId":{"$id":"/properties/searchId","description":"search they entered the listing from, if applicable","type":["string","null"]}},"required":["listingId","searchId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserPressedViewInstagramPhoto', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserPressedViewPhoto' track call.
 *
 * @param UserPressedViewPhoto props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userPressedViewPhoto(props: UserPressedViewPhoto, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserPressedViewPhoto","$schema":"http://json-schema.org/draft-07/schema#","description":"[MESSAGING - PHOTOS] after a user sent a photo, a user views the picture sent","properties":{"bookingId":{"$id":"/properties/bookingId","description":"the booking shown when the user clicks to see the reservation on chat - logic defined by Mojin in Chat Redesign PRD","type":"integer"},"guestId":{"$id":"/properties/guestId","description":"the guest for the booking","type":"integer"},"hostId":{"$id":"/properties/hostId","description":"the host for the booking","type":"integer"},"listingId":{"$id":"/properties/listingId","description":"the listing for the booking","type":"integer"},"roomId":{"$id":"/properties/roomId","description":"the room id for the chat","type":"string"},"sentByUserId":{"$id":"/properties/sentByUserId","description":"the user who sent the picture","type":"integer"},"userIsHost":{"$id":"/properties/userIsHost","description":"","type":"boolean"}},"required":["roomId","userIsHost","listingId","bookingId","sentByUserId","guestId","hostId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserPressedViewPhoto', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserPressedViewReservationFromPostBookingInvite' track call.
 *
 * @param UserPressedViewReservationFromPostBookingInvite props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userPressedViewReservationFromPostBookingInvite(props: UserPressedViewReservationFromPostBookingInvite, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserPressedViewReservationFromPostBookingInvite","$schema":"http://json-schema.org/draft-07/schema#","description":"[POST BOOKING INVITE]  (will be deprecated) beta guest pressed to \"view reservation\" from a post booking invite","properties":{"bookingId":{"$id":"/properties/bookingId","description":"id of the booking this pertains to","type":"string"}},"required":["bookingId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserPressedViewReservationFromPostBookingInvite', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserPressedViewReviews' track call.
 *
 * @param UserPressedViewReviews props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userPressedViewReviews(props: UserPressedViewReviews, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserPressedViewReviews","$schema":"http://json-schema.org/draft-07/schema#","description":"[PLP] user pressed to view reviews from PLP","properties":{"displayedRating":{"$id":"/properties/displayedRating","description":"displayed rating for the listing","type":["number","null"]},"listingId":{"$id":"/properties/listingId","description":"id the the listing to share","type":"string"},"numReviews":{"$id":"/properties/numReviews","description":"total number of reviews","type":"integer"},"searchId":{"$id":"/properties/searchId","description":"search they entered the listing from, if applicable","type":["string","null"]}},"required":["displayedRating","listingId","numReviews","searchId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserPressedViewReviews', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserPressedXToExitReview' track call.
 *
 * @param UserPressedXToExitReview props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userPressedXToExitReview(props: UserPressedXToExitReview, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserPressedXToExitReview","$schema":"http://json-schema.org/draft-07/schema#","description":"[POST BOOKING REVIEW] user select \"x\" on web to close the screen for reviews","properties":{"bookingId":{"$id":"/properties/bookingId","description":"id of the booking associated with the review","type":"integer"},"listingId":{"$id":"/properties/listingId","description":"id of the listing being reviewed","type":"integer"}},"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserPressedXToExitReview', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserPressedYourInvitesFriends' track call.
 *
 * @param UserPressedYourInvitesFriends props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userPressedYourInvitesFriends(props: UserPressedYourInvitesFriends, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserPressedYourInvitesFriends","$schema":"http://json-schema.org/draft-07/schema#","description":"[REFERRAL] user pressed joined friend button under your invites","properties":{"id":{"$id":"/properties/id","description":"","type":"string"}},"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserPressedYourInvitesFriends', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserPressedYourInvitesHosts' track call.
 *
 * @param UserPressedYourInvitesHosts props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userPressedYourInvitesHosts(props: UserPressedYourInvitesHosts, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserPressedYourInvitesHosts","$schema":"http://json-schema.org/draft-07/schema#","description":"[REFERRAL] user pressed joined host button under your invites\n","properties":{"id":{"$id":"/properties/id","description":"","type":"string"}},"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserPressedYourInvitesHosts', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserReceivedPostBookingInvite' track call.
 *
 * @param UserReceivedPostBookingInvite props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userReceivedPostBookingInvite(props: UserReceivedPostBookingInvite, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserReceivedPostBookingInvite","$schema":"http://json-schema.org/draft-07/schema#","description":"[POST BOOKING INVITE] (will be deprecated) user receives and opens a post booking invite","properties":{"bookingId":{"$id":"/properties/bookingId","description":"id of the booking this pertains to","type":"string"},"isLoggedIn":{"$id":"/properties/isLoggedIn","description":"is this user logged in to an existing account","type":"boolean"}},"required":["bookingId","isLoggedIn"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserReceivedPostBookingInvite', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserRemovedThemselfFromFL' track call.
 *
 * @param UserRemovedThemselfFromFL props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userRemovedThemselfFromFL(props: UserRemovedThemselfFromFL, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserRemovedThemselfFromFL","$schema":"http://json-schema.org/draft-07/schema#","description":"[GUEST FAVORITE INVITE] user confirmed they wanted to leave Favorites List by pressing \"remove me from list\" ","properties":{"alphaUserId":{"$id":"/properties/alphaUserId","description":"the user id of the account who created the favorite collection","type":"integer"},"betaUserIds":{"$id":"/properties/betaUserIds","description":"an array of any favorite collection collaborator's user ids","type":"array"},"favoriteCollectionId":{"$id":"/properties/favoriteCollectionId","description":"the favorite collection id","type":"integer"},"favoriteCollectionName":{"$id":"/properties/favoriteCollectionName","description":"the name of the favorite collection","type":"string"},"id":{"$id":"/properties/id","description":"","type":"string"},"isAlphaUserId":{"$id":"/properties/isAlphaUserId","description":"a boolean to identify whether the actions being taken to a favorite collection are being done by the alpha user (1) or a beta user (0)","type":"boolean"}},"required":["favoriteCollectionId","favoriteCollectionName","isAlphaUserId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserRemovedThemselfFromFL', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserResetFilters' track call.
 *
 * @param UserResetFilters props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userResetFilters(props: UserResetFilters, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserResetFilters","$schema":"http://json-schema.org/draft-07/schema#","description":"[SEARCH] user pressed filter reset in filter menu","properties":{"id":{"$id":"/properties/id","description":"","type":"string"}},"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserResetFilters', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserSavedAddPaymentMethodWallet' track call.
 *
 * @param UserSavedAddPaymentMethodWallet props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userSavedAddPaymentMethodWallet(props: UserSavedAddPaymentMethodWallet, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserSavedAddPaymentMethodWallet","$schema":"http://json-schema.org/draft-07/schema#","description":"[CHECKOUT] user saved new payment method in wallet","properties":{"checkoutId":{"$id":"/properties/checkoutId","description":"id for the current checkout flow ","type":"string"},"enteredFrom":{"$id":"/properties/enteredFrom","description":" where did the user enter the wallet from","enum":["backup","checkout","edit-booking","pass_management","profile"],"type":"string"},"isSuccessful":{"$id":"/properties/isSuccessful","description":"did the payment successfully update","type":"boolean"},"isUnsuccessfulReason":{"$id":"/properties/isUnsuccessfulReason","description":"if the update failed, what is the reason or reasons","type":"array"},"listingId":{"$id":"/properties/listingId","description":"the id for the pool listing","type":"string"},"paymentId":{"$id":"/properties/paymentId","description":"id of the newly saved payment optoin","type":"string"},"products":{"$id":"/properties/products","description":"A products array to satisfy third party event processors","items":{"$id":"/properties/properties/properties/products/items","description":"","properties":{"category":{"$id":"/properties/properties/properties/products/items/properties/category","description":"The listing type of the relevant listing","type":"string"},"name":{"$id":"/properties/properties/properties/products/items/properties/name","description":"The title of the relevant listing","type":"string"},"productId":{"$id":"/properties/properties/properties/products/items/properties/productId","description":"The id of the relevant listing","type":"number"},"quantity":{"$id":"/properties/properties/properties/products/items/properties/quantity","description":"Should always be 1","type":"number"}},"required":["category","name","productId","quantity"],"type":"object"},"type":"array"},"searchId":{"$id":"/properties/searchId","description":"id for the search that led to this listing","type":["string","null"]},"updatedPaymentType":{"$id":"/properties/updatedPaymentType","description":"what type of payment was attempted to be added ","type":"string"}},"required":["listingId","searchId","isUnsuccessfulReason","checkoutId","enteredFrom","isSuccessful"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserSavedAddPaymentMethodWallet', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserScreenShotted' track call.
 *
 * @param UserScreenShotted props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userScreenShotted(props: UserScreenShotted, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserScreenShotted","$schema":"http://json-schema.org/draft-07/schema#","description":"When a user screen shots while on Swimply","properties":{"listingId":{"$id":"/properties/listingId","description":"If the user is looking at a specific listing, please include the listing id","type":["string","null"]},"screenName":{"$id":"/properties/screenName","description":"The name of the screen (or page) that the user is on when they screenshot","type":"string"}},"required":["screenName"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserScreenShotted', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserSearchedMessages' track call.
 *
 * @param UserSearchedMessages props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userSearchedMessages(props: UserSearchedMessages, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserSearchedMessages","$schema":"http://json-schema.org/draft-07/schema#","properties":{"searchString":{"$id":"/properties/searchString","description":"Search string for messages","type":"string"}},"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserSearchedMessages', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserSelectedBookingReason' track call.
 *
 * @param UserSelectedBookingReason props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userSelectedBookingReason(props: UserSelectedBookingReason, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserSelectedBookingReason","$schema":"http://json-schema.org/draft-07/schema#","description":"[CHECKOUT] user selects the mandatory booking reason","properties":{"bookingId":{"$id":"/properties/bookingId","description":"","type":"integer"},"bookingMessage":{"$id":"/properties/bookingMessage","description":"","type":["string","null"]},"bookingReason":{"$id":"/properties/bookingReason","description":"guest selection (listing type specific) for why they're booking","enum":["casual_play","competitive_play","corporate_or_meeting","courts","date","exercise","family_hangout","friend_hangout","lessons",null,"other","party_celebration","party_or_celebration","pet_swim","photoshoot","training"],"type":["string","null"]},"bookingSpecialOfferId":{"$id":"/properties/bookingSpecialOfferId","description":"","type":["integer","null"]},"bookingStartDateTime":{"$id":"/properties/bookingStartDateTime","description":"","type":"string"},"country":{"$id":"/properties/country","description":"","type":"string"},"globalListingType":{"$id":"/properties/globalListingType","description":"[LISTING TYPE] The type of the listing associated with this event","enum":["artStudio","basketballCourt","dockedBoat","home","homeGym","joyspace","kitchen","largeBackyard","musicStudio","other","pending","pickleball","pool","privateLake","roofDeck","tennisCourt"],"type":"string"},"guestId":{"$id":"/properties/guestId","description":"","type":"integer"},"hostId":{"$id":"/properties/hostId","description":"","type":"integer"},"id":{"$id":"/properties/id","description":"","type":"string"},"isInstantBooking":{"$id":"/properties/isInstantBooking","description":"","type":"boolean"},"listingId":{"$id":"/properties/listingId","description":"","type":"integer"},"listingTitle":{"$id":"/properties/listingTitle","description":"","type":"string"},"market":{"$id":"/properties/market","description":"","type":"string"},"totalGuests":{"$id":"/properties/totalGuests","description":"","type":"integer"},"totalPrice":{"$id":"/properties/totalPrice","description":"","type":"number"}},"required":["guestId","country","isInstantBooking","listingTitle","hostId","globalListingType","listingId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserSelectedBookingReason', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserSelectedOptInSMSAccountNotification' track call.
 *
 * @param UserSelectedOptInSMSAccountNotification props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userSelectedOptInSMSAccountNotification(props: UserSelectedOptInSMSAccountNotification, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserSelectedOptInSmsAccountNotification","$schema":"http://json-schema.org/draft-07/schema#","description":"[ACCOUNT CREATION] user selected the check box for sms notifications related to their account","properties":{"authId":{"$id":"/properties/authId","description":"the authentication session ID","type":"string"}},"required":["authId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserSelectedOptInSmsAccountNotification', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserSelectedOptInSMSNotification' track call.
 *
 * @param UserSelectedOptInSMSNotification props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userSelectedOptInSMSNotification(props: UserSelectedOptInSMSNotification, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserSelectedOptInSmsNotification","$schema":"http://json-schema.org/draft-07/schema#","description":"[ACCOUNT CREATION] user selected the check box for sms notifications related to promotions and marketing","properties":{"authId":{"$id":"/properties/authId","description":"the authentication session ID","type":"string"}},"required":["authId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserSelectedOptInSmsNotification', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserSelectedPopularFilter' track call.
 *
 * @param UserSelectedPopularFilter props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userSelectedPopularFilter(props: UserSelectedPopularFilter, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserSelectedPopularFilter","$schema":"http://json-schema.org/draft-07/schema#","description":"[SEARCH] user selected popular filter","properties":{"amenities":{"$id":"/properties/amenities","description":"an array contains all amenities the user selected in the filter","type":"array"}},"required":["amenities"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserSelectedPopularFilter', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserSelectedPostBookingInviteMethod' track call.
 *
 * @param UserSelectedPostBookingInviteMethod props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userSelectedPostBookingInviteMethod(props: UserSelectedPostBookingInviteMethod, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserSelectedPostBookingInviteMethod","$schema":"http://json-schema.org/draft-07/schema#","description":"[POST BOOKING INVITE] user chose the method to send invites","properties":{"bookingId":{"$id":"/properties/bookingId","description":"id of the booking this pertains to","type":"string"},"enteredFrom":{"$id":"/properties/enteredFrom","description":"did they enter this from reservation page, confirmation page, or the \"who's coming\" page","type":"string"},"methodSelected":{"$id":"/properties/methodSelected","description":"email, sms, link","enum":["email","link","sms"],"type":"string"}},"required":["methodSelected","bookingId","enteredFrom"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserSelectedPostBookingInviteMethod', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserSentMessage' track call.
 *
 * @param UserSentMessage props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userSentMessage(props: UserSentMessage, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserSentMessage","$schema":"http://json-schema.org/draft-07/schema#","description":"User sent a message (with properties for lifecycle). Also an API event","properties":{"lastAssociatedBookingCurrency":{"$id":"/properties/lastAssociatedBookingCurrency","description":"the payment currency of the last booking associated between this user and the recipient, if any","type":"string"},"lastAssociatedBookingDate":{"$id":"/properties/lastAssociatedBookingDate","description":"the date of the last booking associated between this user and the recipient, if any","type":"string"},"lastAssociatedBookingEndTime":{"$id":"/properties/lastAssociatedBookingEndTime","description":"the end time of the last booking associated between this user and the recipient, if any","type":"number"},"lastAssociatedBookingGuestId":{"$id":"/properties/lastAssociatedBookingGuestId","description":"the guest_id of the last booking associated between this user and the recipient, if any","type":"integer"},"lastAssociatedBookingHasPendingSpecialOffer":{"$id":"/properties/lastAssociatedBookingHasPendingSpecialOffer","description":"boolean for whether the booking has a pending special offer (so not accepted yet)\n","type":"boolean"},"lastAssociatedBookingHostId":{"$id":"/properties/lastAssociatedBookingHostId","description":"the host_id of the last booking associated between this user and the recipient, if any","type":"integer"},"lastAssociatedBookingId":{"$id":"/properties/lastAssociatedBookingId","description":"the id of the last booking associated between this user and the recipient, if any","type":"integer"},"lastAssociatedBookingListingId":{"$id":"/properties/lastAssociatedBookingListingId","description":"the listing id of the last booking associated between this user and the recipient, if any","type":"integer"},"lastAssociatedBookingListingPhotoURL":{"$id":"/properties/lastAssociatedBookingListingPhotoURL","description":"the listing id photo url of the last booking associated between this user and the recipient, if any","type":"string"},"lastAssociatedBookingListingType":{"$id":"/properties/lastAssociatedBookingListingType","description":"the listing type of the last booking associated between this user and the recipient, if any","type":"string"},"lastAssociatedBookingNumGuests":{"$id":"/properties/lastAssociatedBookingNumGuests","description":"the num guests of the last booking associated between this user and the recipient, if any","type":"integer"},"lastAssociatedBookingSpecialOfferId":{"$id":"/properties/lastAssociatedBookingSpecialOfferId","description":"if the booking has a special offer, what is the special offer id","type":["integer","null"]},"lastAssociatedBookingSpecialOfferPrice":{"$id":"/properties/lastAssociatedBookingSpecialOfferPrice","description":"if the booking has a special offer, what is the special offer price","type":["number","null"]},"lastAssociatedBookingStartTime":{"$id":"/properties/lastAssociatedBookingStartTime","description":"the start time of the last booking associated between this user and the recipient, if any","type":"number"},"lastAssociatedBookingStatus":{"$id":"/properties/lastAssociatedBookingStatus","description":"the status of the last booking associated between this user and the recipient, if any","type":"string"},"lastAssociatedBookingTotal":{"$id":"/properties/lastAssociatedBookingTotal","description":"the payment total of the last booking associated between this user and the recipient, if any","type":"number"},"messageSentId":{"$id":"/properties/messageSentId","description":"id of the message sent","type":"string"},"messageText":{"$id":"/properties/messageText","description":"sent message text","type":"string"},"recipientFirstName":{"$id":"/properties/recipientFirstName","description":"first name of message recipient","type":"string"},"recipientProfilePhotoURL":{"$id":"/properties/recipientProfilePhotoURL","description":"profile photo url of message recipient","type":"string"},"recipientUserId":{"$id":"/properties/recipientUserId","description":"user_id of message recipient","type":"integer"},"roomId":{"$id":"/properties/roomId","description":"room_id for the message thread","type":"string"},"senderFirstName":{"$id":"/properties/senderFirstName","description":"first name of message sender","type":"string"},"senderLastName":{"$id":"/properties/senderLastName","description":"last name of message sender","type":"string"},"senderProfilePhotoURL":{"$id":"/properties/senderProfilePhotoURL","description":"profile photo url of message sender","type":"string"},"senderUserId":{"$id":"/properties/senderUserId","description":"userId of message sender","type":"number"}},"required":["recipientProfilePhotoURL","recipientUserId","senderUserId","recipientFirstName","messageText","senderProfilePhotoURL","lastAssociatedBookingHasPendingSpecialOffer","senderFirstName","roomId","senderLastName"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserSentMessage', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserSentPhoto' track call.
 *
 * @param UserSentPhoto props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userSentPhoto(props: UserSentPhoto, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserSentPhoto","$schema":"http://json-schema.org/draft-07/schema#","description":"[MESSAGING - PHOTOS]","properties":{"userIsHost":{"$id":"/properties/userIsHost","description":"","type":"boolean"}},"required":["userIsHost"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserSentPhoto', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserSEOEditDate' track call.
 *
 * @param UserSEOEditDate props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userSEOEditDate(props: UserSEOEditDate, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserSeoEditDate","$schema":"http://json-schema.org/draft-07/schema#","description":"[SEO] When user select a date in search bar on the SEO page","properties":{"currentSeoLocation":{"$id":"/properties/currentSeoLocation","description":"the displayed location of the current seo","type":"string"},"currentSeoSpaceType":{"$id":"/properties/currentSeoSpaceType","description":"the current seo space type","enum":["basketballCourt","home","pickleball","pool","tennisCourt",null],"type":["string","null"]},"currentUseCase":{"$id":"/properties/currentUseCase","description":"the displayed use case of the current seo, null if the seo page is not for use cases (false in isUseCaseSeo)","enum":["ada-friendly-swim","anniversary-party","baby-shower","bachelorette-party","bar-mitzvah-party","bat-mitzvah-party","bridal-shower","company-offsite","cooking-event","corporate-event","dinner-party","event","family-swim","graduation-party","meeting","night-swim",null,"party","pet-friendly-swim","photoshoot","pool-party","quinceanera-party","video-shoot"],"type":["string","null"]},"date":{"$id":"/properties/date","description":"the selected date","format":"date-time","type":"string"},"isUseCaseSeo":{"$id":"/properties/isUseCaseSeo","description":"True if the seo is a use case type","type":"boolean"}},"required":["currentUseCase","date","currentSeoSpaceType","currentSeoLocation","isUseCaseSeo"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserSeoEditDate', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserSEOEditDropDown' track call.
 *
 * @param UserSEOEditDropDown props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userSEOEditDropDown(props: UserSEOEditDropDown, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserSeoEditDropDown","$schema":"http://json-schema.org/draft-07/schema#","description":"[SEO] When user edit space type or use case drop down in search bar on the SEO page","properties":{"currentSeoLocation":{"$id":"/properties/currentSeoLocation","description":"the displayed location of the current seo","type":"string"},"currentSeoSpaceType":{"$id":"/properties/currentSeoSpaceType","description":"the current seo space type","enum":["basketballCourt","home","pickleball","pool","tennisCourt",null],"type":["string","null"]},"currentUseCase":{"$id":"/properties/currentUseCase","description":"the displayed use case of the current seo, null if the seo page is not for use cases (false in isUseCaseSeo)","enum":["ada-friendly-swim","anniversary-party","baby-shower","bachelorette-party","bar-mitzvah-party","bat-mitzvah-party","bridal-shower","company-offsite","cooking-event","corporate-event","country_club_with_pickleball_court","country_club_with_pool","country_club_with_tennis_court","dinner-party","event","family-swim","graduation-party","gym_with_pool","meeting","night-swim",null,"party","pet-friendly-swim","photoshoot","pickleball_club","pickleball_lessons","pickleball_membership","pool-party","pool_pass","quinceanera-party","swim_club","swim_lessons","swim_membership","tennis_club","tennis_lessons","tennis_membership","video-shoot"],"type":["string","null"]},"isUseCaseSeo":{"$id":"/properties/isUseCaseSeo","description":"True if the seo is a use case type","type":"boolean"},"newSpaceType":{"$id":"/properties/newSpaceType","description":"the new space type, null when seo is a use case","enum":["basketballCourt","home","pickleball","pool","tennisCourt",null],"type":["string","null"]},"newUseCase":{"$id":"/properties/newUseCase","description":"the new use case, null when seo is not a use case","enum":["ada-friendly-swim","anniversary-party","baby-shower","bachelorette-party","bar-mitzvah-party","bat-mitzvah-party","bridal-shower","company-offsite","cooking-event","corporate-event","country_club_with_pickleball_court","country_club_with_pool","country_club_with_tennis_court","dinner-party","event","family-swim","graduation-party","gym_with_pool","meeting","night-swim",null,"party","pet-friendly-swim","photoshoot","pickleball_club","pickleball_lessons","pickleball_membership","pool-party","pool_pass","quinceanera-party","swim_club","swim_lessons","swim_membership","tennis_club","tennis_lessons","tennis_membership","video-shoot"],"type":["string","null"]}},"required":["currentSeoSpaceType","currentSeoLocation","currentUseCase"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserSeoEditDropDown', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserSEOEditLocation' track call.
 *
 * @param UserSEOEditLocation props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userSEOEditLocation(props: UserSEOEditLocation, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserSeoEditLocation","$schema":"http://json-schema.org/draft-07/schema#","description":"[SEO] When user edit the location in search bar on the SEO page","properties":{"currentSeoLocation":{"$id":"/properties/currentSeoLocation","description":"the displayed location of the current seo","type":"string"},"currentSeoSpaceType":{"$id":"/properties/currentSeoSpaceType","description":"the current seo space type","enum":["basketballCourt","home","pickleball","pool","tennisCourt",null],"type":["string","null"]},"currentUseCase":{"$id":"/properties/currentUseCase","description":"the displayed use case of the current seo, null if the seo page is not for use cases (false in isUseCaseSeo)","enum":["ada-friendly-swim","anniversary-party","baby-shower","bachelorette-party","bar-mitzvah-party","bat-mitzvah-party","bridal-shower","company-offsite","cooking-event","corporate-event","country_club_with_pickleball_court","country_club_with_pool","country_club_with_tennis_court","dinner-party","event","family-swim","graduation-party","gym_with_pool","meeting","night-swim",null,"party","pet-friendly-swim","photoshoot","pickleball_club","pickleball_lessons","pickleball_membership","pool-party","pool_pass","quinceanera-party","swim_club","swim_lessons","swim_membership","tennis_club","tennis_lessons","tennis_membership","video-shoot"],"type":["string","null"]},"isUseCaseSeo":{"$id":"/properties/isUseCaseSeo","description":"True if the seo is a use case type","type":"boolean"},"newLocation":{"$id":"/properties/newLocation","description":"the new location user entered","type":"string"}},"required":["newLocation","currentSeoSpaceType","currentSeoLocation","isUseCaseSeo","currentUseCase"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserSeoEditLocation', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserSEOPressedOtherSEOLink' track call.
 *
 * @param UserSEOPressedOtherSEOLink props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userSEOPressedOtherSEOLink(props: UserSEOPressedOtherSEOLink, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserSeoPressedOtherSeoLink","$schema":"http://json-schema.org/draft-07/schema#","description":"[SEO] When user press the alternative SEO links in the bottom of the page","properties":{"currentSeoLocation":{"$id":"/properties/currentSeoLocation","description":"the displayed location of the current seo","type":"string"},"currentSeoSpaceType":{"$id":"/properties/currentSeoSpaceType","description":"the current seo space type","enum":["basketballCourt","home","pickleball","pool","tennisCourt",null],"type":["string","null"]},"currentUseCase":{"$id":"/properties/currentUseCase","description":"the displayed use case of the current seo, null if the seo page is not for use cases (false in isUseCaseSeo)","enum":["ada-friendly-swim","anniversary-party","baby-shower","bachelorette-party","bar-mitzvah-party","bat-mitzvah-party","bridal-shower","company-offsite","cooking-event","corporate-event","country_club_with_pickleball_court","country_club_with_pool","country_club_with_tennis_court","dinner-party","event","family-swim","graduation-party","gym_with_pool","meeting","night-swim",null,"party","pet-friendly-swim","photoshoot","pickleball_club","pickleball_lessons","pickleball_membership","pool-party","pool_pass","quinceanera-party","swim_club","swim_lessons","swim_membership","tennis_club","tennis_lessons","tennis_membership","video-shoot"],"type":["string","null"]},"isUseCaseSeo":{"$id":"/properties/isUseCaseSeo","description":"True if the seo is a use case type","type":"boolean"},"newLinkLocation":{"$id":"/properties/newLinkLocation","description":"the new location of the alternative link","type":"string"},"newLinkSpaceType":{"$id":"/properties/newLinkSpaceType","description":"the new space type of the alternative link","enum":["basketballCourt","home","pickleball","pool","tennisCourt",null],"type":["string","null"]},"newLinkUseCase":{"$id":"/properties/newLinkUseCase","description":"the new use case of the alternative link","enum":["ada-friendly-swim","anniversary-party","baby-shower","bachelorette-party","bar-mitzvah-party","bat-mitzvah-party","bridal-shower","company-offsite","cooking-event","corporate-event","country_club_with_pickleball_court","country_club_with_pool","country_club_with_tennis_court","dinner-party","event","family-swim","graduation-party","gym_with_pool","meeting","night-swim",null,"party","pet-friendly-swim","photoshoot","pickleball_club","pickleball_lessons","pickleball_membership","pool-party","pool_pass","quinceanera-party","swim_club","swim_lessons","swim_membership","tennis_club","tennis_lessons","tennis_membership","video-shoot"],"type":["string","null"]},"sectionName":{"$id":"/properties/sectionName","description":"the name of the section of the alternative link","enum":["PerfectSpaces","morePrivateSpace","otherNearby"],"type":"string"}},"required":["sectionName","newLinkLocation","newLinkUseCase","newLinkSpaceType","currentSeoLocation","currentSeoSpaceType","currentUseCase","isUseCaseSeo"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserSeoPressedOtherSeoLink', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserSEOPressedToExpandReadMorePLP' track call.
 *
 * @param UserSEOPressedToExpandReadMorePLP props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userSEOPressedToExpandReadMorePLP(props: UserSEOPressedToExpandReadMorePLP, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserSeoPressedToExpandReadMorePLP","$schema":"http://json-schema.org/draft-07/schema#","description":"[SEO] When user pressed to expand PLP description","properties":{"displayNumberReivew":{"$id":"/properties/displayNumberReivew","description":"number of review displayed on the PLP","type":"number"},"displayPrice":{"$id":"/properties/displayPrice","description":"price displayed on the PLP","type":"number"},"displayRating":{"$id":"/properties/displayRating","description":"rating displayed in the PLP","type":"number"},"listingId":{"$id":"/properties/listingId","description":"id of the listing","type":"integer"},"seoLocation":{"$id":"/properties/seoLocation","description":"location of the seo page","type":"string"},"seoSpaceType":{"$id":"/properties/seoSpaceType","description":"space type of the seo page","enum":["basketballCourt","home","pickleball","pool","tennisCourt",null],"type":["string","null"]},"seoUseCase":{"$id":"/properties/seoUseCase","description":"useCase of the seo page","enum":["ada-friendly-swim","anniversary-party","baby-shower","bachelorette-party","bar-mitzvah-party","bat-mitzvah-party","bridal-shower","company-offsite","cooking-event","corporate-event","country_club_with_pickleball_court","country_club_with_pool","country_club_with_tennis_court","dinner-party","event","family-swim","graduation-party","gym_with_pool","meeting","night-swim",null,"party","pet-friendly-swim","photoshoot","pickleball_club","pickleball_lessons","pickleball_membership","pool-party","pool_pass","quinceanera-party","swim_club","swim_lessons","swim_membership","tennis_club","tennis_lessons","tennis_membership","video-shoot"],"type":["string","null"]}},"required":["seoUseCase","listingId","displayPrice","displayRating","displayNumberReivew","seoLocation","seoSpaceType"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserSeoPressedToExpandReadMorePLP', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserSEOPressedToExpandReview' track call.
 *
 * @param UserSEOPressedToExpandReview props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userSEOPressedToExpandReview(props: UserSEOPressedToExpandReview, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserSeoPressedToExpandReview","$schema":"http://json-schema.org/draft-07/schema#","description":"[SEO] When user pressed to expand review","properties":{"reviewId":{"$id":"/properties/reviewId","description":"id of the booking review","type":"integer"},"seoLocation":{"$id":"/properties/seoLocation","description":"location of the seo page","type":"string"},"seoSpaceType":{"$id":"/properties/seoSpaceType","description":"space type of the seo page","enum":["basketballCourt","home","pickleball","pool","tennisCourt",null],"type":["string","null"]},"seoUseCase":{"$id":"/properties/seoUseCase","description":"useCase of the seo page","enum":["ada-friendly-swim","anniversary-party","baby-shower","bachelorette-party","bar-mitzvah-party","bat-mitzvah-party","bridal-shower","company-offsite","cooking-event","corporate-event","dinner-party","event","family-swim","graduation-party","meeting","night-swim",null,"party","pet-friendly-swim","photoshoot","pool-party","quinceanera-party","video-shoot"],"type":["string","null"]}},"required":["seoSpaceType","seoUseCase","reviewId","seoLocation"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserSeoPressedToExpandReview', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserSetPaymentMethodInWallet' track call.
 *
 * @param UserSetPaymentMethodInWallet props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userSetPaymentMethodInWallet(props: UserSetPaymentMethodInWallet, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserSetPaymentMethodInWallet","$schema":"http://json-schema.org/draft-07/schema#","description":"[CHECKOUT] user set a payment in the wallet","properties":{"checkoutId":{"$id":"/properties/checkoutId","description":"id for the current checkout flow ","type":"string"},"checkoutType":{"$id":"/properties/checkoutType","description":"is the checkout for a pass purchase or a standard booking","enum":["pass","standard_booking"],"type":"string"},"existingPaymentId":{"$id":"/properties/existingPaymentId","description":"the previously applied paymentId, if applicable ","type":"string"},"isApplePay":{"$id":"/properties/isApplePay","description":"is the selected payment option Apple Pay","type":"boolean"},"isGooglePay":{"$id":"/properties/isGooglePay","description":"is the selected payment option Google Pay","type":"boolean"},"isMultiDip":{"$id":"/properties/isMultiDip","description":"is this a multi dip booking","type":"boolean"},"listingId":{"$id":"/properties/listingId","description":"the id for the pool listing","type":"string"},"newPaymentId":{"$id":"/properties/newPaymentId","description":"the newly applied paymentId","type":"string"},"passId":{"$id":"/properties/passId","description":"if the booking was made or partially made with a pass, the pass id used","type":["integer","null"]},"passName":{"$id":"/properties/passName","description":"the type of the pass formatted to be LCM friendly\n","type":["string","null"]},"passType":{"$id":"/properties/passType","description":"if the booking was made or partially made with a pass, what type of pass","enum":["ALL_ACCESS","EARLY_BIRD","WEEKDAY",null],"type":["string","null"]},"searchId":{"$id":"/properties/searchId","description":"id for the search that led to this listing","type":["string","null"]}},"required":["isApplePay","listingId","newPaymentId","isGooglePay","checkoutType","searchId","checkoutId","isMultiDip"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserSetPaymentMethodInWallet', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserShiftedMap' track call.
 *
 * @param UserShiftedMap props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userShiftedMap(props: UserShiftedMap, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserShiftedMap","$schema":"http://json-schema.org/draft-07/schema#","description":"[SEARCH] did user adjust the map view area","properties":{"newLatitudeMaximum":{"$id":"/properties/newLatitudeMaximum","description":"new lat max of map result","type":"number"},"newLatitudeMinimum":{"$id":"/properties/newLatitudeMinimum","description":"new lat min of map result","type":"number"},"newLongitudeMaximum":{"$id":"/properties/newLongitudeMaximum","description":"new long max of map result","type":"number"},"newLongitudeMinimum":{"$id":"/properties/newLongitudeMinimum","description":"new long min of map result","type":"number"},"searchId":{"$id":"/properties/searchId","description":"id of search which generated result","type":["string","null"]}},"required":["searchId","newLongitudeMaximum","newLongitudeMinimum","newLatitudeMaximum","newLatitudeMinimum"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserShiftedMap', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserShowMoreTimesPressed' track call.
 *
 * @param UserShowMoreTimesPressed props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userShowMoreTimesPressed(props: UserShowMoreTimesPressed, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserShowMoreTimesPressed","$schema":"http://json-schema.org/draft-07/schema#","description":"[CHECKOUT] user selected to see more times on time selection screen","properties":{"checkoutId":{"$id":"/properties/checkoutId","description":"id for the current checkout flow ","type":"string"},"listingId":{"$id":"/properties/listingId","description":"the id for the pool listing","type":"string"},"newTimesDisplayed":{"$id":"/properties/newTimesDisplayed","description":"new time values displayed ","type":"array"},"originalTimesDisplayed":{"$id":"/properties/originalTimesDisplayed","description":"original time values displayed","type":"array"},"searchId":{"$id":"/properties/searchId","description":"id for the search that led to this listing","type":["string","null"]},"stillShowMore":{"$id":"/properties/stillShowMore","description":"is there still a \"still show more\" option post press?","type":"boolean"}},"required":["searchId","stillShowMore","originalTimesDisplayed","checkoutId","listingId","newTimesDisplayed"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserShowMoreTimesPressed', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserStartedAuth' track call.
 *
 * @param UserStartedAuth props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userStartedAuth(props: UserStartedAuth, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserStartedAuth","$schema":"http://json-schema.org/draft-07/schema#","description":"[ACCOUNT CREATION] user entered the screen for sign in or sign up","properties":{"authId":{"$id":"/properties/authId","description":"the authentication session ID","type":"string"},"enteredFrom":{"$id":"/properties/enteredFrom","description":"How did we enter into the user creation flow?","enum":["auth","booking","chat","claimReferral","contactHost","earnCredits","emailVerification","enterPromoCode","favoriteListing","hostOnboarding","joinWaitlist","paymentMethods","popUp","postBookingInvite","purchasePass","review","unauthenticatedError","unspecified"],"type":"string"}},"required":["enteredFrom","authId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserStartedAuth', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserStartedCall' track call.
 *
 * @param UserStartedCall props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userStartedCall(props: UserStartedCall, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserStartedCall","$schema":"http://json-schema.org/draft-07/schema#","description":"[MESSAGING - CALLING]","properties":{"bookingId":{"$id":"/properties/bookingId","description":"the booking shown when the user clicks to see the reservation on chat - logic defined by Mojin in Chat Redesign PRD","type":"integer"},"callType":{"$id":"/properties/callType","description":"","enum":["video","voice"],"type":"string"},"guestId":{"$id":"/properties/guestId","description":"the guest for the booking","type":"integer"},"hostId":{"$id":"/properties/hostId","description":"the host for the booking","type":"integer"},"id":{"$id":"/properties/id","description":"","type":"string"},"listingId":{"$id":"/properties/listingId","description":"the listing for the booking","type":"integer"},"roomId":{"$id":"/properties/roomId","description":"the room id for the chat","type":"string"},"userIsHost":{"$id":"/properties/userIsHost","description":"","type":"boolean"}},"required":["hostId","listingId","bookingId","userIsHost","roomId","callType","guestId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserStartedCall', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserSubmitInviteViaEmail' track call.
 *
 * @param UserSubmitInviteViaEmail props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userSubmitInviteViaEmail(props: UserSubmitInviteViaEmail, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserSubmitInviteViaEmail","$schema":"http://json-schema.org/draft-07/schema#","description":"[REFERRAL] user submitted and sent invites to friends via email","properties":{"selectedFriendContactInfo":{"$id":"/properties/selectedFriendContactInfo","description":"contact info of all friends in array form","items":{"$id":"/properties/properties/properties/selectedFriendContactInfo/items","description":"","properties":{"selectedContactEmailAddress":{"$id":"/properties/properties/properties/selectedFriendContactInfo/items/properties/selectedContactEmailAddress","description":"\nEmail address of friend","type":"string"},"selectedContactFirstName":{"$id":"/properties/properties/properties/selectedFriendContactInfo/items/properties/selectedContactFirstName","description":"First name of friend","type":"string"}},"required":["selectedContactEmailAddress"],"type":"object"},"type":"array"}},"required":["selectedFriendContactInfo"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserSubmitInviteViaEmail', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserSubmittedAISearch' track call.
 *
 * @param UserSubmittedAISearch props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userSubmittedAISearch(props: UserSubmittedAISearch, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserSubmittedAISearch","$schema":"http://json-schema.org/draft-07/schema#","description":"[SEARCH] the AI search the user submitted with booking details and filter selections","properties":{"date":{"$id":"/properties/date","description":"date the user entered","type":["string","null"]},"isInstant":{"$id":"/properties/isInstant","description":"True if the user selected instant book, false otherwise","type":"boolean"},"latitude":{"$id":"/properties/latitude","description":"the latitude of the location the user searched","type":"number"},"longitude":{"$id":"/properties/longitude","description":"the longitude of the location the user searched","type":"number"},"maxDistance":{"$id":"/properties/maxDistance","description":"the maximum distance the user filtered on","type":"number"},"maxDistanceMeasurementUnit":{"$id":"/properties/maxDistanceMeasurementUnit","description":"the measurement unit type used to filter on (miles or km)","enum":["km","mi"],"type":"string"},"price":{"$id":"/properties/price","description":"the price the user filtered on","properties":{"highPrice":{"$id":"/properties/properties/properties/price/properties/highPrice","description":"the maximum price the user filtered on","type":["number","null"]},"lowPrice":{"$id":"/properties/properties/properties/price/properties/lowPrice","description":"the minimum price the user filtered on","type":"number"}},"required":[],"type":"object"},"searchId":{"$id":"/properties/searchId","description":"\nid of search which generated result","type":["string","null"]},"startTime":{"$id":"/properties/startTime","description":"starting time the user entered","type":["number","null"]},"termsInputAISearch":{"$id":"/properties/termsInputAISearch","description":"what the user input for their search when using AI search - null when the user didn't search via AI search","type":["string","null"]}},"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserSubmittedAISearch', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserSubmittedAccountChange' track call.
 *
 * @param UserSubmittedAccountChange props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userSubmittedAccountChange(props: UserSubmittedAccountChange, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserSubmittedAccountChange","$schema":"http://json-schema.org/draft-07/schema#","description":"[USER PROFILE - Account Details] user pressed save with changes to their account","properties":{"birthdayFrom":{"$id":"/properties/birthdayFrom","description":"original birthday","type":"string"},"birthdayTo":{"$id":"/properties/birthdayTo","description":"null if no change","type":["string","null"]},"changedFields":{"$id":"/properties/changedFields","description":"which account details were changed (possible values are email, birthday, and password - not mutually exclusive)","type":"array"},"emailFrom":{"$id":"/properties/emailFrom","description":"original email","type":"string"},"emailTo":{"$id":"/properties/emailTo","description":"null if no change","type":["string","null"]}},"required":["changedFields"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserSubmittedAccountChange', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserSubmittedAmenity' track call.
 *
 * @param UserSubmittedAmenity props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userSubmittedAmenity(props: UserSubmittedAmenity, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserSubmittedAmenity","$schema":"http://json-schema.org/draft-07/schema#","description":"[CHECKOUT] send event *per amenity selected*","properties":{"amenities":{"$id":"/properties/amenities","description":"","items":{"$id":"/properties/properties/properties/amenities/items","description":"","properties":{"amenityDescription":{"$id":"/properties/properties/properties/amenities/items/properties/amenityDescription","description":"text blurb about the amenity","type":["string","null"]},"amenityFeeDetails":{"$id":"/properties/properties/properties/amenities/items/properties/amenityFeeDetails","description":"","properties":{"flatFeeAmount":{"$id":"/properties/properties/properties/amenities/items/properties/amenityFeeDetails/properties/flatFeeAmount","description":"flat fee amount if it exists, otherwise 0","type":"number"},"hourlyFeeAmount":{"$id":"/properties/properties/properties/amenities/items/properties/amenityFeeDetails/properties/hourlyFeeAmount","description":"hourly fee amount if it exists, otherwise 0","type":"number"},"isFlatFee":{"$id":"/properties/properties/properties/amenities/items/properties/amenityFeeDetails/properties/isFlatFee","description":"does this amenity have a flat fee","type":"boolean"},"isHourlyFee":{"$id":"/properties/properties/properties/amenities/items/properties/amenityFeeDetails/properties/isHourlyFee","description":"does this amenity have an hourly fee","type":"boolean"}},"required":["flatFeeAmount","hourlyFeeAmount","isFlatFee","isHourlyFee"],"type":"object"},"amenityName":{"$id":"/properties/properties/properties/amenities/items/properties/amenityName","description":"name of amenity","type":"string"},"isCustomAmenity":{"$id":"/properties/properties/properties/amenities/items/properties/isCustomAmenity","description":"is this a custom amenity from the host","type":"boolean"},"isFee":{"$id":"/properties/properties/properties/amenities/items/properties/isFee","description":"does this amenity have a fee","type":"boolean"},"wasPreSelected":{"$id":"/properties/properties/properties/amenities/items/properties/wasPreSelected","description":"was this amenity pre selected","type":"boolean"}},"required":["amenityName","isCustomAmenity","isFee","wasPreSelected","amenityFeeDetails"],"type":"object"},"type":"array"},"checkoutId":{"$id":"/properties/checkoutId","description":"id for the current checkout flow ","type":"string"},"currency":{"$id":"/properties/currency","description":"currency of fees if applicable","type":"string"},"enteredFromReservationEdit":{"$id":"/properties/enteredFromReservationEdit","description":"did user come to this screen via a reservation edit","type":"boolean"},"listingId":{"$id":"/properties/listingId","description":"the id for the pool listing","type":"string"},"searchId":{"$id":"/properties/searchId","description":"id for the search that led to this listing","type":["string","null"]}},"required":["checkoutId","enteredFromReservationEdit","currency","searchId","amenities","listingId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserSubmittedAmenity', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserSubmittedBookingDetails' track call.
 *
 * @param UserSubmittedBookingDetails props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userSubmittedBookingDetails(props: UserSubmittedBookingDetails, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserSubmittedBookingDetails","$schema":"http://json-schema.org/draft-07/schema#","description":"[SEARCH] user submitted the search by pressed \"show me pools\" in the Find a space screen","properties":{"adultGuests":{"$id":"/properties/adultGuests","description":"number of adult guests the user entered","type":"integer"},"categoryTab":{"$id":"/properties/categoryTab","description":"the category tab the user selected, default as 'all spaces'","type":"string"},"childGuests":{"$id":"/properties/childGuests","description":"number of children guests the user entered","type":"integer"},"date":{"$id":"/properties/date","description":"date the user entered","type":["string","null"]},"endTime":{"$id":"/properties/endTime","description":"ending time the user entered","type":["number","null"]},"infantCount":{"$id":"/properties/infantCount","description":"number of infant guests the user entered","type":"integer"},"petCount":{"$id":"/properties/petCount","description":"number of pet guests the user entered","type":"integer"},"startTime":{"$id":"/properties/startTime","description":"starting time the user entered","type":["number","null"]}},"required":["startTime","adultGuests","categoryTab","childGuests","date","endTime","infantCount","petCount"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserSubmittedBookingDetails', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserSubmittedBookingDetailsToFL' track call.
 *
 * @param UserSubmittedBookingDetailsToFL props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userSubmittedBookingDetailsToFL(props: UserSubmittedBookingDetailsToFL, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserSubmittedBookingDetailsToFL","$schema":"http://json-schema.org/draft-07/schema#","description":"[GUEST FAVORITE] user adjusted or added booking details by changing the date, time, or guest count","properties":{"adultGuests":{"$id":"/properties/adultGuests","description":"","type":"integer"},"alphaUserId":{"$id":"/properties/alphaUserId","description":"the user id of the account who created the favorite collection","type":"integer"},"betaUserIds":{"$id":"/properties/betaUserIds","description":"an array of any favorite collection collaborator's user ids","type":"array"},"childGuests":{"$id":"/properties/childGuests","description":"","type":"integer"},"date":{"$id":"/properties/date","description":"","type":["string","null"]},"endTime":{"$id":"/properties/endTime","description":"","type":["number","null"]},"favoriteCollectionId":{"$id":"/properties/favoriteCollectionId","description":"the favorite collection id","type":"integer"},"favoriteCollectionName":{"$id":"/properties/favoriteCollectionName","description":"the name of the favorite collection","type":"string"},"infantCount":{"$id":"/properties/infantCount","description":"","type":"integer"},"isAlphaUserId":{"$id":"/properties/isAlphaUserId","description":"a boolean to identify whether the actions being taken to a favorite collection are being done by the alpha user (1) or a beta user (0)","type":"boolean"},"petCount":{"$id":"/properties/petCount","description":"","type":"integer"},"startTime":{"$id":"/properties/startTime","description":"","type":["number","null"]}},"required":["infantCount","favoriteCollectionId","adultGuests","favoriteCollectionName","isAlphaUserId","petCount","date","childGuests"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserSubmittedBookingDetailsToFL', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserSubmittedBookingInvites' track call.
 *
 * @param UserSubmittedBookingInvites props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userSubmittedBookingInvites(props: UserSubmittedBookingInvites, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserSubmittedBookingInvites","$schema":"http://json-schema.org/draft-07/schema#","description":"[POST BOOKING INVITE] information on all submitted invites","properties":{"bookingId":{"$id":"/properties/bookingId","description":"id of the booking this pertains to","type":"string"},"inviteRecipients":{"$id":"/properties/inviteRecipients","description":"list of all recipients the invite was sent to","items":{"$id":"/properties/properties/properties/inviteRecipients/items","description":"","properties":{"guestContactInfo":{"$id":"/properties/properties/properties/inviteRecipients/items/properties/guestContactInfo","description":"phone number if phone, email if email","type":"string"},"guestFirstName":{"$id":"/properties/properties/properties/inviteRecipients/items/properties/guestFirstName","description":"user input first name","type":"string"}},"required":["guestContactInfo"],"type":"object"},"type":"array"},"messageAdded":{"$id":"/properties/messageAdded","description":"message blurb sent to all new guests","type":"string"},"methodSelected":{"$id":"/properties/methodSelected","description":"\nemails, sms, etc","enum":["email","link","sms"],"type":"string"}},"required":["methodSelected","bookingId","inviteRecipients"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserSubmittedBookingInvites', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserSubmittedContactHostRequest' track call.
 *
 * @param UserSubmittedContactHostRequest props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userSubmittedContactHostRequest(props: UserSubmittedContactHostRequest, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserSubmittedContactHostRequest","$schema":"http://json-schema.org/draft-07/schema#","description":"[PLP] user submitted contact host from PLP","properties":{"bookingEndTime":{"$id":"/properties/bookingEndTime","description":"end time for the booking request, in military format (1:30PM = 13.5)","type":"number"},"bookingNumAdults":{"$id":"/properties/bookingNumAdults","description":"total number of adults for booking inquiry","type":"integer"},"bookingNumChildren":{"$id":"/properties/bookingNumChildren","description":"total number of children for booking inquiry","type":"integer"},"bookingNumInfants":{"$id":"/properties/bookingNumInfants","description":"total number of infants for booking inquiry","type":"integer"},"bookingNumPets":{"$id":"/properties/bookingNumPets","description":"total number of pets for booking inquiry","type":"integer"},"bookingStartTime":{"$id":"/properties/bookingStartTime","description":"start time for the booking request, in military format (1:30PM = 13.5)","type":"number"},"bookingTotalGuests":{"$id":"/properties/bookingTotalGuests","description":"total number of all guests for booking inquiry","type":"integer"},"bookingTotalPrice":{"$id":"/properties/bookingTotalPrice","description":"total estimated price for booking based on time + guest count","type":"number"},"checkoutId":{"$id":"/properties/checkoutId","description":"checkoutId created for subsequent time, user, and reason events","type":"string"},"dateSelected":{"$id":"/properties/dateSelected","description":"date selected for the booking inquiry","type":"string"},"globalListingType":{"$id":"/properties/globalListingType","description":"[LISTING TYPE] The type of the listing associated with this event","enum":["artStudio","basketballCourt","dockedBoat","home","homeGym","joyspace","kitchen","largeBackyard","musicStudio","other","pending","pickleball","pool","privateLake","roofDeck","tennisCourt"],"type":"string"},"listingCity":{"$id":"/properties/listingCity","description":"city name of the listing","type":"string"},"listingCoverPhotoUrl":{"$id":"/properties/listingCoverPhotoUrl","description":"url for the listing cover photo","type":"string"},"listingId":{"$id":"/properties/listingId","description":"\nid the the listing favorited","type":"string"},"listingPrice":{"$id":"/properties/listingPrice","description":"price for the listing (factoring in the guest count)","type":"number"},"listingPriceType":{"$id":"/properties/listingPriceType","description":"daily price for the listing (factoring in the guest count)","enum":["base_tier_daily_price","base_tier_hourly_price"],"type":"string"},"listingState":{"$id":"/properties/listingState","description":"state/region name for the listing","type":"string"},"listingTitle":{"$id":"/properties/listingTitle","description":"title for the listing","type":"string"},"messageId":{"$id":"/properties/messageId","description":"the id of the message created","type":"string"},"messageText":{"$id":"/properties/messageText","description":"the text contained in the message sent to the host","type":"string"},"roomId":{"$id":"/properties/roomId","description":"the ID of the message thread started with host","type":"string"},"searchId":{"$id":"/properties/searchId","description":"search they entered the listing from, if applicable","type":["string","null"]}},"required":["listingCity","listingTitle","searchId","listingPriceType","messageText","bookingNumChildren","globalListingType","bookingNumAdults","bookingNumInfants","listingPrice","roomId","bookingTotalPrice","messageId","listingState","bookingNumPets","bookingTotalGuests","bookingStartTime","listingCoverPhotoUrl","dateSelected","checkoutId","listingId","bookingEndTime"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserSubmittedContactHostRequest', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserSubmittedFLInviteFriendsViaEmail' track call.
 *
 * @param UserSubmittedFLInviteFriendsViaEmail props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userSubmittedFLInviteFriendsViaEmail(props: UserSubmittedFLInviteFriendsViaEmail, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserSubmittedFLInviteFriendsViaEmail","$schema":"http://json-schema.org/draft-07/schema#","description":"[GUEST FAVORITE INVITE] fires when a user actually sends an email invite to a favorites list","properties":{"alphaUserId":{"$id":"/properties/alphaUserId","description":"the user id of the account who created the favorite collection","type":"integer"},"betaUserIds":{"$id":"/properties/betaUserIds","description":"an array of any favorite collection collaborator's user ids","type":"array"},"favoriteCollectionId":{"$id":"/properties/favoriteCollectionId","description":"the favorite collection id","type":"integer"},"favoriteCollectionName":{"$id":"/properties/favoriteCollectionName","description":"the name of the favorite collection","type":"string"},"id":{"$id":"/properties/id","description":"","type":"string"},"isAlphaUserId":{"$id":"/properties/isAlphaUserId","description":"a boolean to identify whether the actions being taken to a favorite collection are being done by the alpha user (1) or a beta user (0)","type":"boolean"},"selectedFriendContactInfo":{"$id":"/properties/selectedFriendContactInfo","description":"contact info of all friends in array form\n","items":{"$id":"/properties/properties/properties/selectedFriendContactInfo/items","description":"","properties":{"selectedContactEmailAddress":{"$id":"/properties/properties/properties/selectedFriendContactInfo/items/properties/selectedContactEmailAddress","description":"email address of friend\n","type":"string"},"selectedContactFirstName":{"$id":"/properties/properties/properties/selectedFriendContactInfo/items/properties/selectedContactFirstName","description":"first name of friend\n","type":"string"}},"required":["selectedContactEmailAddress"],"type":"object"},"type":"array"}},"required":["selectedFriendContactInfo","favoriteCollectionId","favoriteCollectionName","isAlphaUserId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserSubmittedFLInviteFriendsViaEmail', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserSubmittedFLInviteFriendsViaText' track call.
 *
 * @param UserSubmittedFLInviteFriendsViaText props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userSubmittedFLInviteFriendsViaText(props: UserSubmittedFLInviteFriendsViaText, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserSubmittedFLInviteFriendsViaText","$schema":"http://json-schema.org/draft-07/schema#","description":"[GUEST FAVORITE INVITE] fires when a user actually sends an email invite to a favorites list","properties":{"alphaUserId":{"$id":"/properties/alphaUserId","description":"the user id of the account who created the favorite collection","type":"integer"},"betaUserIds":{"$id":"/properties/betaUserIds","description":"an array of any favorite collection collaborator's user ids","type":"array"},"favoriteCollectionId":{"$id":"/properties/favoriteCollectionId","description":"the favorite collection id","type":"integer"},"favoriteCollectionName":{"$id":"/properties/favoriteCollectionName","description":"the name of the favorite collection","type":"string"},"id":{"$id":"/properties/id","description":"","type":"string"},"isAlphaUserId":{"$id":"/properties/isAlphaUserId","description":"a boolean to identify whether the actions being taken to a favorite collection are being done by the alpha user (1) or a beta user (0)","type":"boolean"},"selectedFriendContactInfo":{"$id":"/properties/selectedFriendContactInfo","description":"contact info of all friends in array form\n","items":{"$id":"/properties/properties/properties/selectedFriendContactInfo/items","description":"","properties":{"selectedContactFirstName":{"$id":"/properties/properties/properties/selectedFriendContactInfo/items/properties/selectedContactFirstName","description":"first name of friend\n","type":"string"},"selectedContactLastName":{"$id":"/properties/properties/properties/selectedFriendContactInfo/items/properties/selectedContactLastName","description":"last name of friend","type":"string"},"selectedContactPhoneNumber":{"$id":"/properties/properties/properties/selectedFriendContactInfo/items/properties/selectedContactPhoneNumber","description":"phone number of friend","type":"string"}},"required":["selectedContactPhoneNumber"],"type":"object"},"type":"array"}},"required":["favoriteCollectionId","favoriteCollectionName","isAlphaUserId","selectedFriendContactInfo"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserSubmittedFLInviteFriendsViaText', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserSubmittedFilter' track call.
 *
 * @param UserSubmittedFilter props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userSubmittedFilter(props: UserSubmittedFilter, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserSubmittedFilter","$schema":"http://json-schema.org/draft-07/schema#","description":"[SEARCH] the filter selections the user submitted","properties":{"additionalSpaces":{"$id":"/properties/additionalSpaces","description":"additional spaces requested (ie home with a basketball court)","type":"string"},"amenities":{"$id":"/properties/amenities","description":"any generic space type features that a user filters for ","type":"array"},"cancellationPolicy":{"$id":"/properties/cancellationPolicy","description":"the amount of days before a booking where the user can cancel for free","type":"string"},"categoryTab":{"$id":"/properties/categoryTab","description":"the category tab the user selected, default as 'all spaces'","enum":["all","discover","home","hoops","pc","pet_park","pickleball","pool","tennis"],"type":"string"},"categoryUseCase":{"$id":"/properties/categoryUseCase","description":"any specific use cases that the user filters for in the categories tab","enum":["all","apartment","backyard","bar","budget","conference","corporate","deal","dinner","event_venue","family","grill","heated","hot_tub","house","indoor","loft","mansion","meeting","movie","multicourt","night","outdoor","party","pass","pet","photo","plunge","pool","restaurant","rooftop","sports","studio","vip","warehouse","wedding"],"type":"string"},"features":{"$id":"/properties/features","description":"any generic space type features that a user filters for ","type":"array"},"greatForUseCase":{"$id":"/properties/greatForUseCase","description":"any great for stickers selected in the great for section","type":"array"},"hasPass":{"$id":"/properties/hasPass","description":"whether the listings has passes available (1 if true, 0 if false)","type":"boolean"},"isDeal":{"$id":"/properties/isDeal","description":"true if the user filtered for only listings offering promotions, false otherwise","type":"boolean"},"isInstant":{"$id":"/properties/isInstant","description":"True if the user selected instant book, false otherwise","type":"boolean"},"isKeywordSearch":{"$id":"/properties/isKeywordSearch","description":"true if the user input a keyword (either via filters or the keyword search option)","type":"boolean"},"keywords":{"$id":"/properties/keywords","description":"the keywords input (null if none)","type":["string","null"]},"listingAmenities":{"$id":"/properties/listingAmenities","description":"any listing type specific amenities that a user filters for ","type":"array"},"listingFeatures":{"$id":"/properties/listingFeatures","description":"any listing type specific features that a user filters for ","type":"array"},"maxDistance":{"$id":"/properties/maxDistance","description":"the maximum distance the user filtered on","type":"number"},"maxDistanceMeasurementUnit":{"$id":"/properties/maxDistanceMeasurementUnit","description":"the measurement unit type used to filter on (miles or km)","enum":["km","mi"],"type":"string"},"passIds":{"$id":"/properties/passIds","description":"if the listing has one or more active passes, list the pass ids in an array","type":["array","null"]},"passTypes":{"$id":"/properties/passTypes","description":"the types of passes available for a listing - null if it doesn't have any","type":["array","null"]},"price":{"$id":"/properties/price","description":"the price the user filtered on","properties":{"highPrice":{"$id":"/properties/properties/properties/price/properties/highPrice","description":"the maximum price the user filtered on","type":["number","null"]},"lowPrice":{"$id":"/properties/properties/properties/price/properties/lowPrice","description":"the minimum price the user filtered on","type":"number"}},"required":["lowPrice"],"type":"object"},"privacyPreference":{"$id":"/properties/privacyPreference","description":"how private the user wants the listing","type":"string"},"requirements":{"$id":"/properties/requirements","description":"listing requirements for the user","properties":{"adaCompliant":{"$id":"/properties/properties/properties/requirements/properties/adaCompliant","description":"selected the ada compliant filter","type":"boolean"},"kidsRequired":{"$id":"/properties/properties/properties/requirements/properties/kidsRequired","description":"user selected to show kid friendly listings only","type":"boolean"},"parkingRequired":{"$id":"/properties/properties/properties/requirements/properties/parkingRequired","description":"user selected to show listings with parking only","type":"boolean"},"petRequired":{"$id":"/properties/properties/properties/requirements/properties/petRequired","description":"user selected to show pet friendly listings only","type":"boolean"},"restroomRequired":{"$id":"/properties/properties/properties/requirements/properties/restroomRequired","description":"user selected to show listings with restroom only","type":"boolean"}},"required":["adaCompliant","petRequired","restroomRequired","kidsRequired","parkingRequired"],"type":"object"},"setting":{"$id":"/properties/setting","description":"where the user wants the booking to occur: indoor, outdoor, or both","properties":{"settingIndoor":{"$id":"/properties/properties/properties/setting/properties/settingIndoor","description":"true if the user wants to have their booking indoors","type":"boolean"},"settingOutdoor":{"$id":"/properties/properties/properties/setting/properties/settingOutdoor","description":"true if the user wants to have their booking outdoors","type":"boolean"}},"required":["settingIndoor","settingOutdoor"],"type":"object"},"subSpaceType":{"$id":"/properties/subSpaceType","description":"listing type specific requirements","type":["string","null"]},"waterType":{"$id":"/properties/waterType","description":"type of water in the pool","type":["string","null"]}},"required":["passTypes","requirements","maxDistance","isKeywordSearch","setting","cancellationPolicy","maxDistanceMeasurementUnit","amenities","isDeal","privacyPreference","isInstant","listingAmenities","price","features","categoryTab","listingFeatures","categoryUseCase","passIds","hasPass"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserSubmittedFilter', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserSubmittedProfileVerificationID' track call.
 *
 * @param UserSubmittedProfileVerificationID props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userSubmittedProfileVerificationID(props: UserSubmittedProfileVerificationID, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserSubmittedProfileVerificationId","$schema":"http://json-schema.org/draft-07/schema#","description":"[USER PROFILE - Account Verification] user submitted their id to have their profile verified","properties":{"id":{"$id":"/properties/id","description":"","type":"string"}},"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserSubmittedProfileVerificationId', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserSubmittedRatingValue' track call.
 *
 * @param UserSubmittedRatingValue props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userSubmittedRatingValue(props: UserSubmittedRatingValue, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserSubmittedRatingValue","$schema":"http://json-schema.org/draft-07/schema#","description":"[POST BOOKING REVIEW] user pressed a rating value on booking review","properties":{"bookingId":{"$id":"/properties/bookingId","description":"id of the booking associated with the review","type":"integer"},"listingId":{"$id":"/properties/listingId","description":"id of the listing being reviewed","type":"integer"},"ratingValueMaximum":{"$id":"/properties/ratingValueMaximum","description":"the maximum value the user could have selected for rating","type":"integer"},"ratingValueMinimum":{"$id":"/properties/ratingValueMinimum","description":"the minimum value the user could have selected for rating","type":"integer"},"ratingValueSubmitted":{"$id":"/properties/ratingValueSubmitted","description":"rating value selected","type":"integer"}},"required":["listingId","ratingValueMinimum","ratingValueMaximum","ratingValueSubmitted","bookingId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserSubmittedRatingValue', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserSubmittedSMSForm' track call.
 *
 * @param UserSubmittedSMSForm props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userSubmittedSMSForm(props: UserSubmittedSMSForm, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserSubmittedSMSForm","$schema":"http://json-schema.org/draft-07/schema#","description":"[WEB HOMEPAGE] User submitted their phone number on mweb to get a link to download the app","properties":{"phoneNumber":{"$id":"/properties/phoneNumber","description":"the phone number input","type":"string"}},"required":["phoneNumber"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserSubmittedSMSForm', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserSubmittedSearch' track call.
 *
 * @param UserSubmittedSearch props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userSubmittedSearch(props: UserSubmittedSearch, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserSubmittedSearch","$schema":"http://json-schema.org/draft-07/schema#","description":"[SEARCH] the search the user submitted with booking details and filter selections","properties":{"additionalSpaces":{"$id":"/properties/additionalSpaces","description":"additional spaces requested (ie home with a basketball court)","type":"string"},"adultGuests":{"$id":"/properties/adultGuests","description":"number of adult guests the user entered","type":"integer"},"amenities":{"$id":"/properties/amenities","description":"any generic space type amenities that a user filters for ","type":"array"},"cancellationPolicy":{"$id":"/properties/cancellationPolicy","description":"the amount of days before a booking where the user can cancel for free","type":"string"},"categoryTab":{"$id":"/properties/categoryTab","description":"the category tab the user selected, default as 'all spaces'","enum":["all","discover","home","hoops","pc","pet_park","pickleball","pool","tennis"],"type":"string"},"categoryUseCase":{"$id":"/properties/categoryUseCase","description":"any specific use cases that the user filters for (called the great for section)","enum":["all","apartment","backyard","bar","budget","conference","corporate","deal","dinner","event_venue","family","grill","heated","hot_tub","house","indoor","loft","mansion","meeting","movie","multicourt","night","outdoor","party","pass","pet","photo","plunge","pool","restaurant","rooftop","sports","studio","vip","warehouse","wedding"],"type":"string"},"childGuests":{"$id":"/properties/childGuests","description":"number of children guests the user entered","type":"integer"},"date":{"$id":"/properties/date","description":"date the user entered","type":["string","null"]},"endTime":{"$id":"/properties/endTime","description":"ending time the user entered","type":["number","null"]},"features":{"$id":"/properties/features","description":"any generic space type features that a user filters for","type":"array"},"greatForUseCase":{"$id":"/properties/greatForUseCase","description":"any great for stickers selected in the great for section","type":"array"},"hasPass":{"$id":"/properties/hasPass","description":"whether the listings has passes available (1 if true, 0 if false)","type":"boolean"},"infantGuests":{"$id":"/properties/infantGuests","description":"number of infant guests the user entered","type":"integer"},"isDeal":{"$id":"/properties/isDeal","description":"true if the user filtered for only listings offering promotions, false otherwise","type":"boolean"},"isInstant":{"$id":"/properties/isInstant","description":"True if the user selected instant book, false otherwise","type":"boolean"},"isKeywordSearch":{"$id":"/properties/isKeywordSearch","description":"true if the user input a keyword (either via filters or the keyword search option)","type":"boolean"},"keywords":{"$id":"/properties/keywords","description":"the keywords input (null if none)","type":["string","null"]},"latitude":{"$id":"/properties/latitude","description":"the latitude of the location the user searched","type":"number"},"listingAmenities":{"$id":"/properties/listingAmenities","description":"any listing type specific amenities that a user filters for ","type":"array"},"listingFeatures":{"$id":"/properties/listingFeatures","description":"any listing type specific features that a user filters for ","type":"array"},"longitude":{"$id":"/properties/longitude","description":"the longitude of the location the user searched","type":"number"},"maxDistance":{"$id":"/properties/maxDistance","description":"the maximum distance the user filtered on","type":"number"},"maxDistanceMeasurementUnit":{"$id":"/properties/maxDistanceMeasurementUnit","description":"the measurement unit type used to filter on (miles or km)","enum":["km","mi"],"type":"string"},"passIds":{"$id":"/properties/passIds","description":"if the listing has one or more active passes, list the pass ids in an array","type":["array","null"]},"passTypes":{"$id":"/properties/passTypes","description":"the types of passes available for a listing - null if it doesn't have any","type":["array","null"]},"petGuests":{"$id":"/properties/petGuests","description":"number of pet guests the user entered","type":"integer"},"postalCode":{"$id":"/properties/postalCode","description":"postal code of the user","type":["string","null"]},"postalCodeSource":{"$id":"/properties/postalCodeSource","description":"source of postal code (geolocation or user_input)","type":["string","null"]},"price":{"$id":"/properties/price","description":"the price the user filtered on","properties":{"highPrice":{"$id":"/properties/properties/properties/price/properties/highPrice","description":"the maximum price the user filtered on","type":["number","null"]},"lowPrice":{"$id":"/properties/properties/properties/price/properties/lowPrice","description":"the minimum price the user filtered on","type":"number"}},"required":["lowPrice"],"type":"object"},"privacyPreference":{"$id":"/properties/privacyPreference","description":"how private the user wants the listing\n","type":"string"},"requirements":{"$id":"/properties/requirements","description":"listing requirements the user filtered for","properties":{"adaCompliantFilter":{"$id":"/properties/properties/properties/requirements/properties/adaCompliantFilter","description":"True if the user selected the ADA compliant filter, false otherwise","type":"boolean"},"kidsFilter":{"$id":"/properties/properties/properties/requirements/properties/kidsFilter","description":"True if the user selected to see kid friendly listings only","type":"boolean"},"parkingFilter":{"$id":"/properties/properties/properties/requirements/properties/parkingFilter","description":"True if the user selected to only see listings with parking","type":"boolean"},"petFilter":{"$id":"/properties/properties/properties/requirements/properties/petFilter","description":"True if the user enabled the pet filter, false otherwise","type":"boolean"},"restroomFilter":{"$id":"/properties/properties/properties/requirements/properties/restroomFilter","description":"true if search has a restroom filter, false otherwise","type":"boolean"}},"required":["restroomFilter","adaCompliantFilter","kidsFilter","parkingFilter","petFilter"],"type":"object"},"searchId":{"$id":"/properties/searchId","description":"\nid of search which generated result","type":["string","null"]},"searchType":{"$id":"/properties/searchType","description":"search type which indicates which action trigger the search event (find pool near me, homepage - enter location or/and date to search, search - edit date/ location/ add filter in search result) ","enum":["default","find pool near me","homepage","homepage category","moved map","search add filters","search category tab","search edit date","search edit details app","search edit guest count","search edit location","search edit time","search on app load","seo search bar","seo see more spaces"],"type":"string"},"seoLocation":{"$id":"/properties/seoLocation","description":"the displaye location if user search in SEO page, null if they search in other flow","type":["string","null"]},"seoSpaceType":{"$id":"/properties/seoSpaceType","description":"the displayed seo space type if user search in SEO page, null if they search in other flow","enum":["basketballCourt","home",null,"pickleball","pool","tennisCourt"],"type":["string","null"]},"seoUseCase":{"$id":"/properties/seoUseCase","description":"the displayed use case if user search in SEO page, null if they search in other flow","enum":["baby-shower","bridal-shower","company-offsite","cooking-event","corporate-event","dinner-party","event","meeting",null,"party","photoshoot","video-shoot"],"type":["string","null"]},"setting":{"$id":"/properties/setting","description":"where the user wants the booking to occur: indoor or outdoor","properties":{"settingIndoor":{"$id":"/properties/properties/properties/setting/properties/settingIndoor","description":"true if the user filtered to have their booking indoors","type":"boolean"},"settingOutdoor":{"$id":"/properties/properties/properties/setting/properties/settingOutdoor","description":"true if the user filtered to have their booking outdoors","type":"boolean"}},"required":["settingIndoor","settingOutdoor"],"type":"object"},"startTime":{"$id":"/properties/startTime","description":"starting time the user entered","type":["number","null"]},"subSpaceType":{"$id":"/properties/subSpaceType","description":"listing type specific requirements","type":["string","null"]},"termsInputAISearch":{"$id":"/properties/termsInputAISearch","description":"what the user input for their search when using AI search - null when the user didn't search via AI search","type":["string","null"]},"waterType":{"$id":"/properties/waterType","description":"water type the user selected (salt water or chlorine)","type":["string","null"]}},"required":["listingFeatures","hasPass","cancellationPolicy","latitude","longitude","maxDistanceMeasurementUnit","maxDistance","passTypes","isDeal","categoryUseCase","categoryTab","listingAmenities","passIds","isKeywordSearch","price","searchType","searchId","setting","privacyPreference","requirements","amenities","adultGuests"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserSubmittedSearch', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserSubmittedTimeRange' track call.
 *
 * @param UserSubmittedTimeRange props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userSubmittedTimeRange(props: UserSubmittedTimeRange, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserSubmittedTimeRange","$schema":"http://json-schema.org/draft-07/schema#","description":"[CHECKOUT] selected time range on time+date modification screen","properties":{"beginTime":{"$id":"/properties/beginTime","description":"start time for booking","type":"number"},"checkoutId":{"$id":"/properties/checkoutId","description":"id for the current checkout flow ","type":"string"},"displayedPriceTotal":{"$id":"/properties/displayedPriceTotal","description":"displayed price thus far","type":"number"},"endTime":{"$id":"/properties/endTime","description":"end time for booking","type":"number"},"enteredFromContactHostFlow":{"$id":"/properties/enteredFromContactHostFlow","description":"did they enter this item from the \"contact host\" PLP flow","type":"boolean"},"enteredFromPLP":{"$id":"/properties/enteredFromPLP","description":"did they enter this item from the PLP ","type":"boolean"},"enteredFromReservationEdit":{"$id":"/properties/enteredFromReservationEdit","description":"did user come to this screen via a reservation edit","type":"boolean"},"listingId":{"$id":"/properties/listingId","description":"the id for the pool listing","type":"string"},"searchId":{"$id":"/properties/searchId","description":"id for the search that led to this listing","type":["string","null"]}},"required":["searchId","enteredFromContactHostFlow","beginTime","checkoutId","displayedPriceTotal","enteredFromPLP","endTime","listingId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserSubmittedTimeRange', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserSubmittedWrittenReviewText' track call.
 *
 * @param UserSubmittedWrittenReviewText props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userSubmittedWrittenReviewText(props: UserSubmittedWrittenReviewText, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserSubmittedWrittenReviewText","$schema":"http://json-schema.org/draft-07/schema#","description":"[POST BOOKING REVIEW] user submitted written review","properties":{"blurb":{"$id":"/properties/blurb","description":"text submitted for review","type":"string"},"bookingId":{"$id":"/properties/bookingId","description":"id of the booking associated with the review","type":"integer"},"listingId":{"$id":"/properties/listingId","description":"id of the listing being reviewed","type":"integer"}},"required":["blurb","listingId","bookingId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserSubmittedWrittenReviewText', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserSwitchedToFriendsInviteWithinTrackInvitesPage' track call.
 *
 * @param UserSwitchedToFriendsInviteWithinTrackInvitesPage props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userSwitchedToFriendsInviteWithinTrackInvitesPage(props: UserSwitchedToFriendsInviteWithinTrackInvitesPage, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserSwitchedToFriendsInviteWithinTrackInvitesPage","$schema":"http://json-schema.org/draft-07/schema#","description":"[REFERRAL] user selected the friends tab on the your invites page (Guests tab for hosts)","properties":{"id":{"$id":"/properties/id","description":"","type":"string"}},"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserSwitchedToFriendsInviteWithinTrackInvitesPage', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserSwitchedToHostsInviteWithinTrackInvitesPage' track call.
 *
 * @param UserSwitchedToHostsInviteWithinTrackInvitesPage props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userSwitchedToHostsInviteWithinTrackInvitesPage(props: UserSwitchedToHostsInviteWithinTrackInvitesPage, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserSwitchedToHostsInviteWithinTrackInvitesPage","$schema":"http://json-schema.org/draft-07/schema#","description":"[REFERRAL] user selected the host tab on the your invites page","properties":{"id":{"$id":"/properties/id","description":"","type":"string"}},"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserSwitchedToHostsInviteWithinTrackInvitesPage', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserUpdatedFilters' track call.
 *
 * @param UserUpdatedFilters props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userUpdatedFilters(props: UserUpdatedFilters, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserUpdatedFilters","$schema":"http://json-schema.org/draft-07/schema#","description":"[SEARCH] the user updated a filter","properties":{"updatedFilterName":{"$id":"/properties/updatedFilterName","description":"the name of the filter selected ie \"price\"","type":"string"},"updatedFilterValue":{"$id":"/properties/updatedFilterValue","description":"the value filtered ie \"10\", \"400\"","type":"array"}},"required":["updatedFilterName","updatedFilterValue"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserUpdatedFilters', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserUpdatedPhoneNumber' track call.
 *
 * @param UserUpdatedPhoneNumber props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userUpdatedPhoneNumber(props: UserUpdatedPhoneNumber, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserUpdatedPhoneNumber","$schema":"http://json-schema.org/draft-07/schema#","description":"[USER PROFILE - Account Details] user added a new phone number and pressed update","properties":{"id":{"$id":"/properties/id","description":"","type":"string"}},"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserUpdatedPhoneNumber', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserVerifiedPhoneNumber' track call.
 *
 * @param UserVerifiedPhoneNumber props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userVerifiedPhoneNumber(props: UserVerifiedPhoneNumber, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserVerifiedPhoneNumber","$schema":"http://json-schema.org/draft-07/schema#","description":"[USER PROFILE - Account Details] user verified their new phone number","properties":{"id":{"$id":"/properties/id","description":"","type":"string"}},"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserVerifiedPhoneNumber', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserViewFormPartyBanner' track call.
 *
 * @param UserViewFormPartyBanner props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userViewFormPartyBanner(props: UserViewFormPartyBanner, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserViewFormPartyBanner","$schema":"http://json-schema.org/draft-07/schema#","description":"[PARTY BANNER] user viewed the form by clicking the party banner","properties":{"id":{"$id":"/properties/id","description":"","type":"string"}},"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserViewFormPartyBanner', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserViewedCozymealBookingAdditions' track call.
 *
 * @param UserViewedCozymealBookingAdditions props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userViewedCozymealBookingAdditions(props: UserViewedCozymealBookingAdditions, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserViewedCozymealBookingAdditions","$schema":"http://json-schema.org/draft-07/schema#","description":"[COZYMEAL] User viewed the Cozymeal catering options page","properties":{"bookingId":{"$id":"/properties/bookingId","description":"","type":"integer"},"cozyMealListingIdsShown":{"$id":"/properties/cozyMealListingIdsShown","description":"","type":"array"},"enteredFrom":{"$id":"/properties/enteredFrom","description":"","enum":["post_booking_pop_up","reservation_details"],"type":"string"},"guestId":{"$id":"/properties/guestId","description":"","type":"integer"},"hostId":{"$id":"/properties/hostId","description":"","type":"integer"},"listingId":{"$id":"/properties/listingId","description":"","type":"integer"}},"required":["enteredFrom","cozyMealListingIdsShown","guestId","hostId","listingId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserViewedCozymealBookingAdditions', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserViewedCozymealBookingAdditionsPopUp' track call.
 *
 * @param UserViewedCozymealBookingAdditionsPopUp props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userViewedCozymealBookingAdditionsPopUp(props: UserViewedCozymealBookingAdditionsPopUp, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserViewedCozymealBookingAdditionsPopUp","$schema":"http://json-schema.org/draft-07/schema#","description":"[COZYMEAL] User viewed the Cozymeal catering post booking pop up","properties":{"bookingId":{"$id":"/properties/bookingId","description":"","type":"integer"},"guestId":{"$id":"/properties/guestId","description":"","type":"integer"},"hostId":{"$id":"/properties/hostId","description":"","type":"integer"},"id":{"$id":"/properties/id","description":"","type":"string"},"listingId":{"$id":"/properties/listingId","description":"","type":"integer"}},"required":["guestId","hostId","listingId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserViewedCozymealBookingAdditionsPopUp', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserViewedMemberProfileFromMessages' track call.
 *
 * @param UserViewedMemberProfileFromMessages props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userViewedMemberProfileFromMessages(props: UserViewedMemberProfileFromMessages, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserViewedMemberProfileFromMessages","$schema":"http://json-schema.org/draft-07/schema#","description":"user pressed to view profile of member in chat","properties":{"associatedUserHasPhoto":{"$id":"/properties/associatedUserHasPhoto","description":"did the profile have a photo","type":"boolean"},"associatedUserHasReviews":{"$id":"/properties/associatedUserHasReviews","description":"did the profile have reviews","type":"boolean"},"associatedUserId":{"$id":"/properties/associatedUserId","description":"user_id of who's profile was viewed","type":"integer"},"associatedUserIsVerified":{"$id":"/properties/associatedUserIsVerified","description":"is the associated user profile verified","type":"boolean"}},"required":["associatedUserId","associatedUserHasPhoto","associatedUserHasReviews","associatedUserIsVerified"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserViewedMemberProfileFromMessages', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserViewedMessage' track call.
 *
 * @param UserViewedMessage props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userViewedMessage(props: UserViewedMessage, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserViewedMessage","$schema":"http://json-schema.org/draft-07/schema#","description":"User viewed an unread message. Replaces current \"ViewedMessage\" api event. Also an API event","properties":{"lastAssociatedBookingCurrency":{"$id":"/properties/lastAssociatedBookingCurrency","description":"the payment currency of the last booking associated between this user and the recipient, if any","type":"string"},"lastAssociatedBookingDate":{"$id":"/properties/lastAssociatedBookingDate","description":"the date of the last booking associated between this user and the recipient, if any","type":"string"},"lastAssociatedBookingEndTime":{"$id":"/properties/lastAssociatedBookingEndTime","description":"the end time of the last booking associated between this user and the recipient, if any","type":"number"},"lastAssociatedBookingGuestId":{"$id":"/properties/lastAssociatedBookingGuestId","description":"the guest_id of the last booking associated between this user and the recipient, if any","type":"integer"},"lastAssociatedBookingHostId":{"$id":"/properties/lastAssociatedBookingHostId","description":"the host_id of the last booking associated between this user and the recipient, if any","type":"integer"},"lastAssociatedBookingId":{"$id":"/properties/lastAssociatedBookingId","description":"the id of the last booking associated between this user and the recipient, if any","type":"integer"},"lastAssociatedBookingListingId":{"$id":"/properties/lastAssociatedBookingListingId","description":"the listing id of the last booking associated between this user and the recipient, if any","type":"integer"},"lastAssociatedBookingListingPhotoURL":{"$id":"/properties/lastAssociatedBookingListingPhotoURL","description":"the listing id photo url of the last booking associated between this user and the recipient, if any","type":"string"},"lastAssociatedBookingListingType":{"$id":"/properties/lastAssociatedBookingListingType","description":"the listing type of the last booking associated between this user and the recipient, if any","type":"string"},"lastAssociatedBookingNumGuests":{"$id":"/properties/lastAssociatedBookingNumGuests","description":"the num guests of the last booking associated between this user and the recipient, if any","type":"integer"},"lastAssociatedBookingStartTime":{"$id":"/properties/lastAssociatedBookingStartTime","description":"the start time of the last booking associated between this user and the recipient, if any","type":"number"},"lastAssociatedBookingStatus":{"$id":"/properties/lastAssociatedBookingStatus","description":"the status of the last booking associated between this user and the recipient, if any","type":"string"},"lastAssociatedBookingTotal":{"$id":"/properties/lastAssociatedBookingTotal","description":"the payment total of the last booking associated between this user and the recipient, if any","type":"number"},"messageText":{"$id":"/properties/messageText","description":"sent message text","type":["string","null"]},"messageViewedId":{"$id":"/properties/messageViewedId","description":"id of the message viewed","type":"string"},"recipientFirstName":{"$id":"/properties/recipientFirstName","description":"first name of message recipient","type":"string"},"recipientProfilePhotoURL":{"$id":"/properties/recipientProfilePhotoURL","description":"profile photo url of message recipient","type":"string"},"recipientUserId":{"$id":"/properties/recipientUserId","description":"user_id of message recipient","type":"integer"},"roomId":{"$id":"/properties/roomId","description":"room_id for the message thread","type":"string"},"senderFirstName":{"$id":"/properties/senderFirstName","description":"first name of message sender","type":"string"},"senderLastName":{"$id":"/properties/senderLastName","description":"last name of message sender","type":"string"},"senderProfilePhotoURL":{"$id":"/properties/senderProfilePhotoURL","description":"profile photo url of message sender","type":"string"},"senderUserId":{"$id":"/properties/senderUserId","description":"userId of message sender","type":"number"}},"required":["senderFirstName","senderUserId","recipientProfilePhotoURL","senderLastName","recipientUserId","recipientFirstName","senderProfilePhotoURL","roomId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserViewedMessage', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserViewedMessageTab' track call.
 *
 * @param UserViewedMessageTab props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userViewedMessageTab(props: UserViewedMessageTab, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserViewedMessageTab","$schema":"http://json-schema.org/draft-07/schema#","description":"user viewed the message tab","properties":{"enteredFrom":{"$id":"/properties/enteredFrom","description":"how did the user get to the message tab","type":"string"},"viewedAsRole":{"$id":"/properties/viewedAsRole","description":"viewed as host or guest","type":"string"}},"required":["enteredFrom","viewedAsRole"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserViewedMessageTab', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserViewedWeather' track call.
 *
 * @param UserViewedWeather props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userViewedWeather(props: UserViewedWeather, options?: Options, callback?: Callback): void {

    const schema = {"$id":"UserViewedWeather","$schema":"http://json-schema.org/draft-07/schema#","description":"[SEARCH] displayed weather widget in search","properties":{"temperatureDisplayedFahrenheit":{"$id":"/properties/temperatureDisplayedFahrenheit","description":"degree of weather displayed","type":"number"},"viewedFrom":{"$id":"/properties/viewedFrom","description":"where was this weather info displayed","enum":["categoriesSearchBar","dateSelectionToday","dateSelectionTomorrow","hostDashboard"],"type":"string"},"weatherTypeDisplayed":{"$id":"/properties/weatherTypeDisplayed","description":"string category of weather type displayed (sunny, cloudy, etc)","type":["string","null"]}},"required":["viewedFrom","temperatureDisplayedFahrenheit","weatherTypeDisplayed"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('UserViewedWeather', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'ViewedListing' track call.
 *
 * @param ViewedListing props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function viewedListing(props: ViewedListing, options?: Options, callback?: Callback): void {

    const schema = {"$id":"ViewedListing","$schema":"http://json-schema.org/draft-07/schema#","description":"[PLP] user entered PLP","properties":{"amountOff":{"$id":"/properties/amountOff","description":"if the listing has an active deal, what percent amount off of this promo code (1-100)\n","type":["number","null"]},"city":{"$id":"/properties/city","description":"city of the listing","type":"string"},"coverImageUrl":{"$id":"/properties/coverImageUrl","description":"the url of the listing cover image ","type":"string"},"expireDate":{"$id":"/properties/expireDate","description":"if the listing has an active deal, when is the expiration\n","type":["string","null"]},"globalListingType":{"$id":"/properties/globalListingType","description":"[LISTING TYPE] The type of the listing associated with this event","enum":["artStudio","basketballCourt","dockedBoat","home","homeGym","joyspace","kitchen","largeBackyard","musicStudio","other","pending","pickleball","pool","privateLake","roofDeck","tennisCourt"],"type":"string"},"hasActivePass":{"$id":"/properties/hasActivePass","description":"does the listing have an active pass","type":"boolean"},"hasDeal":{"$id":"/properties/hasDeal","description":"does the listing have a currently active deal (1 - yes, 0 - no)\n","type":"boolean"},"hasPass":{"$id":"/properties/hasPass","description":"whether the listings has passes available (1 if true, 0 if false)","type":"boolean"},"hasPassUpsellDisplayed":{"$id":"/properties/hasPassUpsellDisplayed","description":"does the listing have a pass upsell displayed","type":"boolean"},"listingId":{"$id":"/properties/listingId","description":"the id of the listing","type":"string"},"passIds":{"$id":"/properties/passIds","description":"if the listing has one or more active passes, list the pass ids in an array","type":["array","null"]},"passTypes":{"$id":"/properties/passTypes","description":"the types of passes available for a listing - null if it doesn't have any","type":["array","null"]},"passUpsellCreditAmountOffer":{"$id":"/properties/passUpsellCreditAmountOffer","description":"If the guest is shown an expiring discount towards the pass purchase, how much is it for (null if it's expired or not sh...\n","type":"number"},"price":{"$id":"/properties/price","description":"displayed price of the listing","type":"number"},"priceType":{"$id":"/properties/priceType","description":"the format of the price of the listing","enum":["base_tier_daily_price","base_tier_hourly_price"],"type":"string"},"state":{"$id":"/properties/state","description":"state of the listing","type":"string"}},"required":["hasPass","hasDeal","city","globalListingType","listingId","hasActivePass","state","passTypes","priceType","hasPassUpsellDisplayed","coverImageUrl","price"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('ViewedListing', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}

const clientAPI = {
    /**
     * Updates the run-time configuration of this Typewriter client.
     *
     * @param {TypewriterOptions} options - the options to upsert
     *
     * @typedef {Object} TypewriterOptions
     * @property {AnyAnalytics} [analytics] - Underlying analytics instance where analytics
     * 		calls are forwarded on to. Defaults to window.analytics.
     * @property {Function} [onViolation] - Handler fired when if an event does not match its spec. This handler does not fire in
     * 		production mode, because it requires inlining the full JSON Schema spec for each event in your Tracking Plan. By default,
     * 		it will throw errors if NODE_ENV="test" so that tests will fail if a message does not match the spec. Otherwise, errors
     * 		will be logged to stderr.
     */
    setTypewriterOptions,

    /**
     * Fires a 'AccountDeletionUserPressedConfirmCancellation' track call.
     *
     * @param AccountDeletionUserPressedConfirmCancellation props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    accountDeletionUserPressedConfirmCancellation,
    /**
     * Fires a 'AccountDeletionUserPressedContactSupport' track call.
     *
     * @param AccountDeletionUserPressedContactSupport props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    accountDeletionUserPressedContactSupport,
    /**
     * Fires a 'AccountDeletionUserViewedPrivacyPolicy' track call.
     *
     * @param AccountDeletionUserViewedPrivacyPolicy props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    accountDeletionUserViewedPrivacyPolicy,
    /**
     * Fires a 'BecomeAHostPopupSubmission' track call.
     *
     * @param BecomeAHostPopupSubmission props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    becomeAHostPopupSubmission,
    /**
     * Fires a 'BecomeAHostPopupView' track call.
     *
     * @param BecomeAHostPopupView props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    becomeAHostPopupView,
    /**
     * Fires a 'BookingReasonSelected' track call.
     *
     * @param BookingReasonSelected props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    bookingReasonSelected,
    /**
     * Fires a 'DisplayedReferral' track call.
     *
     * @param DisplayedReferral props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    displayedReferral,
    /**
     * Fires a 'DisplayedReferralDetailsHost' track call.
     *
     * @param DisplayedReferralDetailsHost props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    displayedReferralDetailsHost,
    /**
     * Fires a 'DisplayedSharingInvitesOptions' track call.
     *
     * @param DisplayedSharingInvitesOptions props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    displayedSharingInvitesOptions,
    /**
     * Fires a 'FansComposeMessageCTAPressed' track call.
     *
     * @param FansComposeMessageCTAPressed props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    fansComposeMessageCTAPressed,
    /**
     * Fires a 'FansComposeMessageScreenViewed' track call.
     *
     * @param FansComposeMessageScreenViewed props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    fansComposeMessageScreenViewed,
    /**
     * Fires a 'FansInfoBottomSheetViewed' track call.
     *
     * @param FansInfoBottomSheetViewed props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    fansInfoBottomSheetViewed,
    /**
     * Fires a 'FansInfoCTAPressed' track call.
     *
     * @param FansInfoCTAPressed props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    fansInfoCTAPressed,
    /**
     * Fires a 'FansIntroCTAPressed' track call.
     *
     * @param FansIntroCTAPressed props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    fansIntroCTAPressed,
    /**
     * Fires a 'FansMessageSentScreenViewed' track call.
     *
     * @param FansMessageSentScreenViewed props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    fansMessageSentScreenViewed,
    /**
     * Fires a 'FansRulesBottomSheetViewed' track call.
     *
     * @param FansRulesBottomSheetViewed props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    fansRulesBottomSheetViewed,
    /**
     * Fires a 'FansRulesCTAPressed' track call.
     *
     * @param FansRulesCTAPressed props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    fansRulesCTAPressed,
    /**
     * Fires a 'FansSelectBottomSheetViewed' track call.
     *
     * @param FansSelectBottomSheetViewed props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    fansSelectBottomSheetViewed,
    /**
     * Fires a 'FansSelectCTAPressed' track call.
     *
     * @param FansSelectCTAPressed props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    fansSelectCTAPressed,
    /**
     * Fires a 'GuestAcceptReviewChangesFromHost' track call.
     *
     * @param GuestAcceptReviewChangesFromHost props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    guestAcceptReviewChangesFromHost,
    /**
     * Fires a 'GuestConfirmedCancelPass' track call.
     *
     * @param GuestConfirmedCancelPass props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    guestConfirmedCancelPass,
    /**
     * Fires a 'GuestDeclineReviewChangesFromHost' track call.
     *
     * @param GuestDeclineReviewChangesFromHost props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    guestDeclineReviewChangesFromHost,
    /**
     * Fires a 'GuestEnteredOtherCancelReason' track call.
     *
     * @param GuestEnteredOtherCancelReason props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    guestEnteredOtherCancelReason,
    /**
     * Fires a 'GuestExitChangeRequest' track call.
     *
     * @param GuestExitChangeRequest props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    guestExitChangeRequest,
    /**
     * Fires a 'GuestPassHoursUsed' track call.
     *
     * @param GuestPassHoursUsed props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    guestPassHoursUsed,
    /**
     * Fires a 'GuestPassPurchaseFailure' track call.
     *
     * @param GuestPassPurchaseFailure props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    guestPassPurchaseFailure,
    /**
     * Fires a 'GuestPassPurchaseSuccess' track call.
     *
     * @param GuestPassPurchaseSuccess props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    guestPassPurchaseSuccess,
    /**
     * Fires a 'GuestPassRenewed' track call.
     *
     * @param GuestPassRenewed props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    guestPassRenewed,
    /**
     * Fires a 'GuestPressedAcceptAndPay' track call.
     *
     * @param GuestPressedAcceptAndPay props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    guestPressedAcceptAndPay,
    /**
     * Fires a 'GuestPressedAwesomeThanksButton' track call.
     *
     * @param GuestPressedAwesomeThanksButton props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    guestPressedAwesomeThanksButton,
    /**
     * Fires a 'GuestPressedBookingType' track call.
     *
     * @param GuestPressedBookingType props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    guestPressedBookingType,
    /**
     * Fires a 'GuestPressedCancelPassNevermind' track call.
     *
     * @param GuestPressedCancelPassNevermind props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    guestPressedCancelPassNevermind,
    /**
     * Fires a 'GuestPressedCancelPassNext' track call.
     *
     * @param GuestPressedCancelPassNext props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    guestPressedCancelPassNext,
    /**
     * Fires a 'GuestPressedChatFromReservationDetails' track call.
     *
     * @param GuestPressedChatFromReservationDetails props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    guestPressedChatFromReservationDetails,
    /**
     * Fires a 'GuestPressedCloseFlowTrustAndSafety' track call.
     *
     * @param GuestPressedCloseFlowTrustAndSafety props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    guestPressedCloseFlowTrustAndSafety,
    /**
     * Fires a 'GuestPressedCloseThanksForReading' track call.
     *
     * @param GuestPressedCloseThanksForReading props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    guestPressedCloseThanksForReading,
    /**
     * Fires a 'GuestPressedDeclineSpecialOffer' track call.
     *
     * @param GuestPressedDeclineSpecialOffer props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    guestPressedDeclineSpecialOffer,
    /**
     * Fires a 'GuestPressedEditAmenities' track call.
     *
     * @param GuestPressedEditAmenities props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    guestPressedEditAmenities,
    /**
     * Fires a 'GuestPressedExtendReservationLiveBooking' track call.
     *
     * @param GuestPressedExtendReservationLiveBooking props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    guestPressedExtendReservationLiveBooking,
    /**
     * Fires a 'GuestPressedInitiateRefundRequest' track call.
     *
     * @param GuestPressedInitiateRefundRequest props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    guestPressedInitiateRefundRequest,
    /**
     * Fires a 'GuestPressedLearnMorePassOnboarding' track call.
     *
     * @param GuestPressedLearnMorePassOnboarding props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    guestPressedLearnMorePassOnboarding,
    /**
     * Fires a 'GuestPressedManagePass' track call.
     *
     * @param GuestPressedManagePass props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    guestPressedManagePass,
    /**
     * Fires a 'GuestPressedManagePassCancelPass' track call.
     *
     * @param GuestPressedManagePassCancelPass props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    guestPressedManagePassCancelPass,
    /**
     * Fires a 'GuestPressedManagePassContactSupport' track call.
     *
     * @param GuestPressedManagePassContactSupport props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    guestPressedManagePassContactSupport,
    /**
     * Fires a 'GuestPressedManagePassMessageHost' track call.
     *
     * @param GuestPressedManagePassMessageHost props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    guestPressedManagePassMessageHost,
    /**
     * Fires a 'GuestPressedManagePassPurchaseHistory' track call.
     *
     * @param GuestPressedManagePassPurchaseHistory props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    guestPressedManagePassPurchaseHistory,
    /**
     * Fires a 'GuestPressedManagePassTurnOffAutoRenew' track call.
     *
     * @param GuestPressedManagePassTurnOffAutoRenew props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    guestPressedManagePassTurnOffAutoRenew,
    /**
     * Fires a 'GuestPressedManagePassTurnOnAutoRenew' track call.
     *
     * @param GuestPressedManagePassTurnOnAutoRenew props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    guestPressedManagePassTurnOnAutoRenew,
    /**
     * Fires a 'GuestPressedManagePassViewBookings' track call.
     *
     * @param GuestPressedManagePassViewBookings props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    guestPressedManagePassViewBookings,
    /**
     * Fires a 'GuestPressedManagePasses' track call.
     *
     * @param GuestPressedManagePasses props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    guestPressedManagePasses,
    /**
     * Fires a 'GuestPressedNextPageTrustAndSafety' track call.
     *
     * @param GuestPressedNextPageTrustAndSafety props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    guestPressedNextPageTrustAndSafety,
    /**
     * Fires a 'GuestPressedNextPassOnboarding' track call.
     *
     * @param GuestPressedNextPassOnboarding props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    guestPressedNextPassOnboarding,
    /**
     * Fires a 'GuestPressedPurchasePass' track call.
     *
     * @param GuestPressedPurchasePass props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    guestPressedPurchasePass,
    /**
     * Fires a 'GuestPressedReadGuideButton' track call.
     *
     * @param GuestPressedReadGuideButton props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    guestPressedReadGuideButton,
    /**
     * Fires a 'GuestPressedRequestChanges' track call.
     *
     * @param GuestPressedRequestChanges props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    guestPressedRequestChanges,
    /**
     * Fires a 'GuestPressedReservation' track call.
     *
     * @param GuestPressedReservation props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    guestPressedReservation,
    /**
     * Fires a 'GuestPressedReviewChangesFromHost' track call.
     *
     * @param GuestPressedReviewChangesFromHost props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    guestPressedReviewChangesFromHost,
    /**
     * Fires a 'GuestPressedSecurityDepositLearnMore' track call.
     *
     * @param GuestPressedSecurityDepositLearnMore props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    guestPressedSecurityDepositLearnMore,
    /**
     * Fires a 'GuestPressedSecurityDepositLearnMoreExit' track call.
     *
     * @param GuestPressedSecurityDepositLearnMoreExit props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    guestPressedSecurityDepositLearnMoreExit,
    /**
     * Fires a 'GuestPressedSeeHostRules' track call.
     *
     * @param GuestPressedSeeHostRules props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    guestPressedSeeHostRules,
    /**
     * Fires a 'GuestPressedSeeParkingDetails' track call.
     *
     * @param GuestPressedSeeParkingDetails props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    guestPressedSeeParkingDetails,
    /**
     * Fires a 'GuestPressedStartExploringPasses' track call.
     *
     * @param GuestPressedStartExploringPasses props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    guestPressedStartExploringPasses,
    /**
     * Fires a 'GuestPressedSwimplyPromiseBanner' track call.
     *
     * @param GuestPressedSwimplyPromiseBanner props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    guestPressedSwimplyPromiseBanner,
    /**
     * Fires a 'GuestPressedToConfirmBookingEdit' track call.
     *
     * @param GuestPressedToConfirmBookingEdit props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    guestPressedToConfirmBookingEdit,
    /**
     * Fires a 'GuestPressedToConfirmCancellation' track call.
     *
     * @param GuestPressedToConfirmCancellation props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    guestPressedToConfirmCancellation,
    /**
     * Fires a 'GuestPressedToEnterFavoriteList' track call.
     *
     * @param GuestPressedToEnterFavoriteList props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    guestPressedToEnterFavoriteList,
    /**
     * Fires a 'GuestPressedToShowPriceDetails' track call.
     *
     * @param GuestPressedToShowPriceDetails props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    guestPressedToShowPriceDetails,
    /**
     * Fires a 'GuestPressedViewAndAcceptOfferThread' track call.
     *
     * @param GuestPressedViewAndAcceptOfferThread props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    guestPressedViewAndAcceptOfferThread,
    /**
     * Fires a 'GuestPressedViewReservation' track call.
     *
     * @param GuestPressedViewReservation props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    guestPressedViewReservation,
    /**
     * Fires a 'GuestPressedViewSpecialOfferMessages' track call.
     *
     * @param GuestPressedViewSpecialOfferMessages props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    guestPressedViewSpecialOfferMessages,
    /**
     * Fires a 'GuestReservationCancellationPressedReschedule' track call.
     *
     * @param GuestReservationCancellationPressedReschedule props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    guestReservationCancellationPressedReschedule,
    /**
     * Fires a 'GuestReservationEditBookingDateTime' track call.
     *
     * @param GuestReservationEditBookingDateTime props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    guestReservationEditBookingDateTime,
    /**
     * Fires a 'GuestReservationPressedContactHost' track call.
     *
     * @param GuestReservationPressedContactHost props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    guestReservationPressedContactHost,
    /**
     * Fires a 'GuestReservationPressedContactSupport' track call.
     *
     * @param GuestReservationPressedContactSupport props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    guestReservationPressedContactSupport,
    /**
     * Fires a 'GuestReservationPressedEditGuest' track call.
     *
     * @param GuestReservationPressedEditGuest props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    guestReservationPressedEditGuest,
    /**
     * Fires a 'GuestReservationPressedMakeChange' track call.
     *
     * @param GuestReservationPressedMakeChange props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    guestReservationPressedMakeChange,
    /**
     * Fires a 'GuestReservationPressedPayExtendedHour' track call.
     *
     * @param GuestReservationPressedPayExtendedHour props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    guestReservationPressedPayExtendedHour,
    /**
     * Fires a 'GuestReservationPressedToContinueCancel' track call.
     *
     * @param GuestReservationPressedToContinueCancel props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    guestReservationPressedToContinueCancel,
    /**
     * Fires a 'GuestReservationPressedToEnterCancellation' track call.
     *
     * @param GuestReservationPressedToEnterCancellation props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    guestReservationPressedToEnterCancellation,
    /**
     * Fires a 'GuestReservationPressedViewHostCancelPolicy' track call.
     *
     * @param GuestReservationPressedViewHostCancelPolicy props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    guestReservationPressedViewHostCancelPolicy,
    /**
     * Fires a 'GuestReservationSaveChangeAmenities' track call.
     *
     * @param GuestReservationSaveChangeAmenities props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    guestReservationSaveChangeAmenities,
    /**
     * Fires a 'GuestReservationSaveChangeDateTime' track call.
     *
     * @param GuestReservationSaveChangeDateTime props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    guestReservationSaveChangeDateTime,
    /**
     * Fires a 'GuestReservationSaveChangeGuest' track call.
     *
     * @param GuestReservationSaveChangeGuest props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    guestReservationSaveChangeGuest,
    /**
     * Fires a 'GuestReservationSelectedCancelReason' track call.
     *
     * @param GuestReservationSelectedCancelReason props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    guestReservationSelectedCancelReason,
    /**
     * Fires a 'GuestSelectFavoriteList' track call.
     *
     * @param GuestSelectFavoriteList props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    guestSelectFavoriteList,
    /**
     * Fires a 'GuestSelectedRefundType' track call.
     *
     * @param GuestSelectedRefundType props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    guestSelectedRefundType,
    /**
     * Fires a 'GuestSubmittedRefundRequest' track call.
     *
     * @param GuestSubmittedRefundRequest props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    guestSubmittedRefundRequest,
    /**
     * Fires a 'GuestSubmittedSendRequestWithNote' track call.
     *
     * @param GuestSubmittedSendRequestWithNote props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    guestSubmittedSendRequestWithNote,
    /**
     * Fires a 'HostAddedPromotionToListing' track call.
     *
     * @param HostAddedPromotionToListing props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostAddedPromotionToListing,
    /**
     * Fires a 'HostAdditionalPoolDetailsEntered' track call.
     *
     * @param HostAdditionalPoolDetailsEntered props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostAdditionalPoolDetailsEntered,
    /**
     * Fires a 'HostAgreeNeighborGuidelines' track call.
     *
     * @param HostAgreeNeighborGuidelines props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostAgreeNeighborGuidelines,
    /**
     * Fires a 'HostAmenitiesAdded' track call.
     *
     * @param HostAmenitiesAdded props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostAmenitiesAdded,
    /**
     * Fires a 'HostAmenitiesEntered' track call.
     *
     * @param HostAmenitiesEntered props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostAmenitiesEntered,
    /**
     * Fires a 'HostAvailabilitySettingPressedAdvancedSetting' track call.
     *
     * @param HostAvailabilitySettingPressedAdvancedSetting props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostAvailabilitySettingPressedAdvancedSetting,
    /**
     * Fires a 'HostAvailabilitySettingPressedDoneAdvancedSetting' track call.
     *
     * @param HostAvailabilitySettingPressedDoneAdvancedSetting props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostAvailabilitySettingPressedDoneAdvancedSetting,
    /**
     * Fires a 'HostAvailabilitySettingPressedDoneGeneralSetting' track call.
     *
     * @param HostAvailabilitySettingPressedDoneGeneralSetting props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostAvailabilitySettingPressedDoneGeneralSetting,
    /**
     * Fires a 'HostAvailabilitySettingPressedDoneListingStatus' track call.
     *
     * @param HostAvailabilitySettingPressedDoneListingStatus props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostAvailabilitySettingPressedDoneListingStatus,
    /**
     * Fires a 'HostAvailabilitySettingPressedGeneralSetting' track call.
     *
     * @param HostAvailabilitySettingPressedGeneralSetting props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostAvailabilitySettingPressedGeneralSetting,
    /**
     * Fires a 'HostAvailabilitySettingPressedListingStatus' track call.
     *
     * @param HostAvailabilitySettingPressedListingStatus props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostAvailabilitySettingPressedListingStatus,
    /**
     * Fires a 'HostAvailabilitySettingPressedSyncCals' track call.
     *
     * @param HostAvailabilitySettingPressedSyncCals props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostAvailabilitySettingPressedSyncCals,
    /**
     * Fires a 'HostAvailabilitySettingPressedUnavailabilityRules' track call.
     *
     * @param HostAvailabilitySettingPressedUnavailabilityRules props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostAvailabilitySettingPressedUnavailabilityRules,
    /**
     * Fires a 'HostBookingCancellationPolicy' track call.
     *
     * @param HostBookingCancellationPolicy props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostBookingCancellationPolicy,
    /**
     * Fires a 'HostBookingHostPrivacy' track call.
     *
     * @param HostBookingHostPrivacy props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostBookingHostPrivacy,
    /**
     * Fires a 'HostBookingRequestReview' track call.
     *
     * @param HostBookingRequestReview props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostBookingRequestReview,
    /**
     * Fires a 'HostBookingRules' track call.
     *
     * @param HostBookingRules props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostBookingRules,
    /**
     * Fires a 'HostCalSyncPressedExportCalendar' track call.
     *
     * @param HostCalSyncPressedExportCalendar props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostCalSyncPressedExportCalendar,
    /**
     * Fires a 'HostCalSyncPressedImportCalendar' track call.
     *
     * @param HostCalSyncPressedImportCalendar props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostCalSyncPressedImportCalendar,
    /**
     * Fires a 'HostCalSyncPressedManageCronofy' track call.
     *
     * @param HostCalSyncPressedManageCronofy props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostCalSyncPressedManageCronofy,
    /**
     * Fires a 'HostCalSyncPressedManageImportedCal' track call.
     *
     * @param HostCalSyncPressedManageImportedCal props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostCalSyncPressedManageImportedCal,
    /**
     * Fires a 'HostCalSyncPressedSyncWCronofy' track call.
     *
     * @param HostCalSyncPressedSyncWCronofy props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostCalSyncPressedSyncWCronofy,
    /**
     * Fires a 'HostCalendarApplyDiscountOrBoost' track call.
     *
     * @param HostCalendarApplyDiscountOrBoost props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostCalendarApplyDiscountOrBoost,
    /**
     * Fires a 'HostCalendarBottomCardAdjustedStatus' track call.
     *
     * @param HostCalendarBottomCardAdjustedStatus props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostCalendarBottomCardAdjustedStatus,
    /**
     * Fires a 'HostCalendarClearDiscountOrBoost' track call.
     *
     * @param HostCalendarClearDiscountOrBoost props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostCalendarClearDiscountOrBoost,
    /**
     * Fires a 'HostCalendarCloseApplyDiscountOrBoost' track call.
     *
     * @param HostCalendarCloseApplyDiscountOrBoost props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostCalendarCloseApplyDiscountOrBoost,
    /**
     * Fires a 'HostCalendarCloseClearDiscountOrBoost' track call.
     *
     * @param HostCalendarCloseClearDiscountOrBoost props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostCalendarCloseClearDiscountOrBoost,
    /**
     * Fires a 'HostCalendarCloseScheduleConflict' track call.
     *
     * @param HostCalendarCloseScheduleConflict props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostCalendarCloseScheduleConflict,
    /**
     * Fires a 'HostCalendarConfirmClearDiscountOrBoost' track call.
     *
     * @param HostCalendarConfirmClearDiscountOrBoost props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostCalendarConfirmClearDiscountOrBoost,
    /**
     * Fires a 'HostCalendarNoTierPricePressedSetDiscountOrBoost' track call.
     *
     * @param HostCalendarNoTierPricePressedSetDiscountOrBoost props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostCalendarNoTierPricePressedSetDiscountOrBoost,
    /**
     * Fires a 'HostCalendarNoTierPricePressedUpdatePrices' track call.
     *
     * @param HostCalendarNoTierPricePressedUpdatePrices props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostCalendarNoTierPricePressedUpdatePrices,
    /**
     * Fires a 'HostCalendarPressedApplyBlockScheduleConflict' track call.
     *
     * @param HostCalendarPressedApplyBlockScheduleConflict props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostCalendarPressedApplyBlockScheduleConflict,
    /**
     * Fires a 'HostCalendarPressedAvailability' track call.
     *
     * @param HostCalendarPressedAvailability props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostCalendarPressedAvailability,
    /**
     * Fires a 'HostCalendarPressedConfirmBlockedHour' track call.
     *
     * @param HostCalendarPressedConfirmBlockedHour props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostCalendarPressedConfirmBlockedHour,
    /**
     * Fires a 'HostCalendarPressedEditDiscountorBoost' track call.
     *
     * @param HostCalendarPressedEditDiscountorBoost props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostCalendarPressedEditDiscountorBoost,
    /**
     * Fires a 'HostCalendarPressedExitManageDate' track call.
     *
     * @param HostCalendarPressedExitManageDate props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostCalendarPressedExitManageDate,
    /**
     * Fires a 'HostCalendarPressedManageGeneralAvailability' track call.
     *
     * @param HostCalendarPressedManageGeneralAvailability props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostCalendarPressedManageGeneralAvailability,
    /**
     * Fires a 'HostCalendarPressedManageSelectDates' track call.
     *
     * @param HostCalendarPressedManageSelectDates props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostCalendarPressedManageSelectDates,
    /**
     * Fires a 'HostCalendarPressedPrice' track call.
     *
     * @param HostCalendarPressedPrice props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostCalendarPressedPrice,
    /**
     * Fires a 'HostCalendarPressedRemoveBlock' track call.
     *
     * @param HostCalendarPressedRemoveBlock props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostCalendarPressedRemoveBlock,
    /**
     * Fires a 'HostCalendarPressedSetDiscountOrBoost' track call.
     *
     * @param HostCalendarPressedSetDiscountOrBoost props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostCalendarPressedSetDiscountOrBoost,
    /**
     * Fires a 'HostCalendarRemoveSelectedDates' track call.
     *
     * @param HostCalendarRemoveSelectedDates props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostCalendarRemoveSelectedDates,
    /**
     * Fires a 'HostCalendarSelectedDate' track call.
     *
     * @param HostCalendarSelectedDate props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostCalendarSelectedDate,
    /**
     * Fires a 'HostCalendarViewReservationScheduleConflict' track call.
     *
     * @param HostCalendarViewReservationScheduleConflict props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostCalendarViewReservationScheduleConflict,
    /**
     * Fires a 'HostCancelledSpecialOffer' track call.
     *
     * @param HostCancelledSpecialOffer props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostCancelledSpecialOffer,
    /**
     * Fires a 'HostConfirmedDeactivatePass' track call.
     *
     * @param HostConfirmedDeactivatePass props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostConfirmedDeactivatePass,
    /**
     * Fires a 'HostConfirmedRefundPassholder' track call.
     *
     * @param HostConfirmedRefundPassholder props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostConfirmedRefundPassholder,
    /**
     * Fires a 'HostDeletedReviewReply' track call.
     *
     * @param HostDeletedReviewReply props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostDeletedReviewReply,
    /**
     * Fires a 'HostEarningHistChangedStartDate' track call.
     *
     * @param HostEarningHistChangedStartDate props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostEarningHistChangedStartDate,
    /**
     * Fires a 'HostEarningHistPressedEndDate' track call.
     *
     * @param HostEarningHistPressedEndDate props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostEarningHistPressedEndDate,
    /**
     * Fires a 'HostEarningHistPressedStartDate' track call.
     *
     * @param HostEarningHistPressedStartDate props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostEarningHistPressedStartDate,
    /**
     * Fires a 'HostEarningHistSwitchTab' track call.
     *
     * @param HostEarningHistSwitchTab props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostEarningHistSwitchTab,
    /**
     * Fires a 'HostEarningsHistChangedEndDate' track call.
     *
     * @param HostEarningsHistChangedEndDate props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostEarningsHistChangedEndDate,
    /**
     * Fires a 'HostEarningsSwitchTab' track call.
     *
     * @param HostEarningsSwitchTab props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostEarningsSwitchTab,
    /**
     * Fires a 'HostEditListingProperty' track call.
     *
     * @param HostEditListingProperty props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostEditListingProperty,
    /**
     * Fires a 'HostEnteredFlatRatePrice' track call.
     *
     * @param HostEnteredFlatRatePrice props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostEnteredFlatRatePrice,
    /**
     * Fires a 'HostEnteredFullDayPrice' track call.
     *
     * @param HostEnteredFullDayPrice props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostEnteredFullDayPrice,
    /**
     * Fires a 'HostExitChangeRequestNeverMind' track call.
     *
     * @param HostExitChangeRequestNeverMind props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostExitChangeRequestNeverMind,
    /**
     * Fires a 'HostGetVerifiedPressAddressUpload' track call.
     *
     * @param HostGetVerifiedPressAddressUpload props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostGetVerifiedPressAddressUpload,
    /**
     * Fires a 'HostGetVerifiedPressAddressVerif' track call.
     *
     * @param HostGetVerifiedPressAddressVerif props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostGetVerifiedPressAddressVerif,
    /**
     * Fires a 'HostGetVerifiedPressIDUpload' track call.
     *
     * @param HostGetVerifiedPressIDUpload props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostGetVerifiedPressIDUpload,
    /**
     * Fires a 'HostGetVerifiedPressIDVerif' track call.
     *
     * @param HostGetVerifiedPressIDVerif props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostGetVerifiedPressIDVerif,
    /**
     * Fires a 'HostGetVerifiedSubmitAddressUpload' track call.
     *
     * @param HostGetVerifiedSubmitAddressUpload props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostGetVerifiedSubmitAddressUpload,
    /**
     * Fires a 'HostGetVerifiedSubmitIDUpload' track call.
     *
     * @param HostGetVerifiedSubmitIDUpload props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostGetVerifiedSubmitIDUpload,
    /**
     * Fires a 'HostHowSwimplyWorks' track call.
     *
     * @param HostHowSwimplyWorks props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostHowSwimplyWorks,
    /**
     * Fires a 'HostInitialCourtDetailsEntered' track call.
     *
     * @param HostInitialCourtDetailsEntered props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostInitialCourtDetailsEntered,
    /**
     * Fires a 'HostInitialHomeDetailsEntered' track call.
     *
     * @param HostInitialHomeDetailsEntered props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostInitialHomeDetailsEntered,
    /**
     * Fires a 'HostInitialPoolDetailsEntered' track call.
     *
     * @param HostInitialPoolDetailsEntered props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostInitialPoolDetailsEntered,
    /**
     * Fires a 'HostLeadAddressConfirmation' track call.
     *
     * @param HostLeadAddressConfirmation props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostLeadAddressConfirmation,
    /**
     * Fires a 'HostLeadLocationEntered' track call.
     *
     * @param HostLeadLocationEntered props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostLeadLocationEntered,
    /**
     * Fires a 'HostMarketingCloseFansMessages' track call.
     *
     * @param HostMarketingCloseFansMessages props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostMarketingCloseFansMessages,
    /**
     * Fires a 'HostMarketingCloseInviteFriends' track call.
     *
     * @param HostMarketingCloseInviteFriends props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostMarketingCloseInviteFriends,
    /**
     * Fires a 'HostMarketingPressedCloseTips' track call.
     *
     * @param HostMarketingPressedCloseTips props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostMarketingPressedCloseTips,
    /**
     * Fires a 'HostMarketingPressedFansCard' track call.
     *
     * @param HostMarketingPressedFansCard props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostMarketingPressedFansCard,
    /**
     * Fires a 'HostMarketingPressedInviteFriends' track call.
     *
     * @param HostMarketingPressedInviteFriends props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostMarketingPressedInviteFriends,
    /**
     * Fires a 'HostMarketingPressedInviteFriendsCard' track call.
     *
     * @param HostMarketingPressedInviteFriendsCard props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostMarketingPressedInviteFriendsCard,
    /**
     * Fires a 'HostMarketingPressedMessageFans' track call.
     *
     * @param HostMarketingPressedMessageFans props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostMarketingPressedMessageFans,
    /**
     * Fires a 'HostMarketingPressedTips' track call.
     *
     * @param HostMarketingPressedTips props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostMarketingPressedTips,
    /**
     * Fires a 'HostMarketingSwitchTipsCarousel' track call.
     *
     * @param HostMarketingSwitchTipsCarousel props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostMarketingSwitchTipsCarousel,
    /**
     * Fires a 'HostPerfCancelChangeTimeRange' track call.
     *
     * @param HostPerfCancelChangeTimeRange props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostPerfCancelChangeTimeRange,
    /**
     * Fires a 'HostPerfOverviewSwitchTimeRange' track call.
     *
     * @param HostPerfOverviewSwitchTimeRange props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostPerfOverviewSwitchTimeRange,
    /**
     * Fires a 'HostPerfPressedClosePerfTips' track call.
     *
     * @param HostPerfPressedClosePerfTips props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostPerfPressedClosePerfTips,
    /**
     * Fires a 'HostPerfPressedEarnings' track call.
     *
     * @param HostPerfPressedEarnings props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostPerfPressedEarnings,
    /**
     * Fires a 'HostPerfPressedFanFavoriteFAQ' track call.
     *
     * @param HostPerfPressedFanFavoriteFAQ props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostPerfPressedFanFavoriteFAQ,
    /**
     * Fires a 'HostPerfPressedInfoIconScores' track call.
     *
     * @param HostPerfPressedInfoIconScores props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostPerfPressedInfoIconScores,
    /**
     * Fires a 'HostPerfPressedInfoIconTips' track call.
     *
     * @param HostPerfPressedInfoIconTips props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostPerfPressedInfoIconTips,
    /**
     * Fires a 'HostPerfPressedLeaveReply' track call.
     *
     * @param HostPerfPressedLeaveReply props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostPerfPressedLeaveReply,
    /**
     * Fires a 'HostPerfPressedManageListings' track call.
     *
     * @param HostPerfPressedManageListings props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostPerfPressedManageListings,
    /**
     * Fires a 'HostPerfPressedPerfTips' track call.
     *
     * @param HostPerfPressedPerfTips props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostPerfPressedPerfTips,
    /**
     * Fires a 'HostPerfPressedSeeAllReviews' track call.
     *
     * @param HostPerfPressedSeeAllReviews props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostPerfPressedSeeAllReviews,
    /**
     * Fires a 'HostPerfSwitchDashboard' track call.
     *
     * @param HostPerfSwitchDashboard props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostPerfSwitchDashboard,
    /**
     * Fires a 'HostPerfSwitchPerfTipsCarousel' track call.
     *
     * @param HostPerfSwitchPerfTipsCarousel props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostPerfSwitchPerfTipsCarousel,
    /**
     * Fires a 'HostPerfSwitchReviewCarousel' track call.
     *
     * @param HostPerfSwitchReviewCarousel props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostPerfSwitchReviewCarousel,
    /**
     * Fires a 'HostPoolAvailability' track call.
     *
     * @param HostPoolAvailability props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostPoolAvailability,
    /**
     * Fires a 'HostPoolAvailabilityAdvancedSettings' track call.
     *
     * @param HostPoolAvailabilityAdvancedSettings props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostPoolAvailabilityAdvancedSettings,
    /**
     * Fires a 'HostPoolAvailabilityDatesExcluded' track call.
     *
     * @param HostPoolAvailabilityDatesExcluded props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostPoolAvailabilityDatesExcluded,
    /**
     * Fires a 'HostPoolDimensions' track call.
     *
     * @param HostPoolDimensions props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostPoolDimensions,
    /**
     * Fires a 'HostPoolGuestInformation' track call.
     *
     * @param HostPoolGuestInformation props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostPoolGuestInformation,
    /**
     * Fires a 'HostPoolPricingEntered' track call.
     *
     * @param HostPoolPricingEntered props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostPoolPricingEntered,
    /**
     * Fires a 'HostPoolProfileAdded' track call.
     *
     * @param HostPoolProfileAdded props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostPoolProfileAdded,
    /**
     * Fires a 'HostPoolReview' track call.
     *
     * @param HostPoolReview props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostPoolReview,
    /**
     * Fires a 'HostPressedAbandonCartDiscountGetStarted' track call.
     *
     * @param HostPressedAbandonCartDiscountGetStarted props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostPressedAbandonCartDiscountGetStarted,
    /**
     * Fires a 'HostPressedAcceptReservationRequest' track call.
     *
     * @param HostPressedAcceptReservationRequest props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostPressedAcceptReservationRequest,
    /**
     * Fires a 'HostPressedActivateAbandonCartDiscount' track call.
     *
     * @param HostPressedActivateAbandonCartDiscount props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostPressedActivateAbandonCartDiscount,
    /**
     * Fires a 'HostPressedActivatePass' track call.
     *
     * @param HostPressedActivatePass props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostPressedActivatePass,
    /**
     * Fires a 'HostPressedAddAbandonCartDiscount' track call.
     *
     * @param HostPressedAddAbandonCartDiscount props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostPressedAddAbandonCartDiscount,
    /**
     * Fires a 'HostPressedAddPromotionToListing' track call.
     *
     * @param HostPressedAddPromotionToListing props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostPressedAddPromotionToListing,
    /**
     * Fires a 'HostPressedAddWeekdayDiscount' track call.
     *
     * @param HostPressedAddWeekdayDiscount props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostPressedAddWeekdayDiscount,
    /**
     * Fires a 'HostPressedApproveFromDeclineFlow' track call.
     *
     * @param HostPressedApproveFromDeclineFlow props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostPressedApproveFromDeclineFlow,
    /**
     * Fires a 'HostPressedAwesomeThanksButton' track call.
     *
     * @param HostPressedAwesomeThanksButton props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostPressedAwesomeThanksButton,
    /**
     * Fires a 'HostPressedBackFromWithdrawSpecialOffer' track call.
     *
     * @param HostPressedBackFromWithdrawSpecialOffer props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostPressedBackFromWithdrawSpecialOffer,
    /**
     * Fires a 'HostPressedBackOnCreatingSendSo' track call.
     *
     * @param HostPressedBackOnCreatingSendSo props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostPressedBackOnCreatingSendSo,
    /**
     * Fires a 'HostPressedBlockFromMessages' track call.
     *
     * @param HostPressedBlockFromMessages props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostPressedBlockFromMessages,
    /**
     * Fires a 'HostPressedCalendar' track call.
     *
     * @param HostPressedCalendar props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostPressedCalendar,
    /**
     * Fires a 'HostPressedCancelChangeRequest' track call.
     *
     * @param HostPressedCancelChangeRequest props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostPressedCancelChangeRequest,
    /**
     * Fires a 'HostPressedCancelDeleteReviewReply' track call.
     *
     * @param HostPressedCancelDeleteReviewReply props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostPressedCancelDeleteReviewReply,
    /**
     * Fires a 'HostPressedCancelFromReservationPage' track call.
     *
     * @param HostPressedCancelFromReservationPage props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostPressedCancelFromReservationPage,
    /**
     * Fires a 'HostPressedCancelReschedule' track call.
     *
     * @param HostPressedCancelReschedule props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostPressedCancelReschedule,
    /**
     * Fires a 'HostPressedCancelReviewReply' track call.
     *
     * @param HostPressedCancelReviewReply props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostPressedCancelReviewReply,
    /**
     * Fires a 'HostPressedChatFromReservationDetails' track call.
     *
     * @param HostPressedChatFromReservationDetails props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostPressedChatFromReservationDetails,
    /**
     * Fires a 'HostPressedCloseFlowTrustAndSafety' track call.
     *
     * @param HostPressedCloseFlowTrustAndSafety props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostPressedCloseFlowTrustAndSafety,
    /**
     * Fires a 'HostPressedCloseThanksForReading' track call.
     *
     * @param HostPressedCloseThanksForReading props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostPressedCloseThanksForReading,
    /**
     * Fires a 'HostPressedConfirmPreApproval' track call.
     *
     * @param HostPressedConfirmPreApproval props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostPressedConfirmPreApproval,
    /**
     * Fires a 'HostPressedConnectToInstagram' track call.
     *
     * @param HostPressedConnectToInstagram props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostPressedConnectToInstagram,
    /**
     * Fires a 'HostPressedContactSupportFromReservationPage' track call.
     *
     * @param HostPressedContactSupportFromReservationPage props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostPressedContactSupportFromReservationPage,
    /**
     * Fires a 'HostPressedContinueChangeRequest' track call.
     *
     * @param HostPressedContinueChangeRequest props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostPressedContinueChangeRequest,
    /**
     * Fires a 'HostPressedContinueToCreateSo' track call.
     *
     * @param HostPressedContinueToCreateSo props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostPressedContinueToCreateSo,
    /**
     * Fires a 'HostPressedContinueToSetUpTieredPrice' track call.
     *
     * @param HostPressedContinueToSetUpTieredPrice props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostPressedContinueToSetUpTieredPrice,
    /**
     * Fires a 'HostPressedCreatePromoCode' track call.
     *
     * @param HostPressedCreatePromoCode props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostPressedCreatePromoCode,
    /**
     * Fires a 'HostPressedDeactivateAbandonCartDiscount' track call.
     *
     * @param HostPressedDeactivateAbandonCartDiscount props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostPressedDeactivateAbandonCartDiscount,
    /**
     * Fires a 'HostPressedDeactivatePass' track call.
     *
     * @param HostPressedDeactivatePass props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostPressedDeactivatePass,
    /**
     * Fires a 'HostPressedDeclineReservationRequest' track call.
     *
     * @param HostPressedDeclineReservationRequest props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostPressedDeclineReservationRequest,
    /**
     * Fires a 'HostPressedDeleteImportCalendar' track call.
     *
     * @param HostPressedDeleteImportCalendar props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostPressedDeleteImportCalendar,
    /**
     * Fires a 'HostPressedDeleteReviewReply' track call.
     *
     * @param HostPressedDeleteReviewReply props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostPressedDeleteReviewReply,
    /**
     * Fires a 'HostPressedDeleteVideoTour' track call.
     *
     * @param HostPressedDeleteVideoTour props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostPressedDeleteVideoTour,
    /**
     * Fires a 'HostPressedDisconnectCronofy' track call.
     *
     * @param HostPressedDisconnectCronofy props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostPressedDisconnectCronofy,
    /**
     * Fires a 'HostPressedDisconnectInstagram' track call.
     *
     * @param HostPressedDisconnectInstagram props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostPressedDisconnectInstagram,
    /**
     * Fires a 'HostPressedEditAmenities' track call.
     *
     * @param HostPressedEditAmenities props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostPressedEditAmenities,
    /**
     * Fires a 'HostPressedEditConnectToInstagram' track call.
     *
     * @param HostPressedEditConnectToInstagram props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostPressedEditConnectToInstagram,
    /**
     * Fires a 'HostPressedEditDateTime' track call.
     *
     * @param HostPressedEditDateTime props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostPressedEditDateTime,
    /**
     * Fires a 'HostPressedEditGuest' track call.
     *
     * @param HostPressedEditGuest props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostPressedEditGuest,
    /**
     * Fires a 'HostPressedEditPass' track call.
     *
     * @param HostPressedEditPass props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostPressedEditPass,
    /**
     * Fires a 'HostPressedExportCalendarCopyLink' track call.
     *
     * @param HostPressedExportCalendarCopyLink props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostPressedExportCalendarCopyLink,
    /**
     * Fires a 'HostPressedFileSDClaim' track call.
     *
     * @param HostPressedFileSDClaim props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostPressedFileSDClaim,
    /**
     * Fires a 'HostPressedFileSDClaimExit' track call.
     *
     * @param HostPressedFileSDClaimExit props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostPressedFileSDClaimExit,
    /**
     * Fires a 'HostPressedGetStartedOnboardingListing' track call.
     *
     * @param HostPressedGetStartedOnboardingListing props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostPressedGetStartedOnboardingListing,
    /**
     * Fires a 'HostPressedGetStartedPromoOnPDPEdu' track call.
     *
     * @param HostPressedGetStartedPromoOnPDPEdu props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostPressedGetStartedPromoOnPDPEdu,
    /**
     * Fires a 'HostPressedHelpCenterFromMessages' track call.
     *
     * @param HostPressedHelpCenterFromMessages props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostPressedHelpCenterFromMessages,
    /**
     * Fires a 'HostPressedHelpCenterFromReservationPage' track call.
     *
     * @param HostPressedHelpCenterFromReservationPage props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostPressedHelpCenterFromReservationPage,
    /**
     * Fires a 'HostPressedHostWakeUpBannerLearnMore' track call.
     *
     * @param HostPressedHostWakeUpBannerLearnMore props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostPressedHostWakeUpBannerLearnMore,
    /**
     * Fires a 'HostPressedInitiateFullRefund' track call.
     *
     * @param HostPressedInitiateFullRefund props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostPressedInitiateFullRefund,
    /**
     * Fires a 'HostPressedInitiatePartialRefund' track call.
     *
     * @param HostPressedInitiatePartialRefund props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostPressedInitiatePartialRefund,
    /**
     * Fires a 'HostPressedInitiateRefund' track call.
     *
     * @param HostPressedInitiateRefund props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostPressedInitiateRefund,
    /**
     * Fires a 'HostPressedLearnMorePassOnboarding' track call.
     *
     * @param HostPressedLearnMorePassOnboarding props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostPressedLearnMorePassOnboarding,
    /**
     * Fires a 'HostPressedListFromExternalSite' track call.
     *
     * @param HostPressedListFromExternalSite props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostPressedListFromExternalSite,
    /**
     * Fires a 'HostPressedMakeChanges' track call.
     *
     * @param HostPressedMakeChanges props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostPressedMakeChanges,
    /**
     * Fires a 'HostPressedManagePassFromPassOverview' track call.
     *
     * @param HostPressedManagePassFromPassOverview props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostPressedManagePassFromPassOverview,
    /**
     * Fires a 'HostPressedManagePassFromPasses' track call.
     *
     * @param HostPressedManagePassFromPasses props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostPressedManagePassFromPasses,
    /**
     * Fires a 'HostPressedManagePromoCode' track call.
     *
     * @param HostPressedManagePromoCode props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostPressedManagePromoCode,
    /**
     * Fires a 'HostPressedMangeSpecialOffer' track call.
     *
     * @param HostPressedMangeSpecialOffer props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostPressedMangeSpecialOffer,
    /**
     * Fires a 'HostPressedMessageFromReservationPage' track call.
     *
     * @param HostPressedMessageFromReservationPage props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostPressedMessageFromReservationPage,
    /**
     * Fires a 'HostPressedMessagePassholder' track call.
     *
     * @param HostPressedMessagePassholder props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostPressedMessagePassholder,
    /**
     * Fires a 'HostPressedNeverMindOnCreatingSendSo' track call.
     *
     * @param HostPressedNeverMindOnCreatingSendSo props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostPressedNeverMindOnCreatingSendSo,
    /**
     * Fires a 'HostPressedNeverMindOnWithdrawingSo' track call.
     *
     * @param HostPressedNeverMindOnWithdrawingSo props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostPressedNeverMindOnWithdrawingSo,
    /**
     * Fires a 'HostPressedNevermindCancel' track call.
     *
     * @param HostPressedNevermindCancel props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostPressedNevermindCancel,
    /**
     * Fires a 'HostPressedNevermindDeactivatePass' track call.
     *
     * @param HostPressedNevermindDeactivatePass props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostPressedNevermindDeactivatePass,
    /**
     * Fires a 'HostPressedNevermindDecline' track call.
     *
     * @param HostPressedNevermindDecline props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostPressedNevermindDecline,
    /**
     * Fires a 'HostPressedNevermindPassholderRefund' track call.
     *
     * @param HostPressedNevermindPassholderRefund props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostPressedNevermindPassholderRefund,
    /**
     * Fires a 'HostPressedNextPageTrustAndSafety' track call.
     *
     * @param HostPressedNextPageTrustAndSafety props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostPressedNextPageTrustAndSafety,
    /**
     * Fires a 'HostPressedNextPassOnboarding' track call.
     *
     * @param HostPressedNextPassOnboarding props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostPressedNextPassOnboarding,
    /**
     * Fires a 'HostPressedPassFAQ' track call.
     *
     * @param HostPressedPassFAQ props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostPressedPassFAQ,
    /**
     * Fires a 'HostPressedPassFailedManageAvailability' track call.
     *
     * @param HostPressedPassFailedManageAvailability props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostPressedPassFailedManageAvailability,
    /**
     * Fires a 'HostPressedPassGetHelp' track call.
     *
     * @param HostPressedPassGetHelp props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostPressedPassGetHelp,
    /**
     * Fires a 'HostPressedPassholder' track call.
     *
     * @param HostPressedPassholder props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostPressedPassholder,
    /**
     * Fires a 'HostPressedReadGuideButton' track call.
     *
     * @param HostPressedReadGuideButton props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostPressedReadGuideButton,
    /**
     * Fires a 'HostPressedRefreshCalendar' track call.
     *
     * @param HostPressedRefreshCalendar props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostPressedRefreshCalendar,
    /**
     * Fires a 'HostPressedRefundPassholder' track call.
     *
     * @param HostPressedRefundPassholder props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostPressedRefundPassholder,
    /**
     * Fires a 'HostPressedRemoveSecurityDeposit' track call.
     *
     * @param HostPressedRemoveSecurityDeposit props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostPressedRemoveSecurityDeposit,
    /**
     * Fires a 'HostPressedRescheduleFromCancelFlow' track call.
     *
     * @param HostPressedRescheduleFromCancelFlow props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostPressedRescheduleFromCancelFlow,
    /**
     * Fires a 'HostPressedRescheduleFromReservationPage' track call.
     *
     * @param HostPressedRescheduleFromReservationPage props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostPressedRescheduleFromReservationPage,
    /**
     * Fires a 'HostPressedReturnToChatFomManageSo' track call.
     *
     * @param HostPressedReturnToChatFomManageSo props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostPressedReturnToChatFomManageSo,
    /**
     * Fires a 'HostPressedReviewBookingInquiry' track call.
     *
     * @param HostPressedReviewBookingInquiry props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostPressedReviewBookingInquiry,
    /**
     * Fires a 'HostPressedSaveChangeAmenities' track call.
     *
     * @param HostPressedSaveChangeAmenities props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostPressedSaveChangeAmenities,
    /**
     * Fires a 'HostPressedSaveChangeDateTime' track call.
     *
     * @param HostPressedSaveChangeDateTime props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostPressedSaveChangeDateTime,
    /**
     * Fires a 'HostPressedSaveChangeGuest' track call.
     *
     * @param HostPressedSaveChangeGuest props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostPressedSaveChangeGuest,
    /**
     * Fires a 'HostPressedSavePassAndActivateLater' track call.
     *
     * @param HostPressedSavePassAndActivateLater props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostPressedSavePassAndActivateLater,
    /**
     * Fires a 'HostPressedSavePassChanges' track call.
     *
     * @param HostPressedSavePassChanges props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostPressedSavePassChanges,
    /**
     * Fires a 'HostPressedSavePromoCode' track call.
     *
     * @param HostPressedSavePromoCode props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostPressedSavePromoCode,
    /**
     * Fires a 'HostPressedSecurityDepositMoreInformation' track call.
     *
     * @param HostPressedSecurityDepositMoreInformation props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostPressedSecurityDepositMoreInformation,
    /**
     * Fires a 'HostPressedSelfServeSignUp' track call.
     *
     * @param HostPressedSelfServeSignUp props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostPressedSelfServeSignUp,
    /**
     * Fires a 'HostPressedSendChangeRequest' track call.
     *
     * @param HostPressedSendChangeRequest props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostPressedSendChangeRequest,
    /**
     * Fires a 'HostPressedSendSpecialOfferFromMessages' track call.
     *
     * @param HostPressedSendSpecialOfferFromMessages props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostPressedSendSpecialOfferFromMessages,
    /**
     * Fires a 'HostPressedSetSpecialPrice' track call.
     *
     * @param HostPressedSetSpecialPrice props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostPressedSetSpecialPrice,
    /**
     * Fires a 'HostPressedSetUpPass' track call.
     *
     * @param HostPressedSetUpPass props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostPressedSetUpPass,
    /**
     * Fires a 'HostPressedSetUpSecurityDeposit' track call.
     *
     * @param HostPressedSetUpSecurityDeposit props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostPressedSetUpSecurityDeposit,
    /**
     * Fires a 'HostPressedSetUpSecurityDepositExit' track call.
     *
     * @param HostPressedSetUpSecurityDepositExit props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostPressedSetUpSecurityDepositExit,
    /**
     * Fires a 'HostPressedSignUpTogether' track call.
     *
     * @param HostPressedSignUpTogether props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostPressedSignUpTogether,
    /**
     * Fires a 'HostPressedStartSellingPassOnboarding' track call.
     *
     * @param HostPressedStartSellingPassOnboarding props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostPressedStartSellingPassOnboarding,
    /**
     * Fires a 'HostPressedSwitchListing' track call.
     *
     * @param HostPressedSwitchListing props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostPressedSwitchListing,
    /**
     * Fires a 'HostPressedSwitchPricingType' track call.
     *
     * @param HostPressedSwitchPricingType props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostPressedSwitchPricingType,
    /**
     * Fires a 'HostPressedToConfirmChangeToFlatRatePricing' track call.
     *
     * @param HostPressedToConfirmChangeToFlatRatePricing props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostPressedToConfirmChangeToFlatRatePricing,
    /**
     * Fires a 'HostPressedToConfirmChangeToFullDayPricing' track call.
     *
     * @param HostPressedToConfirmChangeToFullDayPricing props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostPressedToConfirmChangeToFullDayPricing,
    /**
     * Fires a 'HostPressedToConfirmChangeToTieredDayPricing' track call.
     *
     * @param HostPressedToConfirmChangeToTieredDayPricing props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostPressedToConfirmChangeToTieredDayPricing,
    /**
     * Fires a 'HostPressedToContinueCancellation' track call.
     *
     * @param HostPressedToContinueCancellation props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostPressedToContinueCancellation,
    /**
     * Fires a 'HostPressedToContinueDecline' track call.
     *
     * @param HostPressedToContinueDecline props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostPressedToContinueDecline,
    /**
     * Fires a 'HostPressedToEditSecurityDeposit' track call.
     *
     * @param HostPressedToEditSecurityDeposit props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostPressedToEditSecurityDeposit,
    /**
     * Fires a 'HostPressedToSharePromoCode' track call.
     *
     * @param HostPressedToSharePromoCode props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostPressedToSharePromoCode,
    /**
     * Fires a 'HostPressedToViewPromoCode' track call.
     *
     * @param HostPressedToViewPromoCode props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostPressedToViewPromoCode,
    /**
     * Fires a 'HostPressedUnsyncCronofy' track call.
     *
     * @param HostPressedUnsyncCronofy props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostPressedUnsyncCronofy,
    /**
     * Fires a 'HostPressedUnsyncICal' track call.
     *
     * @param HostPressedUnsyncICal props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostPressedUnsyncICal,
    /**
     * Fires a 'HostPressedUploadVideoTour' track call.
     *
     * @param HostPressedUploadVideoTour props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostPressedUploadVideoTour,
    /**
     * Fires a 'HostPressedViewDetailsReservationAdjustment' track call.
     *
     * @param HostPressedViewDetailsReservationAdjustment props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostPressedViewDetailsReservationAdjustment,
    /**
     * Fires a 'HostPressedViewLatestBookingAmenityModifications' track call.
     *
     * @param HostPressedViewLatestBookingAmenityModifications props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostPressedViewLatestBookingAmenityModifications,
    /**
     * Fires a 'HostPressedViewLatestBookingModifications' track call.
     *
     * @param HostPressedViewLatestBookingModifications props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostPressedViewLatestBookingModifications,
    /**
     * Fires a 'HostPressedViewReservation' track call.
     *
     * @param HostPressedViewReservation props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostPressedViewReservation,
    /**
     * Fires a 'HostPressedWithdrawSpecialOffer' track call.
     *
     * @param HostPressedWithdrawSpecialOffer props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostPressedWithdrawSpecialOffer,
    /**
     * Fires a 'HostProfileAccount' track call.
     *
     * @param HostProfileAccount props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostProfileAccount,
    /**
     * Fires a 'HostProfileConfirmedRegionSwitch' track call.
     *
     * @param HostProfileConfirmedRegionSwitch props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostProfileConfirmedRegionSwitch,
    /**
     * Fires a 'HostProfilePaymentMethods' track call.
     *
     * @param HostProfilePaymentMethods props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostProfilePaymentMethods,
    /**
     * Fires a 'HostProfilePhotosAdded' track call.
     *
     * @param HostProfilePhotosAdded props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostProfilePhotosAdded,
    /**
     * Fires a 'HostProfilePressReferralBanner' track call.
     *
     * @param HostProfilePressReferralBanner props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostProfilePressReferralBanner,
    /**
     * Fires a 'HostProfilePressTermsofUse' track call.
     *
     * @param HostProfilePressTermsofUse props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostProfilePressTermsofUse,
    /**
     * Fires a 'HostProfilePressedContactUs' track call.
     *
     * @param HostProfilePressedContactUs props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostProfilePressedContactUs,
    /**
     * Fires a 'HostProfilePressedGetVerified' track call.
     *
     * @param HostProfilePressedGetVerified props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostProfilePressedGetVerified,
    /**
     * Fires a 'HostProfilePressedGiftCards' track call.
     *
     * @param HostProfilePressedGiftCards props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostProfilePressedGiftCards,
    /**
     * Fires a 'HostProfilePressedHelpCenter' track call.
     *
     * @param HostProfilePressedHelpCenter props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostProfilePressedHelpCenter,
    /**
     * Fires a 'HostProfilePressedLogout' track call.
     *
     * @param HostProfilePressedLogout props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostProfilePressedLogout,
    /**
     * Fires a 'HostProfilePressedPrivacyPolicy' track call.
     *
     * @param HostProfilePressedPrivacyPolicy props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostProfilePressedPrivacyPolicy,
    /**
     * Fires a 'HostProfilePressedRateApp' track call.
     *
     * @param HostProfilePressedRateApp props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostProfilePressedRateApp,
    /**
     * Fires a 'HostProfilePressedRegionSwitch' track call.
     *
     * @param HostProfilePressedRegionSwitch props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostProfilePressedRegionSwitch,
    /**
     * Fires a 'HostProfilePressedStripeConnect' track call.
     *
     * @param HostProfilePressedStripeConnect props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostProfilePressedStripeConnect,
    /**
     * Fires a 'HostProfilePressedSwimplyStuff' track call.
     *
     * @param HostProfilePressedSwimplyStuff props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostProfilePressedSwimplyStuff,
    /**
     * Fires a 'HostProfileSelectProfile' track call.
     *
     * @param HostProfileSelectProfile props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostProfileSelectProfile,
    /**
     * Fires a 'HostProfileStripeSelectCountry' track call.
     *
     * @param HostProfileStripeSelectCountry props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostProfileStripeSelectCountry,
    /**
     * Fires a 'HostProfileSwitchGuestView' track call.
     *
     * @param HostProfileSwitchGuestView props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostProfileSwitchGuestView,
    /**
     * Fires a 'HostReceivedReservationAdjustmentRequest' track call.
     *
     * @param HostReceivedReservationAdjustmentRequest props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostReceivedReservationAdjustmentRequest,
    /**
     * Fires a 'HostRemovedPromotionFromListing' track call.
     *
     * @param HostRemovedPromotionFromListing props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostRemovedPromotionFromListing,
    /**
     * Fires a 'HostRescheduleDiscountSelected' track call.
     *
     * @param HostRescheduleDiscountSelected props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostRescheduleDiscountSelected,
    /**
     * Fires a 'HostRespondedReservationAdjustmentRequest' track call.
     *
     * @param HostRespondedReservationAdjustmentRequest props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostRespondedReservationAdjustmentRequest,
    /**
     * Fires a 'HostSavedSpecialPrice' track call.
     *
     * @param HostSavedSpecialPrice props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostSavedSpecialPrice,
    /**
     * Fires a 'HostSelectExpirationDate' track call.
     *
     * @param HostSelectExpirationDate props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostSelectExpirationDate,
    /**
     * Fires a 'HostSelectedCancellationReason' track call.
     *
     * @param HostSelectedCancellationReason props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostSelectedCancellationReason,
    /**
     * Fires a 'HostSelectedDeclineReason' track call.
     *
     * @param HostSelectedDeclineReason props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostSelectedDeclineReason,
    /**
     * Fires a 'HostSelectedListingType' track call.
     *
     * @param HostSelectedListingType props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostSelectedListingType,
    /**
     * Fires a 'HostSelectedNewPoolDiscountOption' track call.
     *
     * @param HostSelectedNewPoolDiscountOption props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostSelectedNewPoolDiscountOption,
    /**
     * Fires a 'HostSelectedNewRescheduleTime' track call.
     *
     * @param HostSelectedNewRescheduleTime props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostSelectedNewRescheduleTime,
    /**
     * Fires a 'HostSelectedPassAmenitiesIncluded' track call.
     *
     * @param HostSelectedPassAmenitiesIncluded props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostSelectedPassAmenitiesIncluded,
    /**
     * Fires a 'HostSelectedPassDayAndTimes' track call.
     *
     * @param HostSelectedPassDayAndTimes props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostSelectedPassDayAndTimes,
    /**
     * Fires a 'HostSelectedPassDescription' track call.
     *
     * @param HostSelectedPassDescription props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostSelectedPassDescription,
    /**
     * Fires a 'HostSelectedPassMaxGuests' track call.
     *
     * @param HostSelectedPassMaxGuests props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostSelectedPassMaxGuests,
    /**
     * Fires a 'HostSelectedPassMaxHours' track call.
     *
     * @param HostSelectedPassMaxHours props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostSelectedPassMaxHours,
    /**
     * Fires a 'HostSelectedPassPrice' track call.
     *
     * @param HostSelectedPassPrice props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostSelectedPassPrice,
    /**
     * Fires a 'HostSelectedRescheduleReason' track call.
     *
     * @param HostSelectedRescheduleReason props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostSelectedRescheduleReason,
    /**
     * Fires a 'HostSelectedThirdPartyPublicAccess' track call.
     *
     * @param HostSelectedThirdPartyPublicAccess props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostSelectedThirdPartyPublicAccess,
    /**
     * Fires a 'HostSentSpecialOffer' track call.
     *
     * @param HostSentSpecialOffer props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostSentSpecialOffer,
    /**
     * Fires a 'HostSpaceDetailsAccess' track call.
     *
     * @param HostSpaceDetailsAccess props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostSpaceDetailsAccess,
    /**
     * Fires a 'HostSpaceDetailsBathroom' track call.
     *
     * @param HostSpaceDetailsBathroom props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostSpaceDetailsBathroom,
    /**
     * Fires a 'HostSpaceDetailsEntered' track call.
     *
     * @param HostSpaceDetailsEntered props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostSpaceDetailsEntered,
    /**
     * Fires a 'HostSpaceDetailsParking' track call.
     *
     * @param HostSpaceDetailsParking props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostSpaceDetailsParking,
    /**
     * Fires a 'HostSpaceDetailsPrivacy' track call.
     *
     * @param HostSpaceDetailsPrivacy props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostSpaceDetailsPrivacy,
    /**
     * Fires a 'HostSpaceDetailsSetting' track call.
     *
     * @param HostSpaceDetailsSetting props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostSpaceDetailsSetting,
    /**
     * Fires a 'HostStartedSyncWCronofy' track call.
     *
     * @param HostStartedSyncWCronofy props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostStartedSyncWCronofy,
    /**
     * Fires a 'HostSubmittedCancellation' track call.
     *
     * @param HostSubmittedCancellation props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostSubmittedCancellation,
    /**
     * Fires a 'HostSubmittedDecline' track call.
     *
     * @param HostSubmittedDecline props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostSubmittedDecline,
    /**
     * Fires a 'HostSubmittedDeleteImportCalendar' track call.
     *
     * @param HostSubmittedDeleteImportCalendar props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostSubmittedDeleteImportCalendar,
    /**
     * Fires a 'HostSubmittedDisconnectCronofy' track call.
     *
     * @param HostSubmittedDisconnectCronofy props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostSubmittedDisconnectCronofy,
    /**
     * Fires a 'HostSubmittedImportCalendarFailure' track call.
     *
     * @param HostSubmittedImportCalendarFailure props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostSubmittedImportCalendarFailure,
    /**
     * Fires a 'HostSubmittedImportCalendarSuccess' track call.
     *
     * @param HostSubmittedImportCalendarSuccess props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostSubmittedImportCalendarSuccess,
    /**
     * Fires a 'HostSubmittedListingForReview' track call.
     *
     * @param HostSubmittedListingForReview props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostSubmittedListingForReview,
    /**
     * Fires a 'HostSubmittedPassChangeSurvey' track call.
     *
     * @param HostSubmittedPassChangeSurvey props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostSubmittedPassChangeSurvey,
    /**
     * Fires a 'HostSubmittedPassRefundNote' track call.
     *
     * @param HostSubmittedPassRefundNote props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostSubmittedPassRefundNote,
    /**
     * Fires a 'HostSubmittedRebookingRequest' track call.
     *
     * @param HostSubmittedRebookingRequest props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostSubmittedRebookingRequest,
    /**
     * Fires a 'HostSubmittedRefund' track call.
     *
     * @param HostSubmittedRefund props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostSubmittedRefund,
    /**
     * Fires a 'HostSubmittedReviewReply' track call.
     *
     * @param HostSubmittedReviewReply props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostSubmittedReviewReply,
    /**
     * Fires a 'HostSubmittedSDClaim' track call.
     *
     * @param HostSubmittedSDClaim props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostSubmittedSDClaim,
    /**
     * Fires a 'HostSubmittedSecurityDepositSetUp' track call.
     *
     * @param HostSubmittedSecurityDepositSetUp props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostSubmittedSecurityDepositSetUp,
    /**
     * Fires a 'HostSubmittedSecurityDepositToggleOff' track call.
     *
     * @param HostSubmittedSecurityDepositToggleOff props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostSubmittedSecurityDepositToggleOff,
    /**
     * Fires a 'HostSubmittedSyncWCronofyFailure' track call.
     *
     * @param HostSubmittedSyncWCronofyFailure props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostSubmittedSyncWCronofyFailure,
    /**
     * Fires a 'HostSubmittedSyncWCronofySuccess' track call.
     *
     * @param HostSubmittedSyncWCronofySuccess props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostSubmittedSyncWCronofySuccess,
    /**
     * Fires a 'HostSubmittedUnsyncCronofy' track call.
     *
     * @param HostSubmittedUnsyncCronofy props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostSubmittedUnsyncCronofy,
    /**
     * Fires a 'HostSubmittedUnsyncICal' track call.
     *
     * @param HostSubmittedUnsyncICal props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostSubmittedUnsyncICal,
    /**
     * Fires a 'HostTieredPricingPressedAdjustGroupPrice' track call.
     *
     * @param HostTieredPricingPressedAdjustGroupPrice props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostTieredPricingPressedAdjustGroupPrice,
    /**
     * Fires a 'HostTieredPricingPressedConfirmPrice' track call.
     *
     * @param HostTieredPricingPressedConfirmPrice props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostTieredPricingPressedConfirmPrice,
    /**
     * Fires a 'HostTieredPricingSetGroupPrice' track call.
     *
     * @param HostTieredPricingSetGroupPrice props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostTieredPricingSetGroupPrice,
    /**
     * Fires a 'HostTieredPricingTabDoThisLater' track call.
     *
     * @param HostTieredPricingTabDoThisLater props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostTieredPricingTabDoThisLater,
    /**
     * Fires a 'HostVideoTourUploadFailure' track call.
     *
     * @param HostVideoTourUploadFailure props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostVideoTourUploadFailure,
    /**
     * Fires a 'HostVideoTourUploadSuccess' track call.
     *
     * @param HostVideoTourUploadSuccess props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostVideoTourUploadSuccess,
    /**
     * Fires a 'HostViewedPerfDashboard' track call.
     *
     * @param HostViewedPerfDashboard props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    hostViewedPerfDashboard,
    /**
     * Fires a 'LifeguardAccepted' track call.
     *
     * @param LifeguardAccepted props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    lifeguardAccepted,
    /**
     * Fires a 'LifeguardOffered' track call.
     *
     * @param LifeguardOffered props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    lifeguardOffered,
    /**
     * Fires a 'LifeguardRejected' track call.
     *
     * @param LifeguardRejected props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    lifeguardRejected,
    /**
     * Fires a 'ListListingImpression' track call.
     *
     * @param ListListingImpression props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    listListingImpression,
    /**
     * Fires a 'ListListingImpressionAISearch' track call.
     *
     * @param ListListingImpressionAISearch props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    listListingImpressionAISearch,
    /**
     * Fires a 'ListingPhotoCarouselChanged' track call.
     *
     * @param ListingPhotoCarouselChanged props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    listingPhotoCarouselChanged,
    /**
     * Fires a 'LoadSearchResult' track call.
     *
     * @param LoadSearchResult props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    loadSearchResult,
    /**
     * Fires a 'MapLoaded' track call.
     *
     * @param MapLoaded props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    mapLoaded,
    /**
     * Fires a 'MonitorAccepted' track call.
     *
     * @param MonitorAccepted props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    monitorAccepted,
    /**
     * Fires a 'MonitorOffered' track call.
     *
     * @param MonitorOffered props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    monitorOffered,
    /**
     * Fires a 'MonitorRejected' track call.
     *
     * @param MonitorRejected props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    monitorRejected,
    /**
     * Fires a 'PageViewed' track call.
     *
     * @param PageViewed props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    pageViewed,
    /**
     * Fires a 'SentNewListingNotification' track call.
     *
     * @param SentNewListingNotification props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    sentNewListingNotification,
    /**
     * Fires a 'SwimplyPremiumPurchaseSuccess' track call.
     *
     * @param SwimplyPremiumPurchaseSuccess props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    swimplyPremiumPurchaseSuccess,
    /**
     * Fires a 'UserAccountAddedPhotoSuccess' track call.
     *
     * @param UserAccountAddedPhotoSuccess props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userAccountAddedPhotoSuccess,
    /**
     * Fires a 'UserAccountBioEntered' track call.
     *
     * @param UserAccountBioEntered props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userAccountBioEntered,
    /**
     * Fires a 'UserAccountBirthdayBioSkipped' track call.
     *
     * @param UserAccountBirthdayBioSkipped props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userAccountBirthdayBioSkipped,
    /**
     * Fires a 'UserAccountBirthdayEntered' track call.
     *
     * @param UserAccountBirthdayEntered props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userAccountBirthdayEntered,
    /**
     * Fires a 'UserAccountInitiatedAddPhoto' track call.
     *
     * @param UserAccountInitiatedAddPhoto props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userAccountInitiatedAddPhoto,
    /**
     * Fires a 'UserAccountName' track call.
     *
     * @param UserAccountName props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userAccountName,
    /**
     * Fires a 'UserAccountNameSkipped' track call.
     *
     * @param UserAccountNameSkipped props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userAccountNameSkipped,
    /**
     * Fires a 'UserAccountPhotoSkipped' track call.
     *
     * @param UserAccountPhotoSkipped props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userAccountPhotoSkipped,
    /**
     * Fires a 'UserAccountProfileContextAdded' track call.
     *
     * @param UserAccountProfileContextAdded props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userAccountProfileContextAdded,
    /**
     * Fires a 'UserAccountProfileContextSkipped' track call.
     *
     * @param UserAccountProfileContextSkipped props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userAccountProfileContextSkipped,
    /**
     * Fires a 'UserAccountProfileDetailsAdded' track call.
     *
     * @param UserAccountProfileDetailsAdded props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userAccountProfileDetailsAdded,
    /**
     * Fires a 'UserAccountProfileDetailsFormViewed' track call.
     *
     * @param UserAccountProfileDetailsFormViewed props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userAccountProfileDetailsFormViewed,
    /**
     * Fires a 'UserAccountProfileDetailsSkipped' track call.
     *
     * @param UserAccountProfileDetailsSkipped props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userAccountProfileDetailsSkipped,
    /**
     * Fires a 'UserAddGuestsConfirmed' track call.
     *
     * @param UserAddGuestsConfirmed props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userAddGuestsConfirmed,
    /**
     * Fires a 'UserAddGuestsDisplayed' track call.
     *
     * @param UserAddGuestsDisplayed props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userAddGuestsDisplayed,
    /**
     * Fires a 'UserAddedBookingMessage' track call.
     *
     * @param UserAddedBookingMessage props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userAddedBookingMessage,
    /**
     * Fires a 'UserBookingDetailsDisplay' track call.
     *
     * @param UserBookingDetailsDisplay props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userBookingDetailsDisplay,
    /**
     * Fires a 'UserBookingSubmittedFailure' track call.
     *
     * @param UserBookingSubmittedFailure props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userBookingSubmittedFailure,
    /**
     * Fires a 'UserBookingSubmittedSuccess' track call.
     *
     * @param UserBookingSubmittedSuccess props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userBookingSubmittedSuccess,
    /**
     * Fires a 'UserCalenderView' track call.
     *
     * @param UserCalenderView props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userCalenderView,
    /**
     * Fires a 'UserChoseDate' track call.
     *
     * @param UserChoseDate props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userChoseDate,
    /**
     * Fires a 'UserChosePaymentMethodInWallet' track call.
     *
     * @param UserChosePaymentMethodInWallet props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userChosePaymentMethodInWallet,
    /**
     * Fires a 'UserContinuedBookAgainOption' track call.
     *
     * @param UserContinuedBookAgainOption props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userContinuedBookAgainOption,
    /**
     * Fires a 'UserDeletedFavoriteList' track call.
     *
     * @param UserDeletedFavoriteList props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userDeletedFavoriteList,
    /**
     * Fires a 'UserDisplayedAmenity' track call.
     *
     * @param UserDisplayedAmenity props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userDisplayedAmenity,
    /**
     * Fires a 'UserDisplayedPostBookingFlow' track call.
     *
     * @param UserDisplayedPostBookingFlow props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userDisplayedPostBookingFlow,
    /**
     * Fires a 'UserEditedFilterDistance' track call.
     *
     * @param UserEditedFilterDistance props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userEditedFilterDistance,
    /**
     * Fires a 'UserEditedFilterPrice' track call.
     *
     * @param UserEditedFilterPrice props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userEditedFilterPrice,
    /**
     * Fires a 'UserEditedPoolType' track call.
     *
     * @param UserEditedPoolType props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userEditedPoolType,
    /**
     * Fires a 'UserEditedWaterType' track call.
     *
     * @param UserEditedWaterType props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userEditedWaterType,
    /**
     * Fires a 'UserEnteredFavoriteListMapView' track call.
     *
     * @param UserEnteredFavoriteListMapView props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userEnteredFavoriteListMapView,
    /**
     * Fires a 'UserEnteredFullScreenMap' track call.
     *
     * @param UserEnteredFullScreenMap props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userEnteredFullScreenMap,
    /**
     * Fires a 'UserEnteredPromoCode' track call.
     *
     * @param UserEnteredPromoCode props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userEnteredPromoCode,
    /**
     * Fires a 'UserEnteredZipCode' track call.
     *
     * @param UserEnteredZipCode props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userEnteredZipCode,
    /**
     * Fires a 'UserExitedCozymealBookingAdditions' track call.
     *
     * @param UserExitedCozymealBookingAdditions props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userExitedCozymealBookingAdditions,
    /**
     * Fires a 'UserFiltersPressed' track call.
     *
     * @param UserFiltersPressed props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userFiltersPressed,
    /**
     * Fires a 'UserFindASpaceScreenEditTime' track call.
     *
     * @param UserFindASpaceScreenEditTime props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userFindASpaceScreenEditTime,
    /**
     * Fires a 'UserFindASpaceScreenEditWhen' track call.
     *
     * @param UserFindASpaceScreenEditWhen props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userFindASpaceScreenEditWhen,
    /**
     * Fires a 'UserFindASpaceScreenEditWhere' track call.
     *
     * @param UserFindASpaceScreenEditWhere props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userFindASpaceScreenEditWhere,
    /**
     * Fires a 'UserFindASpaceScreenEditWho' track call.
     *
     * @param UserFindASpaceScreenEditWho props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userFindASpaceScreenEditWho,
    /**
     * Fires a 'UserLeadCompletedAccountCreationMethod' track call.
     *
     * @param UserLeadCompletedAccountCreationMethod props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userLeadCompletedAccountCreationMethod,
    /**
     * Fires a 'UserLeadEmail' track call.
     *
     * @param UserLeadEmail props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userLeadEmail,
    /**
     * Fires a 'UserLeadExistingAccount' track call.
     *
     * @param UserLeadExistingAccount props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userLeadExistingAccount,
    /**
     * Fires a 'UserLeadExistingAccountSignOnFailed' track call.
     *
     * @param UserLeadExistingAccountSignOnFailed props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userLeadExistingAccountSignOnFailed,
    /**
     * Fires a 'UserLeadExistingAccountSignOnSuccess' track call.
     *
     * @param UserLeadExistingAccountSignOnSuccess props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userLeadExistingAccountSignOnSuccess,
    /**
     * Fires a 'UserLeadForgotPassword' track call.
     *
     * @param UserLeadForgotPassword props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userLeadForgotPassword,
    /**
     * Fires a 'UserLeadInitiatedAccountCreationMethod' track call.
     *
     * @param UserLeadInitiatedAccountCreationMethod props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userLeadInitiatedAccountCreationMethod,
    /**
     * Fires a 'UserLeadNumberEntered' track call.
     *
     * @param UserLeadNumberEntered props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userLeadNumberEntered,
    /**
     * Fires a 'UserLeadNumberVerificationResend' track call.
     *
     * @param UserLeadNumberVerificationResend props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userLeadNumberVerificationResend,
    /**
     * Fires a 'UserLeadNumberVerificationSuccess' track call.
     *
     * @param UserLeadNumberVerificationSuccess props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userLeadNumberVerificationSuccess,
    /**
     * Fires a 'UserLeadPhoneNumberInUse' track call.
     *
     * @param UserLeadPhoneNumberInUse props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userLeadPhoneNumberInUse,
    /**
     * Fires a 'UserLeadPhoneNumberInUseEditNumber' track call.
     *
     * @param UserLeadPhoneNumberInUseEditNumber props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userLeadPhoneNumberInUseEditNumber,
    /**
     * Fires a 'UserLeadSelectedForgotPasswordOption' track call.
     *
     * @param UserLeadSelectedForgotPasswordOption props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userLeadSelectedForgotPasswordOption,
    /**
     * Fires a 'UserLeadSubmittedForgotPasswordEmail' track call.
     *
     * @param UserLeadSubmittedForgotPasswordEmail props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userLeadSubmittedForgotPasswordEmail,
    /**
     * Fires a 'UserLoadMore' track call.
     *
     * @param UserLoadMore props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userLoadMore,
    /**
     * Fires a 'UserMovedFavoriteListMap' track call.
     *
     * @param UserMovedFavoriteListMap props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userMovedFavoriteListMap,
    /**
     * Fires a 'UserMovedMap' track call.
     *
     * @param UserMovedMap props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userMovedMap,
    /**
     * Fires a 'UserOfferedAppStoreReview' track call.
     *
     * @param UserOfferedAppStoreReview props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userOfferedAppStoreReview,
    /**
     * Fires a 'UserOfferedBookAgain' track call.
     *
     * @param UserOfferedBookAgain props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userOfferedBookAgain,
    /**
     * Fires a 'UserOpenedCalendarFromSearch' track call.
     *
     * @param UserOpenedCalendarFromSearch props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userOpenedCalendarFromSearch,
    /**
     * Fires a 'UserOpenedPaymentMethodChangeFromCheckout' track call.
     *
     * @param UserOpenedPaymentMethodChangeFromCheckout props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userOpenedPaymentMethodChangeFromCheckout,
    /**
     * Fires a 'UserPressed360Tour' track call.
     *
     * @param UserPressed360Tour props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userPressed360Tour,
    /**
     * Fires a 'UserPressedActionCTAFromMessageThread' track call.
     *
     * @param UserPressedActionCTAFromMessageThread props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userPressedActionCTAFromMessageThread,
    /**
     * Fires a 'UserPressedAdaFilter' track call.
     *
     * @param UserPressedAdaFilter props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userPressedAdaFilter,
    /**
     * Fires a 'UserPressedAddAnotherFriendEmail' track call.
     *
     * @param UserPressedAddAnotherFriendEmail props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userPressedAddAnotherFriendEmail,
    /**
     * Fires a 'UserPressedAddMeToWaitlist' track call.
     *
     * @param UserPressedAddMeToWaitlist props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userPressedAddMeToWaitlist,
    /**
     * Fires a 'UserPressedAddPaymentMethod' track call.
     *
     * @param UserPressedAddPaymentMethod props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userPressedAddPaymentMethod,
    /**
     * Fires a 'UserPressedAddPromoCode' track call.
     *
     * @param UserPressedAddPromoCode props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userPressedAddPromoCode,
    /**
     * Fires a 'UserPressedAddZipCode' track call.
     *
     * @param UserPressedAddZipCode props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userPressedAddZipCode,
    /**
     * Fires a 'UserPressedAgreeTermsAndCondition' track call.
     *
     * @param UserPressedAgreeTermsAndCondition props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userPressedAgreeTermsAndCondition,
    /**
     * Fires a 'UserPressedAppStoreReview' track call.
     *
     * @param UserPressedAppStoreReview props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userPressedAppStoreReview,
    /**
     * Fires a 'UserPressedBadgeInfoCard' track call.
     *
     * @param UserPressedBadgeInfoCard props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userPressedBadgeInfoCard,
    /**
     * Fires a 'UserPressedBanner' track call.
     *
     * @param UserPressedBanner props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userPressedBanner,
    /**
     * Fires a 'UserPressedBookAgainOption' track call.
     *
     * @param UserPressedBookAgainOption props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userPressedBookAgainOption,
    /**
     * Fires a 'UserPressedBookPostPassPurchase' track call.
     *
     * @param UserPressedBookPostPassPurchase props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userPressedBookPostPassPurchase,
    /**
     * Fires a 'UserPressedCancelSendPicture' track call.
     *
     * @param UserPressedCancelSendPicture props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userPressedCancelSendPicture,
    /**
     * Fires a 'UserPressedCategoryInspiration' track call.
     *
     * @param UserPressedCategoryInspiration props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userPressedCategoryInspiration,
    /**
     * Fires a 'UserPressedCategoryTab' track call.
     *
     * @param UserPressedCategoryTab props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userPressedCategoryTab,
    /**
     * Fires a 'UserPressedChangePhoneNumber' track call.
     *
     * @param UserPressedChangePhoneNumber props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userPressedChangePhoneNumber,
    /**
     * Fires a 'UserPressedClaimReferralButtonBottom' track call.
     *
     * @param UserPressedClaimReferralButtonBottom props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userPressedClaimReferralButtonBottom,
    /**
     * Fires a 'UserPressedClaimReferralButtonReferrerTracking' track call.
     *
     * @param UserPressedClaimReferralButtonReferrerTracking props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userPressedClaimReferralButtonReferrerTracking,
    /**
     * Fires a 'UserPressedClaimReferralButtonTop' track call.
     *
     * @param UserPressedClaimReferralButtonTop props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userPressedClaimReferralButtonTop,
    /**
     * Fires a 'UserPressedCompleteProfileVerification' track call.
     *
     * @param UserPressedCompleteProfileVerification props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userPressedCompleteProfileVerification,
    /**
     * Fires a 'UserPressedConfirmPurchasePass' track call.
     *
     * @param UserPressedConfirmPurchasePass props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userPressedConfirmPurchasePass,
    /**
     * Fires a 'UserPressedContactHost' track call.
     *
     * @param UserPressedContactHost props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userPressedContactHost,
    /**
     * Fires a 'UserPressedContinueRebookScreen' track call.
     *
     * @param UserPressedContinueRebookScreen props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userPressedContinueRebookScreen,
    /**
     * Fires a 'UserPressedCopyFLInviteLink' track call.
     *
     * @param UserPressedCopyFLInviteLink props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userPressedCopyFLInviteLink,
    /**
     * Fires a 'UserPressedCopyInviteLink' track call.
     *
     * @param UserPressedCopyInviteLink props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userPressedCopyInviteLink,
    /**
     * Fires a 'UserPressedCozymealBookingAdditions' track call.
     *
     * @param UserPressedCozymealBookingAdditions props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userPressedCozymealBookingAdditions,
    /**
     * Fires a 'UserPressedCozymealListing' track call.
     *
     * @param UserPressedCozymealListing props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userPressedCozymealListing,
    /**
     * Fires a 'UserPressedCozymealOptionsFilter' track call.
     *
     * @param UserPressedCozymealOptionsFilter props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userPressedCozymealOptionsFilter,
    /**
     * Fires a 'UserPressedCozymealSeeMenu' track call.
     *
     * @param UserPressedCozymealSeeMenu props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userPressedCozymealSeeMenu,
    /**
     * Fires a 'UserPressedCreatePoll' track call.
     *
     * @param UserPressedCreatePoll props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userPressedCreatePoll,
    /**
     * Fires a 'UserPressedDeleteAccount' track call.
     *
     * @param UserPressedDeleteAccount props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userPressedDeleteAccount,
    /**
     * Fires a 'UserPressedDeleteFavoriteList' track call.
     *
     * @param UserPressedDeleteFavoriteList props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userPressedDeleteFavoriteList,
    /**
     * Fires a 'UserPressedDeleteMyAccount' track call.
     *
     * @param UserPressedDeleteMyAccount props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userPressedDeleteMyAccount,
    /**
     * Fires a 'UserPressedDisableEmailNotifications' track call.
     *
     * @param UserPressedDisableEmailNotifications props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userPressedDisableEmailNotifications,
    /**
     * Fires a 'UserPressedDisableMarketingSMSNotifications' track call.
     *
     * @param UserPressedDisableMarketingSMSNotifications props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userPressedDisableMarketingSMSNotifications,
    /**
     * Fires a 'UserPressedDisableTransactionalSMSNotifications' track call.
     *
     * @param UserPressedDisableTransactionalSMSNotifications props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userPressedDisableTransactionalSMSNotifications,
    /**
     * Fires a 'UserPressedDisplayPriceWithFeesToggle' track call.
     *
     * @param UserPressedDisplayPriceWithFeesToggle props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userPressedDisplayPriceWithFeesToggle,
    /**
     * Fires a 'UserPressedDontEnableNotificationsFromStartCall' track call.
     *
     * @param UserPressedDontEnableNotificationsFromStartCall props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userPressedDontEnableNotificationsFromStartCall,
    /**
     * Fires a 'UserPressedEditDateOnCheckoutConfirmation' track call.
     *
     * @param UserPressedEditDateOnCheckoutConfirmation props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userPressedEditDateOnCheckoutConfirmation,
    /**
     * Fires a 'UserPressedEditGuestsOnCheckoutConfirmation' track call.
     *
     * @param UserPressedEditGuestsOnCheckoutConfirmation props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userPressedEditGuestsOnCheckoutConfirmation,
    /**
     * Fires a 'UserPressedEditReasonForBooking' track call.
     *
     * @param UserPressedEditReasonForBooking props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userPressedEditReasonForBooking,
    /**
     * Fires a 'UserPressedEnableEmailNotifications' track call.
     *
     * @param UserPressedEnableEmailNotifications props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userPressedEnableEmailNotifications,
    /**
     * Fires a 'UserPressedEnableMarketingSMSNotifications' track call.
     *
     * @param UserPressedEnableMarketingSMSNotifications props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userPressedEnableMarketingSMSNotifications,
    /**
     * Fires a 'UserPressedEnableNotificationsFromStartCall' track call.
     *
     * @param UserPressedEnableNotificationsFromStartCall props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userPressedEnableNotificationsFromStartCall,
    /**
     * Fires a 'UserPressedEnableTransactionalSMSNotifications' track call.
     *
     * @param UserPressedEnableTransactionalSMSNotifications props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userPressedEnableTransactionalSMSNotifications,
    /**
     * Fires a 'UserPressedEnterPassUpsell' track call.
     *
     * @param UserPressedEnterPassUpsell props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userPressedEnterPassUpsell,
    /**
     * Fires a 'UserPressedEnterSendPicture' track call.
     *
     * @param UserPressedEnterSendPicture props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userPressedEnterSendPicture,
    /**
     * Fires a 'UserPressedEnterStartCall' track call.
     *
     * @param UserPressedEnterStartCall props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userPressedEnterStartCall,
    /**
     * Fires a 'UserPressedFLInviteFriendsViaEmail' track call.
     *
     * @param UserPressedFLInviteFriendsViaEmail props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userPressedFLInviteFriendsViaEmail,
    /**
     * Fires a 'UserPressedFLInviteFriendsViaText' track call.
     *
     * @param UserPressedFLInviteFriendsViaText props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userPressedFLInviteFriendsViaText,
    /**
     * Fires a 'UserPressedFavoriteListMapView' track call.
     *
     * @param UserPressedFavoriteListMapView props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userPressedFavoriteListMapView,
    /**
     * Fires a 'UserPressedFavoriteListing' track call.
     *
     * @param UserPressedFavoriteListing props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userPressedFavoriteListing,
    /**
     * Fires a 'UserPressedFindPoolsNearMe' track call.
     *
     * @param UserPressedFindPoolsNearMe props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userPressedFindPoolsNearMe,
    /**
     * Fires a 'UserPressedFullScreeenListView' track call.
     *
     * @param UserPressedFullScreeenListView props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userPressedFullScreeenListView,
    /**
     * Fires a 'UserPressedFullScreenListView' track call.
     *
     * @param UserPressedFullScreenListView props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userPressedFullScreenListView,
    /**
     * Fires a 'UserPressedGoPuffAd' track call.
     *
     * @param UserPressedGoPuffAd props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userPressedGoPuffAd,
    /**
     * Fires a 'UserPressedHomepageDownloadApp' track call.
     *
     * @param UserPressedHomepageDownloadApp props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userPressedHomepageDownloadApp,
    /**
     * Fires a 'UserPressedHomepageExperience' track call.
     *
     * @param UserPressedHomepageExperience props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userPressedHomepageExperience,
    /**
     * Fires a 'UserPressedHomepageListing' track call.
     *
     * @param UserPressedHomepageListing props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userPressedHomepageListing,
    /**
     * Fires a 'UserPressedHomepageListingType' track call.
     *
     * @param UserPressedHomepageListingType props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userPressedHomepageListingType,
    /**
     * Fires a 'UserPressedHomepagePassType' track call.
     *
     * @param UserPressedHomepagePassType props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userPressedHomepagePassType,
    /**
     * Fires a 'UserPressedHomepagePassesLearnMore' track call.
     *
     * @param UserPressedHomepagePassesLearnMore props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userPressedHomepagePassesLearnMore,
    /**
     * Fires a 'UserPressedHomepageReferralBanner' track call.
     *
     * @param UserPressedHomepageReferralBanner props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userPressedHomepageReferralBanner,
    /**
     * Fires a 'UserPressedHomepageSeeAllPassListings' track call.
     *
     * @param UserPressedHomepageSeeAllPassListings props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userPressedHomepageSeeAllPassListings,
    /**
     * Fires a 'UserPressedHomepageSocial' track call.
     *
     * @param UserPressedHomepageSocial props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userPressedHomepageSocial,
    /**
     * Fires a 'UserPressedHostGuaranteeFromMessages' track call.
     *
     * @param UserPressedHostGuaranteeFromMessages props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userPressedHostGuaranteeFromMessages,
    /**
     * Fires a 'UserPressedHostRulesCheckoutConfirmation' track call.
     *
     * @param UserPressedHostRulesCheckoutConfirmation props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userPressedHostRulesCheckoutConfirmation,
    /**
     * Fires a 'UserPressedHowDoesSwimplyWork' track call.
     *
     * @param UserPressedHowDoesSwimplyWork props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userPressedHowDoesSwimplyWork,
    /**
     * Fires a 'UserPressedInviteAndManageFriendsToFL' track call.
     *
     * @param UserPressedInviteAndManageFriendsToFL props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userPressedInviteAndManageFriendsToFL,
    /**
     * Fires a 'UserPressedInviteButtonTaskBar' track call.
     *
     * @param UserPressedInviteButtonTaskBar props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userPressedInviteButtonTaskBar,
    /**
     * Fires a 'UserPressedInviteFriends' track call.
     *
     * @param UserPressedInviteFriends props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userPressedInviteFriends,
    /**
     * Fires a 'UserPressedInviteFriendsToBooking' track call.
     *
     * @param UserPressedInviteFriendsToBooking props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userPressedInviteFriendsToBooking,
    /**
     * Fires a 'UserPressedInviteFriendsToCollaborateFL' track call.
     *
     * @param UserPressedInviteFriendsToCollaborateFL props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userPressedInviteFriendsToCollaborateFL,
    /**
     * Fires a 'UserPressedInviteFriendsToViewFL' track call.
     *
     * @param UserPressedInviteFriendsToViewFL props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userPressedInviteFriendsToViewFL,
    /**
     * Fires a 'UserPressedInviteViaEmail' track call.
     *
     * @param UserPressedInviteViaEmail props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userPressedInviteViaEmail,
    /**
     * Fires a 'UserPressedJoinFavoriteList' track call.
     *
     * @param UserPressedJoinFavoriteList props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userPressedJoinFavoriteList,
    /**
     * Fires a 'UserPressedJoinReservation' track call.
     *
     * @param UserPressedJoinReservation props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userPressedJoinReservation,
    /**
     * Fires a 'UserPressedKeywordSearch' track call.
     *
     * @param UserPressedKeywordSearch props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userPressedKeywordSearch,
    /**
     * Fires a 'UserPressedKlarnaMoreInfo' track call.
     *
     * @param UserPressedKlarnaMoreInfo props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userPressedKlarnaMoreInfo,
    /**
     * Fires a 'UserPressedLearnMoreSwimplyGuard' track call.
     *
     * @param UserPressedLearnMoreSwimplyGuard props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userPressedLearnMoreSwimplyGuard,
    /**
     * Fires a 'UserPressedLeaveFavoriteList' track call.
     *
     * @param UserPressedLeaveFavoriteList props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userPressedLeaveFavoriteList,
    /**
     * Fires a 'UserPressedListing' track call.
     *
     * @param UserPressedListing props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userPressedListing,
    /**
     * Fires a 'UserPressedListingAISearch' track call.
     *
     * @param UserPressedListingAISearch props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userPressedListingAISearch,
    /**
     * Fires a 'UserPressedListingPhoto' track call.
     *
     * @param UserPressedListingPhoto props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userPressedListingPhoto,
    /**
     * Fires a 'UserPressedMap' track call.
     *
     * @param UserPressedMap props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userPressedMap,
    /**
     * Fires a 'UserPressedMapListing' track call.
     *
     * @param UserPressedMapListing props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userPressedMapListing,
    /**
     * Fires a 'UserPressedNewPoolFilter' track call.
     *
     * @param UserPressedNewPoolFilter props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userPressedNewPoolFilter,
    /**
     * Fires a 'UserPressedNotifications' track call.
     *
     * @param UserPressedNotifications props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userPressedNotifications,
    /**
     * Fires a 'UserPressedPassesUpsellLearnMore' track call.
     *
     * @param UserPressedPassesUpsellLearnMore props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userPressedPassesUpsellLearnMore,
    /**
     * Fires a 'UserPressedPayWithKlarna' track call.
     *
     * @param UserPressedPayWithKlarna props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userPressedPayWithKlarna,
    /**
     * Fires a 'UserPressedPetFilter' track call.
     *
     * @param UserPressedPetFilter props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userPressedPetFilter,
    /**
     * Fires a 'UserPressedPostBookingInviteFromConfirmation' track call.
     *
     * @param UserPressedPostBookingInviteFromConfirmation props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userPressedPostBookingInviteFromConfirmation,
    /**
     * Fires a 'UserPressedPostBookingInviteFromReservationPage' track call.
     *
     * @param UserPressedPostBookingInviteFromReservationPage props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userPressedPostBookingInviteFromReservationPage,
    /**
     * Fires a 'UserPressedPriceTagMapView' track call.
     *
     * @param UserPressedPriceTagMapView props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userPressedPriceTagMapView,
    /**
     * Fires a 'UserPressedProfileVerificationUploadID' track call.
     *
     * @param UserPressedProfileVerificationUploadID props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userPressedProfileVerificationUploadID,
    /**
     * Fires a 'UserPressedPurchaseAnytimePass' track call.
     *
     * @param UserPressedPurchaseAnytimePass props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userPressedPurchaseAnytimePass,
    /**
     * Fires a 'UserPressedPurchaseEarlyBirdPass' track call.
     *
     * @param UserPressedPurchaseEarlyBirdPass props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userPressedPurchaseEarlyBirdPass,
    /**
     * Fires a 'UserPressedPurchaseWeekdayPass' track call.
     *
     * @param UserPressedPurchaseWeekdayPass props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userPressedPurchaseWeekdayPass,
    /**
     * Fires a 'UserPressedRatingValue' track call.
     *
     * @param UserPressedRatingValue props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userPressedRatingValue,
    /**
     * Fires a 'UserPressedRebookWithPass' track call.
     *
     * @param UserPressedRebookWithPass props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userPressedRebookWithPass,
    /**
     * Fires a 'UserPressedRecommendedListingInClaims' track call.
     *
     * @param UserPressedRecommendedListingInClaims props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userPressedRecommendedListingInClaims,
    /**
     * Fires a 'UserPressedRedirectToCozyMeal' track call.
     *
     * @param UserPressedRedirectToCozyMeal props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userPressedRedirectToCozyMeal,
    /**
     * Fires a 'UserPressedReferAHost' track call.
     *
     * @param UserPressedReferAHost props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userPressedReferAHost,
    /**
     * Fires a 'UserPressedRemoveFriendsFromFL' track call.
     *
     * @param UserPressedRemoveFriendsFromFL props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userPressedRemoveFriendsFromFL,
    /**
     * Fires a 'UserPressedReservationsFromMessageThread' track call.
     *
     * @param UserPressedReservationsFromMessageThread props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userPressedReservationsFromMessageThread,
    /**
     * Fires a 'UserPressedRestroomFilter' track call.
     *
     * @param UserPressedRestroomFilter props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userPressedRestroomFilter,
    /**
     * Fires a 'UserPressedReviewArrow' track call.
     *
     * @param UserPressedReviewArrow props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userPressedReviewArrow,
    /**
     * Fires a 'UserPressedSaveFavoriteFromFavoriteList' track call.
     *
     * @param UserPressedSaveFavoriteFromFavoriteList props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userPressedSaveFavoriteFromFavoriteList,
    /**
     * Fires a 'UserPressedSaveFavoriteFromPLP' track call.
     *
     * @param UserPressedSaveFavoriteFromPLP props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userPressedSaveFavoriteFromPLP,
    /**
     * Fires a 'UserPressedSaveFavoriteFromSearch' track call.
     *
     * @param UserPressedSaveFavoriteFromSearch props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userPressedSaveFavoriteFromSearch,
    /**
     * Fires a 'UserPressedSaveFavoriteListChanges' track call.
     *
     * @param UserPressedSaveFavoriteListChanges props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userPressedSaveFavoriteListChanges,
    /**
     * Fires a 'UserPressedScrollInstagramPhotos' track call.
     *
     * @param UserPressedScrollInstagramPhotos props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userPressedScrollInstagramPhotos,
    /**
     * Fires a 'UserPressedSearchInviteFriendsReferralBanner' track call.
     *
     * @param UserPressedSearchInviteFriendsReferralBanner props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userPressedSearchInviteFriendsReferralBanner,
    /**
     * Fires a 'UserPressedSearchPassesCloseIntro' track call.
     *
     * @param UserPressedSearchPassesCloseIntro props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userPressedSearchPassesCloseIntro,
    /**
     * Fires a 'UserPressedSearchPassesLearnMore' track call.
     *
     * @param UserPressedSearchPassesLearnMore props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userPressedSearchPassesLearnMore,
    /**
     * Fires a 'UserPressedSelectCallType' track call.
     *
     * @param UserPressedSelectCallType props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userPressedSelectCallType,
    /**
     * Fires a 'UserPressedSendPicture' track call.
     *
     * @param UserPressedSendPicture props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userPressedSendPicture,
    /**
     * Fires a 'UserPressedShareFavoriteListFromSearch' track call.
     *
     * @param UserPressedShareFavoriteListFromSearch props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userPressedShareFavoriteListFromSearch,
    /**
     * Fires a 'UserPressedSharePostBookingInviteLink' track call.
     *
     * @param UserPressedSharePostBookingInviteLink props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userPressedSharePostBookingInviteLink,
    /**
     * Fires a 'UserPressedShowMapView' track call.
     *
     * @param UserPressedShowMapView props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userPressedShowMapView,
    /**
     * Fires a 'UserPressedSkipBookingReview' track call.
     *
     * @param UserPressedSkipBookingReview props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userPressedSkipBookingReview,
    /**
     * Fires a 'UserPressedSwitchReferral' track call.
     *
     * @param UserPressedSwitchReferral props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userPressedSwitchReferral,
    /**
     * Fires a 'UserPressedTOSFromMessages' track call.
     *
     * @param UserPressedTOSFromMessages props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userPressedTOSFromMessages,
    /**
     * Fires a 'UserPressedToBecomeHost' track call.
     *
     * @param UserPressedToBecomeHost props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userPressedToBecomeHost,
    /**
     * Fires a 'UserPressedToEnterBookingFlow' track call.
     *
     * @param UserPressedToEnterBookingFlow props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userPressedToEnterBookingFlow,
    /**
     * Fires a 'UserPressedToFavorite' track call.
     *
     * @param UserPressedToFavorite props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userPressedToFavorite,
    /**
     * Fires a 'UserPressedToRemoveBetaGuest' track call.
     *
     * @param UserPressedToRemoveBetaGuest props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userPressedToRemoveBetaGuest,
    /**
     * Fires a 'UserPressedToSharePLP' track call.
     *
     * @param UserPressedToSharePLP props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userPressedToSharePLP,
    /**
     * Fires a 'UserPressedToSharePLPwFriends' track call.
     *
     * @param UserPressedToSharePLPwFriends props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userPressedToSharePLPwFriends,
    /**
     * Fires a 'UserPressedToViewGuestList' track call.
     *
     * @param UserPressedToViewGuestList props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userPressedToViewGuestList,
    /**
     * Fires a 'UserPressedTryAISearch' track call.
     *
     * @param UserPressedTryAISearch props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userPressedTryAISearch,
    /**
     * Fires a 'UserPressedUnsaveFavoriteFromFavoriteList' track call.
     *
     * @param UserPressedUnsaveFavoriteFromFavoriteList props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userPressedUnsaveFavoriteFromFavoriteList,
    /**
     * Fires a 'UserPressedUnsaveFavoriteFromPLP' track call.
     *
     * @param UserPressedUnsaveFavoriteFromPLP props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userPressedUnsaveFavoriteFromPLP,
    /**
     * Fires a 'UserPressedUnsaveFavoriteFromSearch' track call.
     *
     * @param UserPressedUnsaveFavoriteFromSearch props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userPressedUnsaveFavoriteFromSearch,
    /**
     * Fires a 'UserPressedViewAllCozymealOptions' track call.
     *
     * @param UserPressedViewAllCozymealOptions props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userPressedViewAllCozymealOptions,
    /**
     * Fires a 'UserPressedViewAllCozymealOptionsFromSearch' track call.
     *
     * @param UserPressedViewAllCozymealOptionsFromSearch props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userPressedViewAllCozymealOptionsFromSearch,
    /**
     * Fires a 'UserPressedViewAllListingPhotosAndVideos' track call.
     *
     * @param UserPressedViewAllListingPhotosAndVideos props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userPressedViewAllListingPhotosAndVideos,
    /**
     * Fires a 'UserPressedViewHostProfile' track call.
     *
     * @param UserPressedViewHostProfile props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userPressedViewHostProfile,
    /**
     * Fires a 'UserPressedViewInstagramPhoto' track call.
     *
     * @param UserPressedViewInstagramPhoto props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userPressedViewInstagramPhoto,
    /**
     * Fires a 'UserPressedViewPhoto' track call.
     *
     * @param UserPressedViewPhoto props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userPressedViewPhoto,
    /**
     * Fires a 'UserPressedViewReservationFromPostBookingInvite' track call.
     *
     * @param UserPressedViewReservationFromPostBookingInvite props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userPressedViewReservationFromPostBookingInvite,
    /**
     * Fires a 'UserPressedViewReviews' track call.
     *
     * @param UserPressedViewReviews props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userPressedViewReviews,
    /**
     * Fires a 'UserPressedXToExitReview' track call.
     *
     * @param UserPressedXToExitReview props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userPressedXToExitReview,
    /**
     * Fires a 'UserPressedYourInvitesFriends' track call.
     *
     * @param UserPressedYourInvitesFriends props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userPressedYourInvitesFriends,
    /**
     * Fires a 'UserPressedYourInvitesHosts' track call.
     *
     * @param UserPressedYourInvitesHosts props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userPressedYourInvitesHosts,
    /**
     * Fires a 'UserReceivedPostBookingInvite' track call.
     *
     * @param UserReceivedPostBookingInvite props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userReceivedPostBookingInvite,
    /**
     * Fires a 'UserRemovedThemselfFromFL' track call.
     *
     * @param UserRemovedThemselfFromFL props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userRemovedThemselfFromFL,
    /**
     * Fires a 'UserResetFilters' track call.
     *
     * @param UserResetFilters props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userResetFilters,
    /**
     * Fires a 'UserSavedAddPaymentMethodWallet' track call.
     *
     * @param UserSavedAddPaymentMethodWallet props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userSavedAddPaymentMethodWallet,
    /**
     * Fires a 'UserScreenShotted' track call.
     *
     * @param UserScreenShotted props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userScreenShotted,
    /**
     * Fires a 'UserSearchedMessages' track call.
     *
     * @param UserSearchedMessages props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userSearchedMessages,
    /**
     * Fires a 'UserSelectedBookingReason' track call.
     *
     * @param UserSelectedBookingReason props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userSelectedBookingReason,
    /**
     * Fires a 'UserSelectedOptInSMSAccountNotification' track call.
     *
     * @param UserSelectedOptInSMSAccountNotification props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userSelectedOptInSMSAccountNotification,
    /**
     * Fires a 'UserSelectedOptInSMSNotification' track call.
     *
     * @param UserSelectedOptInSMSNotification props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userSelectedOptInSMSNotification,
    /**
     * Fires a 'UserSelectedPopularFilter' track call.
     *
     * @param UserSelectedPopularFilter props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userSelectedPopularFilter,
    /**
     * Fires a 'UserSelectedPostBookingInviteMethod' track call.
     *
     * @param UserSelectedPostBookingInviteMethod props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userSelectedPostBookingInviteMethod,
    /**
     * Fires a 'UserSentMessage' track call.
     *
     * @param UserSentMessage props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userSentMessage,
    /**
     * Fires a 'UserSentPhoto' track call.
     *
     * @param UserSentPhoto props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userSentPhoto,
    /**
     * Fires a 'UserSEOEditDate' track call.
     *
     * @param UserSEOEditDate props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userSEOEditDate,
    /**
     * Fires a 'UserSEOEditDropDown' track call.
     *
     * @param UserSEOEditDropDown props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userSEOEditDropDown,
    /**
     * Fires a 'UserSEOEditLocation' track call.
     *
     * @param UserSEOEditLocation props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userSEOEditLocation,
    /**
     * Fires a 'UserSEOPressedOtherSEOLink' track call.
     *
     * @param UserSEOPressedOtherSEOLink props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userSEOPressedOtherSEOLink,
    /**
     * Fires a 'UserSEOPressedToExpandReadMorePLP' track call.
     *
     * @param UserSEOPressedToExpandReadMorePLP props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userSEOPressedToExpandReadMorePLP,
    /**
     * Fires a 'UserSEOPressedToExpandReview' track call.
     *
     * @param UserSEOPressedToExpandReview props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userSEOPressedToExpandReview,
    /**
     * Fires a 'UserSetPaymentMethodInWallet' track call.
     *
     * @param UserSetPaymentMethodInWallet props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userSetPaymentMethodInWallet,
    /**
     * Fires a 'UserShiftedMap' track call.
     *
     * @param UserShiftedMap props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userShiftedMap,
    /**
     * Fires a 'UserShowMoreTimesPressed' track call.
     *
     * @param UserShowMoreTimesPressed props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userShowMoreTimesPressed,
    /**
     * Fires a 'UserStartedAuth' track call.
     *
     * @param UserStartedAuth props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userStartedAuth,
    /**
     * Fires a 'UserStartedCall' track call.
     *
     * @param UserStartedCall props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userStartedCall,
    /**
     * Fires a 'UserSubmitInviteViaEmail' track call.
     *
     * @param UserSubmitInviteViaEmail props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userSubmitInviteViaEmail,
    /**
     * Fires a 'UserSubmittedAISearch' track call.
     *
     * @param UserSubmittedAISearch props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userSubmittedAISearch,
    /**
     * Fires a 'UserSubmittedAccountChange' track call.
     *
     * @param UserSubmittedAccountChange props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userSubmittedAccountChange,
    /**
     * Fires a 'UserSubmittedAmenity' track call.
     *
     * @param UserSubmittedAmenity props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userSubmittedAmenity,
    /**
     * Fires a 'UserSubmittedBookingDetails' track call.
     *
     * @param UserSubmittedBookingDetails props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userSubmittedBookingDetails,
    /**
     * Fires a 'UserSubmittedBookingDetailsToFL' track call.
     *
     * @param UserSubmittedBookingDetailsToFL props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userSubmittedBookingDetailsToFL,
    /**
     * Fires a 'UserSubmittedBookingInvites' track call.
     *
     * @param UserSubmittedBookingInvites props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userSubmittedBookingInvites,
    /**
     * Fires a 'UserSubmittedContactHostRequest' track call.
     *
     * @param UserSubmittedContactHostRequest props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userSubmittedContactHostRequest,
    /**
     * Fires a 'UserSubmittedFLInviteFriendsViaEmail' track call.
     *
     * @param UserSubmittedFLInviteFriendsViaEmail props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userSubmittedFLInviteFriendsViaEmail,
    /**
     * Fires a 'UserSubmittedFLInviteFriendsViaText' track call.
     *
     * @param UserSubmittedFLInviteFriendsViaText props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userSubmittedFLInviteFriendsViaText,
    /**
     * Fires a 'UserSubmittedFilter' track call.
     *
     * @param UserSubmittedFilter props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userSubmittedFilter,
    /**
     * Fires a 'UserSubmittedProfileVerificationID' track call.
     *
     * @param UserSubmittedProfileVerificationID props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userSubmittedProfileVerificationID,
    /**
     * Fires a 'UserSubmittedRatingValue' track call.
     *
     * @param UserSubmittedRatingValue props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userSubmittedRatingValue,
    /**
     * Fires a 'UserSubmittedSMSForm' track call.
     *
     * @param UserSubmittedSMSForm props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userSubmittedSMSForm,
    /**
     * Fires a 'UserSubmittedSearch' track call.
     *
     * @param UserSubmittedSearch props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userSubmittedSearch,
    /**
     * Fires a 'UserSubmittedTimeRange' track call.
     *
     * @param UserSubmittedTimeRange props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userSubmittedTimeRange,
    /**
     * Fires a 'UserSubmittedWrittenReviewText' track call.
     *
     * @param UserSubmittedWrittenReviewText props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userSubmittedWrittenReviewText,
    /**
     * Fires a 'UserSwitchedToFriendsInviteWithinTrackInvitesPage' track call.
     *
     * @param UserSwitchedToFriendsInviteWithinTrackInvitesPage props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userSwitchedToFriendsInviteWithinTrackInvitesPage,
    /**
     * Fires a 'UserSwitchedToHostsInviteWithinTrackInvitesPage' track call.
     *
     * @param UserSwitchedToHostsInviteWithinTrackInvitesPage props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userSwitchedToHostsInviteWithinTrackInvitesPage,
    /**
     * Fires a 'UserUpdatedFilters' track call.
     *
     * @param UserUpdatedFilters props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userUpdatedFilters,
    /**
     * Fires a 'UserUpdatedPhoneNumber' track call.
     *
     * @param UserUpdatedPhoneNumber props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userUpdatedPhoneNumber,
    /**
     * Fires a 'UserVerifiedPhoneNumber' track call.
     *
     * @param UserVerifiedPhoneNumber props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userVerifiedPhoneNumber,
    /**
     * Fires a 'UserViewFormPartyBanner' track call.
     *
     * @param UserViewFormPartyBanner props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userViewFormPartyBanner,
    /**
     * Fires a 'UserViewedCozymealBookingAdditions' track call.
     *
     * @param UserViewedCozymealBookingAdditions props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userViewedCozymealBookingAdditions,
    /**
     * Fires a 'UserViewedCozymealBookingAdditionsPopUp' track call.
     *
     * @param UserViewedCozymealBookingAdditionsPopUp props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userViewedCozymealBookingAdditionsPopUp,
    /**
     * Fires a 'UserViewedMemberProfileFromMessages' track call.
     *
     * @param UserViewedMemberProfileFromMessages props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userViewedMemberProfileFromMessages,
    /**
     * Fires a 'UserViewedMessage' track call.
     *
     * @param UserViewedMessage props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userViewedMessage,
    /**
     * Fires a 'UserViewedMessageTab' track call.
     *
     * @param UserViewedMessageTab props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userViewedMessageTab,
    /**
     * Fires a 'UserViewedWeather' track call.
     *
     * @param UserViewedWeather props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userViewedWeather,
    /**
     * Fires a 'ViewedListing' track call.
     *
     * @param ViewedListing props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    viewedListing,
};

export default new Proxy<typeof clientAPI>(clientAPI, {
    get(target, method) {
        if (typeof method === 'string' && target.hasOwnProperty(method)) {
            return target[method as keyof typeof clientAPI];
        }

        return () => {
            console.warn(`⚠️  You made an analytics call (${String(method)}) that can't be found. Either:
         a) Re-generate your typewriter client: \`npx typewriter\`
         b) Add it to your Tracking Plan: https://app.segment.com/segment-oscb/protocols/tracking-plans/rs_1zTHJU9fd5mt7cndWnd4PgJbMCE`);
            const a = analytics();
            if (a) {
                a.track(
                    'Unknown Analytics Call Fired',
                    {
                        method,
                    },
                    withTypewriterContext(),
                );
            }
        };
    },
});

